const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Tsukuyomi Background",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Failed to publish due to excessive scene assets. Please delete some assets and try again.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Currently no permission to access membership-related features",
  T_12_I_GIFT_SENDER_BELL: "ေခါင္းေလာင္း",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "ေတြ႕ၿပီးလားး [FFB300](ဦးထုပ္ဖြက္)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "ဆန္တာကေလာ့မုတ္ဆိတ္",
  T_12_L_COS_PINKMAN: "ပန္းေရာင္ဒိုင္ႏိုေဆာ",
  T_12_L_COS_POLAR: "ပိုလာဝက္ဝံ",
  T_12_L_COS_RENDER: "သက္တံေရာင္စဥ္ဒိုင္ႏိုေဆာ",
  T_12_L_COS_TIGER: "ေရႊက်ား",
  T_12_L_MALE_BOTTOM_COS_ELF: "ေငြႏွင္းျဖဴ",
  T_12_L_MALE_COS_SANTA: "ဆန္တာကေလာ့ရဲ႕စိ္ုက္ပ်ိဳးဝတ္စံု",
  T_12_L_MALE_HAIR_COS_ELF: "ေရႊသမင္ကေလး",
  T_12_L_MALE_SHOE_COS_ELF: "ဆောင္းသမင္္္္္ကလေး",
  T_12_L_MALE_TOP_COS_ELF: "ေငြႏွင္းျဖဴ",
  T_12_O_CAT_NAME: "ေၾကာင္ကေလး",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014-Winterlands",
  T_12_O_MACHETE_GOLD_NAME: "ေရႊဓား",
  T_12_O_PET_TITLE: "တိရိစာၦန္",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "ခုန္ဖိနပ္",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "ေနာက္ဆံုးေပၚဖိနပ္ ေလထဲတြင္ခုန္သြားလို႔ရသည္",
  T_12_Q_ITEM_FLYSHOE: "ဂ်က္ဖိနပ္",
  T_12_Q_ITEM_FLYSHOE_DESC: "ပ်ံလႊားဖိနပ္",
  T_12_Q_ITEM_STOCK1: "လက္တံ Lv1",
  T_12_Q_ITEM_STOCK2: "လက္တံ Lv2",
  T_12_Q_ITEM_STOCK3: "လက္တံ Lv3",
  T_12_Q_ITEM_TREATMENTGUN: "ကုသေရးပစၥတို",
  T_12_Q_ITEM_VEST4: "အကာအဆင့္ 4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "ကမယ္ ကမယ္",
  T_12_R_EMOTE_WAVE_NAME: "ယိမ္းႏြဲ႔လက္ေမာင္း",
  T_12_R_SKILL_NAME_GANGLEADER: "လူဆိုးေသြး",
  T_12_R_SKILL_NAME_MONKEYGOD: "ကိုယ္ပြား",
  T_13_I_COLLECTION_V_AMPHIBIAN: "ကုန္းတပိုင္းေရတပိုင္းကား",
  T_13_I_COLLECTION_V_JEEP: "ဂ်စ္ကား",
  T_13_I_COLLECTION_V_MONSTER: "မြန္စတားကားၾကီး",
  T_13_I_COLLECTION_V_MOTOBIKE: "ဆိုင္ကယ္",
  T_13_I_COLLECTION_V_ROADSTER: "ၿပိဳင္ကား",
  T_13_I_COLLECTION_V_SUV: "ကုန္တင္ကား",
  T_13_I_COLLECTION_V_TUTU: "တုတ္တုတ္ကား",
  T_13_L_MALE_ACCESSORY_COS_BJD: "ဘလူးမယ္ရီအိုနက္",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "ေလထဲကအခ်စ္",
  T_13_L_MALE_HAIR_COS_BJD: "ဘလူးမယ္ရီအိုနက္",
  T_13_L_MALE_TOP_COS_VALENTINE: "ေလထဲကအခ်စ္",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "လက္နက္",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "တိရိစာၦန္စကင္း: ေၾကာင္ကေလး",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR - Cupid",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "ေဘဘီရွာ့ခ္",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "ဒိ္ုင္ပင္ထိုးမယ္",
  T_13_R_EMOTE_EGYPT_NAME: "မမ္မီအက",
  T_13_R_PVE_WEAPON_SLOT: "လက္နက္ေနရာ",
  T_13_R_PVE_WEAPONSKIN_RANGE: "ထိေရာက္ေသာအကြာအေဝး",
  T_13_R_PVE_WEAPONSKIN_SPEED: "ပစ္ခ်က္",
  T_13_R_SKILL_DESC_HACKERGIRL: "Moco ပစ္လိုက္သည့္ရန္သူကိုအဖြဲ႕သားမ်ားေတြ႕ရွိရန္ {0}စကၠန္႔",
  T_13_R_SKILL_NAME_HACKERGIRL: "ဟက္ကာအစြမ္း",
  T_13_Z_KICKOFF_BAN: "ပိတ္ပင္",
  T_13_Z_ROOM_MORNING: "ရက္",
  T_13_Z_ROOM_NIGHT: "ည",
  T_14_G_ITEM_KATANA: "ခါတာန",
  T_14_I_HEADPIC_SONGKRAN_NAME: "ျဗန္းးး!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "ယုန္ေလးေထာက္",
  T_14_L_COS_EASTER: "လေ့လာသူ 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "ေလဒီဖိုင္ဖိုက္တာ",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "ယုန္ငရဲ",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47- Water Balloon",
  T_14_O_DOG_NAME: "စက္ရုပ္ေခြး",
  T_14_O_PETSKIN_IRON_DOG_NAME: "တိရိစာၦန္စကင္း အိုင္ရြန္လက္ကီး",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "တိရိစာၦန္စကင္း:လိုတ္နင္းလက္ကီး",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "တိရိစာၦန္စကင္း:မက္နက္လက္ကီး",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "တိရိစာၦန္စကင္း:ခရမ္းေရာင္ေၾကာင္",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - Blood Moon",
  T_14_O_SCAR_SHARK_NAME: "SCAR - Shark Attack",
  T_14_Q_ITEM_RGS50: "RGS-50",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "အသက္စြမ္းအားေလ်ာ့က်ရင္ {0}% {1}% က်ဥ္ေဖာက္ထြင္းမႈ့",
  T_14_R_SKILL_NAME_SAMURAI: "ဘူခ်ိဒို",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "THE STARVATION",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "THE STARVATION",
  T_15_L_MALE_BOTTOM_COS_FAIM: "THE STARVATION",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Venom Touch",
  T_15_L_MALE_SHOE_COS_FAIM: "Hunger Strike (Shoes)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Venom Touch (Shoes)",
  T_15_L_MALE_TOP_COS_FAIM: "Hunger Strike (Top)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "ဘေးဥပဒ်",
  T_15_L_TOP_COS_MOTHERSDAY: "အေကာင္းဆံုးမမ္မီ",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - Cataclysm",
  T_15_O_BASEBALLBAT_VIKING_NAME: "ဝိုင္ကင္း",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - Cataclysm",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - Cataclysm",
  T_15_O_PANTHER_NAME: "ညက်ားသစ္",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "တိရိစာၦန္စကင္း:ကပၸတိန္",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "တိရိစာၦန္စကင္း : ေရႊက်ားသစ္",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "တိရိစာၦန္စကင္း : ဝိုင္အိုက်ားသစ္",
  T_15_O_SKS_DEATH_NAME: "SKS - Death Wish",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - Cataclysm",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "Gatling",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "တူတူကမယ္",
  T_15_R_SKILL_DESC_AGENT: "မွန္ေျပာင္းသံုးစဥ္တိက်မွဳ {0}%တိုးသည္",
  T_15_R_SKILL_NAME_AGENT: "လက္ေျဖာင့္သမား",
  T_15_W_BACKPACK_MECHGIRL_NAME: "ခရမ္းေတာင္ပံ",
  T_16_B_ITEM_GRAPPLINGHOOK: "ႀကိဳးေသနတ္",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "ႀကိဳးေသနတ္",
  T_16_L_MALE_COS_LEGO: "မက္ဘရစ္မန္း",
  T_16_L_MALE_SHOE_COS_SUMMER: "ေႏြအားလပ္ရက္ (ဖိနပ္)",
  T_16_P_MANUAL_MONSTER: "မြန္စတားကားၾကီး",
  T_16_P_MANUAL_MUSHROOM1: "မိႈ Lv1",
  T_16_P_MANUAL_MUSHROOM2: "မိႈ Lv 2",
  T_16_P_MANUAL_MUSHROOM3: "မိႈ Lv 3",
  T_16_P_MANUAL_MUSHROOM4: "မိႈ Lv 4",
  T_16_P_MANUAL_ROADSTER_DESC: "ၿပိဳင္ကား HP နည္းသည္ ဒါေပမယ့္တအားျမန္သည္ ႏွစ္ေယာက္ထိုင္လို႔ရသည္",
  T_16_P_MANUAL_STROP: "ႀကိဳးေသနတ္",
  T_16_P_MANUAL_SUV: "ကုန္တင္ကား",
  T_16_P_MANUAL_SUV_DESC: "Free fire ရဲ႕သေကၤတကုန္တင္ကား က်ဥ္ကာအလတ္အေလာပါဝင္သည္ အရွိန္နႈန္းျမင့္ လူႏွစ္ေယာက္စီးလို႔ရသည္",
  T_16_P_MANUAL_TUTU_DESC: "HP ရွိသည္ အရွိန္နည္း ကစားသူ ၃ေယာက္ဆံသည္",
  T_16_P_MANUAL_WEAPON_AR: "႐ိုင္ဖယ္ေသနတ္",
  T_16_P_MANUAL_WEAPON_BOMB: "ဗံုး",
  T_16_P_MANUAL_WEAPON_PISTOL: "ပစၥတို",
  T_16_P_MANUAL_WEAPON_SG: `အနီးပစ္
ေသနတ္`,
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "စႏိုက္ပါ",
  T_16_Q_MINISENTRY: "ေမွ်ာ္စင္",
  T_16_Q_MINISENTRY_DESC: "ေအာ္တိုေသနတ္ပစ္လိုရသည့္ေမ်ာ္စင္ ကိုယ္တိုင္ခ်ိန္လို႔ရသည္",
  T_16_R_EMOTE_DESERT_NAME: "ဆလန္ငရဲ",
  T_16_R_EMOTE_EPHUNTER_NAME: "အဆင္သင့္ျဖစ္ၿပီး!!!",
  T_16_R_EMOTE_EPHUNTER2_NAME: "ဟိုင္ဖိုင္းးး",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "မြန္းဖလစ္",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "ဟိုရမ္းဒီရမ္းသြားျခင္း",
  T_16_W_AK_FIRE_NAME: "AK47- Flaming Red",
  T_16_W_SCAR_LLENN_NAME: "SCAR - Pink Devil",
  T_16_W_SCAR_WATER_NAME: "SCAR - Water Elemental",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "စံုေထာက္ပန္ဒါ",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "တိရိစာၦန္စကင္း : ပန္ဒါ",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "တိရိစာၦန္စကင္း : ပန္ဒါ",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "တိရိစာၦန္စကင္း : လွ်ပ္စီးပန္ဒါ",
  T_17_B_CS_MODE_NAME: "4v4",
  T_17_C_SKILL_NAME_PLAYBOY: "စပရစ္ရတ္ခ်္",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "ေလာ္ရယ္ဂ်က္စတား",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "ဘလက္ဒီခ်ယ္ရီ",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "ဘလက္ဒီးခ်ယ္ရီ",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Selvedgework",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "ဘလန္ဒီခ်ယ္ရီ",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "ဘလတ္ဒီခ်ယ္ရီ(အက်ႌ)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "ဘလတ္ဒီးဝိုင္",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "ရာကူဆာ",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "ဘရတ္ဒီးဝိုင္",
  T_17_L_MALE_HAIR_COS_FFUNIT: "ေပပါရွိတ္",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "ေဒဝါနီ",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "ဘလက္ဒီဝိုင္",
  T_17_L_MALE_TOP_COS_VAMPIRE: "ဘလက္ဒီဝိုင္",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "ဂိုးဒန္း ရွိတ္",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "တိရိစာၦန္စကင္း : ေညာင္မင္းသမီး",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "တိရိစာၦန္စကင္း : ေရႊေခတ္",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "တိရိစာၦန္စကင္း: အျပာရင့္",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "တိရိစာၦန္စကင္း:ေၾကာက္စရာ",
  T_17_O_SHIBA_NAME: "ခ်ိဘ",
  T_17_Q_FOLDWINGS: "ပ်ံစက္",
  T_17_Q_FOLDWINGS_DESC: "တ္တ္လတ္လတ္ျဖစ္ခ်င္ရင္ ဒါသံုးၾကည့္",
  T_17_Q_SUPERHEAT: "ပလက္စမား",
  T_17_R_EMOTE_PARTYDANCE_NAME: "အစြမ္းကုန္ကမယ္",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS - Vampire",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR - Phantom Assassin",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR - Old Fashioned",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "အမည္",
  T_17_Z_ROOM_JUMP_SWITCH: "အခုန္အျမင့္",
  T_17_Z_ROOM_SPEED_SWITCH: "လွဳပ္ရွားမွဳအလ်င္",
  T_18_B_THROWINGKNIFE_NAME: "FF ဓား",
  T_18_C_DUMMY_NAME: "လွည့္စားဗံုး",
  T_18_C_SKILL_DESC_DJMALE: "ေရြ႕လ်ားျခင္း {3}%တိုးျပီး HP {2} ခု {0}စကၠန္႔အတြင္းတက္သည့္ {1}မီတာေအာ္ရာဖန္တီးပါ။သက္ေရာက္မွဳမထပ္ပါ။ CD: {4}s",
  T_18_C_SKILL_NAME_DJMALE: "စည္းခ်က္စလိုက္ေတာ့",
  T_18_C_SKILL_NAME_JUNKENGINEER: "ဂီယာ ရီဆိုင္ကယ္",
  T_18_L_COS_INDIANEWYEAR: "ေဒဝါလီ၏နတ္ဆိုး",
  T_18_L_HAIR_COS_HALLOWEEN2019: "ဖုတ္ေကာင္ ဦး ထု",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "ပတၱျမားႏွလုံး (မ်က္ႏွာဖုံး)",
  T_18_O_FOX_NAME: "ေျမေခြးျဖဴ",
  T_18_O_PETSKIN_BLACKFOX_NAME: "တိရိစာၦန္စကင္း : ေျမေခြးတိုက္ပြဲ",
  T_18_O_PETSKIN_BLUEFOX_NAME: "တိရိစာၦန္စကင္း:Blue Fox",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "တိရိစာၦန္စကင္း:Pumpkin",
  T_18_O_PETSKIN_PINKFOX_NAME: "တိရိစာၦန္စကင္း:Red Fox",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "တိရိစာၦန္စကင္း:Spirit",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 - Flaming Skull",
  T_18_W_UMP_GEISHA_N: "UMP - Art of War",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Shani",
  T_19_B_HB_NAME: "ဟိုေဝးေဘာ့",
  T_19_C_ICE_GUN_NAME: "ေရခဲေသနတ္",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "ပ်က္ဆီးျခင္းတိုး ေပါက္ကြဲႏိုင္သည့္လက္နက္က {0}% အကြာေဝးတိုး {1}%",
  T_19_C_SKILL_DESC_TOMBOY: "ယာဥ္ထဲမွာရွိေနရင္ ေသြးမ်ားျပန္လည္ျဖည့္မည္ {1}ခု {0}စကၠန္႔တိုင္း အားလံုး {2}စကၠန္႔",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "လႊင့္ေလေျပ",
  T_19_C_SKILL_NAME_TOMBOY: "လ်င္ျမန္လူသား",
  T_19_I_EVENT_INFI_ITEM: "Unlimited",
  T_19_L_A_ICEFESTIVAL19_B: "သမင္ျပံဳး",
  T_19_L_F_S_ICEFESTIVAL: "မတ္ဆန္တီ(ဖိနပ္)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "ဖီဖိုင္အခ်စ္ဇာတ္လမ္း(ေဘာင္းဘီ)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "ဖီဖိုင္အခ်စ္ဇာတ္လမ္း(ဆံေက)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "ဖီဖိုင္အခ်စ္ဇာတ္လမ္း(အက်ႌ)",
  T_19_O_PETSKIN_NAME: "ပံွမွန္တိရိစာၦန္စကင္း",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "တိရိစာၦန္စကင္း:ဂိုဏ္းစတားပန္ဒါ",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "တိရိစာၦန္စကင္း:ေတာင္႐ိုးစြန္းဝက္ဝံ",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "တိရိစာၦန္စကင္း : ဖါလို ႐ိုဘို",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "တိရိစာၦန္စကင္း:ေႏြရာသီရဲ႕႐ိုဘို",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "တိရိစာၦန္စကင္း: ႏွင္းျဖဴနဲ႔႐ိုဘို",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "တိရိစာၦန္စကင္း:ခ်ိဘဂိုဏ္းစတား",
  T_19_O_ROBOT_NAME: "႐ိုဘို",
  T_19_O_TDM_NAME: "Team Deathmatch",
  T_19_R_EMOTE_MIGUEL_NAME: "ကခုန္ပါ",
  T_19_S_SECOND_WEAPON_TITLE: "အရံလက္နက္",
  T_19_S_VEST_TITLE: "က်ည္ကာ",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Double Magazine",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA - Tagger Revolt",
  T_19_W_M60_ICEFESTIVAL_N: "M60 - Santa's Choice",
  T_19_W_MP40_PARK_N: "MP40 - Carnival Carnage",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR - Aurous Dragon",
  T_19_X_PVE_SAMURAINAME: "ဆာမႈ႐ိုင္",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Inhaler",
  T_20_C_SKILL_DESC_PARKOURGUY: "ေသနတ္သံုးေသာအခါ၊ ရန္သူကိုပစ္ျခင္းသည္အသံုးျပဳသူအတြက္ HP အခ်ိဳ႕ျပန္လည္တက္ႏိုင္မည္။ ရန္သူရွင္းလင္းႏိုင္ပါက HP {0}%ျပန္တက္မည္။",
  T_20_C_SKILL_NAME_GRAFFITIST: "ဝရမ္းေျပးပံုဆြဲျခင္း",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "ဖရက္ ဘူေလ့",
  T_20_C_SKILL_NAME_PARKOURGUY: "လ်င္ျမန္ သြက္လက္",
  T_20_L_A_APRILFOOL2020: "ပုတ္ပုတ္ေလး",
  T_20_L_F_A_METALHEAD_RED: "ဆိုက္ဘာဘလက္(မ်က္ႏွာဖံုး)",
  T_20_L_F_B_THAIGIRL: "အထစ္တယာ(ေအာက္ေျခ)",
  T_20_L_F_H_KILLERCUPID: "ပန္းေရာင္ခရက္ (ဦး ေခါင္း)",
  T_20_L_F_H_THAIGIRL: "အထစ္တယာ (ဦး ေခါင္း)",
  T_20_L_F_S_THAIGIRL: "အထစ္တယာ(ေျခေထာက္)",
  T_20_L_F_T_METALHEAD_RED: "ဆိုက္ဘာဘလက္ (ထိပ္)",
  T_20_L_F_T_THAIGIRL: "အထစ္တယာ(ထိပ္)",
  T_20_L_JEANDINO: "ဒိုင္ႏိုဂ်င္းေဘာင္းဘီ",
  T_20_L_M_A_METALHEAD_RED: "ဆိုက္ဘာ ရတ္ခ်္ (မ်က္ႏွာဖံုး)",
  T_20_L_M_T_METALHEAD_RED: "ဆိုက္ဘာ ရတ္ခ်္ (ထိပ္)",
  T_20_L_M_T_STOCKING: "ဗစ္တိုးရီးယား(ထိပ္)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "တိရိစၧာန္စကင္း:ဗာလင္တိုင္းေဖါ့စ္",
  T_20_P_CHANNEL_G: "ခလန္",
  T_20_P_WORLD_SSPEAKER: "ေလာ္စပီကာ",
  T_20_S_CSROOM_COIN: "စတင္ပိုက္ဆံ",
  T_20_U_SHIELD_GUN_NAME: "Shield Gun",
  T_20_W_AN94_METALHEAD_N: "AN94 - Carrot Imp-Head",
  T_20_W_P90_EVILBONE_N: "P90 - The Punishers",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'Kelly "the Swift"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "မီးခိုးဗံုး စနစ္က်က်တိုက္ခိုက္ရန္အသံုး၀င္သည္",
  T_21_B_SMOKEGRENADE_NAME: "မီးခိုးဗံုး",
  T_21_C_AUTOPICKUP_AVERAGE: "ပံုမွန္",
  T_21_C_SKILL_DESC_KPOPSINGER: `ပစၥည္းမ်ားကိုအေထာက္အကူေပးသည္{0}%
စေကးမ်ားကို{1}% အေထာက္အကူေပးသည္ျပဳတ္က်သည့္အခါ
 ေသြးေလ်ာ့နႈန္းကို{2}%ေလ်ာ့က်သည္`,
  T_21_C_SKILL_DESC_SOCCERSTAR: "ရွင္းလင္းမွဳတိုင္း HP အျမင့္ဆံုး {0} မွ {1} ထိတိုးမည္",
  T_21_C_SKILL_NAME_KPOPSINGER: "ေသြးျဖည့္သံစဥ္",
  T_21_C_SKILL_NAME_SOCCERSTAR: "ဟက္ထရစ္",
  T_21_L_ANGELICAL: "အိန္ဂ်ယ္ဒိုင္နို",
  T_21_L_S_VNSLIPPER: "ဗီယက္နမ္ဖိနပ္",
  T_21_O_OTTER_NAME: "ေအာ္တို",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "တိရိစာၦန္စကင္း :ေရဒီယို ေအာ္တို",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "တိရိစာၦန္စကင္း : ဆာကူရာေအာ္တိုရို",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "တိရိစာၦန္စကင္း : နီအြန္ ေအာ္တို",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "တိရိစာၦန္စကင္း : ေသျခင္းအရွင္",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "တိရိစာၦန္စကင္း: မိုးၾကိဳးအသူရကယ္",
  T_21_R_EMOTE_SORROW_NAME: "ဘာလို့လဲ? ဘာလို႔လဲ ?",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "ပန့္ခ္စတားအိတ္",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "ေနာက္ဆံုးရိုက္ခ်က္",
  T_21_W_M79_RABBITKILLER_N: "M79-ဟစ္စတား ဘန္နီ",
  T_21_W_PAN_VOLCANO_N: "Pan - Volcanic Fury",
  T_21_W_XM8_RAINBOW_N: "XM8 - Songkran",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "{0}မီတာအတြင္းရွိေမွာက္သို႔ထိုင္မေနေသာရန္သူမ်ား၏ေနရာကို {1} စကၠန္႔ျပမည္ ,CD {2}စကၠန္႕ၾကာမည္။ အဆင့္တိုင္းသည္အသင္းႏွင့္ေဝမွ်ရမည္။",
  T_22_C_SKILL_NAME_DETECTIVE: "ေျခရာေကာက္ျခင္း",
  T_22_C_SKILL_NAME_STREAMERGUY: "Limelight",
  T_22_L_F_H_COLLEGE: "ဘလက္ေရွာ့ ဂ်ဴးနီယာ(ဆံပင္)",
  T_22_L_F_S_SUMMER20: "ဆမ္မာ ဒါလင္း(ဖိနပ္)",
  T_22_L_M_A_GREENCOAT: "LAZYLOXY",
  T_22_L_M_A_PINKFUR: "UrboyTJ",
  T_22_L_M_A_PLAGUE2: "Plague Phantom(မ်က္နွာဖံုး)",
  T_22_L_M_B_FAIM2: "ကပ္ေဘးျပစ္ဒဏ္ (ေဘာင္းဘီ)",
  T_22_L_M_B_GREENCOAT: "LAZYLOXY",
  T_22_L_M_B_PINKFUR: "UrboyTJ",
  T_22_L_M_B_PLAGUE2: "Plague Phantoms(ေအာက္)",
  T_22_L_M_B_REDPANTS: "OG-ANIC",
  T_22_L_M_B_TIGERSTRIPE: "MAIYARAP",
  T_22_L_M_H_COLLEGE: "Bloodshot Senior(ဆံပင္)",
  T_22_L_M_H_FAIM2: "ကပ္ေဘးျပစ္ဒဏ္ (ေခါင္းေဆာင္း)",
  T_22_L_M_H_GREENCOAT: "LAZYLOXY",
  T_22_L_M_H_PINKFUR: "UrboyTJ",
  T_22_L_M_H_PLAGUE2: "Plague Phantom(ဆံပင္)",
  T_22_L_M_H_REDPANTS: "OG-ANIC",
  T_22_L_M_H_TIGERSTRIPE: "MAIYARAP",
  T_22_L_M_S_FAIM2: "ကပ္ေဘးျပစ္ဒဏ္ (ဖိနပ္)",
  T_22_L_M_S_PLAGUE2: "Plague Phantom(ဖိနပ္)",
  T_22_L_M_T_FAIM2: "ကပ္ေဘးျပစ္ဒဏ္ (အကၤ်ီ)",
  T_22_L_M_T_GREENCOAT: "LAZYLOXY",
  T_22_L_M_T_PINKFUR: "UrboyTJ",
  T_22_L_M_T_PLAGUE2: "Plague Phantom(အေပၚ)",
  T_22_L_M_T_REDPANTS: "OG-ANIC",
  T_22_L_M_T_TIGERSTRIPE: "MAIYARAP",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K - Rebel Academy",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Pan - Watermelon",
  T_22_LC_SCAR_HERMIT_N: "SCAR - Mystic Seeker",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "ကုသေရးပစၥတို - Lifebeam",
  T_22_O_HAWK_NAME: "ေဖၚကို",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "တိရိစာၦန္စကင္း: မာယာေျမေခြး",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "တိရိစာၦန္စကင္း : ငရဲမီးဖယ္လ္ကို",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "တိရိစာၦန္စကင္း : ဂရင္း ေဖၚကို",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "တိရိစာၦန္စကင္း : ဆန္းရိႈင္း ခ်ိဘ",
  T_22_Q_BOMB_PLIERS: "ဗံုးရွင္းလင္းေရးကိရိယာ",
  T_22_R_EMOTE_SHIMMY_NAME: "ခ်စ္သူ",
  T_22_U_GOLD_AWM_N: "AWM_Y",
  T_22_U_WPNSKN_BITE: "က်ဥ္ေဖာက္",
  T_22_U_WPNSKN_SPEED_RUN: "ေရြ႕လ်ားမႈအရိွန္ႏႈန္း",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "မိုးဇက္",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "ေျဖာင့္မတ္ေသာစလက္စ္",
  T_23_C_SKILL_NAME_SWATGUY: "ေဗ့ခ္်ေအာ္တို",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: "Hayato ဖိုင္းယားဗန္း",
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "အႀကီးဗိုက္ဖ္ (ေအာက္)",
  T_23_L_F_B_MIKOGIRL: "ရေခဲမီး (ေအာက္)",
  T_23_L_F_B_NAVYGIRL: "အျပာေရာင္မိန္းကေလး (ေအာက္)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "ဗိုက္ဖ္အႀကီး (ေခါင္း)",
  T_23_L_F_H_MIKOGIRL: "ရေခဲမီး (ေခါင္း)",
  T_23_L_F_H_NAVYGIRL: "ေရတပ္မိန္းကေလး (ေခါင္း)",
  T_23_L_F_S_MIKOGIRL: "ရေခဲမီး (ဖိနပ္)",
  T_23_L_F_S_ORDERCHALLENGER: "ဓါးျမဗိုလ္ (ဖိနပ္)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "ဗိုက္ဖ္အႀကီး (အေပၚ)",
  T_23_L_F_T_MIKOGIRL: "ရေခဲမီး (အေပၚ)",
  T_23_L_F_T_NAVYGIRL: "အျပာေရာင္မိန္းကေလး (အေပၚ)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "ရက္ပါအႀကီး (မ်က္ႏွာဖံုး)",
  T_23_L_M_B_FOXGUY: "မီးေရခဲ (ေအာက္)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "ရက္ပါအႀကီး (ေအာက္)",
  T_23_L_M_H_FOXGUY: "မီးေရခဲ (ေခါင္း)",
  T_23_LC_SKS_GEMINI_N: "SKS- Hysteric",
  T_23_O_PENGUIN_NAME: "မစ္စတာဝက္ကာ",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "တိရိစာၦန္စကင္း : ပါတီ ဝက္ကာ",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "တိရိစာၦန္စကင္း : ဆိုင္ဘာ ဝက္ကာ",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "တိရိစာၦန္စကင္း : ဂိုးလ္ ဝက္ကာ",
  T_23_T_ANNI3_LOBBY_NODENAME20: "4v4",
  T_23_T_ANNI3_LOBBY_NODENAME5: "ကာရိုက္တာ",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "သတိေပးခ်က္",
  T_24_C_FLAMETHROWER_NAME: "မီးေတာက္က်ဲသူ",
  T_24_C_SKILL_DESC_PROFESSOR: "EP အျမင့္ဆံုး {0} တိုး  ဂ်ဴဂ်စ္ဆုနည္းလမ္း:အဖြဲ႔သားျဖင့္ {2} အကြာအေဝးတြင္ EP ကေနHP သို႔ ေျပာင္းလဲျခင္း {1}% တိုး  ဆိုင္ကိုလိုဂ်ီနည္းလမ္း:{4} စကၠန္႔တိုင္း EP {5} ခုျဖည့္ေပးသည္ အမ်ားဆုံး {6} ခုစဝွစ္ခ်္ စီဒီ နည္းလမ္း :  {3}စကၠန္႔",
  T_24_C_SKILL_NAME_PARTYGIRL: "ပါတီဂဲးလ္",
  T_24_C_SKILL_NAME_PROFESSOR: "အားလံုး၏အရွင္",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "MAX ေဘာင္းဘီ",
  T_24_L_H_PUMPKIN2020_A: "ထဝွစ္ ပမ္ကင္း  (ေခါင္း)",
  T_24_L_T_TSHIRT_COMEDIAN: "သူရဲေကာင္းရဲ႕ေနာက္ဆံုးအခ်က္",
  T_24_LC_MP5_RICHBOXER_N: "MP5- Champion Boxer",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR- ပါတီသရဲ",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD- Swordsman Legends",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "စုစုေပါင္းရမွတ္",
  T_24_V_TRAINING_BOX_ATTACH: "တပ္တြဲရန္",
  T_24_V_TRAINING_BOX_WEAPON: "လက္နက္မ်ား",
  T_24_W_ARMORY: "လက္နက္",
  T_24_W_ARMOTY_MELEE: "မီလီ",
  T_24_W_ARMOTY_PISTOL: "ပစ္စတိုေသနတ္",
  T_24_W_ARMOTY_RIFLE: `ရိုင္ဖယ္
ေသနတ္`,
  T_24_W_ARMOTY_SHOTGUN: "ေသနတ္",
  T_24_W_ARMOTY_SNIPER: "စႏိုက္ပါေသနတ္",
  T_24_W_ARMOTY_SPECIAL: "အျခား",
  T_24_W_ARMOTY_SUBMACHINE: "SMGs",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "တိရိစာၦန္စကင္း: ဘူးရားလ္ ပန္ဒါ",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "တိရိစာၦန္စကင္း : ေရာ့ကီ",
  T_24_W_PETSKIN_RACCOON_MECH_N: "တိရိစာၦန္စကင္း : ပါတီေရာ့ခ္ကီ",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "တိရိစာၦန္စကင္း: အန္ဒတ္ေရာ့ခ္ကီ",
  T_24_W_RACCOON_N: "ေက်ာက္တံုး",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "အခ်ိန္လွည့္သူ",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "ပရီဆက္ 1",
  T_25_E_HUD_02: "ပရီဆက္ 2",
  T_25_L_F_B_DEMONKILLER: "အေမႊစိန္ ဂ်ဴနီယာ (ေဘာင္းဘီ)",
  T_25_L_F_H_DEMONKILLER: "အေမႊစိန္ ဂ်ဴနီယာ (ဦးေခါင္း)",
  T_25_L_F_S_DEMONKILLER: "အေမႊစိန္ ဂ်ဴနီယာ (ဖိနပ္)",
  T_25_L_F_T_DEMONKILLER: "အေမႊစိန္ ဂ်ဴနီယာ (အက်ႌ)",
  T_25_L_HA_FP_EVIL: "နတ္ဆိုး (မ်က္ႏွာပန္းခ်ီ)",
  T_25_L_M_H_ANIMEHAIR: "ေလညင္းသာ (ဆံပင္)",
  T_25_L_S_MAXSNEAKERS: "MAX စနီကာ",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Cyber Swing",
  T_25_LC_GLOO_WINTERFEST2020_N: "ေရခဲနံရံ- ေဆာင္းနယ္ေျမ 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887- Winterlands 2020",
  T_25_LC_MACHETE_BOUNTY_N: "ဆိုက္ဘာ ဓါး",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90- Tune Blaster Green",
  T_25_LC_P90_MUSICFALL_RED_N: "P90- Tune Blaster Red",
  T_25_LC_PAN_BOUNTY_N: "Pan- Cyber Bounty Hunter",
  T_25_R_LEGEND_REMIND: "သတိေပးခ်က္",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "ဓါးရိုးရွည္",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "ဘာဘြန္း",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "တိရိစာၦန္စကင္း : ဂလက္စီရာသားေကာင္",
  T_25_W_PETSKIN_BABOON_HELL_N: "တိရိစာၦန္စကင္း : မီးေတာက္သားရဲ",
  T_25_W_PETSKIN_BABOON_PURE_N: "တိရိစာၦန္စကင္း : ၾကီးျမတ္သားရဲျဖဴ",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "တိရိစာၦန္စကင္း : စႏိုးပန္ဒါ",
  T_25_Z_R_SIMULATOR_OFF: "ခြင့္မျပဳပါ",
  T_26_C_SKILL_DESC_SUPERSTAR: "အသံလႈိင္းကိုေရွ႕သို႔ပို႔ၿပီး {1}, cooldown {2} စကၠန႔္အတြင္း {0} မီတာအတြင္း အိုက္စ္ေဝါl ကိုပ်က္စီးေစသည္။ {3} ယူနစ္ မွစတင္၍ ဤဂိမ္းတြင္အသုံးျပဳသည္ (ျပန္လည္ထူေထာင္အမွတ္သက္ေရာက္မႈမ်ားမဆင့္စီထားပါ)",
  T_26_C_SKILL_NAME_SUPERSTAR: "ရစ္တိုက္ရစ္တန္",
  T_26_D_CHARACTER_DELIVERY_N: "Shirou",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "UAV-Lite",
  T_26_L_A_FLAMING_PREM: "ငရဲသားစစ္သား (မ်က္ႏွာဖံုး)",
  T_26_L_A_SANTAMODE: "ႏွင္းလူသားေဘာ့ (မ်က္ႏွာဖံုး)",
  T_26_L_B_SANTAMODE: "ႏွင္းလူသားေဘာ့ (ေဘာင္းဘီ)",
  T_26_L_F_B_WATERFEST21_A: "ေႏြရာသီေလေျပ (ေဘာင္းဘီ)",
  T_26_L_F_H_WATERFEST21_A: "ေႏြရာသီေလေျပ (ဦးေခါင္း)",
  T_26_L_F_S_WATERFEST21_A: "ေႏြရာသီေလေျပ (ဖိနပ္)",
  T_26_L_F_T_WATERFEST21_A: "ေႏြရာသီေလေျပ (အကၤ်ီ)",
  T_26_L_M_A_EGGDAY2021: "ဆိုက္ဘာဘန္နီ (မ်က္ႏွာဖံုး)",
  T_26_L_M_B_EGGDAY2021: "ဆိုက္ဘာဘန္နီ (ေဘာင္းဘီ)",
  T_26_L_M_B_PAIRING: "ဒိုင္နမစ္ဒိုအမ္ (ေဘာင္းဘီ)",
  T_26_L_M_B_WATERFEST21_A: "ေႏြရာသီလွိဳင္း (ေဘာင္းဘီ)",
  T_26_L_M_H_EGGDAY2021: "ဆိုက္ဘာဘန္နီ (ဦးေခါင္း)",
  T_26_L_M_H_PAIRING: "ဒိုင္နမစ္ဒိုအမ္ (ဦးေခါင္း)",
  T_26_L_M_H_WATERFEST21_A: "ေႏြရာသီလွိဳင္း (ဦးေခါင္း)",
  T_26_L_M_S_EGGDAY2021: "ဆိုက္ဘာဘန္နီ (ဖိနပ္)",
  T_26_L_M_S_PAIRING: "ဒိုင္နမစ္ဒိုအမ္ (ဖိနပ္)",
  T_26_L_M_S_WATERFEST21_A: "ေႏြရာသီလွိဳင္း (ဖိနပ္)",
  T_26_L_M_T_EGGDAY2021: "ဆိုက္ဘာဘန္နီ (အကၤ်ီ)",
  T_26_L_M_T_PAIRING: "ဒိုင္နမစ္ဒိုအမ္ (အကၤီ်)",
  T_26_L_M_T_WATERFEST21_A: "ေႏြရာသီလွိဳင္း (အကၤ်ီ)",
  T_26_L_S_SANTAMODE: "ႏွင္းလူသားေဘာ့ (ဖိနပ္)",
  T_26_L_T_SANTAMODE: "ႏွင္းလူသားေဘာ့ (အကၤ်ီ)",
  T_26_LC_AWM_KOICARP_N: "AWM- Lucky Koi",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana- Season of Pink",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "စေပါ့ကား - ေကာ္ဘရာ",
  T_26_P_SKILL_NAME_DELIVERY: "ထိေရာက္သည့္ထိခိုက္မွဳ",
  T_26_V_TRAINING_BHH: "ဖန္စီတူ",
  T_26_V_TRAINING_DICE: "ဧရာမအန္စာတံုး",
  T_26_W_DRAGON_N: "ဒရက္ကီ",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "တိရိစာၦန္စကင္း : ပက္ဖ်န္းဒရက္ကီ",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "တိရိစာၦန္စကင္း : အဆံုးပို႔မဲ့ဒရက္ကီ",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "တိရိစာၦန္စကင္း : ဂလက္စီဒရက္ကီ",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "တိရိစာၦန္စကင္း : ဝွက္ေဂါလ္ခ်စ္ျခင္း",
  T_26_XL_SETTING_TEAMMATE_INFO: "အသင္းသားအခ်က္အလက္",
  T_26_YP_HISTORY_WIN: "အႏိုင္ရသည္",
  T_26_YP_SOCIAL_GENDER_FEMALE: "မ",
  T_26_YP_SOCIAL_GENDER_MALE: "က်ား",
  T_26_YP_SOCIAL_NAME: "အမည္ေျပာင္",
  T_27_C_SKILL_DESC__RACERGIRL: "ယာဥ္ေမာင္းစဥ္တြင္ {0}%အရွိန္တိုးျမွင့္မည္, ဇာတ္ေကာင္သည္ပိုျပီးခ်ိန္ရခက္မည္, ပ်က္စီးမွဳသည္ {1}%ထိေလွ်ာ့က်မည္",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "ထိခိုက္မွဳအား {0} ပိတ္ဆို႔ႏိုင္ေသာအင္အားကြင္းတီထြင္ပါ. အတြင္းမွျပင္ပရွိရန္သူကိုပစ္မရပါ. သက္ေရာက္မွဳအားလံုး{1}s ရွိမည္. CD {2}s",
  T_27_C_SKILL_DESC_FALCONER: `ပ်က္စီးမွဳသည္အကြာအေဝးအလိုက္ {0}%
တိုးျမွင့္မည္, ခ်ိန္ပစ္မွတ္ရန္သူသို႔ {1}%တိုးမည္`,
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "ႏိုးထျခင္း : HPဆံုးရွဳံးမွဳအျမင့္ဆံုး {0}%တိုင္းအတြက္ ေရွ႕ပိုင္းပ်က္စီးမွဳ {1}% ေလွ်ာ့က်မည္",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "ႏိုးၾကားျခင္း: {0}s ေျပားျပီးအသက္သြင္းပါ. ႏိုးၾကားလာေသာအခါ, ပထမပစ္ခ်က္ {2}ခုပစ္မွတ္ကို {1}% ထိခိုက္မွဳေပးပါ. 3s ၾကာရမည္",
  T_27_C_SKILL_NAME_FALCONER: "သိမ္းမ်ိဳးစိတ္အား",
  T_27_C_SKILL_NAME_XTREME: "တစ္ဖက္စြန္းတိုက္ခိုက္ျခင္း",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: "ရက္စက္ခက္ထန္တဲ့ Andrew",
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xayne",
  T_27_F_EAP_PKG3_D: "စတိုင္က်က်တိုက္ပြဲ!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "က်ားစကၠဴ (မ်က္ႏွာဖံုး)",
  T_27_L_B_CARDBOARD_REG: "ဝက္ဝံစကၠဴ (ေဘာင္းဘီ)",
  T_27_L_M_S_KAZAKHSTAN: "ပဂါးဒါး (ဖိနပ္)",
  T_27_L_S_CARDBOARD_REG: "ဝက္ဝံစကၠဴ (ဖိနပ္)",
  T_27_L_T_CARDBOARD_REG: "ဝက္ဝံစကၠဴ (အကၤ်ီ)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector- FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "မြန္စတားကားၾကီး - FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "ဆိုင္ကယ္- K.O. ညမိုက္",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "ျပိဳင္ကား - ျမေက်ာက္မီးေတာက္",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "ကုန္တင္ကား - နဂါးမီးေတာက္",
  T_27_P_SKILL_NAME_HITMAN_RE: "အသံတိတ္ေသျခင္း",
  T_27_R_EMOTE_GREETING_NAME: "ႏွဳိက္ဆက္ျခင္း",
  T_27_R_VEHICLE_ACCELERATION: "အရွိန္အဟုန္",
  T_27_R_VEHICLE_HP: "ၾကာခ်ိန္",
  T_27_R_VEHICLE_SPEED: "အျမင့္ဆံုးအလ်င္",
  T_27_U_KORD: "ေကာ့ဒ္စက္ေသနတ္",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "ႏိုးၾကားျခင္း: က်ည္ကာပ်က္စီးမွဳက်ဆင္းႏွဳန္း {0}% တိုးျမွင့္.ထပ္ေဆာင္းအေနႏွင့္ အသင္းေဖာ္အားလံုးစြမ္းရည္သံုးသူတိုင္း 15% ပ်က္စီးမွဳက်ဆင္းမည္",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "ဝံပုေလြအထုပ္",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "မြန္းနီ",
  T_27_W_ARMOTY_DMR: "လက္ေျဖာင့္ရိုင္ဖယ္",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "တိရိစာၦန္စကင္း : ခရစ္စတယ္မြန္းနီ",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "တိရိစာၦန္စကင္း : ဂိမ္းသမားေလးမြန္းနီ",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "တိရိစာၦန္စကင္း : ဟစ္စတာမြန္းနီ",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "တိရိစာၦန္စကင္း : FFWS 2021 ပါပီ",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "တိရိစာၦန္စကင္း : FFWS 2021 ပန္ဒါ",
  T_27_XC_REPLAY_DIE: "ေသျခင္း",
  T_27_XC_REPLAY_KILL: "ေခ်မွဳန္းႏွဳန္း",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "ျပဳျပင္",
  T_28_C_G_ICE_NAME: "အလင္းဗံုး",
  T_28_C_SKILL_DESC_STREETBEAT: "လွဳပ္ရွားစဥ္ပစ္ေသာအခါ, လွဳပ္ရွားမွဳအလ်င္ {0}%တိုးျမွင့္သည္, တိက်မွဳ {1}%တိုးျမွင့္သည္",
  T_28_C_SKILL_NAME_STREETBEAT: "က်ည္သံဇဥ္",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "Uzi အေသး",
  T_28_L_B_BRJERSEY_A: "နံပါတ္ 23 ေဘာလံုးဂ်ာစီ (ေဘာင္းဘီ)",
  T_28_L_B_BRJERSEY_B: "နံပါတ္ 10 ေဘာလံုးဂ်ာစီ (ေဘာင္းဘီ)",
  T_28_L_B_BRJERSEY_C: "နံပါတ္ 24 ေဘာလံုးဂ်ာစီ (ေဘာင္းဘီ)",
  T_28_L_B_BRJERSEY_D: "နံပါတ္ 30 ေဘာလံုးဂ်ာစီ (ေဘာင္းဘီ)",
  T_28_L_B_BRJERSEY_E: "နံပါတ္ 1 ေဘာလံုးဂ်ာစီ (ေဘာင္းဘီ)",
  T_28_L_B_BRJERSEY_F: "နံပါတ္ 20 ေဘာလံုးဂ်ာစီ (ေဘာင္းဘီ)",
  T_28_L_F_B_FOURSYMBOLS_C: "ဟသၤပဒါးေလေပြ (ေဘာင္းဘီ)",
  T_28_L_F_H_FOURSYMBOLS_C: "ဟသၤပဒါးေလေပြ (ဦးေခါင္း)",
  T_28_L_F_HA_FOURSYMBOLS_C: "ဟသၤပဒါးေလေပြ (မ်က္ႏွာပန္းခ်ီ)",
  T_28_L_F_S_FOURSYMBOLS_C: "ဟသၤပဒါးေလေပြ (ဖိနပ္)",
  T_28_L_F_T_FOURSYMBOLS_C: "ဟသၤပဒါးေလေပြ (အကၤ်ီ)",
  T_28_L_HA_THUNDER: "လွ်ပ္စီးမ်က္လံုး (မ်က္ႏွာပန္းခ်ီ)",
  T_28_L_M_A_SPORTSUIT: "ဘီစကိတ္ဘိြဳင္း (မ်က္ႏွာဖံုး)",
  T_28_L_M_B_FOURSYMBOLS_D: "ေျမငလ်င္ဖန္တီးသူ (ေဘာင္းဘီ)",
  T_28_L_M_B_SPORTSUIT: "ဘီစကိတ္ဘိြဳင္း (ေဘာင္းဘီ)",
  T_28_L_M_H_FOURSYMBOLS_D: "ေျမငလ်င္ဖန္တီးသူ (ဦးေခါင္း)",
  T_28_L_M_H_SPORTSUIT: "ဘီစကိတ္ဘိြဳင္း (ဦးေခါင္း)",
  T_28_L_M_S_FOURSYMBOLS_D: "ေျမငလ်င္ဖန္တီးသူ (ဖိနပ္)",
  T_28_L_M_S_SPORTSUIT: "ဘီစကိတ္ဘိြဳင္း (ဖိနပ္)",
  T_28_L_M_T_FALLWINTER: "မိုက္မဲသား (အက်ၤီ)",
  T_28_L_M_T_FOURSYMBOLS_D: "ေျမငလ်င္ဖန္တီးသူ (အကၤ်ီ)",
  T_28_L_M_T_SPORTSUIT: "ဘီစကိတ္ဘိြဳင္း (အကၤ်ီ)",
  T_28_L_T_BRJERSEY_A: "နံပါတ္ 23 ေဘာလံုးဂ်ာစီ (အက်ၤီ)",
  T_28_L_T_BRJERSEY_B: "နံပါတ္ 10 ေဘာလံုးဂ်ာစီ (အကၤ်ီ)",
  T_28_L_T_BRJERSEY_C: "နံပါတ္ 24 ေဘာလံုးဂ်ာစီ (အကၤ်ီ)",
  T_28_L_T_BRJERSEY_D: "နံပါတ္ 30 ေဘာလံုးဂ်ာစီ (အကၤ်ီ)",
  T_28_L_T_BRJERSEY_E: "နံပါတ္ 1 ေဘာလံုးဂ်ာစီ (အကၤ်ီ)",
  T_28_L_T_BRJERSEY_F: "နံပါတ္ 20 ေဘာလံုးဂ်ာစီ (အကၤ်ီ)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94- Ruby Bride",
  T_28_LC_GLOO_FALLWINTER_N: "အိုက္စ္ေဝါ- မိုက္မဲသား",
  T_28_LC_GLOO_FOURSYMBOLS_N: "အိုက္စ္ေဝါ- မုန္တိုင္းဖန္တီးရွင္",
  T_28_LC_KORD_SHINOBI_N: "Kord- ရွီႏိုဘီ",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker- အၾကင္နာမဲ့ေမွာ္ဆရာ",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - အဆိပ္ျပင္းဆူးေတာင္",
  T_28_LC_PAN_FOURSYMBOLS_N: "Pan- ေျမငလ်င္ေဆာင့္သူ",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Jeep- မုန္တိုင္းဖန္တီးရွင္",
  T_28_T_WS_ITEM1: "ေလးေထာင့္ေသတၱာ",
  T_28_T_WS_ITEM10: "ဦးထုပ္",
  T_28_T_WS_ITEM11: "အေစာင့္တာဝါ",
  T_28_T_WS_ITEM12: "တပ္စခန္း",
  T_28_T_WS_ITEM13: "ေဟာက္စ္ A",
  T_28_T_WS_ITEM14: "ေဟာက္စ္ B",
  T_28_T_WS_ITEM15: "ေဟာက္စ္ C",
  T_28_T_WS_ITEM16: "သဲဖြဲ႕စည္းပံု",
  T_28_T_WS_ITEM17: "ေဖာင္တိန္",
  T_28_T_WS_ITEM18: "ခ်ယ္ရီပြင့္",
  T_28_T_WS_ITEM19: "ငွက္ေပ်ာသီးပင္",
  T_28_T_WS_ITEM2: "ေသတၱာအရွည္",
  T_28_T_WS_ITEM20: "ဘိုထိုင္အိမ္သာ",
  T_28_T_WS_ITEM21: "အကာ",
  T_28_T_WS_ITEM3: "ခ်ံဳပုတ္",
  T_28_T_WS_ITEM4: "ျမက္ေျခာက္",
  T_28_T_WS_ITEM5: "ကား",
  T_28_T_WS_ITEM6: "ဘတ္စ္ကား",
  T_28_T_WS_ITEM7: "ကြန္တိန္နာ A",
  T_28_T_WS_ITEM8: "ကြန္တိန္နာ B",
  T_28_T_WS_ITEM9: "ကြန္တိန္နာ C",
  T_28_T_WS_TYPE1: "အရာဝတၳဳမ်ား",
  T_28_T_WS_TYPE4: "အခင္းအက်င္းမ်ား",
  T_28_W_DUCK_N: "ေဒါက္တာပဲနီ",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "တိရိစာၦန္စကင္း : ဒ႑ာရီလာဒရက္ကီ",
  T_28_W_PETSKIN_DUCK_ARMY_N: "တိရိစာၦန္စကင္း: စိန္႔ပဲနီ",
  T_28_W_PETSKIN_DUCK_BLACK_N: "တိရိစာၦန္စကင္း : ဂန္းစတားပဲနီ",
  T_28_W_PETSKIN_DUCK_SHINY_N: "တိရိစာၦန္စကင္း : ဒီေဂ်ပဲနီ",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "ႏိုးထျခင္း: ရန္သူလွဳပ္ရွားစဥ္ရန္သူကို {0}s ၾကာခ်ိန္ထားပါ",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "ပေဟဠိမ်က္လံုး",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "ပဓာနစြမ္းရည္",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "ႏွလံုးခုန္သံကုစားျခင္း",
  T_29_D_CHARACTER_AMOCO_N: "Moco ပေဟဠိ",
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "အစင္းဂ်ာစီ (ေဘာင္းဘီ)",
  T_29_L_M_A_FALCONER_C: "သဒၶါထက္သူ (မ်က္ႏွာဖံုး)",
  T_29_L_M_A_JUNGLE_GREEN: "တိုက္ပြဲလိပ္ (မ်က္ႏွာဖံုး)",
  T_29_L_M_B_FALCONER_C: "သဒၶါထက္သူ (ေဘာင္းဘီ)",
  T_29_L_M_B_JUNGLE_GREEN: "တိုက္ပြဲလိပ္ (ေဘာင္းဘီ)",
  T_29_L_M_H_FALCONER_C: "သဒၶါထက္သူ (ဦးေခါင္း)",
  T_29_L_M_H_JUNGLE_GREEN: "တိုက္ပြဲလိပ္ (ဦးေခါင္း)",
  T_29_L_M_S_FALCONER_C: "သဒၶါထက္သူ (ဖိနပ္)",
  T_29_L_M_S_JUNGLE_GREEN: "တိုက္ပြဲလိပ္ (ဖိနပ္)",
  T_29_L_M_T_FALCONER_C: "သဒၶါထက္သူ (အကၤ်ီ)",
  T_29_L_M_T_JUNGLE_GREEN: "တိုက္ပြဲလိပ္ (အကၤ်ီ)",
  T_29_L_T_TRJERSEY: "အစင္းဂ်ာစီ (အကၤ်ီ)",
  T_29_M_WS_ITEM22: "အၾကမ္းခံကြန္တိန္နာ",
  T_29_M_WS_ITEM23: "အၾကမ္းခံျခံစည္းရိုး",
  T_29_M_WS_ITEM24: "ေပါက္ဖြားအမွတ္ A",
  T_29_M_WS_ITEM25: "ေပါက္ဖြားအမွတ္ B",
  T_29_M_WS_TYPE5: "တုံ႔ျပန္ျခင္း",
  T_29_W_PETSKIN_BROWN_TIGER_N: "တိရိစာၦန္စကင္း : ေျမဆန္ဆိုင္းတစ္",
  T_29_W_PETSKIN_FIRE_TIGER_N: "တိရိစာၦန္စကင္း : မီးေတာက္ဆန္ဆိုင္းတစ္",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "တိရိစာၦန္စကင္း : ဆိုက္ဘာသိန္းငွက္",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "တိရိစာၦန္စကင္း : ပါတီပန္ဒါ",
  T_29_W_PETSKIN_WHITE_TIGER_N: "တိရိစာၦန္စကင္း : ေရခဲဆန္ဆိုင္းတစ္",
  T_29_W_TIGER_NINJA_N: "ဆန္ဆိုင္းတစ္",
  T_29_YF_MACHETE_MUSICFEST_N: "အသံလွဳိင္းတုန္ခါေစသူ",
  T_29_YF_MAGEZINE_CHAIN_N: "AR က်ည္ကပ္",
  T_29_YF_MUZZLE_CRASH_N: "SMGs က်ည္",
  T_29_YF_MUZZLE_WIDE_N: "ေသနတ္ေျပာင္းဝ",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12- ေကာ္စမစ္ပို႔သူ",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi- Amber Megacypher",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Monster Truck- သူပုန္အေဂါ",
  T_30_AD_RP_ROUNDEND: "ပြဲျပီးပါျပီ",
  T_30_AD_TRAINING_SNOWBALL: "ႏွင္းေဘာလံုး",
  T_30_AD_TRAINING_SNOWBALL_DES: "ႏွင္းလံုးပစ္တမ္းကစားရေအာင္!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] after being attacked, recover [FFB300]{1}HP[-]/s for [FFB300]{2}s[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "ဘက္ဇာဘီတာ",
  T_30_C_SKILL_NAME_MUERTOGUY: "မွတ္ဥာဏ္စ",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Jai မိုက္ခရိုခ်ိစ္",
  T_30_L_A_BRMASCOT_ADULT: "ေဒါသနဲ႔ေပါက္စေခါင္း",
  T_30_L_A_BRMASCOT_KIDS: "ခ်စ္စဖြယ္ေပါက္စေဦးေခါင္း",
  T_30_L_A_SUGARSKULL21_BANDANA: "မရဏခိုက္ျခင္းမ်က္ႏွာဖံုး",
  T_30_L_B_BRFOOTBALL_BLACK: "စီဘီအက္ဖ္ဂ်ာစီ - အနက္ (ေဘာင္းဘီ)",
  T_30_L_B_BRFOOTBALL_GREEN: "စီဘီအက္ဖ္ဂ်ာစီ - အစိမ္း (ေဘာင္းဘီ)",
  T_30_L_B_BRFOOTBALL_GREY: "စီဘီအက္ဖ္ဂ်ာစီ - မီးခိုး (ေဘာင္းဘီ)",
  T_30_L_B_BRUNIFORM: "ကနရီဌက္ငယ္ (ေဘာင္းဘီ)",
  T_30_L_F_A_SUGARSKULL21: "ေရႊကြပ္ဘုရင္မ (မ်က္ႏွာဖံုး)",
  T_30_L_F_B_SUGARSKULL21: "ေရႊကြပ္ဘုရင္မ (ေဘာင္းဘီ)",
  T_30_L_F_B_THASIAN: "သႏၲာေက်ာက္ဒုကၡ (ေဘာင္းဘီ)",
  T_30_L_F_H_CATEARS: "ခါဝါးအီ",
  T_30_L_F_H_SUGARSKULL21: "ေရႊကြပ္ဘုရင္မ (ဦးေခါင္း)",
  T_30_L_F_H_THASIAN: "သႏၲာေက်ာက္ဒုကၡ (ေခါင္းေဆာင္း)",
  T_30_L_F_S_SUGARSKULL21: "ေရႊကြပ္ဘုရင္မ (ဖိနပ္)",
  T_30_L_F_S_THASIAN: "သႏၲာေက်ာက္ဒုကၡ (ဖိနပ္)",
  T_30_L_F_T_SUGARSKULL21: "ေရႊကြပ္ဘုရင္မ (အကၤ်ီ)",
  T_30_L_F_T_THASIAN: "သႏၲာေက်ာက္ဒုကၡ (အကၤ်ီ)",
  T_30_L_H_CHILDRENSDAY_BLUE: "လင္းပိုင္ဦးေခါင္း",
  T_30_L_H_CHILDRENSDAY_RED: "ဆင္ေခါင္း",
  T_30_L_H_CLOWNHAT: "ဆပ္ကပ္ဦးထုပ္ - အဝါ",
  T_30_L_H_ZASCARF: "ေရႊလည္စည္း",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "ဒီစီဂန္းစတား (မ်က္ႏွာဖံုး)",
  T_30_L_M_A_SUGARSKULL21: "ေရႊကြပ္ဘုရင္ (မ်က္ႏွာဖံုး)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "ဒီစီဂန္းစတား (ေဘာင္းဘီ)",
  T_30_L_M_B_PKCRICKET: "အစိမ္းခ်န္ပီယံ (ေဘာင္းဘီ)",
  T_30_L_M_B_SUGARSKULL21: "ေရႊကြပ္ဘုရင္ (ေဘာင္းဘီ)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "ေလဟုန္စီးသူ (ေဘာင္းဘီ)",
  T_30_L_M_B_THASIAN: "သႏၲာေက်ာက္သူပုန္ (ေဘာင္းဘီ)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "ဒီစီဂန္းစတား (ဦးေခါင္း)",
  T_30_L_M_H_SUGARSKULL21: "ေရႊကြပ္ဘုရင္ (ဦးေခါင္း)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "ေလဟုန္စီးသူ (ဦးေခါင္း)",
  T_30_L_M_H_THASIAN: "သႏၲာေက်ာက္သူပုန္ (ေခါင္းေဆာင္း)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "အယ္ဖာလ္ရိုန္ဂ်ာ (မ်က္ႏွာပန္းခ်ီ)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "ဒီစီဂန္းစတား (ဖိနပ္)",
  T_30_L_M_S_PKCRICKET: "အစိမ္းခ်န္ပီယံ (ဖိနပ္)",
  T_30_L_M_S_SUGARSKULL21: "ေရႊကြပ္ဘုရင္ (ဖိနပ္)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "ေလဟုန္စီးသူ (ဖိနပ္)",
  T_30_L_M_S_THASIAN: "သႏၲာေက်ာက္သူပုန္ (ဖိနပ္)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "ဒီစီဂန္းစတား (အကၤ်ီ)",
  T_30_L_M_T_PKCRICKET: "အစိမ္းခ်န္ပီယံ (အကၤ်ီ)",
  T_30_L_M_T_SUGARSKULL21: "ေရႊကြပ္ဘုရင္ (အကၤ်ီ)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "ေလဟုန္စီးသူ (အကၤ်ီ)",
  T_30_L_M_T_THASIAN: "သႏၲာေက်ာက္သူပုန္ (အကၤ်ီ)",
  T_30_L_S_BRUNIFORM: "ကနရီဌက္ငယ္ (ဖိနပ္)",
  T_30_L_T_BRFOOTBALL_BLACK: "စီဘီအက္ဖ္ဂ်ာစီ - အနက္ (အကၤ်ီ)",
  T_30_L_T_BRFOOTBALL_GREEN: "စီဘီအက္ဖ္ဂ်ာစီ - အစိမ္း (အကၤ်ီ)",
  T_30_L_T_BRFOOTBALL_GREY: "စီဘီအက္ဖ္ဂ်ာစီ - မီးခိုး (အကၤ်ီ)",
  T_30_L_T_BRUNIFORM: "ကနရီဌက္ငယ္ (အကၤ်ီ)",
  T_30_M_WS_PARTY_MODE: "ကစားကြင္း",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "စိန္ေခၚသူ",
  T_30_R_EMOTE_MAX_NAME: "ရတ္ပါေပါက္စ",
  T_30_R_LEGEND_HALO_NAME: "အပူစက္ဝိုင္း",
  T_30_T_WS_DEFAULTDESCRIPTION: `Free Fire တီထြင္မွဳနယ္
ေျမကရင္ခုန္စရာေျမပံု`,
  T_30_T_WS_ITEM26: "အဆင့္မ်ား",
  T_30_T_WS_ITEM27: "Messy Tires A",
  T_30_T_WS_ITEM28: "Messy Tires B",
  T_30_T_WS_ITEM29: "Messy Tires C",
  T_30_T_WS_ITEM30: "ဘန္ဘာကား",
  T_30_T_WS_ITEM31: "Amphibian Car",
  T_30_T_WS_ITEM32: "Jeep",
  T_30_T_WS_ITEM33: "အမွိဳက္ပံုး",
  T_30_T_WS_ITEM34: "Shade",
  T_30_T_WS_ITEM35: "ေဆးဝါးတဲအိမ္",
  T_30_T_WS_ITEM36: "ဂိုေထာင္",
  T_30_T_WS_ITEM37: "ေဆးျခယ္နံရံ",
  T_30_T_WS_ITEM38: "Torii",
  T_30_T_WS_ITEM39: "Iron Platform",
  T_30_T_WS_ITEM40: "Site Hut",
  T_30_T_WS_ITEM41: "အျမည္း",
  T_30_T_WS_ITEM42: "တံတိုင္း A",
  T_30_T_WS_ITEM43: "တံတိုင္း B",
  T_30_T_WS_ITEM44: "တံတိုင္း C",
  T_30_T_WS_ITEM45: "တံတိုင္း D",
  T_30_T_WS_ITEM46: "တံတိုင္း E",
  T_30_T_WS_ITEM47: "တံတိုင္း F",
  T_30_U_ATTACHMENT_1: "က်ည္ကာ HP ျမွင့္စက္",
  T_30_U_ATTACHMENT_4: "က်ည္ကာတိုးခ်ဲ႕စက္",
  T_30_U_ATTACHMENT_5: "ေခါင္းေဆာင္းထူထူ",
  T_30_U_ATTACHMENT_6: "က်ည္ကာထူထူ",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "တိရိစာၦန္စကင္ : သားရဲအရိုးေခါင္း",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "တိရိစာၦန္စကင္ : ပန္႔ခ္ဝါေဂါလ္",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "တိရိစာၦန္စကင္: ခ်က္မေအးဂ်န္႔ေဟာ့",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "တိရိစာၦန္စကင္: ေအးဂ်န္႔ေဟာ့ပြဲေတာ္",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "တိရိစာၦန္စကင္: ဆိုက္ဘာေအးဂ်န္႔ေဟာ့",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "တိရိစာၦန္စကင္ : နဇာရိုဘို",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "တိရိစာၦန္စကင္ : အစိမ္းရိုဘိုခဲ",
  T_30_W_RABBIT_N: "ေအးဂ်န္႔ေဟာ့",
  T_30_XH_PCMAP_P17: "စက္ရံု",
  T_30_YF_GLOO_BOOYAHDAY21_N: "အိုက္စ္ေဝါ- BOOYAH DAY 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "ဗံုး- BOOYAH DAY 2021",
  T_30_YF_Healinggun_Sniper_N: "ကုသေရး စႏိုက္ဘာ",
  T_30_YF_MINI_LIGHTFEST_N: "AC80- ေတာ္ဝင္သူရဲေကာင္",
  T_30_YF_PARAFAL_ZATRIBAL_N: "Crimson Heir",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR- ေတာ္ဝင္သူရဲေကာင္း",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- ဂုဏ္ရည္ျမင့္ေရႊဝန္း",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "စေပါ့ကား- ပန္႔ခ္အရိုးေခါင္း",
  T_31_C_SKILL_NAME_WINTERGUY: "Ice Iron",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Winter Basher",
  T_31_HQ_GLOO_EAGLE_N: "အိုက္စ္ေဝါလ္- အပူခံကႏၲာရ",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "ကုသေရးစႏိုက္ဘာ- ေရခဲအရိုး",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana- Snow Doom",
  T_31_HQ_PAN_WINTERFEST21_N: "ဒယ္အိုး- Snow Doom",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "တိရိစာၦန္စကင္း : စႏိုးအို႔တီရို",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "တိရိစာၦန္စကင္: Waggor On Ice",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "တိရိစာၦန္စကင္: Tribal Yeti",
  T_31_HQ_PETSKIN_YETI_RED_N: "တိရိစာၦန္စကင္း: ဖီရာရီရတီီ",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Scythe of Snow",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "ဆိုင္ကယ္- Ice Blossoms",
  T_31_HQ_YETI_N: "Yeti",
  T_31_KK_WINTER_BUJIX: "ေထာက္ပံ့ပစၥည္း",
  T_31_KK_WINTER_SANJITOU: "ဦးထုပ္",
  T_31_L_A_BDCRICKET: "ခရစ္ကက္ (မ်က္ႏွာဖံုး)",
  T_31_L_A_WINTERFEST21: "Reindeer Cover",
  T_31_L_B_BDCRICKET: "ခရစ္ကက္ (ေဘာင္းဘီ)",
  T_31_L_B_MEJERSEY_10: "နံပါတ္ 10 ရူဘီဂ်ာစီ (ေဘာင္းဘီ)",
  T_31_L_B_MEJERSEY_11: "နံပါတ္ 11 အနီဂ်ာစီ (ေဘာင္းဘီ)",
  T_31_L_B_MEJERSEY_13: "နံပါတ္ 13 အျဖဴဂ်ာစီ (ေဘာင္းဘီ)",
  T_31_L_B_MEJERSEY_18G: "နံပါတ္ 18 အစိမ္းဂ်ာစီ (ေဘာင္းဘီ)",
  T_31_L_B_MEJERSEY_18R: "နံပါတ္ 18 မရြန္ဂ်ာစီ (ေဘာင္းဘီ)",
  T_31_L_B_MEJERSEY_7: "နံပါတ္ 7 ဘရာဇီးဂ်ာစီ (ေဘာင္းဘီ)",
  T_31_L_F_B_RUMUSICIAN: "ေမသံစဥ္ (ေဘာင္းဘီ)",
  T_31_L_F_B_THAGENT: "ရာဂအျငိဳး (ေဘာင္းဘီ)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Tie Dye Bucket",
  T_31_L_F_H_RUMUSICIAN: "ေမသံစဥ္ (ဦးေခါင္း)",
  T_31_L_F_H_THAGENT: "ရာဂအျငိဳး (ဦးေခါင္း)",
  T_31_L_F_HA_RUMUSICIAN: "ေမသံစဥ္ (မ်က္ႏွာပန္းခ်ီ)",
  T_31_L_F_S_RUMUSICIAN: "ေမသံစဥ္ (ဖိနပ္)",
  T_31_L_F_S_THAGENT: "ရာဂအျငိဳး (ဖိနပ္)",
  T_31_L_F_T_RUMUSICIAN: "ေမသံစဥ္ (အကၤ်ီ)",
  T_31_L_F_T_THAGENT: "ရာဂအျငိဳး (အကၤ်ီ)",
  T_31_L_HA_RUMUSICIAN_MU: "ေထာင္ေခ်ာက္ကြင္း (မ်က္ႏွာပန္းခ်ီ)",
  T_31_L_HA_WINTERFEST21_BLUE: "ျပဇာတ္လူျပက္မ်က္ႏွာပန္းခ်ီ",
  T_31_L_HA_WINTERFEST21_PINK: "မီးပြားစမ်က္ႏွာပန္းခ်ီ",
  T_31_L_M_A_REGGAETON_B: "ရက္ကီစည္းခ်က္ (မ်က္ႏွာဖံုး)",
  T_31_L_M_A_REGGAETON_P: "ရွင္သန္ျခင္းအားမာန္ (မ်က္ႏွာဖံုး)",
  T_31_L_M_A_RUMUSICIAN: "ၾကိဳးေထာင္ေခ်ာက္ (မ်က္ႏွာဖံုး)",
  T_31_L_M_A_THAGENT: "ကင္းေထာက္ (မ်က္ႏွာဖံုး)",
  T_31_L_M_B_PKCOSTUME: "စိမ္းလဲ့လဲ့ညိဳ႕ (ေဘာင္းဘီ)",
  T_31_L_M_B_REGGAETON_B: "ရက္ကီစည္းခ်က္ (ေဘာင္းဘီ)",
  T_31_L_M_B_REGGAETON_P: "ရွင္သန္ျခင္းအားမာန္ (ေဘာင္းဘီ)",
  T_31_L_M_B_RUMUSICIAN: "ၾကိဳးေထာင္ေခ်ာက္ (ေဘာင္းဘီ)",
  T_31_L_M_B_THAGENT: "ကင္းေထာက္ (ေဘာင္းဘီ)",
  T_31_L_M_H_GREENCAP: "Winner Cap",
  T_31_L_M_H_PKCOSTUME: "စိမ္းလဲ့လဲ့ညိဳ႕ (ဦးေဆာင္း)",
  T_31_L_M_H_REGGAETON_B: "ရက္ကီစည္းခ်က္ (ဦးေဆာင္း)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "ခ်ည္ဆိုးေဆးဦးထုပ္",
  T_31_L_M_H_REGGAETON_P: "ရွင္သန္ျခင္းအားမာန္ (ဦးေခါင္း)",
  T_31_L_M_H_RUMUSICIAN: "ၾကိဳးေထာင္ေခ်ာက္ (ဦးေဆာင္း)",
  T_31_L_M_H_THAGENT: "ကင္းေထာက္ (ဦးေဆာင္း)",
  T_31_L_M_S_PKCOSTUME: "စိမ္းလဲ့လဲ့ညိဳ႕ (ဖိနပ္)",
  T_31_L_M_S_REGGAETON_B: "ရက္ကီစည္းခ်က္ (ဖိနပ္)",
  T_31_L_M_S_REGGAETON_P: "ရွင္သန္ျခင္းအားမာန္ (ဖိနပ္)",
  T_31_L_M_S_RUMUSICIAN: "ၾကိဳးေထာင္ေခ်ာက္ (ဖိနပ္)",
  T_31_L_M_S_THAGENT: "ကင္းေထာက္ (ဖိနပ္)",
  T_31_L_M_T_PKCOSTUME: "စိမ္းလဲ့လဲ့ညိဳ႕ (အကၤ်ီ)",
  T_31_L_M_T_REGGAETON_B: "ရက္ကီစည္းခ်က္ (အကၤ်ီ)",
  T_31_L_M_T_REGGAETON_P: "ရွင္သန္ျခင္းအားမာန္ (အကၤ်ီ)",
  T_31_L_M_T_REGGAETON_TATOO: "Familia Ink",
  T_31_L_M_T_RUMUSICIAN: "ၾကိဳးေထာင္ေခ်ာက္ (အကၤ်ီ)",
  T_31_L_M_T_THAGENT: "ကင္းေထာက္ (အကၤ်ီ)",
  T_31_L_S_BDCRICKET: "ခရစ္ကက္ (ဖိနပ္)",
  T_31_L_T_BDCRICKET: "ခရစ္ကက္ (အကၤ်ီ)",
  T_31_L_T_BRBANK: "Maroon Bomber",
  T_31_L_T_MEJERSEY_10: "နံပါတ္ 10 ရူဘီဂ်ာစီ (အကၤ်ီ)",
  T_31_L_T_MEJERSEY_11: "နံပါတ္ 11 အနီဂ်ာစီ (အကၤ်ီ)",
  T_31_L_T_MEJERSEY_13: "နံပါတ္ 13 အျဖဴဂ်ာစီ (အကၤ်ီ)",
  T_31_L_T_MEJERSEY_18G: "နံပါတ္ 18 အစိမ္းဂ်ာစီ (အကၤ်ီ)",
  T_31_L_T_MEJERSEY_18R: "နံပါတ္ 18 မရြန္ဂ်ာစီ (အကၤ်ီ)",
  T_31_L_T_MEJERSEY_7: "နံပါတ္ 7 ဘရာဇီးဂ်ာစီ (ေဘာင္းဘီ)",
  T_31_L_T_PKMOBILE: "အင္ဖင္နစ္တီရွပ္",
  T_31_L_T_REGGAETON_HOOD: "ဂိုဏ္းအျပံဳးေခါင္းစြပ္",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "နံပါတ္ 1",
  T_31_RW_COMBINEMACHINE_2: "Akimbo အသက္သြင္းခလုတ္ (အဆင့္ျမင့္)",
  T_31_RW_VIBRATION_EXPLOSION: "ေပါက္ကြဲခ်က္",
  T_31_RW_VIBRATION_MELEEWEAPONS: "မီလီလက္နက္မ်ား",
  T_31_RW_VIBRATION_OTHERWEAPONS: "အျခားေသနတ္မ်ား",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Duo",
  T_31_T_WS_3PLAYERTEAM: "Trio",
  T_31_T_WS_4PLAYERTEAM: "Squad",
  T_31_T_WS_5PLAYERTEAM: "V 5",
  T_31_T_WS_6PLAYERTEAM: "V 6",
  T_31_T_WS_BUFFTIME_TITLE: "ျပန္စခ်ိန္",
  T_31_T_WS_BUFFTYPE_AMMO: "က်ည္",
  T_31_T_WS_BUFFTYPE_ARMOR: "က်ည္ကာ",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "က်ပန္း",
  T_31_T_WS_BUFFTYPE_TITLE: "ဘဖ္အမ်ိဳးအစား",
  T_31_T_WS_DESC48: "စကၠန႔္အတြင္း, အျခားေနရာကိုေခၚသြားပါ",
  T_31_T_WS_DESC49: "စႏၵယားအသံဖန္တီးပါ",
  T_31_T_WS_DESC51: "ဒရမ္သံဖန္တီးပါ",
  T_31_T_WS_DESC53: "ဂီတဖန္တီးပါ",
  T_31_T_WS_DESC59: "ဘက္ခ္ပံုမွန္ထုတ္သည့္ကိရိယာ. အလားတူျမွင့္တင္မွဳရရွိရန္ေရြးယူပါ",
  T_31_T_WS_DRUMTYPE_CLAPS: "Clap",
  T_31_T_WS_DRUMTYPE_HIHATS: "Hi-hat",
  T_31_T_WS_DRUMTYPE_KICK: "Kick Drum",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Opening Hi-hat",
  T_31_T_WS_DRUMTYPE_RIDES: "Ride Cymbal",
  T_31_T_WS_DRUMTYPE_SNARES: "Snare Drum",
  T_31_T_WS_EARLYSHRINK: "အျမန္က်ံဳ႕ျခင္း",
  T_31_T_WS_ITEM48: "ေပၚတယ္",
  T_31_T_WS_ITEM49: "Piano Key",
  T_31_T_WS_ITEM51: "Drum Key",
  T_31_T_WS_ITEM53: "Combo Key A",
  T_31_T_WS_ITEM55: "Combo Key B",
  T_31_T_WS_ITEM57: "Combo Key C",
  T_31_T_WS_ITEM59: "ဘက္ခ္ထုတ္လုပ္သူ",
  T_31_T_WS_LATESHRINK: "အေႏွးက်ံဳ႕ျခင္း",
  T_31_T_WS_ME_DAMAGE: "ပ်က္စီးမွဳ",
  T_31_T_WS_ME_DAMAGED: "ခံရတဲ့ပ်က္စီးမွဳ",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "EP စတင္သည္",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "ပထမေဘးကင္းဇုန္အခ်င္းဝက္",
  T_31_T_WS_ME_EPQUICKRESTORE: "EP အျမန္ေျပာင္းလဲျခင္း",
  T_31_T_WS_ME_FLOW: "မုဒ္",
  T_31_T_WS_ME_GENERALSETTING: "အေထြေထြ",
  T_31_T_WS_ME_INRANDOMSPAWN: "က်ပန္းေပါက္ဖြားမွတ္",
  T_31_T_WS_ME_KILLSCORE: "သတ္ႏွဳန္းေဘာနပ္စ္",
  T_31_T_WS_ME_MAXEP: "အမ်ားဆံုး EP",
  T_31_T_WS_ME_MAXHP: "အမ်ားဆံုး HP",
  T_31_T_WS_ME_NEARTEAM: "အသင္းေဖာ္အနီး",
  T_31_T_WS_ME_REBIRTH: "ျပန္ႏိုးထရန္ၾကာခ်ိန္",
  T_31_T_WS_ME_REBIRTHLOCATION: "ျပန္ႏိုးထေနရာ",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "ဇုန္က်ဥ္းစတင္ခ်ိန္",
  T_31_T_WS_ME_WINSCORE: "အႏိုင္ရအမွတ္မ်ား",
  T_31_T_WS_MINIZONE: "Mini Zone",
  T_31_T_WS_MUSICTYPE_TITLE: "ဂီတအမ်ိဳးစား",
  T_31_T_WS_UNLIMITEDAMMO: "အကန္႔သတ္မဲ့က်ည္",
  T_31_WT_WS_DESC1: "ေလးေထာင့္သစ္သားေသတၱာ တစ္ခုနဲ႔တစ္ခုအေပၚကို stack ႏိုင္ပါသည္",
  T_31_WT_WS_DESC10: "ေသနတ္တက္ရန္ ေလွကားပါေသာ သစ္သားတဲ",
  T_31_WT_WS_DESC11: "ျပတင္းေပါက္အမ်ားႀကီးပါသည္ စႏိုက္ပါသမားမ်ားအတြက္ သင့္ေတာ္သည္",
  T_31_WT_WS_DESC12: "သတၱဳျဖင့္ျပဳလုပ္ထားၿပီး တံခါးမ်ားႏွင့္ ျပတင္းေပါက္မ်ားပါရွိသည္",
  T_31_WT_WS_DESC13: "တံခါးႏွင့္ျပတင္းေပါက္မ်ားပါဝင္သည္",
  T_31_WT_WS_DESC14: "ၿခံစည္း႐ိုးႏွင့္အိမ္",
  T_31_WT_WS_DESC15: "အမိုးပိတ္အိမ္",
  T_31_WT_WS_DESC16: "အလွဆင္ျခင္း - ႏွလုံးပုံသ႑ာန္ သဲ႐ုပ္တု",
  T_31_WT_WS_DESC17: "အလွဆင္ျခင္း - ၾကည္လင္ေသာ စမ္းေရတြင္း",
  T_31_WT_WS_DESC18: "အလွဆင္ - ပန္းေရာင္ပန္းပြင့္ႏွင့္သစ္ပင္",
  T_31_WT_WS_DESC19: "အလွဆင္ - အ႐ြယ္မေရာက္ေသးေသာငွက္ေပ်ာပင္မ်ား",
  T_31_WT_WS_DESC2: "တစ္ခုႏွင့္တစ္ခု အေပၚထပ္တြင္ ခ်ိတ္ထားႏိုင္ေသာ သစ္သားေသတၱာမ်ား",
  T_31_WT_WS_DESC20: "အျဖဴေရာင္ေရခ်ိဳးခန္းပရိေဘာဂ အိမ္တြင္းတြင္ထားႏိုင္သည္",
  T_31_WT_WS_DESC21: "နယ္ေျမခြဲရန္ အသုံးျပဳႏိုင္ေသာ ၿခံစည္း႐ိုးငယ္",
  T_31_WT_WS_DESC22: "ကြန္တိန္နာ သစ္သားဘက္ကို ဖ်က္ဆီးႏိုင္သည္",
  T_31_WT_WS_DESC23: "အင္အားသံုးျဖိဳခြင္းႏိုင္ေသာျခံစည္းရိုးငယ္",
  T_31_WT_WS_DESC24: "အသင္း A ေပါက္ဖြားဧရိယာ (4v4 အုပ္စု, Deathmatch အသင္း ႏွင့္ကစားကြင္းမုဒ္မွာသာရမည္)",
  T_31_WT_WS_DESC25: "အသင္း B ေပါက္ဖြားဧရိယာ (4v4 အုပ္စု, Deathmatch အသင္း ႏွင့္ကစားကြင္းမုဒ္မွာသာရမည္)",
  T_31_WT_WS_DESC26: "တိုေတာင္းေသာအကြာအေဝးသို႔ ကစားသမားကို ေရွ႕သို႔ပို႔ပါ",
  T_31_WT_WS_DESC27: "အတိုအကြာအေဝးတြင္လမ္းေၾကာင္းအတိုင္းကစားသူကိုပို႔ေပးသည္",
  T_31_WT_WS_DESC28: "အလယ္အကြာအေဝးအတြက္ျပထားသည့္လမ္းေၾကာင္းအတိုင္းကစားသူကိုပံ့ပိုးသည္",
  T_31_WT_WS_DESC29: "တာေဝးအတြက္ျပထားသည့္ လမ္းေၾကာင္းအတိုင္း ကစားသမားမ်ားကို ပို႔ေပးသည္",
  T_31_WT_WS_DESC3: "သင္၏စစ္ေျမျပင္ကိုေရာင္စံုပန္းျဖင့္အလွဆင္ပါ",
  T_31_WT_WS_DESC30: "ေမာင္းနင္ႏိုင္ေသာဘန္ပါကားမ်ား",
  T_31_WT_WS_DESC31: "ကုန္းေရႏွစ္သြယ္ယာဥ္ ေမာင္းႏိုင္သည္",
  T_31_WT_WS_DESC32: "ေမာင္းႏွင္ႏိုင္ေသာဂ်စ္္ကား",
  T_31_WT_WS_DESC33: "အမႈိက္ပုံးမ်ားသည္ ေသးငယ္ေသာ္လည္း အဖုံးအျဖစ္ အသုံးျပဳႏိုင္သည္",
  T_31_WT_WS_DESC34: "ေလဟာျပင္၊ သတၱဳၿပိဳင္ကား လမ္းေၾကာင္းမွာ အမိုးအကာ",
  T_31_WT_WS_DESC35: "တံခါးႏွစ္ေပါက္ရွိေသာ္လည္း ျပတင္းေပါက္မရွိေသာ အလတ္စားတဲတစ္လုံး",
  T_31_WT_WS_DESC36: "အုတ္ခဲႏွင့္ေဆာက္ေသာဂိုေဒါင္",
  T_31_WT_WS_DESC37: "ေနရာပိုင္းျခားရာသံုးႏိုင္သည့္ၾကီးမားတဲ့အုပ္ခဲနံရံ",
  T_31_WT_WS_DESC38: "အသံုးဝင္ေသာမွတ္တိုင္",
  T_31_WT_WS_DESC39: "အဓိကတိုက္ပြဲတြင္းအျဖစ္ အသုံးျပဳႏိုင္ေသာ ႀကီးမားေသာသတၱဳပလပ္ေဖာင္းတစ္ခု",
  T_31_WT_WS_DESC4: "အ႐ြယ္အစားႀကီးေသာ ကာဗာအျဖစ္လည္း အသုံးျပဳႏိုင္ပါသည္",
  T_31_WT_WS_DESC40: "အပန္းေျဖစရာကားတစ္စီးႏွင့္တူၿပီး တံခါးမ်ားႏွင့္ ျပတင္းေပါက္မ်ားစြာရွိသည္",
  T_31_WT_WS_DESC41: "အပန္းေျဖစရာကားတစ္စီးႏွင့္တူၿပီး တံခါးတစ္ခုႏွင့္ ျပတင္းေပါက္မ်ားစြာပါရွိသည္",
  T_31_WT_WS_DESC42: "ဝင္ေပါက္ႏွင့္တစ္ဖက္သတ္နံရံ",
  T_31_WT_WS_DESC43: "ပံုမွန္တစ္ဖက္သတ္နံရံ",
  T_31_WT_WS_DESC44: "နံရံေထာင့္",
  T_31_WT_WS_DESC45: "မညီညာေသာနံရံေထာင့္",
  T_31_WT_WS_DESC46: "မညီညာေသာနံရံေထာင့္",
  T_31_WT_WS_DESC47: "ျပတင္းေပါက္ႏွင့္နံရံေထာင့္",
  T_31_WT_WS_DESC5: "လူထက္အနည္းငယ္တိုေသာ္လည္း ကာဗာေပးစြမ္းႏိုင္ေသာ ေဘးမဲ့ကား",
  T_31_WT_WS_DESC6: "လူသားထက္ အရပ္ျမင့္ၿပီး ကာဗာအျဖစ္ လုပ္ေဆာင္ႏိုင္သည္",
  T_31_WT_WS_DESC7: "အစြန္းႏွစ္ဖက္စလုံးတြင္ ဖြင့္ထားၿပီး လမ္းေၾကာင္းမ်ားဖြဲ႕စည္းရန္ သို႔မဟုတ္ ဧရိယာမ်ားခြဲရန္ စီစဥ္ႏိုင္သည္",
  T_31_WT_WS_DESC8: "အဝင္အထြက္လမ္းတစ္ေၾကာင္း ေနရာခြဲရန္ သင့္ေတာ္သည္",
  T_31_WT_WS_DESC9: "ဝင္ေပါက္မရွိ. ေနရာခြဲရန္ သင့္ေတာ္သည္.",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "ယာဥ္",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "{0}s အျမန္ႏႈန္းျဖင့္ေရွ႕သို႔ေျပးပါ. အေျပးျဖည့္တင္းခ်ိန္: {1}s. ဤစြမ္းရည္သည္ {2} ၾကိမ္အထိစုေဆာင္းသံုးႏိုင္သည္, တစ္ခါသံုးျပီးတိုင္း 5s ကူးေဒါင္းရွိသည္.",
  T_32_C_SKILL_NAME_YAKUZA: "Rebel Rush",
  T_32_HQ_AUG_VNSTREET_N: "AUG- Roaring Gunfighter",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Dawnlit Drago အိတ္",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B- Vampire Malevolence",
  T_32_HQ_GLOO_DUNHUANG_N: "အိုက္စ္ေဝါ- ပလက္တီနမ္ခဲ",
  T_32_HQ_GLOO_HURRICANE_2_N: "အိုက္စ္ေဝါ- Aurora Core",
  T_32_HQ_GRENADE_HURRICANE_N: "ဗံုး- ဘရက္စီမိုက္",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10- Frozen Platinum",
  T_32_HQ_PETSKIN_DUCK_RED_N: "တိရိစာၦန္စကင္: Red Beanie",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "တိရိစာၦန္စကင္: Cyber Flash",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "တိရိစာၦန္စကင္: Gamer Flash",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "တိရိစာၦန္စကင္: Festive Flash",
  T_32_HQ_TORTOISE_N: "ဖလပ္ရွ္",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Sports Car- Buried Purpledust",
  T_32_L_F_A_PHARAOH: "Goldcoated Cleo (မ်က္ႏွာဖံုး)",
  T_32_L_F_B_PHARAOH: "Goldcoated Cleo (ေဘာင္းဘီ)",
  T_32_L_F_H_PHARAOH: "Goldcoated Cleo (ဦးေဆာင္း)",
  T_32_L_F_HA_PHARAOH: "Goldcoated Cleo (မ်က္ႏွာပန္းခ်ီ)",
  T_32_L_F_S_PHARAOH: "Goldcoated Cleo (ဖိနပ္)",
  T_32_L_F_T_PHARAOH: "Goldcoated Cleo (အကၤ်ီ)",
  T_32_L_M_A_JUNKFOOD: "ဘာဂါလုလင္ (မ်က္ႏွာဖံုး)",
  T_32_L_M_A_PHARAOH: "ေရႊခ်ယ္ဝန္းမံမီ (မ်က္ႏွာဖံုး)",
  T_32_L_M_B_JUNKFOOD: "ဘာဂါလုလင္ (ေဘာင္းဘီ)",
  T_32_L_M_B_PHARAOH: "ေရႊခ်ယ္ဝန္းမံမီ (ေဘာင္းဘီ)",
  T_32_L_M_H_JUNKFOOD: "ဘာဂါလုလင္ (ဦးထုပ္)",
  T_32_L_M_H_PHARAOH: "ေရႊခ်ယ္ဝန္းမံမီ (ဦးေဆာင္း)",
  T_32_L_M_S_JUNKFOOD: "ဘာဂါလုလင္ (ဖိနပ္)",
  T_32_L_M_S_PHARAOH: "ေရႊခ်ယ္ဝန္းမံမီ (ဖိနပ္)",
  T_32_L_M_T_JUNKFOOD: "ဘာဂါလုလင္ (အကၤ်ီ)",
  T_32_L_M_T_PHARAOH: "ေရႊခ်ယ္ဝန္းမံမီ (အကၤ်ီ)",
  T_32_L_T_WHITESWEATER: "အျဖဴဆြယ္တာ",
  T_32_LC_NEWVAULT_EMOTE: "အမူအရာ",
  T_32_LO_WS_IMMORTAL: "မေသေသာဇုန္",
  T_32_LO_WS_ITEM60: "ပိုက္",
  T_32_LO_WS_ITEM60_DESC: "လမ္းေလွ်ာက္ႏိုင္ေသာပိုက္လိုင္း",
  T_32_LO_WS_ITEM61: "T ပံုပိုက္",
  T_32_LO_WS_ITEM61_DESC: "လမ္းေလွ်ာက္ရန္လံုေလာက္ေသာပိုက္မ်ား",
  T_32_LO_WS_ITEM62: "4 ေထာင့္ပိုက္",
  T_32_LO_WS_ITEM62_DESC: "လမ္းေလွ်ာက္ႏိုင္ေသာလမ္းဆုံဥမင္တစ္ခု",
  T_32_LO_WS_ITEM63: "ေထာင့္ပိုက္",
  T_32_LO_WS_ITEM63_DESC: "လမ္းေလွ်ာက္ရန္လိုအပ္ေသာပိုက္မ်ား",
  T_32_LO_WS_ITEM64: "အစားအေသာက္ကား",
  T_32_LO_WS_ITEM64_DESC: "ခဏရပ္လိုက္ စားလိုက္ေပါ့",
  T_32_LO_WS_ITEM65: "ဧရာမမွိဳ",
  T_32_LO_WS_ITEM65_DESC: "လူကိုသယ္ႏိုင္သည့္ၾကီးမားသည့္မွိဳပြင့္",
  T_32_LO_WS_ITEM66: "ေလယာဥ္ရံု",
  T_32_LO_WS_ITEM66_DESC: "လူေနရပ္ကြက္တြင္အျဖစ္မ်ားသည္",
  T_32_LO_WS_ITEM67: "သစ္သားပ်ဥ္ျပား",
  T_32_LO_WS_ITEM67_DESC: "သစ္သားတံတားေဆာက္ရာတြင္သံုးသည္",
  T_32_LO_WS_ITEM68: "ဇလီ",
  T_32_LO_WS_ITEM68_DESC: "ဇိမ္ခံမႈႏွင့္သက္ေတာင့္သက္သာရွိမႈ",
  T_32_LO_WS_ITEM69: "အခ်ိန္",
  T_32_LO_WS_ITEM69_DESC: "ေဆာက္လုပ္ေရးဆိုဒ္ရွိ ဘံုအရာ",
  T_32_LO_WS_ITEM70: "ရွားေစာင္း",
  T_32_LO_WS_ITEM70_DESC: "ဆူးမရွိေသာရွားေစာင္းၾကီး",
  T_32_LO_WS_ITEM71: "သစ္ပင္ေျခာက္",
  T_32_LO_WS_ITEM71_DESC: "ဆယ္စုႏွစ္တစ္ခုေက်ာ္ၾကာတည္ရွိခဲ့ေသာ သစ္ပင္တစ္ပင္",
  T_32_LO_WS_ITEM72: "ေက်ာက္မီးအိမ္",
  T_32_LO_WS_ITEM72_DESC: "ဥယ်ာဥ္ကိုအလွတိုးေစမည့္အလွဆင္ပစၥည္းမ်ား",
  T_32_LO_WS_ITEM73: "လမ္းမီးအိမ္",
  T_32_LO_WS_ITEM73_DESC: "ပံုမွန္လမ္းေပၚတြင္ေတြ႕ႏိုင္သည္",
  T_32_LO_WS_ITEM74: "ဆိုလာျပား",
  T_32_LO_WS_ITEM74_DESC: "ေနမွစြမ္းအင္စုပ္ယူသည္",
  T_32_LO_WS_ITEM75: "အဲကြန္း",
  T_32_LO_WS_ITEM75_DESC: "ေနပူထဲေအးေအာင္ေန",
  T_32_LO_WS_ITEM76: "ပန္ကာ",
  T_32_LO_WS_ITEM77: "ဒယ္အိုး",
  T_32_LO_WS_ITEM78: "ေသတၱာ",
  T_32_LO_WS_ITEM79: "လက္စြပ္",
  T_32_LO_WS_ITEM80: "တူ",
  T_32_LO_WS_ITEM81: "ဘုတ္",
  T_32_LO_WS_ITEM82: "ပစ္မွတ္",
  T_32_LO_WS_ITEM83: "အလိုေတာ္နံရံ",
  T_32_LO_WS_ITEM84AMMO: "က်ည္မ်ားသိုေလွာင္ရာေနရာ",
  T_32_LO_WS_ITEM84AMMO_DESC: "ထားျပီးသည့္အခါ, ေ႐ြးထားေသာ က်ည္မ်ားသည္ထိုေနရာတြင္ေပၚမည္",
  T_32_LO_WS_ITEM84AR: "က်ည္ကာထားရာေနရာ",
  T_32_LO_WS_ITEM84AR_DESC: "ေနရာေရြးျပီးေသာအခါ, ေရြးျပီးက်ည္ကာသည္ထိုေနရာတြင္ေပၚသည္",
  T_32_LO_WS_ITEM84ARLV1: "က်ည္ကာ Lv.1",
  T_32_LO_WS_ITEM84ARLV2: "က်ည္ကာ Lv.2",
  T_32_LO_WS_ITEM84ARLV3: "က်ည္ကာ Lv.3",
  T_32_LO_WS_ITEM84CO: "ပစၥည္းသိုေလွာင္မႈအမွတ္",
  T_32_LO_WS_ITEM84CO_DESC: "ေနရာခ်ထားေသာအမွတ္မ်ားကိုသိမ္းဆည္းရန္ ေ႐ြးခ်ယ္ထားေသာအရာမ်ားရွိပါမည္",
  T_32_LO_WS_ITEM84JA: "ဗံုးပစၥည္းေကာက္မွတ္",
  T_32_LO_WS_ITEM84JA_DESC: "စုေဆာင္းရန္ ေ႐ြးခ်ယ္ထားေသာဗုံးတစ္လုံးရွိမည့္ ေနရာတြင္ထားရွိပါ",
  T_32_LO_WS_ITEM84TE: "ေသနတ္မွန္ေျပာင္းသိမ္းဆည္းရာ",
  T_32_LO_WS_ITEM84TE_DESC: "ေနရာခ်ျပီးေသာအခါ, ေရြးထားေသာမွန္ေျပာင္းသည္ဖိုေနရာမွာေပၚမည္",
  T_32_LO_WS_ITEM84W: "လက္နက္လုရာအမွတ္",
  T_32_LO_WS_ITEM84W_DESC: "ထားရွိရမည့္ေနရာတြင္ ေ႐ြးခ်ယ္ထားေသာလက္နက္မ်ားထားရွိမည္ျဖစ္သည္",
  T_32_LO_WS_ITEM85: "ယႏၲရား",
  T_32_LO_WS_ITEM85_DESC: "ေနရာထားျပီးေသာအခါ, အစပ်ိဳးဇုန္ထဲသို႔ဝင္ေသာကစားသမားမ်ားသည္ မေသႏိုင္ေသာ သို႔မဟုတ္ ပ်က္စီးျခင္း၏သတ္မွတ္ထားေသာအက်ိဳးသက္ေရာက္မႈကိုခံစားရလိမ့္မည္. (4v4, အလဲထိုးပြဲႏွင့္ကစားကြင္းမုဒ္မပါဝင္ပါ)",
  T_32_LO_WS_ITEM85CP: "စစ္ေဆးရန္အခ်က္",
  T_32_LO_WS_ITEM85CP_DESC: `(အထူးမုဒ္တြင္သာ) ျမန္ႏႈန္းမုဒ္တြင္မရွိမျဖစ္အရာတစ္ခု.
ကစားသမားမ်ားသည္ စစ္ေဆးေရးဂိတ္တစ္ခုစီကို ျဖတ္သန္းရမည္ျဖစ္သည္. ျပဳတ္က်ေသာအခါ ကစားသမားသည္ ၎တို႔စစ္ေဆးၿပီးသည့္ ေနာက္ဆုံးအခ်ိန္၌ ျပန္လည္ေမြးဖြားမည္ျဖစ္သည္.`,
  T_32_LO_WS_ITEM85TM: "ျပီးဆံုးမွတ္",
  T_32_LO_WS_ITEM85TM_DESC: "Parkour မုဒ္တြင္ဂိမ္းကစားျခင္းကိုတည္ေဆာက္ရန္အသုံးျပဳသည့္အရာ. ပန္းတိုင္ၿပီးေျမာက္ရန္အတြက္ကစားသမားမ်ားသည္အၿပီးသတ္စည္းအတြင္းသို႔ေရာက္ရွိရပါမည္. (4v4, အလဲထိုးပြဲႏွင့္ကစားကြင္းမုဒ္မပါဝင္ပါ)",
  T_32_LO_WS_ITEM86: "ေပါက္ဖြားအမွတ္",
  T_32_LO_WS_ITEM86_DESC: "ဤအမွတ္ကိုမတိက်တဲ့အသင္းသို႔ခြဲေဝမည္. ထားရွိျပီးေသာအခါ, က်ပန္းအသင္းေပါက္ဖြားမည္. (4v4, အလဲထိုးပြဲႏွင့္ကစားကြင္းမုဒ္မပါဝင္ပါ)",
  T_32_LO_WS_ITEM86L: "ၾကီးမားေသာေပါက္ပြားအမွတ္",
  T_32_LO_WS_ITEM86L_DESC: "Parkour မုဒ္အတြက္အၾကံဳျပဳထားသည့္ၾကီးမားေသာေပါက္ဖြားအမွတ္၊ ကစားသမားအားလံုးေပါက္ဖြားမည္. (4v4, အလဲထိုးပြဲႏွင့္ကစားကြင္းမုဒ္မပါဝင္ပါ)",
  T_32_LO_WS_ITEM87: "ဘေလာက္",
  T_32_LO_WS_ITEM87_DESC: "ဆိုဒ္စိတ္ၾကိဳက္လုပ္ႏိုင္သည္",
  T_32_LO_WS_ITEM88: "ကုန္းေစာင္း",
  T_32_LO_WS_ITEM88_DESC: "ဆုိဒ္စိတ္ၾကိဳက္ျပဳျပင္ႏိုင္သည္",
  T_32_LO_WS_ITEMLINE: "မသည္",
  T_32_LO_WS_ITEMMOVE: "ယႏၲရားဆက္တင္",
  T_32_LO_WS_ITEMROT: "အလွည့္",
  T_32_LO_WS_ITEMSCALE: "အရြယ္အစား",
  T_32_LO_WS_KILLZONE: "မရဏဇုန္",
  T_32_LO_WS_LOOT_AMMOTYPE: "က်ည္",
  T_32_LO_WS_LOOT_ARTYPE: "က်ည္ကာ",
  T_32_LO_WS_LOOT_COTYPE: "ပစၥည္း",
  T_32_LO_WS_LOOT_JATYPE: "ေပါက္ကြဲမွဳ",
  T_32_LO_WS_LOOT_RANDOM: "က်ပန္း",
  T_32_LO_WS_LOOT_TETYPE: "မွန္ေျပာင္း",
  T_32_LO_WS_LOOT_WEAPONTYPE: "လက္နက္",
  T_32_LO_WS_SCALEX: "အရွည္",
  T_32_LO_WS_SCALEY: "အျမင့္",
  T_32_LO_WS_SCALEZ: "အက်ယ္",
  T_32_LO_WS_TRIGGERH: "ဝွပ္မည္",
  T_32_LO_WS_TRIGGERHORP: "ယႏၲရားကို ျပ/ဝွပ္",
  T_32_LO_WS_TRIGGERP: "ျပမည္",
  T_32_LO_WS_TRIGGERTYPE: "အမ်ိဳးအစား",
  T_32_M_WS_MODE_ANNIHILATE: "ေခ်မွဳန္းသည္",
  T_32_M_WS_MODE_SCORE: "ေက်ာက္ဆူးမွတ္",
  T_32_M_WS_MODE_SPEED: "Parkour",
  T_32_M_WS_MULTIPLETEAMS: "အသင္းေပါင္းစံုတိုက္ပြဲ",
  T_32_M_WS_ROUNDS: "အၾကိမ္",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Switching Steps",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "အႏၲရာယ္ဇုန္",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "ပ်က္စီးမွဳ",
  T_32_T_WS_ME_BLUECIRCLESETTING: "အႏၲရာယ္ဇုန္",
  T_32_T_WS_ME_CUSTOM: "စိတ္ၾကိဳက္ဖန္တီး",
  T_32_T_WS_ME_ENDTYPE1: "ေခ်မွဳန္းသည္",
  T_32_T_WS_ME_ENDTYPE2: "ေက်ာက္ဆူးမွတ္",
  T_32_T_WS_ME_ENDTYPE3: "Parkour",
  T_32_T_WS_ME_ENDTYPEDESC1: "ေနာက္ဆံုးအသင္းအျဖစ္ရွင္သန္ပါ",
  T_32_T_WS_ME_ENDTYPEDESC2: "ပစ္မွတ္အမွတ္အရင္ရေသာအသင္းႏိုင္မည္",
  T_32_T_WS_ME_ENDTYPEDESC3: "အသင္းသားမ်ားအားလုံး အဆုံးအမွတ္သို႔ေရာက္ရွိသည့္အသင္းသည္အႏိုင္ရရွိမည္",
  T_32_T_WS_ME_MATCHTIME: "ျပိဳင္ပြဲအခ်ိန္",
  T_32_T_WS_ME_MECHANIC: "ယႏၲရား",
  T_32_T_WS_ME_NEARCHECKPOINT: "စစ္ေဆးေရးဂိတ္အနီး",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "ကစားသူအမ်ားဆံုး 12 ေယာက္သာရသည္",
  T_32_T_WS_ME_PREGAMETIME: "ျပင္ဆင္အခ်ိန္",
  T_32_T_WS_ME_RESPAWN: "ျပန္ေမြးဖြားမွတ္",
  T_32_T_WS_ME_RESPAWNSETTING: "ျပန္ေမြးဖြားမွတ္",
  T_32_T_WS_ME_ROUNDNUM: "အၾကိမ္အေရအတြက္",
  T_32_T_WS_ME_ROUNDOPEN: "အၾကိမ္ေပါင္းမ်ားစြာကစားပါ",
  T_32_T_WS_ME_ROUNDRESET: "အလွည့္ျပန္စပါ",
  T_32_T_WS_ME_ROUNDSETTING: "အလွည့္",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "ဇုန္က်ဥ္းၾကာခ်ိန္",
  T_32_T_WS_ME_SCORESETTING: "ရမွတ္",
  T_32_T_WS_ME_TEAMMATENUM: "တစ္သင္းအသင္းဝင္",
  T_32_T_WS_ME_TEAMNUM: "အသင္းအေရအတြက္",
  T_32_T_WS_ME_TEAMSETTING: "အသင္း",
  T_32_U_ATTACHMENT_8: "ေဘးအိတ္",
  "T_32_U_GOLD_FAMAS-I": "Famas-I",
  "T_32_U_GOLD_FAMAS-II": "Famas-II",
  "T_32_U_GOLD_FAMAS-III": "Famas-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "အဆင့္ျမင့္ခ်ိစ္",
  T_32_WT_WS_BARRIER: "ကြင္း",
  T_32_WT_WS_BDS: "အေဆာက္အဦး",
  T_32_WT_WS_MMINVALIDERROR: "ေျမပံုကုဒ္မွားယြင္း",
  T_32_WT_WS_TRGS: "စနစ္",
  T_32_YF_CHARGESHOT_N: "Charge Buster",
  T_32_YF_GOLD_GROZA_N: "GROZA-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "အပိုပ်က္စီးမွဳ",
  T_32_YS_WEAPON_TAG_3: "ပစ္ခတ္ႏွဳန္း",
  T_32_YS_WEAPON_TAG_36: "က်ည္ကာထိုးေဖာက္ျခင္း",
  T_32_YS_WEAPON_TAG_39: "Akimbo ေထာက္ခံသည္",
  T_32_YS_WEAPON_TAG_42: "အိုက္စ္ေဝါ",
  T_33_C_SKILL_DESC_GRAFFITIST: "ပစ္ႏိုင္ေသာအရာမ်ားကိုပိတ္ဆို႔သည့္ {0}m ဧရိယာကိုဖန္တီးပါ. ဧရိယာရွိ မဟာမိတ္မ်ားသည္ စကၠန႔္တိုင္းက်ည္ကာခံႏိုင္ရည္အား {1}% ျပန္လည္ရရွိမည္ျဖစ္ၿပီးက်ည္ထိခိုက္မႈ {2}% ေလ်ာ့က်သြားမည္ျဖစ္သည္. {3}s သံုးႏိုင္မည္. CD: {4}s. အက်ိဳးသက္ေရာက္မႈမ်ားမပါဝင္ပါ.",
  T_33_C_SKILL_DESC_HITMAN: "စႏိုက္ဘာႏွင့္လက္ေျဖာင့္ရိုင္ဖယ္သံုးေသာအခါ, ပစ္ခတ္သံတိတ္ဆိတ္ျပီး ေသြးထြက္ႏွဳန္း {0}% ပိုျမန္ျခင္းျဖင့္ရန္သူလဲက်မည္.",
  T_33_C_SKILL_DESC_KENTA: "ေရွ႕ပိုင္းမွလာေသာလက္နက္ပ်က္စီးမႈကို {1}% ေလွ်ာ့ခ်ေပးသည့္ {0}m အက်ယ္ရွိေသာ ေရွ႕မ်က္ႏွာစာဒိုင္းကိုဖန္တီးပါ.{2}s ၾကာရွည္ၿပီး အသုံးျပဳသူပစ္ခတ္သည့္အခါ ျပန္ဆန္းသစ္မည္. Cooldown: {3}s.",
  T_33_C_SKILL_DESC_MADEMANA: "{0} မီတာသံလိုက္စက္ကြင္းကိုထုတ္လႊတ္ၿပီး ရန္သူ၏ကြၽမ္းက်င္မႈကိုပိတ္ဆို႔ကာ, {3} ခါပ်က္စီးမွဳႏွင့္, ကူးေဒါင္းလုပ္ေဆာင္မွဳေႏွာက္ယွက္ပါ. {1}s ၾကာျပီး. CD: {2}s.",
  T_33_C_SKILL_NAME_BODYGUARD: "လက္နက္ကြ်မ္းက်င္သူ",
  T_33_C_SKILL_NAME_KENTA: "ဓါးသြားထက္ကအမုန္း",
  T_33_C_SKILL_NAME_MADEMANA: "တိုက္ပြဲ၏ရက္စက္ျခင္း",
  T_33_DY_AXOLOTL_N: "Zasil",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "တိရစာၦန္စကင္: Fruity Zasil",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "တိရစာၦန္စကင္: FFWS ပဲနီ",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "တိရစာၦန္စကင္: Blooming Falco",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Deadly Baguette ရိုက္တံ",
  T_33_HQ_EMOTE_SONGKRAN_N: "Come and Dance",
  T_33_HQ_G18_CYBERTHIEF_N: "G18- Hypercore Blues",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "ဗံုး- Hypercore Blues",
  T_33_HQ_M14_SPIDERLILY_N: "M14- Burning Lily",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7- Shadow Rogue",
  T_33_HQ_MP40_FFWS03_N: "MP40- Haven Warrior",
  T_33_HQ_SCAR_FFWS03_N: "SCAR- Haven Warrior",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Emerald Power ဓါးရွည္",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "ေဟဗန္ရဲမက္ဓါးေျမွာင္",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector- Hypercore Blues",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "ဂ်စ္ကား- Emerald Shimmer",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "ကားၾကီး- Bonebruiser Scorch",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "ကားၾကီး - Haven Guardian",
  T_33_LO_WS_BHPARA_A: "Active",
  T_33_LO_WS_BHPARA_ATKMODE: "တိုက္ခိုက္အမ်ိဳးစား",
  T_33_LO_WS_BHPARA_GROUP: "အသင္း",
  T_33_LO_WS_BHPARA_NA: "မတိုက္ခိုက္ရ",
  T_33_LO_WS_BHPARA_P: "ကိုယ္ပိုင္စြမ္းရည္",
  T_33_LO_WS_DICE_DESC: "သင္၏ခုန္ျခင္းျမွင့္တင္ေပးမည့္အန္စာတံုး",
  T_33_LO_WS_DICEVXZ: "အလ်ားလိုက္အလ်င္",
  T_33_LO_WS_DICEVY: "ေဒါင္လိုက္အလ်င္",
  T_33_LO_WS_DTOWER: "ေမွ်ာ္စင္",
  T_33_LO_WS_DTOWER_DESC: "ခံစစ္ဖြဲ႕စည္းပုံမွသတ္မွတ္ထားေသာအကြာအေဝးအတြင္းရွိရန္သူမ်ားကိုအလိုအေလ်ာက္တိုက္ခိုက္သည္. ၎၏ HP သည္သုညသို႔ေရာက္ရွိပါကပ်က္စီးသြားပါသည္. (4v4, အလဲထိုးပြဲႏွင့္ကစားကြင္းမုဒ္မပါဝင္ပါ)",
  T_33_LO_WS_FORT: "ခံတပ္",
  T_33_LO_WS_FORT_DESC: "အေရးၾကီးဖြဲ႕စည္းပံုမွတိက်အကြာအေဝးအတြင္းရွိရန္သူမ်ားကိုအလိုေလ်ာက္တိုက္မည္. HP သုညေရာက္ပါကပိတ္မည္. (4v4, အလဲထိုးပြဲႏွင့္ကစားကြင္းမုဒ္တြင္မရွိပါ)",
  T_33_LO_WS_ITEM89: "သန႔္စင္ကန္",
  T_33_LO_WS_ITEM89_DESC: "ေရတိုင္ကီ",
  T_33_LO_WS_ITEM90: "ေခြးအိမ္",
  T_33_LO_WS_ITEM90_DESC: "ေခြးေလးေတြတြက္အိမ္",
  T_33_LO_WS_ITEM91: "ဘတ္စ္ကားမွတ္တိုင္",
  T_33_LO_WS_ITEM91_DESC: "ပံုေသဘတ္စ္ကားမွတ္တိုင္",
  T_33_LO_WS_ITEM92: "ဂရပ္ဖီတီနံရံ",
  T_33_LO_WS_ITEM92_DESC: "မွဳတ္ေဆးျဖင့္အလွဆင္ထားေသာနံရံ",
  T_33_LO_WS_ITEM93: "တည္ျငိမ္သည္",
  T_33_LO_WS_ITEM93_DESC: "အေျခခံျမက္ေျခာက္တည္ေဆာက္ပံု",
  T_33_LO_WS_ITEM94: "ခံုတန္းရွည္",
  T_33_LO_WS_ITEM94_DESC: "ပန္းျခံခံုတန္းလ်ား",
  T_33_LO_WS_ITEM95: "ေက်ာက္တံုးတံတား",
  T_33_LO_WS_ITEM95_DESC: "ေက်ာက္တံုးႏွင့္ေဆာက္ထားေသာတံတား",
  T_33_LO_WS_ITEM96: "မ်က္မွန္",
  T_33_LO_WS_ITEM96_DESC: "ေနေလာင္ျခင္းကိုထီးေအာက္က ကာကြယ္ပါ",
  T_33_LO_WS_ITEM97: "အျပီးသတ္လိုင္း",
  T_33_LO_WS_ITEM97_DESC: "အျပီးသတ္မ်ဥ္းသတ္မွတ္ပါ",
  T_33_LO_WS_ITEM98: "ေၾကာ္ျငာဆိုင္းဘုတ္",
  T_33_LO_WS_ITEM98_DESC: "ေၾကာ္ျငာမ်ားအတြက္ပံုမွန္ဘန္နာ",
  T_33_LO_WS_PARA_DM: "ပ်က္စီးမွဳ",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "ရန္သူစကင္န္အကြာအေဝး",
  T_33_LO_WS_PARA_SP: "အလ်င္",
  T_33_LO_WS_ZBPARA_AMOUNT: "တစ္လွိဳင္းရွိ ဖုတ္ေကာင္မ်ား",
  T_33_LO_WS_ZBPARA_INTERVAL: "Wave interval",
  T_33_LO_WS_ZBPARA_ROUND: "# လွိဳင္းမ်ား",
  T_33_LO_WS_ZBSPAWNER: "ဖုတ္ေကာင္ေပါက္ဖြား",
  T_33_LO_WS_ZBSPAWNER_DESC: "ဖြဲ႕စည္းပုံမ်ားႏွင့္အညီဖုတ္ေကာင္မ်ားကိုအလိုအေလ်ာက္ေမြးျမဴသည္. ၎တို႔၏အျပဳအမူကို drop-down menu ကိုအသုံးျပဳ၍စီစဥ္ျပဳလုပ္ႏိုင္ပါသည္. (4v4, အလဲထိုးပြဲႏွင့္ကစားကြင္းမုဒ္မပါဝင္ပါ)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "အဆင့္တက္",
  T_33_RW_SKILL_DESC_GANGGIRL: "ပစ္ခတ္မႈႏႈန္း {0}% တိုးေစသည္. အသုံးျပဳသူသည္ရန္သူကိုထိေသာအခါ၊ ပစ္ခတ္ႏႈန္း၏ အမ်ားဆုံး {1}% သည္ ေ႐ြ႕လ်ားမႈအျမန္ႏႈန္းသို႔ ေျပာင္းလဲသြားၿပီး တိုက္ပြဲတြင္ အသုံးျပဳသူမွ လြတ္ေျမာက္ေသာအခါ ကြၽမ္းက်င္မႈကို ျပန္စတင္မည္.",
  T_33_RW_SKILL_NAME_GANGGIRL: "Fight or Flight",
  T_33_WT_WS_BASICSET1: "အေထြေထြ",
  T_33_WT_WS_QCEPRTIP: "EP ကို HP သို႔ျမန္ေအာင္ေျပာင္းပါ",
  T_33_WT_WS_SKILLSET_TAG: "အကန္႔သတ္မဲ့စြမ္းရည္",
  T_33_WT_WS_SKILLSET1: "စြမ္းရည္ခ်ိန္ညွိျခင္း",
  T_33_WT_WS_SKILLSET10: "Time Turner (Chrono)",
  T_33_WT_WS_SKILLSET11: "Riptide Rhythm (Skyler)",
  T_33_WT_WS_SKILLSET12: "Xtreme Encounter (Xayne)",
  T_33_WT_WS_SKILLSET13: "ႏွလံုးခုန္သံကုစားျခင္း (Dimitri)",
  T_33_WT_WS_SKILLSET2: "တုဏိွေဘာစြမ္းရည္",
  T_33_WT_WS_SKILLSET2_TIP: "တဏိွေဘာစြမ္းရည္ ဖြင့္/ပိတ္",
  T_33_WT_WS_SKILLSET3: "တက္ၾကြစြမ္းရည္ (ေအာက္ပါၾကန္႔ၾကာခ်ိန္ကိုခ်ိန္ညႇိရန္ ဖြင့္ပါ)",
  T_33_WT_WS_SKILLSET3_TIP: "တက္ၾကြစြမ္းရည္ ဖြင့္/ပိတ္. ဖြင့္ထားပါက၊ အမ်ိဳးမ်ိဳးေသာ တက္ႂကြေသာစြမ္းရည္မ်ား၏ cooldown အခ်ိန္ကို ေအာက္တြင္ စီစဥ္သတ္မွတ္ႏိုင္ပါသည္.",
  T_33_WT_WS_SKILLSET4: "ေျပာက္က်ား (Wukong)",
  T_33_WT_WS_SKILLSET5: "တိုက္ပြဲ၏ရက္စက္ျခင္း (A124)",
  T_33_WT_WS_SKILLSET6: "စည္းခ်က္စလိုက္ေတာ့ (Alok)",
  T_33_WT_WS_SKILLSET7: "Painted Refuge (Steffie)",
  T_33_WT_WS_SKILLSET8: "Tracing Steps (Clu)",
  T_33_WT_WS_SKILLSET9: "Master of All (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/စကၠန႔္",
  T_33_WT_WS_UNIT_METER: "မီတာ",
  T_33_WT_WS_UNIT_SECOND: "စကၠန္႔",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Raindoll (ေဘာင္းဘီ)",
  T_33_YS_H_ONIGIRI: "အိုနီဂီရီမ်က္ႏွာဖံုး",
  T_33_YS_H_RAINCOAT: "Raindoll (ေခါင္းေဆာင္း)",
  T_33_YS_HA_CRYINGFACE: "Crying Emote (မ်က္ႏွာပန္းခ်ီ)",
  T_33_YS_M_H_FROGKING: "ဖားဘုရင္ဦးထုပ္",
  T_33_YS_S_RAINCOAT: "Raindoll (ဖိနပ္)",
  T_33_YS_T_BLACKHOLE: "The Doppler Shift ေခါင္းစြပ္အကၤ်ီ",
  T_33_YS_T_RAINCOAT: "Raindoll (အကၤ်ီ)",
  T_33_YS_T_SOCCER_GREEN: "Electrified Kick (ဂ်ာစီ)",
  T_33_YS_T_SOCCER_YELLOW: "Energized Kick (ဂ်ာစီ)",
  T_33_YS_T_WIFI: "ႏွလံုးသေကၤတတီရွပ္",
  T_34_C_SKILL_DESC_STREAMERGUY: "ဖယ္ထုတ္မႈတိုင္းပရိသတ္တစ္ဦးကိုေပါင္းထည့္မည္ျဖစ္ၿပီး ၾကည့္ရႈသူအေရအတြက္ေလ်ာ့နည္းမည္မဟုတ္ပါ. ထပ္ေလာင္းၾကည့္ရႈသူတစ္ဦးစီႏွင့္အတူ၊ ေခါင္းပစ္ခ်က္မွရရွိေသာပ်က္စီးဆုံးရႈံးမႈသည္ {0}% (အမ်ားဆုံး {1}%) ႏွင့္ရန္သူမ်ားကိုေခါင္းပစ္ခ်က္ေၾကာင့္ပ်က္စီးဆုံးရႈံးမႈ {2}% (အမ်ားဆုံး {3}%) တိုးေစမည္.",
  T_34_C_SKILL_DESC_TRACKER: "အနီးဆုံးရန္သူကိုမီတာ100 အေရွ႕အကြာအေဝးအတြင္းဒရုန္းကိုလႊတ္တင္ၿပီး 5 မီတာအခ်င္းရွိ ေသြးခုန္ႏႈန္းေပါက္ကြဲမႈကိုဖန္တီးကာလႈပ္ရွားမႈအလ်င္ {0}%ေလွ်ာ့ခ်ျပီးပစ္ခတ္မႈအလ်င္ {1}% ျဖင့္ ပ်က္စီးမႈ {2} ကိုဖန္တီးပါ. {3}s ၾကာသံုးႏိုင္သည္. CD: {4}s.",
  T_34_C_SKILL_NAME_TRACKER: "Senses Shockwave",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "တိရစာၦန္စကင္: Angry Surfer Finn",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "တိရစာၦန္စကင္: ပင္လယ္နက္ဆူး",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "တိရစာၦန္စကင္: Thunderstorm Finn",
  T_34_DY_PETSKIN_TIGER_BIS_N: "တိရစာၦန္စကင္: Digital Tig",
  T_34_DY_SURFSHARK_N: "Finn",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Great Conductor",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "တက္ၾကြသည္",
  T_34_HQ_EMOTE_RIDICULE_N: "ေလွာင္ေျပာင္သည္",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Pickup Truck- Evil Engineer",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuk Tuk- Husky Pup",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle- Hybrid Explosion",
  T_34_JL_G36_MADBIONIC_N: "G36- Flaring Bionica",
  T_34_JL_GRENADE_BIS_N: "ဗံုး- Soldier Pixel",
  T_34_JL_MACHETE_RAMPAGE4_N: "Night Blade",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Banana Dagger",
  T_34_JL_UMP45_BIS_N: "UMP- Digital Dasher",
  T_34_LY_WS_ABS_DESC: "ဤနံပါတ္၏ပကတိတန္ဖိုးကိုရယူပါ",
  T_34_LY_WS_ADD_DESC: "စာရင္းအဆံုးတြင္အရာအသစ္ထည့္ပါ",
  T_34_LY_WS_AUTO_A: "ရေန္သူမ်ားကိုေအာ္တိုစကန္",
  T_34_LY_WS_BOT: "ပံုမွန္",
  T_34_LY_WS_BOT_PATH: "လမ္းေၾကာင္း",
  T_34_LY_WS_BOT_TYPE: "အမ်ိဳးအစား",
  T_34_LY_WS_BOT4: "Axe",
  T_34_LY_WS_BOT5: "ပစ္ခ်",
  T_34_LY_WS_BOT6: "ကိုယ္တိုင္ေပါက္ကြဲ",
  T_34_LY_WS_BOT8: "သားသတ္သမား",
  T_34_LY_WS_COL_DESC: "အေရာင္ေရြးပါ",
  T_34_LY_WS_DEL_DESC: "စာရင္းရွိသတ္မွတ္ထားသည့္ကိန္းညႊန္းသက္ဆိုင္ေသာအရာကိုဖ်က္ပါ",
  T_34_LY_WS_DF_PER: "ခုခံေရး %",
  T_34_LY_WS_FORT_INTERVAL: "တိုက္ခိုက္မွဳၾကားကာလ",
  T_34_LY_WS_GET: "ရရွိသည္",
  T_34_LY_WS_GET_DESC: "စာရင္းရွိသတ္မွတ္ထားသည့္ကိန္းညႊန္း၏သက္ဆိုင္ရာအရာရရွိသည္",
  T_34_LY_WS_GLEN_ARR_DESC: "လက္ရွိစာရင္းရွိအစိတ္အပိုင္းအေရအတြက္ကိုရယူပါ",
  T_34_LY_WS_GLEN_DESC: "ဤစာေၾကာင္း၏အရွည္ကို ရယူပါ",
  T_34_LY_WS_GVX: "x ဗက္တာအစိတ္အပိုင္းရရွိသည္",
  T_34_LY_WS_GVX_DESC: "ဗက္တာ၏ပထမအစိတ္ပိုင္းရရွိသည္",
  T_34_LY_WS_GVY: "y ဗက္တာအစိတ္ပိုင္းရရွိသည္",
  T_34_LY_WS_GVY_DESC: "ဗက္တာ၏ဒုတိယအစိတ္အပိုင္းကိုသတ္မွတ္ပါ",
  T_34_LY_WS_GVZ: "z ဗက္တာအစိတ္အပိုင္းရရွိသည္",
  T_34_LY_WS_GVZ_DESC: "ဗက္တာ၏တတိယအစိတ္ပိုင္းကိုရယူပါ",
  T_34_LY_WS_INDEX: "အညႊန္း",
  T_34_LY_WS_JOIN: "ခ်ိတ္ဆက္",
  T_34_LY_WS_NEG_DESC: "ဤနံပါတ္၏အႏုတ္တန္ဖိုးကိုရယူပါ",
  T_34_LY_WS_PATH: "လမ္းေၾကာင္းသတ္မွတ္သည္",
  T_34_LY_WS_PATH_DESC: "အထူးသက္ရွိပစၥည္းမ်ား၏ခရီးသြားလမ္းေၾကာင္းမ်ားကို ထည့္ရန္/ဖ်က္ရန္အသုံးျပဳပါ. (4v4, အလဲထိုးပြဲႏွင့္ကစားကြင္းမုဒ္တြင္မရွိပါ)",
  T_34_LY_WS_POINT: "Marker",
  T_34_LY_WS_POINT_DESC: "လက္ရွိတည္ေနရာကိုအမွတ္အသားျပဳရန္အသုံးျပဳပါ. (4v4, အလဲထိုးပြဲႏွင့္ကစားကြင္းမုဒ္တြင္မရွိပါ)",
  T_34_LY_WS_RANGE_F: "အေဝး",
  T_34_LY_WS_RANGE_M: "အလယ္",
  T_34_LY_WS_RANGE_N: "အနီး",
  T_34_LY_WS_RNDF_DESC: "ၾကားကာလတစ္ခုမွက်ပန္းဒႆမတစ္ခုကိုဖန္တီးပါ",
  T_34_LY_WS_RNDI_DESC: "ၾကားကာလတစ္ခုမွက်ပန္းကိန္းျပည့္ကိုဖန္တီးပါ",
  T_34_LY_WS_SET: "အစံု",
  T_34_LY_WS_SET_DESC: "စာရင္းရွိသတ္မွတ္ထားသည့္ကိန္းညႊန္း၏သက္ဆိုင္ရာအရာသတ္မွတ္ပါ",
  T_34_LY_WS_SQRT_DESC: "ဤနံပါတ္၏စတုရန္းအျမစ္ကိုရရွိသည္",
  T_34_LY_WS_STRC_DESC: "စာသားႏွစ္ခုကိုခ်ိတ္ဆက္ပါ",
  T_34_LY_WS_SVX: "x ဗက္တာအစိတ္ပိုင္းသတ္မွတ္ပါ",
  T_34_LY_WS_SVX_DESC: "ဗက္တာ၏ပထမအစိတ္အပိုင္းသတ္မွတ္ပါ",
  T_34_LY_WS_SVY: "y ဗက္တာအစိတ္အပိုင္းအစံု",
  T_34_LY_WS_SVY_DESC: "ဗက္တာဒုတိယအစိတ္အပိုင္းသတ္မွတ္ပါ",
  T_34_LY_WS_SVZ: "z ဗက္တာအစိတ္အပိုင္းအစံု",
  T_34_LY_WS_SVZ_DESC: "ဗက္တာ၏တတိယအစိတ္အပိုင္းကိုသတ္မွတ္ပါ",
  T_34_LY_WS_VADD: "ထပ္တိုးဗက္တာ",
  T_34_LY_WS_VADD_DESC: "Vector ႏွစ္ခုထည့္ပါ",
  T_34_LY_WS_VAL_DESC: "အေျခအေနအရကိန္းျပည့္ သို႔မဟုတ္ ဒႆမတစ္ခုထည့္ပါ",
  T_34_LY_WS_VANG_DESC: "ဗက္တာႏွစ္ခုၾကားေထာင့္ကိုတြက္ခ်က္ပါ",
  T_34_LY_WS_VCP: "ကုန္ကူးပစၥည္း",
  T_34_LY_WS_VCP_DESC: "ဗက္တာႏွစ္ခုေပါင္းျခင္းျဖင့္ကုန္ကူးပစၥည္းတြက္ခ်က္ပါ",
  T_34_LY_WS_VDIS_DESC: "ဗက္တာႏွစ္ခုၾကားအကြာအေဝးကိုတိုင္းပါ",
  T_34_LY_WS_VDP: "Dot product",
  T_34_LY_WS_VDP_DESC: "ဗက္တာႏွစ္ခု၏အစက္ကိုတြက္ခ်က္ပါ",
  T_34_LY_WS_VFX1: "အဝိုင္းပုံသ႑ာန္",
  T_34_LY_WS_VFX2: "ဒုလံုးရွည္",
  T_34_LY_WS_VFX3: "လက္စြပ္",
  T_34_LY_WS_VFX4: "ဘြန္း",
  T_34_LY_WS_VFX5: "ပစ္ဇယ္",
  T_34_LY_WS_VFX6: "မီးပြားမ်ား",
  T_34_LY_WS_VMOD_DESC: "ဗက္တာတစ္ခု၏ျပင္းအားကိုတြက္ခ်က္ပါ",
  T_34_LY_WS_VMUL: "Vector အပြား",
  T_34_LY_WS_VMUL_DESC: "ဗက္တာႏွစ္ခုေျမွာက္ပါ",
  T_34_LY_WS_VNOR_DESC: "ဗက္တာကိုပံုမွန္လုပ္ပါ",
  T_34_LY_WS_VSUB: "ဗက္တာကိုဖ်က္ပါ",
  T_34_LY_WS_VSUB_DESC: "ဗက္တာႏွစ္ခုအႏွဳတ္သက္ေရာက္မွဳ",
  T_34_M_WS_ANGLE: "လွည့္ေထာင့္",
  T_34_M_WS_ARRAY: "စာရင္း",
  T_34_M_WS_ATT: "ပိုင္ဆိုင္မွဳ",
  T_34_M_WS_BOOL: "Boolean",
  T_34_M_WS_COLORARRAY: "အေရာင္အာေရး",
  T_34_M_WS_COLOUR: "အေရာင္",
  T_34_M_WS_CONFRONBANNER: "တိုက္ပြဲဘန္နာ",
  T_34_M_WS_COORDINATE: "ၾသဒိနိတ္",
  T_34_M_WS_CUSTOMINF: "စိတ္ၾကိဳက္ HUD",
  T_34_M_WS_CUSTOMMODEDESC: "စိတ္ၾကိဳက္ဖန္တီးမွဳျပီးပါျပီ. သင္၏စည္းမ်ဥ္းႏွင့္ဖန္တီးျပီးကစားပါ.",
  T_34_M_WS_DAMAGETYPE: "ပ်က္စီးမွဳအမ်ိဳးအစား",
  T_34_M_WS_DAMAGETYPEDESC: "စနစ္တြင္လက္ရွိသံုးပ်က္စီးမွဳအမ်ိဳးအစား",
  T_34_M_WS_DESCTEXT: "ေဖာ္ျပခ်က္စာသား",
  T_34_M_WS_DURACTION: "ၾကာခ်ိန္",
  T_34_M_WS_ECAMODE: "စိတ္ၾကိဳက္ဖန္တီးမုဒ္",
  T_34_M_WS_ENDPHASEDESC: "လက္ရွိအဆင့္ကိုခ်က္ခ်င္းအဆံုးသတ္ျပီးေနာက္တစ္ခုစပါ",
  T_34_M_WS_ENTITY: "Entity",
  T_34_M_WS_FLOAT: "ဒႆမ",
  T_34_M_WS_GAME: "ဂိမ္း",
  T_34_M_WS_GAMERESULTS: "ျပိဳင္ပြဲရလဒ္",
  T_34_M_WS_GETCONTROL2: "Entity ပိုင္ဆိုင္မွဳကိုတည္းျဖတ္ရန္ကစားသမားမ်က္ႏွာျပင္မွထိန္းခ်ဳပ္သည့္အရာကိုရယူပါ (ဒီဇိုင္း၊အေရာင္၊အေၾကာင္းအရာ၊အျခားအပါအဝင္)",
  T_34_M_WS_HEIGHT: "အျမင့္",
  T_34_M_WS_HUDBUTTONWIDGET: "ထိန္းခ်ဳပ္ခလုတ္",
  T_34_M_WS_HUDEMPTYWIDGET: "Empty pivot",
  T_34_M_WS_HUDIMAGEWIDGET: "ရုပ္ပံုထိန္းခ်ဳပ္ခ်က္",
  T_34_M_WS_HUDINPUTWIDGET: "စာသားေသတၱာထိန္းခ်ဳပ္ခ်က္",
  T_34_M_WS_HUDLABELWIDGET: "စာသားထိန္းခ်ဳပ္ခ်က္",
  T_34_M_WS_ICON: "အိုင္ကြန္",
  T_34_M_WS_ICON_AIM: "ရည္မွန္းခ်က္",
  T_34_M_WS_ICON_ARROW: "ျမွား",
  T_34_M_WS_ICON_BLAST: "ေပါက္ကြဲမွဳ",
  T_34_M_WS_ICON_CIRCULAR: "စက္ဝိုင္း",
  T_34_M_WS_ICON_CLOTH: "စကၠဴ",
  T_34_M_WS_ICON_COLLIMATION: "ပစ္မွတ္ပစ္ခတ္မွဳ",
  T_34_M_WS_ICON_CORPSE: "ဖုတ္ေကာင္",
  T_34_M_WS_ICON_CROSS: "လက္ဝါးကပ္တိုင္",
  T_34_M_WS_ICON_DAY: "ေန",
  T_34_M_WS_ICON_DEFENSE: "က်ည္ကာ",
  T_34_M_WS_ICON_DIALOGUE: "ဒိုင္ယာေလာ့ခ္",
  T_34_M_WS_ICON_DIAMONDS: "စိန္",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "အာေမဋိတ္အမွတ္အသား",
  T_34_M_WS_ICON_FLAG: "အလံ",
  T_34_M_WS_ICON_FOLDER: "ဖိုင္",
  T_34_M_WS_ICON_GLASSES: "မ်က္လံုး",
  T_34_M_WS_ICON_GUN: "ေသနတ္",
  T_34_M_WS_ICON_HEART: "ႏွလံုး",
  T_34_M_WS_ICON_HEXAGON: "ဆ႒ဂံ",
  T_34_M_WS_ICON_HOURGLASS: "သဲနာရီ",
  T_34_M_WS_ICON_HOUSE: "အိမ္",
  T_34_M_WS_ICON_KEY: "ေသာ့",
  T_34_M_WS_ICON_LIGHTNING: "လွ်ပ္စီး",
  T_34_M_WS_ICON_LOCK: "ေသာ့ခတ္",
  T_34_M_WS_ICON_LOOP: "ကြင္းဆက္",
  T_34_M_WS_ICON_MAGNIFIER: "မွန္ဘီလူး",
  T_34_M_WS_ICON_MONEY: "ပိုက္ဆံ",
  T_34_M_WS_ICON_MONTH: "လ",
  T_34_M_WS_ICON_OPENFOLDER: "ဖိုင္တြဲဖြင့္မည္",
  T_34_M_WS_ICON_PLUS: "အေပါင္းသေကၤတ",
  T_34_M_WS_ICON_QUADRI: "စတုဂံ",
  T_34_M_WS_ICON_QUESTIONMARK: "ေမးခြန္းအမွတ္အသား",
  T_34_M_WS_ICON_RECYCLING: "ျပန္လည္အသံုးျပဳ",
  T_34_M_WS_ICON_REFRESH: "ျပန္ဆန္းသစ္",
  T_34_M_WS_ICON_REST: "ျပန္စပါ",
  T_34_M_WS_ICON_RETURN: "ေနာက္သို႔",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "ညာၾတာပီဇိြဳက္",
  T_34_M_WS_ICON_SCISSORS: "ကတ္ေၾကး",
  T_34_M_WS_ICON_SETUP: "ဆက္တင္",
  T_34_M_WS_ICON_SIGN: "အမွတ္အသား",
  T_34_M_WS_ICON_SIGNOUT: "ထြက္မည္",
  T_34_M_WS_ICON_SQUARE: "စတုရန္း",
  T_34_M_WS_ICON_STAR: "ၾကယ္",
  T_34_M_WS_ICON_STONE: "ေက်ာက္တံုး",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Swim ring",
  T_34_M_WS_ICON_TAGGING: "ရင္ထိုး",
  T_34_M_WS_ICON_THESWORD: "ဓါး",
  T_34_M_WS_ICON_TRAPEZOID: "ၾတာပီဇိြဳက္",
  T_34_M_WS_ICON_TRASHCAN: "အမွိဳက္ပံုး",
  T_34_M_WS_ICON_TRIANGLE: "ၾတိဂံ",
  T_34_M_WS_ICON_TROPHY: "ဆုဖလား",
  T_34_M_WS_ICON_UP: "အားေပး",
  T_34_M_WS_ICON_WRONG: "မွားသည္",
  T_34_M_WS_ICON_YES: "မွန္သည္",
  T_34_M_WS_ICONNAME: "အိုင္ကြန္အမည္",
  T_34_M_WS_INT: "ကိန္းျပည့္",
  T_34_M_WS_KILLZONE: "မရဏဇုန္",
  T_34_M_WS_LEFTCOLOR: "ဘယ္ဘက္အေရာင္",
  T_34_M_WS_LEFTTEAMINDEX: "ဘယ္အသင္းအညႊန္း",
  T_34_M_WS_LEFTTEAMSCORE: "ဘယ္အသင္းရမွတ္",
  T_34_M_WS_LOCSWITCH: "ဘာသာစကားေျပာင္း",
  T_34_M_WS_MAX: "အမ်ားဆံုး",
  T_34_M_WS_MIN: "အနည္းဆံုး",
  T_34_M_WS_NUMBER: "နံပါတ္",
  T_34_M_WS_OBJECT: "Entity",
  T_34_M_WS_OPEN: "ဖြင့္",
  T_34_M_WS_OPENSATUS: "အေျခအေနကိုဖြင့္ပါ",
  T_34_M_WS_PICTURE: "ဂရပ္ဖစ္",
  T_34_M_WS_RANKARRAY: "အဆင့္ျပသမွဳ",
  T_34_M_WS_RESULTS: "ရလဒ္မ်ား",
  T_34_M_WS_RIGHTCOLOR: "အေရာင္မွန္",
  T_34_M_WS_RIGHTTEAMINDEX: "ညာအသင္းအညႊန္း",
  T_34_M_WS_RIGHTTEAMSCORE: "ညာအသင္းရမွတ္",
  T_34_M_WS_ROUNDBANNER: "အလွည့္ဘန္နာ",
  T_34_M_WS_ROUNDDESC: "အလွည့္ရွင္းလင္းခ်က္",
  T_34_M_WS_ROUNDHUD: "အလွည့္နံပါတ္",
  T_34_M_WS_ROUNDPARAMS: "အလွည့္နံပါတ္ျပသမွဳ",
  T_34_M_WS_SAME_NAME: "အမည္ထပ္ေနသည္.အသစ္တစ္ခုစမ္းပါ.",
  T_34_M_WS_SCOREARRAY: "အာေရးရမွတ္",
  T_34_M_WS_SCORINGTYPE: "ရမွတ္အမ်ိဳးအစား",
  T_34_M_WS_SCORINGTYPEDECS: "ကစားသမားမ်ားရႏိုင္တဲ့ရမွတ္အမ်ိဳးအစား. ရမွတ္စိတ္ႀကိဳက္ျပင္ဆင္ျခင္းကိုပံ့ပိုးေပးသည္.",
  T_34_M_WS_SCUFFLESCORING: "အသင္းမ်ိဳးစံုရမွတ္",
  T_34_M_WS_SETATTRIBUTES: "ပိုင္ဆိုင္မွဳဆက္တင္မ်ား",
  T_34_M_WS_SHUT: "ပိတ္",
  T_34_M_WS_SOUND: "အသံအက္ဖက္",
  T_34_M_WS_SOUNDCLICK: "ႏွိပ္ေနသည္",
  T_34_M_WS_SOUNDDD: "ေရတြက္ခ်ိန္",
  T_34_M_WS_SOUNDFEMALEA: "ဒဏ္ရာရအမ်ိဳးသမီး",
  T_34_M_WS_SOUNDM: "ေသနတ္သံ",
  T_34_M_WS_SOUNDMALEA: "ဒဏ္ရာရ (အမ်ိဳးသား)",
  T_34_M_WS_SOUNDUAV: "ေပါက္ကြဲမွဳ",
  T_34_M_WS_ST_ASSISTCOUNT: "ကူညီမွဳမ်ား",
  T_34_M_WS_ST_CHECKPROGRESS: "စစ္ေဆးေရးမွတ္တိုးတက္မွဳ",
  T_34_M_WS_ST_DAMAGESUM: "ပ်က္စီးမွဳ",
  T_34_M_WS_ST_FINISHCOUNT: "ရရွိျပီးရည္မွန္းခ်က္အရည္အတြက္",
  T_34_M_WS_ST_FINISHORDER: "ရည္းမွန္းခ်က္မ်ားရရွိသည္",
  T_34_M_WS_ST_FINISHTIME: "ပစ္မွတ္ရရွိျပီးအခ်ိန္",
  T_34_M_WS_ST_KILLCOUNT: "သတ္ႏွဳန္း",
  T_34_M_WS_ST_MAINSCORE: "ပစ္မွတ္ရမွတ္",
  T_34_M_WS_ST_RANKSCORE: "အဆင့္အမွတ္",
  T_34_M_WS_ST_SURVIVALDURACTION: "ရွင္သန္အခ်ိန္",
  T_34_M_WS_ST_UNKOWN: "အမည္မသိ",
  T_34_M_WS_STARTBANNER: "စတင္ဘန္နာ",
  T_34_M_WS_STARTTIME: "စတင္ခ်ိန္",
  T_34_M_WS_STRING: "စာသား",
  T_34_M_WS_STUDIO: "စတူဒီယို",
  T_34_M_WS_TEAMARRAY: "အာေရးအသင္း",
  T_34_M_WS_TEXTCONTENT: "အေၾကာင္းအရာ",
  T_34_M_WS_THEMECOLOR: "အျပင္အဆင္အေရာင္",
  T_34_M_WS_TIME: "ေရတြက္ခ်ိန္",
  T_34_M_WS_TITLETEXT: "စာသားေခါင္းစဥ္",
  T_34_M_WS_TYPE: "အမ်ိဳးအစား",
  T_34_M_WS_UODATETYPE: "အပ္ဒိတ္အမ်ိဳးအစား",
  T_34_M_WS_VARNAME: "ေျပာင္းလဲႏိုင္ေသာအမည္",
  T_34_M_WS_VECTOR: "ဗက္တာ",
  T_34_M_WS_VFX: "ျမင္ကြင္းအက္ဖက္",
  T_34_M_WS_WIDTH: "အက်ယ္",
  T_34_MF_CHARACTER_TRACKER_N: "Homer",
  T_34_PD_FlagBattle_HYPE_1: "မီး",
  T_34_SP_WS_BLOCK1_NAME: "အဆင့္ေျပာင္းပါ",
  T_34_SP_WS_BLOCK1_NAMEDESC: "လိုခ်င္ေသာအဆင့္ (သို႔) အလွည့္သို႔ဝင္ရန္ျၿပိဳင္ပြဲတစ္ခု၏အဆင့္ကိုေျပာင္းပါ. အလွည့္မ်ားတြင္ အဆင့္ၫႊန္းကိန္းမ်ားပါရွိၿပီးအထူးအမ်ိဳးအစားတစ္ခုျဖစ္သည္",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "ပစ္မွတ္အဆင့္၏အညႊန္း",
  T_34_SP_WS_BLOCK10_NAME: "ျမင္ကြင္းအက္ဖက္ဖန္တီးပါ",
  T_34_SP_WS_BLOCK10_NAMEDESC: "သတ္မွတ္႐ုပ္ပုံအက္ဖက္အသုံးျပဳ၍အိုင္ကြန္တစ္ခုဖန္တီးပါ. ျမင္ကြင္းအက္ဖက္ entity ၏ပိုင္ဆိုင္မွဳမ်ားကိုခ်ိန္ညႇိျခင္းျဖင့္ျမင္ကြင္းအက္ဖက္၏ ေနာက္ထပ္ပိုင္ဆိုင္မွဳမ်ားကိုျပင္ဆင္ႏိုင္သည္.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "ျမင္ကြင္းအက္ဖက္",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "အသံုးခ်လို႔ရတဲ့အျမင္အာရံုမ်ိဳး",
  T_34_SP_WS_BLOCK12_NAME: "ျမင္ကြင္းအက္ဖက္ဖ်တ္သိမ္း",
  T_34_SP_WS_BLOCK12_NAMEDESC: "သတ္မွတ္ထားေသာျမင္ကြင္းဖ်တ္သိမ္း",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Entity ျမင္ကြင္းအက္ဖက္",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "ဖ်က္ရမည့္ျမင္ကြင္းအက်ိဳးသက္ေရာက္မွဳ",
  T_34_SP_WS_BLOCK13_NAMEDESC: "ျမင္ကြင္းအက္ဖက္ဖြင့္ရန္ကစားသူကိုအမိန္႔ေပးပါ",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "ကစားသမားစာရင္း",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "မက္ေဆ့ခ်္လက္ခံရမည့္ကစားသမား",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "အရင္းအျမစ္လမ္းေၾကာင္း",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "စနစ္အရင္းအျမစ္လမ္းေၾကာင္းသည္:လမ္းေၾကာင္းတြင္ရွိသည္. စိတ္ႀကိဳက္အရင္းအျမစ္လမ္းေၾကာင္းသည္အျပင္-လမ္းေၾကာင္းျဖစ္သည္. မူရင္းအတိုင္းဗလာျဖစ္သည္.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA ခ်န္နယ္၊ ခ်န္နယ္တစ္ခုစီသည္ 0 ႏွင့္ 255 ၾကားတန္ဖိုးကို int32 တြင္သိမ္းဆည္းထားသည္. မူရင္းအေရာင္မွာအျဖဴေရာင္ (255,255,255,255) ျဖစ္သည္.",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Zoom",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "ပံုခ်ဲ႕စေကး; မူရင္းမွာ 1  ျဖစ္သည္",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "ကမာၻလုံးဆိုင္ရာၾသဒီနိတ္မ်ားျဖင့္ ေဖာ္ျပထားေသာအေနအထား. ပုံေသအားျဖင့္ Vector3(0).",
  T_34_SP_WS_BLOCK14_NAME: "အသံအက္ဖက္ဖြင့္ပါ",
  T_34_SP_WS_BLOCK14_NAMEDESC: "အသံအက္ဖက္ကိုဖြင့္ရန္သံုးစြဲသူအားအမိန္႔ေပးပါ",
  T_34_SP_WS_BLOCK15_NAME: "အထြက္မွတ္တမ္း",
  T_34_SP_WS_BLOCK15_NAMEDESC: "မွတ္တမ္းမ်က္ႏွာျပင္ေပၚရွိအေၾကာင္းရာကိုထုတ္ပါ",
  T_34_SP_WS_BLOCK2_NAMEDESC: "လံုျခံဳေရးဇုန္အျပင္ဘက္ရွိကစားသမားမ်ားထိခိုက္မႈျဖစ္ေစရန္အတြက္ဖြင့္ပါ",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "လံုျခံဳေရးဇုန္၏ဗဟိုအမွတ္",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "အခ်င္းဝတ္မ်ဥ္း",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "လံုျခံဳေရးဇုန္၏အခ်င္းဝက္",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "လံုျခံဳေရးဇုန္စတင္က်ဥ္းျခင္းၾကာခ်ိန္",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "လံုျခံဳေရးဇုန္က်ဥ္းျခင္းၾကာခ်ိန္",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "လံုျခံဳေရးဇုန္အျပင္ဘက္တြင္ပ်က္စီးဆုံးရႈံးမႈပမာဏ",
  T_34_SP_WS_BLOCK3_NAMEDESC: "အႏၲရာယ္ဇုန္ပိတ္ထားေသာအခါ၊ လံုျခံဳေရးျပင္ပရွိကစားသမားမ်ားသည္ထိခိုက္မႈရရွိမည္မဟုတ္ပါ",
  T_34_SP_WS_BLOCK4_NAMEDESC: "သတ္မွတ္ထားေသာအခ်ိန္အတြက္ေနာက္ဆက္တြဲလုပ္ေဆာင္မႈကိုေႏွာင့္ေႏွးရန္အသုံးျပဳပါ",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "ေစာင့္ဆိုင္းၾကာခ်ိန္ကိုမိုင္စကၠန႔္ျဖင့္တိုင္းတာသည္",
  T_34_SP_WS_BLOCK5_NAMEDESC: "ေနာက္ေဘာင္သို႔ေနာက္ဆက္တြဲလုပ္ေဆာင္ခ်က္ကိုေ႐ႊ႕ဆိုင္းရန္အသုံးျပဳပါ",
  T_34_SP_WS_BLOCK6_NAME: "စိတ္ၾကိဳက္ HUD ဖန္တီးပါ",
  T_34_SP_WS_BLOCK6_NAMEDESC: "သတ္မွတ္ထားေသာစိတ္ၾကိဳက္ HUD ဖန္တီးပါ",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "HUD entity ဖန္တီးရန္သံုးသည့္အမည္. ၎ႏွင့္သက္ဆိုင္ေသာlocal variableသည္HUDကိုဖန္တီးေနေသာentityျဖစ္သည္.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "ကစားသမား",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "Entity ကစားသမား",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "HUD ၏ထူးျခားေသာအၫႊန္း",
  T_34_SP_WS_BLOCK7_NAMEDESC: "သတ္မွတ္ထားေသာကစားသမားမ်ားအတြက္သာျမင္ႏိုင္ေသာမူရင္း HUD တစ္ခုကိုဖန္တီးပါ",
  T_34_SP_WS_BLOCK8_NAMEDESC: "ဖ်က္လိုက္ေသာအခါတြင္၊ မူရင္း HUD ကိုကစားသမားတြင္ေတြ႕လိမ့္မည္မဟုတ္ပါ (ဝွက္ထားသည္ျဖစ္ေစသို႔မဟုတ္ စြန႔္ပစ္ထားသည္)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD entity",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "ဖ်တ္သိမ္းမည့္ HUD entity",
  T_34_SP_WS_BLOCK9_NAMEDESC: "ပယ္ရွားျပီးေသာအခါ၊ စိတ္ၾကိဳက္ HUD ကိုကစားသူတြင္ေတြ႕ရမည္မဟုတ္ပါ (ဝွက္ထားသည္ သို႔ စြန္႔ပစ္ထားသည္)",
  T_34_T_WS_BLOCK1_NAMEDESC: "ျပိဳင္ပြဲစတင္ေသာအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK10_NAMEDESC: "ကစားသမားဖယ္ထုတ္ျပီးအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "ဖယ္ထုတ္ခံရကစားသမားသည္အျဖစ္ပ်က္ကိုအစပ်ိဳးမည္",
  T_34_T_WS_BLOCK13_NAMEDESC: "ကစားသမားအျခားကစားသမားကူညီေသာအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "ဖယ္ထုတ္ခံရကစားသမား",
  T_34_T_WS_BLOCK14_NAMEDESC: "ကစားသူပ်က္စီးမွဳထုတ္ေသာအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "ပ်က္စီးမွဳလက္ခံရသည့္ကစားသမား",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "ထိခိုက္ပ်က္စီးမွဳအမ်ိဳးအစား",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "ထိခ်ုက္ပ်က္စီးမွဳပမာဏ",
  T_34_T_WS_BLOCK15_NAMEDESC: "ကစားသူမွအျခားကစားသမားကိုေခ်မွဳန္းျပီးအခါတြင္အစပ်ိဳးသည္",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "ရွင္းထုတ္ျပီးေသာကစားသမား",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "ပ်က္စီးေစေသာအမ်ိဳးအစားႏွိမ္နင္းျခင္း",
  T_34_T_WS_BLOCK16_NAMEDESC: "ကစားသမားျပိဳင္ပြဲခ်ိတ္ဆက္တဲ့အခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK17_NAMEDESC: "ကစားသမားကယ္တင္ျပီးအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK18_NAMEDESC: "အသင္းပယ္ရွားျပီးအခါတြင္အျဖစ္အပ်က္အစပ်ိဳးသည္",
  T_34_T_WS_BLOCK19_NAMEDESC: "အသင္းထည့္ျပီးေသာအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK2_NAMEDESC: "ျပိဳင္ပြဲျပီးဆံုးေသာအခါအျဖစ္ပ်က္အစပ်ိဳးသည္",
  T_34_T_WS_BLOCK20_NAMEDESC: "တစ္သင္းလံုးျပဳတ္ေသာအခါအစပ်ိဳးမည္",
  T_34_T_WS_BLOCK3_NAMEDESC: "အလွည့္စတင္ေသာအခါအျဖစ္ပ်က္အစပ်ိဳးသည္",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "အလွည့္နံပါတ္သည္ 0 မွစမည္",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "အဝိုင္းအညႊန္း",
  T_34_T_WS_BLOCK4_NAMEDESC: "အလွည့္ျပီးဆံုးေသာအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK5_NAMEDESC: "သတ္မွတ္အဆင့္စတင္ေသာအခါတြင္အစပ်ိဳးသည္",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "သတ္မွတ္အကြာအေဝး 0 မွစမည္",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "ဂိမ္းတြင္း Entity",
  T_34_T_WS_BLOCK6_NAMEDESC: "အဆင့္ျပီးဆံုးေသာအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK7_NAMEDESC: "ကစားသမားျပိဳင္ပြဲမွထြက္ေသာအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "အျဖစ္ပ်က္အစပ်ိဳးေပးမည့္ကစားသမား",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "ယႏၲရားကစားသမား",
  T_34_T_WS_BLOCK8_NAMEDESC: "ကစားသမား၏အမွတ္ေျပာင္းလဲေသာအခါအစပ်ိဳးသည္",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "ေျပာင္းလဲသည့္ရမွတ္အမ်ိဳးအစား",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "ေျပာင္းလဲျပီးေနာက္ရလဒ္တန္ဖိုး",
  T_34_T_WS_BLOCK9_NAMEDESC: "အသင္း၏ရမွတ္မ်ားေျပာင္းလဲေသာအခါတြင္အျဖစ္အပ်က္အစပ်ိဳးသည္",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "အျဖစ္ပ်က္အစပ်ိဳးမည့္အသင္း",
  T_34_WT_WS_BORNENTITY_PARAM1: "ေပါက္ဖြားအမွတ္",
  T_34_WT_WS_BORNENTITY_PARAM2: "ရရွိႏိုင္ေသာၾသဒိနိတ္",
  T_34_WT_WS_BORNENTITY_PARAM3: "ပံုေသေပါက္ဖြားအမွတ္သတ္မွတ္",
  T_34_WT_WS_BORNENTITY_PARAM4: "ေတာက္ပေနေသာနယ္နိမိတ္မ်ား",
  T_34_WT_WS_BORNENTITY_PARAM5: "သံုးေနလား မသံုးဘူးလား",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "စစ္ေဆးေရးစီမံခန္႔ခြဲမွဳ",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "အေျခအေနကိုဖြင့္ပါ",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "အေျခအေနအစပ်ိဳး",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "ဖယ္ထုတ္ေရးအစပ်ိဳးသည္သို႔မစပါ",
  T_34_WT_WS_ENTITY_PARAM1: "ဂိမ္း Entity",
  T_34_WT_WS_ENTITY_PARAM10: "အသင္းမ်ား",
  T_34_WT_WS_ENTITY_PARAM11: "အဖြဲ႕ဝင္အေရအတြက္",
  T_34_WT_WS_ENTITY_PARAM12: "အလွည့္တိုင္းျပန္လွည္သတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY_PARAM13: "ဇုန္ျပင္ပပ်က္စီးမွဳကိုဖြင့္ပါ",
  T_34_WT_WS_ENTITY_PARAM14: "ဇုန္ဆိုဒ္",
  T_34_WT_WS_ENTITY_PARAM15: "ဇုန္က်ဥ္းစတင္ခ်ိန္",
  T_34_WT_WS_ENTITY_PARAM16: "ဇုန္က်ဥ္းၾကာခ်ိန္",
  T_34_WT_WS_ENTITY_PARAM17: "ဇုန္ျပင္ပပ်က္စီးမွဳ",
  T_34_WT_WS_ENTITY_PARAM18: "ပစ္မွတ္ရမွတ္",
  T_34_WT_WS_ENTITY_PARAM19: "ဖယ္ထုတ္ေရးရမွတ္",
  T_34_WT_WS_ENTITY_PARAM2: "မွားယြင္းအေျခအေန",
  T_34_WT_WS_ENTITY_PARAM20: "ျပန္ႏိုးထအမ်ိဳးအစား",
  T_34_WT_WS_ENTITY_PARAM21: "ရမွတ္အေလွည့္အဆင့္သတ္မွတ္ခ်က္ (ကစားသမား)",
  T_34_WT_WS_ENTITY_PARAM22: "စံသတ္မွတ္ခ်က္အေရးပါမွဳ (ကစားသမား)",
  T_34_WT_WS_ENTITY_PARAM23: "ရမွတ္အေလွည့္အဆင့္သတ္မွတ္ခ်က္ (အသင္း)",
  T_34_WT_WS_ENTITY_PARAM24: "အေရးပါလိုအပ္ခ်က္ (အသင္း)",
  T_34_WT_WS_ENTITY_PARAM25: "ရမွတ္အဆင့္သတ္မွတ္ခ်က္ (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "အေရးၾကီးသတ္မွတ္ခ်က္ (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "အဆင့္ရမွတ္",
  T_34_WT_WS_ENTITY_PARAM28: "ရလဒ္စာမ်က္ႏွာတြင္စံႏႈန္းမ်ားကိုျပပါ",
  T_34_WT_WS_ENTITY_PARAM29: "အလွည့္အားလံုး",
  T_34_WT_WS_ENTITY_PARAM3: "ဂိမ္းခ်ိန္",
  T_34_WT_WS_ENTITY_PARAM4: "လက္ရွိအလွည့္အညႊန္း",
  T_34_WT_WS_ENTITY_PARAM5: "လက္ရွိအဆင့္အညႊန္း",
  T_34_WT_WS_ENTITY_PARAM6: "မုဒ္နမူနာပံုစံ ID",
  T_34_WT_WS_ENTITY_PARAM7: "ကစားသမားႏိုးၾကားမွဳဖြင့္ပါ",
  T_34_WT_WS_ENTITY_PARAM8: "ေဘာ့အားလံုးအသက္သြင္းပါ",
  T_34_WT_WS_ENTITY_PARAM9: "ကယ္တင္အခ်ိန္",
  T_34_WT_WS_ENTITY1_NAME: "လက္ရွိ Entity",
  T_34_WT_WS_ENTITY1_NAMEDESC: "လက္ရွိလာရာကိုျပန္ပါ",
  T_34_WT_WS_ENTITY10_NAME: "အိုင္ကြန္ဖယ္ရွားပါ",
  T_34_WT_WS_ENTITY10_NAMEDESC: "သတ္မွတ္အိုင္ကြန္ကိုပယ္ရွားပါ",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "သင္ဖယ္ရွားလိုသည့္အိုင္ကြန္ေရြးပါ",
  T_34_WT_WS_ENTITY11_NAME: "စာသားဖယ္ရွားပါ",
  T_34_WT_WS_ENTITY11_NAMEDESC: "စာသား Entity ဖယ္မည္",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "သင္ဖယ္ထုတ္လိုေသာစာသားကိုေရြးပါ",
  T_34_WT_WS_ENTITY12_NAMEDESC: "သတ္မွတ္ကစားသမားအတြက္ပစၥည္းထည့္ပါ",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "ပစၥည္းလက္ခံမည့္ကစားသမား",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "ရယူရမည့္သီးျခားပစၥည္း ID",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "ေပးရမည့္ပစၥည္းပမာဏ",
  T_34_WT_WS_ENTITY12_PARAM3: "အေရအတြက္",
  T_34_WT_WS_ENTITY13_PARAM1: "အမ်ိဳးအစား",
  T_34_WT_WS_ENTITY13_PARAM2: "တည္ေနရာ",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "အရာဝတၳဳ၏ေပါက္ပြားတည္ေနရာ၏ၾသဒိနိတ္မ်ား",
  T_34_WT_WS_ENTITY13_PARAM4: "အရာဝတၳဳ",
  T_34_WT_WS_ENTITY14_NAME: "အရာဝတၳဳဖယ္ရွားပါ",
  T_34_WT_WS_ENTITY14_NAMEDESC: "သတ္မွတ္ထားေသာအရာဝတၳဳကိုဖယ္ရွားပါ",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "အရာဝတၳဳကိုဖ်က္ပါ",
  T_34_WT_WS_ENTITY15_NAMEDESC: "ကစားသမားအားလံုး Entity ျပန္လည္ရယူပါ",
  T_34_WT_WS_ENTITY16_NAMEDESC: "အသင္း Entity အားလံုးျပန္လည္ရယူပါ",
  T_34_WT_WS_ENTITY17_NAMEDESC: "သတ္မွတ္ကစားသမားမ်ားအတြက္ HP မည္မွ်အတက္အက် ရွိသည္ကိုသတ္မွတ္ပါ. ျပန္တက္ပမာဏသည္အမ်ားဆံုး HP ထက္ေက်ာ္ပါက, HP သည္အမ်ားဆံုးထိသာတက္ပါမည္.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "HP အတက္အက်ကိုစီစဥ္သတ္မွတ္ေပးထားသည့္ကစားသမား",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "ျပန္ထူေထာင္ရန္လိုသည့္သတ္မွတ္ HP ပမာဏ",
  T_34_WT_WS_ENTITY18_NAME: "က်ပန္းေပါက္ဖြားမွတ္ကိုၾသဒိနိတ္ရရွိသည္",
  T_34_WT_WS_ENTITY18_NAMEDESC: "ဒီဇိုင္းထားသည့္ကစားသမားမ်ား ေပါက္ပြားရန္ႏွင့္ျပန္သြားရန္အတြက္တည္ေနရာကိုစီစဥ္သတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "ဤေနရာမွက်ပန္းေပါက္ဖြားမည့္ကစားသမား(မ်ား)",
  T_34_WT_WS_ENTITY18_RETURNDESC: "ကစားသမားသတ္မွတ္ေပးမည့္ေနရာ၏ၾသဒိနိတ္မ်ား",
  T_34_WT_WS_ENTITY19_NAME: "ကစားသမားရမွတ္ရယူပါ",
  T_34_WT_WS_ENTITY19_NAMEDESC: "သတ္မွတ္ကစားသမား၏အခ်ိဳ႕ရမွတ္မ်ားရယူပါ",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "ဤကစားသမား၏ရမွတ္ entity ရယူပါ",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "ရမွတ္အမ်ိဳးအစညးလိုအပ္သည္",
  T_34_WT_WS_ENTITY19_RETURNDESC: "ရရွိမည့္တိက်ေသာအမွတ္တန္ဖိုး",
  T_34_WT_WS_ENTITY2_NAME: "သတ္မွတ္ဂုဏ္သတၱိမ်ား",
  T_34_WT_WS_ENTITY2_NAMEDESC: "ပိုင္ဆိုင္မႈအမ်ိဳးအစားကိုေ႐ြးခ်ယ္ထားၿပီးျဖစ္သည့္ပိုင္ဆိုင္မႈတစ္ခု၏တန္ဖိုးကိုသတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY2_PARAM1: "Entity",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "ဂိမ္းဖြဲ႕စည္းမွဳ၏ပိုင္ဆိုင္မွဳတန္ဖိုး",
  T_34_WT_WS_ENTITY2_PARAM3: "ပိုင္ဆိုင္မွဳ",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "Entity ၏ပိုင္ဆိုင္မွဳမ်ား",
  T_34_WT_WS_ENTITY2_PARAM4: "တန္ဖိုး",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "ပစၥည္းတစ္ခု၏သီးျခားတန္ဖိုး. ပိုင္ဆိုင္မႈအမ်ိဳးအစားသည္ေ႐ြးခ်ယ္ထားသည့္အရာႏွင့္သက္ဆိုင္ရာလုပ္ကြက္မ်ားတြင္ဖြဲ႕စည္းထားေသာအမ်ိဳးအစားကိုက္ညီေၾကာင္းေသခ်ာပါေစ.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "သတ္မွတ္ကစားသမား၏ရမွတ္အခ်ိဳ႕ကိုစီစဥ္သတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "ဤကစားသမား၏ရမွတ္ကိုစီစဥ္သတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "ရမွတ္အမ်ိဳးအစားကိုသတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY20_PARAM3: "ရမွတ္",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "သတ္မွတ္ထားေသာရမွတ္တန္ဖိုးကိုသတ္မွတ္ေပးသည္",
  T_34_WT_WS_ENTITY21_NAME: "စုစုေပါင္းရရွိအသင္းရမွတ္",
  T_34_WT_WS_ENTITY21_NAMEDESC: "သတ္မွတ္အသင္း၏စုစုေပါင္းရမွတ္အခ်ိဳ႕ကိုရယူပါ",
  T_34_WT_WS_ENTITY21_PARAM1: "အသင္း",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "ဤအသင္း၏ရမွတ္Entityကိုရယူပါ",
  T_34_WT_WS_ENTITY22_NAME: "လက္ရွိအလွည့္အသင္းရမွတ္သတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY22_NAMEDESC: "သတ္မွတ္အသင္းမ်ား၏လက္ရွိအလွည့္၏ရမွတ္အခ်ိဳ႕ကိုစီစဥ္သတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "ဤအသင္း၏ရမွတ္ကိုျပင္ဆင္သတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY23_NAME: "ကစားသမားအလွည့္ရမွတ္ရယူပါ",
  T_34_WT_WS_ENTITY23_NAMEDESC: "သတ္မွတ္သည့္ကစားသမားမ်ားအတြက္ ေသခ်ာေသာအလွည့္၏အမွတ္အခ်ိဳ႕ကိုရယူပါ",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "ဤကစားသမား(မ်ား)၏ပတ္ပတ္လည္ရမွတ္မ်ားရယူပါ",
  T_34_WT_WS_ENTITY23_PARAM2: "အလွည့္",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "ဤအလွည့္မွရရွိသည့္ရမွတ္",
  T_34_WT_WS_ENTITY24_NAME: "အသင္းအလွည့္ရမွတ္ရယူပါ",
  T_34_WT_WS_ENTITY24_NAMEDESC: "သတ္မွတ္အသင္းမ်ားအတြက္သတ္မွတ္အခ်ီ၏အခ်ိဳ႕ရမွတ္မ်ားရယူပါ",
  T_34_WT_WS_ENTITY25_NAME: "တယ္လီပို႔",
  T_34_WT_WS_ENTITY25_NAMEDESC: "သတ္မွတ္ေနရာသို႔သတ္မွတ္ကစားသမားပို႔ေဆာင္ပါ",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "တယ္လီပို႔ခံရမည့္ကစားသမား",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "ကစားသမားမ်ားရွိရာညႇိႏႈိင္းခ်က္မ်ားကိုတယ္လီပို႔ပါမည္",
  T_34_WT_WS_ENTITY26_NAMEDESC: "သတ္မွတ္ထားေသာပစ္မွတ္မ်ားကိုထိခိုက္ပ်က္စီးေစရန္သတ္မွတ္ထားေသာကစားသမားမ်ားကို ဖြင့္ပါ. တိုက္စစ္ကစားသမားကိုမေ႐ြးခ်ယ္ပါကသတ္မွတ္ထားေသာပစ္မွတ္မ်ားသည္စနစ္မွ ပ်က္စီးမႈရရွိမည္ျဖစ္သည္.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Entity ဒဏ္ရာ",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "ပ်က္စီးမွဳပမာဏျပဳလုပ္ခ်က္",
  T_34_WT_WS_ENTITY28_NAMEDESC: "သတ္မွတ္ကစားသမားကယ္တင္ပါ",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "ျပန္လည္ရွင္သန္ႏိုင္ေသာကစားသမား",
  T_34_WT_WS_ENTITY3_NAMEDESC: "ဘေလာ့အမ်ိဳးအစားသတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY3_PARAM1: "ကဲ့သို႔",
  T_34_WT_WS_ENTITY4_NAME: "ပိုင္ဆိုင္မွဳရယူပါ",
  T_34_WT_WS_ENTITY4_NAMEDESC: "အဖြဲ႕အစည္း၏သီးျခားပိုင္ဆိုင္မႈကိုရယူပါ",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "ပိုင္ဆိုင္မႈတန္ဖိုး၏သတ္မွတ္ဂိမ္းအေၾကာင္းအရာကိုရယူပါ",
  T_34_WT_WS_ENTITY4_RETURNDESC: "ရရွိမည့္သီးျခားပိုင္ဆိုင္မွဳတန္ဖိုး",
  T_34_WT_WS_ENTITY5_NAMEDESC: "ကစားသမားအားလုံးအတြက္ေျပာင္းေ႐ႊ႕ႏိုင္မႈကိုစီစဥ္သတ္မွတ္ပါ",
  T_34_WT_WS_ENTITY6_NAME: "အိုင္ကြန္ဖန္တီးပါ",
  T_34_WT_WS_ENTITY6_PARAM1: "အိုင္ကြန္",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "HUD တြင္ျပသထားသည့္ရုပ္ပံု. ဒီဇိုင္းမ်ိဳးစံုမွေရြးယူပါ.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "ဘယ္ဒီဇိုင္းထည့္ရမလဲ အိုင္ကြန္ေရြးပါ",
  T_34_WT_WS_ENTITY7_NAMEDESC: "သတ္မွတ္ကစားသမားမ်ားအတြက္ HUD အိုင္ကြန္ဖန္တီးပါ. အကယ္လို႔ဘယ္ကစားသမားဖြဲ႕စည္းမွဳမွမေရြးခံရလွ်င္၊ HUD သည္ကစားသမားအားလံုးအတြက္ဖန္တီးထားမည္.",
  T_34_WT_WS_ENTITY7_PARAM1: "ကစားသမား",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "ေ႐ြးခ်ယ္ကစားသမား(မ်ား)အတြက္ HUD အိုင္ကြန္တစ္ခုဖန္တီးပါ",
  T_34_WT_WS_ENTITY8_NAME: "စာသားဖန္တီးပါ",
  T_34_WT_WS_ENTITY8_PARAM1: "စာသား",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "ဤအမိန႔္မွဖန္တီးရမည့္သီးျခားစာသားအေၾကာင္းအရာ",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "လက္ရွိဖန္တီးေနသည့္စာသားအေၾကာင္းအရာ",
  T_34_WT_WS_ENTITY9_NAMEDESC: "သတ္မွတ္ကစားသမားအတြက္ HUD ၏မ်ဥ္းကိုထည့္ပါ. ကစားသမားဖြဲ႕စည္းျခင္းသည္မေရြးခံရပါက၊ ကစားသမားအားလံုး၏ HUD တြင္စာသားဖန္တီးလိမ့္မည္.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "ေရြးထားေသာကစားသမားမ်ားအတြက္ HUD ထည့္ပါ",
  T_34_WT_WS_ICONENTITY_PARAM1: "အိုင္ကြန္ Entity",
  T_34_WT_WS_ICONENTITY_PARAM2: "ဒီဇိုင္း",
  T_34_WT_WS_ICONENTITY_PARAM3: "အေရာင္",
  T_34_WT_WS_ICONENTITY_PARAM4: "အတိုင္းအတာ",
  T_34_WT_WS_ICONENTITY_PARAM5: "ျပသမွဳအေနအထား",
  T_34_WT_WS_ICONENTITY_PARAM6: "ပစ္မွတ္ကိုလိုက္",
  T_34_WT_WS_ICONENTITY_PARAM7: "နံရံမွတဆင့္ျမင္ႏိုင္သည္",
  T_34_WT_WS_ICONENTITY_PARAM8: "အျမဲဖန္သားေပၚမွာ",
  T_34_WT_WS_ONETEAM_TAG: "အသင္းတစ္ခုတည္း",
  T_34_WT_WS_PHASEENTITY_PARAM1: "စစ္ေဆးေရးဂိတ္",
  T_34_WT_WS_PHASEENTITY_PARAM2: "အဆင့္ညႊန္းကိန္း",
  T_34_WT_WS_PHASEENTITY_PARAM3: "စတင္အခ်ိန္",
  T_34_WT_WS_PHASEENTITY_PARAM4: "ျပီးဆံုးခ်ိန္",
  T_34_WT_WS_PHASEENTITY_PARAM5: "ၾကာခ်ိန္",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Entity ကစားသမား",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "ျပန္လည္ႏိုးထအမွတ္",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "လက္နက္ဒါ့ေမ့ခ်္ %",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "ဇာတ္ေကာင္ 3D ေမာ္ဒယ္",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "အေထာက္အထား",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "လက္ရွိ HP",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Max. HP",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "ကစားသမားအေျခအေန",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "ရွင္သန္အခ်ိန္",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "မေသႏိုင္ေသာ",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "အသင္း",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "ပစ္မွတ္စစ္ေဆးေရးဂိတ္ ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "ေပါက္ဖြားအမွတ္",
  T_34_WT_WS_PROCIRCLE_ICON: "Icon",
  T_34_WT_WS_PVEDESC1: "အခ်ိန္မကုန္မီအနည္းဆုံးကစားသမားတစ္ဦးသည္အၿပီးသတ္စည္းသို႔ေရာက္ပါက၊ အသင္းအႏိုင္ရမည္ျဖစ္သည္. ကစားသမားအားလုံးကိုတစ္ခ်ိန္တည္းမွာ ဖယ္ထုတ္လိုက္ရင္ ပြဲၿပီးသြားပါၿပီ.",
  T_34_WT_WS_PVEDESC2: "အႏိုင္ရရန္သတ္မွတ္ထားေသာအခ်ိန္အတြက္ရွင္သန္ပါ. ကစားသမားအားလုံးကိုတစ္ခ်ိန္တည္းမွာဖယ္ထုတ္လိုက္ရင္ ပြဲၿပီးသြားပါၿပီ.",
  T_34_WT_WS_PVENAME1: "အလုအယက္",
  T_34_WT_WS_PVENAME2: "Endurance",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "လက္ရွိစစ္ေဆးေရးဂိတ္ ID",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Parkour မုဒ္စစ္ေဆးေရးနံပါတ္",
  T_34_WT_WS_SKILLSET14: "ဓါးသြားထက္ကအမုန္း (Kenta)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "အသင္း",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Ace",
  T_34_WT_WS_TEAMENTITY_PARAM3: "မန္ဘာအားလံုး",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "ပံုမွန္ခလုတ္",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "အသြင္အျပင္အမိ်ဳးစား",
  T_34_WT_WS_TXTENTITY_PARAM1: "Entity စာသား",
  T_34_WT_WS_TXTENTITY_PARAM2: "အေၾကာင္းအရာ",
  T_34_WT_WS_VFXENTITY_PARAM1: "Entity ျမင္ကြင္းအက္ဖက္",
  T_34_WZ_WS_LOGIC10_NAME: "ေရွ႕ဆက္မည္",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "လက္ရွိကြင္းဆက္ကိုေက်ာ္ၿပီး ေနာက္တစ္ခုကိုလုပ္ေဆာင္ပါ",
  T_34_WZ_WS_LOGIC11_NAME: "ျပန္မည္",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "လက္ရွိလုပ္ေဆာင္မႈကိုအဆုံးသတ္ၿပီးပင္မပ႐ိုဂရမ္သို႔ျပန္သြားပါ။ ျပန္လာသည့္အခါ ေဒတာျပန္ပို႔ခြင့္ျပဳသည္။",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "ျပန္ေပးတန္ဖိုး",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "ပင္မပ႐ိုဂရမ္သို႔ျပန္ပို႔ရမည့္ေဒတာ",
  T_34_WZ_WS_LOGIC2_NAME: "ႏွိဳင္းယွဥ္ပါ",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "သတ္မွတ္ထားသည့္ဖန္ရွင္ကိုအသုံးျပဳ၍တန္ဖိုး 2 ခုကိုႏႈိင္းယွဥ္ပါ",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "က်န္ရွိတန္ဖိုး",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "ႏွိဳင္းယွဥ္မွဳအတြက္အသံုးျပဳသည့္ဘယ္ဘက္ျခမ္းတန္ဖိုး",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "ႏွိဳင္းယွဥ္လုပ္ေဆာင္ခ်က္",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "တန္ဖိုးဘယ္လိုႏွိဳင္းယွဥ္လိုလည္းေရြးခ်ယ္ပါ. ပံ့ပိုးေပးထားေသာ ေအာ္ပေရတာမ်ားမွာ- >, >=,==, !=, <=, <, ႏွင့္ (Boolean only), သို႔ (Boolean only)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "အမွန္တန္ဖိုး",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "ႏႈိင္းယွဥ္မႈအတြက္အသုံးျပဳသည့္ညာဘက္ျခမ္းတန္ဖိုး",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "ႏွိဳင္းယွဥ္ျခင္း၏ရလဒ္",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "ယုတၱိတန္ဖိုး၏ေျပာင္းျပန္ကိုေပးသည္",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "NOT ေအာ္ပေရတာေပၚတြင္အသုံးျပဳလိုေသာတန္ဖိုး",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "NOT စစ္ဆင္ေရးရလဒ္",
  T_34_WZ_WS_LOGIC4_NAME: "ဗလာစစ္ေဆးပါ",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "ေနရပ္သည္ ဗလာ/တရားမဝင္ရွိမရွိ စစ္ေဆးပါ",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Entity",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "အနတၱကိုစစ္ေဆးရန္အဖြဲ႕အစည္း",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "ဘာဘဲျဖစ္ျဖစ္ Entity သည္ဗလာျဖစ္သည္",
  T_34_WZ_WS_LOGIC5_NAME: "အေျခေနဆိုင္ရာထုတ္ျပန္ခ်က္",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "အေျခအေနမ်ားႏွင့္ကိုက္ညီ/မကိုက္ညီသည္ျဖစ္ေဆာင္႐ြက္ေပးပါသည္.လုပ္ငန္းစဥ္ခြဲမ်ားသည္ ေနာက္ဆက္တြဲယုတၱိေဗဒအကိုင္းအခက္မ်ားႏွင့္အတူတူပင္ျဖစ္သည္.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "တန္ဖိုး",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "အေျခအေနအေရအတြက္ႏွင့္လုပ္ငန္းစဥ္ခြဲမ်ား၏ အေရအတြက္ (ေလာ့ဂ်စ္အခြဲမ်ား) သည္ တူညီရပါမည္",
  T_34_WZ_WS_LOGIC6_NAME: "ကိန္းျပည့္အပိုင္းျခားကြင္းဆက္",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "x မွ y ကို z အဆင့္ျဖင့္ဆက္ပါ။ လုပ္ငန္းစဥ္ခြဲသည္ကြင္းဆက္ျဖစ္သည္",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "ကြင္းဆက္အၫႊန္း၏အမည္ ေဒသဆိုင္ရာေျပာင္းလဲႏိုင္ေသသာကြင္းဆက္အညႊန္းတန္ဖိုးမ်ားကိုျပန္လည္ရယူရန္အသုံးျပဳသည္",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "အစတန္ဖိုး",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "ကြင္းဆက္စတင္သည့္တန္ဖိုး",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "အဆံုးတန္ဖိုး",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "ကြင္းဆက္အဆံုးသတ္သည့္တန္ဖိုး",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "အဆင့္",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "ကြင္းဆက္တစ္ခုစီရဲ႕ေျခလွမ္း. အစတန္ဖိုးသည္အဆုံးတန္ဖိုးထက္နည္းေသာအခါ၊ အဆင့္သည္ 0 ထက္ႀကီးသင့္သည္. စတင္တန္ဖိုးသည္အဆုံးတန္ဖိုးထက္ႀကီးေသာအခါ၊ အဆင့္သည္ 0 ထက္နည္းသင့္သည္.",
  T_34_WZ_WS_LOGIC7_NAME: "အရာတိုင္းကိုလွည့္ပတ္ပါ",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "၎ရွိျဒပ္ခြဲတစ္ခုစီကိုထုတ္ယူရန္ေဒတာကြန္တိန္နာတစ္ခု၏ျဖတ္သန္းမႈကိုဖြင့္ပါ. လုပ္ငန္းစဥ္ခြဲသည္ကြင္းဆက္ျဖစ္သည္.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "ျဒပ္အမည္",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "ဤအမည္သို႔ျဖတ္သြားျခင္းသည္ေဒသႏၲရေျပာင္းလဲႏိုင္ေသာအစိတ္အပိုင္းခြဲ၏တန္ဖိုးကိုထုတ္ယူပါမည္",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "ေဒတာကြန္တိန္နာ",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "ေဒတာကြန္တိန္နာကိုျဖတ္သန္းရန္. လက္ရွိပံ့ပိုးေပးသည့္စာရင္းအမ်ိဳးအစား.",
  T_34_WZ_WS_LOGIC8_NAME: "အေျခအေနကြင္းဆက္",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "အေျခအေနတစ္ခုျပည့္မီသည္အထိအေျခအေနဆိုင္ရာကြင္းဆက္တစ္ခုထပ္လုပ္သည္. အေျခအေနမွားယြင္းေသာအခါကြင္းဆက္ရပ္တန႔္မည္.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "အေျခအေန",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "အေျခအေနမွန္လွ်င္လွည့္ပတ္ၿပီး အေျခအေနသည္မွားသည္အထိမွရပ္မည္",
  T_34_WZ_WS_LOGIC9_NAME: "ကြင္းဆက္ကြဲ",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "လက္ရွိကြင္းဆက္ကိုရပ္ၿပီးကြင္းဆက္ကေနထြက္ပါ",
  T_34_Y_B_DINOSAURS: "Dinosaur Illusion (ေဘာင္းဘီ)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "နတ္သမီးစင္စစ္ (F)",
  T_34_YS_F_B_PANDACATTLE: "Moo Zoo (ေဘာင္းဘီ)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Aqua Rogue (ေဘာင္းဘီ)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Aqua Rogue (ေခါင္းေဆာင္း)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Aqua Rogue (မ်က္ႏွာပန္းခ်ီ)",
  T_34_YS_F_S_PANDACATTLE: "Moo Zoo (ဖိနပ္)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Aqua Rogue (ဖိနပ္)",
  T_34_YS_F_T_PANDACATTLE: "Moo Zoo (အကၤ်ီ)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Aqua Rogue (အကၤ်ီ)",
  T_34_YS_M_B_ANGEL_BW: "နတ္သားစင္စစ္ (M)",
  T_34_YS_M_B_PANDACATTLE: "Panda Pyjamas (ေဘာင္းဘီ)",
  T_34_YS_M_H_PANDACATTLE: "Panda Pyjamas (ေခါင္းေဆာင္း)",
  T_34_YS_M_S_PANDACATTLE: "Panda Pyjamas (ဖိနပ္)",
  T_34_YS_M_T_PANDACATTLE: "Panda Pyjamas (အကၤ်ီ)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "ရန္သူကိုေခ်မွဳန္းျခင္းျဖင့္ {0} EP ရယူပါ.",
  T_35_DY_PET_OWL_N: "ဟုစ္",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "တိရစာၦန္စကင္: Spaceship Moony",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "တိရစာၦန္စကင္: Azulcrema Trace Zasil",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "တိရစာၦန္စကင္: သိမ္းငွက္ျပာ",
  T_35_DY_PETSKIN_OWL_FIRE_N: "တိရစာၦန္စကင္: ဟုစ္အဆင့္ျမင့္စကင္",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "တိရစာၦန္စကင္: ညဇီးကြက္ဟုစ္",
  T_35_DY_PETSKIN_OWL_STORM_N: "တိရစာၦန္စကင္: ေရခဲဟုစ္",
  T_35_JL_KNOCKEDDOWN: "က်သြားသည္",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "စြမ္းရည္ထြက္ျပီး {1}s ေနာက္အတြင္း, စြမ္းရည္သံုးသူသည္ အိုက္စ္၏ {3}m အတြင္းရန္သူမွတ္ရန္အိုက္စ္ေဝါကိုေအာင္ျမင္စြာပစ္ႏိုင္သည္. အိုက္စ္ေဝါကိုထိုးေဖာက္ျပီးရန္သူကိုပ်က္စီးမွဳျဖစ္ေစသည္(ထိခိုက္မွဳသည္ပံုမွန္ထက္နည္းမည္). အမ်ားဆံုး {0} အိုက္စ္ေဝါသို႔သက္ေရာက္သည္. CD: {2}s.",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "နံရံတိုက္ပြဲ",
  T_35_KY_INFECTION_MAPNAME: "စြန္႔ပစ္နယ္ေျမ",
  T_35_M_WS_BUTTONCLICKDESC: "သက္ဆိုင္သည့္ခလုတ္ကိုႏွိပ္လိုက္သည့္အခါဤအျဖစ္ပ်က္စတင္သည္. အစပ်ိဳးကစားသမားသည္ကန္႔သတ္ခ်က္သံုးျပီးရရွိႏိုင္သည္.",
  T_35_M_WS_GETTEAMMATEPOS: "အနီးရွိအသင္းေဖာ္တည္ေနရာရရွိသည္",
  T_35_M_WS_ROUND2: "လက္ရွိလွိဳင္း",
  T_35_PD_Infection_HUMANSELECT: "လက္နက္ေရြးပါ",
  T_35_PD_INFECTION_MODENAME: "Droid Apocalypse",
  T_35_QX_WS_ICONTYPE_ITEM: "အရာဝတၳဳ",
  T_35_QX_WS_ICONTYPE_NATURE: "သဘာဝ၏ရုပ္ပံု",
  T_35_QX_WS_ICONTYPE_SHAPE: "ဂ်ီၾသေမၾတီ",
  T_35_QX_WS_ICONTYPE_SYMBOL: "သေကၤတ",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "လက္နက္",
  T_35_R_EMOTE_TAG_MUSIC_N: "ဂီတ",
  T_35_RW_SKILL_DESC_Singers: "{0}m အတြင္းရွိမဟာမိတ္ႏွင့္စြမ္းရည္သံုးသူသည္ EP သံုးျပီး {1}% ပ်က္စီးမွဳတားဆီးႏိုင္သည္. ထို႔ေၾကာင့္မဟာမိတ္ထံမွ EP ႏွဳတ္ယူျခင္းသည္ အသံုးျပဳသူ EP စြမ္းရည္ကိုထည့္ေပါင္းေပးမည္.",
  T_35_RW_SKILL_NAME_Singers: "အသံတိတ္အေစာင့္",
  T_35_SP_WS_COMMENTKEY_01: "အသင့္တင့္အခက္အခဲ",
  T_35_SP_WS_COMMENTKEY_02: "ၾကံဆမွဳေကာင္း",
  T_35_SP_WS_COMMENTKEY_03: "စိတ္ဝင္စားဖြယ္ဂိမ္းကစားပံု",
  T_35_SP_WS_COMMENTKEY_04: "ထပ္ခါထပ္ခါကစားႏိုင္သည္",
  T_35_SP_WS_COMMENTKEY_05: "ဆန္းၾကယ္ေသာဇာတ္လမ္း",
  T_35_SP_WS_COMMENTKEY_06: "အလြန္ေကာင္းေသာဟန္ခ်က္",
  T_35_SP_WS_COMMENTKEY_07: "ၾကည္ႏူးစရာအေတြ႕အၾကံဳ",
  T_35_SP_WS_COMMENTKEY_08: "အဆင္ေျပသည္",
  T_35_SP_WS_COMMENTKEY_09: "ၾကည္ႏူးစရာ",
  T_35_SP_WS_COMMENTKEY_10: "ခက္ခဲလြန္းသည္",
  T_35_SP_WS_COMMENTKEY_11: "လြယ္လြန္းတယ္",
  T_35_SP_WS_COMMENTKEY_12: "ပ်င္းစရာေကာင္း",
  T_35_SP_WS_COMMENTKEY_13: "ရွည္လြန္းသည္",
  T_35_SP_WS_COMMENTKEY_14: "ဟန္ခ်က္မညီမွ်",
  T_35_SP_WS_COMMENTKEY_15: "မၾကည္ႏူးစရာအေတြ႕အၾကံဳ",
  T_35_SP_WS_IMAGE03: "အေသြးအေရာင္",
  T_35_SP_WS_IMAGE04: "ေဘာင္",
  T_35_SY_CHARGESHOT_TEARS_N: "Charge Buster- Lava Lustre",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "ဗံုး- Crystal Eerie",
  T_35_SY_GRENADE_PIRATES_N: "ဗံုး- Rowdy Searuler",
  T_35_SY_GRENADE_RIDERS_N: "ဗံုး- Grim Rider",
  T_35_SY_M24_KUN_N: "M24- Riverdust Splasher",
  T_35_SY_SCAR_PARKOUR_N: "SCAR- Gusto Freerunner",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "ဂ်စ္ကား- Monochrome Jigsaw",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "ဂုဏ္ျပဳပြဲကိုဆင္ႏႊဲပါ!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "ဆိုင္ကယ္- Crystal Symmetry",
  T_35_WT_WS_PREFAB_MENUBAR_1: "ဖြဲ႕စည္းပံုအလွဆင္",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "ဖြဲ႕စည္းပံုမ်ား",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "အျခား",
  T_35_WT_WS_PREFAB_MENUBAR_2: "ဗိသုကာပညာ",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "အိမ္ၾကီး",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "အလယ္လတ္အိမ္မ်ား",
  T_35_WT_WS_PREFAB_MENUBAR_3: "ဂိမ္းကစားအရာဝတၳဳမ်ား",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "အေရးၾကီးမုဒ္မ်ား",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "ဂီတ",
  T_35_WT_WS_PVEMODE_TAG: "ရွင္သန္ေရးမုဒ္",
  T_35_WZY_WS_BECRE_NAMEDESC: "ဤ Entity ဖန္တီးျပီးေသာအခါအစပ်ိဳးသည္",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'ဤ Entity ဖယ္ရွားျပီးေသာအခါအစပ်ိဳးသည္. တိုက္ခိုက္မွဳအရင္းျမစ္သည္ "Trigger Entity" အသံုးျပဳေဖာ္ထုတ္ႏိုင္ျပီး တိုက္ခိုက္မွဳအမ်ိဳးအစားသည္ "Damage Type" ကိုသံုးျပီးေဖာ္ထုတ္ႏိုင္သည္.',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "ျဖစ္ရပ္အစပ်ိဳးသည့္ Entity",
  T_35_WZY_WS_CREPROP_NAMEDESC: "သတ္မွတ္တည္ေနရာမွာအိုင္တန္အစံု သို႔ အိုင္တန္အမ်ိဳးအစားဖန္တီးပါ. အိုင္တန္အမ်ိဳးစားတစ္ခုဖန္တီးေသာအခါ, အိုင္တန္အေရအတြက္သည္အသံုးျပဳအာေရးပမာဏသံုးျပီးစီစဥ္သတ္မွတ္ႏိုင္ျပီး ဖန္တီးအိုင္တန္မ်ားသည္ေျမပံုယူနစ္ေပၚမူတည္လိမ့္မည္.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "ဖန္တီးရမည့္အိုင္တန္ပါဝင္သည့္စာရင္း. အိုင္တန္တစ္ခုတည္းပါဝင္သည္လည္းျဖစ္ႏိုင္သည္.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "အိုင္တန္စာရင္းသို႔သက္ဆိုင္သည့္စာရင္းပမာဏ. အိုင္တန္အမ်ိဳးစားပမာဏတစ္ခုသာပါဝင္သည္.",
  T_35_WZY_WS_DAMTYPE_CAR: "ယာဥ္",
  T_35_WZY_WS_DAMTYPE_FALL: "ျပဳတ္က်သည္",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "ေသနတ္",
  T_35_WZY_WS_DAMTYPE_GRENADE: "ဗံုး",
  T_35_WZY_WS_DAMTYPE_MELEE: "မီလီ",
  T_35_WZY_WS_DAMTYPE_ZONE: "ဇုန္ျပင္ပ",
  T_35_WZY_WS_DELPROP_NAMEDESC: "ေပးထားသည့္ကစားသမားမွပစၥည္းအေရတြက္ကိုဖယ္ရွားသည္",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "အစပ်ိဳးဧရိယာထည့္ပါ",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'အစပ်ိဳးဧရိယာဝင္ေသာအခါ "Trigger Entity" သည္အစပ်ိဳးသည္',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "Entity ရရွိေသာကစားသမားသည္. ကစားသမားႏွင့္ခ်ိတ္ျပီးေသာအခါ၊ entity's အခ်က္အလက္သည္ထိုကစားသမားအတြက္သာအပ္ဒိတ္ျဖစ္လိမ့္မည္. ခ်ိတ္ထားေသာကစားသမားမရွိေသာအခါ၊ ကစားသမားအားလံုးသည္ Entity အခ်က္လက္လက္ခံရလိမ့္မည္.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "တိုက္ပြဲ Entity",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "အရာဝတၳဳအားလံုး၏အထူးအမ်ိဳးအစားကိုရယူပါ. ျပန္လာရလဒ္သည္စာရင္းတြင္ရွိသည္.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "အရာဝတၳဳအမ်ိဳးအစား",
  T_35_WZY_WS_HUDWIDGET_NAME: "ထိန္းခ်ဳပ္ UI",
  T_35_WZY_WS_HURT_NAMEDESC: 'Entity ပ်က္စီးမွဳယူေသာအခါအစပ်ိဳးသည္. ပ်က္စီးမွဳ၏အရင္းျမစ္ "Trigger Entity" စစ္ေဆးျခင္းျဖင့္ေဖာ္ထုတ္ေနသည္.',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "အိုင္တန္၏အမ်ိဳးအစား",
  T_35_WZY_WS_LEVELOBJECT_NAME: "စင္ျမင့္အရာဝတၳဳ",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'ဤ Entity မွ အျခား Entity ကိုဖယ္ရွားေသာအခါအစပ်ိဳးသည္. ဖယ္ရွားခံရသည့္ Entity အမ်ိဳးအစားသည္ "Eliminated Entity" သံုးျပီးေဖာ္ထုတ္ႏိုင္ပါသည္.',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "ဖယ္ရွားျပီးသည့္ Entity",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Entity ပ်က္စီးမွဳျဖစ္ေစတဲ့အခါအစပ်ိဳးသည္",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "ပ်က္စီးမွဳထုတ္သည့္ Entity",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "ပ်က္စီးမွဳ Entity",
  T_35_WZY_WS_PREFABID_NAME: "နမူနာပံုစံ ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "လက္ရွိ EP",
  T_35_WZY_WS_PROPERTY_JUMP: "အခုန္အျမင့္",
  T_35_WZY_WS_QUITTRIGGER_NAME: "အစပ်ိဳးဧရိယာထြက္မည္",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'အစပ်ိဳးဧရိယာမွထြက္ေသာအခါ "Trigger Entity" သည္အစပ်ိဳးသည္',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "စာရင္းမွသတ္မွတ္အရာကိုဖယ္ထုတ္ပါ. [List] သည္အရာရွိသည့္စာရင္းျဖစ္သည္. [Element] သည္ဖယ္ထုတ္ရမည့္အရာျဖစ္သည္.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "အရာဝတၳဳတန္ဖိုး",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "ဖ်က္ပစ္ရမည့္အရာ၏တန္ဖိုး",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Entity အလွည့္",
  T_35_WZY_WS_TOWER_PARAM1: "ေမွ်ာ္စင္ ႏွင့္ ခံတပ္ျမိဳ႕",
  T_35_WZY_WS_TOWER_PARAM2: "အသင္း ID",
  T_35_WZY_WS_TOWER_PARAM3: "လက္ရွိ HP",
  T_35_WZY_WS_TOWER_PARAM4: "အမ်ားဆံုး. HP",
  T_35_WZY_WS_TOWER_PARAM5: "ပ်က္စီးမွဳ",
  T_35_WZY_WS_TOWER_PARAM6: "ၾကားျဖတ္တိုက္ခိုက္မွဳ",
  T_35_WZY_WS_TOWER_PARAM7: "တိုက္ခိုက္မွဳအကြာအေဝး",
  T_35_WZY_WS_TOWER_PARAM8: "ခုခံမွဳ %",
  T_35_XYL_PDM_REVENGE: "လက္စားေခ်",
  T_35_XYL_WS_BISPARTERRE: "ဂရပ္ဖက္တီပန္းအိပ္ရာ",
  T_35_XYL_WS_BISPARTERRE_DESC: "စတိုက္က်က်တိုက္ပြဲပံုေက်ာက္ပန္းခင္း",
  T_35_XYL_WS_BISWALL: "ဂရပ္ဖစ္တီနံရံ",
  T_35_XYL_WS_BISWALL_DESC: "ေပါင္းစည္းႏိုင္တဲ့စတိုင္က်က်တိုက္ပြဲပံု",
  T_35_XYL_WS_BOTDROP: "အဖြင့္/ပိတ္ သိုေလွာင္မွဳ",
  T_35_XYL_WS_CUSTOMTRIGGER: "Custom trigger",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "ကစားသမားမွအသက္သြင္းေသာအခါစိတ္ၾကိဳက္အထူးအက္ဖက္အစပ်ိဳးသည့္အရာဝတၳဳကိုထားပါ. အက္ဖက္သည္စာမူတြင္ျပင္ဆင္သတ္မွတ္ရမည္. (စိတ္ၾကိဳက္ဖန္တီးမုဒ္တြင္သာရမည္.)",
  T_35_XYL_WS_DOUBLEDOOR: "ဂိတ္",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "အက္ကြဲေနေသာတံခါး",
  T_35_XYL_WS_RESET: "အလွည့္တိုင္းျပန္စပါ",
  T_35_XYL_WS_RESETN: "No",
  T_35_XYL_WS_RESETY: "Yes",
  T_35_XYL_WS_ROADBLOCK: "လမ္းပိတ္ဆို႔မွဳ",
  T_35_XYL_WS_ROADBLOCK_DESC: "ျဖတ္သန္းျခင္းမွတားဆီးထားသည္",
  T_35_XYL_WS_STAIRS: "ေလွကားမ်ား",
  T_35_XYL_WS_STAIRS_DESC: "ဆင္းသက္ျခင္းႏွင့္ေပါင္းစည္းႏိုင္သည့္ေလွကားမ်ား",
  T_35_XYL_WS_STAIRSL: "ဂိတ္ B",
  T_35_XYL_WS_STAIRSL_DESC: "ေလွကားထစ္ႏွင့္ေပါင္းစည္းႏိုင္ေသာပလက္ေဖာင္း",
  T_35_XYL_WS_STAIRSZ: "ဂိတ္ A",
  T_35_XYL_WS_STAIRSZ_DESC: "ေလွကားထစ္ႏွင့္ေပါင္းစည္းႏိုင္ေသာပလက္ေဖာင္း",
  T_35_XYL_WS_TBOOTH: "ဖုန္းဆိုင္",
  T_35_XYL_WS_TBOOTH_DESC: "လမ္းေတြေပၚမွာေတြ႕ရမ်ားတယ္",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "သိမ္းငွက္ျပာ",
  T_35_YS_A_CUBBY: "ဝက္ဝံမ်က္ႏွာဖံုး",
  T_35_YS_F_A_PANTOMIME: "Two-toned Grief (မ်က္ႏွာဖံုး)",
  T_35_YS_F_A_RIDERS: "Fatal Rider (မ်က္ႏွာဖံုး)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Beauty Reuniter (ေဘာင္းဘီ)",
  T_35_YS_F_B_GOLDCHAIN: "Armor of Riches (ေဘာင္းဘီ)",
  T_35_YS_F_B_PANTOMIME: "Two-toned Grief (ေဘာင္းဘီ)",
  T_35_YS_F_B_RIDERS: "Fatal Rider (ေဘာင္းဘီ)",
  T_35_YS_F_H_BEAR_HW: "ဝက္ဝံဦးထုပ္",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Beauty Reuniter (ေခါင္းေဆာင္း)",
  T_35_YS_F_H_GOLDCHAIN: "Armor of Riches (ေခါင္းေဆာင္း)",
  T_35_YS_F_H_PANTOMIME: "Two-toned Grief (ေခါင္းေဆာင္း)",
  T_35_YS_F_H_RIDERS: "Fatal Rider (ေခါင္းေဆာင္း)",
  T_35_YS_F_HA_GOLDCHAIN: "Armor of Riches (မ်က္ႏွာပန္းခ်ီ)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Beauty Reuniter (ဖိနပ္)",
  T_35_YS_F_S_GOLDCHAIN: "Armor of Riches (ဖိနပ္)",
  T_35_YS_F_S_PANTOMIME: "Two-toned Grief (ဖိနပ္)",
  T_35_YS_F_S_RIDERS: "Fatal Rider (ဖိနပ္)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Beauty Reuniter (အကၤ်ီ)",
  T_35_YS_F_T_GOLDCHAIN: "Armor of Riches (အကၤ်ီ)",
  T_35_YS_F_T_PANTOMIME: "Two-toned Grief (အကၤ်ီ)",
  T_35_YS_F_T_RIDERS: "Fatal Rider (အကၤ်ီ)",
  T_35_YS_ITEM_SUPERFAK: "စူပါေဆး",
  T_35_YS_M_A_GOLDCHAIN: "Chainz of Lux (မ်က္ႏွာဖံုး)",
  T_35_YS_M_A_RIDERS: "Grim Rider (မ်က္ႏွာဖံုး)",
  T_35_YS_M_B_GOLDCHAIN: "Chainz of Lux (ေဘာင္းဘီ)",
  T_35_YS_M_B_RIDERS: "Grim Rider (ေဘာင္းဘီ)",
  T_35_YS_M_H_BEAR_HW: "ဝက္ဝံဦးထုပ္",
  T_35_YS_M_H_GOLDCHAIN: "Chainz of Lux (ေခါင္းေဆာင္း)",
  T_35_YS_M_H_RIDERS: "Grim Rider (ေခါင္းေဆာင္း)",
  T_35_YS_M_S_GOLDCHAIN: "Chainz of Lux (ဖိနပ္)",
  T_35_YS_M_S_RIDERS: "Grim Rider (ဖိနပ္)",
  T_35_YS_M_T_GOLDCHAIN: "Chainz of Lux (အကၤ်ီ)",
  T_35_YS_M_T_RIDERS: "Grim Rider (အကၤ်ီ)",
  T_35_YS_T_CHAMPION: "ခ်န္ပီယံအကၤ်ီ",
  T_35_YS_T_PAINTING: "Squeeze Tee",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "ကစားပြဲစေသာအခါဒဂၤါးရရွိသည္",
  T_36_JH_WS_CESAYCLOSE: "စနစ္ကိုသူ႔အလိုလို ဖြင့္/ပိတ္ လုပ္မလား",
  T_36_JH_WS_CHOOSEEDITSHOP: "တည္းျဖတ္ရန္စတိုးေရြးပါ",
  T_36_JH_WS_CHOOSESHOP: "စတိုးေရြးပါ",
  T_36_JH_WS_COINCOUNT: "ေငြေၾကးပမာဏ",
  T_36_JH_WS_COINHUD: "ဒဂၤါးပမာဏျပသမည္?",
  T_36_JH_WS_CRAFTSHOP: "စတိုးတည္းျဖတ္",
  T_36_JH_WS_CREATEGOLD: "ဒဂၤါးထုတ္လုပ္သူ",
  T_36_JH_WS_CSHOPENTITY: "ေစ်းဆိုင္ Entity ေပါင္းပါ",
  T_36_JH_WS_CSHOPHUD: "ေစ်းဆိုင္မ်က္ႏွာျပင္",
  T_36_JH_WS_CURRENTLIMIT: "က်န္ရွိဝယ္ယူကန္႔သတ္ခ်က္",
  T_36_JH_WS_ECONOMIC: "စီးပြားေရး",
  T_36_JH_WS_INGAMEECONOMI: "ဂိမ္းစီးပြားေရး",
  T_36_JH_WS_ITEMINDEXID: "ကုန္ပစၥည္းနံပါတ္",
  T_36_JH_WS_KILLMONEY: "ႏွိမ္နင္းျခင္းအတြက္ဒဂၤါးရရွိသည္",
  T_36_JH_WS_KILLMONEYTIP: "Rush မုဒ္ႏွင့္ခံႏိုင္ရည္မုဒ္တြင္ဖုတ္ေကာင္မ်ားကိုဖယ္ရွားရန္အတြက္ရရွိရန္ဒဂၤါးပမာဏ",
  T_36_JH_WS_LISTINDEX: "ကုန္ပစၥည္းအမ်ိဳးအစားမ်ားစာရင္း",
  T_36_JH_WS_NULL: "ဗလာ",
  T_36_JH_WS_NUMBER: "ပမာဏ",
  T_36_JH_WS_OPTIONNAME: "Droid Apocalypses အထူးသီးသန္႔မုဒ္",
  T_36_JH_WS_REALSHOPENTITY: "ေစ်းဆိုင္ Entity",
  T_36_JH_WS_SEEORHIDE: "အေရာင္းစက္ျပသပါ",
  T_36_JH_WS_SHOPFRONT: "စတိုး",
  T_36_JH_WS_SHOPITEMLIST: "ကုန္ပစၥည္းအမ်ိဳးအစား",
  T_36_JH_WS_SHOPOPENCON: "အဖြင့္အေျခေန",
  T_36_JH_WS_SSHOPNAME: "စတိုးအမည္",
  T_36_JH_WS_TOTALLIMIT: "ဝယ္ယူႏွဳန္းကန္႔သတ္ခ်က္",
  T_36_JH_WS_TRIGGERWIDE: "အစပ်ိဳးအကြာအေဝး",
  T_36_JH_WS_VENDMACHINE: "အေရာင္းစက္",
  T_36_JH_WS_WINMONEY: "ေအာင္ျမင္ျခင္းအတြက္ဒဂၤါးရရွိသည္",
  T_36_JH_WS_WORTH: "တန္ဖိုးရွိသည္",
  T_36_JL_FOREGRIP_MR_N: "Marksman Foregrip",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "ေသနတ္ပစ္စေတာ့ခ္",
  T_36_JL_STOCK_SR_N: "စႏိုက္ပါစေတာ့ခ္",
  T_36_KK_WS_MONTSTERDES: "4 ေယာက္စီးထရပ္ကားသည္တာရွည္ခံၿပီးၾကမ္းတမ္းနယ္ေျမမ်ားကိုသြားလာႏိုင္သည္.",
  T_36_M_WS_SETTEMPVAR: "ယာယီေျပာင္းလဲမွဳသတ္မွတ္ပါ",
  T_36_M_WS_TEMPVAR: "ယာယီေျပာင္းလဲမွဳ",
  T_36_SY_AK47_MAMBAS_N: "AK47- Mamba Gnaw",
  T_36_SY_AN94_MAMBAS_N: "AN94- Mamba Gnaw",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher- Mamba Gnaw",
  T_36_SY_AUG_MAMBAS_N: "AUG- Mamba Gnaw",
  T_36_SY_AWM_MAMBAS_N: "AWM- Mamba Gnaw",
  T_36_SY_BLT_MAMBAS_N: "M82B- Mamba Gnaw",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Charge Buster- Mamba Gnaw",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle- Mamba Gnaw",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS- Mamba Gnaw",
  T_36_SY_G18_MAMBAS_N: "G18- Mamba Gnaw",
  T_36_SY_G36_MAMBAS_N: "G36- Mamba Gnaw",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "ဗံုး- Navy Festivity",
  T_36_SY_GROZA_MAMBAS_N: "Groza- Mamba Gnaw",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Hand Cannon- Mamba Gnaw",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "ကုသေရးစႏိုက္ဘာ- Mamba Gnaw",
  T_36_SY_ICE_GUN_MAMBAS_N: "Ice Gun- Mamba Gnaw",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k- Mamba Gnaw",
  T_36_SY_KORD_MAMBAS_N: "Kord- Mamba Gnaw",
  T_36_SY_M1014_MAMBAS_N: "M1014- Mamba Gnaw",
  T_36_SY_M14_MAMBAS_N: "M14- Mamba Gnaw",
  T_36_SY_M1873_MAMBAS_N: "M1873- Mamba Gnaw",
  T_36_SY_M1887_MAMBAS_N: "M1887- Mamba Gnaw",
  T_36_SY_M1917_MAMBAS_N: "M1917- Mamba Gnaw",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker- Mamba Gnaw",
  T_36_SY_M24_MAMBAS_N: "M24- Mamba Gnaw",
  T_36_SY_M249_MAMBAS_N: "M249- Mamba Gnaw",
  T_36_SY_M4A1_MAMBAS_N: "M4A1- Mamba Gnaw",
  T_36_SY_M500_MAMBAS_N: "M500- Mamba Gnaw",
  T_36_SY_M60_MAMBAS_N: "M60- Mamba Gnaw",
  T_36_SY_M79_MAMBAS_N: "M79- Mamba Gnaw",
  T_36_SY_MAC10_MAMBAS_N: "MAC10- Mamba Gnaw",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7- Mamba Gnaw",
  T_36_SY_MINI_MAMBAS_N: "AC80- Mamba Gnaw",
  T_36_SY_MP40_MAMBAS_N: "MP40- Mamba Gnaw",
  T_36_SY_MP5_MAMBAS_N: "MP5- Mamba Gnaw",
  T_36_SY_P90_MAMBAS_N: "P90- Mamba Gnaw",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL- Mamba Gnaw",
  T_36_SY_PP19_MAMBAS_N: "Bizon- Mamba Gnaw",
  T_36_SY_PP19_POLICEMAN_N: "Bizon- Wraith Patrol",
  T_36_SY_SCAR_MAMBAS_N: "SCAR- Mamba Gnaw",
  T_36_SY_SKS_MAMBAS_N: "SKS- Mamba Gnaw",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12- Mamba Gnaw",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA- Mamba Gnaw",
  T_36_SY_SVD_MAMBAS_N: "SVD- Mamba Gnaw",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson- Mamba Gnaw",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "ဓါး- Mamba Dagger",
  T_36_SY_THROWINGKNIFE_MENA_N: "Boho Dagger- ဓါး",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Treatment Pistol- Mamba Gnaw",
  T_36_SY_UMP45_MAMBAS_N: "UMP- Mamba Gnaw",
  T_36_SY_USP45_MAMBAS_N: "USP- Mamba Gnaw",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi- Mamba Gnaw",
  T_36_SY_VECTOR_MAMBAS_N: "Vector- Mamba Gnaw",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "ထရပ္ကား- Blinding Gold",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "ဆိုင္ကယ္- Spectral Ride",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "ျပိဳင္ကား- Speed Acer",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "တုတ္တုတ္- Netherworld Ride",
  T_36_SY_VSS_MAMBAS_N: "VSS- Mamba Gnaw",
  T_36_SY_XM8_MAMBAS_N: "XM8- Mamba Gnaw",
  T_36_WZY_AFTERACCUMULATOR: "ေနာက္ေၾကာင္းကိုတြက္ပါ",
  T_36_WZY_AVAILAB: "ဖြင့္ထားသည္",
  T_36_WZY_BACKANDFORTH: "အသြားျပန္ခရီး",
  T_36_WZY_BASEMULTIPLIER: "အေျခခံအေျမာက္",
  T_36_WZY_BASIC: "အေျခခံအမ်ိဳးအစား",
  T_36_WZY_BEFORACCUMULATOR: "ေရွ႕တြက္ခ်က္မွဳ",
  T_36_WZY_CYLIC: "စက္ဝိုင္း-ေနာက္ျပန္",
  T_36_WZY_GUNPRO_PARAM1: "မူလပ်က္စီးအား",
  T_36_WZY_GUNPRO_PARAM10: "က်ည္စတင္ပ်ံ႕ႏွံ႔လာသည္",
  T_36_WZY_GUNPRO_PARAM11: "အမ်ားဆံုးပ်ံ႕သည့္ဧရိယာ",
  T_36_WZY_GUNPRO_PARAM12: "ေပါက္ကြဲမွဳ",
  T_36_WZY_GUNPRO_PARAM2: "က်ည္ကန္႔တြင္က်ည္ဆံရွိသည္",
  T_36_WZY_GUNPRO_PARAM3: "ကနဦးမဂၢဇင္းနံပါတ္",
  T_36_WZY_GUNPRO_PARAM4: "ပစ္ခတ္မွဳၾကားကာလ",
  T_36_WZY_GUNPRO_PARAM7: "အျမင့္ဆံုးအပ်က္စီးအတြက္အကြာအေဝး",
  T_36_WZY_GUNPRO_PARAM8: "မိနစ္ပ်က္စီးမွဳအတြက္အကြာအေဝး",
  T_36_WZY_GUNPRO_PARAM9: "အနည္းဆံုးပ်က္စီးမွဳ",
  T_36_WZY_MULTIPLIR: "အေျမာက္",
  T_36_WZY_PRICE: "ေစ်းႏွဳန္း",
  T_36_WZY_SUMMULTIPLIER: "အေျမာက္ဂဏန္းတြက္စက္",
  T_36_WZY_WS_3DZOOM: "3D Zoom",
  T_36_WZY_WS_ABSRES: "ပကတိတန္ဖိုးရလဒ္",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "[ရင္းျမစ္စာရင္း] မွအစိတ္အပိုင္းအားလုံးကို [ပစ္မွတ္စာရင္း] ေအာက္ေျခသို႔ထည့္ပါ",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "ျဒပ္စင္မ်ားထည့္ရန္ပစ္မွတ္စာရင္း",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "ထည့္ရမည့္အစိတ္အပိုင္းမ်ားပါရွိေသာအရင္းအျမစ္စာရင္း",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "သတ္မွတ္ပိုက္ဆံအိတ္ထဲသို႔သတ္မွတ္ေငြေၾကးပမာဏအခ်ိဳ႕ထည့္ပါ",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "ပိုက္ဆံအိတ္",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "ပိုက္ဆံအိတ္ထဲသို႔ ေငြေၾကးထည့္ရန္",
  T_36_WZY_WS_ADDSUB: "တန္ဖိုး ထည့္ သို႔ ႏွဳတ္ပါ",
  T_36_WZY_WS_AIENTITY: "AI entity",
  T_36_WZY_WS_ALLSHOP_DESC: "စတိုး entities မ်ားပါေသာစာရင္း",
  T_36_WZY_WS_ANGLE_DESC: "ေထာင့္တိုင္းတာျခင္း",
  T_36_WZY_WS_ANYTYPE: "မည္သည့္အမ်ိဳးစား",
  T_36_WZY_WS_ARILEFT: "စစ္ဆင္ေရးမွက်န္ရွိတန္ဖိုး",
  T_36_WZY_WS_ARIRES: "စြမ္းေဆာင္ရည္",
  T_36_WZY_WS_ARIRIGHT: "စစ္ဆင္ေရးတြင္မွန္ကန္ေသာတန္ဖိုး",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 ဂဏန္းသခၤ်ာလုပ္ငန္းမ်ား",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "အေျခခံကိန္းျပည့္လည္ပတ္မႈမ်ားသည္ေပါင္းျခင္း၊ ႏုတ္ျခင္း၊ ေျမႇာက္ျခင္း၊ စားျခင္းႏွင့္အႂကြင္းတို႔ကိုပံ့ပိုးေပးသည္. Float လုပ္ေဆာင္ခ်က္မ်ားသည္ေပါင္းျခင္း၊ ႏုတ္ျခင္း၊ အေျမႇာက္ႏွင့္ ပိုင္းျခင္းကိုပံ့ပိုးေပးသည္.",
  T_36_WZY_WS_ARRAY_DESC: "ပစ္မွတ္စာရင္း",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "စာရင္းတစ္ခုတြင္သတ္မွတ္ထားေသာျဒပ္စင္ပါရွိမရွိစစ္ေဆးပါ. အျပန္တန္ဖိုးသည္ Boolean ျဖစ္သည္.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "သတ္မွတ္ထားေသာစာရင္း",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "စာရင္းတြင္ရွာေဖြရမည့္အရာ",
  T_36_WZY_WS_ARRCONELERES: "စာရင္းတစ္ခုတြင္သတ္မွတ္ထားေသာျဒပ္စင္တစ္ခုရွိမရွိ၏ရလဒ္. တန္ဖိုးသည္ Boolean ျဖစ္သည္.",
  T_36_WZY_WS_ATTACK: "လွည့္ကင္းႏွင့္တိုက္ခိုက္မွဳ",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "ကစားသမားလဲက်ေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_BIGFLOAT: "ဒႆမႀကီး",
  T_36_WZY_WS_BIGTOYBALL: "အန္စာတံုး",
  T_36_WZY_WS_BOOLLIST: "Boolean စာရမ္း",
  T_36_WZY_WS_CEIL_NAME_DESC: "အငယ္ဆုံးကိန္းျပည့္ကိုသူ႔ထက္ႀကီးေသာတန္ဖိုးသို႔လွည့္ပါ",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "တန္ဖိုးစုစည္းရန္",
  T_36_WZY_WS_CEILRES: "အလွည့္တက္ရလဒ္",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "ေ႐ြးခ်ယ္ထားေသာ AI သည္အကြာအေဝးမခြဲျခားဘဲဤအရာအားလိုက္ရွာမည္ျဖစ္သည္. [Chased entity] သည္မည္သည့္မဆိုျဖစ္ႏိုင္သည္. [Chased entity] တြင္ HP ပိုင္ဆိုင္မႈမရွိေသာအခါ၊ ထို႔ေနာက္ AI entity သည္မည္သည့္ပ်က္စီးမႈကိုမွ်မထိခိုက္ေစပါ.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "လိုက္ဖမ္းေနသည့္ Entity",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "လိုက္ဖမ္းေနသည့္ပစ္မွတ္ Entity. မည္သည့္ Entity ျဖစ္ျဖစ္ရသည္.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "အရာဝတၳဳမ်ားကိုပုံတူပြားျခင္းအတြက္နမူနာပုံစံ. ကာဆာသံုးျပီးေရြးပါ. ပံုတူ၏စာမူႏွင့္ပိုင္ဆိုင္မွဳသည္ေရြးထားေသာအရာႏွင့္တူလိမ့္မည္.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "ပုံတူပြားရမည့္အရာဝတၳဳ",
  T_36_WZY_WS_CONDITION: "အေျခေန",
  T_36_WZY_WS_CONDITIONLIST: "အေျခေနစာရင္း",
  T_36_WZY_WS_CONOFHUD: "ထိန္းခ်ဳပ္မႈတြင္ရွိေသာ HUD အေၾကာင္းအရာ",
  T_36_WZY_WS_CONTROL_DESC: "ထိန္းခ်ဳပ္မွဳ၏တစ္ခုတည္းေသာအညႊန္း",
  T_36_WZY_WS_COS_NAMEDESC: "ေထာင့္၏ cosine ကိုရွာပါ",
  T_36_WZY_WS_COSRES: "ေထာင့္၏ကိုဆိုင္း",
  T_36_WZY_WS_CREABLEOB: "ဖန္တီးႏိုင္ေသာအရာဝတၳဳ",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "သတ္မွတ္တည္ေနရာမွာအရာဝတၳဳ Entity ဖန္တီးပါ (အစမ္းဗားရွင္း)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "ဖန္တီးမည့္အရာဝတၳဳ၏ၾသဒိနိတ္မ်ား",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "ဖန္တီးရမည့္အရာဝတၳဳအမ်ိဳးအစား",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "ဖန္တီးရမည့္အရာဝတၳဳ၏ entity",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "ေငြေၾကး",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "ကုန္ပစၥည္း Entity",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "ကုန္ပစၥည္း Entity ဖန္တီးပါ",
  T_36_WZY_WS_CREWALL_NAMEDESC: "ပိုက္ဆံအိတ္ Entity ဖန္တီးပါ. [Bind player] သည္ဤပိုက္ဆံအိတ္ကိုျမင္ႏိုင္ေသာ ကစားသမားျဖစ္သည္. [Owner] သည္ပိုက္ဆံအိတ္ပိုင္ဆိုင္သည့္ကစားသမားျဖစ္သည္. ပိုက္ဆံအိတ္ရွိႏွင့္ၿပီးပါကမမွန္ကန္ပါ.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "ကစားသမားေပါင္းပါ",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "ပိုက္ဆံအိတ္ကိုျမင္ႏိုင္ေသာကစားသမား. ဆက္တင္မ်ားကိုျပင္ဆင္သတ္မွတ္မထားပါက၊ ပိုက္ဆံအိတ္ကိုအားလုံးျမင္ႏိုင္မည္ျဖစ္သည္.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "ပိုက္ဆံအိတ္၏ပိုင္ရွင္",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "ပိုက္ဆံအိတ္ Entity",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "ဖန္တီးထားသည့္ပိုက္ဆံအိတ္ Entity",
  T_36_WZY_WS_CURRAMT: "ေငြေၾကးပမာဏ",
  T_36_WZY_WS_DATA_TYPE1: "ထည့္ျပီးသည့္ေဘာင္",
  T_36_WZY_WS_DATA_TYPE2: "အေျခခံႏွင့္ယုတၱိေဗဒတြက္ခ်က္မႈ",
  T_36_WZY_WS_DATA_TYPE3: "ျခယ္လွယ္ျခင္းစာရင္း",
  T_36_WZY_WS_DATA_TYPE4: "ဗက္တာတြက္ခ်က္ျခင္း",
  T_36_WZY_WS_DESTITEM_NAME: "ကစားသမားအိုင္တန္ကိုဖ်က္ပါ",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "သတ္မွတ္ထားသည့္ကစားသမားအတြက္သတ္မွတ္အိုင္တန္အမ်ိဳးစားကိုဖ်က္ဆီးပါ",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "ဖ်က္ဆီးလို႔ရသည့္အိုင္တန္မွာ လက္နက္မ်ား, က်ည္ကာႏွင့္အေဆာင္းမ်ားျဖစ္သည္",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "ေ႐ြးခ်ယ္ထားေသာအရာအမ်ိဳးအစား၏အကြက္အၫႊန္း. လက္နက္အၫႊန္းကိန္းသည္ [1,3] ျဖစ္ၿပီးမူရင္းအတိုင္းအက်ႌႏွင့္ဦးထုပ္သည္ 1 ျဖစ္သည္.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "ဖယ္ရွားၿပီးပါကစက္ပစၥည္းမ်ားဆုံးရႈံးသည္",
  T_36_WZY_WS_DESTOBJ: "ဖ်က္ဆီးႏိုင္သည့္အရာဝတၳဳ",
  T_36_WZY_WS_DIRPOINT: "ဦးတည္ခ်က္အမွတ္",
  T_36_WZY_WS_DIRPOINTDESC: "ဖန္တီးရမည့္ဦးတည္ရာအမွတ္",
  T_36_WZY_WS_ELEFINDRES: "ျဒပ္စင္တစ္ခု၏ပထမေနရာအၫႊန္း",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'စာရင္းတစ္ခုရွိျဒပ္စင္တစ္ခု၏ပထမေနရာအၫႊန္းကိုရယူပါ. စာရင္းထဲတြင္ပစ္မွတ္ျဒပ္စင္မရွိလွ်င္ရလဒ္သည္ "-1" ျပန္လာလိမ့္မည္.',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "စာရင္းတြင္ရွာေဖြရမည့္အရာ",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'စာရင္းတစ္ခုရွိျဒပ္စင္တစ္ခု၏ေနာက္ဆုံးအေနအထားအၫႊန္းကိုရယူပါ. စာရင္းထဲတြင္ ပစ္မွတ္ျဒပ္စင္မရွိလွ်င္ရလဒ္သည္ "-1" ျပန္လာလိမ့္မည္.',
  T_36_WZY_WS_ELELINDRES: "ျဒပ္စင္တစ္ခု၏ေနာက္ဆုံးအေနအထား၏အၫႊန္း",
  T_36_WZY_WS_ELEMENTSNUM: "# စာရင္းရွိအစိတ္ပိုင္းမ်ား",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "[အစပ်ိဳးျခင္း entity] အစပ်ိဳးျခင္းႏွင့္တိုက္မိေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "ဤအစပ်ိဳးျခင္းႏွင့္တိုက္မိသည့္ Entity",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "[Triggering entity] သည္ယာဥ္ကိုေမာင္းႏွင္ေသာအခါအစပ်ိဳးသည္.",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "ယာဥ္ေမာင္းေနသည့္ Entity",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "အစပ်ိဳးသို႔ကစားသမားဝင္ေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "ဝင္ေရာက္ရန္ခလုတ္",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "[အစပ်ိဳးျခင္း entity] ယာဥ္မွထြက္ေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "ယာဥ္မွထြက္သည့္ Entity",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "[အစပ်ိဳး entity] ယာဥ္သို႔ဝင္သည့္အခါအစပ်ိဳးသည္",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "ယာဥ္ထဲသို႔ဝင္သည့္ Entity",
  T_36_WZY_WS_ENTITY_TYPE1: "အသံုးမ်ားသည္",
  T_36_WZY_WS_ENTITY_TYPE2: "ပိုင္ဆိုင္မွဳမ်ား",
  T_36_WZY_WS_ENTITY_TYPE3: "အရာဝတၳဳႏွင့္အိုင္တန္မ်ား",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "ေျပာင္းလဲရမည့္ျဒပ္စင္တန္ဖိုး",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "ပစ္မွတ္ကစားသမား",
  T_36_WZY_WS_ENTITYLIST: "Entity စာရင္း",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "[Triggering entity] တာယာေပၚမွခုန္တက္လာေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "တာယာေပၚမွခုန္ထြက္လာတဲ့ပစၥည္း",
  T_36_WZY_WS_ENTTP_NAMEDESC: "[Triggering entity] သည္ေပၚတယ္သို႔ဝင္ေရာက္ၿပီးတယ္လီပို႔သည့္အခါအစပ်ိဳးသည္",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "တယ္လီပို႔ျပီးသည့္ Entity",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "က်ည္ကာ၊ ဦးထုပ္၊ ေက်ာပိုးအိတ္အပါအဝင္သံခ်ပ္ကာအမ်ိဳးအစား",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "ကစားသမားသည္လက္နက္ေအာင္ျမင္စြာတပ္ဆင္သည့္အခါအစပ်ိဳးသည္.[Trigger player] သည္လက္နက္ကိုေအာင္ျမင္စြာတပ္ဆင္ႏိုင္ေသာကစားသမားျဖစ္သည္. [လက္နက္ entity] သည္ကစားသမားတပ္ဆင္ထားေသာလက္နက္ျဖစ္သည္.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "တပ္ဆင္ျပီးသည့္လက္နက္ Entity",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "လက္နက္အမ်ိဳးအစား",
  T_36_WZY_WS_EULERANGLE: "Euler ေထာင့္မ်ား",
  T_36_WZY_WS_FACECAMERA: "အျမဲတမ္းကင္မရာဘက္လွည့္ပါ",
  T_36_WZY_WS_FLOATLIST: "Float စာရင္း",
  T_36_WZY_WS_FLOOR_NAME_DESC: "တန္ဖိုးတစ္ခုအားသူ႔ထက္ငယ္ေသာအႀကီးဆုံးကိန္းျပည့္သို႔လွည့္ပါ",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "အလွည့္က်ရန္တန္ဖိုး",
  T_36_WZY_WS_FLOORRES: "အလွည့္က်ရလဒ္",
  T_36_WZY_WS_FORMUENT: "ပိုင္ဆိုင္မွဳပံုေသရႏိုင္သည့္ Entity",
  T_36_WZY_WS_FORMUFACT: "ပိုင္ဆိုင္မွဳေဖာ္ျမဴလာ၏အမ်ိဳးအစား",
  T_36_WZY_WS_GAME_TYPE2: "ဂိမ္းကစားပံု",
  T_36_WZY_WS_GAME_TYPE3: "အထူးအက္ဖက္",
  T_36_WZY_WS_GENENT_NAMEDESC: "ထုတ္စက္ယူနစ္မ်ားေပါက္ေသာအခါအစပ်ိဳးသည္. [ယူနစ္ entity] သည္ထုတ္စက္မွေပါက္ဖြားလာေသာယူနစ္မ်ားစာရင္းျဖစ္သည္. [# of waves] သည္မ်ိဳးဆက္မွေပါက္ဖြားလာေသာလႈိင္းအေရအတြက္ျဖစ္သည္.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "ယူနစ္ Entity",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "ထုတ္စက္ျဖင့္ေပါက္ပြားသည့္ entities ယူနစ္စာရင္းပါဝင္သည္",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "ထုတ္စက္မွေပါက္သည့္လွိဳင္းအေရတြက္",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "ကစားပြဲအတြင္းစတိုးအားလံုးမွရရွိသည္. ျပန္လာေသာတန္ဖိုးသည္စတိုး entities ပါဝင္ေသာစာရင္းျဖစ္သည္",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "အေရာင္ရရွိရန္ RGB သံုးပါ",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "သတ္မွတ္ထားေသာပိုက္ဆံအိတ္ရွိအခ်ိဳ႕ေသာေငြေၾကးပမာဏကိုရယူပါ",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "ပိုက္ဆံအိတ္မွရရွိသည့္ ေငြေၾကးပမာဏ",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "ရရွိမည့္ေငြေၾကးပမာဏ၏ ေငြေၾကးအမ်ိဳးအစား",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "ပစ္မွတ္ Entity ၏ Entity အမ်ိဳးစားရရွိသည္",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "ရယူရမည့္အမ်ိဳးစား",
  T_36_WZY_WS_GETENTTYPERES: "ပစ္မွတ္ Entity ၏ Entity အမ်ိဳးအစား",
  T_36_WZY_WS_GETFOR_NAME: "လမ္းညႊန္ကိုၾသဒိနိတ္မ်ားရယူပါ",
  T_36_WZY_WS_GETFOR_NAMEDESC: "သတ္မွတ္ထဦးတည္ခ်က္အမွတ္၏ဗက္တာကိုရယူပါ",
  T_36_WZY_WS_GETFORRES: "ဦးတည္အမွတ္၏ဗက္တာ",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "ပိုက္ဆံအိတ္ရွိေငြေၾကးအမ်ိဳးစားအခ်ိဳ႕၏ေငြေၾကး Entity ရရွိသည္",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "ေငြေၾကး Entity ျဖစ္သည့္ပိုက္ဆံအိတ္",
  T_36_WZY_WS_GETPOS_NAME: "ကိုၾသဒိနိတ္ရယူပါ",
  T_36_WZY_WS_GETPOS_NAMEDESC: "သတ္မွတ္ထားေသာဦးတည္ခ်က္အမွတ္၏ၾသဒီနိတ္မ်ားကိုရယူပါ",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "သတ္မွတ္ထားသည့္ဦးတည္အမွတ္",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "စက္ပစၥည္းအမ်ိဳးအစား",
  T_36_WZY_WS_GETWALLET_NAME: "ပိုက္ဆံအိတ္ရယူပါ",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "ေရြးခ်ယ္ထားသည့္ပိုင္ရွင္၏ပိုက္ဆံအိတ္ရရွိသည္",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "ေပါင္းထားေသာပိုက္ဆံအိတ္ရွိမရွိ",
  T_36_WZY_WS_GETWALLETRES: "ပိုက္ဆံအိတ္ပိုင္ရွင္ Entity",
  T_36_WZY_WS_HUDCONTROL_DESC: "HUD ၏ထိန္းခ်ဳပ္ Entity",
  T_36_WZY_WS_HUDTYPE: "HUD အမ်ိဳးစား",
  T_36_WZY_WS_INCIDENT_TYPE1: "တိုက္ဆိုင္မွဳအျဖစ္ပ်က္",
  T_36_WZY_WS_INCIDENT_TYPE2: "Entity အျဖစ္ပ်က္",
  T_36_WZY_WS_INDEX_DESC: "စာရင္း၏ကိန္းညႊန္းတန္ဖိုး. 0 မွစသည္.",
  T_36_WZY_WS_INTLIST: "ကိန္းျပည့္စာရင္း",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Entity အမ်ိဳးအစားသည္အခ်ိဳ႕ေသာအမ်ိဳးအစားခြဲတစ္ခုႏွင့္သက္ဆိုင္ျခင္းရွိမရွိစစ္ေဆးပါ. ျပန္လာရလဒ္သည္ Boolean ျဖစ္သည္.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "၎ႏွင့္သက္ဆိုင္မႈရွိမရွိစစ္ေဆးရန္ပင္မအမ်ိဳးအစား",
  T_36_WZY_WS_JENTSUBCLRES: "ပင္မအမ်ိဳးအစားစစ္ေဆးခ်က္၏ရလဒ္",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "အေၾကာင္းအရာတစ္ခုသည္အခ်ိဳ႕ေသာ entity အမ်ိဳးအစားမွပိုင္ဆိုင္ျခင္းရွိမရွိစစ္ေဆးပါ. ရလဒ္သည္ Boolean ျဖစ္သည္.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "စစ္ေဆးရန္ Entity",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "၎သည္ entity အမ်ိဳးအစားႏွင့္တူညီသည္ဟုဆိုလိုသည္",
  T_36_WZY_WS_JENTTYPERES: "Entity စာရင္းစစ္ရလဒ္မ်ား",
  T_36_WZY_WS_JUSTPATROL: "လွည့္ကင္းသာ",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "ကစားသမားထြက္သြားေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "ထြက္ရန္ခလုတ္",
  T_36_WZY_WS_LEVELOBLIST: "အရာဝတၳဳစာရင္း",
  T_36_WZY_WS_LEVOBJSLIST: "ဤပြဲရွိေျမပုံအရာဝတၳဳအားလုံး၏စာရင္း",
  T_36_WZY_WS_LEVOBTYPE: "အရာဝတၳဳအမ်ိဳးစား",
  T_36_WZY_WS_LISTT: "ပံုစံမ်ားစာရင္း",
  T_36_WZY_WS_LOGCONTEXT_DESC: "ပံုႏွိပ္ရမည့္အေၾကာင္းရာ",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "ခ်ိတ္ဆက္ရန္ဘယ္ဘက္ String",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "ခ်ိတ္ဆက္ရမည့္မွန္ကန္သည့္ၾကိဳး",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "ထည့္ရမည့္ျဒပ္စင္တန္ဖိုး",
  T_36_WZY_WS_LOGOPER: "ေလာ့ဂ်စ္လုပ္ေဆာင္ခ်က္မ်ား (ႏွင့္ & သို႔မဟုတ္): ေပးထားေသာ Boolean တန္ဖိုးႏွစ္ခုလုံးသည္မွန္ပါက၊ ရလဒ္မွာ TRUE ျဖစ္ၿပီး၊ သို႔မဟုတ္ လုပ္ေဆာင္ခ်က္ကို အသုံးျပဳပါက Boolean တန္ဖိုးႏွစ္ခုစလုံးသည္မွားေနပါကရလဒ္မွာ TRUE ျဖစ္သည္.",
  T_36_WZY_WS_LOOTPOINT: "ပစၥည္းေကာက္မွတ္",
  T_36_WZY_WS_MAINWEAP: "လက္ရွိလက္နက္",
  T_36_WZY_WS_MAX_DESC: "ထုတ္ေပးေသာကိန္းျပည့္၏အေပၚပိုင္းအကြာအေဝး (အဖြင့္ၾကားကာလ)",
  T_36_WZY_WS_MIN_DESC: "ထုတ္ေပးေသာကိန္းျပည့္ (အပိတ္ၾကားကာလ) ၏ေအာက္အပိုင္း",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "လက္နက္ entity",
  T_36_WZY_WS_MONENT: "ေငြေၾကး Entity",
  T_36_WZY_WS_MONTYPE: "ေငြေၾကးအမ်ိဳးစား",
  T_36_WZY_WS_MOVETO_NAMEDESC: "ဦးတည္ရာသို႔ ေ႐ြ႕လ်ားရန္ AI ကိုေရြ႕လ်ားေစပါ. သင္ AI ကိုအစမွတ္သို႔ ျပန္သြားရန္ ဆုံးျဖတ္ရန္ [Return or not] ကိုသုံးပါ. AI သည္၎၏လမ္းေပၚရွိ ရန္သူမ်ားကိုစကင္န္ဖတ္မည္ကို ေ႐ြးခ်ယ္ရန္ [Attack or not] ကိုအသုံးျပဳပါ.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "ခရီသြားမည့္ AI Entity",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "ဦးတည္ရာ",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "ဦးတည္ရာသို႔ေရာက္ရွိၿပီးေနာက္ AI သည္မူလတည္ေနရာသို႔ျပန္သြားျခင္း ရွိ၊ မရွိ သတ္မွတ္ရန္အသုံးျပဳပါ. TRUE ဆိုသည္မွာျပန္လာျခင္း၊ FALSE ဆိုသည္မွာမျပန္ပါ.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "တိုက္မလား မတိုက္ဘူးလား",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "လမ္းတစ္ေလွ်ာက္တြင္ AI သည္အနီးနားရွိ၏ရန္သူမ်ားတိုက္ခိုက္မည္ကိုသတ္မွတ္ရန္အသုံးျပဳပါ. TRUE ဆိုသည္မွာရန္သူမ်ားကိုစကင္န္ဖတ္ျခင္း၊ FALSE ဆိုသည္မွာရန္သူမ်ားကိုစကင္န္မဖတ္ပါႏွင့္ျဖစ္သည္.",
  T_36_WZY_WS_MULVALUE: "Scalar",
  T_36_WZY_WS_MULVEC: "Scalar ေျမွာက္ျခင္းဗက္တာ",
  T_36_WZY_WS_NEGRES: "အႏုတ္လကၡဏာတန္ဖိုးရလဒ္",
  T_36_WZY_WS_NEUTRAL: "ပံုမွန္",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "သတ္မွတ္ထားေသာထုတ္စက္ေနာက္လႈိင္းေပါက္ေစရန္တြန္းအားေပးပါ. ထုတ္စက္မ်ားတြင္ဖုတ္ေကာင္ေပါက္မ်ားႏွင့္ပစၥည္းေပါက္ျခင္းမ်ားပါဝင္သည္.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "ထုတ္စက္ Entity",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "သတ္မွတ္ထားသည့္ထုတ္စက္ Entity, ဥပမာ ဖုတ္ေကာင္ေပါက္ပြားျခင္းႏွင့္အိုင္တန္ေပါက္ပြားျခင္း",
  T_36_WZY_WS_OBJENT: "အရာဝတၳဳ Entity",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "အိုင္တန္ရရွိျပီးသည့္အခါအစပ်ိဳးသည္. [အိုင္တန္အမ်ိဳးအစား] သည္ရရွိသည့္အိုင္တန္အမ်ိဳးစားျဖစ္သည္.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "လက္နက္ရရွိျပီးေသာအခါအစပ်ိဳးသည္. [လက္နက္ Entity] သည္ရရွိသည့္လက္နက္ျဖစ္သည္.",
  T_36_WZY_WS_ONEWAY: "တစ္လမ္္း",
  T_36_WZY_WS_OPENSTATE: "အေျခေန",
  T_36_WZY_WS_OPERMETHOD_NAME: "ေအာ္ပေရးရွင္း",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "အေျခခံဂဏန္းသခ်ၤာလုပ္ငန္းမ်ား. ေလာေလာဆယ္တြင္၊ ကိန္းျပည့္လုပ္ငန္းေဆာင္တာမ်ားတြင္ေပါင္းျခင္း၊ ႏုတ္ျခင္း၊ ေျမႇာက္ျခင္း၊ စားျခင္း ႏွင့္ အႂကြင္းမ်ားပါဝင္ၿပီး float ေဆာင္႐ြက္မႈမ်ားတြင္ေပါင္းျခင္း၊ ႏုတ္ျခင္း၊ ေျမႇာက္ျခင္းႏွင့္ စားျခင္းပါဝင္သည္.",
  T_36_WZY_WS_OWNERENT_DESC: "ပိုက္ဆံအိတ္ရရန္အန္တစ္တီ",
  T_36_WZY_WS_PERCENTAGE: "ရာခိုင္ႏွဳန္းခ်ိန္ညွိခ်က္",
  T_36_WZY_WS_PLACOLLIDE_NAME: "ကစားသမားစက္ယႏၲရားႏွင့္တိုက္မိေသာအခါ",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "[အစပ်ိဳးကစားသမား] ယႏၲရားႏွင့္တိုက္မိေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "ယႏၲရားႏွင့္တိုက္မိသည့္ကစားသမား",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "ကစားသမားႏွင့္တိုက္မိေသာအရာဝတၳဳ Entity",
  T_36_WZY_WS_PLADRIVEH_NAME: "ကစားသမားယာဥ္ေမာင္းတဲ့အခါ",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "[အစပ်ိဳးကစားသမား] ယာဥ္ကိုေမာင္းေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "ယာဥ္ကိုေမာင္းႏွင္ေသာကစားသမား",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "ကစားသမားေမာင္းႏွင္ေနသည့္ယာဥ္ Entity",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "ကစားသမားယာဥ္မွထြက္ေသာအခါ",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "[အစပ်ိဳးကစားသမား] ယာဥ္မွထြက္ေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "ယာဥ္မွထြက္လာတဲ့ကစားသမား",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "ကစားသမားထြက္သြားေသာအခါယာဥ္ Entity",
  T_36_WZY_WS_PLAGETONVEH_NAME: "ကစားသမားယာဥ္ထဲဝင္ေသာအခါ",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "[အစပ်ိဳးကစားသမား] ယာဥ္သို႔ဝင္ေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "Entity သည္ကစားသမားဝင္ေရာက္လာေသာယာဥ္",
  T_36_WZY_WS_PLAKNOFLY_NAME: "ကစားသမားတာယာမွခုန္ဆင္းတဲ့အခါ",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "[Trigger player] တာယာေပၚျပန္တက္လာေသာအခါအစပ်ိဳးသည္",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "တာယာေပၚမွခုန္တက္ေသာကစားသမား",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "Entity ကစားသူထံသို႔ ျပန္တက္လာေသာအရာ",
  T_36_WZY_WS_PLATP_NAME: "ကစားသမားတယ္လီပို႔ျပီးေနာက္",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "ေပၚတယ္အသံုးျပဳသည့္ကစားသမား",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "ကစားသမားအသံုးျပဳသည့္ေပၚတယ္ Entity",
  T_36_WZY_WS_PLAYERLIST_DESC: "ဤပြဲမွကစားသမားအားလံုးစာရင္း",
  T_36_WZY_WS_POINTPICKER: "အေရးၾကီးေသာလမ္း",
  T_36_WZY_WS_PORTALENT: "ေပၚတယ္ Entity",
  T_36_WZY_WS_PREFAB: "နမူနာပံုစံ",
  T_36_WZY_WS_PRODLIST: "ကုန္ပစၥည္းစာရင္း",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "စီစဥ္ေပးျခင္း",
  T_36_WZY_WS_PROPMOD: "ပိုင္ဆိုင္မွဳေျပာင္းလဲျခင္းနည္းလမ္း",
  T_36_WZY_WS_RANKABLEE: "အဆင့္ရသည့္ Entity",
  T_36_WZY_WS_REDCURR_NAMEDESC: "သတ္မွတ္ထားေသာပိုက္ဆံအိတ္တြင္သတ္မွတ္ထားသည့္ေငြေၾကးပမာဏအခ်ိဳ႕သံုးပါ",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "ေငြေၾကးသံုးစြဲေသာပိုက္ဆံအိတ္",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "သံုးစြဲသည့္ေငြေၾကးအမ်ိဳးအစား",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "သံုးစြဲေငြေၾကးပမာဏ",
  T_36_WZY_WS_RNDFRES: "က်ပန္း Float ထုတ္သည္",
  T_36_WZY_WS_RNDIRES: "က်ပန္းကိန္းျပည့္မ်ိဳးဆက္၏ရလဒ္",
  T_36_WZY_WS_ROUND_NAME_DESC: "တန္ဖိုးတစ္ခုကိုအနီးဆုံးကိန္းျပည့္သို႔လွည့္ပါ",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "အလွည့္တန္ဖိုး",
  T_36_WZY_WS_ROUNDRES: "အလွည့္က်ရလဒ္",
  T_36_WZY_WS_RUNAI_NAMEDESC: "AI လုပ္ေဆာင္ရန္ေ႐ြးခ်ယ္ထားေသာအျပဳအမူမ်ားစာရင္း",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "ပံုေသအမူအက်င့္ကိုရပ္တန္႔/လုပ္ေဆာင္သည့္ ယူနစ္ Entity",
  T_36_WZY_WS_SCOREABLEE: "အမွတ္ရသည့္ Entity",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "ရမွတ္ေျပာင္းလဲေသာအခါအစပ်ိဳးသည္. [ရမွတ္အမ်ိဳးအစား] သည္ေျပာင္းလဲသြားေသာရမွတ္အမ်ိဳးအစားျဖစ္သည္. [ရမွတ္] သည္ရမွတ္အသစ္ျဖစ္သည္.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "ဦးတည္ခ်က္အမွတ္ဖန္တီးပါ",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "အသစ္ဖန္တီးထားေသာဦးတည္ခ်က္အမွတ္ကိုရယူပါ. ဦးတည္ခ်က္၏ ဗက္တာကိုသတ္မွတ္ရန္ ကိုၾသဒိနိတ္မွတ္ႏွင့္ [ဦးတည္ခ်က္] ကိုသတ္မွတ္ရန္ [တည္ေနရာ] ကိုသုံးပါ.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "ဦးတည္ခ်က္အမွတ္၏ကိုၾသဒိနိတ္မ်ား",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "ဦးတည္ခ်က္",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "ဦးတည္ခ်က္အမွတ္၏ဗက္တာ",
  T_36_WZY_WS_SETPATH_NAMEDESC: "AI Entities သည္ဤေနရာတြင္သတ္မွတ္ထားသည့္အမိန႔္အတိုင္းခရီးသြားပါမည္. ရႏိုင္ေသခရီးသြားအမ်ိဳးအစားမ်ားမွာအဝိုင္း-အျပန္၊ တစ္လမ္းေမာင္းႏွင့္အသြားအျပန္မ်ားျဖစ္သည္. AI သည္၎၏သြားရာလမ္းတြင္ရန္သူမ်ားကိုစကင္န္ဖတ္မည္ကိုသင္ေ႐ြးခ်ယ္ႏိုင္သည္.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "AI သြားလာသင့္သည့္အခ်က္မ်ားပါ၀င္သည့္စာရင္း",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "ခရီူသြားအမ်ိဳးစား",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "ဤအရာသည္ခရီးသြားအမ်ိဳးအစားျဖစ္သည္. တစ္လမ္းေမာင္းသည္ဦးတည္ရာသို႔ေရာက္သည္ႏွင့္ AI သည္ခရီးကိုရပ္တန႔္ရန္ျဖစ္သည္. အဝိုင္း-ေနာက္သည္ AI သည္ဦးတည္ရာသို႔ေရာက္သည္ႏွင့္ေနာက္ျပန္လမ္းကိုရွာေဖြရန္ျဖစ္သည္. အသြားအျပန္ခရီးသည္လမ္းေၾကာင္းစာရင္း၏ေနာက္ျပန္အစီအစဥ္အတိုင္း AI အတြက္မူလတည္ေနရာသို႔ ျပန္သြားရန္ျဖစ္သည္.",
  T_36_WZY_WS_SHOPECON: "စတိုးဆိုင္ႏွင့္စီးပြားေရး",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "မ်က္ႏွာျပင္ေပၚတြင္အသိေပးခ်က္မ်ားကိုျပသရန္အတြက္အသုံးျပဳသည္. အေၾကာင္းအရာ [Text]၊ လိုခ်င္ေသာအေရာင္ [Color] ႏွင့္ ၾကာခ်ိန္ [Duration] (တန္ဖိုးမ်ားကို မီလီစကၠန႔္အတြင္း) သတ္မွတ္ပါ.",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "ေရေပၚသတိေပးခ်က္၏အေၾကာင္းအရာ",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "ေရေပၚအသိေပးခ်က္၏အေရာင္",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "မိုင္စကၠန႔္အတြင္း ရေပၚအေၾကာင္းၾကားခ်က္၏ျပသမႈၾကာခ်ိန္",
  T_36_WZY_WS_SIN_NAMEDESC: "ေထာင့္တစ္ခု၏ sine ကိုရွာပါ",
  T_36_WZY_WS_SINRES: "ေထာင့္၏ဆိုင္း",
  T_36_WZY_WS_SKIPKNODOWN: "အလဲထိုးမွဳအရဖယ္ထုတ္ခံရသည္ျဖစ္ေစ",
  T_36_WZY_WS_SQRTRES: "ႏွစ္ထပ္ကိန္းရလဒ္",
  T_36_WZY_WS_STRCONRES: "ၾကိဳးခ်ိတ္ဆက္မွဳရလဒ္",
  T_36_WZY_WS_STRINGLIST: "ၾကိဳးစာရင္း",
  T_36_WZY_WS_STRLEN: "ၾကိဳးအရွည္",
  T_36_WZY_WS_STRVAL: "String ရလဒ္",
  T_36_WZY_WS_TAN_NAMEDESC: "ေထာင့္တစ္ခု၏တန္းဂ်င့္ကိုရွာပါ",
  T_36_WZY_WS_TANRES: "ေထာင့္၏တန္႔ဂ်န္႔",
  T_36_WZY_WS_TEAMLIST: "အသင္းစာရင္း",
  T_36_WZY_WS_TEAMLIST_DESC: "ဒီပြဲကအသင္းအားလံုးစာရင္းပါ",
  T_36_WZY_WS_TIMETWEENTIPS: "ေရတြက္ခ်ိန္သတိေပးခ်က္ Entity",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "ပစ္မွတ္တစ္ခုကိုစာေၾကာင္းတစ္ခုျဖစ္ေျပာင္းပါ",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "ၾကိဳးတစ္ခုေျပာင္းရန္ပစ္မွတ္တန္ဖိုး",
  T_36_WZY_WS_TOSTRINGRES: "ၾကိဳးေျပာင္းျခင္း၏ရလဒ္",
  T_36_WZY_WS_TOWERCAMP_DESC: "ေဘးနံပတ္နဲ႔အသင္းနံပါတ္အတူတူျဖစ္သည္. ၾကားေနရဲတိုက္မ်ားႏွင့္ခံတပ္မ်ားသည္အကြာအေဝးအတြင္းရွိကစားသမားမ်ားႏွင့္ AIs အားလုံးကိုတိုက္ခိုက္သည္.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "သတ္မွတ္ထားေသာေငြၾကးပမာဏအခ်ိဳ႕ကိုပိုက္ဆံအိတ္တစ္ခုမွအျခားတစ္ခုသို႔လႊဲေျပာင္းပါ",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "ပိုက္ဆံအိတ္ထဲမွေငြေၾကးကိုလႊဲေျပာင္းသည္",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "ေငြေပးေငြယူအမ်ိဳးစား",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "ေငြလႊဲမွဳတြင္ေငြေၾကး၏ပမာဏ",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "ပိုက္ဆံအိတ္ထဲသို႔ ေငြေၾကးလႊဲေျပာင္းရန္",
  T_36_WZY_WS_TWEENTIPS: "Entity သတိေပးခ်က္ Floating",
  T_36_WZY_WS_TYPEENUM: "Enum အမ်ိဳးအစား",
  T_36_WZY_WS_USEPROP_NAMEDESC: "ကစားသမားသည္အိုင္တန္ကိုအသုံးျပဳေသာအခါအစပ်ိဳးသည္. [Triggeri player] သည္ပစၥည္းတစ္ခုကိုအသုံးျပဳသည့္ကစားသမားျဖစ္သည္. [Item type] သည္ စားသမားအသုံးျပဳသည့္အရာျဖစ္သည္.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "ကစားသမားမွအသံုးျပဳျပီးသည့္အိုင္တန္အမ်ိဳးစား",
  T_36_WZY_WS_VECADDLEFT: "ထပ္ေပါင္းဗက္တာ၏ဘယ္ဘက္တန္ဖိုး",
  T_36_WZY_WS_VECADDRES: "ဗက္တာထပ္တိုးရလဒ္",
  T_36_WZY_WS_VECADDRIGHT: "ထပ္ေပါင္းဗက္တာ၏ညာဘက္တန္ဖိုး",
  T_36_WZY_WS_VECANGLEFT: "ဗက္တာေထာင့္၏ဘယ္တန္ဖိုး",
  T_36_WZY_WS_VECANGRES: "ဗက္တာ 2 ခုၾကားေထာင့္",
  T_36_WZY_WS_VECANGRIGHT: "ဗက္တာေထာင့္၏ညာဘက္တန္ဖိုး",
  T_36_WZY_WS_VECCROLEFT: "ျဖတ္ေက်ာ္ပစၥည္း၏ဘယ္ဘက္တန္ဖိုး",
  T_36_WZY_WS_VECCRORES: "ျဖတ္ေက်ာ္ပစၥည္း၏ရလဒ္",
  T_36_WZY_WS_VECCRORIGHT: "ျဖတ္ေက်ာ္ပစၥည္း၏ညာဘက္တန္ဖိုး",
  T_36_WZY_WS_VECDISLEFT: "ဗက္တာအကြာအေဝး၏ဘယ္ဘက္တန္ဖိုး",
  T_36_WZY_WS_VECDISRES: "ဗက္တာႏွစ္ခုၾကားအကြာအေဝး",
  T_36_WZY_WS_VECDISRIGHT: "ဗက္တာအကြာအေဝး၏အမွန္တန္ဖိုး",
  T_36_WZY_WS_VECDOCLEFT: "အစက္၏ဘယ္ဘက္တန္ဖိုး",
  T_36_WZY_WS_VECDOCRES: "အစက္ပစၥည္း၏ရလဒ္",
  T_36_WZY_WS_VECDOCRIGHT: "အစက္၏ညာဘက္တန္ဖိုး",
  T_36_WZY_WS_VECMULRES: "Scalar ေျမွာက္ျခင္း၏ရလဒ္",
  T_36_WZY_WS_VECNORRES: "ပံုမွန္ဗက္တာ",
  T_36_WZY_WS_VECSIZERES: "ဗက္တာတစ္ခု၏ျပင္းအား",
  T_36_WZY_WS_VECSUBLEFT: "အႏုတ္ကိန္းဂဏာန္း၏က်န္ရွိတန္ဖိုး",
  T_36_WZY_WS_VECSUBRES: "ဗက္တာအႏုတ္ရလဒ္",
  T_36_WZY_WS_VECSUBRIGHT: "အႏုတ္ဗက္တာ၏အမွန္တန္ဖိုး",
  T_36_WZY_WS_VECTORLIST: "ဗက္တာစာရင္း",
  T_36_WZY_WS_VECX: "x အပိုင္းစ",
  T_36_WZY_WS_VECY: "y အစိတ္အပိုင္း",
  T_36_WZY_WS_VECZ: "z အပိုင္းစ",
  T_36_WZY_WS_VEHENT: "ယာဥ္ Entity",
  T_36_WZY_WS_WALLCONT: "ပိုက္ဆံအိတ္အေၾကာင္းရာ",
  T_36_WZY_WS_ZOMBIESPERWAVE: "အဆက္မျပတ္",
  T_36_XYL_WS_AIBOT: "ယူနစ္",
  T_36_XYL_WS_AIGENERATOR: "ထုတ္စက္ယူနစ္",
  T_36_XYL_WS_AIGENERATOR_DESC: "သတ္မွတ္ယူနစ္အဆက္မျပတ္ထုတ္ႏိုင္သည့္ထုတ္စက္ (ဥပမာ-ဖုတ္ေကာင္)",
  T_36_XYL_WS_AIWAVE: "# လွိဳင္းတစ္ခုယူနစ္",
  T_36_XYL_WS_ARROW: "လမ္းညႊန္ဆိုင္းဘုတ္",
  T_36_XYL_WS_ARROW_DESC: "ဦးတည္ရာကိုၫႊန္ျပေသာလကၡဏာ",
  T_36_XYL_WS_BREAKBOX: "Breakable ေသတၱာ",
  T_36_XYL_WS_BREAKBOX_DESC: "တိုက္ခိုက္တဲ့အခါက်ိဳးႏိုင္သည့္သစ္သားေသတၱာ",
  T_36_XYL_WS_FENCE: "သံျခံစည္းရိုး",
  T_36_XYL_WS_FENCE_DESC: "က်ည္ဆံမ်ားျဖတ္ေက်ာ္ႏိုင္ေစမည့္ၿခံစည္း႐ိုး",
  T_36_XYL_WS_STAIRI: "ဂိတ္ C",
  T_36_XYL_WS_STAIRI_DESC: "ေလွကားထစ္မ်ားႏွင့္ေပါင္းစည္းထားသည့္ပလက္ေဖာင္း",
  T_36_XYL_WS_ZOMBIEAI: "ဖုတ္ေကာင္",
  T_36_XYL_WS_ZOMBIEAI_DESC: "စိတ္ႀကိဳက္ျပင္ဆင္ႏိုင္ၿပီး ယူနစ္ထုတ္စက္တြင္ရယူၿပီးထပ္တူက်ေသာ အေၾကာင္းအရာတစ္ခုျဖစ္လာႏိုင္သည့္ဖုတ္ေကာင္",
  T_36_YF_CORRODE_GRENADE_N: "ဗံုး- Gloo Melter",
  T_36_YF_SETTING_TYPE3: "ပရီဆက္ 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (ေဘာင္းဘီ)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (ေဘာင္းဘီ)",
  T_36_YS_F_A_GHOSTHUNTER: "Fiendish Foxtail (မ်က္ႏွာဖံုး)",
  T_36_YS_F_B_GHOSTHUNTER: "Fiendish Foxtail (ေဘာင္းဘီ)",
  T_36_YS_F_H_GHOSTHUNTER: "Fiendish Foxtail (ေခါင္းေဆာင္း)",
  T_36_YS_F_S_GHOSTHUNTER: "Fiendish Foxtail (ဖိနပ္)",
  T_36_YS_SETTING_GRENADE: "ပစ္ႏိုင္သည့္အရာမ်ား",
  T_36_YS_SETTING_MOVE: "ေရြ႕လ်ားမွဳ",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (အကၤ်ီ)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (အကၤ်ီ)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Fang",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "အေကာင္စကင္: Purple Zasil",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "အေကာင္စကင္: Lightning Falco",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "တိရစာၦန္စကင္: Lava Fang",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "တိရစာၦန္စကင္: Spectral Guide",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "တိရစာၦန္စကင္: Arctic Fang",
  T_37_B_WS_HIDE: "တူတူပုန္း",
  T_37_HZ_WS_CATMODEDESC1: "တူတူပုန္း",
  T_37_JH_WS_CREATEGOLD_DESC: "အိုင္တန္ဝယ္ႏိုင္သည့္ကစားသမားထံမွအေရာင္းစက္. (4v4, Deathmatch, ကစားကြင္းႏွင့္ Apocalypse modes မွာမရႏိုင္ပါ)",
  T_37_JH_WS_NAME1: "FF Knife (Droid Apocalypse)",
  T_37_JH_WS_NAME10: "M1887-X (Droid Apocalypse)",
  T_37_JH_WS_NAME11: "SPAS12 (Droid Apocalypse)",
  T_37_JH_WS_NAME12: "M1014 (Droid Apocalypse)",
  T_37_JH_WS_NAME13: "MP40 (Droid Apocalypse)",
  T_37_JH_WS_NAME14: "MP5-III (Droid Apocalypse)",
  T_37_JH_WS_NAME15: "P90 (Droid Apocalypse)",
  T_37_JH_WS_NAME16: "M60-III (Droid Apocalypse)",
  T_37_JH_WS_NAME17: "Thompson (Droid Apocalypse)",
  T_37_JH_WS_NAME18: "UMP (Droid Apocalypse)",
  T_37_JH_WS_NAME19: "SVD",
  T_37_JH_WS_NAME2: "GROZA (Droid Apocalypse)",
  T_37_JH_WS_NAME20: "AWM (Droid Apocalypse)",
  T_37_JH_WS_NAME21: "M82B (Droid Apocalypse)",
  T_37_JH_WS_NAME22: "M249-X (Droid Apocalypse)",
  T_37_JH_WS_NAME23: "Kar98k-III (Droid Apocalypse)",
  T_37_JH_WS_NAME3: "AK47 (Droid Apocalypse)",
  T_37_JH_WS_NAME4: "M4A1-III (Droid Apocalypse)",
  T_37_JH_WS_NAME5: "SCAR (Droid Apocalypse)",
  T_37_JH_WS_NAME6: "M14-III (Droid Apocalypse)",
  T_37_JH_WS_NAME7: "PARAFAL (Droid Apocalypse)",
  T_37_JH_WS_NAME8: "XM8 (Droid Apocalypse)",
  T_37_JH_WS_NAME9: "MAG-7 (Droid Apocalypse)",
  T_37_JH_WS_VENDMACHINE_DESC: "ေျမပုံတစ္ဝိုက္တြင္ ေ႐ႊကို ေကာက္ယူႏိုင္သည္. (Clash Squad၊ Team Deathmatch၊ Playground ႏွင့္ Droid Apocalypse မုဒ္မ်ားတြင္ မမွန္ကန္ပါ)",
  T_37_JH_WS_X: "X ဝင္ရိုး",
  T_37_JH_WS_Y: "Y ဝင္ရိုး",
  T_37_JH_WS_Z: "Z ဝင္ရိုး",
  T_37_JL_FOOTBALL_TIE: "Tie",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "က်င္း",
  T_37_KK_WS_SNOWMAN: "ႏွင္းလူသား",
  T_37_LC_BP_ENTRANCE_GIFT: "လက္ေဆာင္!",
  T_37_M_WS_MISSING: "Missing source",
  T_37_M_WS_NAMEERROR: "ထိလြယ္ရွလြယ္ ဇာတ္ေကာင္မ်ား ပါရွိသည္. ေျပာင္းလဲပါ.",
  T_37_PD_HuntingGround_BOSSTITLE: "သားသတ္သမား",
  T_37_QL_JUMPPAD_DES: "ေျမျပင္ခုန္သည့္အခံကိုဖန္တီးပါ. ေလထဲအျမင့္ပ်ံႏိုင္ဖို႔ျဖစ္ရမည္ ေလထဲလည္းပစ္ႏိုင္ရမည္.",
  T_37_QL_JUMPPAD_NAME: "ပတၱဴဖ်င္ခ်ပ္",
  T_37_R_TAILOR_LIMIT: "ကန္႔သတ္အခ်ိန္",
  T_37_RW_LOADOUT_BORNFIRETAG: "Get 2 Bonfires at the start of the match. Bonfire [FFBA00]regenerates 5 HP and 20 EP per second[-] (up to 10 seconds) for you and your teammates within the area. Bonfire effects do not stack.",
  T_37_RW_PROPCATAPULT_DESC: "ေဖာင္းလာေသာအခါတြင္၊ ပေလယာတစ္လုံးကို ေလထဲသို႔ ပေရာဂ်က္ျပဳလုပ္ရန္ ပစ္လႊတ္သည့္အကြက္ကိုအသုံးျပဳႏိုင္သည္. သို႔ေသာ္ Safe Zone တြင္ေနရန္ေသခ်ာပါေစ.",
  T_37_RW_PROPCATAPULT_NAME: "မိုဘိုင္းေလာင္ခ်ာ",
  T_37_SP_WS_COLOR_02: "အေရာင္",
  T_37_SP_WS_COLOR_03: "အသြင္ျပင္",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "ယူနစ္သည္ null ျဖစ္သည္",
  T_37_SP_WS_LOG_PHASE_END: "အဆင့္ {0} ျပီးဆံုးသည္",
  T_37_SP_WS_LOG_PHASE_START: "အဆင့္ {0} စတင္သည္",
  T_37_SP_WS_LOG_ROUND_END: "အလွည့္ {0} ျပီးဆံုးသည္.",
  T_37_SP_WS_LOG_ROUND_START: "အလွည့္ {0} စတင္သည္.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "ကိန္းရွင္သို႔ တန္ဖိုးတစ္ခုသတ္မွတ္ေသာအခါ မကိုက္ညီေသာအမ်ိဳးအစား. လက္ရွိအမ်ိဳးအစား- {0}. လိုအပ္ေသာအမ်ိဳးအစား- {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "သတ္မွတ္မထားေသာ သို႔မဟုတ္ နယ္ပယ္ျပင္ပတြင္ရွိေသာကိန္းရွင္ {0}",
  T_37_SP_WS_MAPACCESS_08: "တည္းျဖတ္",
  T_37_SP_WS_RACEMODE_01: "ႏွစ္သစ္မုဒ္",
  T_37_SP_WS_RACEMODE_02: "ေရတြက္ခ်ိန္",
  T_37_SP_WS_RACEMODE_04: "ဖြင့္ေသာအခါတြင္၊ အသင္းတစ္သင္းလုံး ၿပီးဆုံးသည့္မွတ္တိုင္သို႔ ေရာက္သည့္အခါ ႏွစ္သစ္ႀကိဳဆိုပြဲတစ္ခုျဖစ္လိမ့္မည္. ႏွစ္သစ္ႀကိဳဆိုပြဲ ၿပီးဆုံးေသာအခါ ဂိမ္းသည္ ၿပီးဆုံးသည္.",
  T_37_SY_AR15_KABUKI_N: "Kingfisher- Song of Hana",
  T_37_SY_BACKPACK_STRAW_N: "ေကာက္ရိုးဦးထုပ္",
  T_37_SY_GRENADE_FFWS2022_01_N: "ဗံုး- Navy Starsea",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "တြင္းနက္",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Mamba Gnaw",
  T_37_SY_PET_FLYINGCREATURE_N: "အာဗြန္",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "တိုက္ပြဲအေဖာ္: Glamstar Beanie",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "တိုက္ပြဲအေဖာ္စကင္း: Ash Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "တိုက္ပြဲစကင္: ဂလက္စီအာဗြန္",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "တိုက္ပြဲအေဖာ္စကင္: မီးသူရဲေကာင္းအာဗြန္",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "တိုက္ပြဲအေဖာ္စကင္: ျမန္လြန္းတဲ့ေျခစံု",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "တိုက္ပြဲအေဖာ္: Winterlands Yeti",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "ဂ်စ္ကား- Rockin' Festival Ride",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "ကားၾကီး- Starsea Beast",
  T_37_WT_WS_PVE2DESC: "အခ်ိန္ကန႔္သတ္အတြင္းဖုတ္ေကာင္မ်ား၏ပစ္မွတ္အေရအတြက္ကို ဖယ္ရွားပါ/ အဆုံးအထိရွင္သန္ပါ",
  T_37_WT_WS_RULEDESC: "အႏိုင္ရရန္ပစ္မွတ္ဖုတ္ေကာင္အေရတြက္ေခ်မွဳန္းရမည္",
  T_37_WT_WS_RULETITLE: "ဂိုး",
  T_37_WT_WS_TXT1: "ဖုတ္ေကာင္မ်ားဖယ္ရွား",
  T_37_WT_WS_TXT1DESC: "ဖြင့္သည့္အခါ၊ ကစားသမားသည္ သတ္မွတ္ထားေသာဖုတ္ေကာင္အေရအတြက္ကို ဖယ္ရွားျခင္းျဖင့္အႏိုင္ရသည္. ပိတ္သည့္အခါ၊ ကစားသမားသည္အဆုံးအထိရွင္သန္ျခင္းျဖင့္အႏိုင္ရသည္.",
  T_37_WT_WS_TXT2: "ေခ်မွဳန္းပမာဏ",
  T_37_WZY_FRIDPLA: "ရည္မြန္ေသာကစားသမား",
  T_37_WZY_FRIDSIDE: "ရင္းႏွီးေသာအပိုင္းခြဲ",
  T_37_WZY_FRIDTEAM: "ေဖာ္ေရြသည့္အသင္း",
  T_37_WZY_HOSTPLA: "ရန္သူကစားသမား",
  T_37_WZY_HOSTSIDE: "ရန္သူအဖြဲ႕ခြဲ",
  T_37_WZY_WS_ACCFRAMES: "စုေဆာင္းထားသည့္ေဘာင္မ်ား",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "ကုန္ပစၥည္းတစ္ခုသို႔ပစၥည္းမ်ားထည့္ပါ. တစ္ခုတည္းေသာအရာ သို႔မဟုတ္ ပစၥည္းအုပ္စုတစ္စုကို သင္ထည့္ႏိုင္သည္. ပမာဏသည္ ပစၥည္းတစ္ခုခ်င္းစီ၏အေရအတြက္ သို႔မဟုတ္ ဤပမာဏ၏ပစၥည္းမ်ားပါရွိေသာစာရင္းတစ္ခုျဖစ္ႏိုင္သည္.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "ပစၥည္းမ်ားထည့္ရန္ကုန္သြယ္ပစၥည္း",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "ထည့္ရန္အိုင္တန္. အိုင္တန္တစ္ခု သို႔ အိုင္တန္အုပ္စုထည့္ႏိုင္သည္",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "ထည့္ေပါင္းရန္အိုင္တန္တစ္ခုျခင္းစီ၏ပမာဏ သိို႔ ဤပမာဏ၏အိုင္တန္၏ပါဝင္ေသာစာရင္း.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "ေရြးထားသည့္အန္တစ္တီအတြက္ကတ္ျပားထည့္ပါ",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "တဂ္သို႔ထည့္ရမည့္အရာ",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "ထည့္ရန္စာသားအေၾကာင္းရာ",
  T_37_WZY_WS_AIMABLEENT: "ခ်ိန္ႏိုင္သည့္အန္တစ္တီ",
  T_37_WZY_WS_AIMASSISTTYPE: "ခ်ိန္ခ်က္ကူညီအမ်ိဳးစား",
  T_37_WZY_WS_ALLOWDROP_NAME: "အိုင္တန္က် ဖြင့္/ပိတ္",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "ကစားသမားအိုင္တန္ခ်ႏိုင္မခ်ႏိုင္",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "အိုင္တန္ခ်မခ်စိစစ္ရန္ကစားသမားအန္တစ္တီ",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "ကစားသမားသည္အိုင္တန္ကိုခ်ႏိုင္မခ်ႏိုင္. ဤသည္မွာဘိုလီယံတန္ဖိုးျဖစ္သည္.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "အိုင္တန္ေကာက္ျခင္း ဖြင့္/ပိတ္",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "ကစားသမားကပစၥည္းေတြကိုေကာက္ယူႏိုင္မလား",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "ပစၥည္းမ်ားေကာက္ျခင္း ရွိ၊မရွိကိုစီစဥ္သတ္မွတ္ရန္ကစားသမား entity",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "ကစားသမားပစၥည္းေတြကိုေကာက္ယူႏိုင္မလား. ဒါက Boolean တန္ဖိုးပါ.",
  T_37_WZY_WS_AMBIENTCOLOR: "ပတ္ဝန္းက်င္အလင္းေရာင္",
  T_37_WZY_WS_AMRORTOOL: "က်ည္ကာျပဳျပင္",
  T_37_WZY_WS_ATTACK: "တိုက္ခိုက္",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "၎တို႔၏ပုံမွန္အသြင္အျပင္သို႔ ျပန္လည္ေရာက္ရွိေစရန္ ကစားသမား၏အသြင္အျပင္ကိုပယ္ဖ်က္ပါ.",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "ပယ္ဖ်က္ရန္ဖုံးကြယ္ထားေသာကစားသမားမ်ား",
  T_37_WZY_WS_BALLADDV_NAMEDES: "ေဘာလံုး၏အလ်င္တိုးျမွင့္သည္",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "ေဘာလံုးကိုအရွိန္ျမွင့္ရန္",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "ဗက္တာအျမန္ႏွဳန္း",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "ေဘာလုံးကို Football Shooter ကထိမိတဲ့အခါအစပ်ိဳးသည္ [Player entity] သည္ Football Shooter ကို ပိုင္ဆိုင္ေသာကစားသမားျဖစ္သည္. [Speed Boost] သည္ ထိမွန္ၿပီးေနာက္ေဘာလုံး၏ထပ္ေလာင္းအျမန္ႏႈန္းျဖစ္သည္.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "ေဘာလံုးစက္ပိုင္သည့္ကစားသမား",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "အပစ္ခံရျပီးေနာက္ေဘာလံုး၏ဗက္တာအလ်င္",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "ေဘာလုံးသည္အရာဝတၳဳတစ္ခုႏွင့္ တိုက္မိၿပီးေဘာလုံး၏အရွိန္တိုးလာေသာအခါ အစပ်ိဳးသည္. [Colliding entity] သည္ေဘာလုံးႏွင့္ တိုက္မိေသာအရာျဖစ္သည္.[Speed Boost] သည္ တိုက္မိၿပီးေနာက္ေဘာလုံး၏ထပ္ေလာင္းအျမန္ႏႈန္းျဖစ္သည္.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "ေဘာလံုးႏွင့္တိုက္မိသည့္အန္တစ္တီ",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "တိုက္မိသည့္အခါေဘာလုံးသို႔ ေပါင္းထည့္ေသာအရွိန္အဟုန္",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "ကစားသမားတစ္ဦးမွရည္မွန္းထားသည့္အရာအားအစပ်ိဳးေပးသည္",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "အန္တစ္တီကိုခ်ိန္ေနသည့္ကစားသမား",
  T_37_WZY_WS_BEHAVIORSTAT: "ကစားသမားအျပဳအမူအေနအထား",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "တိုက္ခိုက္ရာတြင္အသံုးျပဳေသာလက္နက္",
  T_37_WZY_WS_BLOODBARENT: "ေသြဘားအန္တစ္တီ",
  T_37_WZY_WS_BOMBEND: "ေပါက္ကြဲမွဳမတိုင္မီ",
  T_37_WZY_WS_BOMBSTART: "ဗံုးအခ်က္ျပျခင္း",
  T_37_WZY_WS_CHANENT: "ခ်န္နယ္အန္တစ္တီ",
  T_37_WZY_WS_CHEER: "ခ်ီးယား",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "ေရြးထားသည့္အန္တစ္တီသည္သတ္မွတ္ထားသည့္ကတ္ျပားပါဝင္မဝင္စစ္ပါ",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "၎တြင္တဂ္မ်ား ပါဝင္ျခင္း ရွိ၊ မရွိ စစ္ေဆးရန္အဖြဲ႕အစည္း",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "စစ္ေဆးရန္ကတ္ျပား",
  T_37_WZY_WS_CHELABELRES: "Tag စစ္ေဆးျခင္း၏ရလဒ္. ဒါက Boolean တန္ဖိုးပါ.",
  T_37_WZY_WS_CJERSEY_NAME: "ဂ်ာစီေျပာင္း",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "ဂ်ာစီေျပာင္းရမည့္ကစားသမား",
  T_37_WZY_WS_CJERSEY_PARAM2: "ဂ်ာစီဒီဇိုင္း",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "ဒီဇိုင္းေျပာင္းရန္",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "ဂ်ာစီေပၚရွိအပိုင္း 1 ၏အေရာင္",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "ဂ်ာစီေပၚတြင္အပိုင္း 2 ၏အေရာင္",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "ဂ်ာစီေပၚတြင္ အပိုင္း 3 ၏အေရာင္",
  T_37_WZY_WS_CJERSEYTYPE1: "ဒီဇိုင္း 1",
  T_37_WZY_WS_CJERSEYTYPE2: "ဒီဇိုင္း 2",
  T_37_WZY_WS_CJERSEYTYPE3: "ဒီဇိုင္း 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "စာရင္းထဲရွိအစိတ္အပိုင္းအားလုံးကိုရွင္းပါ",
  T_37_WZY_WS_CREABLEOB_DESC: "ဘေလာက္မ်ားကို အသုံးျပဳ၍ဖန္တီးႏိုင္ေသာအရာဝတၳဳအမ်ိဳးအစား",
  T_37_WZY_WS_CREPROD_NAMEDESC: "စိတ္ႀကိဳက္ျပင္ဆင္ႏိုင္ေသာကုန္ပစၥည္းတစ္ခုကိုဖန္တီးၿပီးကုန္ပစၥည္းတစ္ခုအား ျပန္ပို႔ပါ. အေရာင္းအ၀ယ္အေၾကာင္းအရာကိုပိုင္ဆိုင္မႈဆက္တင္မ်ားမွတစ္ဆင့္ ျပင္ဆင္သတ္မွတ္ႏိုင္သည္.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "စိတ္ႀကိဳက္ျပင္ဆင္ႏိုင္ေသာကုန္ပစၥည္းစာရင္းကိုဖန္တီးၿပီး ကုန္ပစၥည္းစာရင္းတစ္ခုအားျပန္ပို႔ပါ. ဤစာရင္း၏အေၾကာင္းအရာကိုပိုင္ဆိုင္မႈဆက္တင္မ်ားမွတစ္ဆင့္ ေျပာင္းလဲႏိုင္သည္.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "ဖန္တီးရမည့္ကုန္ပစၥည္းစာရင္း",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "အဖြဲ႕ခြဲတစ္ခုဖန္တီးပါ",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "ဂိုဏ္းခြဲဖြဲ႕စည္းမည့္အဖြဲ႕အစည္း",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "စိတ္ၾကိဳက္ဖန္တီးႏိုင္ေသာစတိုးကိုဖန္တီးျပီးစတိုးအန္တစ္တီတစ္ခုသို႔ျပန္ပို႔ပါ. စတိုး၏အေၾကာင္းရာသည္ပိုင္ဆိုင္မွဳဆက္တင္တြင္ေျပာင္းႏိုင္သည္.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "ဖန္တီးျပီးသည့္စတိုးအန္တစ္တီ",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "ဂိမ္းတြင္းေကာင္းကင္၏ပတ္ဝန္းက်င္ေျပာင္းမည္. ေရြးခ်ယ္မွဳမ်ားတြင္ေန႔, ေနဝင္ရီ ႏွင့္ညပါဝင္သည္.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "ေကာင္းကင္အမ်ိဳးအစားကိုေျပာင္းလဲေပးလိုက္ပါ. ေ႐ြးခ်ယ္မႈမ်ားတြင္ ေန႔၊ ညေစာင္းႏွင့္ ညတို႔ပါဝင္သည္",
  T_37_WZY_WS_DARKNESS: "အေမွာင္ထု",
  T_37_WZY_WS_DELENT_NAMEDESC: "သတ္မွတ္ထားသည့္ အန္တစ္တီဖ်က္သိမ္း. လက္ရွိကူညီအိုင္ကြန္အန္တစ္တီ, စာသားအန္တစ္တီ, HUD အန္တစ္တီ, ျမင္ကြင္းအက္ဖက္အန္တစ္တီ, လက္နက္အန္တစ္တီ, ႏွင့္အျခားအရာအန္တစ္တီ.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "ဖ်က္သိမ္းရန္အန္တစ္တီ",
  T_37_WZY_WS_DROP: "အမွား",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "ကစားသမားအိုင္တန္ခ်ေသာအခါအစျပဳသည္. [အိုင္တန္အမ်ိဳးအစား] သည္ခ်သည့္အိုင္တန္၏ ID ျဖစ္သည္.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "က်သည့္အိုင္တန္၏အမ်ိဳးအစား ID",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "ကစားသမားလက္နက္ခ်တဲ့အခါအစပ်ိဳးသည္ [Weapon entity] သည္ပစ္ခ်ခံရေသာလက္နက္ျဖစ္သည္",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "ခ်သည့္လက္နက္",
  T_37_WZY_WS_DUMMYLEOBJ: "ပုံမွန္အဆင့္အရာ",
  T_37_WZY_WS_DUST: "ဆည္းဆာ",
  T_37_WZY_WS_EMPTYCH: "မူရင္းအလြတ္ခ်န္နယ္",
  T_37_WZY_WS_EMPTYCH1: "ခ်န္နယ္အလြတ္ 1",
  T_37_WZY_WS_EMPTYCH2: "ခ်န္နယ္အလြတ္ 2",
  T_37_WZY_WS_EMPTYCH3: "ခ်န္နယ္အလြတ္ 3",
  T_37_WZY_WS_EMPTYCH4: "ခ်န္နယ္အလြတ္ 4",
  T_37_WZY_WS_EMPTYCH5: "ခ်န္နယ္အလြတ္ 5",
  T_37_WZY_WS_EMPTYCH6: "ခ်န္နယ္အလြတ္ 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: `အေျခေန 3 ရပ္ကိုေက်နပ္သည့္အန္တစ္တီအားလံုးပါဝင္သည့္စာရင္းရရွိသည္. အေၾကာင္းရာသည္ "Includes all", "Excludes"အတြက္ထည့္ထားသည္, 
ႏွင့္င့္ "Includes" စင္ဂဲယ္ဘက္စပ္ပါဝင္အမ်ိဳးစား သို႔ ဘက္စပ္ပါဝင္အမ်ိဳးစားစာရင္းျဖစ္သည္. ျပန္လာသည့္ရလဒ္သည္အေျခေနကိုေက်နပ္ေစသည့္ အန္တစ္တီစာရင္းျဖစ္သည္.`,
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "စစ္ထုတ္ထားေသာအရာမ်ားသည္ ဤအခင္းအက်င္းမွအစိတ္အပိုင္းအားလုံးပါဝင္ရပါမည္",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "စစ္ထုတ္ထားေသာအရာမ်ားသည္ ဤအာရပ္မွသတ္မွတ္ထားေသာအစိတ္အပိုင္း(မ်ား) မပါဝင္ရပါ.",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "စစ္ထုတ္ထားေသာအရာမ်ားသည္ဤအခင္းအက်င္းမွ အနည္းဆုံးအစိတ္အပိုင္းတစ္ခု ပါဝင္ရပါမည္",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "ေျပာင္းလဲရန္ ဤအဖြဲ႕အစည္း၏ပိုင္ဆိုင္မႈအမ်ိဳးအစား",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "ေျပာင္းရန္ပိုင္ဆိုင္မွဳတန္ဖိုး",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "ကစားသမားကိုလက္ရွိခ်န္နယ္တြင္ေပးထြက္ပါ ထိုမွသာသူတို႔သည္မည္သည့္ခ်န္နယ္မွာမွမရွိပါ",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "ခ်န္နယ္မွထြက္ရန္ကစားသမား",
  T_37_WZY_WS_FAKEENT: "ရုပ္ဖ်က္တပ္ဖြဲ႕",
  T_37_WZY_WS_FIND_STR_DESC: "စာေၾကာင္းတစ္ခုအတြင္းသတ္မွတ္ထားေသာစာသားတစ္ခု၏တည္ေနရာကိုရွာပါ",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "ရွာရန္စာလံုး",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "0 မွအစျပဳသည့္ စတင္တည္ေနရာမွ စာေၾကာင္းတစ္ေၾကာင္းကိုရွာပါ",
  T_37_WZY_WS_FINDSTRRES: "စာေၾကာင္းေပၚလာသည့္ပထမဆံုးတည္ေနရာမွစတင္သည္",
  T_37_WZY_WS_FOGCOLOR: "ျမဴခိုးအေရာင္",
  T_37_WZY_WS_FRICTIONCON: "ပုံမွန္ပြတ္တိုက္မႈအေျမႇာက္",
  T_37_WZY_WS_FRICTIONIMP: "ယာဥ္တိုက္မႈ ပြတ္တိုက္မႈအေျမႇာက္",
  T_37_WZY_WS_FROMDEATH: "ျပန္ရွင္ျခင္း",
  T_37_WZY_WS_FROMKNODOWN: "ကူညီမည္",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "သတ္မွတ္ထားေသာ ကစားသမားတြင္ရွိေသာခ်န္နယ္ကိုရယူပါ",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "ရယူမည့္႐ုပ္သံလိုင္းမွကစားသမားအဖြဲ႕အစည္း",
  T_37_WZY_WS_GETCHANRES: "ကစားသမားလက္ရွိရွိေနသည့္ခ်န္နယ္",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "ခ်န္နယ္ ID 1 မွ 8 အရ၊ ဂိမ္းအစတြင္ ပုံေသဖန္တီးထားသည့္ အလြတ္ခ်န္နယ္ကို ရယူပါ",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "မူရင္းအလြတ္ခ်န္နယ္၏ ID",
  T_37_WZY_WS_GETEMPTYCH_RES: "ရရွိသည့္ခ်န္နယ္အန္တစ္တီ",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "အရာဝတၳဳ၏အသြင္ေျပာင္းအန္တစ္တီရရွိသည္. ကစားသမား၏အသြင္ျပင္ေျပာင္းလဲရန္သံုးပါ.",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "ရုပ္ဖ်က္ထားေသာအရာအန္တစ္တီကိုရယူပါ",
  T_37_WZY_WS_GETGAMEENT_NAME: "ကိုက္ညီမႈအန္တစ္တီကိုရယူပါ",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "ဤကစားပြဲ၏ဂိမ္းအန္တစ္တီရရွိသည္",
  T_37_WZY_WS_GETHOSTPLA_NAME: "တိုက္ခိုက္ႏိုင္ေသာကစားသမားရရွိ",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "အဖြဲ႕ခြဲအန္တစ္တီ",
  T_37_WZY_WS_GOAL_NAMEDESC: "ေဘာလံုးဂိုးဝင္ေသာအခါအစပ်ိဳးသည္. [ဂိုး] မွာဤေဘာလံုးဝင္သည့္ဂိုးျဖစ္သည္. [ေဘာလံုးကစားသမား] သည္ေဘာလံုးႏွင့္ေနာက္ဆံုးဆက္စပ္သူျဖစ္သည္. [ကူညီမွဳ] သည္ ဒုတိယမွေနာက္ဆံုးကစားသမားထိ ေဘာလံုးႏွင့္လာေရာက္ဆက္စပ္ရမည္ျဖစ္သည္.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "ဒီေဘာလံုးဝင္တဲ့ဂိုး",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "ေဘာလုံးနဲ႔ ထိေတြ႕ခြင့္ရတဲ့ ေနာက္ဆုံးကစားသမား",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "ေဘာလုံးနဲ႔ ထိေတြ႕ရတဲ့ ဒုတိယမွ ေနာက္ဆုံးကစားသမား",
  T_37_WZY_WS_HEARTBEAT: "ရင္ခုန္သံ",
  T_37_WZY_WS_HEAVYWEAPON: "ေလးလံေသာလက္နက္",
  T_37_WZY_WS_HIHGSHOOTANGLE: "အေသးငယ္ဆံုးေဘာ္လီေထာင့္",
  T_37_WZY_WS_HOSTPLA: "တိုက္ႏိုင္ေသာကစားသမားစာရင္း",
  T_37_WZY_WS_HOSTSIDE: "တိုက္ခိုက္ႏိုင္သည့္ဂိုဏ္း၏စာရင္း",
  T_37_WZY_WS_HOSTTEAM: "တိုက္ခိုက္ႏိုင္သည့္အသင္းစာရင္း",
  T_37_WZY_WS_ICON_CLOCK: "ႏွစ္သစ္",
  T_37_WZY_WS_ICON_CLOTHES: "အဝတ္စားမ်ား",
  T_37_WZY_WS_ICON_QUIT: "ထြက္မည္",
  T_37_WZY_WS_INSERT_ARR_DESC: "စာရင္းရွိသတ္မွတ္ထားေသာတည္ေနရာသို႔ အစိတ္အပိုင္းအသစ္တစ္ခုကိုထည့္သြင္းပါ",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "အၫႊန္းတည္ေနရာမွစတင္၍သတ္မွတ္ထားေသာ အရွည္၏စာေၾကာင္းတစ္ခုကိုထုတ္ယူပါ. ထုတ္ယူမႈအရွည္သည္စာေၾကာင္းအရွည္ထက္ေက်ာ္လြန္ပါက၊ ၎သည္ စာေၾကာင္းအဆုံးအထိ အေၾကာင္းအရာကိုထုတ္ယူမည္ျဖစ္သည္.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "ထုတ္ယူမွဳ၏အရွည္",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "ျဖည္လိုက္ေသာစာေၾကာင္း",
  T_37_WZY_WS_INTORINTL: "ကိန္းျပည့္ သို႔ ကိန္းျပည့္စာရင္း",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "ကစားသမားအားသတ္မွတ္ထားေသာအဖြဲ႕ခြဲတြင္ပါဝင္ခြင့္ျပဳပါ",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "ကစားသမားခ်ိတ္ဆက္ရန္အပိုင္းခြဲ",
  T_37_WZY_WS_JUMP: "ခုန္",
  T_37_WZY_WS_LABEL: "ကတ္ျပား",
  T_37_WZY_WS_LENSFLARE: "မွန္ဘီလူးမီးေတာက္",
  T_37_WZY_WS_LENTH: "အရွည္",
  T_37_WZY_WS_LIGHTATTACK: "ေအာင္ျမင္သည့္ရိုက္ခ်က္",
  T_37_WZY_WS_LIGHTCOLOR: "အလင္းအရင္းျမစ္အေရာင္",
  T_37_WZY_WS_LIGHTINTENSITY: "အလင္းရင္းျမစ္ေတာက္ပမႈ",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "ရွဳခင္းအသစ္ကိုသံုးပါ",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "ရွဴခင္းအမည္ကိုတင္ရန္",
  T_37_WZY_WS_MOROBJECT: "အရာဝတၳဳကိုဖုံးကြယ္ထားပါ",
  T_37_WZY_WS_MOVEAXISX: "x ဝင္ရိုးအေလွ်ာက္ေရြ႕လ်ားသည္",
  T_37_WZY_WS_MOVEAXISY: "y ဝင္ရိုးတစ္ေလွ်ာက္ေရြ႕ပါ",
  T_37_WZY_WS_MOVEAXISZ: "z ဝင္ရိုးတစ္ေလွ်ာက္ေရြ႕ပါ",
  T_37_WZY_WS_MOVEDISTITLE: "ေရြ႕လ်ားမွဳအကြာအေဝး",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "အျမန္မက္ေဆ့ခ်္ ဖြင့္/ပိတ္",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "အျမန္စာတိုမ်ားကို ဖြင့္ပါ သို႔မဟုတ္ ပိတ္ပါ. ပိတ္သည့္အခါ၊ အျမန္မက္ေဆ့ခ်္ HUD ကို အသုံးမျပဳႏိုင္ဘဲကစားသမားမ်ားသည္အျမန္မက္ေဆ့ခ်္မ်ား ေပးပို႔ျခင္း သို႔မဟုတ္ လက္ခံျခင္းတို႔ကို ျပဳလုပ္ႏိုင္မည္မဟုတ္ပါ.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "အျမန္မက္ေဆ့ခ်္မ်ားကို ဖြင့္/ပိတ္ရန္ ကစားသမား",
  T_37_WZY_WS_MUTEVOICE_NAME: "အသံခ်က္တင္ ဖြင့္/ပိတ္",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "အသံခ်တ္ကို အဖြင့္ သို႔မဟုတ္ ပိတ္ပါ. ပိတ္သည့္အခါ၊ အသံ HUD ကိုအသုံးမျပဳႏိုင္ဘဲကစားသမားသည္ အသံမက္ေဆ့ခ်္မ်ားေပးပို႔ျခင္း သို႔မဟုတ္ လက္ခံျခင္းတို႔ကိုျပဳလုပ္ႏိုင္မည္မဟုတ္ေပ.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "အသံစကားေျပာ ဖြင့္/ပိတ္ရမည့္ကစားသမားအတြက္",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "ဘိုလ်င္. အမွန္ကိုပိတ္ျခင္း, အမွားကိုဖြင့္ျခင္းဆိုလိုသည္.",
  T_37_WZY_WS_NIGHTMODE: "ညမုဒ္",
  T_37_WZY_WS_ONAIM_NAMEDESC: "ကစားသမားသည္ရည္႐ြယ္ခ်က္ရွိေသာအရာတစ္ခုကိုခ်ိန္႐ြယ္သည့္အခါအစပ်ိဳးသည္.[Target entity] သည္ ရည္႐ြယ္ထားေသာအရာျဖစ္သည္. ရည္႐ြယ္ထားသည့္အရာမရွိေသာအခါ၊ ျပန္တန္ဖိုးသည္ null ျဖစ္သည္.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "အန္တစ္တီခ်ိန္သည္",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "လက္နက္ထိမွန္ထားသည့္အန္တစ္တီ",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "ရွဳခင္းေအာင္ျမင္စြာဆြဲျပီးေသာအခါအစပ်ိဳးသည္",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "ရွဳခင္းအမည္ကိုတင္ရန္. ဒါကၾကိဳးတစ္ေခ်ာင္းပါ.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "ဒီေန႔ကဒရမ္တီးဖို႔ရည္စူးထားတဲ့ေန႔ပါ. ေခြၽးမရွိ၊ အေလာင္းအစားမရွိ!",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "ရႈခင္းသစ္၏အမည္. ဒါကၾကိဳးတစ္ေခ်ာင္းပါ.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "ကစားသမား၏အဝတ္အစားမ်ားကို ၎၏မူလပုံစံသို႔ ျပန္ယူပါ",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "အၾကင္ကစားသမားသည္ ပုံေသအဝတ္အစားကို မူလအတိုင္းျပန္ေပးသည္.",
  T_37_WZY_WS_PETSET: "အေကာငိဆက္တင္",
  T_37_WZY_WS_PETSKILL: "အေကာင္စြမ္းရည္",
  T_37_WZY_WS_PETSWITCH2: "တိုက္ပြဲအေဖာ္စြမ္းရည္အသံုးျပဳမျပဳ",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "ကစားသမားေရြ႕လ်ားမွဳဖြင့္သည္ျဖစ္ေစ. ဤသည္မွာဘိုလင္းတန္ဖိုးျဖစ္သည္.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "ကစားသမားအျပဳအမူအမ်ိဳးအစား",
  T_37_WZY_WS_PRESS: "ညင္သာစြာႏွိပ္ပါ",
  T_37_WZY_WS_PROGRESS: "လက္ရွိတိုးတက္မွဳ",
  T_37_WZY_WS_PROGRESSBAR: "HUD အန္တစ္တီတိုးတက္မွဳ",
  T_37_WZY_WS_RANKDOWN: "အဆင့္က်",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "ေ႐ြးခ်ယ္ထားေသာယူနစ္အတြက္တဂ္ကိုဖယ္ရွားပါ",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "ဖယ္ရွားရန္စာသားအေၾကာင္းရာ",
  T_37_WZY_WS_REPLACE_STR_DESC: "စာေၾကာင္းတစ္ခု၏အေၾကာင္းအရာကို သတ္မွတ္ထားေသာအေၾကာင္းအရာတစ္ခုျဖင့္အစားထိုးပါ",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "အစားထိုးရမည့္ဇာတ္ေကာင္",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "ဇာတ္ေကာင္အသစ္ျဖင့္အစားထိုးရန္",
  T_37_WZY_WS_REVERSE_ARR_DESC: "ဤစာရင္းရွိအစိတ္အပိုင္းအားလုံးကိုေျပာင္းျပန္လွန္ပါ",
  T_37_WZY_WS_REVIVEHERE: "ဤျပန္လည္ႏိုးၾကားလာခ်ိန္တြင္အသင္းေဖာ္မ်ားကိုျပန္လည္အသက္သြင္းေနေသာ ကစားသမားျဖစ္သည္.",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "ကစားသမားတစ္ဦးသည္ အသင္းေဖာ္မ်ားအားဤျပန္လည္ႏိုးၾကားလာခ်ိန္တြင္ ျပန္လည္အသက္သြင္းသည့္အခါအစပ်ိဳးသည္",
  T_37_WZY_WS_REVIVEWAYDESC: "ကစားသမားသည္ေခ်မွဳန္းခံရသည္ သို႔ အလဲထိုးခံရျပီးမွ ကယ္တင္ခံရသည္ သို႔ ကူညီခံရသည့္နည္းလမ္း",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "ကစားသမားအတြက္ကြဲျပားေသာအျပဳမွဳအေျခေန. ပိတ္ထားသည့္အခါ, HUD ေပၚကသက္ဆိုင္သည့္ခလုတ္သည္သံုးမရပါ, အလိုေလ်ာက္ ႏွင့္ထိန္းခ်ဳပ္ေရြ႕လ်ားမွဳခြင့္မျပဳထားပါ. ဝွက္ထားေသာအခါ, သက္ဆိုင္ရာခလုတ္သည္ HUD တြင္ျပသမည္မဟုတ္ပါ, and manual movements are not allowed while automatic movements are allowed. When enabled, the corresponding buttons will be displayed on the HUD, and manual and automatic movements are allowed.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "အျပဳအမူအေျခေနျပရန္ကစားသမား",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "ကစားသမားအျပဳအမူ, ေရြ႕လ်ားမွဳအပါအဝင္, တိုက္ခိုက္မွဳ, ခုန္ျခင္းႏွင့္ ေျပးျခင္း",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "အေျခေနမ်ားတြင္ပိတ္သည္, ဝွက္ထားသည္, ႏွင့္ဖြင့္သည္ပါဝင္သည္. ဝွက္ထားေသာအခါ, သက္ဆိုင္သည့္ခလုတ္သည္ HUD တြင္ျပသလိမ့္မည္မဟုတ္ပါ, ျပီးေတာ့ အလိုေလ်ာက္ေရြ႕လ်ားမွဳမ်ားကိုခြင့္ျပဳထားလွ်င္လက္ျဖင့္ေရြ႕လ်ားမွဳကိုခြင့္မျပဳပါ. ဖြင့္ထားေသာအခါ, သက္ဆိုင္သည့္ခလုတ္သည္ HUD တြင္ျပသလိမ့္မည္, အလိုေလ်ာက္ႏွင့္ လက္ျဖင့္ေရြ႕သည့္ေရြ႕လ်ားမွဳသည္ခြင့္ျပဳသည္.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "The coordinates of the football",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Whether the football should maintain its pre-configuration speed. This is a Boolean value.",
  T_37_WZY_WS_SETPLAHOST_NAME: "ကစားသူတိုက္ခိုက္ဆက္တင္",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "[Setting player] သည္ [Target player] ကို တိုက္ခိုက္ႏိုင္ျခင္း ရွိမရွိ စီစဥ္သတ္မွတ္ပါ. မူရင္းဆက္တင္သည္ ပစ္မွတ္ကစားသမားသည္ တိုက္ခိုက္ႏိုင္သည့္အသင္းႏွင့္ အဖြဲ႕ခြဲတစ္ခုရွိမရွိအေပၚ အေျခခံထားသည္. ဤဆက္တင္သည္ အသင္း/အဖြဲ႕ခြဲဆက္တင္ထက္ ပိုမိုဦးစားေပးပါသည္.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "ရန္သသူမ်ားကိုစိစစ္လုပ္ရန္ကစားသမား",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "ရန္သူျဖစ္သည့္ကစားသမား",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "တိုက္ခိုက္ရမရ",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: 'တိုက္ခိုက္ႏိုင္ေသာ၊ "မဟုတ္ဘူး" မတိုက္ခိုက္ႏိုင္ဘူးလို႔ဆိုလိုတာပါ. မူရင္းဆက္တင္သည္ပစ္မွတ္ကစားသမားသည္ တိုက္ခိုက္ႏိုင္သည့္အသင္းႏွင့္အဖြဲ႕ခြဲတစ္ခုရွိမရွိအေပၚအေျခခံထားသည္.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"ဟုတ္" တိုက္ခိုက္ႏိုင္ေသာ၊ "မဟုတ္ဘူး" မတိုက္ခိုက္ႏိုင္ဘူးလို႔ဆိုလိုတာပါ',
  T_37_WZY_WS_SHADOWSTRENGTH: "အရိပ္မ်ား",
  T_37_WZY_WS_SHOOTANGLE: "အေသးငယ္ဆံုးရိုက္ကြင္း",
  T_37_WZY_WS_SKYBOX: "ေကာင္းကင္",
  T_37_WZY_WS_SKYBOXENT: "စကိုင္းအန္တစ္တီ",
  T_37_WZY_WS_SKYBOXTYPE: "အေျခခံေကာင္းကင္အမ်ိဳးစား",
  T_37_WZY_WS_STEPPED: "အသက္သြင္းျခင္းအဆင့္",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "ကစားသမား၏အသံခ်က္တင္ခ်န္နယ္ကိုေျပာင္းပါ",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "ကစားသမားသည္ ခ်န္နယ္ေျပာင္းရန္",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "ေျပာင္းလဲရန္ခ်န္နယ္",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "သတ္မွတ္ထားသည့္ရွဳခင္းသို႔ေျပာင္းပါ",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "ေျပာင္းမည့္ရွဳခင္းအမည္",
  T_37_WZY_WS_TARGETSTR_DESC: "ပစ္မွတ္ဆက္တင္",
  T_37_WZY_WS_TEAMASIDE: "အသင္း ႏွင့္ အဖြဲ႕ခြဲ",
  T_37_WZY_WS_TELEPORTN_AUTO: "ေအာ္တို",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "တယ္လီပို႔ႏိုင္သည္ျဖစ္ေစ",
  T_37_WZY_WS_TELEPORTN_MANUAL: "လူကိုယ္တိုင္",
  T_37_WZY_WS_TELEPORTN_NO: "မလုပ္ပါ",
  T_37_WZY_WS_TELEPORTN_TITLE: "တယ္လီပို႔နည္းလမ္း",
  T_37_WZY_WS_TELEPORTN_YES: "အတည္ျပဳ",
  T_37_WZY_WS_TERRAINWET: "ေျမျပင္အစိုဓါတ္",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "[Player entity] အတြက္ [Disguise entity] ထည့္ပါ",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "ကစားသမား၏အသြင္အျပင္ကိုေျပာင္းလဲရန္",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "အသြင္ေျပာင္းယူနစ္သို႔ ေျပာင္းလဲရန္",
  T_37_WZY_WS_TRANSP: "ျမင္သာမွဳ",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "သတ္မွတ္ထားေသာရွဴခင္းကိုျဖဳတ္ပါ",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "ရွဳခင္းအမည္ကိုျဖဳတ္ပါ",
  T_37_WZY_WS_VFX1: "သေကၤတ",
  T_37_WZY_WS_VFX2: "မီးခိုးေငြ႕",
  T_37_WZY_WS_VFX3: "က်ိန္စာေပါက္ကြဲမွဳ",
  T_37_WZY_WS_VFX5: "ႏွင္းခဲ",
  T_37_WZY_WS_VFX6: "မီးေမာင္း",
  T_37_WZY_WS_VFX7: "ဖရိုဖရဲ",
  T_37_WZY_WS_VFX8: "ေလထုေပါက္ကြဲမႈ",
  T_37_WZY_WS_VISABLE: "ျမင္ႏိုင္စြမ္း",
  T_37_WZY_WS_WEAOPEN: "ျပသမည္ေလာ?",
  T_37_WZY_WS_WEAPONENT: "လက္နက္အန္တစ္တီ",
  T_37_WZY_WS_WEATARGETED: "ရည္႐ြယ္ခ်က္ျဖင့္ပစ္မွတ္ထားႏိုင္သလား",
  T_37_XYL_CUSTOMJERSEY: "ဂ်ာစီစက္",
  T_37_XYL_CUSTOMJERSEY_DESC: "သင္၏စံျပဂ်ာစီကိုဖန္တီးရန္ဂ်ာစီစက္ကိုသုံးပါ",
  T_37_XYL_FOOTGUN: "ေဘာလံုးစက္",
  T_37_XYL_SOCCER: "ေဘာလံုး",
  "T_37_XYL_SOCCER_ RADIUS": "စက္ဝန္း",
  T_37_XYL_SOCCER_DESC: "စိတ္ႀကိဳက္ျပင္ဆင္ႏိုင္ေသာေဘာလုံးမ်ိဳးျဖစ္သည္",
  T_37_XYL_SOCCER_HIGHT1: "ပံုမွန္ေထာင့္",
  T_37_XYL_SOCCER_HIGHT2: "ေဘာလီေထာင့္",
  T_37_XYL_SOCCER_RESET: "ဂိုးရျပီးေနာက္အခ်ိန္ျပန္စ",
  T_37_XYL_SOCCER_RESIST1: "ပြတ္တိုက္မႈ (ကန္သြင္းမုဒ္)",
  T_37_XYL_SOCCER_RESIST2: "ပြတ္တိုက္မွဳ (ေသနတ္မုဒ္)",
  T_37_XYL_SOCCERGOAL: "ဂိုးေပါက္",
  T_37_XYL_SOCCERGOAL_DESC: "ဤသည္မွာဂိုးျဖစ္သည္. ဂိုးသြင္းရန္ေဘာလံုးကိုပစ္ပါ. (အမွတ္ဖမ္းရာတြင္သာအက်ံဳးဝင္သည္)",
  T_37_XYL_SOCCERITEM: "ေပၚထြက္အိုင္တန္",
  T_37_XYL_SOCCERITEM_DESC: "ထားရွိျပီးသည့္အခါ, ေရြးထားသည့္အိုင္တန္ထုတ္ေပးလိမ့္မည္",
  T_37_XYL_SPAWN_PEOPLE: "ကစားသမားအေရတြက္",
  T_37_XYL_WS_AIRCONDITIONER001: "အဲကြန္း B",
  T_37_XYL_WS_AMMUCHEST: "တိုက္ပြဲေသတၱာ A",
  T_37_XYL_WS_BAFFLE001: "စည္ပိုင္း A",
  T_37_XYL_WS_BARREL001: "စည္ပိုင္း",
  T_37_XYL_WS_BARREL001_DES: "အဝိုင္းပတ္ထားေသာသစ္သားစည္မ်ားကိုေတြ႕ရမ်ားသည္",
  T_37_XYL_WS_BOARD001: "ေၾကာ္ညာဘုတ္ B",
  T_37_XYL_WS_BOOK001: "စာအုပ္အပံု A",
  T_37_XYL_WS_BOOK002: "စာအုပ္ B အုပ္စု",
  T_37_XYL_WS_BOUGAINVILLEA: "Bougainvillea",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "အျပင္အဆင္ - ေနရာကိုေတာက္ပေစပါသည္",
  T_37_XYL_WS_BOX001: "A ပံုးမ်ား",
  T_37_XYL_WS_BOX002: "စေမာလ္ေသတၱာ",
  T_37_XYL_WS_BUSHCOVER: "ခ်ံဳ",
  T_37_XYL_WS_BUSHCOVER_DES: "ပုန္းေအာင္းရန္အသုံးျပဳႏိုင္ေသာခ်ဳံတစ္ပင္",
  T_37_XYL_WS_CABINET001: "အံဆြဲ A",
  T_37_XYL_WS_CHAIR001: "ခုန္ A",
  T_37_XYL_WS_COCONUTTREE: "အုန္းပင္",
  T_37_XYL_WS_COCONUTTREE_DES: "အျပင္အဆင္ - သာယာေသာကမ္းေျခ",
  T_37_XYL_WS_COMPUTER001: "ကြန္ပ်ဴတာ A",
  T_37_XYL_WS_DAMAGERATIO: "Damage Ratio",
  T_37_XYL_WS_FIREEX: "မီးသတ္ေဆးဘူး",
  T_37_XYL_WS_GUIDEPOSE: "ညႊန္ျပသည္",
  T_37_XYL_WS_HUGEHOUSE001: "3 ထပ္အိမ္",
  T_37_XYL_WS_HUGEHOUSE002: "2-Story House B",
  T_37_XYL_WS_JACKSTRAW: "စာေျခာက္ရုပ္",
  T_37_XYL_WS_LADDER001: "ေလွကား A",
  T_37_XYL_WS_OILDRUM: "ဆီအိုးအေသး",
  T_37_XYL_WS_ORNAMENT001: "ဖန္အိုး A",
  T_37_XYL_WS_PACKBOX: "ေထာက္ပံ့ေရးကြန္တိန္နာ",
  T_37_XYL_WS_PILLA001: "ကြန္ကရစ္တိုင္",
  T_37_XYL_WS_PRESENT: "လက္ေဆာင္ေသတၱာ",
  T_37_XYL_WS_PRESENT_DES: "အားလက္ရက္လက္ေဆာင္ပါဝင္သည္",
  T_37_XYL_WS_PUMPKIN: "Square Jack-O'-မီးအိမ္",
  T_37_XYL_WS_PUMPKINCUT: "Jack-O'-မီးအိမ္",
  T_37_XYL_WS_PUMPKINCUT_DES: "ေၾကာက္မက္ဖြယ္ေကာင္းေသာ ပြဲေတာ္တစ္ခုအတြက္အလွဆင္ေလ့ရွိသည္",
  T_37_XYL_WS_ROADBLOCK001: "လမ္းပိတ္ဆို႔႔မွဳ B",
  T_37_XYL_WS_SHELF001: "စာအုပ္စင္ A",
  T_37_XYL_WS_SOFA001: "ဆိုဖာ A",
  T_37_XYL_WS_SPAWNTEAM: "အသင္းအားလံုး",
  T_37_XYL_WS_SUPPLYBOX: "က်ည္ေသတၱာ",
  T_37_XYL_WS_TABLE001: "စားပြဲ A",
  T_37_XYL_WS_TABLE002: "စားပြဲ B",
  T_37_XYL_WS_TARGET001: "ပစ္မွတ္",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "ေပၚတယ္အဆံုးသတ္အမွတ္",
  T_37_XYL_WS_TELEPORTNEW: "ေပၚတယ္ A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "ေပၚတယ္၏အဆံုးသတ္အမွတ္ကစားသမားတယ္လီပို႔ႏိုင္သည့္ေပၚတယ္",
  T_37_XYL_WS_TIRES001: "အလႊာ A",
  T_37_XYL_WS_TOOLRACK: "စင္ကိရိယာမ်ား",
  T_37_XYL_WS_WALL001: "နံရံ",
  T_37_XYL_WS_WOOD001: "ခုတ္ထားသည့္သစ္သား",
  T_37_XYL_WS_YELLOWDUCK001: "ဘဲေဗာ္ယာ",
  T_37_XYL_WS_YELLOWDUCK001_DES: "ဘဲတစ္ေကာင္ပုံသ႑ာန္နဲ႔ ေဖာင္းေနတဲ့ေရကူးကြင္း",
  T_37_YM_BOMBSQUAD_DEFUSER: "ဗံုးတံ",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF အျဖဴဂ်ာစီ (ေဘာင္းဘီ)",
  T_37_YS_F_B_VN_STREET: "Crimson Auspicion (ေဘာင္းဘီ)",
  T_37_YS_F_H_VN_STREET: "Crimson Auspicion (ေခါင္းေဆာင္း)",
  T_37_YS_F_S_VN_STREET: "Crimson Auspicion (ဖိနပ္)",
  T_37_YS_F_T_VN_STREET: "Crimson Auspicion (အကၤ်ီ)",
  T_37_YS_M_A_CRICKET_BLACK: "ဘန္ဘလီခရစ္ကတ္သမား (မ်က္ႏွာဖံုး)",
  T_37_YS_M_A_THKOL: "မီးေတာက္ျပင္းဒဏ္ခတ္မွဳ (မ်က္ႏွာဖံုး)",
  T_37_YS_M_B_CRICKET_BLACK: "ဘန္ဘလီခရစ္ကတ္သမား (အေဘာင္းဘီ)",
  T_37_YS_M_B_SILVERERA: "အေၾကာက္တရားမဲ့အေစာင့္ (ေဘာင္းဘီ)",
  T_37_YS_M_B_THKOL: "မီးေတာက္ျပင္းဒဏ္ခတ္မွဳ (ေဘာင္းဘီ)",
  T_37_YS_M_H_SILVERERA: "အေၾကာက္တရားမဲ့အေစာင့္ (ေခါင္းေဆာင္း)",
  T_37_YS_M_H_THKOL: "မီးေတာက္ျပင္းဒဏ္ခတ္မွဳ (ေခါင္းေဆာင္း)",
  T_37_YS_M_S_CRICKET_BLACK: "ဘန္ဘလီခရစ္ကတ္သမား (ဖိနပ္)",
  T_37_YS_M_S_SILVERERA: "အေၾကာက္တရားမဲ့အေစာင့္ (ဖိနပ္)",
  T_37_YS_M_S_THKOL: "မီးေတာက္ျပင္းဒဏ္ခတ္မွဳ (ဖိနပ္)",
  T_37_YS_M_T_CRICKET_BLACK: "ဘန္ဘလီခရစ္ကတ္သမား (အကၤ်ီ)",
  T_37_YS_M_T_SILVERERA: "အေၾကာက္တရားမဲ့အေစာင့္ (အကၤ်ီ)",
  T_37_YS_M_T_THKOL: "မီးေတာက္ျပင္းဒဏ္ခတ္မွဳ (အကၤ်ီ)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF အျဖဴဂ်ာစီ (အကၤ်ီ)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "အနည္းဆံုးကစားသမား",
  T_38_BQ_SKILL_NAME_DUMMY1: "Stunt Double",
  T_38_BQ_SKILL_NAME_DUMMY2: "Shape Splitter",
  T_38_CJ_F_B_STREAMER_MUSIC: "e-Heartseeker (Bottom)",
  T_38_CJ_F_H_STREAMER_MUSIC: "e-Heartseeker (Head)",
  T_38_CJ_F_S_STREAMER_MUSIC: "e-Heartseeker (Shoes)",
  T_38_CJ_F_T_STREAMER_MUSIC: "e-Heartseeker (Top)",
  T_38_JH_WS_CM1: "Clear Rules",
  T_38_JH_WS_CM2: "Unclear Rules",
  T_38_JH_WS_CM3: "Frequent Quit Outs",
  T_38_JL_M79_AMMO_N: "M79 Ammo",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs' Microchip",
  T_38_M_WS_VECTOR2: "2D Vector",
  T_38_R_TACTICS_N: "Preset",
  T_38_RW_NIW_NIWNAME: "Gloo Maker",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Too many layers of blocks. Current: {0}. Max.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Number of items you've created ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Number of incidents received in the same frame ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Per-frame dynamic entity creation limit reached ({0}); {1} creation attempt(s) refused.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "Length of the initialized list ({0}) has exceeded the limit ({1}). Auto-creates a max capacity list.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Number of loops ({0}) has exceeded the limit ({1}). Loop interrupted",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "The number of concurrent coroutines  ({0}) in the coroutine scope has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Failed to add element to the list. List {0} is empty",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Mismatched value types when executing the basic arithmetic operation. The left value type is {0} and the right value type is {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Repeated temporary variable definition. Variable name: {0}.",
  T_38_SP_WS_REVIEW_01: "Toxic",
  T_38_SP_WS_REVIEW_02: "Vulgar",
  T_38_SP_WS_REVIEW_03: "Insulting",
  T_38_SP_WS_REVIEW_04: "Extremely Toxic",
  T_38_SP_WS_REVIEW_05: "Threatening",
  T_38_SP_WS_REVIEW_06: "Disrespectful",
  T_38_SP_WS_REVIEW_07: "Under Review",
  T_38_SP_WS_REVIEW_08: "{0} name {1} does not comply with the rules. {2}.",
  T_38_SP_WS_REVIEW_09: "String",
  T_38_SP_WS_REVIEW_10: "Store",
  T_38_SP_WS_REVIEW_11: "Variable",
  T_38_SP_WS_REVIEW_12: "Function",
  T_38_SP_WS_REVIEW_13: "Object",
  T_38_SP_WS_REVIEW_14: "Go to definition.",
  T_38_SP_WS_REVIEW_15: "Go to Manage Objects.",
  T_38_SP_WS_REVIEW_16: "No redirection.",
  T_38_SP_WS_REVIEW_17: "Map Name",
  T_38_SP_WS_REVIEW_18: "Description",
  T_38_SP_WS_REVIEW_19: "Cover Image",
  T_38_SP_WS_REVIEW_20: "Text contains sensitive words.",
  T_38_SP_WS_REVIEW_21: "Save failed. Unable to be reviewed.",
  T_38_SP_WS_REVIEW_22: "Review under cooldown.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Bat - Mayhem",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Pet Skin: Ghost Kactus",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Pet Skin: Neon Kactus",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Pet Skin: Palm Dream Kactus",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Pet Skin: Party Arvon",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Pet Skin: Trendy Rockie",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Nightfire Kami",
  T_38_SY_SICKLE_ES_N: "Scythe - Pop-Pow",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Pickup Truck - Mochi Food Truck",
  T_38_WT_WS_MUITLEVEL: "Multi-Level",
  T_38_WT_WS_SKILLSET15: "Thrill of Battle (A124)",
  T_38_WT_WS_SKILLSET16: "Senses Shockwave (Homer)",
  T_38_WT_WS_SKILLSET17: "Wall Brawl (Iris)",
  T_38_WT_WS_SKILLSET18: "Rebel Rush (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Active in scenery or not",
  T_38_WZY_WS_ACTIVEB: "Turn on logic refresh or not",
  T_38_WZY_WS_ACTIVEVALUE: "Activity status",
  T_38_WZY_WS_AIR: "Air",
  T_38_WZY_WS_ALLOWMOVE: "Moveable or not",
  T_38_WZY_WS_AMMOAMOUNT: "Ammo amount",
  T_38_WZY_WS_AMMONAME: "Ammo Entity",
  T_38_WZY_WS_ARMOR_DAMRED: "DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Explosion DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DURABILITY: "Current durability",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Max. durability",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Damageable or not",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Destructible or not",
  T_38_WZY_WS_ARMOR_LEVEL: "Level",
  T_38_WZY_WS_ASSCONZOM: "Zombie elimination assist.",
  T_38_WZY_WS_BAGNAME: "Backpack Entity",
  T_38_WZY_WS_BAGSPACEEX: "Additional backpack space",
  T_38_WZY_WS_BRIDGING: "Bridge render component",
  T_38_WZY_WS_BUBBLE: "Bubble",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Clear all items in the [player entity's] backpack",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Clear the unwanted items lying around the map, such as loot, throwable residue, and loot boxes",
  T_38_WZY_WS_CLEARPRO: "Clear single property factor",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Clone a [scenery object] entity at the location of a [player entity] and return the [disguise entity]",
  T_38_WZY_WS_COMPONENT: "Component",
  T_38_WZY_WS_COSTAMMO: "Consume ammo",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Create a camera and return a [camera entity], whose properties can be modified through property settings",
  T_38_WZY_WS_CYCLES: "Times played",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a circular pole. The [center] is the center of the pole, the [radius] is the radius of the circular surface, the [height] is the height of the pole, the [Euler angles] are the angles of the 3D orientation of the pole.",
  T_38_WZY_WS_CYLINDERJUD_RES: "The result of the circular pole scope check. This is a Boolean value.",
  T_38_WZY_WS_DAMSUMZOM: "DMG to zombies",
  T_38_WZY_WS_DARKNESS: "Darkness",
  T_38_WZY_WS_DIFCOLOR: "Surface color",
  T_38_WZY_WS_DIFTEXTURE: "Surface texture",
  T_38_WZY_WS_DRUMMUSIC: "Component type: drums",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "The player that was disconnected",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "The player that is reconnecting",
  T_38_WZY_WS_EUIANCHOR: "HUD anchor type enumeration",
  T_38_WZY_WS_FEATHER: "Feather",
  T_38_WZY_WS_FLAMEAMMO: "Flamethrower Ammo",
  T_38_WZY_WS_FLOWER: "Flower",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Set the [entity] to always follow the [followed entity]. [Offset coordinates] is the distance between the two entities.",
  T_38_WZY_WS_FOLLOWENT: "Followed entity",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Get the camera entity that is currently being used by a [player entity]",
  T_38_WZY_WS_GETCURCAMDESC: "The camera that is currently being used by the player",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Get the amount of an item in the [designated item type] that a [player] owns",
  T_38_WZY_WS_GETITEMNUM_RES: "The amount of the designated item that the player owns",
  T_38_WZY_WS_GETVEC_NAME: "Get vector",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Get a vector using the x, y, and z components of a set of coordinates",
  T_38_WZY_WS_GETVECRES: "The vector got from the x, y, and z components",
  T_38_WZY_WS_GHOST: "Ghost",
  T_38_WZY_WS_GRENADEFROZENNAME: "Flash Freeze Entity",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Freeze zone radius",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Freeze duration",
  T_38_WZY_WS_GRENADENAME: "Grenade Entity",
  T_38_WZY_WS_GRENADEPARAM1: "Min. DMG",
  T_38_WZY_WS_GRENADEPARAM2: "Max. DMG",
  T_38_WZY_WS_GRENADEPARAM4: "Explosion range",
  T_38_WZY_WS_GRENADEPARAM5: "Throwing speed",
  T_38_WZY_WS_GRENADEPARAM6: "Explosion delay",
  T_38_WZY_WS_GRENADEPARAM7: "Self DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM8: "Ally DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM9: "Vehicle DMG multiplier",
  T_38_WZY_WS_GUNFIRE: "Gunfire",
  T_38_WZY_WS_GUNPRO_PARAM2: "Reload Speed",
  T_38_WZY_WS_GUNPRO_PARAM3: "Body shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM4: "Headshots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM5: "Limb shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM7: "Extra DMG",
  T_38_WZY_WS_HELMET_NAME: "Helmet Entity",
  T_38_WZY_WS_ICON1: "Crown",
  T_38_WZY_WS_ICON2: "Duel",
  T_38_WZY_WS_INITPOS: "Initial location",
  T_38_WZY_WS_ISRESET: "Reciprocating Motion",
  T_38_WZY_WS_KILLCONZOM: "No. of zombies eliminated",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Eliminate the chosen [entity], which must be a battle entity type. Ignores the invulnerable status.",
  T_38_WZY_WS_LABELPARAM: "Text content parameter list",
  T_38_WZY_WS_LEADMUSICA: "Component type: piano (treble)",
  T_38_WZY_WS_LEADMUSICB: "Component type: piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Component type: piano (bass)",
  T_38_WZY_WS_LINE: "Line",
  T_38_WZY_WS_LIQUID: "Liquid",
  T_38_WZY_WS_LOCALKEY: "Localized key",
  T_38_WZY_WS_LOCALPOS: "Relative location",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Set an [entity] to aways face the [aimed entity]. [Offset coordinates] is the difference in coordinates of the aimed point and the entity's position.",
  T_38_WZY_WS_MAINWEAPONA: "Main Weapon 1",
  T_38_WZY_WS_MAINWEAPONB: "Main Weapon 2",
  T_38_WZY_WS_MOTIONTIME: "Movement duration",
  T_38_WZY_WS_MOTIONTYPE: "Movement method",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "Modified EP",
  T_38_WZY_WS_MUSHROOMNAME: "Mushroom Entity",
  T_38_WZY_WS_OBFACTION: "Spectating faction",
  T_38_WZY_WS_OBGLOBAL: "Spectate all",
  T_38_WZY_WS_OBSERVER: "Spectator Options",
  T_38_WZY_WS_OBTEAM: "Spectating team",
  T_38_WZY_WS_OFFSETVEC: "Offset coordinates",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Triggers when a player is buying items from this Vending Machine. [Player entity] is the player that makes the purchase. [Merchandise entity] is the item bought.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Triggers when equipped by a [player entity]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Triggers when the player completes the jumping action",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Triggers when the player completes the prone position",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Triggers when the weapon reloads",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Triggers when the player completes the sprinting action",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Triggers when the player completes the crouching action",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Triggers when the weapon eliminates a unit. [Eliminated entity] is the unit that was eliminated.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Triggers when the weapon inflicts damage to a battle entity. [Hit target] is the battle entity that damage was inflicted on. [Damage] is the damage being inflicted.",
  T_38_WZY_WS_OWNER: "Owner",
  T_38_WZY_WS_PARAMLIST: "Parameter list",
  T_38_WZY_WS_PARTICALMAP: "Particle Mapping",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Pause or resume the current emote for a [player entity]. [Pause or not] is a Boolean value. "Yes" means pause. "No" means resume.',
  T_38_WZY_WS_PLAENTTRI_DESC: "Activated by player entering the trigger",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Activated by player leaving the trigger",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Force the [player entity] to play the designated [emote] once and return to original position when finished",
  T_38_WZY_WS_PLAYSPEED: "Playback speed percentage",
  T_38_WZY_WS_PREHUD_NAME: "Preset icon",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Let the [player entity] leave its current faction",
  T_38_WZY_WS_RESETENT: "Reset components every round",
  T_38_WZY_WS_RESUUID: "Resource UUID",
  T_38_WZY_WS_RIMCOLOR: "Border color",
  T_38_WZY_WS_RIMTEXTURE: "Border texture",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Check whether an [entity] is inside a cone. The [center] and [radius] are the center and radius of the cone. The [extracted radius] is the radius of the smaller sector within the cone. The height is the height of the 3D structure. The [angle] is the central angle of the cone. The [direction angle] is the direction vector of the central axis.",
  T_38_WZY_WS_SECTORJUD_RES: "The result of the fan-shaped scope check. This is a Boolean value.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Set the activity status of a [target entity]. [Activity status] is a Boolean value and affects the availability, visibility, and collidability of the entity.",
  T_38_WZY_WS_SETROUNDSCORE: "Set player's round score",
  T_38_WZY_WS_SHOOTANGMAX: "Max. shooting angle",
  T_38_WZY_WS_SHOWMAPINFO: "Display map info for same faction",
  T_38_WZY_WS_SHOWNAMEHUD: "Display name HUD for same faction",
  T_38_WZY_WS_SOUND1: "Acceleration",
  T_38_WZY_WS_SOUND10: "Phase Start",
  T_38_WZY_WS_SOUND11: "Zombies",
  T_38_WZY_WS_SOUND12: "Horror",
  T_38_WZY_WS_SOUND13: "Transformation",
  T_38_WZY_WS_SOUND14: "Pounding Heart",
  T_38_WZY_WS_SOUND15: "Medium Heartbeat",
  T_38_WZY_WS_SOUND16: "Slow Heartbeat",
  T_38_WZY_WS_SOUND17: "Rush Time",
  T_38_WZY_WS_SOUND18: "Click",
  T_38_WZY_WS_SOUND19: "Skill Recover",
  T_38_WZY_WS_SOUND2: "Disappear Notification",
  T_38_WZY_WS_SOUND20: "Join A Game",
  T_38_WZY_WS_SOUND3: "Visual Effects",
  T_38_WZY_WS_SOUND4: "Night Chirps",
  T_38_WZY_WS_SOUND5: "Hit (Blunt)",
  T_38_WZY_WS_SOUND6: "Reaction",
  T_38_WZY_WS_SOUND7: "Surprise Find",
  T_38_WZY_WS_SOUND8: "Apparition",
  T_38_WZY_WS_SOUNDENT: "Music entity",
  T_38_WZY_WS_SPAWNPOS: "Old Spawn Point",
  T_38_WZY_WS_SPHERENAME: "Basic sphere",
  T_38_WZY_WS_SPHERERADIUS: "Sphere radius",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Check whether an [entity] is inside a spherical scope. The [center] and [radius] is the center and radius of the spherical structure.",
  T_38_WZY_WS_SPHERICALJUD_RES: "The result of the spherical scope check. This is a Boolean value.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a cube. The [center] is the center of the cube, the [length], [width], and [height] are the length, width, and height of the cube, and the [Euler angles] are the angles of the 3D orientation of the cube.",
  T_38_WZY_WS_SQUAREJUD_RES: "The result of the cubic scope check. This is a Boolean value.",
  T_38_WZY_WS_STARTGENTIME: "Spawn start time",
  T_38_WZY_WS_STAYTIME: "Pause duration",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Switch a player's camera to the [camera entity]. [Switch mode] can be either no animation or progressive movement. [Switch time] is the time of switching during progressive mode.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Switch the camera mode. You can select between No Animation and Progressive Movement.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'The switch time during progressive movement mode. When selected "no animation", this setting is void.',
  T_38_WZY_WS_TEXTHUD: "HUD text component",
  T_38_WZY_WS_TEXTTYPE: "Font Size",
  T_38_WZY_WS_TEXTUREID: "Texture type",
  T_38_WZY_WS_TRANDIST: "Max. distance",
  T_38_WZY_WS_TWEENERENABLED: "Turn on UITweener script or not",
  T_38_WZY_WS_TYPELIST: "Type list",
  T_38_WZY_WS_TYPELISTORLIST: "Type or type list",
  T_38_WZY_WS_VEST_NAME: "Vest Entity",
  T_38_WZY_WS_VFX1: "Hider Elimination",
  T_38_WZY_WS_VFX10: "Cyclic Combustion",
  T_38_WZY_WS_VFX11: "Poison Gas",
  T_38_WZY_WS_VFX13: "Heart",
  T_38_WZY_WS_VFX15: "Door",
  T_38_WZY_WS_VFX2: "Rampage",
  T_38_WZY_WS_VFX3: "Clone Elimination",
  T_38_WZY_WS_VFX4: "Hit Feedback",
  T_38_WZY_WS_VFX5: "Clone",
  T_38_WZY_WS_VFX6: "Disguise",
  T_38_WZY_WS_VFX7: "Flashbang Sparks",
  T_38_WZY_WS_VFX8: "Motion Trail",
  T_38_WZY_WS_VFX9: "Fire Charge",
  T_38_WZY_WS_VFXENT: "VFX Instance",
  T_38_WZY_WS_VFXTYPEA_NAME: "Customizable mapping VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "Non-customizable mapping VFX",
  T_38_WZY_WS_VISIBILITY: "Visibility type",
  T_38_WZY_WS_VOLUME: "Volume",
  T_38_WZY_WS_WEAPONGEN: "Weapon Generator",
  T_38_WZY_WS_WHECYCLE: "Replay",
  T_38_XXJ_WS_BLOCKMODE: "Blocked Mode",
  T_38_XXJ_WS_CUSTOMCAMARA: "Custom Camera",
  T_38_XXJ_WS_FFCLASSIC: "Classic FF (Shooting)",
  T_38_XXJ_WS_FOV: "Field of View",
  T_38_XXJ_WS_FOVDESC: "The field of view is the observable range of the camera.",
  T_38_XXJ_WS_FPS: "First Person (Shooting)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Horizontal Angle",
  T_38_XXJ_WS_INVISICAM: "Semi-Transparent",
  T_38_XXJ_WS_OFFSET: "Offset",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Orthographic",
  T_38_XXJ_WS_PERSPECTIVE: "Perspective",
  T_38_XXJ_WS_PROJECTIONMODE: "Projection Mode",
  T_38_XXJ_WS_STABLE: "Fixed",
  T_38_XXJ_WS_STARTCAMERA: "Default Camera",
  T_38_XXJ_WS_STARTCAMERAMODE: "Default Camera Mode",
  T_38_XXJ_WS_THIRD: "Chase Camera",
  T_38_XXJ_WS_TOPVIEW: "High Angle",
  T_38_XXJ_WS_TPS: "Third Person",
  T_38_XXJ_WS_TRANSVERSE: "Horizontal Movement",
  T_38_XXJ_WS_VERTICALANGLE: "Vertical Angle",
  T_38_XXJ_WS_ZOOM: "Zoom",
  T_38_XYL_WS_AISTARTTIME: "Start time (s)",
  T_38_XYL_WS_ARMORDESTROY: "Armor DMG multiplier",
  T_38_XYL_WS_BONFIRE: "Bonfire",
  T_38_XYL_WS_CANDLE01: "Candle A",
  T_38_XYL_WS_CANNON01: "Mechanical Cannon",
  T_38_XYL_WS_CLIPAMMOSIZE: "Magazine Storage",
  T_38_XYL_WS_DAMAGEDTRUCK: "Damaged Truck",
  T_38_XYL_WS_DOLL01: "Eerie Doll",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Brick House A",
  T_38_XYL_WS_FENCE002: "Iron Fence B",
  T_38_XYL_WS_FIREWORK01: "Fireworks A",
  T_38_XYL_WS_GENERATOR: "Generator",
  T_38_XYL_WS_GRAVITY: "Gravitational Acceleration",
  T_38_XYL_WS_GRAVITYAREA: "Abnormal Grav Zone",
  T_38_XYL_WS_GRAVITYAREA_DESC: "A zone where players can change gravity",
  T_38_XYL_WS_HOLDWEAPON: "Weapon Hold",
  T_38_XYL_WS_INDOORFURNITURE: "Indoor Furniture",
  T_38_XYL_WS_LIGHTTUBE001: "Tube Light A",
  T_38_XYL_WS_LOVEBALLOON01: "Valentine Balloon A",
  T_38_XYL_WS_LOVELAMP01: "Heart Streetlight",
  T_38_XYL_WS_LOVESIGN01: "Love Neonlights",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Oil Barrel Damage Ratio",
  T_38_XYL_WS_OUTDOORPROPS: "Outdoor Items",
  T_38_XYL_WS_PIPEANDBOX: "Pipes and Containers",
  T_38_XYL_WS_PLANT: "Plants",
  T_38_XYL_WS_ROSE01: "Rose",
  T_38_XYL_WS_ROSEN: "Rose Bouquet",
  T_38_XYL_WS_SMALLBUILDING: "Small Buildings",
  T_38_XYL_WS_SOFA002: "Sofa B",
  T_38_XYL_WS_TOWNHOUSE01: "Old 2-Story House",
  T_38_XYL_WS_TV001: "Old TV",
  T_38_ZP_CC_EXCHANGESTATUS: "Status",
  T_39_BQ_SKILL_NAME_VILLAIN: "Crimson Crush",
  T_39_CJ_A_BURN: "Victory Glintmark",
  T_39_HJ_WS_Arrow002: "Arrow 2",
  T_39_HJ_WS_LIKERATE2: "{0} min",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} min",
  T_39_HJ_WS_SOUND10: "Step",
  T_39_HJ_WS_SOUND11: "Mission Complete 1",
  T_39_HJ_WS_SOUND13: "Danger Alert 1",
  T_39_HJ_WS_SOUND14: "Danger Alert 2",
  T_39_HJ_WS_SOUND15: "Countdown 3",
  T_39_HJ_WS_SOUND16: "Tips Sound",
  T_39_HJ_WS_SOUND17: "Crow Caw",
  T_39_HJ_WS_SOUND18: "Sound of teleporting to a wrong area",
  T_39_HJ_WS_SOUND19: "Sound of teleporting to a correct area",
  T_39_HJ_WS_SOUND2: "Countdown 1",
  T_39_HJ_WS_SOUND20: "Teleport",
  T_39_HJ_WS_SOUND21: "Electric Shock",
  T_39_HJ_WS_SOUND23: "Get Item",
  T_39_HJ_WS_SOUND24: "Electronic & Cute BGM",
  T_39_HJ_WS_SOUND25: "Casual Game BGM",
  T_39_HJ_WS_SOUND4: "Mechanical Device Echo",
  T_39_HJ_WS_SOUND5: "Mosquito",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Gear Switched On",
  T_39_HJ_WS_SOUND9: "Charge 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Unlimited Gloo Walls",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Unlimited Throwables",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Special Firing Sound",
  T_39_HQ_UGC_CUSTOMRES: "Custom Resources",
  T_39_M_ACCOUNTID: "Account",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Execute after double click",
  T_39_MF_SKILLTAG_4: "Movement",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "After knocking down an enemy, marks their teammates within [FFB300]{0}m[-] from them and slows down their movement speed by [FFB300]{1}%[-]. Lasts for [FFB300]{2}s[-]. When knocked down by a nearby enemy, marks and slows down the attacker and their teammates.",
  T_39_QL_SKILL_WOLFRAHH_DES: "After knocking down an enemy, enter Highlight mode, which increases rate of fire by [FFB300]{0}%[-] and movement speed by [FFB300]{1}%[-] but then decays quickly. Lasts for [FFB300]{2}s[-]. During Highlight mode, consecutively knocking down enemies will reset countdown and further boost rate of fire by [FFB300]{3}%[-] and movement speed by [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Xtreme Mode: Get [FFB300]{0} temporary HP[-] for [FFB300]{1}s[-]. During this time, HP-healing effects are enhanced by [FFB300]{2}%[-]. Cooldown: [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "Failed",
  T_39_RW_SKILL_DESC_FORD: "Gain [FFB300]{1} HP/s[-] for [FFB300]{0}s[-] when taking damage. After releasing an active skill, this passive skill will reset immediately. Cooldown: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "Item entity",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "Rageblast"',
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - 1001 Nights",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Pet skin: Green Imp Arvon",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Pet Skin: Royal Tig",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Pet Skin: Scorpio Fang",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Monster Truck - Green Giant",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Floral Chariot",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Awakening: [FFB300]{0}s[-] before detonating, grenade produces [FFB300]{1}[-] extra grenades, which can cause [FFB300]{2}%[-] damage of their original.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Split Blitz",
  T_39_WT_WS_EMPTYMAP_TAG: "Empty space",
  T_39_WT_WS_FEMAPMODE: "Mode Title",
  T_39_WT_WS_FEMAPTAG: "Map Tag",
  T_39_WT_WS_MAPPLAYER: "Number of Players",
  T_39_WT_WS_MEDENTERNUM: "Mid-game joining player limit",
  T_39_WT_WS_MIDENTER: "Mid-game joining",
  T_39_WT_WS_MIDENTERCOUNT: "Quota of joining mid-game",
  T_39_WT_WS_MIDENTERTIME1: "Time limit of mid-game joining",
  T_39_WT_WS_MIDENTERTIME2: "Duration of mid-game joining",
  T_39_WT_WS_MIDENTERTIMETIP: "When the map player number limit is not reached, enable players to join in within N sec after match starts. Players cannot join in after N sec.",
  T_39_WT_WS_MIDENTERTIP: "When enabled, players can join this map mid-game.",
  T_39_WT_WS_PLAYERCOUNT: "Initial player number",
  T_39_WT_WS_PLAYERCOUNTTIP: "The player number when the match starts. More players can join mid-game until it reaches the map's limit.",
  T_39_WT_WS_TAG1: "Free For All",
  T_39_WT_WS_TAG10: "Easy",
  T_39_WT_WS_TAG11: "Medium",
  T_39_WT_WS_TAG12: "Hard",
  T_39_WT_WS_TAG13: "Very Challenging",
  T_39_WT_WS_TAG14: "Escape",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Custom Resources",
  T_39_WT_WS_TAG18: "Puzzles",
  T_39_WT_WS_TAG19: "Racing",
  T_39_WT_WS_TAG2: "Gun Fight",
  T_39_WT_WS_TAG20: "Music",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Adventure",
  T_39_WT_WS_TAG23: "Zombie Hunt",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "Party Game",
  T_39_WT_WS_TAG26: "Team Deathmatch",
  T_39_WT_WS_TAG27: "Turret Defense",
  T_39_WT_WS_TAG28: "Training",
  T_39_WT_WS_TAG3: "Gun King",
  T_39_WT_WS_TAG4: "Respawn",
  T_39_WT_WS_TAG5: "Sniper",
  T_39_WT_WS_TAG6: "Survival",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Horror",
  T_39_WT_WS_TAG9: "Casual",
  T_39_WT_WS_TAGMAXTIP: "Select up to {0} tags",
  T_39_WT_WS_TAGTYPE1: "Gameplay Type",
  T_39_WT_WS_TAGTYPE2: "Map Type",
  T_39_WT_WS_TAGTYPE3: "Mode Type",
  T_39_WT_WS_TAGTYPE4: "Team Size",
  T_39_WZY_WS_ACCSPEED: "Acceleration",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Add script [Script Name] for [Entity]",
  T_39_WZY_WS_ASC: "Ascending",
  T_39_WZY_WS_ASCIGZERO: "Ignore zero using Ascending",
  T_39_WZY_WS_BALLISTMOVENT: "Ballistic Motion Entity",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Triggers incident when the item is used by [Player Entity]",
  T_39_WZY_WS_BODYSCALE: "Body scale",
  T_39_WZY_WS_BRAKETORQUE: "Brake Horsepower",
  T_39_WZY_WS_CAMTRANTYPE: "Camera transition type",
  T_39_WZY_WS_CARVEHICLE: "4-Wheeler",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Check if a specified script [Script Name] exists in [Entity]. (The returned value should be Boolean)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Check if the entity has a result of the specified script (Boolean)",
  T_39_WZY_WS_COMBINEALL: "Dual-wielding (Different guns)",
  T_39_WZY_WS_COMBINESELF: "Dual-wielding (Same gun)",
  T_39_WZY_WS_CONENAME: "Basic Cone",
  T_39_WZY_WS_COORSYS: "Coordinate system",
  T_39_WZY_WS_CRASHMAXD: "Max Crash Damage",
  T_39_WZY_WS_CRASHMIND: "Minimum Crash Damage",
  T_39_WZY_WS_CRAWLSPEED: "Mvmt. spd. percentage (Prone)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Create Ballistic Motion for [Target Entity]. Can edit [Initial Speed], [Acceleration], and [Max Distance] accumulated in the direction of initial speed for the target entity, and return [Ballistic Motion Entity]",
  T_39_WZY_WS_CRETWEEN_NAME: "Create Interpolation Motion",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Create an Interpolation Motion for [Entity], with [Attributes] of the entity moving smoothly from [Start Value] to [Target Value] within [Time]. [Method] represents the way of motion, including [One-way], [PingPong], [Cycle]. [Curve] is the curve of motion. And [Interpolation Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_CURVE: "Curve",
  T_39_WZY_WS_CUSTRESULT: "Custom Match Result",
  T_39_WZY_WS_CYLINDERNAME: "Basic Cylinder",
  T_39_WZY_WS_DEFAULT: "No animation (Default)",
  T_39_WZY_WS_DESC: "Descending",
  T_39_WZY_WS_DIFFUSEALPHA: "Surface Transparency",
  T_39_WZY_WS_DISCONNECT: "Disconnect",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Energy recovery per sec",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Consume Energy",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Max second jump height",
  T_39_WZY_WS_ENABLEJOIN: "Allow joining midway",
  T_39_WZY_WS_ENDPOS: "End point coordinates",
  T_39_WZY_WS_ENGINETORQUE: "Engine Horsepower",
  T_39_WZY_WS_EXPLODED: "Explosion Damage",
  T_39_WZY_WS_FEELDSPEED: "Mvmt. spd. percentage (Downed)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Center flash time",
  T_39_WZY_WS_FLASH_CRANGE: "Center range",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Edge flash time",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Flashbomb hit effect",
  T_39_WZY_WS_FLASH_RANGE: "Explosion range",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Descending speed",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Max. altitude",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Horizontal glide speed",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Vertical glide speed",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Minimum end height",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Minimum takeoff height",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Descent speed after super high",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Turning speed",
  T_39_WZY_WS_FOLMOVENT: "Position Following Motion Entity",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Get Skill List of [Player Entity]",
  T_39_WZY_WS_HB_BOOSTCD: "Sprint cooldown",
  T_39_WZY_WS_HB_BOOSTDURATION: "Sprint duration",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTSPEED: "Sprint speed",
  T_39_WZY_WS_HB_HOVERBCD: "Skyboard cooldown",
  T_39_WZY_WS_HB_JUMPCD: "Jump cooldown",
  T_39_WZY_WS_HB_JUMPH: "Skyboard jump height",
  T_39_WZY_WS_HEADSCALE: "Head scale",
  T_39_WZY_WS_HEADSHOTDESCALE: "Headshot damage reduction",
  T_39_WZY_WS_INTITALSPEED: "Initial Speed",
  T_39_WZY_WS_INVENTORYBASE: "Basic item types",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Energy cost per sec",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Basic horizontal speed",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Basic vertical speed",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Dash energy cost per sec",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Sprint horizontal speed",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Sprint distance",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Rush energy cost per sec",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Sprint vertical speed",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Upward energy cost per sec",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Attackable",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Self-triggerable",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Whether can be triggered by allies",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Triggerable by vehicle",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Duration",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Activation time",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Trigger radius",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Trigger time",
  T_39_WZY_WS_LEAVE: "Quit",
  T_39_WZY_WS_LIMBSCALE: "Limbs scale",
  T_39_WZY_WS_LISTLOCSTR: "Localized text list",
  T_39_WZY_WS_LOADRESULT_NAME: "Upload battle result",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Upload battle result of [Player], including [Rank], [Result], [Score Name], [Score Value]. The result type is an integer. 1 for victory, 2 for defeat, 3 for Booyah, and 4 for a draw.",
  T_39_WZY_WS_LOOKMOVENT: "Gaze-following Motion Entity",
  T_39_WZY_WS_MAXCOUNT: "Maximum Quantity",
  T_39_WZY_WS_MAXDISTANCE: "Max. Distance",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Turret Depression Angle",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Turret Angular Speed",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Turret Elevation Angle",
  T_39_WZY_WS_MINISENTRY_DAM: "Turret Damage",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Damage Reduction Rate",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Firing Angle",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Turret Hit Rate",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Turret Attack Interval",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Max Turret Number",
  T_39_WZY_WS_MINISENTRY_RANGE: "Turret Attack Range",
  T_39_WZY_WS_MOVEENT: "Motion Entity",
  T_39_WZY_WS_NOCOMBINE: "Not dual-wieldable",
  T_39_WZY_WS_ONCE: "Once",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Triggers incident when the item is discarded by [Player Entity]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Triggers incident when the item is equipped by [Player Entity]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Triggers incident when Hook Gun fires",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Triggers incident when Landmine is activated",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Triggers incident when Landmine is triggered by [Player Enitity]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Triggers when entity motion pauses",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Triggers when entity restarts moving from pause",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Triggers when entity starts moving",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Triggers incident when the item is picked up by [Player Entity]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Triggers incident when Throwable hits target",
  T_39_WZY_WS_OPENATTACK: "Whether to enable the attack",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Pause Motion Entity or Motion Entity List",
  T_39_WZY_WS_PAUSESOUND_NAME: "Pause sound effect",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Pause Sound Entity or Sound Entity List",
  T_39_WZY_WS_PIANOTYPE: "Music Component Type",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Motion Entity List",
  T_39_WZY_WS_PLAYINGSTATUE: "Status",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Restore the paused Motion Entity or Motion Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Play sound effect",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Restore the paused Sound Entity or Sound Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PROCIRCLE_NAME: "Progress Circle",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [List of Entities Hit] and [List of Coordinates Hit]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [Entity Hit] and [Coordinates Hit]",
  T_39_WZY_WS_REAHEALHP: "Armor recovery value",
  T_39_WZY_WS_REAHEALTIME: "In-effect time interval",
  T_39_WZY_WS_RELATCOORSYS: "Relative coordinate system",
  T_39_WZY_WS_REPAIRARM: "Repair Kit",
  T_39_WZY_WS_REVERSE: "Reverse",
  T_39_WZY_WS_RIMALPHA: "Edge Transparency",
  T_39_WZY_WS_SCORENAME: "Score Name",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Send a signal to Target Entity, the parameters uploaded are defined by predefined signal parameters. The selection of the entity type at the time of definition will generate the corresponding signal accepting event.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Create a position following motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Position Following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Create a Gaze-following Motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Gaze-following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Falling damage percentage",
  T_39_WZY_WS_SHOE_MAXENERGY: "Max. Energy",
  T_39_WZY_WS_SKILLLIST: "Skill List",
  T_39_WZY_WS_SKILLTYPE: "Character skill",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Smoke effect duration",
  T_39_WZY_WS_SMOOTH: "Camera switch",
  T_39_WZY_WS_SOUNDENTL: "Sound Effect Entity List",
  T_39_WZY_WS_SOUNDENTLORSENT: "Sound Effect Entity or List",
  T_39_WZY_WS_SPRINTSPEED: "Sprint speed percentage",
  T_39_WZY_WS_SQUATSPEED: "Mvmt. spd. percentage (Squat)",
  T_39_WZY_WS_STARTCOO: "Initial Coordinates",
  T_39_WZY_WS_STATE: "Play status",
  T_39_WZY_WS_TARGETVAL: "Target value",
  T_39_WZY_WS_THROWSPEED: "Hook flying speed",
  T_39_WZY_WS_TOWER_PARAM10: "Rotation angle",
  T_39_WZY_WS_TOWER_PARAM11: "Turret status",
  T_39_WZY_WS_TOWER_PARAM12: "Entity ID",
  T_39_WZY_WS_TOWER_PARAM9: "Attack Target",
  T_39_WZY_WS_TOWSPEED: "Player traveling speed",
  T_39_WZY_WS_TWEENCURVE_NAME: "Custom Curve",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "Custom Curve can be used for Interpolation Motion",
  T_39_WZY_WS_TWEENENT: "Interpolation Motion Entity",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Motion Methods",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Methods of Interpolation Motion",
  T_39_WZY_WS_TWEENSTYLE: "Method",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Delete script [Script Name] for [Entity]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Randomize listed elements ",
  T_39_WZY_WS_VISIBLEONBACK: "Visible on back",
  T_39_WZY_WS_WEAPCOMBINET: "Dual-Wielding Weapon Type",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Extra damage on the downed",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Single shot bullet number",
  T_39_WZY_WS_WEAREPLAY: "Restart motion?",
  T_39_WZY_WS_WORLDCOORSYS: "World coordinate system",
  T_39_XXJ_WS_ADDFRIEND: "Add friend",
  T_39_XXJ_WS_ALLOWZ: "Enable player x-axis movement",
  T_39_XXJ_WS_BLOCKMODEDESC: "Camera's motion when there's an object between the camera and target",
  T_39_XXJ_WS_CAMERADISTANCE: "Distance from target",
  T_39_XXJ_WS_CAMERATYPEDESC: "Multiple types of preset and custom camera are provided",
  T_39_XXJ_WS_CAMERAUSER: "Camera user",
  T_39_XXJ_WS_CURENTCAMERA: "Camera used",
  T_39_XXJ_WS_DETAILS: "Match Details",
  T_39_XXJ_WS_FFECONOMY: "Economy",
  T_39_XXJ_WS_FOCUSTARGET: "Target observed",
  T_39_XXJ_WS_FOLLOWTARGET: "Target followed",
  T_39_XXJ_WS_GAMERESULT: "Match Result",
  T_39_XXJ_WS_GAMETITLE1: "Match 1",
  T_39_XXJ_WS_GAMETITLE2: "Match 2",
  T_39_XXJ_WS_GIFT: "Gift",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Camera's horizontal rotation angle",
  T_39_XXJ_WS_INVISICAM: "Translucent",
  T_39_XXJ_WS_INVISICAMDESC: "Object between the camera and target becomes translucent",
  T_39_XXJ_WS_LEFTSCORE: "Left Team Score",
  T_39_XXJ_WS_LIKE: "Like",
  T_39_XXJ_WS_LOBBY: "Lobby",
  T_39_XXJ_WS_MAINSCORENAME: "Total Score Name",
  T_39_XXJ_WS_MAINSCORENUM: "Total Score Number",
  T_39_XXJ_WS_MAPEVALUATE: "Map Rating",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Result of Multiple Teams",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Observation point offset",
  T_39_XXJ_WS_OFFSET2DESC: "Typically refers to the offset of camera focus point relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_OFFSETDESC: "Typically refers to the offset of camera position relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_ORTHOGONAL: "Orthogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "Camera portrays distant and nearer targets as the same size",
  T_39_XXJ_WS_PERSPECTIVE: "Perspective",
  T_39_XXJ_WS_PERSPECTIVEDESC: "Camera uses perspective projection to observe the target",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Camera's image formation when rendering",
  T_39_XXJ_WS_RANK1: "Team Rank",
  T_39_XXJ_WS_RANK2: "Player Rank",
  T_39_XXJ_WS_REPORT: "Report",
  T_39_XXJ_WS_REVIEW: "Replay",
  T_39_XXJ_WS_RIGHTSCORE: "Right Team Score",
  T_39_XXJ_WS_SCORENUM1: "Score 1",
  T_39_XXJ_WS_SCORENUM2: "Score 2",
  T_39_XXJ_WS_SCORENUM3: "Score 3",
  T_39_XXJ_WS_SCORENUM4: "Score 4",
  T_39_XXJ_WS_SCORENUM5: "Score 5",
  T_39_XXJ_WS_SCORETITLELIST: "Score Name List",
  T_39_XXJ_WS_SHARE: "Share",
  T_39_XXJ_WS_SPECTATORSWITCH: "Spectator",
  T_39_XXJ_WS_STABLE: "Stable",
  T_39_XXJ_WS_STABLEDESC: "Camera remains stable if there's an object in between the camera and the followed entity",
  T_39_XXJ_WS_TEAMNAME1: "Left Team Name",
  T_39_XXJ_WS_TEAMNAME2: "Right Team Name",
  T_39_XXJ_WS_TEAMRANK: "Team Rank",
  T_39_XXJ_WS_TRANSITIONTIME: "Camera transition time",
  T_39_XXJ_WS_TRANSITIONTYPE: "Camera transition type",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Result of 2 Teams",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Camera's vertical rotation angle",
  T_39_XXJ_WS_ZOOM: "Zoom",
  T_39_XXJ_WS_ZOOMDESC: "Camera zooms in if there's an object in between the camera and the followed entity",
  T_39_XYL_WS_LIGHTINTENSITY: "Light intensity",
  T_39_XYL_WS_LIGHTRANGE: "Light range",
  T_39_XYL_WS_POINTLIGHT: "Pointlight",
  T_39_XYL_WS_WATERZONE: "Custom water zone",
  T_40_B_DISABLE_RECONNECT: "Disable Auto-reconnection",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Midnight Jersey",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Arctic Blaze Jersey",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Cherry Coal Jersey",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Sunny Sky Jersey",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Flame Up Jersey",
  T_40_DYEING_CLEAR: "Clear Coloring Status",
  T_40_HJ_WS_EFFECT32: "Sneakers",
  T_40_HJ_WS_EFFECT33: "Explosion",
  T_40_HJ_WS_EFFECT34: "Spawnpoint",
  T_40_HJ_WS_EFFECT35: "Laser",
  T_40_HJ_WS_EFFECT36: "Ammo",
  T_40_HJ_WS_EFFECT37: "Hit Effect",
  T_40_HJ_WS_EFFECT38: "Firing Effect",
  T_40_HJ_WS_EFFECT43: "Spider Web",
  T_40_HJ_WS_EFFECT44: "Releasing a Skill",
  T_40_HJ_WS_SOUND69: "Opening a Box",
  T_40_HJ_WS_SOUND70: "Level Up",
  T_40_HJ_WS_SOUND71: "Level Maxed",
  T_40_HJ_WS_SOUND72: "Tapping a Button",
  T_40_HJ_WS_SOUND73: "Countdown 1",
  T_40_HJ_WS_SOUND74: "Whistle",
  T_40_HJ_WS_SOUND75: "Game Over",
  T_40_HJ_WS_SOUND76: "Forward",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Checkpoint",
  T_40_HJ_WS_SOUND79: "Countdown 2",
  T_40_HJ_WS_SOUND80: "Game Starts",
  T_40_HJ_WS_SOUND81: "Obtained Many Coins",
  T_40_HJ_WS_SOUND82: "Obtained Coins",
  T_40_HJ_WS_SOUND83: "Obtained Some Coins",
  T_40_HJ_WS_SOUND84: "Joined the Game",
  T_40_HJ_WS_SOUND85: "Opening Guild Supply",
  T_40_HJ_WS_SOUND86: "Horn",
  T_40_HJ_WS_SOUND87: "Eliminated a Boss",
  T_40_HJ_WS_SOUND88: "Opening War Chest",
  T_40_HJ_WS_SOUND89: "Explosive Paint Skill",
  T_40_HJ_WS_SOUND90: "Bullet Hitting",
  T_40_HJ_WS_SOUND91: "Paint Shield Skill",
  T_40_HJ_WS_SOUND92: "Tapping a Disabled Button",
  T_40_HJ_WS_SOUND93: "Skill Charging Complete",
  T_40_HJ_WS_SOUND95: "Laser Skill",
  T_40_HJ_WS_SOUND96: "Get Item 2",
  T_40_HJ_WS_SOUND97: "Game Over 2",
  T_40_HJ_WS_SOUND98: "Elimination Notification",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Background Music",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "In-Match Sound Effect",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI Widget Sound Effect",
  T_40_JH_WS_MAPTAG1: "Color Game",
  T_40_JH_WS_MAPTAG10: "Color Hide N Seek",
  T_40_JH_WS_MAPTAG11: "Anniversary",
  T_40_JH_WS_MAPTAG12: "Role Play",
  T_40_JH_WS_MAPTAG13: "Simulation",
  T_40_JH_WS_MAPTAG14: "Asymmetrical",
  T_40_JH_WS_MAPTAG15: "Resource Battle",
  T_40_JH_WS_MAPTAG16: "Cart Escort",
  T_40_JH_WS_MAPTAG17: "Official Map",
  T_40_JH_WS_MAPTAG18: "Mini Game",
  T_40_JH_WS_MAPTAG19: "Speed Challenge",
  T_40_JH_WS_MAPTAG2: "Color Spray",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Color Fight",
  T_40_JH_WS_MAPTAG4: "Color Fight",
  T_40_JH_WS_MAPTAG5: "Color Playground",
  T_40_JH_WS_MAPTAG6: "Playground Color",
  T_40_JH_WS_MAPTAG7: "Color Party",
  T_40_JH_WS_MAPTAG8: "Color Parkour",
  T_40_JH_WS_MAPTAG9: '"Spider-Verse" Parkour',
  T_40_JH_WS_TAG30: "Tycoon",
  T_40_JH_WS_TAG31: "Home-Wreck Havoc",
  T_40_JH_WS_TAG32: "Mystery Town",
  T_40_JH_WS_TAG33: "Dawn Crisis",
  T_40_JH_WS_TAG34: "Death Uprising",
  T_40_JH_WS_TAG35: "Fist Fight",
  T_40_JH_WS_TAG36: "Old Factory Roof",
  T_40_JH_WS_UGCTOKENNAME: "Craftland Token",
  T_40_L_QUICKMESSAGE_MODE2: "Clash Squad",
  T_40_M_WS_HIS: "of",
  T_40_SP_WS_DYEING: "Color",
  T_40_SP_WS_DYEING_AREA: "Area Coloring",
  T_40_SP_WS_DYEING_COLOR: "Color number",
  T_40_SP_WS_DYEING_COUNT: "Coloring Count",
  T_40_SP_WS_DYEING_DIR: "Coloring Direction",
  T_40_SP_WS_DYEING_DIS: "Coloring Distance",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Fixed Coloring Area",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Plane Area Coloring",
  T_40_SP_WS_DYEING_POSITION: "Coordinate",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Random Coloring Rate Decay",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Random Coloring Rate",
  T_40_SP_WS_DYEING_RANGE: "Coloring Area",
  T_40_SP_WS_DYEING_STATE: "Coloring Status",
  T_40_SP_WS_FACTIONTIPS_11: "Purple",
  T_40_SP_WS_SHOE_CURENERGY: "Current Energy",
  T_40_SW_SKILL_Name_Nanoscientist: "Nano Lifeshield",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Waggor's Wonder",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Awakened Alok",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Waggor's Wonder",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Waggor's Wonder",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Waggor's Wonder",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Waggor's Wonder",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Pet Skin: "Spider-Verse" Moony',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Pet Skin: Electric Arvon",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Pet Skin: Laser Eyes Pug",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Pet Skin: Aloha Pug",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Pet Skin: Tigerstripe Pug",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Waggor's Wonder",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Waggor's Wonder",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Waggor's Wonder",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Waggor's Wonder",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Waggor's Wonder",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Activate Text Content",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Placeholder Text Content",
  T_40_W_DJMALE_AWAKENING_D: "Awakening: While the aura is active, music notes that last for [FFB300]{2}s[-] will be dropped [FFB300]{1}m[-] behind the skill user every [FFB300]{0}s[-]. Teammates who pick up the music note will receive the same effect as the aura.",
  T_40_W_DJMALE_AWAKENING_N: "Party Remix",
  T_40_W_NURSE_D: "Spread [FFB300]{0}%[-] of the user's single-target healing effects (skill, Med Kit, heal gun, etc.) to teammates within [FFB300]{1}m[-] of the user.",
  T_40_WH_MP_BOXING_NAME: "Boxing Match",
  T_40_WH_MP_C_PACK: "Unlawful Backpack",
  T_40_WH_MP_EXCH_COIN: "Cash",
  T_40_WH_MP_EXCH_TEMPCOIN: "Unlawful Money",
  T_40_WH_MP_PAYCHECK: "Wages",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "The speed of helping up teammates is increased by [FFB300]{0}%[-]. Cooldown: [FFB300]{3}s[-]. The helped up teammate recovers [FFB300]{2} HP[-] in [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Creates a [FFB300]{0}m-radius[-] healing zone. Inside, user and allies recover [FFB300]{1} HP/s[-]. Help up will be automatically triggered when needed. Zone lasts for [FFB300]{2}s[-]. The effects of helping up teammates can be enhanced by other skills. Cooldown: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Method of display",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Capsule",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Height",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Radius",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Sphere",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "Color",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progressive",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Image Resources",
  T_40_WZY_WS_ICONENTITY_NAME: "Icon object",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Method of display",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simple",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-Grid",
  T_40_WZY_WS_ICONENTITY_TILED: "Tiles",
  T_40_WZY_WS_NEWMAPTAG: "New Map Icon",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Curse",
  T_40_WZY_WS_NEWVFX11: "Freeze Zone",
  T_40_WZY_WS_NEWVFX12: "Cold Air",
  T_40_WZY_WS_NEWVFX13: "Snowflake",
  T_40_WZY_WS_NEWVFX14: "Flame",
  T_40_WZY_WS_NEWVFX15: "Light Beam",
  T_40_WZY_WS_NEWVFX16: "Spread of Poison Gas",
  T_40_WZY_WS_NEWVFX17: "Poison Gas",
  T_40_WZY_WS_NEWVFX18: "Explosive Blaze",
  T_40_WZY_WS_NEWVFX19: "Light Effect",
  T_40_WZY_WS_NEWVFX2: "Bubble",
  T_40_WZY_WS_NEWVFX20: "Star",
  T_40_WZY_WS_NEWVFX3: "Ash",
  T_40_WZY_WS_NEWVFX4: "Stone Splash",
  T_40_WZY_WS_NEWVFX5: "Line",
  T_40_WZY_WS_NEWVFX6: "Flicker",
  T_40_WZY_WS_NEWVFX7: "Ring",
  T_40_WZY_WS_NEWVFX8: "Rising Particle",
  T_40_WZY_WS_NEWVFX9: "Smoke",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Font Size",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Font Style",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Font",
  T_40_WZY_WS_TEXTENTITY_NAME: "Text object",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Interaction button HUD component",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Whether it can be used in the scenery. This is read only and depends on "Parent available or not" and "Activity status".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Whether all parents are active. This is read only and not visible to players.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Parent available or not",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Whether it can be active on self. To use in the scenery, you must use "Active in scenery or not". This is read only and configured using an API.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Whether the camera's cullingMask is visible to a certain layer",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Generate tokens at a certain place",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "The lootable item to give to the player",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Current orientation of the player",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Direction",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "The AI is attacking the entity",
  T_40_XXJ_WS_AITARGET_DESCKEY: "The attacking AI",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "The align style",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Horizontal align",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Vertical align",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparency",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "The remaining ammo count",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Remaining ammo",
  T_40_XXJ_WS_ANCHORMAX: "Maximum Anchor",
  T_40_XXJ_WS_ANCHORMIN: "Minimum Anchor",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Current position of the player",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Position",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Armor HUD switch",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "Configured asset ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "Asset ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Target of attack",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Attack throwables",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "The entity that is being attacked by the AI",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Target attacked",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "The available coordinates of spawnpoints",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Available coordinates",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "The bottom image",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Background",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Backpack",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Background transparency",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Background color",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Background color",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Whether to fill the background",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Background fill",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Background name",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Background name",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Background size delta",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Background size delta",
  T_40_XXJ_WS_BLUE: "Blue",
  T_40_XXJ_WS_BODY_DESCKEY: "Torso",
  T_40_XXJ_WS_BODY_NAMEKEY: "Torso",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Skeleton scale",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "The player's spawnpoint",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Spawn point",
  T_40_XXJ_WS_BOTH: "Either",
  T_40_XXJ_WS_BUTTONNAME: "Button component name",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Camera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "The direction that the client camera is facing",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "The location of the client camera",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Detect the camera line of the client",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Camera ray detection",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Stop dragging when coinciding with the viewport",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Exit drag after fit",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "The distance between the center of the semicircles of the pill shape. It cannot be smaller than twice the radius of the sphere.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Cell size",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Child cell height",
  T_40_XXJ_WS_CELLVALUE: "Read the content of a certain cell and return an object",
  T_40_XXJ_WS_CENTER_DESCKEY: "The world coordinates that corresponds to the minimap's center. 0 by default.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Minimap center",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "The offset of the button's position",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Position offset",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "The center of mass relative to the local coordinates",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Center of mass",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Whether to display the middle line",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Display middle line or not",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Middle line position [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Middle line position",
  T_40_XXJ_WS_CHASERANGE: "Chase Vicinity",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "The entity that is being chased by the AI",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Target chased",
  T_40_XXJ_WS_CHILD_DESCKEY: "Child entity",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Parent's children",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "The point that is hit by the camera line",
  T_40_XXJ_WS_CHOOSECARHUD: "Select card HUD entity",
  T_40_XXJ_WS_CLAMP_DESCKEY: "If the parameter is within the numerical range between the minimum and maximum values, the function will return the value of the parameter; if the parameter is greater than the range, the function will return the maximum value; if the argument is less than the range, the function will return the minimum value",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "The size of the click area",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Click size",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Clipping type",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Clipping type",
  T_40_XXJ_WS_CLONEENT_D: "Clone the selected entity and its attributes while keeping the original parent. If Level Object is selected, it will be based on Create Level Object.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "The list of outfits",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "Outfit ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_COL_DESC: "The column to read.",
  T_40_XXJ_WS_COLNAME_DESC: "The name of the column to be read.",
  T_40_XXJ_WS_COLOR_DESCKEY: "Color",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Value",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Add color layers using the RGBA color channel. A channel value lies in between 0 and 255 and is stored in an Int32. White (255, 255, 255, 255) by default.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Color of the progress bar",
  T_40_XXJ_WS_COLOR3_DESCKEY: "The type of the RGBA color channel, which ranges from 0 to 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "The color of the text",
  T_40_XXJ_WS_COLOR5_DESCKEY: "The color of the HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "The color of the lighting",
  T_40_XXJ_WS_COLORA_DESCKEY: "The A color value",
  T_40_XXJ_WS_COLORB_DESCKEY: "The B color value",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Progress bar color",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Color barrel",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Color Barrel",
  T_40_XXJ_WS_COLORG_DESCKEY: "The G color value",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Obtain the RGBA channel",
  T_40_XXJ_WS_COLORGUN: "Rainbow Spray Rifle",
  T_40_XXJ_WS_COLORGUN_01: "Rainbow Spray Rifle (Red)",
  T_40_XXJ_WS_COLORGUN_02: "Rainbow Spray Rifle (Yellow)",
  T_40_XXJ_WS_COLORGUN_03: "Rainbow Spray Rifle (Blue)",
  T_40_XXJ_WS_COLORGUN_04: "Rainbow Spray Rifle (Green)",
  T_40_XXJ_WS_COLORGUN_05: "Rainbow Spray Rifle (Purple)",
  T_40_XXJ_WS_COLORR_DESCKEY: "The R color value",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Text color",
  T_40_XXJ_WS_COLVALUE: "Column Content",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "The HUD entity of a general HUD switch",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "HUD entity of general HUD switch",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "The number of constraints",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Constraint count",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Original content",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Default direction",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "The starting point of the scroll. Upper left corner by default.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Generate a static pixel for a certain object in the map. The pixel will not move with the object.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Create a minimap icon",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Define a localized string for a timestamp",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Create a custom UI component at the designated custom HUD and parent component",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Crawl",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Display when true, otherwise closed",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Crouch",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "This is the camera's cullingMask render layer. You can filter the render entity using the level of the visible layer.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "The top ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Top",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "Facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "The shoes ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Shoes",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "The head ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Head",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "The facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Mask",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "The bottom ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Bottom",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Facepaint",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "The bundle ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Onesie",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "The drag amount in the xy direction",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY drag",
  T_40_XXJ_WS_DB: "Read Table Value",
  T_40_XXJ_WS_DB_DESC: "Read the corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBDELETE_DESC: "Delete a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "A custom name used to identify data",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identifier",
  T_40_XXJ_WS_DBTABLENAME: "Database Table Name",
  T_40_XXJ_WS_DBTABLENAME_DESC: "The name of a table in a database.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "The value to write",
  T_40_XXJ_WS_DBWRITE: "Write Table Value",
  T_40_XXJ_WS_DBWRITE_DESC: "Write a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Defense throwables",
  T_40_XXJ_WS_DEFULT: "Default",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Delete a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Delete a corresponding value of a certain rank on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DEPTH: "HUD layer",
  T_40_XXJ_WS_DEPTH_D: "The basic layer of the HUD",
  T_40_XXJ_WS_DICTANDLIST: "List and Dictionary",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "The value of the targeted dictionary",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "The transparency of the surface",
  T_40_XXJ_WS_DIR_DESCKEY: "Vector",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "A point that is provided and can be used as a revival points, etc.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Coordinates",
  T_40_XXJ_WS_DISABLEALL: "Deselect All",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Disabled color",
  T_40_XXJ_WS_DISTANT_DESCKEY: "The distance of the camera line detection",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Projecting distance",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Supports multiple dragging directions",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Drag effect",
  T_40_XXJ_WS_DRIVER_DESCKEY: "The driver of the vehicle",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Driver",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Modify a value",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Effects color",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "The special effects entity represents the special effect to be displayed",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "The special effects object",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Emoji HUD switch",
  T_40_XXJ_WS_ENABLEALL: "Select all",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Whether to turn on logic update. When off, the blocks on this entity will stop updating every frame.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "When written into the weapon attributes, the weapon's basic statistics will be affected by the weapon skin",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Write weapon skin attribute",
  T_40_XXJ_WS_ENTITY_DESCKEY: "An entity is a vessel that holds all components, which must be added to entities in order to be activated",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Entity type",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "The basic component of an entity. All components will combine this component.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "The entity to transform into",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "The parameter name used in the code to represent the entity of the newly added custom UI control. Its corresponding local variable value is the entity of the newly added custom UI control.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "The name of the entity variable",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "The parameter name used in the code to represent the entity of the created icon. Its corresponding local variable value is the entity of the created icon.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP bar HUD switch",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Euler angles",
  T_40_XXJ_WS_FACINFECTION: "Faction (Droid Apocalyse)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Faction of the player. 1 = Human, 2 = Droid.",
  T_40_XXJ_WS_FEMALE: "Female",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Fill direction",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Sort direction",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Fire",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "The value of the float",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "The target entity to follow. Empty by default.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "The size of the text",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Font size",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "The font style",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Football Gloo Wall",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "The formatting style",
  T_40_XXJ_WS_FORWARD_DESCKEY: "The direction of the player",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "The direction to teleport",
  T_40_XXJ_WS_FREE_DESCKEY: "A camera that is controllable by the player and can be moved freely",
  T_40_XXJ_WS_FREE_NAMEKEY: "Free Camera",
  T_40_XXJ_WS_GENDER: "Gender",
  T_40_XXJ_WS_GENDER_DESCKEY: "Gender",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Gender enum",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Obtain the camera's cullingMask",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Obtain the player's outfit ID",
  T_40_XXJ_WS_GETPLAYERRANK: "Get Player Rank",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Get Player Total Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Get Player Round Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Get Player Specific Round Rank",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Search for data of the player's token",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Obtain the player's weapon skin",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Obtain a set of coordinates that has not been occupied by random spawnpoints",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Obtain the sky box of a scenery",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Obtain the region of a server",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Obtain the timestamp of a server",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Obtain a location near the teammate, avoiding areas where players cannot stand on",
  T_40_XXJ_WS_GETTEAMRANK: "Get Team Rank",
  T_40_XXJ_WS_GETTEAMRANK_D: "Get Team Total Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Get Team Round Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Get Team Specific Round Rank",
  T_40_XXJ_WS_GREEN: "Green",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Half of the dimensions of a 3-dimensional shape",
  T_40_XXJ_WS_HEAD_DESCKEY: "Head",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Head",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "The heartbeat effect entity",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Heartbeat effect entity",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "The height",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Hint button",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Tips button",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "The entity to be displayed at the target location",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entity targeted",
  T_40_XXJ_WS_HITPOS_DESCKEY: "The spot that is hit",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "The horizontal display type",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Horizontal display type",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "The entity that is following another entity",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "The entity that is looking at another entity",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Health bar HUD switch",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Empty HUD panel component",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "The HUD entity it belongs to",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "HUD grid component",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "HUD panel component",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD scroll view component",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "Human model ID",
  T_40_XXJ_WS_ICON_DESCKEY: "The resource name of the icon",
  T_40_XXJ_WS_ICON_NAMEKEY: "Icon",
  T_40_XXJ_WS_ICON1_DESCKEY: "Select an icon",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "The icon entity represents the icon to be displayed",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "A resource path. Built-in resource is in:path. Custom resource is out:path. Empty by default.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Icon name",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Icon name",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "The resource path. Empty by default.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Whether it can scan for triggers",
  T_40_XXJ_WS_INDEX_DESCKEY: "The child's index under the parent",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Initial value [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "The value of the integer",
  T_40_XXJ_WS_IS3D: "3D sound effect",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Always facing the camera",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Bold",
  T_40_XXJ_WS_ISBYORDER_D: "Detect whether players should trigger level objects in chronological order",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Is FirEditor button",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Whether the camera line has hit the entity",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Whether it is visible to a certain layer",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Italic",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Whether marked by scan",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Scanned or not",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Whether marked by the pin button",
  T_40_XXJ_WS_ISTRIGGER: "Is trigger",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Underlined",
  T_40_XXJ_WS_ITEMID_DESCKEY: "The entity's corresponding item ID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "Item ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "The item ID (only weapon ID available in the current version)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "The item ID of the weapon",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "Item ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Metropolis area",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Metropolis area",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Jump",
  T_40_XXJ_WS_KEY_DESCKEY: "The value of the key",
  T_40_XXJ_WS_KEY_NAMEKEY: "Key",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "The name of the key to traverse. You can use this to obtain the value of a key in a local variable.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Elimination announcement",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Text color",
  T_40_XXJ_WS_LANDMINEOBJ: "Entity after landmine creation",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "The mask of the collide layer. Layers not selected will not be included in the scan. When empty, all layers will be included in the scan.",
  T_40_XXJ_WS_LAYERSEDIT: "Edit Layers",
  T_40_XXJ_WS_LAYERSETTING: "Visible layer settings",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "The collision layer of the camera line detection",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Layer",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Layout type",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Layout type",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Scoreboard HUD component",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "The HUD entity of the scoreboard. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Leaderboard Name",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "The name of the leaderboard table in the database.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "The acceleration upon swinging",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Leave acceleration",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Left arm",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Left arm",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "The left color",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Left color",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the left",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Display left effect or not",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Left foot",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Left foot",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Left hand",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Left hand",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Left icon",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Left icon",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Left leg",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Left leg",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Left score text",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Left score text",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Left text",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Left text",
  T_40_XXJ_WS_LERP_DESCKEY: 't lies in between 0 and 1. When t=0, return "from". When t=1, return "to". When t=0.5, return the average of the values of "from" and "to".',
  T_40_XXJ_WS_LEVELOBJECT: "Level Object",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Line spacing",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Compare the values in a list and return the largest one",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Compare the values in a list and return the smallest one",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "List or Dict",
  T_40_XXJ_WS_LOCALPOSITION: "Local position",
  T_40_XXJ_WS_LOCALROTA: "Local Euler angles",
  T_40_XXJ_WS_LOCALROTATIONQ: "Local quaternion rotation",
  T_40_XXJ_WS_LOCALSACLE: "Local scale",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Localization switch",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "The container to traverse",
  T_40_XXJ_WS_MALE: "Male",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Remove the dictionary",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Obtain the length of the dictionary",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Obtain the value of the designated key in the dictionary element",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Remove the designated key-value pair in the dictionary",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Configure the value of a designated key in the dictionary",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "The size of the minimap. Its width and height are equal.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Map size",
  T_40_XXJ_WS_MAPT: "Dict template",
  T_40_XXJ_WS_MAPT_D: "The data template for dict. You may designate the content type through T1 and T2.",
  T_40_XXJ_WS_MAPVALUE_D: "A data container for dict. The element is a pair that consists of a key and a value.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "The target dictionary",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "The mask type is the image name used when masking",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Mask name",
  T_40_XXJ_WS_MASS_DESCKEY: "Mass (in kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Mass (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Compare 2 values and return the larger one",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Max. length",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "The maximum value",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "The biggest component ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "Max. widget ID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Healing items",
  T_40_XXJ_WS_MIN_DESCKEY: "Compare 2 values and return the smaller one",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Minimap component",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Minimap pixel",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Minimap icon",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Minimap",
  T_40_XXJ_WS_MINNUM_DESCKEY: "The minimum value",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "The factor of the momentum. The larger the value, the bigger the momentum while scrolling.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Momentum factor",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Movement joystick",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Match result",
  T_40_XXJ_WS_NEWENTITY_D: "The new item entity after creation (may be null)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Create a new dictionary",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "New Dict",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "The normal of the hit",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD position [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD position",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "The list to convert indices into numbers",
  T_40_XXJ_WS_OBJECT_DESCKEY: "The object that the spray gun hits",
  T_40_XXJ_WS_OBSOLETE: "Deleted, for safety reasons please replace this block.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "The screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Display position (the anchor is on the top right corner)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "The vertical offset",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Vertical offset",
  T_40_XXJ_WS_OK_DESCKEY: "Conversion successful",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Trigger this event when the entity enters the attack vicinity",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Trigger this event when the entity enters the chase vicinity",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Trigger this event when the entity leaves the attack vicinity",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Trigger this event when the entity leaves the chase vicinity",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Trigger a camera line detection through the client",
  T_40_XXJ_WS_ONCOLLISION_D: "Only entities with the Collider component attached support this event",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Trigger this event when the spray gun hits an entity",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "When the firing stops",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "When a player switches the scenery area",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Open status",
  T_40_XXJ_WS_ORANGE: "Orange",
  T_40_XXJ_WS_ORDER_DESC: "The rank on the leaderboard",
  T_40_XXJ_WS_ORDER1: "Starting Rank",
  T_40_XXJ_WS_ORDER2: "Finishing Rank",
  T_40_XXJ_WS_ORIGINAL: "Keep original logic",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Overflow method",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "When prioritized, the attributes of the player's weapon will replace the weapon's original attributes",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Prioritize player weapon skin",
  T_40_XXJ_WS_OWNER_DESCKEY: "The player that owns this entity",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "The global UID of the child scenery it belongs to",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID of child scenery",
  T_40_XXJ_WS_PARENT_DESCKEY: "Parent entity",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Parent",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "Parent component entity ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "The file ID of the parent component",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "All the passengers in the vehicle",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Passenger",
  T_40_XXJ_WS_PHYSICALLAYER: "Physical Layer",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Physical Layer Matrix",
  T_40_XXJ_WS_PHYSICALTIP1: "Name Already Exists",
  T_40_XXJ_WS_PHYSICALTIP2: "Remove a layer name and make it invisible in the Physical Layer Matrix and Layer Enum, but the entity objects within that layer will not be affected.",
  T_40_XXJ_WS_PHYSICS: "Physics",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Loot list HUD switch",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "A playable entity",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "An entity always faces another entity",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "An entity follows another entity",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "The bullet trail animation is a simulated animation of a bullet trail",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "The player to receive the message",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "The avatar used by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "The outfit equipped by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Player outfit",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "The player's HUD type",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Player HUD type",
  T_40_XXJ_WS_PLAYERIDINFAC: "Faction Serial No.",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "The player to record in the log",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Consume a certain player's token",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "The list of skills of the player",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "The status of a player: alive, knocked down, or eliminated",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "For example, 1.25 means 25% faster than the original speed",
  T_40_XXJ_WS_POS_DESCKEY: "The coordinates to teleport to",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "The type of special effects sticker",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Color on press",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Executes a traversal of a container to obtain the key-value pair. Includes a child process, which is the loop.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Loop dict visit",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "The button for the skill progress",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Skill progress button",
  T_40_XXJ_WS_QUATERNION: "Quaternion rotation",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Quick msg HUD switch",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Msgs beside team list",
  T_40_XXJ_WS_RADIUS_DESCKEY: "The radius of the two semicircles of a pill shape",
  T_40_XXJ_WS_READCELL: "Read A Cell",
  T_40_XXJ_WS_READCSV: "Read Table Content",
  T_40_XXJ_WS_READCSV_DESC: "Read the content on the entire table. Return a two-dimensional array.",
  T_40_XXJ_WS_READCSVCELL: "Read by row # and column name",
  T_40_XXJ_WS_READCSVCOL_DESC: "Read a certain column's content on the table. Returns an array.",
  T_40_XXJ_WS_READCSVROW_DESC: "Read a certain row's content on the table. Returns an array.",
  T_40_XXJ_WS_READLEADERBOARD: "Read Leaderboard Value",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Read a corresponding value of a certain identifier on a leaderboard table in the database.",
  T_40_XXJ_WS_READLEADERBOARD2: "Read By Rank Range",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Read the value of the difference between a certain rank to a certain rank on the leaderboard in a database.",
  T_40_XXJ_WS_RED: "Red",
  T_40_XXJ_WS_RELOAD: "Reload",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Method of display",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Restore the player's default outfit",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Restore the player's default weapon skin",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Whether the dragging is constrained to the viewport. Selected by default.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Constrain drag or not",
  T_40_XXJ_WS_RESULT_DESCKEY: "The result of the read",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Result",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Whether to find the largest number in the list",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Whether to find the smallest number in the list",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Find the smallest number in a list",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Find the largest number in a list",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "The revival point of a player. If there are no checkpoints, use a spawnpoint. Otherwise use checkpoints.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Revival point",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Right arm",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Right arm",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "The right color",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Right color",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the right",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Display right effect or not",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Right foot",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Right foot",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Right hand",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Right hand",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Right icon",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Right icon",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Right leg",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Right leg",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Right score text",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Right score text",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Right text",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Right text",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "The component of the rigid body type",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Rigid body component",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "The enum of the rigid body type",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Rigid body type enum",
  T_40_XXJ_WS_ROW_DECS: "The row to read.",
  T_40_XXJ_WS_ROWVALUE: "Row Content",
  T_40_XXJ_WS_SCALE_DESCKEY: "Configure the zoom scale of the object",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Scale",
  T_40_XXJ_WS_SCALE0_DESCKEY: "The zoom scale of the coordinate series in the world",
  T_40_XXJ_WS_SCALE1_DESCKEY: "The zoom scale. 1 by default.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "The scale value",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "The name of the area",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Scorebar",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Score bar",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Supports multiple scrolling directions",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Scroll direction",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "The factor of the scroll. The larger the value, the faster the scrolling.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Scroll factor",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Configure the camera's cullingMask",
  T_40_XXJ_WS_SETGLOBAL: "Set Global",
  T_40_XXJ_WS_SETPARENT_D: "Only supports entities that have the Transform component",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Configure the player's outfit ID",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Modify multiple player outfits",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Set Player Direction",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Configure a player's HUD switch",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Configure the player's weapon skin",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Whether to display entities at the target location",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Display entity on target",
  T_40_XXJ_WS_SHOWPLAYER: "Display entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Single-player match details HUD entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "A HUD entity for single-player matches. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_SIZEDELTA: "Size delta of anchor box and component",
  T_40_XXJ_WS_SKELETON: "Skeleton",
  T_40_XXJ_WS_SKELETON_D: "The pivot used to access the skeleton mask",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Skeleton part",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Skill button HUD entity",
  T_40_XXJ_WS_SLOT_DESCKEY: "The weapon's slot",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "When selected, there will be a slow movement upon dragging. When unselected, the dragging corresponds to the speed of the mouse.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Smooth motion or not",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Softness",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Softness",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Sound entity",
  T_40_XXJ_WS_SPACE_DESCKEY: "Space",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Child cell spacing",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "The coordinates of the AI's spawnpoint",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Spawn point coordinates",
  T_40_XXJ_WS_SPEED_DESCKEY: "Speed",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Speed",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Sprint",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "The radius of the sphere",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "The color of the spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Spray color",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "The spray result",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Spray result",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "The spray gun (assault rifle)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Spray Rifle",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Initial Velocity",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Flip sticker",
  T_40_XXJ_WS_SPRITEID: "Sprite asset ID",
  T_40_XXJ_WS_SPRITEID_D: "The ID used to describe the sprite asset",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Sticker type",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "The target entity to generate into a static pixel",
  T_40_XXJ_WS_STARTPOSITION_D: "The coordinates of the shape's geometrical center",
  T_40_XXJ_WS_STAY_D: "Retain the current world position, rotation, and scaling of the child? This is generally set to true, and UI settings are ineffective for this option.",
  T_40_XXJ_WS_STRING_NAMEKEY: "String",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Convert a string to a float",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Convert a string to an integer",
  T_40_XXJ_WS_STYLE_DESCKEY: "The play method of the interpolation. Options include play once, loop, and play again.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Switch the player's area",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Switch value",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Switch weapons according to the player's slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Switch the item slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Item switch",
  T_40_XXJ_WS_TABLENAME_DESC: "Displayed as the table name but is actually the UID",
  T_40_XXJ_WS_TABLEVALUE: "Table content",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "The list of tags",
  T_40_XXJ_WS_TARGET_DESCKEY: "The target entity to generate map pixel. Empty by default.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entity to create map pixel",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Attack target",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "The target entity",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entity",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "The entity where the customized function is at",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "The entity that is attacked by the AI",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "The target entity to follow",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "The item entity (can be empty)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "The target entity to look at",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "The sound entity to pause",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "The sound entity to play after the pause",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "The sound entity to delete",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Teammates info",
  T_40_XXJ_WS_TELEPORTA_D: "Teleport the player to a designated spot with a set direction",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Tip text",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Notification text color",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "The text entity represents the text to be displayed",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "The text keys to display",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Text key",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "The timestamp",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "The display style of a localized string",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Timestamp display style",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "The localized string for a timestamp",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Loc string timestamp",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Hint",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Tip",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "The amount of lootable item",
  T_40_XXJ_WS_TOKENID_DESCKEY: "The ID of a lootable item",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "The tow speed of a player",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Translation type",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "The interpolation animation entity",
  T_40_XXJ_WS_TYPE_DESCKEY: 'This is the type of the description. Using "typeof" will return its type.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Rigid body type",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Different types of rigid bodies have different functions",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Only basic currencies supported in the current version",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Whether to enable minimap depth display",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Use depth map",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Whether it follows the gravitational law",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitational or not",
  T_40_XXJ_WS_UUID_DESCKEY: "The unique identifier of a player",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "The value",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Value",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Value [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "The first value",
  T_40_XXJ_WS_VALUE2_DESCKEY: "The second value",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Value [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "The starting value",
  T_40_XXJ_WS_VALUEB_DESCKEY: "The target value",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "The name of the value to traverse. You can use this to obtain the value in a local variable.",
  T_40_XXJ_WS_VALUET_DESCKEY: "The interpolation progress. Lies in between 0 and 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Variable type",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "The vertical display type",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Vertical display type",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "The level of an object's visibility",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Visible layer",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Outfits include bundle, head, mask, facepaint, top, bottom, and shoes",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Outfit type",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Outfit slot",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Weapons",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "The weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "Weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "The ID of the weapon skin",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "The player's weapon skin",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Component type enum",
  T_40_XXJ_WS_WIDTH_DESCKEY: "The width",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Word Wrap",
  T_40_XXJ_WS_WRITELEADERBOARD: "Write Leaderboard Value",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Write a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XYL_WS_BUMPERFACTORY: "Bumper Car Factory",
  T_40_XYL_WS_BURNDAMAGE: "Combustion Damage",
  T_40_XYL_WS_BURNINTERVAL: "Combustion Damage Interval (s)",
  T_40_XYL_WS_BURNTIME: "Combustion Time After Explosion",
  T_40_XYL_WS_COLORFULSKY: "Colorful Sky",
  T_40_XYL_WS_CRANEMACHINE: "Claw Crane",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Maximum Crash Damage",
  T_40_XYL_WS_CRASHMAXSPEED: "Maximum Crash Damage Speed Limit",
  T_40_XYL_WS_CRASHMESS: "Mass Parameter During Crash",
  T_40_XYL_WS_CRASHMINDAMAGE: "Min. Crash Damage",
  T_40_XYL_WS_DISPLAYBOARD: "Billboard",
  T_40_XYL_WS_EXPLODEDAMAGE: "Explosion Damage",
  T_40_XYL_WS_EXPLODEDELAY: "Explosion Delay Time",
  T_40_XYL_WS_EXPLODERANGE: "Explosion Range",
  T_40_XYL_WS_FERRISWHEEL: "Ferris Wheel",
  T_40_XYL_WS_FOODTRUCK002: "Food Truck B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Gear Changing Time (s)",
  T_40_XYL_WS_ICAROUSEL001: "Merry-Go-Round Component A",
  T_40_XYL_WS_ICAROUSEL002: "Merry-Go-Round Component B",
  T_40_XYL_WS_ICAROUSEL003: "Merry-Go-Round",
  T_40_XYL_WS_ICEDANCEDOOL: "Blue Doll",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Uncontrolled Parking Horsepower Ratio",
  T_40_XYL_WS_LOLLIPOP: "Giant Lollipop",
  T_40_XYL_WS_NEWHOOKGUN: "Super Hook Gun",
  T_40_XYL_WS_OPENSWING: "Swing button",
  T_40_XYL_WS_OPENTRACTION: "Tow button",
  T_40_XYL_WS_PODIUM: "Podium",
  T_40_XYL_WS_SKYCITY: "City",
  T_40_XYL_WS_SKYSCRAPER_A001: "Skyscraper A Component A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Skyscraper A Component B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Skyscraper A Component C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Skyscraper B Component A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Skyscraper B Component B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Skyscraper B Component C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Skyscraper C Component A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Skyscraper C Component B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Skyscraper C Component C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Skyscraper D Component A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Skyscraper D Component B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Skyscraper D Component C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Skyscraper E Component A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Skyscraper E Component B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Skyscraper E Component C",
  T_40_XYL_WS_STEERANGLE: "High-speed Turning Radius",
  T_40_XYL_WS_STEERSPEED: "Maximum Speed During High-speed Turning",
  T_40_XYL_WS_SWINGSPEED: "Swing speed",
  T_40_XYL_WS_TARGETOBJECT: "Motion Anchor",
  T_40_XYL_WS_TRACTIONSPEED: "Tow speed",
  T_40_XYL_WS_TRIGGERCAPSULE: "Custom Capsule Trigger",
  T_40_XYL_WS_TRIGGERSPHERE: "Custom Sphere Trigger",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Custom Object",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "An empty object component that can be used with the render component and collision component.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Custom Render Component",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "A custom rendering component, used for rendering with custom model resources.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Your enemy markings have bounty value. Anyone on ally team who eliminates a marked enemy will earn [FFB300]{0} in-match currency[-]. You will earn an extra [FFB300]100[-] for eliminating an enemy. Receive extra [FFB300]{1} FF Coins[-] from Coin Machines in BR matches.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Money Mark",
  T_41_CJ_A_ESPORTS_TH: "FFTC The Pro (Mask)",
  T_41_CJ_B_ESPORTS_TH: "FFTC The Pro (Bottom)",
  T_41_CJ_H_ESPORTS_TH: "FFTC The Pro (Head)",
  T_41_CJ_S_ESPORTS_TH: "FFTC The Pro (Shoes)",
  T_41_CJ_T_ESPORTS_TH: "FFTC The Pro (Top)",
  T_41_CJ_T_FFSI: "FFSI Champion Jersey",
  T_41_CJ_T_FOOTBALL_EU01: "Sunburst Jersey",
  T_41_CJ_T_FOOTBALL_EU02: "Bold Red Jersey",
  T_41_CJ_T_FOOTBALL_EU03: "Majestic Crown Jersey",
  T_41_CJ_T_FOOTBALL_EU04: "Regal Titan Jersey",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Item",
  T_41_R_CD_COIL: "Zone Shrink",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Whether to activate this device",
  T_41_SJ_WS_SPECIALITEM_NAME: "Device",
  T_41_SW_SKILL_DESC_DELIVERY: "When hit by an enemy from within [FFB300]{0}m[-], said attacker is marked for [FFB300]{1}s[-] (intel is shared with teammates). Max. [FFB300]{2} markings[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Get [FFB300]{0} extra Shield Points[-] at the start of the match. Recovers Shield Points after surviving combat.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "When using an active skill, gives [FFB300]{1} Shield Points[-] to self and teammates within [FFB300]{0}m[-]. The Shield Points decay after [FFB300]{2}s[-], after which players can obtain the effects again. Cooldown: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Deployed Gloo Walls restore [FFB300]{0}[-] durability per second when hit, during which teammates within [FFB300]{1}m[-] restore [FFB300]{2} HP/s[-]. Max. [FFB300]{3} HP[-] per teammate from each Gloo Wall.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Pet Skin: Recollective Kactus",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Pet Skin: Inked Falco",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Type",
  T_41_WT_SKILL_DESC_FIREBOY: "Deploys a [FFB300]{1}m[-]-wide flaming screen that lasts [FFB300]{0}s[-] and moves forward at [FFB300]{2}m/s[-] for up to [FFB300]{3}s[-]. While in effect, use the skill again to stop the screen. [FFB300]Enemies (or Gloo Walls)[-] that get in touch with it will instantly take [FFB300]{4} (or {5}) DMG[-], and then take [FFB300]{6} (or {7}) DMG/s[-]. Lasts [FFB300]{8}s[-]. Cooldown: [FFB300]{9}s[-]. Up to [FFB300]{10}[-] skill uses can be stored, with a [FFB300]{11}s[-] cooldown between each use.",
  T_41_WT_SKILL_NAME_FIREBOY: "Flame Mirage",
  T_41_WZY_WS_CHARGEMAX: "Max. Gloo Maker charge",
  T_41_WZY_WS_CROSSBOWNAME: "Crossbow",
  T_41_WZY_WS_DECELERATIONRATIO: "Deceleration % in water",
  T_41_WZY_WS_DEICEWALLPARAM1: "Radius of melt area",
  T_41_WZY_WS_DEICEWALLPARAM2: "Duration of melt",
  T_41_WZY_WS_EXPPERCHIP: "EXP from Gloo Chip",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP from dealing DMG",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP from each meter traveled",
  T_41_WZY_WS_EXPPERSECOND: "EXP per second",
  T_41_WZY_WS_GRENADEEXPTIME: "Explosion delay",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosives",
  T_41_WZY_WS_GRENADEMAX: "Maximum DMG",
  T_41_WZY_WS_GRENADEMIN: "Minimum DMG",
  T_41_WZY_WS_GRENADERANGE: "Explosion range",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "DMG coefficient on vehicles",
  T_41_WZY_WS_GRENADERATIOSELF: "DMG coefficient on self",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "DMG coefficient on teammates",
  T_41_WZY_WS_GRENADTHROWSPEED: "Explosive travel speed",
  T_41_WZY_WS_HANDCANNONNAME: "Hand Cannon",
  T_41_XXJ_WS_ACCELERATION: "Acceleration",
  T_41_XXJ_WS_ACCELERATION_D: "Create a designated acceleration effect",
  T_41_XXJ_WS_ACTION: "Action node",
  T_41_XXJ_WS_ACTION_D: "Action Pivot",
  T_41_XXJ_WS_ADDHP: "Healing Items",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Add max. HP",
  T_41_XXJ_WS_AICASTSKILL_D: "AI release skill",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Aim assist center offset",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Aim assist distance",
  T_41_XXJ_WS_AIMASSISTENTITY: "Aim assist entity",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entity that can be aim assisted",
  T_41_XXJ_WS_AISKILLTYPE: "Zombie skill type",
  T_41_XXJ_WS_AISKILLTYPE_D: "Zombie skill type",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "All items",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "All items",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Modify magazine size",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Bullets in the magazine",
  T_41_XXJ_WS_ANCHORPOSITION_D: "The anchor coordinates in relation to the parent",
  T_41_XXJ_WS_ANGLE_D: "The z axis rotation angle",
  T_41_XXJ_WS_ANGULARDRAG: "Angular drag",
  T_41_XXJ_WS_ANGULARVELOCITY: "Angular velocity",
  T_41_XXJ_WS_ANIMATIONCLIP: "Animation state",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Animation Controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Animation entity",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "The file and resource used to manage the animation controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "Animation controller resource UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Loop type enum",
  T_41_XXJ_WS_ANIMATIONSTATE: "Animation state",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Operation, where all types of value assignment are supported, and digital types also support self-increment, self-subtraction, self-multiplication, and self-division",
  T_41_XXJ_WS_ATTACHMENT: "Attachment",
  T_41_XXJ_WS_ATTACHMENT_D: "Attachment",
  T_41_XXJ_WS_ATTACHTARGET: "Linked entity",
  T_41_XXJ_WS_BAG: "Backpack",
  T_41_XXJ_WS_BAG_D: "Backpack Component",
  T_41_XXJ_WS_BANNERID: "Banner ID",
  T_41_XXJ_WS_BANNERID_D: "Banner ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "Behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Behavior Tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Behavior-mountable tree entity",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "A behavior tree entity that can be mounted",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Behavior tree custom node",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Behavior Tree Custom Pivot",
  T_41_XXJ_WS_BODY: "Body",
  T_41_XXJ_WS_BORDERLR: "Border (left & right)",
  T_41_XXJ_WS_BORDERLR_D: "The left and right border",
  T_41_XXJ_WS_BORDERTB: "Border (top & bottom)",
  T_41_XXJ_WS_BORDERTB_D: "The top and bottom border",
  T_41_XXJ_WS_BRPEAKRANK: "Highest BR rank",
  T_41_XXJ_WS_BRPEAKRANK_D: "Highest BR rank",
  T_41_XXJ_WS_BRRANK: "BR rank",
  T_41_XXJ_WS_BRRANK_D: "BR Rank",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Behavior tree node type",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Behavior Tree Pivot Type",
  T_41_XXJ_WS_BTREE: "Behavior tree",
  T_41_XXJ_WS_BTREENODESTATE: "Behavior tree node state",
  T_41_XXJ_WS_BTREENODESTATE_D: "Behavior Tree Pivot Operating Status",
  T_41_XXJ_WS_BUFFABLEENTITY: "Buff-enabled entity",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Enables adding buffs, removing buffs, and getting added buff lists",
  T_41_XXJ_WS_BUILDINGICEWALL: "Gloo Wall",
  T_41_XXJ_WS_CAMOUFLAGE: "Functional items",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Skyboard, Camouflage...",
  T_41_XXJ_WS_CAPICITY_D: "Initial Capacity",
  T_41_XXJ_WS_CENTERINVISIBLE: "Invisible to center",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Not visible to center",
  T_41_XXJ_WS_COLOR: "Color",
  T_41_XXJ_WS_COLOR_D: "The color",
  T_41_XXJ_WS_CONDITION: "Condition node",
  T_41_XXJ_WS_CONDITION_D: "Conditions are a special Boolean type",
  T_41_XXJ_WS_CONDITION1_D: "Condition Pivot",
  T_41_XXJ_WS_CONSTRAIN: "RigidBody constraint",
  T_41_XXJ_WS_CONSTRAIN_D: "Add constraints to the RigidBody. This is a compilation of RigidBody Constraint Type.",
  T_41_XXJ_WS_COUNT_D: "Amount",
  T_41_XXJ_WS_CROSSBOW_D: "Crossbow",
  T_41_XXJ_WS_CSPEAKRANK: "Highest CS rank",
  T_41_XXJ_WS_CSPEAKRANK_D: "Highest CS rank",
  T_41_XXJ_WS_CSRANK: "CS rank",
  T_41_XXJ_WS_CSRANK_D: "CS Rank",
  T_41_XXJ_WS_CSVNAME_D: "The csv file under SceneData that corresponds to the mode. Ends in .csv. Headers are written in lower case letters.",
  T_41_XXJ_WS_CURCAPACITY: "Used capacity",
  T_41_XXJ_WS_CURPROGRESS: "Current progress",
  T_41_XXJ_WS_CURRENTCLIP: "Current clip",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Current clip progress",
  T_41_XXJ_WS_CURRENTSTATE: "Current state",
  T_41_XXJ_WS_CUSTOMHUDID: "Custom HUD ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "The ID used to describe a custom HUD asset",
  T_41_XXJ_WS_DASHATTACK: "Dash attack",
  T_41_XXJ_WS_DEBUG: "Start debugging",
  T_41_XXJ_WS_DEBUG_D: "Fix",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "Deceleration %: The deceleration when an object is in the water (range temporarily set as 0-100)",
  T_41_XXJ_WS_DEPTH_D: "The depth",
  T_41_XXJ_WS_DRAG: "Drag coefficient",
  T_41_XXJ_WS_DRAG_D: "The larger the coefficient, the faster the movement speed deceleration",
  T_41_XXJ_WS_DUMMY: "Dummy",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Enable low-graphics mode",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "When low fps is on, the game will run on 15 fps; or else 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Return entity list created",
  T_41_XXJ_WS_ENTITYNAME: "Object name",
  T_41_XXJ_WS_ENTITYNAME_D: "The object name customized by the player",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Logical Entity or Prefab ID",
  T_41_XXJ_WS_EQUIPANDBAG: "Armor and Backpack",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Equipment slot enum",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Equipment Slot Enum",
  T_41_XXJ_WS_EXPLODE: "Self-explode",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Explosive Weapon",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Auto reload speed",
  T_41_XXJ_WS_FILEID: "Internal ID",
  T_41_XXJ_WS_FILEID_D: "The internal ID of the control in the prefab",
  T_41_XXJ_WS_FILLAMOUNT: "Fill amount",
  T_41_XXJ_WS_FILLAMOUNT_D: "The fill value",
  T_41_XXJ_WS_FILLDIR: "Fill direction",
  T_41_XXJ_WS_FILLDIR_D: "The direction of the fill",
  T_41_XXJ_WS_FILLDIR_D1: "Fill direction enum",
  T_41_XXJ_WS_FILLTYPE: "Fill type",
  T_41_XXJ_WS_FILLTYPE_D: "The fill type",
  T_41_XXJ_WS_FILLTYPE_D1: "Fill type enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Find path",
  T_41_XXJ_WS_FINISH: "Complete",
  T_41_XXJ_WS_FIREINTERVAL: "Firing interval",
  T_41_XXJ_WS_FIREINTERVAL_D: "Attack Interval",
  T_41_XXJ_WS_FLIP: "Flip method",
  T_41_XXJ_WS_FLIP_D: "The flip method",
  T_41_XXJ_WS_FLYBOMBBEE: "Flying Zombie",
  T_41_XXJ_WS_FORCE: "Force",
  T_41_XXJ_WS_FORCE_D: "Create a force of a designated intensity",
  T_41_XXJ_WS_FORCETYPE: "Force type",
  T_41_XXJ_WS_FORCETYPE_D: "The different types of forces on the RigidBody. P.S. Only effective on dynamic RigidBody types.",
  T_41_XXJ_WS_FREEZEALL: "Freeze movement and rotation",
  T_41_XXJ_WS_FREEZEPOSITION: "Freeze linear movement",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Freeze x axis",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Freeze y axis",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Freeze z axis",
  T_41_XXJ_WS_FREEZEROTATION: "Freeze all rotation",
  T_41_XXJ_WS_FREEZEROTATIONX: "Freeze x rotation",
  T_41_XXJ_WS_FREEZEROTATIONY: "Freeze y rotation",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Freeze z rotation",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Distance for max. damage",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Distance for max. damage",
  T_41_XXJ_WS_GAMEID_D: "Mission ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Give a Metropolis item",
  T_41_XXJ_WS_GRADIENT: "Gradient",
  T_41_XXJ_WS_GRADIENT_D: "The gradient",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Gradient at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "The gradient at the bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparency at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Bottom Transparency",
  T_41_XXJ_WS_GRADIENTTOP: "Gradient at top",
  T_41_XXJ_WS_GRADIENTTOP_D: "The gradient at the top",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparency at top",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Top Transparency",
  T_41_XXJ_WS_GRAPHID: "Script ID",
  T_41_XXJ_WS_GRAPHID_D: "The ID used to describe a script asset",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Gloo Melter Component",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Explosion Delay",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Throwable",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Max. DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Min. DMG",
  T_41_XXJ_WS_GRENADERANGE_D: "Explosion Range",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Self DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Ally DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Vehicle DMG multiplier",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Throwing Speed",
  T_41_XXJ_WS_GRENADEWEAPON: "Throwable category",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Basic Throwable Types",
  T_41_XXJ_WS_HANDCANNON_D: "Throwables",
  T_41_XXJ_WS_HEAD: "Head",
  T_41_XXJ_WS_HEADID: "Avatar ID",
  T_41_XXJ_WS_HEADID_D: "Avatar ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Heavy Weapon",
  T_41_XXJ_WS_HELMET_D: "The current helmet",
  T_41_XXJ_WS_HELMET1_D: "Helmet",
  T_41_XXJ_WS_HELMET2_D: "Helmet Entity",
  T_41_XXJ_WS_HITBODYPART_D: "The body part that is hit",
  T_41_XXJ_WS_HITBPDYPART: "Hit body part",
  T_41_XXJ_WS_HITENTITY_D: "Hit Entity",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "The HUD entity it belongs to",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D content container",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "The HUD 3D container entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDGRID: "Custom Layout(Panel) control",
  T_41_XXJ_WS_HUDLAYOUT: "Layout control",
  T_41_XXJ_WS_HUDLAYOUT_D: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Custom avatar control",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "The HUD profile info entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTEXTURE: "Texture control",
  T_41_XXJ_WS_HUDTEXTURE_D: "The HUD texture entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTRANSFORM: "UITransform control component",
  T_41_XXJ_WS_HUDTRANSFORM_D: "The UITransform control entity",
  T_41_XXJ_WS_IMPULSE: "Strike",
  T_41_XXJ_WS_IMPULSE_D: "Create a strike of a designated intensity",
  T_41_XXJ_WS_INITIALWORLDPOS: "Initial world coordinates",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Buff enum",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Corresponds to the ID column in the BuffData.csv. Before adding new content, please first check compatability with GPP.",
  T_41_XXJ_WS_INVERTFILL: "Invert fill",
  T_41_XXJ_WS_INVERTFILL_D: "Invert the fill",
  T_41_XXJ_WS_ISLOOP: "Is loop",
  T_41_XXJ_WS_ISLOOP_D: "Whether or not to loop. Default is false.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Static NavMesh generation",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Only used to check for static NavMesh generation when static loading objects",
  T_41_XXJ_WS_ISSUCCESS_D: "Destructed or not",
  T_41_XXJ_WS_ITEMENTITY_D: "Item Entity",
  T_41_XXJ_WS_ITEMID: "Item ID",
  T_41_XXJ_WS_ITEMID_D: "Item ID",
  T_41_XXJ_WS_ITEMID_D1: "The corresponding item ID of the attachment",
  T_41_XXJ_WS_ITEMLIST: "Item list",
  T_41_XXJ_WS_ITEMTYPE_D: "Item Type",
  T_41_XXJ_WS_JUMPATTACK: "Jump attack",
  T_41_XXJ_WS_LANDMINE: "Landmine",
  T_41_XXJ_WS_LENGTH: "Clip length",
  T_41_XXJ_WS_LENGTH_D: "The length of the progress bar. The default value is the length on the prefab UI.",
  T_41_XXJ_WS_LIMB: "Limbs",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Failed to add element since list length has exceeded capacity",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Buff list",
  T_41_XXJ_WS_LOOP: "Loop",
  T_41_XXJ_WS_LOOP_D: "Loop",
  T_41_XXJ_WS_MAXCAPACITY: "Capacity",
  T_41_XXJ_WS_MAXCAPACITY_D: "The backpack capacity",
  T_41_XXJ_WS_MAXPROGRESS: "Max. progress",
  T_41_XXJ_WS_MELEEWEAPON_D: "Melee Weapon",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Distance for min. damage",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Distance for min. damage",
  T_41_XXJ_WS_MINISENTRY: "Auto Turret",
  T_41_XXJ_WS_NAME: "Name",
  T_41_XXJ_WS_NAME_D: "The name of the skill button. Used for parameter sending during OnClick incidents, so uniqueness must be guaranteed.",
  T_41_XXJ_WS_NAME1_D: "Merchandise Name",
  T_41_XXJ_WS_NAME2_D: "Merchandise List Name",
  T_41_XXJ_WS_NAME3_D: "Vending Machine Name",
  T_41_XXJ_WS_NICKNAME: "Nickname",
  T_41_XXJ_WS_NICKNAME_D: "Player Name",
  T_41_XXJ_WS_NOCHANGE: "No changes",
  T_41_XXJ_WS_NONE: "No constraints",
  T_41_XXJ_WS_NONE1: "None",
  T_41_XXJ_WS_OFFSET: "Offset",
  T_41_XXJ_WS_OFFSET_D: "Offset",
  T_41_XXJ_WS_OFFSET1_D: "Written Offset Value",
  T_41_XXJ_WS_ONCE: "Once",
  T_41_XXJ_WS_ONCE_D: "Once",
  T_41_XXJ_WS_ONHIDE: "When interface is closed",
  T_41_XXJ_WS_ONHIDE_D: "When the interface is closed",
  T_41_XXJ_WS_ONNODEENTER_D: "When the pivot is entering",
  T_41_XXJ_WS_ONSHOW: "When interface is open",
  T_41_XXJ_WS_ONSHOW_D: "When the interface is open",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Triggers when the text box has changed",
  T_41_XXJ_WS_PERSONALUAV: "UAV-Lite",
  T_41_XXJ_WS_PINID: "Pin ID",
  T_41_XXJ_WS_PINID_D: "Pin ID",
  T_41_XXJ_WS_PLAYERBAG: "Player backpack entity",
  T_41_XXJ_WS_PLAYERBAG_D: "The player's backpack entity",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Player backpack",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Player's backpack",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Modified coefficient of speed while scoped in",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Impact of movement speed while firing",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Impact of movement speed while firing",
  T_41_XXJ_WS_PREFABID: "Prefab ID",
  T_41_XXJ_WS_PREFABID_D: "The ID used to describe a prefab asset",
  T_41_XXJ_WS_PREFABID1_D: "The HUD template entity that this ID represents",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Main Weapon 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Main Weapon 2",
  T_41_XXJ_WS_PROFILEINFO: "Player profile",
  T_41_XXJ_WS_PROFILEINFO_D: "Player bio",
  T_41_XXJ_WS_PROGRESSICON_D: "The progress icon",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Progress icon name",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Quit the Metropolis minigame",
  T_41_XXJ_WS_RANGE: "Firing range",
  T_41_XXJ_WS_RANGE_D: "Attack Range",
  T_41_XXJ_WS_RANGE_D1: "Explosion Range",
  T_41_XXJ_WS_RANGE_D2: "Turret Range",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Read the content on the entire table. Return a two-dimensional array.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Read the content of a certain cell",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Read a certain column's content. Returns an array.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Read a certain row's content. Returns an array.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Read accumulated database",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Read the value corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Continuously recover HP",
  T_41_XXJ_WS_RELOADSPEED: "Reload speed",
  T_41_XXJ_WS_RELOADSPEED_D: "Reload Speed (Basic Speed x Multiplier)",
  T_41_XXJ_WS_RESOURCEID: "Resource UUID",
  T_41_XXJ_WS_RESOURCEID_D: "Resource UUID",
  T_41_XXJ_WS_RESUUID: "Resource ID",
  T_41_XXJ_WS_RESUUID_D: "The designated resource UUID to render",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "RigidBody constraint type",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Each constraint is defined by a bit marking and can be used as a combination",
  T_41_XXJ_WS_ROTATION: "Rotation",
  T_41_XXJ_WS_ROTATION_D: "The rotation angle in the world coordinates. x, y, z refers to the yaw, pitch, and roll, respectively.",
  T_41_XXJ_WS_ROTATION1_D: "The rotation",
  T_41_XXJ_WS_RUNNING: "Running",
  T_41_XXJ_WS_SCALE: "Scale",
  T_41_XXJ_WS_SCALE_D: "Scale",
  T_41_XXJ_WS_SCALE1_D: "Scales along a certain axis. Can be a combination of three axes.",
  T_41_XXJ_WS_SCATTERMAX: "Max. bullet scatter",
  T_41_XXJ_WS_SCATTERMAX_D: "The value at which bullet spread begins",
  T_41_XXJ_WS_SCATTERMOVE1: "Spread size when moving",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERSPEED: "Speed of spread increase",
  T_41_XXJ_WS_SCATTERSPEED_D: "Speed of spread increase (0.1 = The crosshair enlarges 10% for every one burst increase)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Less spread on prone and crouch",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Secondary Weapon",
  T_41_XXJ_WS_SHADERNAME: "Shader name",
  T_41_XXJ_WS_SHADERNAME_D: "The shader name",
  T_41_XXJ_WS_SHIELDBROKEN: "Shield-shatter attack",
  T_41_XXJ_WS_SHIELDUP: "Shield attack",
  T_41_XXJ_WS_SHOCKWAVE: "Shockwave",
  T_41_XXJ_WS_SHOWNAME: "Display nickname",
  T_41_XXJ_WS_SHOWNAME_D: "Display Nickname",
  T_41_XXJ_WS_SHOWPIN: "Display pin",
  T_41_XXJ_WS_SHOWPIN_D: "Display Pin",
  T_41_XXJ_WS_SHOWRANK: "Display rank",
  T_41_XXJ_WS_SHOWRANK_D: "Display Rank",
  T_41_XXJ_WS_SHOWTYPE: "Design",
  T_41_XXJ_WS_SHOWTYPE_D: "Type",
  T_41_XXJ_WS_SHRINKSPEED: "Shrink speed",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Enable aim assist on scope",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Aim assist crosshair sensitivity with distance (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Coefficient when prioritizing distance for aim assist (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Max. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Min. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Aim assist crosshair sensitivity (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Scope zoom in factor",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV zoom in factor",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Scope rotation sensitivity coefficient",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Modified coefficient x of min. scoped in DMG",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Scoped in firing UI zoom in time (s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Scoped in firing UI zoom in factor",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Scoped in firing UI resume time (s)",
  T_41_XXJ_WS_SPEED: "Playback speed",
  T_41_XXJ_WS_SPEEQUIP: "Functional equipment",
  T_41_XXJ_WS_SPEITEM: "Devices",
  T_41_XXJ_WS_STATICGRAPHID: "Static script ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "The ID used to describe a static script asset",
  T_41_XXJ_WS_STATICWAINING: "Failed to modify static Rigidbody type",
  T_41_XXJ_WS_TARGETTREE: "Behavior tree entity",
  T_41_XXJ_WS_TARGETTREE_D: "The behavior tree entity",
  T_41_XXJ_WS_TEAMINDEX: "Team serial no.",
  T_41_XXJ_WS_TEAMINDEX_D: "The team index, which coincides with the team index in the room",
  T_41_XXJ_WS_TEAMINDEX_D1: "Team Faction Number",
  T_41_XXJ_WS_TEMPLATEPREFABID: "Template prefab ID",
  T_41_XXJ_WS_TEXT_D: "Content",
  T_41_XXJ_WS_TEXTURENAME: "Texture name",
  T_41_XXJ_WS_TEXTURENAME_D: "The texture name",
  T_41_XXJ_WS_THROWATTACK: "Grenade",
  T_41_XXJ_WS_TICKINTERVAL: "Refresh interval",
  T_41_XXJ_WS_TICKINTERVAL_D: "Refresh interval. The larger the number, the longer the refresh takes.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Enable special devices in the player's backpack",
  T_41_XXJ_WS_UVRECTWH: "UV width & height",
  T_41_XXJ_WS_UVRECTWH_D: "The UV width and height",
  T_41_XXJ_WS_UVRECTXY: "UV offset",
  T_41_XXJ_WS_UVRECTXY_D: "The UV offset",
  T_41_XXJ_WS_VELOCITY: "Velocity",
  T_41_XXJ_WS_VELOCITY_D: "Refrain from directly changing the RigidBody's speed. You may change it using related APIs.",
  T_41_XXJ_WS_VEST_D: "The current vest",
  T_41_XXJ_WS_VEST1_D: "Vest",
  T_41_XXJ_WS_WIDGETID: "Control ID",
  T_41_XXJ_WS_WIDGETID_D: "The ID used to describe a control in the interface assets. It must be paired with a custom HUD ID in order to ensure that it corresponds to a unique control ID.",
  T_41_XXJ_WS_WINDATTACK: "Tornado attack",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Write accumulated database offset",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Write the offset corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_ZONEDURATION_D: "Freeze duration",
  T_41_XXJ_WS_ZONEDURATION1_D: "Gloo Melter Duration",
  T_41_XXJ_WS_ZONERADIUS_D: "Freeze zone radius",
  T_41_XXJ_WS_ZONERADIUS1_D: "Gloo Melter Radius",
  T_41_XYL_WS_BOT12: "Earth Driller",
  T_41_XYL_WS_BOT9: "Mutated Tossing Zombie",
  T_41_XYL_WS_ITEM262: "Frozen Steel Panel A",
  T_41_XYL_WS_ITEM263: "Frozen Container A",
  T_41_XYL_WS_ITEM264: "Frozen Supply Container",
  T_41_XYL_WS_ITEM265: "Frozen Metal Gate",
  T_41_XYL_WS_ITEM266: "Frozen Container B",
  T_41_XYL_WS_ITEM267: "Frozen Stone A",
  T_41_XYL_WS_ITEM268: "Frozen Stone B",
  T_41_XYL_WS_ITEM269: "Frozen Stone C",
  T_41_XYL_WS_ITEM270: "Frozen Stone D",
  T_41_XYL_WS_ITEM271: "Abandoned Subway Car",
  T_41_XYL_WS_MODELMATCHNAME: "Contest Canvas",
  T_41_XYL_WS_NAVMESH: "Dynamic navmesh",
  T_41_XYL_WS_REFCUBE: "Reflective Cube",
  T_41_XYL_WS_SNOWSKY: "Frost Galaxy",
  T_41_XYL_WS_TOYCUBE: "Play Cube",
  T_42_CJ_F_B_VOCATIONAL: "Gearing Blueprint (Bottom)",
  T_42_CJ_F_H_VOCATIONAL: "Gearing Blueprint (Head)",
  T_42_CJ_F_S_VOCATIONAL: "Gearing Blueprint (Shoes)",
  T_42_CJ_F_T_VOCATIONAL: "Gearing Blueprint (Top)",
  T_42_CJ_HA_THUNDER_GOLD: "Lightning Facepaint",
  T_42_CJ_M_B_VOCATIONAL: "Mechanic Masterplan (Bottom)",
  T_42_CJ_M_H_VOCATIONAL: "Mechanic Masterplan (Head)",
  T_42_CJ_M_S_VOCATIONAL: "Mechanic Masterplan (Shoes)",
  T_42_CJ_M_T_VOCATIONAL: "Mechanic Masterplan (Top)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Gloo Wall - Tiger's Fury",
  T_42_H_GRENADE_SMUDGE_N: "Grenade - Feline Shadow",
  T_42_H_M1917_EMPIRE_N: "M1917 - Crowned Conqueror",
  T_42_HJ_WS_VFX_INK: "Ink",
  T_42_JH_WS_BANMATCHMAKING: "Matchmaking not allowed for this map",
  T_42_JH_WS_BANROOMCREATE: "Unable to create a room",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Party Remix (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Wall of Flame (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Shape Splitter (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nano Lifeshield (Sonia)",
  T_42_JH_WS_TAG1: "Frost Brawl",
  T_42_JH_WS_TAG10: "Infinity Racer",
  T_42_JH_WS_TAG11: "Race Rush",
  T_42_JH_WS_TAG12: "Car Racing",
  T_42_JH_WS_TAG13: "Exclude from Popular",
  T_42_JH_WS_TAG14: "Frontline",
  T_42_JH_WS_TAG15: "Zombie War",
  T_42_JH_WS_TAG16: "Legacy Legend",
  T_42_JH_WS_TAG2: "Social Island 1.0",
  T_42_JH_WS_TAG3: "Social Island 2.0",
  T_42_JH_WS_TAG4: "Play Together",
  T_42_JH_WS_TAG5: "Ruin Survivor",
  T_42_JH_WS_TAG6: "Preying Party",
  T_42_JH_WS_TAG7: "Preying Party",
  T_42_JH_WS_TAG8: "Fort Feud 2.0",
  T_42_JH_WS_TAG9: "Bounty Hunting",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Place a portal anywhere and teleport away!",
  T_42_RW_PORTALSPERSONAL_NAME: "Portal Go",
  T_42_SJ_WS_ACCESSORIESITEM: "Equip attachment",
  T_42_SJ_WS_AUTOPLAY: "Auto play",
  T_42_SJ_WS_CLIMB: "Climb over",
  T_42_SJ_WS_CLOCK_EVENTS: "Event compilation",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Countdown or not",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Loops",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Pause event",
  T_42_SJ_WS_CLOCK_START_EVENT: "Start event",
  T_42_SJ_WS_CLOCK_START_TIME: "Countdown start time",
  T_42_SJ_WS_CLOCK_STATE: "Stopwatch status",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Stop event",
  T_42_SJ_WS_DAMRATIOHEAD: "Headshot DMG coefficient change",
  T_42_SJ_WS_DAMRATIOLIMB: "Limb DMG coefficient change",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Reduction coefficient from explosive DMG",
  T_42_SJ_WS_DRIVE: "Drive",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Display layers",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Extra backpack capacity",
  T_42_SJ_WS_EXTRAHPRATIO: "HP ratio",
  T_42_SJ_WS_GETOFF_DRIVE: "Exit vehicle",
  T_42_SJ_WS_GETON_DRIVE: "Enter vehicle",
  T_42_SJ_WS_KNIFEITEM: "Dagger",
  T_42_SJ_WS_KNIFEITEMPICK: "Dagger (ground loot)",
  T_42_SJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "You can enable or disable the pin button",
  T_42_SJ_WS_MAXDISTANCE: "Max. distance",
  T_42_SJ_WS_MAXDURARATIO: "Max. durability ratio",
  T_42_SJ_WS_MICBTNHUD: "The mic switch on the HUD",
  T_42_SJ_WS_MICBTNHUD_D: "You can enable or disable the mic button",
  T_42_SJ_WS_MINDISTANCE: "Min. distance",
  T_42_SJ_WS_OPE_VEHICLE: "Operate vehicle",
  T_42_SJ_WS_PLANE_DESC: "A basic mesh whose size can be freely adjusted",
  T_42_SJ_WS_PLANENAME: "Basic Plane",
  T_42_SJ_WS_PRIORITY: "Priority",
  T_42_SJ_WS_REPLACEPRIORITY: "Replace priority",
  T_42_SJ_WS_SETBTNHUD: "The settings button on the HUD",
  T_42_SJ_WS_SETBTNHUD_D: "You can enable or disable the settings button",
  T_42_SJ_WS_SIGNALBTNHUD: "The network connection button on the HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "You can enable or disable the network connection button",
  T_42_SJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "You can enable or disable the vehicle horn button",
  T_42_SJ_WS_START_TIME: "Start time (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Get an additional [FFB300]{0}[-] backpack capacity for ammo, excluding Grenade Launcher. ([FFB300]{1}[-] AR Ammo, [FFB300]{2}[-] SMG Ammo, [FFB300]{3}[-] Sniper Ammo, [FFB300]{4}[-] SG Ammo)",
  T_42_SW_SKILL_DESC_Bodyguard: "Reload speed increases by [FFB300]{0}%[-]. Every time the skill user hits an enemy, said target will get a [FFB300]{1}%[-] healing deduction that lasts for [FFB300]{3}s[-] (max. deduction: [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Become immune from disruptive effects (e.g. slowdown, marking, skill-silencing) and have a [FFB300]{1}%[-] movement speed boost for [FFB300]{2}s[-]. Cooldown: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "After knocking down an enemy or using an active skill, [FFB300]{0}%[-] of the gun's magazine reloads automatically.",
  T_42_SW_SKILL_NAME_Playboy: "Silver Spoon",
  T_42_SY_BACKPACK_EMPIRE_N: "Backpack - Crowned Roar",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Pet Skin: Icy Hop",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Motorbike - Urban Scooter",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Amount of CS Cash obtained after losing a round",
  T_42_TYC_CST_LOSE_MONEY_2: "Amount of CS Cash obtained upon a 2-round losing streak",
  T_42_TYC_CST_LOSE_MONEY_3: "Amount of CS Cash obtained upon a 3-round losing streak",
  T_42_WH_ITEM_HEALUAV: "Heal UAV-Lite",
  T_42_WH_ITEM_HEALUAV_DESC: "Deploys a UAV-Lite that flies forward and continuously heals teammates within the range below",
  T_42_WH_ITEM_SKILLCARD: "Skill: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Use to release the active skill of [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Ammo Type",
  T_42_XXJ_WS_AMMOTYPE_D: "Ammo Type",
  T_42_XXJ_WS_ASSETCONFIGID: "Skin ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Skin",
  T_42_XXJ_WS_ATTACKSTATUS: "Attack status",
  T_42_XXJ_WS_AUTOPLAY: "Auto play",
  T_42_XXJ_WS_AUTOPLAY_D: "Auto play",
  T_42_XXJ_WS_AVATARABLE: "Modifiable appearance component",
  T_42_XXJ_WS_AVATARABLE_D: "Change appearance according to the parts",
  T_42_XXJ_WS_AVATARRESUUID: "Appearance resource UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Convert the axis-angle representation of a rotation into Quaternions",
  T_42_XXJ_WS_B_D: "The B color value",
  T_42_XXJ_WS_BASEVALUE_D: "Base of logarithm",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier curve",
  T_42_XXJ_WS_BEZIERCURVE_D: "The Bézier curve",
  T_42_XXJ_WS_BOTDIFFICULTY: "Bot Difficulty",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Combination Method of Bounciness",
  T_42_XXJ_WS_BOUNCINES: "Bounciness",
  T_42_XXJ_WS_BTREEID: "Behavior tree ID",
  T_42_XXJ_WS_BTREEID_D: "Behavior tree ID",
  T_42_XXJ_WS_CANPURCHAS: "Purchasable or Not",
  T_42_XXJ_WS_CANPURCHAS_D: "Purchasable or not",
  T_42_XXJ_WS_CLIMBSTATUS: "Climbing behavior",
  T_42_XXJ_WS_CLOCK: "Timer Object",
  T_42_XXJ_WS_CLOCK_D: "Timer Object",
  T_42_XXJ_WS_CLOCK_D1: "Timer",
  T_42_XXJ_WS_CONTAINER: "Container",
  T_42_XXJ_WS_CONTROLPOINTS: "Control points",
  T_42_XXJ_WS_CONTROLPOINTS_D: "The control points",
  T_42_XXJ_WS_COROUTINEID: "Coroutine handle",
  T_42_XXJ_WS_COROUTINEID_D: "The Coroutine ID refers to the handle of a specific coroutine. It allows for various operations to be performed on the handle.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESOUND: "Create Sound Effect",
  T_42_XXJ_WS_CREATESOUND_D: "Play the designated sound effect. If there are more properties to set, you can do so by configuring its entity properties.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Complete custom mission",
  T_42_XXJ_WS_DAMAGELIST_D: "DMG increment list",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Headshot DMG ratio",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Explosion DMG reduction multiplier",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Default Physics Material",
  T_42_XXJ_WS_DEFAULTFIST_D: "Default fist",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Logic frame interval",
  T_42_XXJ_WS_DELTATIME_D: "The interval between the 2 logic frame updates of the GS",
  T_42_XXJ_WS_DEPTH: "Layer",
  T_42_XXJ_WS_DEPTH_D: "Display layers on the icon",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "List of disabled ground loot",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "The list of items that are not ground loot",
  T_42_XXJ_WS_DRIVER: "Driver's seat",
  T_42_XXJ_WS_DRIVINGSTATUS: "Drive",
  T_42_XXJ_WS_DURATION_D1: "The countdown duration in seconds",
  T_42_XXJ_WS_DURATION_D2: "The duration in seconds",
  T_42_XXJ_WS_DURATION_D3: "The duration",
  T_42_XXJ_WS_DURATION_D4: "The duration of invulnerability in seconds",
  T_42_XXJ_WS_DURATIONTIMES: "Time Duration",
  T_42_XXJ_WS_DURATIONTIMES_D: "The duration in seconds",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Dynamic Friction",
  T_42_XXJ_WS_EASY: "Very Easy",
  T_42_XXJ_WS_ENDTIMES: "End Time",
  T_42_XXJ_WS_ENDTIMES_D: "The end time on the timer in seconds",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Global Energy Threshold",
  T_42_XXJ_WS_ENTITYVARNAME_D: "The self-relative entity",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Equip attachment",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Convert the given Euler angles into Quaternions",
  T_42_XXJ_WS_EXPONENTIATION_D: "Exponentiation",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Extra backpack capacity",
  T_42_XXJ_WS_FIST: "Fist",
  T_42_XXJ_WS_FONTTYPE: "Font enum",
  T_42_XXJ_WS_FONTTYPE_D: "Font enum",
  T_42_XXJ_WS_FORCESYNCVALUE: "Force sync GS status",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "The force sync value",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "The location info. from the GS force sync",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Location info from force sync",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "An entity that can formulate properties",
  T_42_XXJ_WS_FORWARD_D: "Direction vector",
  T_42_XXJ_WS_FRICTION_COMBINE: "Method of Friction Combination",
  T_42_XXJ_WS_FUNCPOINT: "Function Pointer",
  T_42_XXJ_WS_FUNCPOINT_D: "A pointer that points to an instance of a function. It is used to implement virtual functions or delegate mechanisms.",
  T_42_XXJ_WS_GETMAPID_D: "Get Map ID",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Exit vehicle",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Enter vehicle (driver)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Enter vehicle (passenger)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Search for today's player token data",
  T_42_XXJ_WS_GRAVITY: "Global Gravity",
  T_42_XXJ_WS_HANDHELDITEM: "Current handheld",
  T_42_XXJ_WS_HANDHELDITEM_D: "The current handheld",
  T_42_XXJ_WS_HARD: "Hard",
  T_42_XXJ_WS_HASCOMPONENT_D: "Whether there exists a component",
  T_42_XXJ_WS_HEIGHTLIST_D: "Height increment list",
  T_42_XXJ_WS_INDEXLIST_D: "Access the index list of the string",
  T_42_XXJ_WS_INSCENE: "In scene",
  T_42_XXJ_WS_INSCENE_D: "In scene",
  T_42_XXJ_WS_IS3D_D: "Whether it is a 3D music",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Countdown or stopwatch",
  T_42_XXJ_WS_ISLOOP: "Loop or not",
  T_42_XXJ_WS_ISLOOP_D: "The IsLoop command",
  T_42_XXJ_WS_ISREPLAY_D: "Whether or not to start from the beginning",
  T_42_XXJ_WS_ISSWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it can be combined with absolute motion.",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Jump status",
  T_42_XXJ_WS_LEFTVALUE: "Left Value",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logarithm",
  T_42_XXJ_WS_LOOPABLE: "Loopable",
  T_42_XXJ_WS_LOOPABLE_D: "Loopable",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Get all keys from the dict",
  T_42_XXJ_WS_MAPVALUE_D: "Target Dict",
  T_42_XXJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "The maximum distance",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "The mic switch on the HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "The minimum distance",
  T_42_XXJ_WS_MISSIONID_D: "Mission ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progress (cannot be a negative number)",
  T_42_XXJ_WS_MODERATE: "Moderate",
  T_42_XXJ_WS_MONSTERTRUCK: "Monster Truck",
  T_42_XXJ_WS_MOTORBIKE: "Motor Bike",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Movement status",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplication of two quaternions (representing rotation superposition)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Discarded",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Enable player perspective",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Enable player perspective",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Weapon Type",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Weapon Type",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Prioritize Player Config.",
  T_42_XXJ_WS_PARAMSARRAY: "Parameters Array",
  T_42_XXJ_WS_PARAMSARRAY_D: "Parameters Array is a list of parameters involved in output. It needs to match the number of %v in the format description.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "The list of actual parameters passed to the custom functions.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Part visibility mask 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Part visibility mask 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Part visibility mask 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Part visibility mask 4",
  T_42_XXJ_WS_PASSENGER1: "Passenger seat 1",
  T_42_XXJ_WS_PASSENGER2: "Passenger seat 2",
  T_42_XXJ_WS_PASSENGER3: "Passenger seat 3",
  T_42_XXJ_WS_PHYMAT: "Physical Material",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entity",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Self-relative motion in each frame",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Self-relative motion every frame",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Self-relative motion",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "The self-relative motion",
  T_42_XXJ_WS_PLAYER_D: "The player that needs to enter the vehicle",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Entity of player behavior property sync",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "The entity of the player behavior property sync",
  T_42_XXJ_WS_PRIORITY_D: "Priority",
  T_42_XXJ_WS_PROPID_D: "The property ID",
  T_42_XXJ_WS_QUATERNION: "Quaternion",
  T_42_XXJ_WS_QUATERNION_D: "Quaternion is a special four-dimensional vector used only to represent a rotation",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Convert the given Quaternions to axis-angle representation",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Convert the given Quaternions to Euler angles. If the Quaternions do not meet the standard, return (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "The number of times played. Default is 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Reset",
  T_42_XXJ_WS_RIGHTVALUE: "Right Value",
  T_42_XXJ_WS_RIGHTVALUE_D: "Power",
  T_42_XXJ_WS_SEATTYPE: "Vehicle seat enum",
  T_42_XXJ_WS_SEPSTR_D: "String used for separation",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Set player fall DMG",
  T_42_XXJ_WS_SETTINGSBTNHUD: "The settings button on the HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Show Location",
  T_42_XXJ_WS_SHOWPOSITION_D: "Show Location",
  T_42_XXJ_WS_SIGNALICOHUD: "The network connection button on the HUD",
  T_42_XXJ_WS_SIMPLE: "Easy",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Spherical quaternion interpolation from A to B",
  T_42_XXJ_WS_SOUNDENTITY_D: "The sound effect entity represents a sound effect that is being played",
  T_42_XXJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Use a certain string as a delimiter to split the string into a slice",
  T_42_XXJ_WS_SPORTSCAR: "Sports Car",
  T_42_XXJ_WS_SPRINTSTATUS: "Sprint status",
  T_42_XXJ_WS_SRCVAL_D: "The source value",
  T_42_XXJ_WS_STARTTICKCOUNT: "The moment when the GS starts to tick",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "The moment when GS starts to tick",
  T_42_XXJ_WS_STARTTIME_D: "Time of start",
  T_42_XXJ_WS_STARTTIME_D1: "Time of start",
  T_42_XXJ_WS_STATE_D: "A player's status: active, knocked down, or eliminated",
  T_42_XXJ_WS_STATE_D1: "Check whether this sound effect is playing",
  T_42_XXJ_WS_STATIC_FRICTION: "Static Friction",
  T_42_XXJ_WS_STRELEMS_D: "Target string set",
  T_42_XXJ_WS_STRINGFINDAT_D: "Return the final combined string according to the index list",
  T_42_XXJ_WS_STRINGJOIN_D: "Join strings using a specified identifier",
  T_42_XXJ_WS_STRINGLOWER_D: "Convert all characters in the string to lowercase",
  T_42_XXJ_WS_STRINGSTRIP_D: "Remove whitespace characters from both sides of the string",
  T_42_XXJ_WS_STRINGUPPER_D: "Convert all characters in the string to uppercase",
  T_42_XXJ_WS_STYLE_D: "How it is played",
  T_42_XXJ_WS_SUV: "Pickup Truck",
  T_42_XXJ_WS_SWITCH: "Switch",
  T_42_XXJ_WS_SWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it must be combined with absolute motion, otherwise the properties won't take effect correctly.",
  T_42_XXJ_WS_TARGETENTITY_D: "The target entity",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Team Round Score Banner",
  T_42_XXJ_WS_TEAMSEQ_D: "The team serial number that corresponds to the serial number property of the team entity",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Temporary shield points",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Temporary shield points",
  T_42_XXJ_WS_TEXT_D: "The original text to perform a profanity filter on",
  T_42_XXJ_WS_THREESTATESWITCH: "3-Status Switch",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Dagger (ground loot)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Dagger",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Teams Match Details",
  T_42_XXJ_WS_UNIQUEID: "Unique ID",
  T_42_XXJ_WS_UNIQUEID_D: "Unique ID",
  T_42_XXJ_WS_VALUE_D: "The value",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Direction vector to Euler angles",
  T_42_XXJ_WS_VEHICLEID: "Vehicle ID",
  T_42_XXJ_WS_VEHICLESKINID: "Vehicle skin ID",
  T_42_XXJ_WS_VERYHARD: "Very Hard",
  T_42_XXJ_WS_VOLUME_D: "The sound volume. Default is 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Weapon's Main Type",
  T_42_XXJ_WS_WORKSHOPCODE: "Map code",
  T_42_XXJ_WS_WORKSHOPCODE_D: "The map code that corresponds to a data in the database",
  T_42_XXJ_WS_WORLDPOSITION: "World coordinates",
  T_42_XXJ_WS_WORLDPOSITION_D: "World coordinates",
  T_42_XYL_WS_ITEM275: "Fuel Tank",
  T_42_XYL_WS_ITEM276: "Sand Bag A",
  T_42_XYL_WS_ITEM277: "Sand Bag B",
  T_42_XYL_WS_ITEM278: "Sand Bag C",
  T_42_XYL_WS_ITEM279: "Sand Bag",
  T_42_XYL_WS_ITEM280: "Double Deck Villa",
  T_42_XYL_WS_ITEM281: "Arms Factory",
  T_42_XYL_WS_ITEM282: "Stone Wall A",
  T_42_XYL_WS_ITEM283: "Stone Wall B",
  T_42_XYL_WS_ITEM284: "Stone Wall C",
  T_42_XYL_WS_ITEM285: "Stone Wall D",
  T_42_XYL_WS_ITEM286: "Military Supply Box A",
  T_42_XYL_WS_ITEM287: "Copper Coin",
  T_42_XYL_WS_ITEM288: "Silver Coin",
  T_42_XYL_WS_ITEM289: "Gold Coin",
  T_42_XYL_WS_ITEM290: "Diamond",
  T_42_XYL_WS_ITEM291: "Diamond Shards",
  T_42_XYL_WS_ITEM292: "Ruby",
  T_42_XYL_WS_ITEM293: "Emerald",
  T_42_XYL_WS_ITEM294: "Sapphire",
  T_42_XYL_WS_ITEM295: "Warning Sign",
  T_42_XYL_WS_ITEM297: "Ruin",
  T_42_XYL_WS_ITEM297TRUE: "Control Device",
  T_42_XYL_WS_ITEM298: "Supply Container B",
  T_42_XYL_WS_ITEM299: "Snow Pile",
  T_42_XYL_WS_ITEM300: "High-Tech Wall A",
  T_42_XYL_WS_ITEM301: "High-Tech Wall B",
  T_42_XYL_WS_ITEM302: "Frozen Stone F",
  T_42_XYL_WS_ITEM303: "Frozen Stone E",
  T_42_XYL_WS_ITEM304: "High-Tech Platform A",
  T_42_XYL_WS_ITEM305: "High-Tech Staircase A",
  T_42_XYL_WS_ITEM306: "Exploration Lamp A",
  T_42_XYL_WS_ITEM307: "Ruin Baffle A",
  T_42_XYL_WS_ITEM308: "Ruin Baffle B",
  T_42_XYL_WS_ITEM309: "Ruin Steel Bracket A",
  T_42_XYL_WS_ITEM310: "Ruin Stone A",
  T_42_XYL_WS_ITEM311: "Ruin Stone B",
  T_42_XYL_WS_ITEM312: "Ruin Stone C",
  T_42_XYL_WS_ITEM313: "Flashlight A",
  T_42_XYL_WS_ITEM314: "Ruin Rebar A",
  T_42_XYL_WS_LOGICALOBJECT: "Logic",
  T_42_XYL_WS_THEMEHIGHTECH: "Futuristic",
  T_42_XYL_WS_THEMEICE: "Icy",
  T_42_XYL_WS_THEMEMILITARY: "Military",
  T_42_XYL_WS_THEMEOBJECTS: "Themed Object",
  T_42_XYL_WS_TIMERCONTINUE: "Timer Resuming Incident",
  T_42_XYL_WS_TIMERCYCLE: "Loop Count",
  T_42_XYL_WS_TIMERDOWN: "Countdown",
  T_42_XYL_WS_TIMEREND: "Timer ending incident",
  T_42_XYL_WS_TIMEREVENT: "Customized Timer Incident",
  T_42_XYL_WS_TIMEREVENT1: "Control Timer",
  T_42_XYL_WS_TIMEREVENT2: "Set Timer Incidents",
  T_42_XYL_WS_TIMERORDER: "Timing Method",
  T_42_XYL_WS_TIMERPAUSE: "Timer Pausing Incident",
  T_42_XYL_WS_TIMERSTART1: "Timer Start Time",
  T_42_XYL_WS_TIMERSTART2: "Timer Starting Incident",
  T_42_XYL_WS_TIMERUP: "Count Up",
  T_42_XYL_WS_TRIGGERTIME_MS: "Trigger Time (in milliseconds)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "A skywing that can hold multiple players.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Individual Score",
  T_42_ZZ_GUILDWAR_SCORE: "Score",
  T_43_B_SKILL_DESC_MONKEYGOD: "Transforms into a bush for [FFB300]{1}s[-] . Cooldown: [FFB300]{0}s[-]. Attacking others or being attacked will return Wukong to his original state. CD resets when taking down an enemy.",
  T_43_B_SKILL_DESC_Nanoscientist: "After taking fatal damage, enter an invulnerable and immobile state for [FFB300]{0}s[-]. Then, gain a [FFB300]{1} HP shield[-] that lasts for [FFB300]{2}s[-]. The skill user will be eliminated when the shield disappears. Cooldown: [FFB300]{3}s[-].",
  T_43_B_SKILL_DESC_ORION: "Replaces EP with [FFB300]{0} Crimson Energy[-]. Consumes [FFB300]{1} Crimson Energy[-] to activate its protection, during which you cannot take damage or attack enemies and will absorb [FFB300]{4} HP[-] (ignoring enemy Shield Points) from foes within [FFB300]{3}m[-]. Lasts for [FFB300]{2}s[-], during which your movement speed will decrease by [FFB300]{6}%[-]. Cooldown: [FFB300]{5}s[-].",
  T_43_CJ_F_A_RACER: "Velocity Racer (Mask)",
  T_43_CJ_F_B_RACER: "Velocity Racer (Bottom)",
  T_43_CJ_F_H_RACER: "Velocity Racer (Head)",
  T_43_CJ_F_HA_RACER: "Velocity Racer (Facepaint)",
  T_43_CJ_F_S_RACER: "Velocity Racer (Shoes)",
  T_43_CJ_F_T_RACER: "Velocity Racer (Top)",
  T_43_CJ_M_A_RACER: "Turbo Racer (Mask)",
  T_43_CJ_M_B_MACHINERY: "Turquoise Tech (Bottom)",
  T_43_CJ_M_B_RACER: "Turbo Racer (Bottom)",
  T_43_CJ_M_H_MACHINERY: "Turquoise Tech (Head)",
  T_43_CJ_M_H_RACER: "Turbo Racer (Head)",
  T_43_CJ_M_HA_MACHINERY: "Turquoise Tech (Facepaint)",
  T_43_CJ_M_S_MACHINERY: "Turquoise Tech (Shoes)",
  T_43_CJ_M_S_RACER: "Turbo Racer (Shoes)",
  T_43_CJ_M_T_MACHINERY: "Turquoise Tech (Top)",
  T_43_CJ_M_T_RACER: "Turbo Racer (Top)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Mamba Gnaw",
  T_43_HJ_WS_OPTION8: "Other",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bamboo",
  T_43_HJ_WS_TEXTURE_BEACH: "Beach",
  T_43_HJ_WS_TEXTURE_BRICK1: "Brick Wall A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Brick Wall B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Brick Wall C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Concrete Floor",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Concrete",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Crystal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Grass A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Grass B",
  T_43_HJ_WS_TEXTURE_ICE: "Ice Block",
  T_43_HJ_WS_TEXTURE_IRON: "Metal Floor",
  T_43_HJ_WS_TEXTURE_IRON2: "Container",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Marble Floor",
  T_43_HJ_WS_TEXTURE_NONE: "Empty",
  T_43_HJ_WS_TEXTURE_STONE: "Stone",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Tablecloth A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Tablecloth B",
  T_43_HJ_WS_TEXTURE_WOOD: "Wood",
  T_43_HJ_WS_TEXTURE_WOODEN: "Wooden Floor A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Wooden Floor B",
  T_43_JH_WS_MAPTAG1: "Newbie-Friendly",
  T_43_JH_WS_MAPTAG10: "Boring new content",
  T_43_JH_WS_MAPTAG11: "Little sense of reward",
  T_43_JH_WS_MAPTAG12: "Reward imbalance",
  T_43_JH_WS_MAPTAG13: "Weak sense of progress",
  T_43_JH_WS_MAPTAG14: "Newbie-Unfriendly",
  T_43_JH_WS_MAPTAG15: "Confusing tutorial",
  T_43_JH_WS_MAPTAG16: "Lack of tutorials",
  T_43_JH_WS_MAPTAG17: "Players quit a lot",
  T_43_JH_WS_MAPTAG18: "Complicated controls",
  T_43_JH_WS_MAPTAG19: "Cluttered UI",
  T_43_JH_WS_MAPTAG2: "Preferred new content",
  T_43_JH_WS_MAPTAG20: "Poor map design",
  T_43_JH_WS_MAPTAG21: "Thrilling Shooter",
  T_43_JH_WS_MAPTAG22: "Fast-paced",
  T_43_JH_WS_MAPTAG23: "Open World",
  T_43_JH_WS_MAPTAG24: "Story-rich",
  T_43_JH_WS_MAPTAG25: "Progression",
  T_43_JH_WS_MAPTAG26: "Sports Simulation",
  T_43_JH_WS_MAPTAG27: "Co-op Mission",
  T_43_JH_WS_MAPTAG28: "Social",
  T_43_JH_WS_MAPTAG29: "Diverse Instances",
  T_43_JH_WS_MAPTAG3: "Active players",
  T_43_JH_WS_MAPTAG30: "Free Exploration",
  T_43_JH_WS_MAPTAG31: "Ranking Challenge",
  T_43_JH_WS_MAPTAG32: "Achievement",
  T_43_JH_WS_MAPTAG33: "Currency Redeem",
  T_43_JH_WS_MAPTAG4: "Well-Designed Map",
  T_43_JH_WS_MAPTAG40: "Numerous rewards",
  T_43_JH_WS_MAPTAG41: "Satisfying progression",
  T_43_JH_WS_MAPTAG42: "Popular Training Grounds",
  T_43_JH_WS_MAPTAG43: "Popular Solo Tower",
  T_43_JH_WS_MAPTAG44: "Popular War Zone",
  T_43_JH_WS_MAPTAG5: "Stuttering",
  T_43_JH_WS_MAPTAG6: "Hard co-op",
  T_43_JH_WS_MAPTAG7: "Buggy",
  T_43_JH_WS_MAPTAG8: "Few updates",
  T_43_JH_WS_MAPTAG9: "Boring in-match events",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Spider Trap (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Drop Items",
  T_43_SJ_WS_AIRDROP_NAME: "Airdrop",
  T_43_SJ_WS_AIRDROP_TIME: "Start Drop Time",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Drop Items",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Is Auto-Play",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Is Center Position",
  T_43_SJ_WS_ANITRIGGER_CLIP: "Animation Clip ID",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Is Loop",
  T_43_SJ_WS_ANITRIGGER_NAME: "Animation Trigger HUD",
  T_43_SJ_WS_RESET_ROUND: "Reset per Round",
  T_43_SJ_WS_START_DROPTIME: "Start Drop Time (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Animation Trigger",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Pet Skin: Meow Meow Zasil",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Motorbike - Incarnational Speed",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Contains essential battle supplies such as ammo and medical items",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Supply Box",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Spawn a [FFB300]{1} HP[-] mannequin that autonomously travels for [FFB300]{0}s[-]. When the mannequin is within [FFB300]{3}m[-], use the skill again to switch positions with it. You can only switch once within [FFB300]{4}s[-], up to [FFB300]{2} time(s)[-] in total. The player who destroys the mannequin will be marked for [FFB300]{5}s[-]. Cooldown: [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Active Skill",
  T_43_XXJ_WS_AIRDROP: "Airdrop and Zombie",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "The overall transparency of the HUD, with a range from 0 to 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "Animation Controller ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "The ID used to describe an animation controller asset",
  T_43_XXJ_WS_AUDIOID: "Audio ID",
  T_43_XXJ_WS_AUDIOID_D: "The ID used to describe an audio asset",
  T_43_XXJ_WS_BACKGRCOLOR: "Background Color",
  T_43_XXJ_WS_BACKGRCOLOR_D: "The color of the health bar boarder and the blurred background",
  T_43_XXJ_WS_BURNING: "Burning",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "The ID used to describe a configuration table asset",
  T_43_XXJ_WS_CURRENTHP: "Current HP",
  T_43_XXJ_WS_CURRENTHP_D: "Current HP value",
  T_43_XXJ_WS_DAMAGEMAKER_D: "The game entity that deals damage",
  T_43_XXJ_WS_DAMAGEZONE: "Damage Zone",
  T_43_XXJ_WS_DEFAULT: "Default",
  T_43_XXJ_WS_DEFAULT_D: "Default",
  T_43_XXJ_WS_EFFECTID: "Effect ID",
  T_43_XXJ_WS_EFFECTID_D: "The ID used to describe a special effect asset",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "An entity that can fight (e.g. launch attacks, be attacked, or get eliminated)",
  T_43_XXJ_WS_FOLLOWTARGET: "Follow Target",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Must follow an entity with a Transform component",
  T_43_XXJ_WS_GAINHPCOLOR: "Gain HP Color",
  T_43_XXJ_WS_GAINHPCOLOR_D: "The increased portion of HP will show in this color for a short time",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Is No Fall Damage",
  T_43_XXJ_WS_ISOPENTWEEN: "Is Open Tween",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Enable this to show HP changes in different colors",
  T_43_XXJ_WS_KNOCKDOWN_D1: "The player is in the knockdown state",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Settings for the response to the knockdown state when eliminated",
  T_43_XXJ_WS_KNOCKDOWN_D3: "The revival source type. A player can be revived while  knocked down.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Knockdown State",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Knockdown State Type",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "The response to the knockdown state: maintain default logic, skip the knockdown state, or force into knockdown.",
  T_43_XXJ_WS_LEVEL: "Level",
  T_43_XXJ_WS_LEVEL_D: "Level",
  T_43_XXJ_WS_LEVEL_D1: "The current zombie level",
  T_43_XXJ_WS_LINESPACING: "Line Spacing",
  T_43_XXJ_WS_LINESPACING_D: "Does not display when the segmented HP between two dividers ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Lose HP Color",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "The reduced portion of HP will show in this color for a short time",
  T_43_XXJ_WS_MAINCOLOR: "Main Color",
  T_43_XXJ_WS_MAINCOLOR_D: "The color for HP, levels, and outlines",
  T_43_XXJ_WS_MINISENTRY: "Turret",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "The enum for the types of targets a turret can attack",
  T_43_XXJ_WS_MISSILEEXPLODE: "Missile Explode",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Must Knockdown",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Forced knockdown",
  T_43_XXJ_WS_OFFSET: "Offset",
  T_43_XXJ_WS_OFFSET_D: "Offset relative to the target followed",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Oil Drum Explode",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Only triggered when the controller initiates movement",
  T_43_XXJ_WS_PLAYER_D: "The in-game player entity. Each player has one.",
  T_43_XXJ_WS_PLAYERHEADHUD: "Player Head HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "The information displayed above the player's head",
  T_43_XXJ_WS_PLAYERNAME: "Player Name",
  T_43_XXJ_WS_PLAYERNAME_D: "Displays the name of the current health bar owner",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Player or Vehicle",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "The alias for the player/vehicle entity type",
  T_43_XXJ_WS_SCALE: "Scale",
  T_43_XXJ_WS_SCALE_D: "Determines the overall HUD scale size, with the font scaled to match.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Show Damage Number",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "True by default. Displays damage number.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Skip Knockdown",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Skip the knockdown state and get eliminated instantly",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Is Skip Stagger Animation",
  T_43_XXJ_WS_TEAM_D: "(Deprecated. Please use Team ID.)",
  T_43_XXJ_WS_TERRAIN: "Terrain",
  T_43_XXJ_WS_TERRAIN_D: "A terrain component of which attributes cannot be modified. Used to test functions only.",
  T_43_XXJ_WS_TOTALHP: "Total HP",
  T_43_XXJ_WS_TOTALHP_D: "Total HP value",
  T_43_XXJ_WS_TWEENENTITY: "Tween Entity",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Vehicle Explode",
  T_43_XXJ_WS_WIDTH: "Width",
  T_43_XXJ_WS_WIDTH_D: "The width of the displayed health bar",
  T_43_XXJ_WS_ZOMBIE: "Zombie",
  T_43_XYL_WS_DROIDFIST: "Fist (Droid Apocalypse)",
  T_43_XYL_WS_DROIDFLAME: "Flamethrower (Droid Apocalypse)",
  T_43_XYL_WS_JAPANESE: "Japanese-Style",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Customize match event logs. Used for user experience analysis.",
  T_43_YU_WS_AIRDROPSTATE: "Airdrop State",
  T_43_YU_WS_AIRDROPSTATE_D: "Airdrop state (1: ready, 2: dropping, 3: landed)",
  T_43_YU_WS_ANIMATIONCLIPID: "Animation Clip ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Customize animation clip ID",
  T_43_YU_WS_ASKBUYTARGET: "Ask Buy Target",
  T_43_YU_WS_ASKBUYTARGET_D: "Specifies the target and sends purchase request",
  T_43_YU_WS_ASKEDLIST: "Asked List",
  T_43_YU_WS_ASKEDLIST_D: "The list of requested items",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Background Color 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "The upper background color",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Background Color 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "The bottom background color",
  T_43_YU_WS_BATCHCOMBINERENDER: "Batch Combine Render",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Bind Money Entity List",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "The list of bound currency entities",
  T_43_YU_WS_BINDWALLETENTITYID: "Bind Wallet Entity ID",
  T_43_YU_WS_BINDWALLETENTITYID_D: "The ID of the bound wallet entity",
  T_43_YU_WS_CENTEROFFSET: "Center Offset",
  T_43_YU_WS_CENTEROFFSET_D: "The offset value for the capsule collider",
  T_43_YU_WS_COLLECTIONID: "Collection ID",
  T_43_YU_WS_COLLECTIONID_D: "The Collection ID used for asset information collection",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Create an airdrop",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Create a damage number",
  T_43_YU_WS_CROSSPLATFORM_D: "When selected, send to the client if called on the server and vice versa.",
  T_43_YU_WS_CSROUNDRESULTHUD: "CS Round Result HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Results displayed at the end of each round",
  T_43_YU_WS_CURRENTEMOTECLIP: "Current Emote Clip",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID of the current emote clip",
  T_43_YU_WS_DAMAGE_D: "The out-of-zone damage",
  T_43_YU_WS_DICTIONARY: "Dictionary",
  T_43_YU_WS_DIRECTIONRULERHUD: "Direction Ruler HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "The compass on the top",
  T_43_YU_WS_DOTWEEN_D: "Whether to perform tween animations",
  T_43_YU_WS_DROPITEMS_D: "Items in the airdrop",
  T_43_YU_WS_DURATION: "Duration",
  T_43_YU_WS_ENERGY: "Energy",
  T_43_YU_WS_ENERGY_D: "EP modification value",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Prone",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Crouch",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Sprinting",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Stand",
  T_43_YU_WS_EVENTID: "Event ID",
  T_43_YU_WS_EVENTID_D: "Represents an event",
  T_43_YU_WS_FACTION: "Faction",
  T_43_YU_WS_FACTION_D: "The faction entity",
  T_43_YU_WS_FACTION_D1: "Ask the faction for help with purchase",
  T_43_YU_WS_FINALRADIUS_D: "The final radius of the safe zone",
  T_43_YU_WS_FIRSTAIDKIT: "MedKit",
  T_43_YU_WS_FIRSTAIDKIT_D: "Med Kit",
  T_43_YU_WS_FIRSTPERSONMODEL: "First Person Model",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "The first-person camera",
  T_43_YU_WS_FONTCOLOR_D: "The font color",
  T_43_YU_WS_FONTSIZE_D: "The font size",
  T_43_YU_WS_FORBIDEN: "Forbidden",
  T_43_YU_WS_FORBIDEN_D: "Disable the HUD for purchase request",
  T_43_YU_WS_FREEZINGTIME: "Freezing Time",
  T_43_YU_WS_FREEZINGTIME_D: "The duration for which the hit target stays frozen",
  T_43_YU_WS_GRAVITY: "Gravity",
  T_43_YU_WS_GRAVITY_D: "The gravitational acceleration. Only affects the player controller.",
  T_43_YU_WS_HANDCATAPULT: "Launch Pad",
  T_43_YU_WS_HANDCATAPULT_D: "Launch Pad",
  T_43_YU_WS_HEALTH: "Health",
  T_43_YU_WS_HEALTH_D: "The recovery value of armor durability",
  T_43_YU_WS_HEIGHT: "Height",
  T_43_YU_WS_HELPEDPLAYER_D: "The player who is helped",
  T_43_YU_WS_HELPPLAYER_D: "The player who helps with the purchase",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Horizontal Max. Angle",
  T_43_YU_WS_HORIZONTALMINANGLE: "Horizontal Min Angle",
  T_43_YU_WS_HUDTOGGLE: "HUD Toggle",
  T_43_YU_WS_HUDTOGGLE_D: "The HudToggle entity that players can edit in the HUD editor",
  T_43_YU_WS_INHALER: "Inhaler",
  T_43_YU_WS_INHALER_D: "Inhaler",
  T_43_YU_WS_INITRADIUS_D: "The initial radius of the safe zone",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "A 64-bit signed integer",
  T_43_YU_WS_ISAPPLYSHADOW: "Is Apply Shadow",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Is Bottom Colliding",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Is Current Emote Loop",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Whether to set the current Emote animation to loop",
  T_43_YU_WS_ISSIDECOLLIDING: "Is Side Colliding",
  T_43_YU_WS_ISSLIDING: "Is Sliding",
  T_43_YU_WS_ISTOPCOLLIDING: "Is Top Colliding",
  T_43_YU_WS_ITEM331: "Futuristic Device A",
  T_43_YU_WS_ITEM332: "Glowing Rock A",
  T_43_YU_WS_ITEM333: "Futuristic Screen A",
  T_43_YU_WS_ITEM334: "Futuristic Container A",
  T_43_YU_WS_ITEM335: "Futuristic Container A",
  T_43_YU_WS_ITEM336: "Stone Sofa A",
  T_43_YU_WS_ITEM337: "Futuristic Switch A",
  T_43_YU_WS_ITEM338: "Futuristic Pipe A",
  T_43_YU_WS_ITEM339: "Metal Platform A",
  T_43_YU_WS_ITEM340: "Futuristic Table A",
  T_43_YU_WS_ITEM341: "Futuristic Table B",
  T_43_YU_WS_ITEM342: "Futuristic Table C",
  T_43_YU_WS_ITEM343: "Futuristic Computer A",
  T_43_YU_WS_ITEM344: "Stone A",
  T_43_YU_WS_ITEM345: "Stone B",
  T_43_YU_WS_ITEM346: "Stone C",
  T_43_YU_WS_ITEM347: "Stone D",
  T_43_YU_WS_ITEM348: "Stone E",
  T_43_YU_WS_ITEM349: "Stone F",
  T_43_YU_WS_ITEM350: "Stone G",
  T_43_YU_WS_ITEM351: "Japanese-Style Curtain A",
  T_43_YU_WS_ITEM352: "Japanese-Style Curtain B",
  T_43_YU_WS_ITEM353: "Japanese-Style Curtain C",
  T_43_YU_WS_ITEM354: "Japanese-Style Stairs A",
  T_43_YU_WS_ITEM355: "Japanese-Style Fence A",
  T_43_YU_WS_ITEM356: "Japanese-Style Fence B",
  T_43_YU_WS_ITEM357: "Japanese-Style Fence C",
  T_43_YU_WS_ITEM358: "Japanese-Style Platform A",
  T_43_YU_WS_ITEM359: "Japanese-Style Wall B",
  T_43_YU_WS_ITEM360: "Japanese-Style Gate B",
  T_43_YU_WS_ITEM361: "Futuristic Wall D",
  T_43_YU_WS_ITEM362: "Futuristic Wall B",
  T_43_YU_WS_ITEM363: "Futuristic Angled Baseboard",
  T_43_YU_WS_LEFTCOLOR: "Left Color",
  T_43_YU_WS_LEFTCOLOR_D: "The left side color",
  T_43_YU_WS_LEFTPLAYERARRAY: "Left Player Array",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "The left player array",
  T_43_YU_WS_LEFTSCORE: "Left Score",
  T_43_YU_WS_LEFTSCORE_D: "The left side score",
  T_43_YU_WS_LEFTSCOREAFTER: "Left Score After",
  T_43_YU_WS_LEFTSCOREAFTER_D: "The final score of the left side. Used in score transition animations.",
  T_43_YU_WS_LEVELOBJECTID: "Level Object ID",
  T_43_YU_WS_LEVELOBJECTID_D: "Describes the object type. Requires parsing through the SceneEditPrefab configuration table before loading.",
  T_43_YU_WS_LOCALPOSITION_D: "Coordinates in the local coordinate system",
  T_43_YU_WS_LOCALPOSITION_D1: "The relative position",
  T_43_YU_WS_LOCALPOSITION_D2: "The position relative to the bottom right anchor",
  T_43_YU_WS_LOCALPOSITION_D3: "The position relative to the anchor",
  T_43_YU_WS_LOCALROTATION_D: "Rotation angles in the local coordinate system (X: yaw, Y: pitch, and Z: roll)",
  T_43_YU_WS_LOCALROTATIONQ_D: "The quaternion in the local coordinate system",
  T_43_YU_WS_LOCALSCALE_D: "The scale size in the world coordinate system",
  T_43_YU_WS_MASS: "Mass",
  T_43_YU_WS_MATERIALS: "Materials",
  T_43_YU_WS_MATERIALS_D: "The list of materials used for rendering",
  T_43_YU_WS_MAXSPEED: "Max. Speed",
  T_43_YU_WS_MAXSPEED_D: "No more horsepower will be generated after the max speed is reached, but the vehicle speed may go over the limit (e.g. through acceleration when going down a hill).",
  T_43_YU_WS_MESHID: "Mesh ID",
  T_43_YU_WS_MESHID_D: "Describes the mesh type",
  T_43_YU_WS_MESHID1: "Mesh ID",
  T_43_YU_WS_MESHID1_D: "The mesh to be used for rendering",
  T_43_YU_WS_MINMOVEDISTANCE: "Min. Move Distance",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Movement with a distance shorter than this value will not be executed. It is recommended to set it to 0 unless there are special requirements.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "Airdrop",
  T_43_YU_WS_MODULE_ANIMATION: "Animation",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Base Attributes",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Behavior Tree",
  T_43_YU_WS_MODULE_BUFF: "Buff",
  T_43_YU_WS_MODULE_CAMERA: "Camera",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Chat Channel",
  T_43_YU_WS_MODULE_CHECKPOINT: "Checkpoint",
  T_43_YU_WS_MODULE_COLLECTION: "Collection",
  T_43_YU_WS_MODULE_COMBAT: "Combat",
  T_43_YU_WS_MODULE_COMPONENT: "Component",
  T_43_YU_WS_MODULE_CONVERT: "Convert",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Customize Room Parameters",
  T_43_YU_WS_MODULE_DATABASE: "Data Storage",
  T_43_YU_WS_MODULE_DYEING: "Dyeing",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Dynamic NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "Economy",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF Platform",
  T_43_YU_WS_MODULE_FOOTBALL: "Football",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Frame Rate Mode",
  T_43_YU_WS_MODULE_GAMERESULT: "Game Results",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Global Scripts",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Cheating",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Input System",
  T_43_YU_WS_MODULE_ITEMS: "Items",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Level Object",
  T_43_YU_WS_MODULE_LIST: "List",
  T_43_YU_WS_MODULE_MAP: "Map",
  T_43_YU_WS_MODULE_MATCHING: "Match",
  T_43_YU_WS_MODULE_MATH: "Math",
  T_43_YU_WS_MODULE_MECHANISM: "Mechanism Parameters",
  T_43_YU_WS_MODULE_MINIMAP: "Minimap",
  T_43_YU_WS_MODULE_MORPH: "Morph",
  T_43_YU_WS_MODULE_OTHER: "Other",
  T_43_YU_WS_MODULE_PET: "Pet",
  T_43_YU_WS_MODULE_PHYSICS: "Physics",
  T_43_YU_WS_MODULE_PLAYABLE: "Playable",
  T_43_YU_WS_MODULE_PLAYER: "Player",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Player Scripts",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Preset Character",
  T_43_YU_WS_MODULE_PROFILE: "Profile",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Property Formula",
  T_43_YU_WS_MODULE_SAFEZONE: "Safe Zone",
  T_43_YU_WS_MODULE_SCENE: "Scene",
  T_43_YU_WS_MODULE_SKILL: "Skill",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Static Scripts",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Report",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD Library",
  T_43_YU_WS_MODULE_STRINGS: "Strings",
  T_43_YU_WS_MODULE_TEAM: "Team",
  T_43_YU_WS_MODULE_WORKFLOW: "Workflow",
  T_43_YU_WS_MONEYICON: "Money Icon",
  T_43_YU_WS_MONEYICON_D: "The currency icon",
  T_43_YU_WS_MONEYICONCOLOR: "Money Icon Color",
  T_43_YU_WS_MONEYICONCOLOR_D: "The currency icon color",
  T_43_YU_WS_MOVESAFEZONE_D: "Smoothly moves the safe zone from its start position to the end position. Players outside the zone will take a certain amount of damage.",
  T_43_YU_WS_NEWVECTOR2: "New Vector2",
  T_43_YU_WS_NEWVECTOR2_D: "Gets a new 2D vector",
  T_43_YU_WS_OFFSET_D: "The world position offset relative to the target entity",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "When the player purchase request is met",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "When a player requests for help with purchase in the store",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Trigger when the Toggle component state changes",
  T_43_YU_WS_OPENSTATE: "Open State",
  T_43_YU_WS_OPENSTATE_D: "Displays when set to true and hides if not",
  T_43_YU_WS_PACEMAKER: "Horizaline",
  T_43_YU_WS_PACEMAKER_D: "Horizaline",
  T_43_YU_WS_PARAMS_D: "The list of parameters",
  T_43_YU_WS_PARENT_D: "The entity ID recorded during serialization",
  T_43_YU_WS_PHYSICALCCT: "Physical CCT",
  T_43_YU_WS_PHYSICALCCT_D: "The player controller with physical effects",
  T_43_YU_WS_PLAYER_D: "The purchasing player",
  T_43_YU_WS_PLAYERDATAID: "Player Data ID",
  T_43_YU_WS_PLAYERDATAID_D: "Customize character asset ID",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Player PhysX Pose Type",
  T_43_YU_WS_POSITION: "Position",
  T_43_YU_WS_POSITION_D: "Coordinates in the world coordinate system",
  T_43_YU_WS_POSITION_D1: "Coordinates in the world coordinate system. Only effective for 3D music.",
  T_43_YU_WS_PRESSEDSPRITE: "Pressed Sprite",
  T_43_YU_WS_PRESSEDSPRITE_D: "The pressed sprite",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Pressed Sprite Type",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "The pressed sprite type",
  T_43_YU_WS_PRETIME: "Pretime",
  T_43_YU_WS_RADIUS: "Radius",
  T_43_YU_WS_RANDOMRANGE_D: "Correct the set position based on a random range",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Request Purchase Type",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Purchase request in the store",
  T_43_YU_WS_REQUESTTYPE: "Request Type",
  T_43_YU_WS_REQUESTTYPE_D: "The type of the target requested by the current HUD player",
  T_43_YU_WS_RESPLAYERUUID: "Preset Player Type",
  T_43_YU_WS_RESPLAYERUUID_D: "The player asset ID",
  T_43_YU_WS_RESUUID: "Asset UUID",
  T_43_YU_WS_RESUUID_D: "Specifies the UUID of the Batch asset to be rendered",
  T_43_YU_WS_RIGHTCOLOR: "Right Color",
  T_43_YU_WS_RIGHTCOLOR_D: "The right side color",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Right Player Array",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "The right player array",
  T_43_YU_WS_RIGHTSCORE: "Right Score",
  T_43_YU_WS_RIGHTSCORE_D: "The right side score",
  T_43_YU_WS_RIGHTSCOREAFTER: "Right Score After",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "The final score of the right side. Used in score transition animations.",
  T_43_YU_WS_ROTATIONQ_D: "The quaternion in the world coordinate system",
  T_43_YU_WS_ROUNDINFOHUD: "Round Info HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "Information displayed at the start of a round",
  T_43_YU_WS_SELECTEDCOLOR: "Selected Color",
  T_43_YU_WS_SELECTEDCOLOR_D: "The selected sprite color",
  T_43_YU_WS_SELECTEDSPRITE: "Selected Sprite",
  T_43_YU_WS_SELECTEDSPRITE_D: "The selected sprite",
  T_43_YU_WS_SELECTEDTYPE: "Selected Type",
  T_43_YU_WS_SELECTEDTYPE_D: "The selected sprite type",
  T_43_YU_WS_SHADOWCOLOR: "Shadow Color",
  T_43_YU_WS_SHADOWOFFSET: "Shadow Offset",
  T_43_YU_WS_SHOWTAG: "Show Tag",
  T_43_YU_WS_SHOWTAG_D: "Show team/faction markings",
  T_43_YU_WS_SHRINKDURATION_D: "The shrinking duration of the safe zone",
  T_43_YU_WS_SIMPLERENDER_D: "The bridging rendering component used for rendering with built-in models",
  T_43_YU_WS_SKINWIDTH: "Skin Width",
  T_43_YU_WS_SKINWIDTH_D: "The depth of penetration into the capsule to prevent the character from getting stuck or jittering",
  T_43_YU_WS_SLOPELIMIT: "Slope Limit",
  T_43_YU_WS_SLOPELIMIT_D: "Objects placed on the slope exceeding this angle will slide down",
  T_43_YU_WS_SPEED: "Speed",
  T_43_YU_WS_STARTDROPTIME_D: "The airdrop arrival time in milliseconds",
  T_43_YU_WS_STARTPOS_D: "The start position of the safe zone",
  T_43_YU_WS_STATICICONCOLORS: "Static Icon Colors",
  T_43_YU_WS_STATICICONCOLORS_D: "Icon colors shown on the ruler",
  T_43_YU_WS_STATICICONS: "Static Icons",
  T_43_YU_WS_STATICICONS_D: "The icons shown on rulers",
  T_43_YU_WS_STEPOFFSET: "Step Offset",
  T_43_YU_WS_STEPOFFSET_D: "Only obstacles exceeding this height will have a blocking effect",
  T_43_YU_WS_SUBTITLE: "SubTitle",
  T_43_YU_WS_SUBTITLE_D: "The subtitle",
  T_43_YU_WS_TARGET: "Target",
  T_43_YU_WS_TARGET_D: "The target entity for the displayed damage number",
  T_43_YU_WS_TARGETICONCOLORS: "Target Icon Colors",
  T_43_YU_WS_TARGETICONCOLORS_D: "Colors of the icon shown by the marked target",
  T_43_YU_WS_TARGETICONS: "Target Icons",
  T_43_YU_WS_TARGETICONS_D: "The icons shown by the marked targets",
  T_43_YU_WS_TARGETPOS_D: "The target end position of the safe zone",
  T_43_YU_WS_TEAM: "Team",
  T_43_YU_WS_TEAM_D: "The team entity in the game. Each team has one entity.",
  T_43_YU_WS_TEAM_D1: "Ask the team for help with purchase",
  T_43_YU_WS_TIMEOFSTAY_D: "The display duration in milliseconds",
  T_43_YU_WS_TITLE: "Title",
  T_43_YU_WS_TITLE_D: "The main title",
  T_43_YU_WS_TRANSFORM_D: "Rotation, scaling, and parent-child record",
  T_43_YU_WS_UNSELECTEDCOLOR: "Unselected Color",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "The unselected sprite color",
  T_43_YU_WS_UNSELECTEDSPRITE: "Unselected Sprite",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "The unselected sprite",
  T_43_YU_WS_UNSELECTEDTYPE: "Unselected Type",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Unselected sprite type",
  T_43_YU_WS_USEPHYSICALCCT: "Use Physical CCT",
  T_43_YU_WS_VALUE_D: "The displayed content",
  T_43_YU_WS_VECTOR2ADD: "Vector2 Add",
  T_43_YU_WS_VECTOR2GETX: "Vector2 Get X",
  T_43_YU_WS_VECTOR2GETY: "Vector2 Get Y",
  T_43_YU_WS_VECTOR2SCALE: "Vector2 Scale",
  T_43_YU_WS_VECTOR2SETX: "Vector2 Set X",
  T_43_YU_WS_VECTOR2SETY: "Vector2 Set Y",
  T_43_YU_WS_VECTOR2SUB: "Vector2 Sub",
  T_43_YU_WS_VELOCITY: "Velocity",
  T_43_YU_WS_VERTICALMAXANGLE: "Vertical Max Angle",
  T_43_YU_WS_VERTICALMINANGLE: "Vertical Min. Angle",
  T_43_YU_WS_VISIBILITY_D: "Indicates whether visibility can be set",
  T_43_YU_WS_VISIBLE_D: "The visibility setting. If set to invisible, the client stops rendering the target.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Futuristic Wall A",
  T_43_ZY_WS_ITEM320: "Futuristic Wall C",
  T_43_ZY_WS_ITEM321: "Futuristic Window",
  T_43_ZY_WS_ITEM322: "Futuristic Door",
  T_43_ZY_WS_ITEM323: "Futuristic Angled Roof",
  T_43_ZY_WS_ITEM324: "Futuristic Circular Roof",
  T_43_ZY_WS_ITEM325: "Futuristic Baseboard",
  T_43_ZY_WS_ITEM326: "Futuristic Circular Baseboard",
  T_43_ZY_WS_ITEM327: "Futuristic Stairs",
  T_43_ZY_WS_ITEM328: "Futuristic Decoration A",
  T_43_ZY_WS_ITEM329: "Futuristic Building A",
  T_43_ZY_WS_ITEM330: "Futuristic Building B",
  T_44_CJ_M_B_SPORT_TH: "Gym Uniform (Bottom)",
  T_44_CJ_M_H_SPORT_TH: "Gym Uniform (Head)",
  T_44_CJ_M_S_SPORT_TH: "Gym Uniform (Shoes)",
  T_44_CJ_M_T_SPORT_TH: "Gym Uniform (Top)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Attack-o'-the-Wisp",
  T_44_H_USP45_CARNIVORE_N: "USP - Poison Tooth",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Motorbike - Thunderstrokes",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Force Start with Min. Players",
  T_44_JH_WS_HALFWAYKEY1: "Prioritize Start with Full Team",
  T_44_PD_PVE_DRAGON_NAME: "Mechadrake",
  T_44_QL_GRENADE_DRAGON: "Dragon Freeze",
  T_44_QL_GRENADE_DRAGON_DES: "An upgraded Flash Freeze that will detonate three times consecutively upon impact",
  T_44_QL_JUMPSHOESX: "Dragon Sprinters",
  T_44_QL_JUMPSHOESX_DES: "A pair of special jumping shoes that allow for sprinting in the air during a double jump",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Safe Zone Close Time",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Time when the Safe Zone disappears. If the Safe Zone Close Time is less than Safe Zone Start Time, no Safe Zone will be generated.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Safe Zone Color",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Damage Interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Damage interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Damage Value",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "The damage dealt to a player out-of-zone in a single instance",
  T_44_SJ_WS_SAFEZONE_DESC: "A placeable out-of-zone object",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Out-of-Zone End Radius",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "End radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Safe Zone Player List",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Get the list of players in the Safe Zone",
  T_44_SJ_WS_SAFEZONE_NAME: "The out-of-zone area",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Shrink Duration (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Length of time the zone shrinking takes",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Out-of-Zone Initial Radius",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Initial radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Start Shrink Time",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Time when the zone shrinking starts",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Safe Zone Start Time",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Time when the safe zone appears each round in-match. Default is 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Activated Alpha",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Activated alpha",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Active Skill Button HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Add a component to an entity. Only supports custom components. (A component will not be added again if it already exists.)",
  T_44_XXJ_WS_ALLMEMBERS: "All Members",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Allow Pressed Outside",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Allow triggering outside the designated area",
  T_44_XXJ_WS_ARROWIMAGE: "Arrow Image",
  T_44_XXJ_WS_ARROWIMAGE_D: "Arrow image",
  T_44_XXJ_WS_ARROWOFFSET: "Arrow Offset",
  T_44_XXJ_WS_ARROWOFFSET_D: "Arrow offset",
  T_44_XXJ_WS_ARROWSIZE: "Arrow Size",
  T_44_XXJ_WS_ARROWSIZE_D: "Arrow size",
  T_44_XXJ_WS_AUTOPLAY_D: "Automatically play upon creation",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Background Image",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Base image",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Background Radius",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Base radius",
  T_44_XXJ_WS_BAGSKINID: "Backpack Skin ID",
  T_44_XXJ_WS_BAGSKINID_D: "The backpack skin ID",
  T_44_XXJ_WS_BONEPOSITION: "Bone Position",
  T_44_XXJ_WS_BONEPOSITION_D: "World coordinates of the bone node",
  T_44_XXJ_WS_CCTMOVE: "Move CCT",
  T_44_XXJ_WS_COLLIDER: "Collider",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Collider Collection",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "The component used to describe the collision shape",
  T_44_XXJ_WS_COLOR: "Color",
  T_44_XXJ_WS_CONTENT: "Content",
  T_44_XXJ_WS_CONTENT_D: "Wallet content is a collection of currencies",
  T_44_XXJ_WS_CONTEXT_D: "Content to be printed",
  T_44_XXJ_WS_CROSSHAIRSHUD: "Crosshairs HUD",
  T_44_XXJ_WS_CURVE_D: "Curve",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Color of the surface texture",
  T_44_XXJ_WS_ENABLE: "Enable",
  T_44_XXJ_WS_ENTITY_D: "Entity",
  T_44_XXJ_WS_GETBAGSKINID_D: "Get player backpack skin configuration",
  T_44_XXJ_WS_GETFACTION_D: "Get faction",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Get the loaded scenes that have not been uninstalled",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Get the local player",
  T_44_XXJ_WS_GROUPID: "Group ID",
  T_44_XXJ_WS_GROUPID_D: "For internal logic",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD Joystick Widget",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Joystick entity. Players can edit the HUD via the HUD Editor.",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD Touchpad Widget",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "The HUD Touchpad widget that players can edit in the HUD editor",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "Custom HUD or HUD Widget",
  T_44_XXJ_WS_ICON: "Icon",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Always Show Mark",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Always show marks on the compass",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Unactivated Alpha",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Unactivated alpha",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "When calling, the number of actual parameters does not match that of formal parameters. The expected number is {0}, while the actual is {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Is Dynamic Obstacle",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Is a dynamic obstacle for NavMesh",
  T_44_XXJ_WS_ISEND: "Is End",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Is Server-Driven",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "If false, then custom objects cannot be controlled by the APIs.",
  T_44_XXJ_WS_ISSUC_D: "Return execution result",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Joystick Drag Radius",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Joystick drag radius",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Joystick Image",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Joystick image",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Joystick Radius",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Joystick radius",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Character Skill ID List",
  T_44_XXJ_WS_LOOPTYPE_D: "Loop type",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Quit Midway Config",
  T_44_XXJ_WS_MOUNTABLE: "Hierarchical",
  T_44_XXJ_WS_MOUNTABLE_D: "Entity capable of mounting child nodes",
  T_44_XXJ_WS_MOVEMENT: "Movement",
  T_44_XXJ_WS_NAME_D: "Name",
  T_44_XXJ_WS_NATURALCONST: "Natural Constant",
  T_44_XXJ_WS_NATURALCONST_D: "Enum of natural constants to reduce redundant definitions",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Play icon animation",
  T_44_XXJ_WS_OFFSET_D: "Default base offset",
  T_44_XXJ_WS_ONFIRE_D: "Triggers the event each time the player shoots, attacks with fists, or attacks with melee weapons.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Trigger the event when the player stands up from prone/crouching",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Trigger the event when the player taps the fire button",
  T_44_XXJ_WS_OPTION: "Options",
  T_44_XXJ_WS_PASSIVESKILLHUD: "Passive Skill HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "Physical Mover",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Players on this platform will automatically follow movement and rotation",
  T_44_XXJ_WS_PHYSICALOBJECT: "Physical Object",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Can apply force to it",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "The mathematical constant π (Pi) ",
  T_44_XXJ_WS_PLAYERS: "Player List",
  T_44_XXJ_WS_PLAYERS_D: "Player list",
  T_44_XXJ_WS_PLAYERSKILLID: "Character Skill ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "The character skill ID in AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "The previous pose before the player stands up",
  T_44_XXJ_WS_PRINT: "Print",
  T_44_XXJ_WS_PRINTERROR: "Print Error",
  T_44_XXJ_WS_PRINTERROR_D: "Print target data as an error to the console",
  T_44_XXJ_WS_PRINTWARNING: "Print Warning",
  T_44_XXJ_WS_PRINTWARNING_D: "Print target data as a warning to the console",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Prioritize Player Skin Config",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Prioritize the out-of-match player skin configuration",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Read the content in cells of a  row by the column number and key",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Clear player backpack skin configuration",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Remove a component from an entity. Only supports custom components.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Reset player backpack skin configuration to its out-of-match configuration",
  T_44_XXJ_WS_SETBAGSKINID_D: "Set player backpack skin configuration",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entity supporting the Transform, SkeletonPart, Player, and MountPoint components",
  T_44_XXJ_WS_SHOWBACKGROUND: "Show Background",
  T_44_XXJ_WS_SKINID_D: "Backpack skin ID and skin configuration",
  T_44_XXJ_WS_SPEED_D: "Playback speed",
  T_44_XXJ_WS_TARGET: "Target",
  T_44_XXJ_WS_TARGET_D: "Target object",
  T_44_XXJ_WS_TITLE: "Title",
  T_44_XXJ_WS_TYPEID_D: "Component type ID. Only supports custom components.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Upload custom match results",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Type mismatch. Unable to read the table content.",
  T_44_XXJ_WS_X_D: "X-axis coordinate",
  T_44_XXJ_WS_Y_D: "Y-axis coordinate",
  T_44_XYL_WS_CTZSAFEZONE: "Custom Safe Zone",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Generates the start and end point of a Safe Zone based on the set positions and properties",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Hemispherical Shell",
  T_44_XYL_WS_QUARTERCYLINDER: "Quarter Cylinder",
  T_44_XYL_WS_SQUAREPYRAMID: "Square Pyramid",
  T_44_XYL_WS_TORUS: "Torus",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Triangular Pyramid",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Add Game Event Log Map",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Add User Event Log",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "The custom match event log used for UX data analysis",
  T_44_YU_WS_ITEM366: "Military Wall A",
  T_44_YU_WS_ITEM367: "Military Wall B",
  T_44_YU_WS_ITEM368: "Military Wall C",
  T_44_YU_WS_ITEM369: "Military Wall D",
  T_44_YU_WS_ITEM370: "Military Window A",
  T_44_YU_WS_ITEM371: "Military Window B",
  T_44_YU_WS_ITEM372: "Military Window C",
  T_44_YU_WS_ITEM373: "Military Door A",
  T_44_YU_WS_ITEM374: "Military Door B",
  T_44_YU_WS_ITEM375: "Military Angled Roof A",
  T_44_YU_WS_ITEM376: "Military Angled Roof B",
  T_44_YU_WS_ITEM377: "Military Stairs A",
  T_44_YU_WS_ITEM378: "Military Stairs B",
  T_44_YU_WS_ITEM379: "Military Pillar A",
  T_44_YU_WS_ITEM380: "Military Handrail A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Customize",
  T_45_CJ_TREATMENTGUN_Y_N: "Heal Pistol-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Champion's Walk",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Inspect",
  T_45_HL_Moderation_fail_1: "Unfortunately, your submitted project did not pass the review.",
  T_45_HL_Moderation_fail_2: "involves",
  T_45_HL_Moderation_fail_3: "Reasons included:",
  T_45_HL_Moderation_fail_Location_1: "Game Content",
  T_45_HL_Moderation_fail_reason_1: "Toxic Content",
  T_45_HL_Moderation_fail_reason_10: "Community Guideline Violation",
  T_45_HL_Moderation_fail_reason_11: "Negative Impacts on In-Game Economies and Virtual Property Infringement",
  T_45_HL_Moderation_fail_reason_2: "Inappropriate Content",
  T_45_HL_Moderation_fail_reason_3: "Politically Sensitivity",
  T_45_HL_Moderation_fail_reason_4: "False Information",
  T_45_HL_Moderation_fail_reason_5: "Copyright Infringement",
  T_45_HL_Moderation_fail_reason_6: "Privacy Violation",
  T_45_HL_Moderation_fail_reason_7: "Security Concerns",
  T_45_HL_Moderation_fail_reason_8: "Hate Speech",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Other Issues",
  T_45_JH_WS_CLEMPTYOBJECT: "Object Group",
  T_45_JH_WS_PETSWITCH1: "Whether to show pets in the match",
  T_45_QL_CSFPP_DES: "Eliminate all opponents through the first-person perspective in this special CS mode!",
  T_45_QL_CSFPP_NAME: "Clash Squad: FPP",
  T_45_QL_CSFPP_RANKNAME: "First-Person",
  T_45_SJ_WS_REVIEW_23: "Game Content",
  T_45_SJ_WS_REVIEW_24: "{0} involves {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} involves {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Tap to view details >>[-]",
  T_45_SJ_WS_REVIEW_27: "Not Approved",
  T_45_SJ_WS_REVIEW_28: "Review Feedback",
  T_45_SJ_WS_REVIEW_29: "The content involves {0} violation(s)",
  T_45_SJ_WS_REVIEW_31: "Not Approved",
  T_45_SJ_WS_REVIEW_32: "The review failed due to server exceptions",
  T_45_SJ_WS_REVIEW_TITLE: "Details of Violation",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Triggers vaulting (jumping over obstacles)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Vault Distance",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Modifies the distance of vaulting",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Vault Height",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Controls the height of moving up and down when vaulting",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Vault Trigger",
  T_45_TYC_CL_TEMPLATE_WS: `An elimination mode where players take out all opposing teams in a chaotic battle to win.
You can set the gameplay rules and edit the gameplay parameters as you like.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Skyblaster",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = auto attack, 1 = defensive attack, 2 = do not attack",
  T_45_XXJ_WS_ADDFRIEND: "Add Friend",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Auto",
  T_45_XXJ_WS_BASEDATA: "Base Data",
  T_45_XXJ_WS_BOTH: "Both",
  T_45_XXJ_WS_BYHIERARCHY: "By Hierarchy",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "By Priority High to Low",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "By Priority Low to High",
  T_45_XXJ_WS_CAMERA: "Camera",
  T_45_XXJ_WS_CAMERATYPE: "Camera Type",
  T_45_XXJ_WS_CENTERINVISIBLE: "Center Invisible",
  T_45_XXJ_WS_CLIENT: "Client",
  T_45_XXJ_WS_COLLIDERID: "Collider ID",
  T_45_XXJ_WS_COLLIDERID_D: "The collider ID",
  T_45_XXJ_WS_COMPONENT: "Component",
  T_45_XXJ_WS_CURRENTCAMERA: "Current Camera",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Custom Push Force",
  T_45_XXJ_WS_DOUBLE: "Double",
  T_45_XXJ_WS_DUMP: "Throw",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Enable Move in Midair",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Enable Rotate with Gravity",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Event",
  T_45_XXJ_WS_FILLAMOUNT: "Fill Amount",
  T_45_XXJ_WS_FILLDIR: "Fill Direction",
  T_45_XXJ_WS_FIRETYPE: "Fire Type",
  T_45_XXJ_WS_FIRETYPE_D: "The firing type",
  T_45_XXJ_WS_FIXEDDELTATIME: "Fixed Delta Time",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "The fixed time interval for frame updates in milliseconds",
  T_45_XXJ_WS_FORWARD: "Forward",
  T_45_XXJ_WS_FORWARD_D: "The direction of the z-axis in the local coordinate system",
  T_45_XXJ_WS_FUNCTIONTYPE: "Function Type",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "The function type",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "The aiming direction of the local player",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Get the local timestamp",
  T_45_XXJ_WS_GRADIENT: "Gradient",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradient Bottom",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradient Bottom Alpha",
  T_45_XXJ_WS_GRADIENTTOP: "Gradient Top",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradient Top Alpha",
  T_45_XXJ_WS_HITPOSITION_D: "The world position of the target hit by bullets",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "UI Social Button Widget",
  T_45_XXJ_WS_INVERTFILL: "Invert Fill",
  T_45_XXJ_WS_ISGROUNDED: "Is Grounded",
  T_45_XXJ_WS_ISSILENCE: "Is Silence",
  T_45_XXJ_WS_ISSILENCE_D: "If it is silenced or not",
  T_45_XXJ_WS_ISSINGLESHOT: "Is Single Shot",
  T_45_XXJ_WS_ISSINGLESHOT_D: "If it is single-shot or not",
  T_45_XXJ_WS_JUMPHEIGHT: "Jump Height",
  T_45_XXJ_WS_JUMPHEIGHT_D: "The jump height",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Layout Sort Type",
  T_45_XXJ_WS_LIGHT_D: "Lights",
  T_45_XXJ_WS_LOCAL: "Local",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Max. Jump Count",
  T_45_XXJ_WS_MODULE: "Module",
  T_45_XXJ_WS_NONE: "None",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Execute the command each time before the entity deals damage",
  T_45_XXJ_WS_ONDISABLE_D: "Execute when the entity is disabled",
  T_45_XXJ_WS_ONEACHLOOP_D: "Execute each time Playable is looped. Only effective on the client side for entities such as Sound Effect and Special Effect.",
  T_45_XXJ_WS_ONENABLE_D: "Execute when the entity is enabled",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "When entering a frame at a fixed rate of 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Trigger the client event when the player adds or deletes a friend",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Trigger the event when the game is paused due to the called API",
  T_45_XXJ_WS_ONGAMERESUME_D: "Trigger the event when the game resumes due to the called API",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "When the player stops sprinting",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "When the player stops surfing",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "When the player is surfing",
  T_45_XXJ_WS_PHYSICALLAYER_D: "The custom physical layer within a range of 0 to 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Platform Type",
  T_45_XXJ_WS_PLATFORMTYPE_D: "The platform type",
  T_45_XXJ_WS_PLAYER: "Player",
  T_45_XXJ_WS_PLAYERCCT: "Player CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "A character controller with physical effects and used for Free Fire characters only",
  T_45_XXJ_WS_PRIORITY: "Priority",
  T_45_XXJ_WS_REMAINMULTINUM: "Remain Jump Count",
  T_45_XXJ_WS_REPORT: "Report",
  T_45_XXJ_WS_RIGHT: "Right",
  T_45_XXJ_WS_RIGHT_D: "The direction of the x-axis in the local coordinate system",
  T_45_XXJ_WS_SERVER: "Server",
  T_45_XXJ_WS_SINGLE: "Single",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Social Button Style Type",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "The social button style",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Social Button Type",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "The social button type",
  T_45_XXJ_WS_SORTTYPE_D: "Sort types: non-zero ascending, descending, and ascending",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Move Speed While ADS",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "The movement speed while aiming down sight",
  T_45_XXJ_WS_STRINGORLOCSTRING: "String or Localized String",
  T_45_XXJ_WS_TRIPLE: "Triple",
  T_45_XXJ_WS_UP: "Up",
  T_45_XXJ_WS_UP_D: "The direction of the y-axis in the local coordinate system",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Use Custom Push Force",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Throw a signal flare towards the designated area to summon a random vehicle",
  T_45_ZD_VEHICLEDROP_R_NAME: "Mystery Vehicle",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Time Played",
  T_46_HJ_WS_SHAREBY: "By {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Game Mode",
  T_46_HJ_WS_SHARETEAM: "Team",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "Top of Class (Bottom)",
  T_46_HX_H_SCHOOL_VN: "Top of Class (Head)",
  T_46_HX_S_SCHOOL_VN: "Top of Class (Shoes)",
  T_46_HX_T_SCHOOL_VN: "Top of Class (Top)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutorial",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Others",
  T_46_XXJ_WS_ACTUALPOSITION: "Actual Position",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Add the object to monitor with AOI synchronization beyond line of sight",
  T_46_XXJ_WS_APPEARANCE: "Appearance",
  T_46_XXJ_WS_APPEARANCERES: "Appearance Resource",
  T_46_XXJ_WS_BECOME: "Activate",
  T_46_XXJ_WS_BRAKETORQUE_D: "The horsepower given to the vehicle when Brake/Reverse is used",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Camera Rotate Angle Restriction Type",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Clear all monitored objects of the target",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "The maximum crash damage used for damage calculation",
  T_46_XXJ_WS_CRASHMAXSPEED: "Crash Max. Speed",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Used for crash damage calculation. Once exceeding this speed, no more damage will be added.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Crash Mass Factor",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "A parameter used in the damage formula for crash damage calculation",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "The minimum crash damage used for damage calculation",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Read and write limit of data storage has been exceeded",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Parameter exception",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Data storage timeout. Mainly applies to read and write now.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Edit Appearance",
  T_46_XXJ_WS_ENDVALUE_D: "The destination value",
  T_46_XXJ_WS_ENGINETORQUE_D: "The horsepower given to the vehicle when the gas pedal is used",
  T_46_XXJ_WS_ERRORCODE_D: "The error code enum",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Euler Angle to Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Convert the Eular angle to a 3D vector",
  T_46_XXJ_WS_EXPIRE: "Expire",
  T_46_XXJ_WS_FEMALEAVATAR: "Female Character",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Get Membership Expire Date",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "If the observer is monitoring an object or not",
  T_46_XXJ_WS_HELICOPTER: "Skyblaster",
  T_46_XXJ_WS_HELICOPTER_D: "A type of flying vehicle",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "High-Speed Steer Restriction",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "The maximum steering angle while in a high-speed state",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "High-Speed Steer Angle at Speed",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "The speed threshold for the maximum high-speed steering angle",
  T_46_XXJ_WS_IDLE: "Idle Animation",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Idle Brake Input",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "When not driving a vehicle, decelerate it by (Idle Brake Input) x (Brake Torque).",
  T_46_XXJ_WS_INTTOFLOAT: "Int to Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Convert an integer to a floating-point number",
  T_46_XXJ_WS_ISPREMIUM: "Is Membership",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "The leaderboard name in the database",
  T_46_XXJ_WS_MALEAVATAR: "Male Character",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "AI Persona",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "New UMA Appearance",
  T_46_XXJ_WS_NONE_D: "No error",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "The NPC object",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Tips: Humanoid NPCs usually have a collision model with a capsule that is 1.4m tall and 0.25m in radius. Pet NPCs usually have a collision model with a capsule that is 1m tall and 0.4m in radius.",
  T_46_XXJ_WS_OBSERVER_D: "The observer that is monitoring objects",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "On Enter Craftland Membership",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "On Quit Craftland Membership",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Open Craftland Membership",
  T_46_XXJ_WS_PERSONA: "Persona",
  T_46_XXJ_WS_PERSONACENTER: "Persona Center",
  T_46_XXJ_WS_PET: "Pet",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Player or Transform",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "An alias for the Player and Transform entity",
  T_46_XXJ_WS_PREMIUM: "Membership",
  T_46_XXJ_WS_PREMIUMSTATUS: "Membership Status",
  T_46_XXJ_WS_PROXYOBSERVER: "Proxy Observer",
  T_46_XXJ_WS_PROXYOBSERVER_D: "The proxy observer",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Remove the monitored object and cancel the AOI synchronization beyond line of sight",
  T_46_XXJ_WS_RENEWAL: "Renew",
  T_46_XXJ_WS_ROTATEVECTOR: "Rotate Vector",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Rotate a vector based on quaternions",
  T_46_XXJ_WS_SKIN: "Gear",
  T_46_XXJ_WS_STARTVALUE_D: "The source value",
  T_46_XXJ_WS_STATUS: "Status",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Switch the proxy observer of the User",
  T_46_XXJ_WS_TARGET_D: "The target that is monitored",
  T_46_XXJ_WS_USER_D: "The user",
  T_46_XXJ_WS_VALUE: "Value",
  T_46_XXJ_WS_VALUE_D: "Vector",
  T_46_XYL_WS_CTZSAFEZONEEND: "Safe Zone End Point",
  T_46_XYL_WS_RESOURCETYPE1: "Basic Structures",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geometrics",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visual & Audio",
  T_46_XYL_WS_RESOURCETYPE2: "Scene Items",
  T_46_XYL_WS_RESOURCETYPE2_2: "Battle Supplies",
  T_46_XYL_WS_RESOURCETYPE3: "Nature",
  T_46_XYL_WS_RESOURCETYPE4: "Modular Component",
  T_46_XYL_WS_TYPEOTHERPROP: "Miscellaneous",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Containers & Boxes",
  T_47_CJ_FOREGRIP_SOFT_N: "Light Foregrip",
  T_47_CJ_MAGEZINE_FAST_N: "Fast Mag",
  T_47_CJ_STOCK_FAST_N: "Power Stock",
  T_47_GT_WS_USERMANUAL: "User Manual",
  T_47_HJ_WS_VFX_FOG: "Fog VFX",
  T_47_HJ_WS_VFX_LIGHTING: "Lighting VFX",
  T_47_HJ_WS_VFX_TRAILING: "Trailing VFX",
  T_47_HL_CL_CREATOR_LABEL1: "Community Talent",
  T_47_HL_CL_MAP_LABEL1: "Selected Works by Community Talents",
  T_47_JH_WS_MODERATION_REASON12: "Gambling-related",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "NARUTO SHIPPUDEN collaboration",
  T_47_SD_RES_MATERIAL: "Material file",
  T_47_SD_RES_MESH: "Mesh",
  T_47_SD_WS_MAPTAG_AI: "AI Map Generate",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a fiery explosion after a short delay to deal burn damage.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Fiery Kunai",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a Lightning strike after a short delay to paralyze the target.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Lightning Kunai",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a windstorm after a short delay to slow down the target moving towards its center.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Wind Kunai",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "A type of shuriken suitable for mid-to-long-range combat. One throw launches one piece quickly, dealing a great amount of damage.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Heavy Shuriken",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "A type of shuriken suitable for close-to-mid-range combat with two attack modes. One throw launches three pieces, dealing a small amount of damage.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Light Shuriken",
  T_47_XXJ_WS_ACTION: "Action",
  T_47_XXJ_WS_AOISETTING: "AOI Setting",
  T_47_XXJ_WS_BAGSKINTYPE: "Backpack Skin Type",
  T_47_XXJ_WS_CLEARMEMORY: "Clear Memory",
  T_47_XXJ_WS_CLNPC: "Advanced NPC",
  T_47_XXJ_WS_CLOTHTYPE: "Outfit Skin Type",
  T_47_XXJ_WS_COMMON_ERROR: "Common Error",
  T_47_XXJ_WS_CONTENT: "Content",
  T_47_XXJ_WS_CREATERANDOMSEED: "Create Random Seed",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Elapsed Percentage",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Enable Fog Feature",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Enable Light Rotation Feature",
  T_47_XXJ_WS_ERRORCODE: "Error Code",
  T_47_XXJ_WS_EXPONENTIAL: "Exponential",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponential Squared",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Failed to create room: no valid Persona IDs",
  T_47_XXJ_WS_FOG: "Fog",
  T_47_XXJ_WS_FOGDENSITY: "Fog Density",
  T_47_XXJ_WS_FOGENDDISTANCE: "Fog End Distance",
  T_47_XXJ_WS_FOGMODE: "Fog Mode",
  T_47_XXJ_WS_FOGMODETYPE: "Fog Mode Type",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Fog Start Distance",
  T_47_XXJ_WS_HEIGHTSCALE: "Height Scale",
  T_47_XXJ_WS_ISVISIBLE: "Is Visible",
  T_47_XXJ_WS_JOINNEWTEAM: "Join New Team",
  T_47_XXJ_WS_JOINTEAM: "Join Team",
  T_47_XXJ_WS_LIGHTROTATE: "Light Rotation",
  T_47_XXJ_WS_LINEAR: "Linear",
  T_47_XXJ_WS_LLMCHATHUD: "UI Persona Chat",
  T_47_XXJ_WS_NEWTEAM: "New Team",
  T_47_XXJ_WS_NEXT: "Next",
  T_47_XXJ_WS_NPC_TIP: "You can edit NPC's appearance and make NPC play animation",
  T_47_XXJ_WS_OBSERVERS: "Observers",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "On Player Send Message by UI Persona Chat",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "On Membership Status Changed",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "On Receive Action From Persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "On Receive Content From Persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "On Receive Finish From Persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "On Receive Status From Persona",
  T_47_XXJ_WS_PARTICLESID: "Particles ID",
  T_47_XXJ_WS_PERSONAAVATAR: "Persona Avatar",
  T_47_XXJ_WS_PERSONAID: "Persona ID",
  T_47_XXJ_WS_PERSONANICKNAME: "Persona Nickname",
  T_47_XXJ_WS_PLAYERORNPC: "Player or NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Membership Closed",
  T_47_XXJ_WS_RANDOM: "Random",
  T_47_XXJ_WS_SEED: "Seed",
  T_47_XXJ_WS_SENDER: "Sender",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Set Persona Observer",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Set Player Can Quit Midway",
  T_47_XXJ_WS_SHOULDREPLY: "Should Reply",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Show System Reply",
  T_47_XXJ_WS_SPOTANGLE: "Spot Angle",
  T_47_XXJ_WS_SPOTLIGHT: "Spotlight",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Send System Message To Persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Stream System Messages to Persona",
  T_47_XXJ_WS_TARGETTEAM: "Target Team",
  T_47_XXJ_WS_THISENTITY: "This Entity",
  T_47_XXJ_WS_USERAVATAR: "User Avatar",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Send User Message To Persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Stream User Messages to Persona",
  T_47_XXJ_WS_USERNICKNAME: "User Nickname",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Vehicle Skin Type",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Weapon Skin Type",
  T_47_XYL_NB_UGC_EFFECT001: "Rasengan VFX",
  T_47_XYL_NB_UGC_EFFECT002: "Chidori VFX",
  T_47_XYL_NB_UGC_EFFECT003: "Cherry Blossom Clash VFX",
  T_47_XYL_NB_UGC_EFFECT004: "Fireball Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT005: "Water Dragon Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT006: "Great Breach VFX",
  T_47_XYL_NB_UGC_EFFECT007: "Tailed Beast Bomb VFX",
  T_47_XYL_NB_UGC_EFFECT008: "Reanimation Curse Mark VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Asset Store",
  T_47_XYL_UGC_DONKEYCART: "Donkey Cart",
  T_47_XYL_UGC_SPOTLIGHT: "Spotlight",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Spotlight Angle",
  T_48_H_EMOTE_WATERFEST25_N: "Swift Steps",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Motorbike - Sea Foam",
  T_48_HJ_AC_STATENOTEXIST: "The state {0} does not exist in the animation controller",
  T_48_HL_CODESCRIPT: "Code Script",
  T_48_HL_GLOBAL_VAR: "Global Variable Name",
  T_48_HL_GRAPH: "Block",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Leaderboard",
  T_48_HL_LOCAL_VAR: "Local Variable Name",
  T_48_HL_LOCALIZATION: "Localization Name",
  T_48_HL_OPEN_ATTRIBUTES: "Open Attribute Name",
  T_48_HX_A_WATERFEST25: "Sea Foam (Mask)",
  T_48_HX_B_WATERFEST25: "Sea Foam (Bottom)",
  T_48_HX_F_B_BLACKDRESS: "Antimatter (Bottom)",
  T_48_HX_F_H_BLACKDRESS: "Antimatter (Head)",
  T_48_HX_F_HA_BLACKDRESS: "Antimatter (Facepaint)",
  T_48_HX_F_S_BLACKDRESS: "Antimatter (Shoes)",
  T_48_HX_F_T_BLACKDRESS: "Antimatter (Top)",
  T_48_HX_H_WATERFEST25: "Sea Foam (Head)",
  T_48_HX_HA_WATERFEST25: "Sea Foam (Facepaint)",
  T_48_HX_M_A_BLACKDRESS: "Dark Matter (Mask)",
  T_48_HX_M_B_BLACKDRESS: "Dark Matter (Bottom)",
  T_48_HX_M_H_BLACKDRESS: "Dark Matter (Head)",
  T_48_HX_M_HA_BLACKDRESS: "Dark Matter (Facepaint)",
  T_48_HX_M_S_BLACKDRESS: "Dark Matter (Shoes)",
  T_48_HX_M_T_BLACKDRESS: "Dark Matter (Top)",
  T_48_HX_S_WATERFEST25: "Sea Foam (Shoes)",
  T_48_HX_T_WATERFEST25: "Sea Foam (Top)",
  T_48_JH_WS_STRINGDESC: "Enter a paragraph of text or other strings. Some widgets can display rich text. Add color to text with rich text using the following format: [#XXXXXX] text text [-]. “#XXXXXX” is the color you wish to display. Please note that the text color of the related widget must be set to white.",
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Find Entity by ID",
  T_48_META_API_10001_P0: "Entity ID",
  T_48_META_API_1098: "Batch Read Database Sheet Value",
  T_48_META_API_1098_D: "Batch read multiple data entries from a specified database sheet, where the entries of the unique player ID list correspond one-to-one with those of the key list.",
  T_48_META_API_1098_P1: "Account IDs",
  T_48_META_API_1098_P1_D: "The list of unique player IDs, which reads the data corresponding to the keys at the same index in the key list.",
  T_48_META_API_1098_P2: "Keys",
  T_48_META_API_1098_P2_D: "The list of keys, which reads the data corresponding to the unique player IDs at the same index in the ID list.",
  T_48_META_API_1098_P5: "Status Codes",
  T_48_META_API_1098_P5_D: "The list of status codes",
  T_48_META_API_1105: "Notify Start Plot",
  T_48_META_API_1105_D: "Start playing the specified plot for the triggering player",
  T_48_META_API_1105_P1_D: "The plot ID",
  T_48_META_API_1108: "Get Local Language",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Set Body Part Weight",
  T_48_META_API_3300_D: "Set the weight of the target body part when blending it with other lower-priority animations",
  T_48_META_API_3300_P0_D: "The addable animation controller component that the body part belongs to",
  T_48_META_API_3300_P1: "Body Part Name",
  T_48_META_API_3300_P1_D: "The body part name",
  T_48_META_API_3300_P2: "Weight",
  T_48_META_API_3300_P2_D: "Weight with a value range of [0, 1], representing the degree of blending with lower-priority animations.",
  T_48_META_API_3315: "Play Character Animation Clip Override",
  T_48_META_API_3315_D: "Play a character animation clip with the option to override the game's default animation",
  T_48_META_API_3315_P3: "Override Gameplay Control",
  T_48_META_API_3315_P3_D: "Whether to override the default animation of the game",
  T_48_META_API_3316: "Stop Animation",
  T_48_META_API_3316_D: "Stop playing the animation for the target in the specified status",
  T_48_META_API_90_P1: "Can Quit Midway",
  T_48_META_API_93: "Create Along Path Motion",
  T_48_META_API_93_D: "Create an interpolated movement along a path to make the object move along the specified path",
  T_48_META_API_93_P1: "Path",
  T_48_META_API_93_P1_D: "The path of motion",
  T_48_META_API_93_P3_D: "The magnitude of velocity",
  T_48_META_API_93_P4: "Tangent Facing",
  T_48_META_API_93_P4_D: "Whether the object is facing the direction of movement. This property remains unchanged even if the object's orientation is forcibly modified by other means.",
  T_48_META_API_96: "Instantiate Prefab",
  T_48_META_API_96_D: "Create a prefab instance with the option to process it asynchronously",
  T_48_META_API_96_P2: "Async Load",
  T_48_META_API_96_P2_D: "Whether loading is asynchronous",
  T_48_META_EVT_3140: "On Change Team",
  T_48_META_EVT_3140_D: "Triggers when the team of the current entity changes",
  T_48_META_EVT_3140_P0: "Former Team",
  T_48_META_EVT_3140_P0_D: "The team one belonged to before the change",
  T_48_META_EVT_3140_P1: "Current Team",
  T_48_META_EVT_3140_P1_D: "The team one belongs to after the change",
  T_48_META_EVT_3141: "On Plot Start",
  T_48_META_EVT_3141_D: "Triggers when the plot starts to play",
  T_48_META_EVT_3141_P1: "Plot ID",
  T_48_META_EVT_3141_P1_D: "The plot ID",
  T_48_META_EVT_3142: "On Plot End",
  T_48_META_EVT_3142_D: "Triggers when the plot ends",
  T_48_META_EVT_3142_P0_D: "The triggering player",
  T_48_META_EVT_3142_P1_D: "The plot ID",
  T_48_META_EVT_3143: "On Trigger Plot Option",
  T_48_META_EVT_3143_D: "Triggers when an option is selected in the plot",
  T_48_META_EVT_3143_P1_D: "The plot ID",
  T_48_META_EVT_3143_P2: "Option ID",
  T_48_META_EVT_3143_P2_D: "The ID of the option selected",
  T_48_META_TYP_409_I10: "Change Team Failed_Invalid Team",
  T_48_META_TYP_409_I11: "Change Team Failed_Eliminated",
  T_48_META_TYP_409_I12: "Change Team Failed_In Vehicle",
  T_48_META_TYP_409_I7: "Change Team Failed_Not Supported",
  T_48_META_TYP_409_I8: "Change Team Failed_Already In Team",
  T_48_META_TYP_409_I9: "Change Team Failed_Invalid Target",
  T_48_META_TYP_41_I19: "Disable Collider",
  T_48_META_TYP_417: "Particles",
  T_48_META_TYP_428: "Player Transform or NPC Outfit",
  T_48_META_TYP_431: "Along Path Motion",
  T_48_META_TYP_431_I1: "Path",
  T_48_META_TYP_432: "Custom Curve Path Waypoint",
  T_48_META_TYP_432_I0: "Roll",
  T_48_META_TYP_432_I1: "Tangent",
  T_48_META_TYP_433: "Custom Curve Path Type",
  T_48_META_TYP_433_I0: "Linear",
  T_48_META_TYP_433_I1: "Smooth",
  T_48_META_TYP_433_I2: "Custom",
  T_48_META_TYP_434: "Custom Curve Path",
  T_48_META_TYP_434_I2: "Closed Loop",
  T_48_META_TYP_434_I3: "Waypoints",
  T_48_META_TYP_437_I5: "Score Type Names",
  T_48_META_TYP_437_I6: "Left Score Content",
  T_48_META_TYP_437_I7: "Right Score Content",
  T_48_META_TYP_438_I1: "Players",
  T_48_META_TYP_438_I2: "Ranks",
  T_48_META_TYP_438_I3: "Total Scores",
  T_48_META_TYP_438_I4: "Score Type Names",
  T_48_META_TYP_438_I5: "Colors",
  T_48_META_TYP_438_I6: "Scores",
  T_48_META_TYP_439: "Group",
  T_48_META_TYP_442_I1: "Left Score",
  T_48_META_TYP_442_I10: "Right Eliminated Icon",
  T_48_META_TYP_442_I2: "Right Score",
  T_48_META_TYP_442_I3: "Left Alive Number",
  T_48_META_TYP_442_I4: "Right Alive Number",
  T_48_META_TYP_442_I5: "Left Eliminated Number",
  T_48_META_TYP_442_I6: "Right Eliminated Number",
  T_48_META_TYP_442_I7: "Left Alive Icon",
  T_48_META_TYP_442_I8: "Right Alive Icon",
  T_48_META_TYP_442_I9: "Left Eliminated Icon",
  T_48_META_TYP_444: "Language Type",
  T_48_META_TYP_444_I0: "English",
  T_48_META_TYP_444_I1: "Simplified Chinese",
  T_48_META_TYP_444_I10: "French",
  T_48_META_TYP_444_I11: "German",
  T_48_META_TYP_444_I12: "Turkish",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Japanese",
  T_48_META_TYP_444_I15: "Romanian",
  T_48_META_TYP_444_I16: "Arabic",
  T_48_META_TYP_444_I17: "Burmese",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengali",
  T_48_META_TYP_444_I2: "Traditional Chinese",
  T_48_META_TYP_444_I3: "Thai",
  T_48_META_TYP_444_I4: "Vietnamese",
  T_48_META_TYP_444_I5: "Indonesian",
  T_48_META_TYP_444_I6: "Portuguese",
  T_48_META_TYP_444_I7: "Spanish",
  T_48_META_TYP_444_I8: "Russian",
  T_48_META_TYP_444_I9: "Korean",
  T_48_SD_ERROR_DIVISOR: "Divisor cannot be 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "The specified key does not exist in map: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "List index out of range: {0}",
  T_48_SD_SK_WARNING: "Did not found {1} in {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Since the attribute "IsServerDriven" of the Craftland character controller {0} is disabled, the related server API does not take effect.',
  T_48_XXJ_WS_PARENTERROR: "Failed to set parent",
  T_48_XXJ_WS_PERFORMANCE: "Performance",
  T_48_XXJ_WS_TANGENT: "Tangent",
  T_48_XXJ_WS_WAYPOINT: "Waypoint",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "List of objects",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Use Custom Minimap",
  T_48_XYL_UGC_HIDEMINIMAP: "Hide Minimap HUD",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Basic Custom Surface",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Cylinder Cutout",
  T_48_XYL_WS_BASICHEMISPHERE: "Basic Hemisphere",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Quarter Torus",
  T_48_XYL_WS_BASICQUARTERTORUS: "Quarter Square Torus",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Torus",
  T_48_XYL_WS_BASICTRIANGLE: "Triangle Surface",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Match players = Number of teams x Number of players per team. The more match players, the longer the matchmaking time",
  T_48_XYL_WS_MAPPLAYERSWARNING: "A high number of match players may lead to longer matchmaking time",
  T_49_HL_CL_CREATOR_LABEL2: "Craftland Community Talent",
  T_49_HL_CL_MAPS_LABEL2: "Map Winner",
  T_49_HL_CL_MAPS_LABEL3: "Gameplay Winner",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Trajectory",
  T_49_JH_WS_SKILLKASSIE: "Electro Therapy (Kassie)",
  T_49_JH_WS_SKILLKODA: "Aurora Vision (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Valiant Dash (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Generate with AI",
  T_49_META_API_10065: "Switch Custom Camera",
  T_49_META_API_10067: "Get Current Custom Camera",
  T_49_META_API_10069: "Create Custom Camera",
  T_49_META_API_10070: "Set Custom Camera Culling Mask",
  T_49_META_API_10070_D: "Set the culling mask of the target camera to control visibility across all layers",
  T_49_META_API_10071: "Get Custom Camera Culling Mask",
  T_49_META_API_10071_D: "Get the culling mask of the target camera",
  T_49_META_API_10072: "Set Custom Camera Culling Mask Layer",
  T_49_META_API_10072_D: "Set the visibility of the target camera for a specific layer",
  T_49_META_API_10073: "Capture Screenshot",
  T_49_META_API_10073_D: "Capture screenshot (for internal testing)",
  T_49_META_API_106: "Get Server Timestamp (ms)",
  T_49_META_API_106_D: "Get the server timestamp with millisecond precision",
  T_49_META_API_107: "Timestamp to Localized String (ms)",
  T_49_META_API_107_D: "Convert timestamps (in ms) into strings based on certain formats",
  T_49_META_API_107_P0: "Timestamp (ms)",
  T_49_META_API_107_P0_D: "A timestamp in millisecond",
  T_49_META_API_108: "Lerp Vector3",
  T_49_META_API_108_D: "Perform linear interpolation from the 3D vector A to vector B",
  T_49_META_API_1089_P2: "Request ID",
  T_49_META_API_109: "Update Context to Persona",
  T_49_META_API_109_D: "Update the model context of a specified persona in the current room and overwrite the original context after execution.The context will influence the persona's interpretation of the background, history, or certain parameters for the current dialogue.",
  T_49_META_API_109_P1: "Context",
  T_49_META_API_109_P1_D: "Details of the context",
  T_49_META_API_110: "Feedback on Persona Response",
  T_49_META_API_110_D: "Submit feedback on the response content of a persona, which will be used to optimize our model.",
  T_49_META_API_110_P1: "Is Liked",
  T_49_META_API_110_P1_D: "Whether the response is liked or not. True = like.",
  T_49_META_API_1109: "Set Local Player Position",
  T_49_META_API_1109_D: "When the player is using classic game characters, this API can set the player's position.",
  T_49_META_API_1109_P0_D: "The target position",
  T_49_META_API_111: "Slerp Vector3",
  T_49_META_API_111_D: "Perform spherical interpolation from the 3D vector A to vector B for smooth rotation",
  T_49_META_API_1110: "Set Local Player Forward",
  T_49_META_API_1110_D: "When the player is using classic game characters, this API can set the direction the player is facing.",
  T_49_META_API_1110_P0_D: "The forward vector",
  T_49_META_API_112: "Roll Back Persona Memory",
  T_49_META_API_112_D: "Roll back the memory of a persona to before the specific response ID. All memory of the dialogues including and after the response will be cleared.",
  T_49_META_API_113: "Play One-Shot Sound",
  T_49_META_API_113_D: "Play a one-shot sound effect with adjustable volume",
  T_49_META_API_113_P0_D: "The sound effect resource ID to be played",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "The playback volume for the sound effect, ranging from 0 to 1.",
  T_49_META_API_97: "Create Skeleton Part Look-at Controller",
  T_49_META_API_97_D: "After creating a skeleton part look-at controller entity, you can use this entity to control the specified skeleton part and make it always face a specific target.",
  T_49_META_API_97_P0_D: "The skeleton part look-at controller entity. If the entity is destroyed, the look-at functionality will cease.",
  T_49_META_API_97_P1_D: "The skeleton part that is being controlled",
  T_49_META_API_97_P2_D: "The target that is being looked at",
  T_49_META_API_98: "Projection",
  T_49_META_API_98_D: "Calculate the projection of vector A onto vector B",
  T_49_META_API_99: "Get Local Timestamp (ms)",
  T_49_META_API_99_D: "Get the local timestamp with millisecond precision",
  T_49_META_EVT_16_P1_D: "Starting from 0, each outgoing request will consume a sequential numeric ID, such as for creating a room and clearing memory.",
  T_49_META_EVT_16_P2: "Response ID",
  T_49_META_EVT_16_P2_D: "Each complete response will have a unique ID",
  T_49_META_TYP_122_I19: "Custom Material",
  T_49_META_TYP_122_I19_D: "Allow for replacing the skybox with a custom material",
  T_49_META_TYP_14_I78_D: "Get or set the camera entity that is currently rendering the scene on the player's client. Note: The camera entity essentially represents the configuration data for controlling the client-side camera.",
  T_49_META_TYP_335_I9: "Elapsed Time (ms)",
  T_49_META_TYP_335_I9_D: "The playback duration of the sound effect in milliseconds. This property can only be accessed on the client side.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "Performance ID",
  T_49_META_TYP_445: "Playable Controller ID",
  T_49_META_TYP_446: "Playable Controller Attachable",
  T_49_META_TYP_446_I0: "Playable Controller",
  T_49_META_TYP_447: "Skeleton Part Controller",
  T_49_META_TYP_448: "Skeleton Part Look-at Controller",
  T_49_META_TYP_448_I0: "Controlled Target",
  T_49_META_TYP_448_I1: "Look-at Target",
  T_49_META_TYP_449: "Custom Camera",
  T_49_META_TYP_449_I2: "Orthographic Size",
  T_49_META_TYP_449_I2_D: "Control the size of the area visible to the camera",
  T_49_META_TYP_450: "Timestamp Localized String (ms)",
  T_49_META_TYPE_449_D: "A custom camera is fully controlled by the developer and determines what the player sees during gameplay",
  T_49_META_TYPE_450_D: "Format a millisecond-level timestamp into a readable text format",
  T_49_SD_SEARCH_ICONDESC: "Smart Association",
  T_49_SD_SEARCHKEY_ACTION: "Action",
  T_49_SD_SEARCHKEY_ANICLIPID: "Animation clip ID",
  T_49_SD_SEARCHKEY_AS: "As",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "Attachment ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Sound effect type",
  T_49_SD_SEARCHKEY_BAGSKINID: "Backpack skin ID",
  T_49_SD_SEARCHKEY_BEZIER: "Bezier curve",
  T_49_SD_SEARCHKEY_BOOL: "Boolean",
  T_49_SD_SEARCHKEY_BREAK: "Break",
  T_49_SD_SEARCHKEY_BTREEID: "Behavior Tree ID",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "On button clicked",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "On button double clicked",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "On Button pressed",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "On button release",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Outfit type",
  T_49_SD_SEARCHKEY_COLOR: "Color",
  T_49_SD_SEARCHKEY_COMMENT: "Comment note",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Component enum",
  T_49_SD_SEARCHKEY_CONCANT: "Connect",
  T_49_SD_SEARCHKEY_CONTINUE: "Continue",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "Custom HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Custom hud widget",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "dynamic create level object type",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Visual effects type",
  T_49_SD_SEARCHKEY_ENTITY: "Select scene object",
  T_49_SD_SEARCHKEY_FLOAT: "Float",
  T_49_SD_SEARCHKEY_FOR: "For index",
  T_49_SD_SEARCHKEY_FOREACH: "For each",
  T_49_SD_SEARCHKEY_FUNCTION: "Function",
  T_49_SD_SEARCHKEY_GETCSV: "Get CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Get registered asset by key",
  T_49_SD_SEARCHKEY_GETVALUE: "Get property value",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Get global variable",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Set Global Variable",
  T_49_SD_SEARCHKEY_IF: "If",
  T_49_SD_SEARCHKEY_IFELSE: "If else",
  T_49_SD_SEARCHKEY_IMGENUM: "Sprite Type",
  T_49_SD_SEARCHKEY_INT: "Integer",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD type",
  T_49_SD_SEARCHKEY_ITEMENUM: "Item Type",
  T_49_SD_SEARCHKEY_LISTAPPEND: "List append",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "List append range",
  T_49_SD_SEARCHKEY_LISTCLEAR: "List clear",
  T_49_SD_SEARCHKEY_LISTCLONE: "List clone",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "List contain",
  T_49_SD_SEARCHKEY_LISTCREATE: "List create",
  T_49_SD_SEARCHKEY_LISTDELETE: "Delete List",
  T_49_SD_SEARCHKEY_LISTGET: "Get list",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "List index of",
  T_49_SD_SEARCHKEY_LISTINSERT: "List insert",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "List last index of",
  T_49_SD_SEARCHKEY_LISTLENGTH: "List length",
  T_49_SD_SEARCHKEY_LISTREVERSE: "List reverse",
  T_49_SD_SEARCHKEY_LISTSET: "Set list",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "List shuffle",
  T_49_SD_SEARCHKEY_LOCALKEY: "Localized key",
  T_49_SD_SEARCHKEY_LOCALVAR: "Local variable",
  T_49_SD_SEARCHKEY_LOGICAL: "And or",
  T_49_SD_SEARCHKEY_LOGINFO: "Log info print",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dict get all keys map get all keys",
  T_49_SD_SEARCHKEY_MAPCLEAR: "clear dict clear map",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict contain key map contain key",
  T_49_SD_SEARCHKEY_MAPCREATE: "create dict create map",
  T_49_SD_SEARCHKEY_MAPGET: "get dict value by key get map value by key",
  T_49_SD_SEARCHKEY_MAPLENGTH: "dict length map length",
  T_49_SD_SEARCHKEY_MAPREMOVE: "remove dict remove map",
  T_49_SD_SEARCHKEY_MAPSET: "set dict value set map value",
  T_49_SD_SEARCHKEY_MATH: "add subtract multiply divide",
  T_49_SD_SEARCHKEY_NEWLIST: "New list",
  T_49_SD_SEARCHKEY_NULL: "Null",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Number to string",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Particles properties",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "Player Data ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Character skill type",
  T_49_SD_SEARCHKEY_PREEFFECT: "Special sticker type",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "Raw ID",
  T_49_SD_SEARCHKEY_READSTATIS: "Read accumulated data",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "Resource uuid",
  T_49_SD_SEARCHKEY_RETURN: "Return",
  T_49_SD_SEARCHKEY_SCENEENUM: "Scene file",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Set property value",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Special item ID type",
  T_49_SD_SEARCHKEY_TEXT: "Text",
  T_49_SD_SEARCHKEY_TEXTUREID: "Texture type",
  T_49_SD_SEARCHKEY_THISENTITY: "This Entity",
  T_49_SD_SEARCHKEY_TIMELINE: "Timeline",
  T_49_SD_SEARCHKEY_TYPEENUM: "Any type",
  T_49_SD_SEARCHKEY_V2VCREATE: "Create Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Get Vector2 components",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vector2 operation add subtract multiply dot product  distance angle",
  T_49_SD_SEARCHKEY_V2VSET: "Set Vector2 components",
  T_49_SD_SEARCHKEY_V3VCREATE: "Create Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Get Vector3 components",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vector3 operation add subtract multiply dot product cross product distance angle",
  T_49_SD_SEARCHKEY_V3VSET: "Set Vector3 components",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "Vehicle skin ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "Weapon Skin ID",
  T_49_SD_SEARCHKEY_WHILE: "While",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Write accumulated database offset",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Write accumulated database offset by map code",
  T_49_XXJ_WS_DURATIONS: "Duration (s)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Edit Performance",
  T_49_XXJ_WS_PERFORMANCE: "Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Delete Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Deleted performance cannot be restored, continue?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Editing {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "This name has already been used, please change it and try again",
  T_49_XXJ_WS_PERFORMANCENAME: "Performance Name",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Add Key Frame",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Add Sub-Track",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Add Track",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Delete Track",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Actor Track",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Event Track",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Key Frame already exists",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "The corresponding actor track already exists",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Content",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Duplicate track names detected. Please change them and try again.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Please start recording or choose a key frame first",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Recording...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Delete Key Frame",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Scene View",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Select an object to create a track or tap the add-track button directly",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Tap the add-track button to create a new track",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Sub-Track",
  T_49_XXJ_WS_TIMELINE_TRACK: "Track",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Track View",
  T_49_XYL_WS_DAILYPROPS: "Basic",
  T_49_XYL_WS_STOREGAMPLAY: "Gameplay",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Trouble Academy",
  T_50_H_MACHETE_VA_N: "Parang - Trouble Academy",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Leaderboard Fields",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Overflow",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Wrap around",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Shrink font",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Create Tuple",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Get Tuple",
  T_50_HJ_SEARCHKEY_TUPLESET: "Set Tuple",
  T_50_HJ_TEXTOBGJ_H: "Height",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Overflow Options",
  T_50_HJ_TEXTOBGJ_W: "Width",
  T_50_HZY_REVIEW_TEXTOBJ: "Text object content",
  T_50_JH_WS_HIDEMAPERROR: "Cannot hide minimap without a custom cover image",
  T_50_JH_WS_HIDEMAPTIP: "When minimap is hidden, it will no longer be used as the cover image",
  T_50_JH_WS_HIDEMINIMAP: "Hide Minimap",
  T_50_META_API_10073_P0: "File Name",
  T_50_META_API_10073_P0_D: "The file name",
  T_50_META_API_10073_P1_D: "The result of the execution. Check the Status Code enum.",
  T_50_META_API_1102: "Read Database Sheet Column Value",
  T_50_META_API_1102_D: "Read the value of a specific column for a given key from a standard database table",
  T_50_META_API_1102_P3: "Column Index",
  T_50_META_API_1102_P3_D: "The column index of the database table (0 = the first column)",
  T_50_META_API_1106: "Create Performance",
  T_50_META_API_1106_D: "Create a performance entity",
  T_50_META_API_1106_P0_D: "The performance asset",
  T_50_META_API_1111: "Read Database Leaderboard Association Value",
  T_50_META_API_1111_D: "Read the combination of values from a leaderboard table and its associated table in the database",
  T_50_META_API_1111_P5: "Association Status Code",
  T_50_META_API_1111_P5_D: "Association Error Code",
  T_50_META_API_1112: "Read Database Leaderboard Association Values by Range",
  T_50_META_API_1112_D: "Read values from the leaderboard table within a specified rank range, read the corresponding values by retrieved keys from the associated table, and combine them.",
  T_50_META_API_1112_P6: "Association Status Code",
  T_50_META_API_1112_P6_D: "Association Error Code",
  T_50_META_API_1113: "Write Database Leaderboard Association Value",
  T_50_META_API_1113_D: "Write the value for a given key into the leaderboard table and its related table in the database",
  T_50_META_API_1113_P5: "Association Status Code",
  T_50_META_API_1113_P5_D: "Association Error Code",
  T_50_META_API_114_D: "Create custom UI",
  T_50_META_API_114_P0_D: "The code is used as the parameter name for creating a UI entity, and its corresponding local variable value represents the created UI entity.",
  T_50_META_API_114_P1_D: "The player entity it belongs to, only visible to the player.",
  T_50_META_API_114_P2: "UI Asset ID",
  T_50_META_API_114_P2_D: "The custom UI asset ID",
  T_50_META_API_115_D: "Create the specified custom UI",
  T_50_META_API_116: "Set Level Object Highlight",
  T_50_META_API_116_D: "Set the highlight status of the object. It may be affected by other in-game logics.",
  T_50_META_API_116_P0_D: "Target Object",
  T_50_META_API_116_P1_D: "Highlight status",
  T_50_META_API_117: "Bitwise Common",
  T_50_META_API_117_D: "Bitwise and/or/xor/left shift/right shift",
  T_50_META_API_117_P0_D: "Left value",
  T_50_META_API_117_P1_D: "Right value",
  T_50_META_API_117_P2_D: "Operation Type",
  T_50_META_API_118: "Bitwise Not",
  T_50_META_API_118_D: "Bitwise NOT, also known as bitwise complement.",
  T_50_META_API_118_P0_D: "Value",
  T_50_META_API_119: "Bitwise List to Int",
  T_50_META_API_119_D: "Perform bitwise OR operation on all list elements and transform the output to an integer value.",
  T_50_META_API_119_P0: "Bit Array",
  T_50_META_API_119_P0_D: "Bitwise array",
  T_50_META_API_120: "Bitwise Int to List",
  T_50_META_API_120_D: "Covert the decimal values represented by bits at position 1 of an integer in its binary form to a list",
  T_50_META_API_120_P0_D: "Integer",
  T_50_META_API_121: "Quaternion Angle",
  T_50_META_API_121_D: "Calculate the angle between two quaternions",
  T_50_META_API_121_P0_D: "Quaternion 1",
  T_50_META_API_121_P1_D: "Quaternion 2",
  T_50_META_API_122: "Quaternion Dot",
  T_50_META_API_122_D: "Calculate the dot product of two quaternions",
  T_50_META_API_123: "Quaternion Inverse",
  T_50_META_API_123_D: "Calculate the inverse of a quaternion",
  T_50_META_API_123_P0_D: "Quaternion",
  T_50_META_API_124: "Quaternion From To Rotation",
  T_50_META_API_124_D: 'Calculate rotation quaternion from "from" to "to"',
  T_50_META_API_124_P0_D: "The start point",
  T_50_META_API_124_P1_D: "The end point",
  T_50_META_API_125: "Quaternion Rotate Towards",
  T_50_META_API_125_D: 'Calculate the rotation quaternion from "from" to "to". Max Degrees Delta is the max. rotation angle.',
  T_50_META_API_125_P0: "From",
  T_50_META_API_125_P0_D: "Initial quaternion",
  T_50_META_API_125_P1: "To",
  T_50_META_API_125_P1_D: "The target quaternion",
  T_50_META_API_125_P2: "Max. Degree Delta",
  T_50_META_API_125_P2_D: "The max. rotation angle",
  T_50_META_API_126: "Get Gyroscope Orientation",
  T_50_META_API_126_D: "Device orientation in 3D space, representing rotation angles around the three axes.",
  T_50_META_API_127: "Get Gyroscope Gravity",
  T_50_META_API_127_D: "The gravity component detected by the sensor on your device",
  T_50_META_API_128: "Get Gyroscope Rotation Rate",
  T_50_META_API_128_D: "This refers to the rotation rate of a device. It is a term related to the gyroscope sensors that describes the device's rotational movement speed in a three-dimensional space.",
  T_50_META_API_129: "Get Gyroscope Rotation Unbiased",
  T_50_META_API_129_D: "Describes the device's rotation rate and provides a more precise result by compensating for the noise or bias of the device's sensors.",
  T_50_META_API_130: "Get Gyroscope User Acceleration",
  T_50_META_API_130_D: "The part of the device's acceleration with the gravity component removed, which is the acceleration caused by user actions or external forces.",
  T_50_META_API_131: "Get Touch Info",
  T_50_META_API_131_D: "Get the specified index screen touch information (including position,  displacement, and change time).",
  T_50_META_API_131_P0_D: "Distribute touch point IDs, starting from 0",
  T_50_META_API_131_P1_D: "Touch position",
  T_50_META_API_131_P2: "Delta Position",
  T_50_META_API_131_P2_D: "The shift in position compared to the last frame",
  T_50_META_API_131_P3: "Delta Time",
  T_50_META_API_131_P3_D: "Time elapsed since last frame",
  T_50_META_API_132: "Get Screen Touch Count",
  T_50_META_API_132_D: "Get the current number of touch points on the screen",
  T_50_META_API_133: "Vibrate Device",
  T_50_META_API_133_D: "Make the device vibrate once",
  T_50_META_API_134_D: "Notify the target player device to play the audio",
  T_50_META_API_134_P0_D: "The target player",
  T_50_META_API_134_P1_D: "The audio asset",
  T_50_META_API_134_P2_D: "The playback speed (valid range: 0.1~3.0; 1 = normal, <1 = slow down, >1 = speed up)",
  T_50_META_API_135_D: "Play the one-time audio file",
  T_50_META_API_135_P0_D: "Audio resources",
  T_50_META_API_135_P1_D: "Play Speed",
  T_50_META_API_136: "Format String",
  T_50_META_API_136_D: "Format the strings",
  T_50_META_API_136_P0_D: "Formatted strings that use Go formatting verb controls",
  T_50_META_API_136_P1: "Parameters Array",
  T_50_META_API_136_P1_D: "Parameter List",
  T_50_META_API_137: "Paste Component",
  T_50_META_API_137_D: "Copy or add component data",
  T_50_META_API_137_P0: "Source",
  T_50_META_API_137_P0_D: "The source entity",
  T_50_META_API_137_P1_D: "Target Entity",
  T_50_META_API_137_P2: "Component Type",
  T_50_META_API_137_P2_D: "Component Type",
  T_50_META_API_137_P3: "Is Success",
  T_50_META_API_137_P3_D: "Whether it is successful or not",
  T_50_META_API_138: "Revive At Next Frame",
  T_50_META_API_138_D: "Revive at the next frame",
  T_50_META_API_139: "Eliminate at Next Frame",
  T_50_META_API_139_D: "Eliminate the battle entity at the next frame",
  T_50_META_API_139_P0_D: "The battle entity",
  T_50_META_API_140: "Quit Game at Next Frame",
  T_50_META_API_140_D: "Exit the game at the next frame",
  T_50_META_API_141: "Get Microphone Volume",
  T_50_META_API_141_D: "Get the microphone volume. Return the status when the player's microphone is off or no access is granted.",
  T_50_META_API_141_P0: "Volume",
  T_50_META_API_141_P0_D: "The microphone volume",
  T_50_META_API_141_P1_D: "Microphone is turned on or off",
  T_50_META_API_142: "Get Render Quality",
  T_50_META_API_142_D: "Get the current rendering quality (enum: Low/Medium/High/Ultra)",
  T_50_META_API_143: "Get Render Resolution",
  T_50_META_API_143_D: "Get the current render resolution",
  T_50_META_API_144: "Bind Custom Player",
  T_50_META_API_144_D: "Dynamically set the target that this player binds to that will override existing bindings. Returns false if failed.",
  T_50_META_API_144_P0: "Custom Player",
  T_50_META_API_144_P0_D: "After binding this Custom Player to the player, data such as position and direction will be automatically synced",
  T_50_META_API_144_P1_D: "Target Player",
  T_50_META_API_145: "Unbind Custom Player",
  T_50_META_API_145_D: "Cancel the binding. Returns false if failed.",
  T_50_META_API_145_P0: "Custom Player",
  T_50_META_API_145_P0_D: "Clear all bindings for this target. After unbinding, data such as position and direction will no longer be automcatically synced.",
  T_50_META_API_146_P0_D: "A custom player",
  T_50_META_API_147: "Set Custom Player State",
  T_50_META_API_147_D: "Automatically upload to the sever and sync with all clients. Returns false if failed.",
  T_50_META_API_147_P0: "Custom Player",
  T_50_META_API_147_P1: "State",
  T_50_META_API_147_P1_D: "Usually used to save the animation states. Get the synced state with Get Custom Player State.",
  T_50_META_API_148: "Get Custom Player State",
  T_50_META_API_148_D: "The state data is automatically synced to the server. Returns false if failed.",
  T_50_META_API_148_P0: "Custom Player",
  T_50_META_API_148_P1: "State",
  T_50_META_API_148_P1_D: "Set the state with Set Custom Player State",
  T_50_META_API_149: "Set Distance Volumes",
  T_50_META_API_149_D: "Set the distance ranges between players to dynamically set audio volume.",
  T_50_META_API_149_P0: "Distance List",
  T_50_META_API_149_P0_D: "A list of distance ranges, each corresponding to an element in the volume list.",
  T_50_META_API_149_P1: "Volume List",
  T_50_META_API_149_P1_D: "A list of volumes, each corresponding to an element in the distance list.",
  T_50_META_API_150: "Get Friends",
  T_50_META_API_150_D: "Get the list of the player's friend IDs",
  T_50_META_API_151: "Get Default UI Info",
  T_50_META_API_151_D: "Get the default UI location of the player",
  T_50_META_API_151_P0_D: "The default interface",
  T_50_META_API_151_P1_D: "Status",
  T_50_META_API_151_P2_D: "UI Position",
  T_50_META_API_151_P3: "Size",
  T_50_META_API_151_P3_D: "UI Size",
  T_50_META_API_152: "Broadcast Custom Event",
  T_50_META_API_152_D: "Broadcast a custom event for any entity to receive (listen to) this event",
  T_50_META_API_153: "Dispatch Event to Entity",
  T_50_META_API_153_D: "Send the custom event to the target entity",
  T_50_META_EVT_17: "On Screen Touch Begin",
  T_50_META_EVT_17_D: "Start the event when the screen is touched",
  T_50_META_EVT_17_P0: "Touch Index",
  T_50_META_EVT_17_P0_D: "Touch point index",
  T_50_META_EVT_17_P1_D: "Touch position",
  T_50_META_EVT_18: "On Screen Touch End",
  T_50_META_EVT_18_D: "End the event when the screen is touched",
  T_50_META_EVT_18_P0: "Touch Index",
  T_50_META_EVT_18_P0_D: "Touch point index",
  T_50_META_EVT_18_P1_D: "Touch positions on the screen",
  T_50_META_EVT_19: "On Receive Persona Create Room Result",
  T_50_META_EVT_19_D: "Receive the corresponding result when failed to create the persona chat room",
  T_50_META_EVT_19_P1: "Room ID",
  T_50_META_EVT_19_P1_D: "The room ID",
  T_50_META_EVT_20: "On User Quit or User Match End",
  T_50_META_EVT_20_D: "Trigger when the user quits the match or when the match ends",
  T_50_META_TYP_11_I44: "Distance Volumes",
  T_50_META_TYP_11_I44_D: "Dynamically adjust the audio volume based on the distance between players",
  T_50_META_TYP_22_I9_D: "The asset ID used to create the UI",
  T_50_META_TYP_244_I12_D: "The text box width",
  T_50_META_TYP_244_I13_D: "The text box height",
  T_50_META_TYP_244_I14_D: "The overflow type",
  T_50_META_TYP_335_I10_D: "The playback speed (valid value > 0, default = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "IO operation failed: an error occurred while creating the file.",
  T_50_META_TYP_409_I21: "IO_Invalid_File_Name",
  T_50_META_TYP_409_I21_D: "IO operation failed. Invalid file name.",
  T_50_META_TYP_448_I0_D: "The controlled skeleton part",
  T_50_META_TYP_448_I1_D: "The target that the skeleton part is looking at",
  T_50_META_TYP_451: "Overflow Type",
  T_50_META_TYP_451_D: "The method for handling text overflow",
  T_50_META_TYP_452: "Custom UI Asset ID",
  T_50_META_TYP_452_D: "The ID that describes the custom HUD asset",
  T_50_META_TYP_453: "Render Quality Type",
  T_50_META_TYP_453_D: "The rendering quality enum",
  T_50_META_TYPE_448_D: "This entity is used to control the skeleton part to look at a target",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D Object Generate Map",
  T_50_SD_WS_MAPTAG_AIRACING: "Racing AI Generate Map",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Animation state name enum",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Disable Footsteps Vibration",
  T_50_XXJ_WS_NOPERFORMANCE: "No performance file yet",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Beta version",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Dear creators, the performance editor is still in the testing phase. It may contain bugs or lack essential features. Please use it with caution.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Add Performance",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Add Key Clip",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Along Path Track",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animation",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Animation Track",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Audio Track",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Hold",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Loop Forever",
  T_50_XXJ_WS_TIMELINE_DURATION: "Duration: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Mismatch between animation and model",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Key clip overlap",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Bound entity missing",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "The track name cannot be empty",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC Track",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Property Track",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Remove Key Clip",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Track count limit exceeded",
  T_50_XYL_WS_AIGETERATESHOW: "Building Blocks",
  T_50_YU_F_B_VA_WITCH: "Mystic Trouble (Bottom)",
  T_50_YU_F_H_VA_WITCH: "Mystic Trouble (Head)",
  T_50_YU_F_HA_VA_WITCH: "Mystic Trouble (Facepaint)",
  T_50_YU_F_S_VA_WITCH: "Mystic Trouble (Shoes)",
  T_50_YU_F_T_VA_WITCH: "Mystic Trouble (Top)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Custom Event",
  T_51_GT_WS_BASIC: "Basic",
  T_51_GT_WS_GLOBALEVENT: "Global Event",
  T_51_GT_WS_PRIVATEEVENT: "Private Event",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "Preparation time before game starts",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Read-only Property",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "အနက္ေရာင္သားေရဂ်ာကင္",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "မိႈရွာသူ",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "အနက္ေရာင္တက္ၾကြေသာ(ဖိနပ္)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GW2018 ေခတ္စားေသာ ေဘာင္းဘီ (အမ်ိဳးသမီး)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GW2018 စကပ္ (အမ်ိဴးသမီး)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "အနက္ေရာင္တက္ၾကြေသာ(ေခါင္းစြပ္)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "ဆုန္ကရန္ အက်ီတို (အနက္)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "ေရပိုက္ျပင္သမားအေပၚဝတ္စံု (အမ်ိဳးသမီး)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GW2018 အားကစား (စြပ္က်ယ္)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "အျဖဴေရာင္္ေအာင္ျမင္မႈ (ေအာက္)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "အနက္ေရာင္အေျပးေဘာင္းဘီ",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "အဖြဲ႕ေဘာင္းဘီ",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "အသက္ကယ္ေဘာင္းဘီ",
  TXT_AVATAR_MALE_PANTS_MARIO: "မာမာမီယာ",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "အသက္ကယ္ ဖိနပ္",
  TXT_AVATAR_MALE_SHOE_RED: "အနီေရာင္ဖိနပ္ (အမ်ိဳးသား)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "အျဖဴေရာင္ေအာင္ျမင္မႈ (ထိပ္)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "အနက္ေရာင္ ေဘစ္ေဘာ့ဆြယ္တာ အက်ီ",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "သူပုန္ေခါင္းေဆာင္း",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "ေအးျမေသာ ဖ်တ္လတ္ဝတ္စံု (ေခါင္းေဆာင္း)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "ဘုရင္ဦးေခါင္းခြံ ဝတ္စံု",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "အသက္ကယ္ အက်ီ",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "ေရပိုက္ျပင္သမားအေပၚဝတ္စံု (အမ်ိဳးသား)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Racer ဂ်ာကင္",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "ညလူရႊင္ေတာ္ (ေခါင္း)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Racer ဂ်ာကင္",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "လက္ျပတ္ဂ်ာကင္",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "ထာကို႔မြန္းစတား",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "ခါဘူကိမ်က္ႏွာဖုံး",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "လက္ေမာင္းအျပည့္တက္တူး",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "အေရွ႕ၾကယ္သီး",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "ဝစ္ေတာ္ရီယာ",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "အိမ္ဂ်ယ္ဝင့္",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "အသီးေဘာင္းဘီ",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "ဆာကူရ",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "အဲးလ္ေဖါ့စ္ခူးး",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "ဆက္ဖိုင္",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "ဆာကုရပြင့္",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "ကင္းၿမီးေကာက္နက္",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "ထြန္ေဖေထ",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "နတ္ကေတာ္",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "ေပါင္းဆက္ထားေသာအဝတ္",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "ဘြတ္ဖိနပ္အျမင့္",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "ေနရာတိုင္းသံုးႏိုင္ေသာ ဘြတ္ဖိနပ္",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "ကာဘြန္စပစ္",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "ဂ်င္း",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "ကင္းၿမီးေကာက္နက္",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "ရဲလ္လိုးပါတ္",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "အရိပ္နတ္ကေတာ္",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "အားကစားေဘာင္းဘီအျဖဴ",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "အမ်ိဳးသမီးအားကစားေဘာင္းဘီ",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Rider ဂ်ာကင္ (အမ်ိဳးသမီး)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "ေဘ့စ္ေဘာအက်ႌ",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "ေယာက္်ားေလးမ်ားေဘ့စ္ေဘာေဘာင္းဘီ",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "စေတ့ပ္အပ္အစံု",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "ဘာ့စ္ေဘာဖိနပ္",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Rider ဂ်ာကင္",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "ေဘ့စ္ေဘာအက်ႌ",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "ကရင္းဒိုင္ႏို",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "ေငြေရာင္အားကစားသမားဖိနပ္",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "ျခေသၤ့ဟိန္းေဟာက္သံ",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "စပိုင္မ်က္ႏွာဖံုး",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "ထူးဆန္းလူသား",
  TXT_AVATAR_PARACHUTE_8: "ျပံဳးရႊင္",
  TXT_AVATAR_SHIRT_PLAID_2: "ခံလုပ္သား",
  TXT_AVATAR_SHOES_1: "ဖိနပ္အျဖဴ",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "ေက်ာင္းသားအက်ႌ(ဘိုေကနီယာ)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "ေက်ာင္းသားအက်ႌ(ႏွင္းဆီ)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "ေက်ာင္းသားအက်ီ္ၤ",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "ေက်ာင္းသား(ခရမ္း)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "ေက်ာင္းသားအက်ႌ(စံပါယ္)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "အလယ္တန္းေက်ာင္းသား",
  TXT_AVATAR_TSHIRT_WEEK_007: "တနဂၤေႏြေန႔ကအေပ်ာ္ဆံုး",
  TXT_BANNER_NAME_MISHA: "စပစ္",
  TXT_CHARACTER_ADAM_NAME: "Primis",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Nulla",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "နာမည္",
  TXT_COLLECTION_DESCRIPTION: "ရွင္းျပခ်က္",
  TXT_COLLECTION_HEADPORTRAIT: "ဓာတ္ပံု",
  TXT_INVENTORY_TITLE_EQUIPMENT: "ပစၥည္းကိရိယာ",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "AR ကျည်",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "အိတ္ Lv 1",
  TXT_ITEM_BAG2: "အိတ္ Lv 2",
  TXT_ITEM_BAG3: "အိတ္ Lv 3",
  TXT_ITEM_BASEBALLPOLE: "ေဘာ့စ္ေဘာရိုက္တံ",
  TXT_ITEM_BOWAMMO: "ဒူးေလးၿမား",
  TXT_ITEM_CHANGUO: "ဒယ္ျပာ",
  TXT_ITEM_CROSSBOW: "ဒူးေလး",
  TXT_ITEM_DESC_FLASH: "ခံစားမႈကိုေခတၱျဖတ္ေတာက္ႏိုင္သည္ ဗံုး",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "ေဆး",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "လက္သီး",
  TXT_ITEM_FLASH: "အလင္းဗံုး",
  TXT_ITEM_FOREGRIP1: "ဂရစ္ပ္Lv1",
  TXT_ITEM_FOREGRIP2: "ဂရစ္ပ္Lv2",
  TXT_ITEM_FOREGRIP3: "ဂရစ္ပ္Lv3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "လက္ပစ္ဗုံး",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "လက္ Cannon",
  TXT_ITEM_HEATSIGHT: "အပူလိႈင္း ကင္မရာ",
  TXT_ITEM_HELMET1: "Lv1 ဦးထုပ္",
  TXT_ITEM_HELMET2: "Lv2 ဦးထုပ္",
  TXT_ITEM_HELMET3: "Lv3 ဦးထုပ္",
  TXT_ITEM_HGAMMO: "HG ကျည်",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M1014",
  TXT_ITEM_M1873: "M1014",
  TXT_ITEM_M249: "M1014",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Parang",
  TXT_ITEM_MAGEZINE1: "မဂၢဇင္း Lv1",
  TXT_ITEM_MAGEZINE2: "မဂၢဇင္း Lv2",
  TXT_ITEM_MAGEZINE3: "မဂၢဇင္း Lv3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "မာဇယ္ Lv1",
  TXT_ITEM_MUZZLE2: "မာဇယ္ Lv2",
  TXT_ITEM_MUZZLE3: "မာဇယ္Lv3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "SG ကျည်",
  TXT_ITEM_SIGHT2: "2x မွန္ေျပာင္း",
  TXT_ITEM_SIGHT4: "4x မွန္ေျပာင္း",
  TXT_ITEM_SILENCER1: "အသံတိတ္",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "SMG ကျည်",
  TXT_ITEM_SNAMMO: "စႏိုက္ပါက်ည္ဆံ",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "က်ဥ္ကာအဆင့္ 1",
  TXT_ITEM_VEST2: "က်ဥ္ကာအဆင့္ 2",
  TXT_ITEM_VEST3: "က်ဥ္ကာဆင့္ 3",
  TXT_ITEM_VSS: "USP",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "ယွဥ္ၿပိဳင္မႈရလဒ္",
  TXT_MESSAGEBOX_ERROR: "မွားယြင္းခ်က္",
  TXT_OB10_HQW_ITEM_BIPOD: "Bipod",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "ဆီတိုင္ကီ",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "ခေရဇီသတ္ျဖတ္သူ",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Mexican Grilled Corn",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "ေပါက္ကြဲမႈအကြာအေဝး",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "The Executioner",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "မိုင္း",
  TXT_OB11_HQW_LANDMINE_DESC: "ေျမေပၚမွာေထာင္ေခ်ာက္ဆင္နိုင္တဲ့ဗုံး။",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "လက္ခုပ္တီး",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "ဒပ္အကြက္",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "ကတက္ ကတက္",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "ေဟ့ေကာင္ေတြ!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "ဟားးးး",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "ေပ်ာ့လိုက္တာ",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "ေသနတ္တင္ေဆာင္လာေသာအခါ ပိုမိုျမန္ဆန္စြာေရႊ႕ျခင္း {0}",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "လက္ေျဖာင့္သူ",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "SCAR - Yellow Puma",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "SCAR - TOP GAMER",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "ျပဳျပင္ေရးေသတၱာ",
  TXT_OB5_HISTORY_HEADSHOOT: "ေခါင္းပစ္ခ်က္",
  TXT_OB5_HISTORY_LIVE: "လြတ္ေျမာက္ျခင္း",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maxim",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "မိႈးစာခိ်န္ႏွင့္ေဆးေသတၱာသံုးခ်ိန္ {0}%တိုးျမွင့္",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "အစားပုတ္",
  TXT_OB7_ZC_CLAN_NICKNAME: "နာမည္ေျပာင္",
  TXT_OB7_ZJS_HISTORY_TIME: "အခ်ိန္",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "မီးပုံ",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "မိုးေကာင္းကင္",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Kla",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "လက္သီးဒါေမ့ခ်္ {0}% တိုး",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "ထိုင္းလက္ေ၀ွ့",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "AWM - Purple Meadows",
  TXT_OB8_ZXR_G18_CAMO_NAME: "G18 - Atom Splitter",
  TXT_OB8_ZXR_M249_CAMO_NAME: "M249 - Withered",
  TXT_OB8_ZXR_M79_CAMO_NAME: "M79 - Skysplitter",
  TXT_OB8_ZXR_USP_CAMO_NAME: "USP - Snow Leopard က",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "လက္ေမာင္း-ညိွႏိွဳင္း",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "ၾကယ္အစိမ္း",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "အိုက္စ္ေဝါ",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "AK47 - Digital Camo",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "ေသြးမာရီီ",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Desert Hunter",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "GROZA- Electric Shock",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "M1014 - Galactic Wyvern",
  TXT_OB9_ZXR_M14_CAMO_NAME: "M14 - Colour Bits",
  TXT_OB9_ZXR_M1873_NAME: "M1873 - Sapphire Blue",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "MACHETE - Swordfish",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "MP5 - Emerald Green",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "SCAR - Purple Quartz",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "SKS - Earthen Military",
  TXT_OPTION_HIGH_BRIGHTNESS: "ေတာက္ပသည္",
  TXT_PLAYER_RANK: "အဆင့့္",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "ဘာျမဴဒါ",
  TXT_SETTING_CHANGEWEAPON: "Quick Weapon Switch Button",
  TXT_SETTING_OB4_NOTREAL: "ေမွာင္",
  TXT_SKILL_DESC_COP: "က်ည္ကာခံႏိုင္ရည္အားနည္းမွဳ {0}% က်ဆင္း",
  TXT_SKILL_DESC_RUNNER: "တာတိုၿပိဳင္ပြဲျမန္ႏႈန္း {0}% အထိတိုးလာ",
  TXT_SKILL_NAME_COP: "သံခ်ပ္ကြ်မ္းက်င္သူ",
  TXT_SKILL_NAME_NURSE: "ကုစားေပးသူ",
  TXT_SKILL_NAME_RACERGIRL: "အနိုင္မခံအရံႈးမေပး",
  TXT_SKILL_NAME_RUNNER: "ဇွဲကြီးသူ",
  TXT_SKILL_NAME_SEAMAN: "သံမဏိလူသား",
  TXT_TUTORIAL_HUD: "HUD",
  TXT_TUTORIAL_HUD_LABEL10: "အျမန္္ေျပး",
  TXT_TUTORIAL_PICKUP_LABEL0: "လက္နက္",
  T_34_M_WS_VFXTYPE: "VFX အမျိုးအစား",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "ထိုးစစ်ဆင်ရေး အကွက်",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "ကစားသမား UI အမျိုးအစား",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "သတ္တဝါ ကျွမ်းကျင်မှု အမျိုးအစား",
  T_45_META_WS_DESCRIPTIVECOLOR: "Descriptive Color",
  T_45_META_WS_GAMETIME: "Game Time",
  T_45_META_WS_PROPERTY: "Property",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "ခလုတ်ဒီဇိုင်းအမျိုးအစား",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "ခလုတ်အမျိုးအစား",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "အရှိန်",
  T_46_META_WS_A_ACCOUNTID: "အကောင့် ID",
  T_46_META_WS_A_ACTIONTYPE: "လှုပ်ရှားမှုအမျိုးအစား",
  T_46_META_WS_A_ACTIVE: "လှုပ်ရှားနေသည်",
  T_46_META_WS_A_ANGLE: "ထောင့်",
  T_46_META_WS_A_ANY: "တစ်ခုခု",
  T_46_META_WS_A_APPEARANCEGROUP: "အမြင်အဖွဲ့",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "အခိုင်အမာဖော်ပြချက်",
  T_46_META_WS_A_ATTACHMENT: "တပ်ဆင်ခြင်း",
  T_46_META_WS_A_ATTACHMENTS: "တပ်ဆင်ခြင်းစာရင်း",
  T_46_META_WS_A_ATTACKABLE: "တိုက်ခိုက်နိုင်",
  T_46_META_WS_A_ATTACKER: "တိုက်ခိုက်သူ",
  T_46_META_WS_A_ATTACKTARGET: "တိုက်ခိုက်မှုပစ်မှတ်",
  T_46_META_WS_A_AUTOPLAY: "အလိုအလျောက်ကစားပါ",
  T_46_META_WS_A_AXIS: "ဝင်ရိုး",
  T_46_META_WS_A_B: "ခ",
  T_46_META_WS_A_BASE: "အခြေခံ",
  T_46_META_WS_A_BOUNDTARGET: "ချိတ်ဆက်ထားသောအထည်",
  T_46_META_WS_A_BTREE: "အပြုအမူပင်",
  T_46_META_WS_A_BUFF: "အားပြင်းခြင်း",
  T_46_META_WS_A_CAMERA: "ကင်မရာ",
  T_46_META_WS_A_CAPICITY: "စွမ်းရည်",
  T_46_META_WS_A_CENTER: "စင်တာ",
  T_46_META_WS_A_CHANGEROTATION: "လှည့်ပတ်မှုကို ပြောင်းပါ",
  T_46_META_WS_A_CHANNEL: "လက်ပံတန်း",
  T_46_META_WS_A_CHASEENEMY: "ရန်သူကိုလိုက်ပါ",
  T_46_META_WS_A_CHILD: "ကလေး",
  T_46_META_WS_A_COLOR: "အရောင်",
  T_46_META_WS_A_COLUMN: "ကော်လံ",
  T_46_META_WS_A_COLUMNNAME: "ကော်လံအမည်",
  T_46_META_WS_A_COMEBACK: "ပြန်လာသည်",
  T_46_META_WS_A_COMPONENT: "အစိတ်အပိုင်း",
  T_46_META_WS_A_CONTENT: "အကြောင်းအရာ",
  T_46_META_WS_A_COORDINATESYSTEM: "ကိုဩဒိနိတ်စနစ်",
  T_46_META_WS_A_COUNT: "ရေတွက်ပါ။",
  T_46_META_WS_A_COUNTS: "အရေအတွက်",
  T_46_META_WS_A_CREATEDENTITY: "ဖန်တီးထားသည့်အရာ",
  T_46_META_WS_A_CROSSPLATFORM: "အပလက်ဖောင်းကျော်",
  T_46_META_WS_A_CULLINGMASK: "ကာလင်မတ်",
  T_46_META_WS_A_CURVE: "ကြောင်းသား",
  T_46_META_WS_A_CUSTOMTAG: "ထုံးစံအမှတ်အသား",
  T_46_META_WS_A_CUTRADIUS: "အချင်းဝက်ကိုဖြတ်ပါ။",
  T_46_META_WS_A_DAMAGE: "ပျက်စီးခြင်း။",
  T_46_META_WS_A_DAMAGESEGMENTS: "ခံရမှုပိုင်း",
  T_46_META_WS_A_DEGREE: "ဘွဲ့",
  T_46_META_WS_A_DELTA: "ဒဲလ်တာ",
  T_46_META_WS_A_DEPTH: "အနက်",
  T_46_META_WS_A_DESTVAL: "နောက်ဆုံးတန်ဖိုး",
  T_46_META_WS_A_DIFFICULTY: "ခက်ခဲမှု",
  T_46_META_WS_A_DIRECTION: "ဦးတည်ချက်",
  T_46_META_WS_A_DISABLE: "ပိတ်ထားသည်",
  T_46_META_WS_A_DISPLACEMENT: "ရွေ့လျားမှု",
  T_46_META_WS_A_DISTANCE: "အကွာအဝေး",
  T_46_META_WS_A_DIVINGMAXSPEED: "တင်းချုပ်အမြင့်ဆုံးအနက်",
  T_46_META_WS_A_DOTWEEN: "တွင်းလုပ်ပါ",
  T_46_META_WS_A_DURATION: "ကြာချိန် (များ)",
  T_46_META_WS_A_EMOTE: "Emote",
  T_46_META_WS_A_ENABLE: "ဖွင့်ပါ။",
  T_46_META_WS_A_ENDAREACENTER: "အဆုံးအထုပ်အလယ်",
  T_46_META_WS_A_ENDAREARANGE: "အဆုံးအထုပ်ကန့်သတ်",
  T_46_META_WS_A_ENDPOSITION: "အဆုံးအနေအထား",
  T_46_META_WS_A_ENDRANK: "အဆုံးအဆင့်",
  T_46_META_WS_A_EQUIPMENTS: "ပစ္စည်းများ",
  T_46_META_WS_A_EVENTID: "ပွဲ ID",
  T_46_META_WS_A_EXPONENT: "သင်္ချာ",
  T_46_META_WS_A_FACTION: "အဖွဲ့အစည်း",
  T_46_META_WS_A_FACTORTYPE: "FactorType",
  T_46_META_WS_A_FILTERTYPE: "Filter အမျိုးအစား",
  T_46_META_WS_A_FINALRADIUS: "စတင်ညွှန်းကိန်း ",
  T_46_META_WS_A_FINDVALUE: "တန်ဖိုးကိုရှာပါ။",
  T_46_META_WS_A_FIXEDRANGE: "အတိအကျအကွာအဝေး",
  T_46_META_WS_A_FOLLOWTARGET: "ပစ်မှတ်ကို လိုက်နာပါ။",
  T_46_META_WS_A_FONTCOLOR: "ဖောင့်အရောင်",
  T_46_META_WS_A_FONTSIZE: "ဖောင့်အရွယ်အစား",
  T_46_META_WS_A_FOOTBALL: "ဘောလုံး",
  T_46_META_WS_A_FORCE: "အင်အား",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "အပြုံးမှီအမြင့်",
  T_46_META_WS_A_FORCEMODE: "အင်အား Mode",
  T_46_META_WS_A_FORWARD: "ရှေ့သို့",
  T_46_META_WS_A_G: "ဆ",
  T_46_META_WS_A_GAMEID: "ဂိမ်း ID",
  T_46_META_WS_A_HALFEXTENTS: "တစ်ဝက်ပမာဏ",
  T_46_META_WS_A_HEIGHT: "အရပ်အမြင့်",
  T_46_META_WS_A_HEIGHTSEGMENTS: "အမြင့်ပိုင်း",
  T_46_META_WS_A_HITDISTANCE: "ထိခိုက်သောအကွာအဝေး",
  T_46_META_WS_A_HITDISTANCES: "အကွာအဝေးထိမှန်",
  T_46_META_WS_A_HITENTITIES: "တိုက်ခံရသောအရာများ",
  T_46_META_WS_A_HITENTITY: "လုံးဝထိ",
  T_46_META_WS_A_HITNORMAL: "ထိခိုက်သောနား",
  T_46_META_WS_A_HITNORMALS: "သဘာဝအချက်များ",
  T_46_META_WS_A_HITPOINTS: "ထိမှန်ချက်များ",
  T_46_META_WS_A_HITPOSITION: "ထိခိုက်သောနေရာ",
  T_46_META_WS_A_INCLUDETRIGGER: "ခလုတ်ကိုပါဝင်ပါ",
  T_46_META_WS_A_INDEX: "အညွှန်း",
  T_46_META_WS_A_INDEXS: "အညွှန်းများ",
  T_46_META_WS_A_INITIALVELOCITY: "စတင်အမြန်နှုန်း",
  T_46_META_WS_A_INITRADIUS: "ကနဦး အချင်းဝက်",
  T_46_META_WS_A_INWALLET: "InWallet",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "အောက်တိုက် ",
  T_46_META_WS_A_ISEXIST: "ရှိပြီးသား",
  T_46_META_WS_A_ISLOOP: "ပြန်လှည့်ခြင်း",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "စခရင်တွင်မိန့်ထားသလား",
  T_46_META_WS_A_ISPAUSE: "ခေတ္တရပ်သည်။",
  T_46_META_WS_A_ISSIDECOLLIDING: "ဘက်စုံ တိုက်ခိုက်မှု",
  T_46_META_WS_A_ISSUCCESS: "အောင်မြင်မှုလား။",
  T_46_META_WS_A_ISTOPCOLLIDING: "အပေါ်တိုက် ",
  T_46_META_WS_A_ITEM: "ကုသိုလ်ကံ",
  T_46_META_WS_A_ITEMID: "ပစ္စည်း ID",
  T_46_META_WS_A_ITEMS: "ပစ္စည်းများ",
  T_46_META_WS_A_ITEMTYPE: "ပစ္စည်းအမျိုးအစား",
  T_46_META_WS_A_JERSEYTYPE: "ဂျာစီအမျိုးအစား",
  T_46_META_WS_A_KEEPVELOCITY: "အမြန်နှုန်းထိန်းသိမ်းထားပါ",
  T_46_META_WS_A_KEY: "သော့",
  T_46_META_WS_A_KEYCOLUMN: "ကီးကော်လံ",
  T_46_META_WS_A_KEYS: "သော့များ",
  T_46_META_WS_A_LAYER: "အဆင့်",
  T_46_META_WS_A_LAYERMASK: "အလွှာ Mask",
  T_46_META_WS_A_LEFT: "ဝဲ",
  T_46_META_WS_A_LEFTVALUE: "လက်ဝဲတန်ဖိုး",
  T_46_META_WS_A_LENGTH: "အရှည်",
  T_46_META_WS_A_LEVELOBJECT: "အဆင့်အရာဝတ္ထု",
  T_46_META_WS_A_LOG: "မှတ်တမ်း",
  T_46_META_WS_A_LOOKATTARGET: "အကွာအဝေးကိုကြည့်ပါ",
  T_46_META_WS_A_LOOPTYPE: "ပြန်လှည့်ခြင်းအမျိုးအစား",
  T_46_META_WS_A_MAINCOLOR1: "အဓိကအရောင်1",
  T_46_META_WS_A_MAINCOLOR2: "အဓိကအရောင်2",
  T_46_META_WS_A_MAPCODE: "မြေပုံကုဒ်",
  T_46_META_WS_A_MAPPEDPOSITION: "မိန့်ထားသောအနေအထား",
  T_46_META_WS_A_MAX: "မက်တယ်။",
  T_46_META_WS_A_MAXDISPLACEMENT: "အများဆုံးရွေ့လျားမှု",
  T_46_META_WS_A_MAXDISTANCE: "အများဆုံးအကွာအဝေး",
  T_46_META_WS_A_MIN: "မင်း",
  T_46_META_WS_A_MISSIONID: "မစ်ရှင် ID",
  T_46_META_WS_A_MISSIONPROGRESS: "MissionProgress",
  T_46_META_WS_A_MODIFYTYPE: "ModifyType",
  T_46_META_WS_A_MONEYTYPE: "ငွေအမျိုးအစား",
  T_46_META_WS_A_MUST: "ဖြစ်ရမယ်။",
  T_46_META_WS_A_NAME: "အမည်",
  T_46_META_WS_A_NEWVALUE: "တန်ဖိုးအသစ်",
  T_46_META_WS_A_NODE: "နိုတ်",
  T_46_META_WS_A_NORMAL: "ပုံမှန်",
  T_46_META_WS_A_NOT: "မဟုတ်ဘူးလား။",
  T_46_META_WS_A_OBSERVER: "စောင့်ကြည့်သူ",
  T_46_META_WS_A_OFFSET: "နှိမ်သည်။",
  T_46_META_WS_A_OLDVALUE: "တန်ဖိုးဟောင်း",
  T_46_META_WS_A_OPERATIOMETHOD: "လုပ်ငန်းစဉ်",
  T_46_META_WS_A_OPTIONS: "ရွေးချယ်စရာ",
  T_46_META_WS_A_OTHERCOLOR: "အခြားအရောင်",
  T_46_META_WS_A_OUTFIT: "ဝတ်စုံ",
  T_46_META_WS_A_OUTFITS: "ဝတ်စုံစာရင်း",
  T_46_META_WS_A_OUTWALLET: "ပိုက်ဆံအိတ်ထဲက",
  T_46_META_WS_A_OWNER: "ပိုင်ရှင်",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "မျက်စိမြင်အမြင့်ဆုံးအနက်",
  T_46_META_WS_A_PARAMS: "ဘောင်များ",
  T_46_META_WS_A_PARENT: "မိဘ",
  T_46_META_WS_A_PARENTWIDGET: "မိဘ Widget",
  T_46_META_WS_A_PATH: "လမ်းကြောင်း",
  T_46_META_WS_A_PATHPOINTS: "လမ်းကြောင်းအချက်အလက်",
  T_46_META_WS_A_PHASEINDEX: "အဆင့်အညွှန်း",
  T_46_META_WS_A_PLATFORM: "အပလက်ဖောင်း",
  T_46_META_WS_A_PLAYER: "ကစားသမား",
  T_46_META_WS_A_PLAYSPEED: "ကစားနှုန်း",
  T_46_META_WS_A_POSITION: "ရာထူး",
  T_46_META_WS_A_POSITIONS: "ရာထူးများ",
  T_46_META_WS_A_POSTION: "ရာထူး",
  T_46_META_WS_A_PREFAB: "ပြင်ဆင်မှု",
  T_46_META_WS_A_PROPERTY: "ပစ္စည်းဥစ္စာ",
  T_46_META_WS_A_PROPERTYID: "PropertyID",
  T_46_META_WS_A_PURSUITTARGET: "ရည်မှန်းချက်ပန်းတိုင်",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "အချင်းဝက်",
  T_46_META_WS_A_RANDOMDECAY: "မတော်တဆကျဆင်းမှု",
  T_46_META_WS_A_RANDOMRANGE: "စံနစ်",
  T_46_META_WS_A_RANDOMRATIO: "မတော်တဆအချိုး",
  T_46_META_WS_A_RANGE: "အကွာအဝေး",
  T_46_META_WS_A_RANK: "အဆင့်",
  T_46_META_WS_A_REALCOIN: "အမှန်တကယ်ငွေ",
  T_46_META_WS_A_REALNUMBER: "တိကျသောအမှတ်",
  T_46_META_WS_A_RESET: "ပြန်လည်စတင်ပါ",
  T_46_META_WS_A_RESOURCE: "အရင်းအမြစ်",
  T_46_META_WS_A_RESULT: "ရလဒ်",
  T_46_META_WS_A_RIGHT: "မှန်တယ်။",
  T_46_META_WS_A_RIGHTVALUE: "မှန်ကန်သောတန်ဖိုး",
  T_46_META_WS_A_ROTATION: "အလှည့်",
  T_46_META_WS_A_ROW: "အတန်း",
  T_46_META_WS_A_SAMPLEPOINT: "နမူနာအချက်",
  T_46_META_WS_A_SCALE: "အတိုင်းအတာ",
  T_46_META_WS_A_SCENEID: "SceneID",
  T_46_META_WS_A_SCORE: "အမှတ်",
  T_46_META_WS_A_SCORENAME: "အမှတ်အမည်",
  T_46_META_WS_A_SCREENPOSITION: "စခရင်အနေအထား",
  T_46_META_WS_A_SCRIPT: "စကရစ်",
  T_46_META_WS_A_SEAT: "အထိုင်",
  T_46_META_WS_A_SEP: "စက်တင်ဘာ",
  T_46_META_WS_A_SEPSTR: "ခွဲထုတ်ခြင်း။",
  T_46_META_WS_A_SHEETNAME: "စာရွက်အမည်",
  T_46_META_WS_A_SHOPITEM: "ဆိုင်ပစ္စည်း",
  T_46_META_WS_A_SHOWBACKGROUND: "နောက်ခံပြပါ",
  T_46_META_WS_A_SHOWMATCHRESULT: "ဂိမ်းရလဒ်ပြပါ",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "ဖျက်မည့်အချိန်တွင်စာမူပြပါ",
  T_46_META_WS_A_SKILL: "ကျွမ်းကျင်မှု",
  T_46_META_WS_A_SKILLS: "ကျွမ်းကျင်မှု",
  T_46_META_WS_A_SKILLTARGET: "ကျွမ်းကျင်မှုရည်မှန်းချက်",
  T_46_META_WS_A_SKIN: "အလှပျို",
  T_46_META_WS_A_SLOT: "အထိုင်",
  T_46_META_WS_A_SRCVAL: "မူလတန်ဖိုး",
  T_46_META_WS_A_SRCVALUE: "မူရင်းတန်ဖိုး",
  T_46_META_WS_A_STARTAREACENTER: "စတင်အထုပ်အလယ်",
  T_46_META_WS_A_STARTAREARANGE: "စတင်အထုပ်ကန့်သတ်",
  T_46_META_WS_A_STARTINDEX: "ခွဲကာ ",
  T_46_META_WS_A_STARTPOSITION: "စတင်ရာထူး",
  T_46_META_WS_A_STARTRANK: "စတင်အဆင့်",
  T_46_META_WS_A_STATE: "အခြေအနေ",
  T_46_META_WS_A_STATUS: "အဆင့်အတန်း",
  T_46_META_WS_A_STATUSCODE: "အခြေအနေကုဒ်",
  T_46_META_WS_A_STYLE: "စတိုင်",
  T_46_META_WS_A_SURFINGMAXSPEED: "စားဖွယ်အမြင့်ဆုံးအနက်",
  T_46_META_WS_A_TARGET: "ပစ်မှတ်",
  T_46_META_WS_A_TARGETPOSITION: "ပစ်မှတ်အနေအထား",
  T_46_META_WS_A_TEAMSEQ: "အသင်းအစီအစဉ်",
  T_46_META_WS_A_THRESHOLD: "စည်းကမ်းများ",
  T_46_META_WS_A_TIMESTAMP: "အချိန်တံဆိပ်",
  T_46_META_WS_A_TIPS: "အကြံပြုချက်များ",
  T_46_META_WS_A_TITLE: "ခေါင်းစဉ်",
  T_46_META_WS_A_TOKENCOUNT: "တိုကင်အရေအတွက်",
  T_46_META_WS_A_TOKENID: "တိုကင် ID",
  T_46_META_WS_A_TORQUE: "တိုးမြှင့်မှု",
  T_46_META_WS_A_TOUCHPOINT: "ထိတွေ့ရာအချက်",
  T_46_META_WS_A_TRANSITIONTIME: "အပြောင်းအလဲအချိန် (ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "အပြောင်းအလဲအမျိုးအစား",
  T_46_META_WS_A_TRIGGER: "အစပျိုးသည်။",
  T_46_META_WS_A_TYPE: "ရိုက်ပါ။",
  T_46_META_WS_A_UI: "UI",
  T_46_META_WS_A_UIID: "UI ID",
  T_46_META_WS_A_UPWARD: "အပေါ်",
  T_46_META_WS_A_VALUE: "တန်ဖိုး",
  T_46_META_WS_A_VALUEA: "ValueA",
  T_46_META_WS_A_VALUEB: "တန်ဖိုးB",
  T_46_META_WS_A_VALUES: "တန်ဖိုးများ",
  T_46_META_WS_A_VALUET: "တန်ဖိုး T",
  T_46_META_WS_A_VALUETYPE: "တန်ဖိုးအမျိုးအစား",
  T_46_META_WS_A_VEHICLE: "ယာဉ်",
  T_46_META_WS_A_VEHICLESKIN: "ယာဉ်အလှပျို",
  T_46_META_WS_A_VELOCITY: "အမြန်နှုန်း",
  T_46_META_WS_A_VELOCITYXZ: "XZ သွေးအမျိုးအစား",
  T_46_META_WS_A_VELOCITYY: "Y သွေးအမည်းအမျိုးအစား",
  T_46_META_WS_A_VISIBLE: "မြင်သာ",
  T_46_META_WS_A_WAITTIME: "စောင့်ချိန် (၎)",
  T_46_META_WS_A_WALLET: "ပိုက်ဆံအိတ်",
  T_46_META_WS_A_WEAPON: "လက်နက်",
  T_46_META_WS_A_WEAPONSKIN: "လက်နက်အသားအရ",
  T_46_META_WS_A_WIDGETID: "ဝစ်ဂျက် ID",
  T_46_META_WS_A_WIDGETTYPE: "Widget အမျိုးအစား",
  T_46_META_WS_A_WIDTH: "အကျယ်",
  T_46_META_WS_A_WORLDPOSITION: "ကမ္ဘာ့အနေအထား",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "ကမ္ဘာ့တည်နေရာကို ထိန်းသိမ်းထားသည်",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "အခင်းဖြတ်ထုတ်ခြင်း",
  T_46_META_WS_ACOS: "စမ်းသပ်မဟုတ်သောအခြေအနေ",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "ဖျက်မှုနဲ့ဖျက်သည်",
  T_46_META_WS_ADDATTACHMENTS: "ဆက်စပ်ပစ္စည်းထည့်",
  T_46_META_WS_ADDBUFF: "Buff ထည့်",
  T_46_META_WS_ADDCOMPONENT: "တိုးချ ထားမှု",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "ဘောလုံးအမြန်နှုန်းထည့်ပါ",
  T_46_META_WS_ADDFORCE: "တည်နေရာတွင်အားထည့်",
  T_46_META_WS_ADDFORCEATPOSITION: "ခေါင်းချွတ်",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "ရုပ်ပြသရုပ်ပွဲအထူးဓာတ်ခွဲပေါင်းထည့်ပါ",
  T_46_META_WS_ADDGAMEEVENTLOG: "ဂိမ်းဖြစ်ရပ်မှတ်တမ်းထည့်",
  T_46_META_WS_ADDHP: "လုပ်ဆောင်နေတဲ့ထိရောက်မှု",
  T_46_META_WS_ADDITEM: "အရာဝတ္ထုထည့်သွင်းခြင်း",
  T_46_META_WS_ADDITEMINSCENE: "ရေးဖြစ်ထွန်းထားသောရယူမှု",
  T_46_META_WS_ADDITEMTOSHOPITEM: "ပစ္စည်းကိုပစ္စည်းထဲတွင်ထည့်ပါ",
  T_46_META_WS_ADDMONEY: "ငွေထည့်ပါ",
  T_46_META_WS_ADDSCRIPT: "စာမူထည့်ပါ",
  T_46_META_WS_ADDTAG: "အမှတ်အသားထည့်ပါ",
  T_46_META_WS_ADDTOKEN: "Token ပေါင်းထည့်ခြင်း",
  T_46_META_WS_ADDTORQUE: "CCT ရွေ့ပြောင်း",
  T_46_META_WS_ADDUSEREVENTLOG: "အသုံးပြုမှတ်တမ်းထည့်",
  T_46_META_WS_ANGEL: "ကိရိယာထည့်ပြီးပြီးစီးမှု",
  T_46_META_WS_APPEND: "စာရင်းထဲတွင်ထည့်ခြင်း",
  T_46_META_WS_APPENDRANGE: "ပေါင်းထည့်ချက်များ",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "စမ်းသပ်မှတ်တမ်းတင်",
  T_46_META_WS_ASIN: "အခင်းဖြတ်ထုတ်ကိရိယာများ",
  T_46_META_WS_ASSERT: "သက်သေပြရန်",
  T_46_META_WS_ASSISTPLAYER: "ကူညီသူကစားသမား",
  T_46_META_WS_ATAN2: "အစိတ်အပိုင်း ဖြုတ်ချ",
  T_46_META_WS_ATTACKER: "ကျူးလွန်သူ",
  T_46_META_WS_ATTACKTARGET: "တိုက်ခိုက်ရန်ရည်ရွယ်ချက်",
  T_46_META_WS_AXISANGLETOQUATERNION: "ကွာတွန်းမှ သံချပ်",
  T_46_META_WS_BOXCAST: "သုံးချက်စမ်းချက်",
  T_46_META_WS_BOXOVERLAP: "ဂြိုဟ်ကျောစွန်း",
  T_46_META_WS_BUTTONNAME: "ခလုတ်အမည်",
  T_46_META_WS_C_ACTIONTYPE: "လှုပ်ရှားမှုအမျိုးအစား",
  T_46_META_WS_C_AIMABLE: "ငါတို့များ၏ဗဟိုအရည်အချင်း",
  T_46_META_WS_C_AIMASSISTABLE: "များကို ရေစစ်ပေးသော ပစ္စည်း",
  T_46_META_WS_C_AIMASSISTTYPE: "ဂီယာ အကူအညီ အမျိုးအစား",
  T_46_META_WS_C_AIRDROP: "လေတိုက်သို့မဟုတ်ပစ်စည်း",
  T_46_META_WS_C_AMMO: "Ammunition",
  T_46_META_WS_C_AMMOTYPE: "ပစ္စည်း အမျိုးအစား",
  T_46_META_WS_C_AMPHIBIAN: "လှုပ်ရှားနိုင်သော မိုတော်ကား",
  T_46_META_WS_C_ANIMATIONCLIP: "အပြုံးဗွီဒီယို",
  T_46_META_WS_C_ANIMATIONCLIPID: "အန်နီမေးရှင်း ကလစ် ID",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "အပြုံးထိန်းချုပ်သူ",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "အနိမ့်မှကြိုတင်ထည့်စရာ အစိတ်အပိုင်း",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "အန်နီမေးရှင်းထိန်းချုပ်သူ ID",
  T_46_META_WS_C_ANIMATIONSTATE: "အပြုံးအခြေအနေ",
  T_46_META_WS_C_ANIMATIONTRIGGER: "အနာဂတ်ပြောင်းဖျက်ရန်",
  T_46_META_WS_C_APPEARENCE: "အထင်အမြင်",
  T_46_META_WS_C_ASSETCONFIGID: "အက်ဆက်ဖွဲ့စည်းမှု ID",
  T_46_META_WS_C_ASSETID: "အက်ဆက် ID",
  T_46_META_WS_C_ATTACHMENT: "ဖက်စပ်",
  T_46_META_WS_C_ATTACKABLETYPE: "တိုက်နိုင်သော အမျိုးအစား",
  T_46_META_WS_C_AUDIOID: "အသံ ID",
  T_46_META_WS_C_BACKPACK: "ချစ်ကြိုး",
  T_46_META_WS_C_BACKPACKSKINID: "ကျောပိုးအိတ်အသားထည် ID",
  T_46_META_WS_C_BASEDATAALIAS: "အခြေခံဒေတာနာမည်",
  T_46_META_WS_C_BASICAPPEARANCE: "အခြေခံ ရုပ်ထွက်",
  T_46_META_WS_C_BASICCYLINDER: "အခြေခံ စာရွက်သွယ်ပုံ",
  T_46_META_WS_C_BASICSCALABLE: "အခြေခံ များစွာ အပြောင်းအလဲ",
  T_46_META_WS_C_BASICSPHERE: "အခြေခံ ဘောလုံးပုံ",
  T_46_META_WS_C_BATCHCOMBINERENDER: "ဘတ်ခ်စ်ပွဲတင်",
  T_46_META_WS_C_BEVTREE: "အပြုအမူ သစ်",
  T_46_META_WS_C_BEVTREEATTACHABLE: "အပြုအမူ သစ် ဆက်စပ်နိုင်သည်",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "အပြုအမူ သစ် စိတ်ကြိုက် အဆင့်များ",
  T_46_META_WS_C_BEVTREEID: "အပြုအမူ သစ် ID",
  T_46_META_WS_C_BEVTREENODESTATUS: "အပြုအမူ သစ် အဆင့် အခြေအနေ",
  T_46_META_WS_C_BEVTREENODETYPE: "အပြုအမူ သစ် အဆင့်များ အမျိုးအစား",
  T_46_META_WS_C_BEZIERCURVE: "ဘီဇီယာကိုတ်",
  T_46_META_WS_C_BOOL: "ဘူးလ်",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "ဘော့အခက်အခဲအမျိုးအစား",
  T_46_META_WS_C_BOUNCINGTIRE: "ဂရိတ်လမ်းကြောင်းကွာတာ",
  T_46_META_WS_C_BUFFABLE: "버프 가능",
  T_46_META_WS_C_BUFFGENERATOR: "Buff ထုတ်လုပ်သူ",
  T_46_META_WS_C_BUFFTYPE: "Lead1 ဂီတ အမျိုးအစား",
  T_46_META_WS_C_BUILTINRENDER: "ပေါင်းစပ် ရေဒါ",
  T_46_META_WS_C_BUILTINUI: "အထည်ချိန်ထားသော UI",
  T_46_META_WS_C_BUILTINUITYPE: "အထည်ချိန်ထားသော UI အမျိုးအစား",
  T_46_META_WS_C_CAMERA: "ကင်မရာ",
  T_46_META_WS_C_CAMERABLOCKMODE: "ကင်မရာ ပိတ်ပင်မှု နည်းစနစ်",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "ကင်မရာ ပရောဂျက်ရှင်းမှု နည်းစနစ်",
  T_46_META_WS_C_CAMERARAYCASTUI: "ကင်မရာ RayCast UI",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "ကင်မရာ လွှဲပြောင်းအမျိုးအစား",
  T_46_META_WS_C_CAMERATYPE: "ကင်မရာ အမျိုးအစား",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "ကင်မရာရင့်ရှုထောင့်ကန့်သတ်ခြင်းအမျိုးအစား",
  T_46_META_WS_C_CAPSULETRIGGER: "ကပ်စဉ်ထိန်း",
  T_46_META_WS_C_CAR: "ကား",
  T_46_META_WS_C_CHARACTERCONTROLLER: "ပုဂ္ဂိုလ်အတွင်းသွားတတ်",
  T_46_META_WS_C_CHATCHANNEL: "စကားပြောချန်နယ်",
  T_46_META_WS_C_CHATCHANNELTYPE: "စကားပြောချန်နယ် အမျိုးအစား",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "အဆုံးသတ်ပစ္စည်း",
  T_46_META_WS_C_COINGENERATOR: "ငွေသား ထုတ်လုပ်သူ",
  T_46_META_WS_C_COLLECTIONID: "အစုစု ID",
  T_46_META_WS_C_COLLIDER: "ချုပ်ထားပစ္စည်း",
  T_46_META_WS_C_COLLIDERCOLLECTION: "ကွဲသွားမည့်ပုံစံ",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "ကော်လိုက်ဒါစုဆောင်းမှု ID",
  T_46_META_WS_C_COLORDRUM: "အရောင်တရား",
  T_46_META_WS_C_COMBATABLE: "전투 가능",
  T_46_META_WS_C_COMPONENT: "အစိတ်အပိုင်း",
  T_46_META_WS_C_CONDITION: "အခြေအနေနှင့်",
  T_46_META_WS_C_CONTAINER: "ကွန်ထုပ်",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "ဂဏန်းစနစ်",
  T_46_META_WS_C_CROSSBOW: "ဂရေနစ် ချိတ်ဆက်",
  T_46_META_WS_C_CSVID: "CSV အိုင်ဒီ",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "သေဆုံးခြင်း သို့မဟုတ် မထိခိုက်နိုင်ခြင်း",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "အထူးသီးသန့် အရာ",
  T_46_META_WS_C_CUSTOMPATH: "အထူးပြု လမ်းကြောင်း",
  T_46_META_WS_C_CUSTOMUI: "ကိုယ်ရေးကိုယ်တာ UI",
  T_46_META_WS_C_CUSTOMUIID: "ID-ul UI Personalizat",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "ရိုးရှင်းသောဝစ်ဂျက်",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "အထူး UI ဝစ်ဂျက် ID",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "ချိုးယွင်းသောခန္ဓာကိုယ်အပိုင်းအမျိုးအစား",
  T_46_META_WS_C_DAMAGETYPE: "ဒဏ်ရာ အမျိုးအစား",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "လက်မှတ်စစ်ဆေး",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "ပျက်စီးနိုင်သောအရာ",
  T_46_META_WS_C_DICE: "ဂရိတ်",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "နှစ်လွှတ်ဘွဲ့",
  T_46_META_WS_C_DRUMMUSIC: "မျက်နှာပြင် ဂီတ",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "တစ်ကြိမ်တည်း လက်ဝါးပတ် အမျိုးအစား",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "အထွေထွေ အဆင့်အရာ",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "အပြောင်းအလဲဖြင့် ဖန်တီးနိုင်သော အရာ အမျိုးအစား",
  T_46_META_WS_C_DYNAMICFENCE: "သုံးစွဲသောကုန်ပစ္စည်း",
  T_46_META_WS_C_EFFECT: "ထိရောက်မှု",
  T_46_META_WS_C_EFFECTCONTAINER: "Buff အမျိုးအစား",
  T_46_META_WS_C_EFFECTID: "အကျိုးသက်ရောက်မှု ID",
  T_46_META_WS_C_EMOTETYPE: "Emote အမျိုးအစား",
  T_46_META_WS_C_ENDPOINTTRIGGER: "အလိုအလျောက် ကွန်မန်",
  T_46_META_WS_C_ENTITY: "အရာ၀တ္ထု",
  T_46_META_WS_C_ENTITYORPREFABID: "အခေါ်အဆိုများ သို့မဟုတ် Prefab ID",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "စက်ပစ္စည်းပစ္စည်း",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "ကိရိယာ စာရင်း အမျိုးအစား",
  T_46_META_WS_C_EQUIPMENTTYPE: "ကိရိယာ အမျိုးအစား",
  T_46_META_WS_C_EVENTID: "အဖြစ်အပျက်အိုင်ဒီ",
  T_46_META_WS_C_FACTION: "တိုင်းရင်းသား",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "ဖြည့်စွက်မှု လမ်းကြောင်း အမျိုးအစား",
  T_46_META_WS_C_FILLTYPE: "ဖြည့်စွက်မှု အမျိုးအစား",
  T_46_META_WS_C_FIRETYPE: "အင်ဂျင် အမျိုးအစား",
  T_46_META_WS_C_FLOAT: "ဖျာငင်ရေစွဲ",
  T_46_META_WS_C_FOLDWING: "ပျံသန်းနိုင်သောအပေါက်",
  T_46_META_WS_C_FOLLOW: "လိုက်နာ",
  T_46_META_WS_C_FONTTYPE: "ဖောင့်အမျိုးအစား",
  T_46_META_WS_C_FOOTBALL: "ကစားသမား",
  T_46_META_WS_C_FORCETYPE: "အာနိသင်အမျိုးအစား",
  T_46_META_WS_C_FORMULABLE: "공식화 가능한",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Frame ကိုယ်တိုင် ဆက်စပ်မှု",
  T_46_META_WS_C_GAMERESULTTYPE: "ဂိမ်းရလဒ် အမျိုးအစား",
  T_46_META_WS_C_GENDERTYPE: "လိင်",
  T_46_META_WS_C_GENERALSPAWNPOINT: "အထွေထွေ မူရင်းထုတ်လွှတ်ခြင်းစမှတ်",
  T_46_META_WS_C_GRENADEDEICEWALL: "အိုင်စအနောက်မှို",
  T_46_META_WS_C_GRENADEFLASHBANG: "မီးထွက်သွားပစ္စည်း",
  T_46_META_WS_C_GRENADEFROZEN: "အအေးရေအာင်",
  T_46_META_WS_C_GRENADELAUNCHER: "ဂရေနစ် လွှတ်ပေးသူ",
  T_46_META_WS_C_GRENADESMOKE: "မီးအုပ်ထား",
  T_46_META_WS_C_GRENADEWEAPON: "ဂရေနစ် အခြေခံ",
  T_46_META_WS_C_GRID: "ဂိမ်းပြန်ကြိုး",
  T_46_META_WS_C_HANDCANNON: "လက်ပတ်သီးဗုံး",
  T_46_META_WS_C_HELMET: "ဦးထုပ်",
  T_46_META_WS_C_HIERARCHICAL: "အဆင့်ဆက်စပ်",
  T_46_META_WS_C_HOOKGUN: "ခေါက်ဘုတ်",
  T_46_META_WS_C_HORIZALINE: "အတိုင်းအတာလိုင်း",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "အထဲက ဝစ်ဂျက်",
  T_46_META_WS_C_HUMANMODELID: "လူသား ပုံစံ ID",
  T_46_META_WS_C_ICEWALL: "ရေခဲတံတား",
  T_46_META_WS_C_ICEWALLCREATED: "ဖန်တီးထားသောရေခဲတံတား",
  T_46_META_WS_C_ICEWALLMAKER: "ပိုက်ဖောက်ကာ မိတ်ဆက်",
  T_46_META_WS_C_ICON: "အိုင်ခေါ်အဖွဲ့",
  T_46_META_WS_C_ICONTYPE: "ဓာတ်ပုံ အမျိုးအစား",
  T_46_META_WS_C_INHALER: "အနက်အင်္ဂါဆေးကွက်",
  T_46_META_WS_C_INT: "အပြုံးနည်း",
  T_46_META_WS_C_INT64: "64-bit အပြုံးနည်း",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "အပြုံးအဆစ်စနစ်",
  T_46_META_WS_C_INTORINTLIST: "အင်တာဂါ သို့မဟုတ် အင်တာဂါ စာရင်း",
  T_46_META_WS_C_INVENTORYTYPE: "စရိတ် စီမံအမျိုးအစား",
  T_46_META_WS_C_ITEMBASE: "ပစ္စည်းအခြေခံ",
  T_46_META_WS_C_ITEMCONTAINER: "아이템 컨테이너",
  T_46_META_WS_C_ITEMID: "အမျိုးအစား ID",
  T_46_META_WS_C_ITEMIDTYPE: "အမျိုးအစား ID",
  "T_46_META_WS_C_JERSEY STYLE": "ဂျပန်လက်အိတ် အမျိုးအစား",
  T_46_META_WS_C_JERSEYMACHINE: "유니폼 교환기",
  T_46_META_WS_C_JETSHOES: "ဂျက်ရှု",
  T_46_META_WS_C_KEYBOARD: "ကီးဘုတ်",
  T_46_META_WS_C_KNOCKDOWNTYPE: "နုတ်ခွာခြင်းအမျိုးအစား",
  T_46_META_WS_C_LANDMINE: "အဖြူရောင်မိုင်း",
  T_46_META_WS_C_LANDMINECREATED: "ဖန်တီးထားသောမိုင်း",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "လွှတ်တင်စက်အဆင့်အရာဝတ္ထု",
  T_46_META_WS_C_LAUNCHPAD: "ပေါင်ဂန်လွှတ်ပေးရာ",
  T_46_META_WS_C_LAYOUTSORTTYPE: "လုပ်ထုံးလုပ်နည်း စီမံခန့်ခွဲမှု အမျိုးအစား",
  T_46_META_WS_C_LEAD1MUSIC: "Lead1 ဂီတ",
  T_46_META_WS_C_LEAD2MUSIC: "Lead2 ဂီတ",
  T_46_META_WS_C_LEAD3MUSIC: "Lead3 ဂီတ",
  T_46_META_WS_C_LEVELOBJECTID: "အဆင့်ရုပ်အစား ID",
  T_46_META_WS_C_LEVELOBJECTTYPE: "အဆင့်ပစ္စည်းအမျိုးအစား",
  T_46_META_WS_C_LIST: "စာရင်း",
  T_46_META_WS_C_LISTORMAP: "စာရင်းသို့မဟုတ် မြေပုံ",
  T_46_META_WS_C_LISTT: "စာရင်း အုပ်စုအမိန့် ID",
  T_46_META_WS_C_LISTT_BOOL: "Boolean List",
  T_46_META_WS_C_LISTT_CONDITION: "အခြေအနေများစာရင်း",
  T_46_META_WS_C_LISTT_ENTITY: "အရာဝတ္ထုစာရင်း",
  T_46_META_WS_C_LISTT_FLOAT: "အလယ်အလတ်စာရင်း",
  T_46_META_WS_C_LISTT_INT: "အင်တာဂါ ID",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "ပစ္စည်းစာရင်း",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "အဆင့် ပစ္စည်း စာရင်း",
  T_46_META_WS_C_LISTT_LOCKEY: "Localization Key List",
  T_46_META_WS_C_LISTT_PLAYABLE: "ပရိုဂရမ်များစာရင်း",
  T_46_META_WS_C_LISTT_PLAYER: "ကစားသမားစာရင်း",
  T_46_META_WS_C_LISTT_SKILLID: "ကျွမ်းကျင်မှုစာရင်း",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "အသံထွက်စာရင်း",
  T_46_META_WS_C_LISTT_STRING: "စာသားစာရင်း",
  T_46_META_WS_C_LISTT_TEAM: "အဖွဲ့စာရင်း",
  T_46_META_WS_C_LISTT_TYPE: "အမျိုးအစားစာရင်း",
  T_46_META_WS_C_LISTT_VECTOR3: "ဗက်တာ၃စာရင်း",
  T_46_META_WS_C_LOCKEY: "လုပ်ငန်းနယ်ပယ်ကီး",
  T_46_META_WS_C_LOOKAT: "ကြည့်ပါ",
  T_46_META_WS_C_LOOPABLE: "반복 가능",
  T_46_META_WS_C_LOOPTYPE: "လှည့်ပတ်မှု အမျိုးအစား ",
  T_46_META_WS_C_LOOTAMMOTYPE: "Loot သည့် အတုလုံး အမျိုးအစား",
  T_46_META_WS_C_LOOTARMOR: "Loot သည့် အထည်အလိပ်",
  T_46_META_WS_C_LOOTARMORTYPE: "Loot သည့် အထည်အလိပ် အမျိုးအစား",
  T_46_META_WS_C_LOOTCONSUMABLE: "Loot သည့် အားဖြည့်မှု",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Loot သည့် အသုံးပြုနိုင်သော အမျိုးအစား",
  T_46_META_WS_C_LOOTIAMMO: "Loot သည့် အတုလုံး",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "အချက်အလက်ဘောလုံးအကြောင်းအရာ",
  T_46_META_WS_C_LOOTSCOPE: "Loot သည့် မျက်မှောက်",
  T_46_META_WS_C_LOOTSCOPETYPE: "Loot သည့် မျက်မှောက် အမျိုးအစား",
  T_46_META_WS_C_LOOTSOCCERTYPE: "ပစ္စည်းဘောလုံးအမျိုးအစား",
  T_46_META_WS_C_LOOTTHROWABLE: "Loot သည့် စွဲစွဲလမ်းလမ်း ပစ္စည်း",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Loot သည့် စွဲစွဲလမ်းလမ်း ပစ္စည်း အမျိုးအစား",
  T_46_META_WS_C_LOOTWEAPON: "Loot သည့် သေနတ်",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Loot သည့် သေနတ် အမျိုးအစား",
  T_46_META_WS_C_LOWGRAVITY: "နိမ့်လွှမ်းခြင်းနေရာ",
  T_46_META_WS_C_MAP: "မြေပုံ",
  T_46_META_WS_C_MAPT: "မြေပုံ အုပ်စုအမိန့် ID",
  T_46_META_WS_C_MATERIALID: "ပစ္စည်း ID",
  T_46_META_WS_C_MEDKIT: "ဆေးကုသရေးကီ",
  T_46_META_WS_C_MESHID: "မက်ရှ် ID",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "အားကစားအစဉ်ထွက်ကွက်",
  T_46_META_WS_C_MINIMAP: "လက်မြေပုံ",
  T_46_META_WS_C_MINIMAPICON: "လက်မြေပုံ အိုင်ကွန်",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "အလေးချိန် မြင်ကွင်း ကုန်ထုတ်မှု",
  T_46_META_WS_C_MINISENTRY: "Mini Sentry",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Mini Sentry အပြုံးအတိုင်းအတာအမျိုးအစား",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini Sentry ဖန်တီးထားသော အရာ",
  T_46_META_WS_C_MONEY: "ငွေ",
  T_46_META_WS_C_MONEYTYPE: "ငွေ အမျိုးအစား",
  T_46_META_WS_C_MONSTER: "သတ္တဝါ",
  T_46_META_WS_C_MONSTERSPAWN: "မွမ်းမံသော ကုန်ပစ္စည်း",
  T_46_META_WS_C_MONSTERTYPE: "မြင်းဆင် အမျိုးအစား",
  T_46_META_WS_C_MORPHABLEOBJECT: "အပြုံးသွားနိုင်သော အရာ",
  T_46_META_WS_C_MORPHOBJECT: "Morph အရာ",
  T_46_META_WS_C_MOTOBIKE: "မိုတော်ကား",
  T_46_META_WS_C_MOVEPLATFORM: "အလွှာ သွားလမ်း",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "အလွှာ သွားလမ်း အမျိုးအစား",
  T_46_META_WS_C_MUSHROOM: "ပန်းနံ့",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "သဘာဝအမြစ်",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "အနံ့",
  T_46_META_WS_C_OBJECT: "အရာ",
  T_46_META_WS_C_OILDRUM: "ဆီကန်",
  T_46_META_WS_C_OUTFITID: "ဝတ်စားမှု ID",
  T_46_META_WS_C_OUTFITSLOTTYPE: "အထည်အလိပ် အကွက်အမျိုးအစား",
  T_46_META_WS_C_PATHPOINT: "경로 점",
  T_46_META_WS_C_PATROLSTYLETYPE: "ရေဘူး စတိုင် အမျိုးအစား",
  T_46_META_WS_C_PATROLTYPE: "ရေဘူး အမျိုးအစား",
  T_46_META_WS_C_PERSONA: "ကိုယ်ရေးအချက်အလက်",
  T_46_META_WS_C_PHASE: "အဆင့်",
  T_46_META_WS_C_PHYSICALMOVER: "ရုပ်ပိုင်းဆိုင်ရာရွှေ့ပြောင်းသူ",
  T_46_META_WS_C_PHYSICALOBJECT: "ရုပ်ပိုင်းဆိုင်ရာပစ္စည်း",
  T_46_META_WS_C_PLATFORMTYPE: "ပလက်ဖောင်းအမျိုးအစား",
  T_46_META_WS_C_PLAYABLE: "재생 가능",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Playable သို့မဟုတ် Playables",
  T_46_META_WS_C_PLAYER: "စစ်ဆင်ရေး",
  T_46_META_WS_C_PLAYERBACKPACK: "ကစားသမားအိတ်",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "ကစားသမား အပြုအမူအခြေအနေ အမျိုးအစား",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "ကစားသမား စိတ်ပုံစံ",
  T_46_META_WS_C_PLAYERCCT: "ကစားသမား CCT",
  T_46_META_WS_C_PLAYERDATAID: "ပုံစံပေးထားသောအမျိုးအစား",
  T_46_META_WS_C_PLAYERORTRANSFORM: "ကစားသမား သို့မဟုတ် ပြောင်းလဲမှု",
  T_46_META_WS_C_PLAYERORVEHICLE: "ကစားသမား သို့မဟုတ် ယာဉ်",
  T_46_META_WS_C_PLAYEROUTFIT: "플레이어 의상",
  T_46_META_WS_C_PLAYERPOSETYPE: "ဖျော်ဖြေရေးပုံစံ",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "သက်သောငြာရက် ငွေကြေး မျိုးစုံ",
  T_46_META_WS_C_PLAYERSTATETYPE: "အတွင်းပြင်ပြီ",
  T_46_META_WS_C_POINTLIGHT: "နာရီအလင်း",
  T_46_META_WS_C_PORTAL: "ပေါက်ဂိတ်",
  T_46_META_WS_C_PREFABID: "ပရိဖေ့စ် ID",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "အသစ်မပြန်လည်ထည့်နိုင်သောအရေပြား",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "ဝစ်ဂျက်",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "ပရိုဖိုင်ဓာတ်ပုံဝစ်ဂျက်",
  T_46_META_WS_C_PROPERTY: "အရည်အချင်း",
  T_46_META_WS_C_PROPERTYFORMULA: "ပိုင်ဆိုင်မှု အရေပြား",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "ပိုင်ဆိုင်မှု အရေပြား အချက်အလက်အမျိုးအစား",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "ပိုင်ဆိုင်မှု ပြင်ဆင်မှု အမျိုးအစား",
  T_46_META_WS_C_QUATERNION: "ကွါတီနီယန်",
  T_46_META_WS_C_RANKABLE: "순위 매길 수 있는",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "ရေခဲစစ်စနစ် အမျိုးအစား",
  T_46_META_WS_C_REPAIRKIT: "ပြင်ဆင်မှု ကိရိယာ",
  T_46_META_WS_C_RESETABLE: "재설정 가능",
  T_46_META_WS_C_RIGIDBODY: "ရုပ်ပိုင်းဆိုင်ရာပစ္စည်း",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "ရုပ်ပိုင်းဆိုင်ရာပစ္စည်းကန့်သတ်အမျိုးအစား",
  T_46_META_WS_C_RIGIDBODYTYPE: "ရုပ်ပိုင်းဆိုင်ရာပစ္စည်းအမျိုးအစား",
  T_46_META_WS_C_ROUND: "ပတ်လမ်း",
  T_46_META_WS_C_SAFEZONE: "လုံခြုံသောဒေသ",
  T_46_META_WS_C_SCOREABLE: "점수화 가능한",
  T_46_META_WS_C_SCRIPTID: "စခရစ်ပ် ID",
  T_46_META_WS_C_SEATTYPE: "နေရာအမျိုးအစား",
  T_46_META_WS_C_SELFRELATIVE: "ကိုယ်တိုင် ဆက်စပ်မှု",
  T_46_META_WS_C_SHOP: "ဆိုင်",
  T_46_META_WS_C_SHOPITEM: "ဆိုင်ပစ္စည်း",
  T_46_META_WS_C_SHOPSHELF: "ဆိုင်ရုံး",
  T_46_META_WS_C_SKATEBOARD: "စကိတ်ဘုတ်",
  T_46_META_WS_C_SKELETON: "အထွတ်အထိပ်",
  T_46_META_WS_C_SKELETONPART: "သွားနှင့်အင်္ဂါပါး",
  T_46_META_WS_C_SKILLID: "ကျွမ်းကျင်မှု ID",
  T_46_META_WS_C_SKYBLASTER: "ပျံသန်းသောစက်",
  T_46_META_WS_C_SKYBOX: "အာကာသဘူး",
  T_46_META_WS_C_SKYBOXTYPE: "ကောင်းကင်အမျိုးအစား",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "လူမှုအီလန်နှင်းသုည",
  T_46_META_WS_C_SORTTYPE: "စီစဉ်မှု အမျိုးအစား",
  T_46_META_WS_C_SOUNDDRUMTYPE: "အသံ ထုတ်လွှင့်ခြင်း အမျိုးအစား",
  T_46_META_WS_C_SOUNDEFFECT: "အသံထွက်အထွေထွေ",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "အသံထွက်သို့မဟုတ် အသံထွက်စာရင်း",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "အသံ အကျိုးသက်ရောက်မှု အမျိုးအစား",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "အသံ ဦးဆောင်ခြင်း ၁ အမျိုးအစား",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "အသံ ဦးဆောင်ခြင်း ၂ အမျိုးအစား",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "အသံ ဦးဆောင်ခြင်း ၃ အမျိုးအစား",
  T_46_META_WS_C_SOUNDPIANOTYPE: "အသံ စနစ်တကျခြင်း အမျိုးအစား",
  T_46_META_WS_C_SPAWN: "스폰",
  T_46_META_WS_C_SPAWNABLE: "스폰 가능",
  T_46_META_WS_C_SPAWNBOX: "အထူးပြုသောအရေပြား",
  T_46_META_WS_C_SPAWNPOSITION: "စမ်းသပ်သည့်အကွောင့်",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "အထူးပစ္စည်း ID အမျိုးအစား",
  T_46_META_WS_C_SPHERETRIGGER: "ဘောလုံးထိန်း",
  T_46_META_WS_C_SPORTSCAR: "အားကစားကား",
  T_46_META_WS_C_SPRAYCOLOR: "ပေးအပ်တဲ့ အရောင်",
  T_46_META_WS_C_SPRAYGUN: "ပေးအပ်တဲ့ လက်နက်",
  T_46_META_WS_C_SPRAYRESULTUI: "ပေးအပ်တဲ့ အကျိုးရလဒ် UI",
  T_46_META_WS_C_SPRAYRIFLE: "ပေးအပ်တဲ့ သေနတ်",
  T_46_META_WS_C_SPRITEID: "စပရိုက့် ID",
  T_46_META_WS_C_STATICSCRIPTID: "အထွေထွေ စခရစ်ပ် ID",
  T_46_META_WS_C_STRING: "စာသား",
  T_46_META_WS_C_STRINGORLOCSTRING: "စာသားသို့မဟုတ် ဘာသာပြန်စာသား",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "ဇောမီးပစ္စည်း",
  T_46_META_WS_C_SWINGGUN: "အပျော့ချိန်မစ်တုံး",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "ပစ္စည်းအပိုင်းစီရင်",
  T_46_META_WS_C_TEAM: "팀",
  T_46_META_WS_C_TERRAIN: "မြေမျက်နှာပြင်",
  T_46_META_WS_C_TEXT: "စာသား အပြစ်",
  T_46_META_WS_C_TEXTUREID: "အထည်အသား ID",
  T_46_META_WS_C_TEXTURETYPE: "ပစ္စည်းအရေပြား",
  T_46_META_WS_C_TIMER: "အချိန်တိုင်းကိရိယာ",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "အချိန်မှတ်တမ်း ဖော်မတ်ပုံစံ အမျိုးအစား",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "အချိန်အမွတ်တံဆိပ်ဒေသိယစာသား",
  T_46_META_WS_C_TRAJECTORY: "လမ်းကြောင်း",
  T_46_META_WS_C_TRANSFORM: "ပြောင်းလဲသည်",
  T_46_META_WS_C_TUKTUK: "Tuk Tuk (သုံးလွှဲကား)",
  T_46_META_WS_C_TURRET: "သစ်တုံးစစ်ဆေးမှုပစ္စည်း",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Tween Curve",
  T_46_META_WS_C_TWEENSTYLE: "Tween Style အမျိုးအစား",
  T_46_META_WS_C_TYPE: "အမျိုးအစား",
  T_46_META_WS_C_TYPEENUM: "အမျိုးအစားစာရင်း",
  T_46_META_WS_C_TYPEORTYPELIST: "အမျိုးအစား သို့မဟုတ် အမျိုးအစားစာရင်း",
  T_46_META_WS_C_UIADDSCORE: "UI အမှတ် ရှေ့တန်း",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI မော်ကွန်းတိုက် သတ်မှတ်ချက် HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "UI ပေါင်းစပ် သီးနှံ",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "ပေါင်းစပ် UI ပိတ်ခလုတ် ခလုတ်",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI ကဒ် ရွေးချယ်မှု ပိုင်းခြား",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI စစ်ဆေးမှတ် ချိန်ခွင်ကျ",
  T_46_META_WS_C_UICOMPASS: "UI လိုက်နာမှု",
  T_46_META_WS_C_UICOUNTDOWN5: "UI ၅-စက္ကန့် တိုင်မာ",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI တိုင်မာ အကြံပြုချက်",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI တိုင်မာ တိုတောင်းသော သတိပေးချက်",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "ဇာတ်ကောင်ရဲ့ခေါင်းအပေါ်က ကျန်းမာရေးဘား",
  T_46_META_WS_C_UIHEALTHBAR: "UI ကျန်းမာရေးဘား",
  T_46_META_WS_C_UIHEARTBEAT: "UI နှလုံးခုန်",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI တိုတောင်းသော သတိပေးချက်",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI အထောက်အထား သတိပေးချက်",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI လုပ်ဆောင်ချက် ခလုတ်",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI ခေါင်းဆောင် ဘုတ်ပြား ခလုတ်",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI ပြိုင်ပွဲ အကြောင်းအရာ ချိန်ခွင်ကျ",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI သတ္တဝါ အဆင့်",
  T_46_META_WS_C_UIMONSTERUI: "UI သတ္တဝါ UI",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI မျိုးစုံ အဖွဲ့ ခေါင်းဆောင် ဘုတ်ပြား",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI မျိုးစုံ အဖွဲ့ ရလဒ် ပိုင်းခြား",
  T_46_META_WS_C_UIOPENINGBANNER: "UI စတင် ချိန်ခွင်ကျ",
  T_46_META_WS_C_UIPANEL: "UI ပိုင်းခြား",
  T_46_META_WS_C_UIPANELEMPTY: "UI ပိုင်းခြား ဗလာ",
  T_46_META_WS_C_UIPHASETIMER: "UI အဆင့်တက် ချိန်ဆွဲခြင်း",
  T_46_META_WS_C_UIPROGRESSBAR: "UI တိုးတက်မှုဘား",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI တိုးတက်မှု စက်ဝိုင်း",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI တိုးတက်မှု ကျွမ်းကျင်မှု ခလုတ်",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI ဝယ်ယူမှု မေးမြန်းမှု အမျိုးအစား",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI လှည့်ပတ် အချက်အလက် ချိန်ခွင်ကျ",
  T_46_META_WS_C_UIROUNDNUMBER: "UI လှည့်ပတ် နံပါတ်",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI လှည့်ပတ် ရလဒ် ချိန်ခွင်ကျ",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI လှည့်ပတ် အစ ချိန်ခွင်ကျ",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI လှည့်ပတ် ပြောင်းလဲမှု",
  T_46_META_WS_C_UISCOREBAR: "UI အမှတ်ဘား",
  T_46_META_WS_C_UISCROLLPANEL: "UI ဆွဲခြင်း ပိုင်းခြား",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI ရိုးရှင်းသော လှည့်ပတ် အမှတ်တရ ချိန်ခွင်ကျ",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI ရိုးရှင်းသော လှည့်ပတ် အစ ချိန်ခွင်ကျ",
  T_46_META_WS_C_UISIMPLETIP: "ရိုးရှင်းသော UI အကြံပြုချက်",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI ရိုးရှင်းသော ရင်ဆိုင်မှု ချိန်ခွင်ကျ",
  T_46_META_WS_C_UISKILLBUTTON: "UI ကျွမ်းကျင်မှု ခလုတ်",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "လူမှုရေးလုပ်ဆောင်မှုအတွက် ခလုတ် widget",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI တစ်ဦးတည်း ခေါင်းဆောင် ဘုတ်ပြား",
  T_46_META_WS_C_UISTORE: "UI စတိုးဆိုင် UI",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI အဖွဲ့ ပြိုင်ပွဲ အချက်အလက်",
  T_46_META_WS_C_UITEXTTIP: "UI စာသား အကြံပြုချက်",
  T_46_META_WS_C_UITIMERINFO: "UI တိုင်မာ အချက်အလက်",
  T_46_META_WS_C_UITIPBUTTON: "UI အကြံပြုချက် ခလုတ်",
  T_46_META_WS_C_UITITLEBANNER: "UI ခေါင်းစဉ် ချိန်ခွင်ကျ",
  T_46_META_WS_C_UITWEENTIP: "UI တိုင်ပင်ချက် မောင်းနှင်မှု ချိန်ခွင်ကျ",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI အဖွဲ့နှစ်ခု အချက်အလက်တိုတောင်းသော အချက်အလက်",
  T_46_META_WS_C_UITWOTEAMINFO: "UI အဖွဲ့နှစ်ခု အချက်အလက်",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI အဖွဲ့နှစ်ခု ခေါင်းဆောင် ဘုတ်ပြား",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI အဖွဲ့နှစ်ခု ရလဒ် ပိုင်းခြား",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI အဖွဲ့နှစ်ခု လှည့်ပတ် အမှတ်တရ ချိန်ခွင်ကျ",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI အဖွဲ့နှစ်ခု အမှတ်တရ ပိုင်းခြား",
  T_46_META_WS_C_UIVERSUSBANNER: "UI ရင်ဆိုင်မှု ချိန်ခွင်ကျ",
  T_46_META_WS_C_UIWIDGET: "UI ဝစ်ဂျက်",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI ဝစ်ဂျက် ခလုတ်",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI ဝစ်ဂျက် ထုပ်ပိုး",
  T_46_META_WS_C_UIWIDGETEMPTY: "UI ဝစ်ဂျက် ဗလာ",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI ဝစ်ဂျက် ပုံရိပ်",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI ဝစ်ဂျက် သွင်းထားသော လေးနက်",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI ဝစ်ဂျက် လက်ကိုင်ထိန်း",
  T_46_META_WS_C_UIWIDGETLABEL: "UI ဝစ်ဂျက် လေးနက်",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI ဝစ်ဂျက် ပုံစံ",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI ဝစ်ဂျက် ကိုယ်ရေးအချက်အလက်",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI ဝစ်ဂျက် အထည်အလိပ်",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI ဝစ်ဂျက် ခလုတ်ဖွင့်",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI ဝစ်ဂျက် အဆင့်တက် ခလုတ်",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI အနိုင်ရသို့မဟုတ် ရှုံးနိမ့်မှု ချိန်ခွင်ကျ",
  T_46_META_WS_C_UNITSPAWN: "유닛 스폰",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "ပြတင်းပေါက်တက်ပုံလက်တွဲ",
  T_46_META_WS_C_VECTOR2: "ဗက်တာ2",
  T_46_META_WS_C_VECTOR3: "ဗက်တာ3",
  T_46_META_WS_C_VEHICLE: "ယာဉ်",
  T_46_META_WS_C_VEHICLEIDTYPE: "ယာဉ် ID အမျိုးအစား",
  T_46_META_WS_C_VEHICLESKINID: "ကား အရေပြား ID",
  T_46_META_WS_C_VENDINGMACHINE: "အလိုအလျောက် အရောင်းစက်",
  T_46_META_WS_C_VEST: "ဦးထုပ်",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "VFX လဲလှယ်နိုင်သည့် အထည်အလိပ် ရှင်သန်မှု",
  T_46_META_WS_C_VFXTEXTURE: "VFX အထည်အလိပ်",
  T_46_META_WS_C_VISIBILITY: "မြင်နိုင်ခြင်း",
  T_46_META_WS_C_WALLET: "ပိုက်ဆံ",
  T_46_META_WS_C_WALLETHUD: "ပိုက်ဆံ UI",
  T_46_META_WS_C_WATERZONE: "ရေဒေသ",
  T_46_META_WS_C_WAVECOUNTTYPE: "လှိုင်း ကိန်းရေ အမျိုးအစား",
  T_46_META_WS_C_WAVEINTERVALTYPE: "လှိုင်း အကွာအဝေး အမျိုးအစား",
  T_46_META_WS_C_WEAPON: "အရင်းအမြစ်",
  T_46_META_WS_C_WEAPONGENERATOR: "무기 생성기",
  T_46_META_WS_C_WEAPONSKINID: "လက်နက် အသားထည် ID",
  T_46_META_WS_C_WEAPONTYPE: "အမျိုးအစား အရင်းအမြစ်",
  T_46_META_WS_C_WIDGETTYPE: "Widget အမျိုးအစား",
  T_46_META_WS_C_ZIPLINE: "ဇစ်ပျော့ကြိုး ",
  T_46_META_WS_CAMERADIRECTION: "ကင်မရာဦးတည်ချက်",
  T_46_META_WS_CAMERAPOSITION: "ကင်မရာတည်နေရာ",
  T_46_META_WS_CAPSULECAST: "ကလပ်ဆားစမ်း",
  T_46_META_WS_CAPSULEOVERLAP: "အားဖြည့်",
  T_46_META_WS_CEIL: "အမှန်တရားကိုထောက်ပံ့ခြင်း",
  T_46_META_WS_CHATCHANNEL: "စကားဝိုင်း",
  T_46_META_WS_CHECKTRIGGERBYORDER: "ပြုပြင်ခဲ့သောလုပ်ငန်း",
  T_46_META_WS_CLAMP: "ကွာတွန်းမှ Euler",
  T_46_META_WS_CLEAR: "လုံးဝရှင်းလင်းခြင်း",
  T_46_META_WS_CLEARALLCHILDREN: "ကလေးများဖျက်",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "သတိမပါမှတ်ချက်",
  T_46_META_WS_CLEARBACKPACK: "အိတ်ကိုရှင်းလင်းပါ",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "ရုပ်ပြသရုပ်ပွဲအထူးဓာတ်ခွဲကိုရှင်းလင်းပါ",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "အဆုံးသတ်အရာဝတ္ထုများရှင်းလင်းခြင်း",
  T_46_META_WS_CLIPNAME: "ဗီဒီယိုခွင်",
  T_46_META_WS_CLONE: "ကလုန်း",
  T_46_META_WS_COLLIDEDENTITY: "တိုက်မိသောအဖွဲ့ဝင်",
  T_46_META_WS_COLORGET: "စမ်းသပ်ခြင်း",
  T_46_META_WS_COMPLETECUSTOMMISSION: "ထုံးစံအဆင့်ပြီးဆုံးခြင်း",
  T_46_META_WS_CONNECT: "ပြုပြင်ခွင့်နှင့်အတူထောက်ပံ့ချက်",
  T_46_META_WS_CONSUMABLEID: "ပစ္စည်း ID",
  T_46_META_WS_CONTAIN: "စမ်းသပ်ထားသောပင်မစနစ်",
  T_46_META_WS_CONTAINKEY: "key ကိုစစ်ဆေးခြင်း",
  T_46_META_WS_COPYTOMORPH: "ပြောင်းလဲမှုကိုမိတ္တူပြုပါ",
  T_46_META_WS_COS: "ဆန့်ကျင်သောကိရိယာ",
  T_46_META_WS_COSTMONEY: "ငွေသုံးပါ",
  T_46_META_WS_COSTTOKEN: "Token သုံးခြင်း",
  T_46_META_WS_CREATEAIRDROP: "ထိခိုက်မှုစနစ်ဖန်တီး",
  T_46_META_WS_CREATEBOT: "Bot တစ်ခုဖန်တီး",
  T_46_META_WS_CREATEBUILTINUI: "အရေးပါသောလုပ်ငန်း",
  T_46_META_WS_CREATEBUILTINUICLIENT: "စည်းမျဉ်းစနစ်",
  T_46_META_WS_CREATECAMERA: "ကင်မရာကိုဖန်တီးပါ",
  T_46_META_WS_CREATECURVE: "ကွန်းဖန်တီး",
  T_46_META_WS_CREATECUSTOMUI: "အစီအစဉ်ပြန်လည်စတင်ခြင်း",
  T_46_META_WS_CREATECUSTOMUICLIENT: "ရေးဖြစ်ထွန်းထားသောအစီအစဉ်",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "စိတ်ကြိုက် UI ဖန်တီး",
  T_46_META_WS_CREATEDAMAGENUM: "အပလက်ဖောင်းဖြင့် ပြည့်စုံ",
  T_46_META_WS_CREATEEFFECT: "အိတ်အသားရေ သတ်မှတ်",
  T_46_META_WS_CREATEEFFECTCLIENT: "အိတ်အသားရေ ပြန်ထား",
  T_46_META_WS_CREATEFACTION: "အဖွဲ့စည်းတည်ဆောက်ပါ",
  T_46_META_WS_CREATEFOLLOW: "လိုက်ပါ",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "ဖရိမ်ရွေ့ပြောင်းဖန်တီး",
  T_46_META_WS_CREATEFROMPREFAB: "ဇာနီဖန်တီး",
  T_46_META_WS_CREATELEVELOBJECT: "အဆင့်အလိုက်အရာဝတ္ထုဖန်တီးခြင်း",
  T_46_META_WS_CREATELOOKAT: "အာရုံစိုက်ခြင်းဖန်တီး",
  T_46_META_WS_CREATEMINIMAPICON: "မိုဃ်းကုပြဇာတ်လမ်းပြုလုပ်",
  T_46_META_WS_CREATEMINIMAPPIXEL: "မိုဃ်းကုပြဇာတ်သင်္ကေတဖန်တီး",
  T_46_META_WS_CREATEMONSTER: "ပစ္စည်းချော်",
  T_46_META_WS_CREATEMORPH: "ပြောင်းလဲမှုကိုဖန်တီးပါ",
  T_46_META_WS_CREATESELFRELATIVE: "ကိုယ်ပိုင်ရွေ့ပြောင်းဖန်တီး",
  T_46_META_WS_CREATESHOP: "ပင်မဆိုင်ရာကိုဖန်တီးပါ",
  T_46_META_WS_CREATESHOPITEM: "ပစ္စည်းကိုဖန်တီးပါ",
  T_46_META_WS_CREATESHOPSHELF: "ပင်မဆိုင်ရာအပြင်ပစ္စည်းကိုဖန်တီးပါ",
  T_46_META_WS_CREATESOUND: "အကျိုးသက်ရောက်မှုရယူ",
  T_46_META_WS_CREATESOUNDCLIENT: "အိတ်အသားရေ",
  T_46_META_WS_CREATETOKENINSCENE: "နေရာတွင် Token ဖန်တီးခြင်း",
  T_46_META_WS_CREATETRAJECTORY: "လမ်းကြောင်းဖန်တီး",
  T_46_META_WS_CREATETWEEN: "Tween ဖန်တီး",
  T_46_META_WS_CREATEWALLET: "ဘဏ်အိတ်ဖန်တီးပါ",
  T_46_META_WS_CROSS: "အထူးထုတ်ပင်ပေါင်းစပ်ခြင်း",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "ကော်လံနံပါတ်ပြောင်း",
  T_46_META_WS_CURRENTAMMOCOUNT: "လက်ရှိကျည်ဆန်ရေ",
  T_46_META_WS_DAMAGE: "ထိခိုက်မှု",
  T_46_META_WS_DAMAGEDBODYPART: "ထိခိုက်သည့်ကိုယ်အစိတ်အပိုင်း",
  T_46_META_WS_DAMAGEDPLAYERS: "ထိခိုက်ခံရသူကစားသမား",
  T_46_META_WS_DAMAGETYPE: "ထိခိုက်မှုအမျိုးအစား",
  T_46_META_WS_DEALDAMAGE: "အစီအစဉ်ဖြန့်ဝေပုံစံ",
  T_46_META_WS_DELETE: "ဖျက်ပစ်ခြင်း",
  T_46_META_WS_DELETEAT: "အရာများကိုဖျက်ခြင်း",
  T_46_META_WS_DELETECUSTOMUI: "ပြန်လည်တင်သွင်းမှု",
  T_46_META_WS_DELETEFROMDATABASE: "ဒေတာဘေ့စ်မှဖျက်",
  T_46_META_WS_DELETEFROMDATASTORE: "ဒေတာစတိုးမှ ဖျက်ပါ",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "ကီးဖြင့်ဒေတာဖျက်",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "အဆင့်ဖြင့်ဒေတာဖျက်",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Key ဖြင့် လီဒ်ဘုတ်ဒေတာစတိုးမှ ဖျက်ပါ",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "အဆင့်ဖြင့် လီဒ်ဘုတ်ဒေတာစတိုးမှ ဖျက်ပါ",
  T_46_META_WS_DELETETAG: "အမှတ်အသားဖျက်ပါ",
  T_46_META_WS_DELTA: "ဒဲလ်တာ",
  T_46_META_WS_DESTROY: "ဖျက်ပါ",
  T_46_META_WS_DESTROYBOT: "Bot တစ်ခုဖျက်",
  T_46_META_WS_DESTROYBUILTINUI: "လက်ကျန်မှတ်တမ်းများ",
  T_46_META_WS_DESTROYEQUIPMENT: "ပစ္စည်းဖျက်ဆီးပါ",
  T_46_META_WS_DESTROYITEM: "ပြီးစီးခြင်း",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "ဧရိယာအနေဖြင့်ထွက်သည်",
  T_46_META_WS_DISABLESAFEZONE: "လုံခြုံဒေသပိတ်ခြင်း",
  T_46_META_WS_DISPATCHEVENT: "ဖြစ်ရပ်ပေးပါ",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "ဖန်တီးခြင်းကိုဆွဲဆောင်",
  T_46_META_WS_DISTANCE: "စာရင်းများကိုစမ်းသပ်ခြင်း",
  T_46_META_WS_DOT: "မက်စ်နှင့်မော်တော်",
  T_46_META_WS_DROPITEM: "လေယာဉ် အိတ်ဖွင့်",
  T_46_META_WS_DYEATAREA: "ဒေသဆေးခြယ်",
  T_46_META_WS_DYEATPLANE: "ပြားဆေးခြယ်",
  T_46_META_WS_DYEATPOSITION: "အချိန်ပြန့်ရာတွင်ဆေးခြယ်",
  T_46_META_WS_E_ABNORMALGRAVZONE: "အနိမ့်ထိပ်ပိုင်း",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "가속도",
  T_46_META_WS_E_ACTIONNODE: "လှုပ်ရှားမှုအဆင့်",
  T_46_META_WS_E_ACTIVE: "လှုပ်ရှားသော",
  T_46_META_WS_E_ACTIVESKILL: "လှုပ်ရှားသောကျွမ်းကျင်မှု",
  T_46_META_WS_E_ADBOARD: "ကြော်ငြာဘုတ်ကြီး",
  T_46_META_WS_E_ADD: "သို့တည်းဖြတ်သည်",
  T_46_META_WS_E_ADDFRIEND: "သူငယ်ချင်းများထည့်ပါ။",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "ရည်မှန်းချက်",
  T_46_META_WS_E_AIR: "공기",
  T_46_META_WS_E_AIRCONDITIONERA: "အပြင်အဆင်တပ်ဆင်",
  T_46_META_WS_E_AIRDROP: "Airdrop၊ Zombie အသေသတ်ခြင်း။",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "အသက်ရှင်လျက်",
  T_46_META_WS_E_AMMO: "ကျည်ဆန် VFX",
  T_46_META_WS_E_AMPHIBIANCAR: "수륙 양용 차량",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "ကလေးများကစားနေသည်",
  T_46_META_WS_E_AR: "라이플",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR 탄약",
  T_46_META_WS_E_ARMAGAZINE: "AR မဂ္ဂဇင်း",
  T_46_META_WS_E_ARMOR: "ခံတွင်းအစိတ်အပိုင်းများ",
  T_46_META_WS_E_ARMORBUFF: "갑옷 버프",
  T_46_META_WS_E_ARMORLV1: "갑옷 Lv1",
  T_46_META_WS_E_ARMORLV2: "갑옷 Lv2",
  T_46_META_WS_E_ARMORLV3: "갑옷 Lv3",
  T_46_META_WS_E_ARMORPIERCING: "ကျိုးပဲ့ချပ်ချပ်",
  T_46_META_WS_E_ARMORSPECIALIST: "ကျွမ်းကျင်မှု ၁",
  T_46_META_WS_E_ARROW: "သရုပ်ပြ",
  T_46_META_WS_E_ASC: "EAGLE",
  T_46_META_WS_E_ASCIGNOREZERO: "UMP2",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "ဓာတ်ငွေ့ပေါက်ကွဲမှု",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "တွဲဖက်စွမ်းဆောင်ရည်များအတွက် ချိတ်ဆက်ချက်1",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "တွဲဖက်စွမ်းဆောင်ရည်များအတွက် ချိတ်ဆက်ချက်4",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "တွဲဖက်စွမ်းဆောင်ရည်များအတွက် ချိတ်ဆက်ချက်5",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "တွဲဖက်စွမ်းဆောင်ရည်များအတွက် ချိတ်ဆက်ချက်6",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "တွဲဖက်စွမ်းဆောင်ရည်များအတွက် ချိတ်ဆက်ချက်8",
  T_46_META_WS_E_ATTACK: "ထိုးနှက်ခြင်း",
  T_46_META_WS_E_ATTACKGRENADE: "တိုက်ခိုက်ရေးဂရိနိတ်",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "အလိုအလျောက်",
  T_46_META_WS_E_AWM: "GOLD_M1014_II",
  T_46_META_WS_E_AWM2: "GOLD_M1014_III",
  T_46_META_WS_E_BACK: "ပြန်လာ",
  T_46_META_WS_E_BACKANDFORTH: "ပြန်သွား",
  T_46_META_WS_E_BAG: "အိတ်",
  T_46_META_WS_E_BAG1: "အိတ်1",
  T_46_META_WS_E_BAG2: "အိတ်2",
  T_46_META_WS_E_BAG3: "အိတ်3",
  T_46_META_WS_E_BAMBOOA: "대나무 A",
  T_46_META_WS_E_BANANATREE: "바나나 나무",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "기본 계수",
  T_46_META_WS_E_BASIC: "기본",
  T_46_META_WS_E_BASICCONE: "ပုံသဏ္ဍာန်အခြေခံ",
  T_46_META_WS_E_BASICCYLINDER: "ကုလားထိုင်အခြေခံ",
  T_46_META_WS_E_BASICSPHERE: "Sferă de bază",
  T_46_META_WS_E_BATTLEINSTYLE: "BattleInStyle",
  T_46_META_WS_E_BELL: "ခေါင်းလောင်း",
  T_46_META_WS_E_BENCH: "တစ်ထောင်တန်း",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "တော်တော်ကြီးသောအပြုံး",
  T_46_META_WS_E_BIPOD: "တူနှစ်ဖက်စီးပျဴ",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS အထူးသတ်မှတ်ထားသော ပြင်ပကျွမ်းကျင်",
  T_46_META_WS_E_BIZON: "GOLD_SCAR_I",
  T_46_META_WS_E_BLACKHOLE: "တွင်းနက်ပေါက်ကွဲမှု အထူးသက်ရောက်မှု",
  T_46_META_WS_E_BLACKHOLEBOOM: "Crystal Ball အထူးအကျိုးသက်ရောက်မှုများ",
  T_46_META_WS_E_BLAST: "ပေါက်ကွဲ",
  T_46_META_WS_E_BLOCK: "စတုရန်း",
  T_46_META_WS_E_BLOODBALL: "Blackhole VFX",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "အပြာရောင်",
  T_46_META_WS_E_BLUEDOLL: "ရေပူပူအပူ",
  T_46_META_WS_E_BOARD: "이동 플랫폼",
  T_46_META_WS_E_BODY: "ခန္ဓာ",
  T_46_META_WS_E_BOMBINDICATION: "ဗုံးထိပ်ဖျား",
  T_46_META_WS_E_BOMBPLIERS: "ဗုံးဖောက်တံ",
  T_46_META_WS_E_BONFIRE: "တောက်လောင်နေသော မီးပုံကြီး",
  T_46_META_WS_E_BOOM: "စန်း",
  T_46_META_WS_E_BOOYAH: "အလွတ်လပ်ပြုံးတစ်ခု",
  T_46_META_WS_E_BOTH: "နှစ်ချက် ပြီး၏။",
  T_46_META_WS_E_BOUNCETIRE: "타이어",
  T_46_META_WS_E_BOWAMMO: "활 탄약",
  T_46_META_WS_E_BREAKABLEBOX: "ဖျက်နိုင်သောရေမြှုပ်ခန်း",
  T_46_META_WS_E_BREAKABLECONTAINER: "파괴 가능한 컨테이너",
  T_46_META_WS_E_BREAKABLEFENCE: "파괴 가능한 울타리",
  T_46_META_WS_E_BRICKA: "벽돌 A",
  T_46_META_WS_E_BRICKB: "벽돌 B",
  T_46_META_WS_E_BRICKC: "벽돌 C",
  T_46_META_WS_E_BRICKHOUSEA: "သေးငယ်သောအိမ် A",
  T_46_META_WS_E_BRIGHT: "တောက်ပသောအရောင်",
  T_46_META_WS_E_BUBBLE: "방울",
  T_46_META_WS_E_BUFFGENERATOR: "버프 생성기",
  T_46_META_WS_E_BULLETBUFF: "총알 버프",
  T_46_META_WS_E_BULLETHITTING: "M4A1",
  T_46_META_WS_E_BUMPERCAR: "범퍼카",
  T_46_META_WS_E_BUMPERCARFACTORY: "ဘမ်ပါကားထုတ်လုပ်သူ",
  T_46_META_WS_E_BURNING: "ပေါက်ကွဲမှုကြောင့် ယာဉ်မီးလောင်ပျက်စီးခြင်း။",
  T_46_META_WS_E_BUSHES: "သစ်ပင်အုပ်စု",
  T_46_META_WS_E_BUSSTOP: "ဘတ်စ်ကားအသွားအလာကျောင်း",
  T_46_META_WS_E_BUTTOM: "အောက်ပိုင်းဝတ်စုံ",
  T_46_META_WS_E_BUTTONWIDGET: "ခလုတ်",
  T_46_META_WS_E_BYHIERARCHY: "အဆင့်အခွင်",
  T_46_META_WS_E_CABINET: "ရုံးခန်း",
  T_46_META_WS_E_CACTUS: "선인장",
  T_46_META_WS_E_CAMOUFLAGE: "ကျွမ်းကျင်မှု ၆",
  T_46_META_WS_E_CAPSULETRIGGER: "ကပ်ဆူးထိန်းချုပ်သူ",
  T_46_META_WS_E_CARDIOTONIC: "စိတ်နှလုံးအားဖြည့်ဆေး",
  T_46_META_WS_E_CASUALGAMEBGM: "အထိအမြတ်ဆုံးအဆင့်",
  T_46_META_WS_E_CEMENTA: "시멘트 A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "ချန်နယ် A",
  T_46_META_WS_E_CHANNELB: "ချန်နယ် B",
  T_46_META_WS_E_CHANNELC: "ချန်နယ် C",
  T_46_META_WS_E_CHANNELD: "ချန်နယ် D",
  T_46_META_WS_E_CHANNELE: "ချန်နယ် E",
  T_46_META_WS_E_CHANNELF: "ချန်နယ် F",
  T_46_META_WS_E_CHARACTERSKILL: "Character Skill ပါ။",
  T_46_META_WS_E_CHARACTOR: "တို့ရောသူ",
  T_46_META_WS_E_CHARGE: "အားလုံးရရှိရန်",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "စစ်ဆေးချက်မှတ်တိုင်",
  T_46_META_WS_E_CHEER: "ပျော်ရွှင်ပါစေ။",
  T_46_META_WS_E_CHERRYBLOSSOM: "벚꽃 나무",
  T_46_META_WS_E_CIRCLE: "원",
  T_46_META_WS_E_CIRCLEBACK: "သံသရာ",
  T_46_META_WS_E_CIRCLEOFHEAT: "Foot Beam",
  T_46_META_WS_E_CITY: "မြို",
  T_46_META_WS_E_CLAPS: "박수",
  T_46_META_WS_E_CLEAR: "지우기",
  T_46_META_WS_E_CLIENT: "ဖောက်သည်",
  T_46_META_WS_E_CLONE: "Changer ကိုကြည့်ပါ။",
  T_46_META_WS_E_CLONEKILL: "မရဏကို မွေးထုတ်သည်။",
  T_46_META_WS_E_CLOSE: "ပိတ်ပါ",
  T_46_META_WS_E_CLOTHES: "အဝတ်အစား",
  T_46_META_WS_E_COINGENERATOR: "သံရငျထုတ်လုပ်သူ",
  T_46_META_WS_E_COLDAIR: "မြူနှင်း",
  T_46_META_WS_E_COLORBLOCK: "အရောင်ဆေးကြောထားသောဘလော့",
  T_46_META_WS_E_COLOROILBARREL: "အရောင်ဆေးကြောထားသောဆီတိုက်",
  T_46_META_WS_E_COMBINEALL: "အားလုံးပေါင်းစပ်ခြင်း",
  T_46_META_WS_E_COMBINESELF: "ကိုယ်ပိုင်ပေါင်းစပ်ခြင်း",
  T_46_META_WS_E_COMBOKEYA1: "음악 노트 - 신디사이저 A",
  T_46_META_WS_E_COMBOKEYA2: "음악 노트 - 신디사이저 A",
  T_46_META_WS_E_COMBOKEYB1: "음악 노트 - 신디사이저 B",
  T_46_META_WS_E_COMBOKEYB2: "음악 노트 - 신디사이저 B",
  T_46_META_WS_E_COMBOKEYC1: "음악 노트 - 신디사이저 C",
  T_46_META_WS_E_COMBOKEYC2: "음악 노트 - 신디사이저 C",
  T_46_META_WS_E_CONCRETEPILLAR: "ခြစ်သတ္တု",
  T_46_META_WS_E_CONDITIONNODE: "အခြေအနေတရား",
  T_46_META_WS_E_CONTAINERA: "컨테이너 A",
  T_46_META_WS_E_CONTAINERB: "컨테이너 B",
  T_46_META_WS_E_CONTAINERC: "컨테이너 C",
  T_46_META_WS_E_CONTAINERWIDGET: "ကွန်တိနာ",
  T_46_META_WS_E_CONTINUOUS: "ဆက်လက်လုပ်ဆောင်ခြင်း",
  T_46_META_WS_E_COUNTDOWN: "အချိန်ကိုက်",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "သင့်ကောင်းမွန်သောကျွမ်းကျင်မှု",
  T_46_META_WS_E_COUNTDOWNDIDI: "ရေတွက်ခြင်း Beep အသံ",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "သွားရောက်မှုအတူအားလုံး",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "အမှားသောရေချိုးသည်ဒသမထွက်ခြင်း",
  T_46_META_WS_E_CROSS: "လက်ဝါးကပ်တိုင်",
  T_46_META_WS_E_CROSSBOW: "석궁",
  T_46_META_WS_E_CROSSHAIR: "ရှေ့မြင်ကွင်း",
  T_46_META_WS_E_CROSSHAIRS: "ဗဟိုကျရှုထောင့်များ",
  T_46_META_WS_E_CROUCH: "ထိုင်ရန်စိတ်ချခံစားခြင်း",
  T_46_META_WS_E_CROUCHING: "ဝပ်နေသည်။",
  T_46_META_WS_E_CROWCAW: "လျှပ်စစ်ထိခိုက်မှု",
  T_46_META_WS_E_CROWN: "သရဖူ",
  T_46_META_WS_E_CUBE: "블록 메커니즘",
  T_46_META_WS_E_CURSE: "talisman ပါ။",
  T_46_META_WS_E_CURSEEXPLOSION: "Talisman ပေါက်ကွဲမှု",
  T_46_META_WS_E_CUSTOM: "မိမိစိတ်ကြိုက်ချိန်ညှိသည့်ကင်မရာ",
  T_46_META_WS_E_CUSTOMTRIGGER: "စိတ်ကြိုက်အချက်ပြ",
  T_46_META_WS_E_CUSTOMWATERZONE: "အထူးပြုရေခင်း",
  T_46_META_WS_E_CYCLICCOMBUSTION: "ကွင်းထဲတွင် မီးလောင်နေသည်။",
  T_46_META_WS_E_CYLIC: "အလှည့်ကျ",
  T_46_META_WS_E_DAGGER: "ပစ်ဓား",
  T_46_META_WS_E_DAMAGEDTRUCK: "ပျက်စီးသောကား",
  T_46_META_WS_E_DAMAGEZONE: "ပျက်စီးမှုဇုန်",
  T_46_META_WS_E_DANGERALARM: "လမ်းပြများ",
  T_46_META_WS_E_DANGERVIBRATING: "ဤသို့မဟုတ်အတန့်အတန့်၏သတင်းစကား",
  T_46_META_WS_E_DARK: "အမှောင်",
  T_46_META_WS_E_DARKNESS: "어둠",
  T_46_META_WS_E_DASHATTACK: "ယာဉ်တိုက်မှု",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "ဒေတာသိုလှောင်မှု ကန့်သတ်ချက်ကို ကျော်သွားပါပြီ။",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "ဒေတာသိုလှောင်မှု ကန့်သတ်ချက် အမှားအယွင်း",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "ဒေတာသိမ်းဆည်းချိန်",
  T_46_META_WS_E_DATETIME: "ရက်စွဲနှင့်အချိန်",
  T_46_META_WS_E_DAY: "နေ့",
  T_46_META_WS_E_DEAD: "သေပြီ။",
  T_46_META_WS_E_DEATH: "သေဆုံးခြင်း",
  T_46_META_WS_E_DEFAULT: "ပုံမှန်",
  T_46_META_WS_E_DEFAULTFIST: "G18",
  T_46_META_WS_E_DEFENCEGRENADE: "ကာကွယ်ရေးဂရိနိတ်",
  T_46_META_WS_E_DESC: "MP5",
  T_46_META_WS_E_DIALOGUE: "တွေ့ဆုံဆွေးနွေးရေး",
  T_46_META_WS_E_DIAMOND: "စိန်",
  T_46_META_WS_E_DIRECTIONSIGN: "အညွှန်း",
  T_46_META_WS_E_DIRVEVEHICLE: "ယာဉ်ကိုမောင်းနှင်ခြင်း",
  T_46_META_WS_E_DISABLE: "ပိတ်ပါ",
  T_46_META_WS_E_DISABLED: "비활성화",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "ပျောက်သွားအောင် အချက်ပေးလိုက်ပါ။",
  T_46_META_WS_E_DISCONNECT: "အဆက်အသွယ်ဖြတ်ပါ။",
  T_46_META_WS_E_DISGUISE: "ကိုယ်ပွား",
  T_46_META_WS_E_DOGHOUSE: "ငါးအိမ်",
  T_46_META_WS_E_DOOR: "တစ်အိမ်",
  T_46_META_WS_E_DOUBLE: "နှစ်ဆ",
  T_46_META_WS_E_DOUBLEDOOR: "နှစ်လုံးပေါက်သံသယ",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "နှစ်ချက်ခုန်ဖိနပ်",
  T_46_META_WS_E_DOUBLEMAGEZINE: "နှစ်ထပ် မဂ္ဂဇင်း",
  T_46_META_WS_E_DRAW: "မပြတ်တောက်တောက်ဆွဲယူထားခြင်း",
  T_46_META_WS_E_DRILLZOMBIE: "လှီးလှောင့်ဇွန်းဘီ",
  T_46_META_WS_E_DRIVE: "မောင်းနှင်ခြင်း",
  T_46_META_WS_E_DRIVER: "ယာဉ်မောင်းသူ",
  T_46_META_WS_E_DROPBEAT: "ကျွမ်းကျင်မှု ၄",
  T_46_META_WS_E_DRUMKEY1: "음악 노트 - 드럼",
  T_46_META_WS_E_DRUMKEY2: "음악 노트 - 드럼",
  T_46_META_WS_E_DUEL: "duel",
  T_46_META_WS_E_DUMMY: "အတုရုပ်",
  T_46_META_WS_E_DUMMYGRENADE: "မျက်နှာကြီးဂရိနိတ်",
  T_46_META_WS_E_DUMP: "အလံပြချစ်ရသော",
  T_46_META_WS_E_DUSK: "ဆည်းဆာ",
  T_46_META_WS_E_DUST: "မီးခိုးနှင့်ဖုန်မှုန့်",
  T_46_META_WS_E_DYNAMIC: "တက်ကြွ",
  T_46_META_WS_E_E: "သဘာဝကြိမ်နှုန်း",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "ရိုးရှင်းသော",
  T_46_META_WS_E_ELECTRICSHOCK: "အားကစားဂိမ်းအတူကောင်းကင်မြင်သာမှု",
  T_46_META_WS_E_ELECTRICSURFBOARD: "လျှပ်စစ်လေလှောင့်ပျဉ်း",
  T_46_META_WS_E_ELECTRICZONE: "လျှပ်စစ်ဇုန်",
  T_46_META_WS_E_ELECTRONICBGM: "အဆင့်တက်",
  T_46_META_WS_E_ELIMINATEDBOSS: "FootballIce",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "AK",
  T_46_META_WS_E_EMOTE: "သဘောထားပြခြင်း",
  T_46_META_WS_E_ENABLE: "ဖွင့်ပါ",
  T_46_META_WS_E_ENERGETIC: "တက်ကြွတယ်။",
  T_46_META_WS_E_ENTERVEHICLE: "ယာဉ်အတွင်းဝင်ခြင်း",
  T_46_META_WS_E_EP: "စွမ်းအင်အခြေအနေ (EP)",
  T_46_META_WS_E_EXCLAMATIONMARK: "အာမေဋိတ်အမှတ်အသား",
  T_46_META_WS_E_EXIT: "ထွက်ပေါက်",
  T_46_META_WS_E_EXITVEHICLE: "ယာဉ်မှထွက်ခြင်း",
  T_46_META_WS_E_EXPLODE: "မိမိကိုယ်ကို ဖျက်ဆီးခြင်း။",
  T_46_META_WS_E_EXPLOSION: "ပေါက်ကွဲမှု VFX",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "ပေါက်ကွဲမီးတောက်များ",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "AK2",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "ပေါက်ကွဲတဲ့ဇွန်းဘီ",
  T_46_META_WS_E_EYE: "မျက်မှန်",
  T_46_META_WS_E_FACEPAINT: "မျက်နှာပန်းချီဆွဲခြင်း",
  T_46_META_WS_E_FACTION: "진영",
  T_46_META_WS_E_FALLING: "ပြုတ်ကျ",
  T_46_META_WS_E_FALLINGSTAR: "အိတ်ဖွင့်",
  T_46_META_WS_E_FALSE: "မဟုတ်ဘူး",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "프로펠러 메커니즘",
  T_46_META_WS_E_FAR: "멀리",
  T_46_META_WS_E_FEATHER: "깃털",
  T_46_META_WS_E_FEMALE: "အပျို",
  T_46_META_WS_E_FENCE: "울타리",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "ရင်ဆိုင်မှု",
  T_46_META_WS_E_FILLED: "ဖြည့်စွက်",
  T_46_META_WS_E_FINISH: "အပြီး",
  T_46_META_WS_E_FINISHINGPOINT: "အဆုံးသတ်ချက်",
  T_46_META_WS_E_FINISHLINEARCH: "ပြီးဆုံးဘန်နာ",
  T_46_META_WS_E_FIRE: "불",
  T_46_META_WS_E_FIRECHARGE: "မီးလုံး",
  T_46_META_WS_E_FIREWORK: "မီးရှူးမီးပန်း",
  T_46_META_WS_E_FIRINGEFFECT: "VFX ရိုက်ခြင်း။",
  T_46_META_WS_E_FIRSTPERSON: "ပထမပုဂ္ဂိုလ်အမြင်ကင်မရာ",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "ပထမပုဂ္ဂိုလ်အမြင်ကင်မရာ (ရှေးဟောင်း)",
  T_46_META_WS_E_FIST: "လက်သီး",
  T_46_META_WS_E_FIT: "သင့်လျော်မှု",
  T_46_META_WS_E_FLAG: "နဖူးစည်းစာတမ်း",
  T_46_META_WS_E_FLAME: "မီး",
  T_46_META_WS_E_FLAMEGUN: "မီးတောက်သေနတ်",
  T_46_META_WS_E_FLAMETHROWER: "မီးတောက်သေနတ်",
  T_46_META_WS_E_FLASH: "플래시뱅",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "Flashbang မီးခိုး",
  T_46_META_WS_E_FLASHFREEZE: "플래시 프리즈",
  T_46_META_WS_E_FLEXWALL: "확장형 벽",
  T_46_META_WS_E_FLICKER: "တုန်ခါနေသည်။",
  T_46_META_WS_E_FLOWER: "꽃",
  T_46_META_WS_E_FLYBOMBBEE: "ပျံသန်းတဲ့ ဗုံးပျားပျား",
  T_46_META_WS_E_FLYPAN: "프라이팬 메커니즘",
  T_46_META_WS_E_FLYSHOE: "ပျံသန်းစီးဖိနပ်",
  T_46_META_WS_E_FOLDER: "ဖိုလ်ဒါ",
  T_46_META_WS_E_FOLDWINGS: "ချိတ်ဆွဲတောင်ပံ",
  T_46_META_WS_E_FOODTRUCK: "အစားအသောက်ကား",
  T_46_META_WS_E_FOODTRUCKB: "အစားအစာတင်သွင်းသောကား B",
  T_46_META_WS_E_FOOTBALL: "ဖွံ့ဖြိုးတိုးတက်မှု",
  T_46_META_WS_E_FOOTBALLGUN: "ဘောလုံးသေနတ်",
  T_46_META_WS_E_FOOTBALLICE: "SCAR2",
  T_46_META_WS_E_FOOTBALLSHIELD: "SCAR",
  T_46_META_WS_E_FOOTBALLSHOOTER: "축구 총",
  T_46_META_WS_E_FORCE: "အား",
  T_46_META_WS_E_FOREGRIP_MR: "MR ရှေ့သွားကိုင်",
  T_46_META_WS_E_FOREGRIP1: "ရှေ့သွားကိုင်1",
  T_46_META_WS_E_FOREGRIP2: "ရှေ့သွားကိုင်2",
  T_46_META_WS_E_FOREGRIP3: "ရှေ့သွားကိုင်3",
  T_46_META_WS_E_FORWARD: "သတ်မှတ်ချက်",
  T_46_META_WS_E_FOUNTAIN: "분수",
  T_46_META_WS_E_FREE: "အခမဲ့သုံးရန်ကင်မရာ",
  T_46_META_WS_E_FREEZEALL: "အားလုံးရပ်တန့်",
  T_46_META_WS_E_FREEZEPOSITION: "ရပ်တန့်",
  T_46_META_WS_E_FREEZEPOSITIONX: "X ချပ်",
  T_46_META_WS_E_FREEZEPOSITIONY: "Y ချပ်",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Z ချပ်",
  T_46_META_WS_E_FREEZEROTATION: "ရပ်တန့်",
  T_46_META_WS_E_FREEZEROTATIONX: "X ရေ",
  T_46_META_WS_E_FREEZEROTATIONY: "Y ရေ",
  T_46_META_WS_E_FREEZEROTATIONZ: "Z ရေ",
  T_46_META_WS_E_FREEZEZONE: "Frozen Area",
  "T_46_META_WS_E_FROST GALAXY": "Frost ဂလက်ဆီ",
  T_46_META_WS_E_FROZEN: "အေးခဲ",
  T_46_META_WS_E_FROZENGRENADE: "အေးခဲနေသော လက်ပစ်ဗုံး",
  T_46_META_WS_E_FUNCTIONALITEMS: "လုပ်ဆောင်နိုင်စွမ်းရှိသောပစ္စည်းများ",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "ဂိမ်း",
  T_46_META_WS_E_GAMEOVER: "FGL24",
  T_46_META_WS_E_GAMESTART: "အကြိုးပြုသောအခိုက်အတန့်",
  T_46_META_WS_E_GARAGE: "차고",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "စက်ကိုဖွင့်ခြင်း",
  T_46_META_WS_E_GENTLETAP: "အားနည်းသောကလစ်",
  T_46_META_WS_E_GETITEM: "M10142",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "유령",
  T_46_META_WS_E_GIANTDICE: "သွားခွေ",
  T_46_META_WS_E_GIANTLOLLIPOP: "ကြီးမားသောလုံးလုံးပတ်",
  T_46_META_WS_E_GIFT: "လက်ဆောင်",
  T_46_META_WS_E_GLOOWALL: "젤 벽",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS အထူးသတ်မှတ်ထားသော ပန်းအိမ်",
  T_46_META_WS_E_GRAFFITIWALL: "ဂရပ်ဖီတီထဲ",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "ကျားဆွဲသေနတ်",
  T_46_META_WS_E_GREATCONDUCTOR: "GreatConductor",
  T_46_META_WS_E_GREEN: "အပင်ရောင်",
  T_46_META_WS_E_GRENADE: "수류탄",
  T_46_META_WS_E_GRID: "ဂရစ်",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "감시탑",
  T_46_META_WS_E_GUILD: "အသင်းအဖွဲ့",
  T_46_META_WS_E_GUN: "သေနတ်",
  T_46_META_WS_E_GUNFIRE: "총알",
  T_46_META_WS_E_HALO: "ထီးဆောင်း၊",
  T_46_META_WS_E_HAMMER: "거대 망치 메커니즘",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "건조대",
  T_46_META_WS_E_HARD: "ခက်တယ်။",
  T_46_META_WS_E_HATTRICK: "ကျွမ်းကျင်မှု ၈",
  T_46_META_WS_E_HAYSTACK: "건초 더미",
  T_46_META_WS_E_HEAD: "ဦးထုပ်",
  T_46_META_WS_E_HEADSHOOT: "ဦးခေါင်းကိုပစ်ခံရခြင်း",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "ဆေးသေနတ်",
  T_46_META_WS_E_HEART: "နှလုံး",
  T_46_META_WS_E_HEARTBEAT: "နှလုံးခုန်",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "ပြင်းထန်သောလက်နက်",
  T_46_META_WS_E_HELL: "အရမ်းခက်တယ်။",
  T_46_META_WS_E_HELMET: "သံခမောက်",
  T_46_META_WS_E_HELMET1: "သံခမောက်1",
  T_46_META_WS_E_HELMET2: "သံခမောက်2",
  T_46_META_WS_E_HELMET3: "သံခမောက်3",
  T_46_META_WS_E_HEXAGON: "ဆဋ္ဌဂံ",
  T_46_META_WS_E_HGAMMO: "HG 탄약",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "ဝှက်ကစားမီးတောက်သေနတ်",
  T_46_META_WS_E_HIDERKILL: "Hider အသတ်ခံရတယ်။",
  T_46_META_WS_E_HIHATS: "하이햇",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "ခြောက်သွေ့သောထိတွေ့မှု",
  T_46_META_WS_E_HITEFFECT: "Bullet Hit VFX",
  T_46_META_WS_E_HITFEEDBACK: "ရိုက်ကွင်း တုံ့ပြန်ချက်",
  T_46_META_WS_E_HOOK: "တံဆိပ်ဆွဲ",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "ကျားဆွဲသေနတ်",
  T_46_META_WS_E_HORIZALINE: "수평선",
  T_46_META_WS_E_HORIZONTAL: "အနားမှာ",
  T_46_META_WS_E_HORN: "FootballShield",
  T_46_META_WS_E_HORROR: "စိတ်ကြွ",
  T_46_META_WS_E_HOURGLASS: "သဲနာရီ",
  T_46_META_WS_E_HOUSE: "အိမ်များ",
  T_46_META_WS_E_HOUSEA: "단층 집",
  T_46_META_WS_E_HOUSEB: "2층 집",
  T_46_META_WS_E_HOUSEC: "삼층 집",
  T_46_META_WS_E_HP: "ကျန်းမာရေးအခြေအနေ (HP)",
  T_46_META_WS_E_HPBUFF: "HP 버프",
  T_46_META_WS_E_HUT: "캐빈",
  T_46_META_WS_E_ICEA: "얼음 A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "ရေခဲတံထုတ်စက်",
  T_46_META_WS_E_ICONOBJECT: "အိုင်ကွန်း",
  T_46_META_WS_E_IMAGEWIDGET: "အကြောင်းအရာ",
  T_46_META_WS_E_IMPULSE: "충격",
  T_46_META_WS_E_INHALER: "흡입기",
  T_46_META_WS_E_INJUREDFEMALE: "အရိုက်ခံရပြီးနောက် အမျိုးသမီးက အော်ဟစ်သည်။",
  T_46_META_WS_E_INJUREDMALE: "အရိုက်ခံရပြီးနောက် အော်ဟစ်နေသော အမျိုးသား",
  T_46_META_WS_E_INK: "မင် VFX",
  T_46_META_WS_E_INPUTLABLEWIDGET: "အမည်အချက်",
  T_46_META_WS_E_INSECTCHIRPING: "ကြိုးတောင်ကြိုးပြန်ပွဲကြားခြင်း",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 စက္ကန့်",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 စက္ကန့်",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 စက္ကန့်",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 စက္ကန့်",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 စက္ကန့်",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 စက္ကန့်",
  T_46_META_WS_E_INVISIBLE: "မမြင်နိုင်သော",
  T_46_META_WS_E_IPIPE: "I 파이프",
  T_46_META_WS_E_IRONFENCE: "ပစ္စည်းပြား",
  T_46_META_WS_E_IRONFENCEB: "ပစ္စည်းပြား B",
  T_46_META_WS_E_IRONPLATFORM: "철제 플랫폼",
  T_46_META_WS_E_ITEMENTITY: "စားသုံးနိုင်သောပစ္စည်းထုတ်လုပ်သူ",
  T_46_META_WS_E_JEEP: "지프",
  T_46_META_WS_E_JERRYCAN: "ဆီတိုက်",
  T_46_META_WS_E_JERSEYMACHINE: "ဂျာစီစက်",
  T_46_META_WS_E_JOINEDGAMEDULL: "ဖျော်ဖြေရေးပေးသူ",
  T_46_META_WS_E_JOINGAME: "ဂိမ်းတွင်တက်ရောက်ခြင်း",
  T_46_META_WS_E_JOYSTICKWIDGET: "ဂိမ်းကိရိယာ",
  T_46_META_WS_E_JUMP: "ခုန်ခြင်း",
  T_46_META_WS_E_JUMPATTACK: "ခုန်ပါ။",
  T_46_META_WS_E_JUSTPATROL: "လျှပ်စစ်လေဆာင်မှု",
  T_46_META_WS_E_KAR98K: "M14",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "သော့",
  T_46_META_WS_E_KICK: "킥",
  T_46_META_WS_E_KILLINGTIPS: "သတ်ဖြတ်မှုအကြံပြုချက်များ",
  T_46_META_WS_E_KILLZONE: "KillZone",
  T_46_META_WS_E_KINEMATIC: "ကိန်းပညာ",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "လက်လှမ်းမမီပြုတ်ကျခြင်း",
  T_46_META_WS_E_KNOCKEDDOWN: "ခေါက်ချ",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "အမှတ်အသား",
  T_46_META_WS_E_LANDINGA: "မိုးကျောကြိုးအဆင့် A",
  T_46_META_WS_E_LANDINGB: "မိုးကျောကြိုးအဆင့် B",
  T_46_META_WS_E_LANDINGC: "မိုးကျောကြိုးအဆင့် C",
  T_46_META_WS_E_LANDMINE: "မြေမြှုပ်မိုင်း",
  T_46_META_WS_E_LANUNCHERAMMO: "ချွတ်တီးစစ်ဆေးရေးခရီးစဉ်",
  T_46_META_WS_E_LASER: "လေဆာ VFX",
  T_46_META_WS_E_LASERSKILL: "M1014",
  T_46_META_WS_E_LATTICESCREEN: "화면",
  T_46_META_WS_E_LAWNA: "잔디 A",
  T_46_META_WS_E_LAWNB: "잔디 B",
  T_46_META_WS_E_LAYOUTWIDGET: "အပြင်အဆင်",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "죽은 나무",
  T_46_META_WS_E_LEVELMAXED: "ရုပ်ရှင်ပြိုကွဲခြင်း",
  T_46_META_WS_E_LEVELUP: "အချိန်ပြန်လည်သုံးစွဲမှု",
  T_46_META_WS_E_LEVELUPDISCARDED: "အဆင့်မြှင့်ခြင်း။",
  T_46_META_WS_E_LIGHTBEAM: "အလင်းတန်း",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "အလင်းတန်း",
  T_46_META_WS_E_LIGHTEFFECT: "အလင်းသက်ရောက်မှု",
  T_46_META_WS_E_LIGHTNING: "번개",
  T_46_META_WS_E_LIMB: "ခြေလက်အင်္ဂါများ",
  T_46_META_WS_E_LINE: "선",
  T_46_META_WS_E_LIQUID: "액체",
  T_46_META_WS_E_LOCAL: "ပြည်တွင်း",
  T_46_META_WS_E_LOCALPOSITION: "ဒေသခံအနေအထား",
  T_46_META_WS_E_LOCK: "သော့ခတ်",
  T_46_META_WS_E_LONGBOX: "긴 나무 상자",
  T_46_META_WS_E_LOOP: "ပတ်လည်",
  T_46_META_WS_E_LOOTITEMBOX: "로트 무기",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "로트 탄약",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "로트 방어구",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "로트 소모품",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "로트 던질 물건",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "로트 스코프",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "ရေခဲဂရိနိတ်",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "လက်ရှိဂိုးယူသီးနဲ့ဘောလုံးဆွဲယူခြင်း",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "ဘောလုံးကြံ့ခိုင်မှု",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "랜덤 무기 루트",
  T_46_META_WS_E_LOSE: "ရှုံးနိမ့်ခြင်း",
  T_46_META_WS_E_LOUDSPEAKER: "တံပိုး",
  T_46_META_WS_E_LOWFALLING: "နိမ့်ကျခြင်း။",
  T_46_META_WS_E_M1014: "HeatGun",
  T_46_META_WS_E_M10142: "GOLD_HEATGUN_I",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "GOLD_SCAR_III",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "M79 ဂရိနိတ်",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "M79 အထူးဂရိနိတ်",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "စက်သေနတ်",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "မဂ္ဂဇင်း1",
  T_46_META_WS_E_MAGEZINE2: "မဂ္ဂဇင်း2",
  T_46_META_WS_E_MAGEZINE3: "မဂ္ဂဇင်း3",
  T_46_META_WS_E_MAGMAA: "마그마 A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "ပုံကြီး",
  T_46_META_WS_E_MALE: "အထီး",
  T_46_META_WS_E_MARK: "အမှတ်အသား",
  T_46_META_WS_E_MARKER: "အမှတ်စံ",
  T_46_META_WS_E_MASK: "မျက်နှာအလှဆင်ခြင်း",
  T_46_META_WS_E_MAXVALUE: "최대값",
  T_46_META_WS_E_MECHANICAL: "စိန်အတူအပေါ်မှတည်ထောင်မှု ၂",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "စက်ပိုင်းဆိုင်ရာဆန့်ကျင်မှု",
  T_46_META_WS_E_MEDICALPROPS: "ဆေးပစ္စည်းများ",
  T_46_META_WS_E_MEDICALTENT: "의료 텐트",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "များသောစိတ်ခုန်",
  T_46_META_WS_E_MEDKIT: "응급 처치 키트",
  T_46_META_WS_E_MELEE: "근접 전투",
  T_46_META_WS_E_MELEEWEAPONS: "melee လက်နက်များ",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "မိုက်ခရိုဖုန်း",
  T_46_META_WS_E_MIDDLE: "중간",
  T_46_META_WS_E_MINIHANDLE: "မီနီလက်ကိုင်",
  T_46_META_WS_E_MINIMAP: "မိမိစိတ်ကြိုက်ပြုလုပ်နိုင်သည့်မြေပုံ",
  T_46_META_WS_E_MINISENTRY: "မိနစ်စင်ထရီ",
  T_46_META_WS_E_MINVALUE: "최소값",
  T_46_META_WS_E_MISSILEEXPLODE: "ဒုံးလက်နက်အမျိုးအစား",
  T_46_META_WS_E_MISSIONCOMPLETE: "ရေချိုးပြန်လည်ရရှိမှု",
  T_46_META_WS_E_MISTAKE: "အမှား",
  T_46_META_WS_E_MODERATE: "အလယ်အလတ်အခက်အခဲ",
  T_46_META_WS_E_MONEY: "ပိုက်ဆံ",
  T_46_META_WS_E_MONSTER: "ဘီလူး",
  T_46_META_WS_E_MONSTERSPAWN: "သတ္တဝါ ပေါက်ဖွားနေရာ",
  T_46_META_WS_E_MONSTERTRUCK: "မွန်စတာထရပ်ကာ",
  T_46_META_WS_E_MOON: "လ",
  T_46_META_WS_E_MOSQUITO: "မျိုးတောင်",
  T_46_META_WS_E_MOTIONTRAIL: "တင်ပါး",
  T_46_META_WS_E_MOTOBIKE: "မော်တော်ဆိုင်ကယ်",
  T_46_META_WS_E_MOTORBIKE: "ဆိုင်ကယ်",
  T_46_META_WS_E_MOVE: "이동하다",
  T_46_META_WS_E_MOVEMENT: "USP",
  T_46_META_WS_E_MOVINGJOYSTICK: "လှုပ်ရှားမှုဂျိုစတစ်",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "မစ္စတာ V",
  T_46_META_WS_E_MULTIPLIER: "승수",
  T_46_META_WS_E_MULTIPLY: "ပမာဏ",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "곱하고 누적",
  T_46_META_WS_E_MUSHROOM1: "မှို1",
  T_46_META_WS_E_MUSHROOM2: "မှို2",
  T_46_META_WS_E_MUSHROOM3: "မှို3",
  T_46_META_WS_E_MUSHROOM4: "မှို4",
  T_46_META_WS_E_MUSHSHADE: "거대 버섯 군집",
  T_46_META_WS_E_MUSIC: "ဂီတ",
  T_46_META_WS_E_MUZZLE1: "မဇလ်1",
  T_46_META_WS_E_MUZZLE2: "မဇလ်2",
  T_46_META_WS_E_MUZZLE3: "မဇလ်3",
  T_46_META_WS_E_NEAR: "가까운",
  T_46_META_WS_E_NIGHT: "ည",
  T_46_META_WS_E_NOATTACK: "တိုက်ခိုက်မှုမရှိခြင်း",
  T_46_META_WS_E_NODUALWIELDING: "သေနတ်နှစ်လက်တစ်ပြိုင်တည်းမရ",
  T_46_META_WS_E_NOERROR: "အမှားအယွင်းမရှိပါ။",
  T_46_META_WS_E_NONE: "မရှိ",
  T_46_META_WS_E_NORMAL: "တော်ရုံတန်ရုံ",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "Skip Knockdown မရှိပါ။",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "ကျွမ်းကျင်မှု ၇",
  T_46_META_WS_E_OBTAINEDCOINS: "ကူညီရန်",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "ပျက်ကွက်မှု",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "အတူတူသောအဆင့်ရှိရန်",
  T_46_META_WS_E_OILDRUMEXPLODE: "ရေနံစည် ပေါက်ကွဲမှု",
  T_46_META_WS_E_ONCE: "တစ်ကြိမ်",
  T_46_META_WS_E_ONEWAY: "တစ်လမ်း",
  T_46_META_WS_E_OPENFOLDER: "folder ကိုဖွင့်ပါ။",
  T_46_META_WS_E_OPENHIHATS: "오픈 하이햇",
  T_46_META_WS_E_OPENINGBOX: "ဖိအားပုံနှိပ်ချက်",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Kar98K",
  T_46_META_WS_E_OPENINGWARCHEST: "Bizon",
  T_46_META_WS_E_ORANGE: "သင်္ဘောနီ",
  T_46_META_WS_E_ORTHOGONAL: "တိုက်ရိုက်ကျိုးကြောင်းဆောင်ရွက်ခြင်း",
  T_46_META_WS_E_OUTPOST: "경비실",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "칠해진 벽",
  T_46_META_WS_E_PAINTSHIELDSKILL: "UMP",
  T_46_META_WS_E_PALM: "အထည်",
  T_46_META_WS_E_PANEL: "ပန်းကန်",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "ခရီးသွား A",
  T_46_META_WS_E_PASSENGERB: "ခရီးသွား B",
  T_46_META_WS_E_PASSENGERC: "ခရီးသွား C",
  T_46_META_WS_E_PASSIVE: "ပျော့ပျောင်းသော",
  T_46_META_WS_E_PASSIVESKILL: "ပျော့ပျောင်းသောကျွမ်းကျင်မှု",
  T_46_META_WS_E_PATROLWHILEATTACK: "မီးရထားပြီးတိုက်",
  T_46_META_WS_E_PERSONALUAV: "ကိုယ်ပိုင် UAV",
  T_46_META_WS_E_PERSPECTIVE: "ရှုထောင့်မြင်ကွင်း",
  T_46_META_WS_E_PETTABBG: "အိမ်မွေးတိရစ္ဆာန်",
  T_46_META_WS_E_PHASESTART: "အဆင့်စတင်ခြင်း",
  T_46_META_WS_E_PHONEBOOTH: "ဖုန်းခန်း",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "음악 노트 - 피아노",
  T_46_META_WS_E_PIANOKEY2: "음악 노트 - 피아노",
  T_46_META_WS_E_PICKUPS: "အမြန်ချိန်ယူခြင်း",
  T_46_META_WS_E_PICKUPTRUCK: "အက်စ်ယူဗီ",
  T_46_META_WS_E_PILLAR: "콘크리트 기둥",
  T_46_META_WS_E_PIN: "အမှတ်အသား",
  T_46_META_WS_E_PINGPONG: "ပင်းပေါင်",
  T_46_META_WS_E_PIPECORNER: "엘보 파이프",
  T_46_META_WS_E_PIPEINTERSECTION: "교차 파이프",
  T_46_META_WS_E_PISTOL: "권총",
  T_46_META_WS_E_PISTOLAMMO: "ပစ္စည်းသေတ္တာ",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "ချက်ဘားကွင်းလပ်ဘလော့",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "ကစားသမား",
  T_46_META_WS_E_PLUS: "ထည့်ပါ။",
  T_46_META_WS_E_PODIUM: "ပွဲသိုက်",
  T_46_META_WS_E_POISONGAS: "အဆိပ်ဓာတ်ငွေ့",
  T_46_META_WS_E_POISONGASPREDISCARDED: "အဆိပ်ဓာတ်ငွေ့",
  T_46_META_WS_E_PORTAL: "မုခ်ဦး",
  T_46_META_WS_E_POSTACCUMULATOR: "후속 누산기",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "မြန်မြန်တဲ့စိတ်ခုန်",
  T_46_META_WS_E_PREACCUMULATOR: "전 누산기",
  T_46_META_WS_E_PRIMARYWEAPONA: "ပင်မလက်နက် A",
  T_46_META_WS_E_PRIMARYWEAPONB: "ပင်မလက်နက် B",
  T_46_META_WS_E_PRIOREXPLOSION: "ဗုံးမပေါက်ကွဲခင်",
  T_46_META_WS_E_PROFILEWIDGET: "အမည်လိပ်စာ",
  T_46_META_WS_E_PRONE: "မှောက်လျက်",
  T_46_META_WS_E_PUMPKIN: "မီးဖို",
  T_46_META_WS_E_PURPLE: "အဖြူနီ",
  T_46_META_WS_E_QUADRILATERAL: "လေးထောင့်ပုံ",
  T_46_META_WS_E_QUESTIONMARK: "မေးခွန်းအမှတ်အသား",
  T_46_META_WS_E_QUICKCHAT: "အမြန်ပြောဆိုမှု",
  T_46_META_WS_E_QUICKCHATSHOW: "အမြန်ပြောဆိုခြင်းပြခြင်း",
  T_46_META_WS_E_RADIAL180: "ရေဒီယယ် 180°",
  T_46_META_WS_E_RADIAL360: "ရေဒီယယ် 360°",
  T_46_META_WS_E_RADIAL90: "ရေဒီယယ် 90°",
  T_46_META_WS_E_RAMPAGE: "သောင်းကျန်းတယ်။",
  T_46_META_WS_E_RANDOM: "무작위",
  T_46_META_WS_E_RANDOMBUFF: "랜덤 버프",
  T_46_META_WS_E_RANKDOWN: "အဆင့်နှိမ့်ချပါ။",
  T_46_META_WS_E_REACTION: "တုံ့ပြန်မှု",
  T_46_META_WS_E_RECOVER: "ပြန်လည်ရယူပါ။",
  T_46_META_WS_E_RECYCLE: "ပြန်လည်အသုံးပြုပါ။",
  T_46_META_WS_E_RED: "အနီရောင်",
  T_46_META_WS_E_REFINERYTANK: "ရေနွေးထည်",
  T_46_META_WS_E_REFLECTIVECUBE: "ပြန်လည်တုံ့ပြန်သောအထူရောင်အခြေခံဘလော့ 1",
  T_46_META_WS_E_REFRESH: "ပြန်လည်ဆန်းသစ်ပါ။",
  T_46_META_WS_E_RELEASINGSKILL: "Skill Cast VFX",
  T_46_META_WS_E_RELOAD: "ပြန်လည်အသုံးပြုခြင်း",
  T_46_META_WS_E_REMINDER: "သတိပေးသည်။",
  T_46_META_WS_E_REPAIR: "ပြုပြင်ခြင်း။",
  T_46_META_WS_E_REPAIREQUIP: "စက်ပစ္စည်းပြုပြင်ခြင်း။",
  T_46_META_WS_E_REPAIRKIT: "수리 키트",
  T_46_META_WS_E_REPLACER: "အစားထိုး",
  T_46_META_WS_E_REPORT: "သတင်းပို့တယ်။",
  T_46_META_WS_E_REST: "အနားယူပါ။",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "라이드",
  T_46_META_WS_E_RIDICULE: "လှောင်ပြောင်သည်။",
  T_46_META_WS_E_RIDICULEFUNNY: "လှောင်ပြောင်ရယ်စရာ",
  T_46_META_WS_E_RIFLE: "ရိုင်ဖယ်",
  T_46_META_WS_E_RIFLEAMMO: "ရိုင်ဖယ်အမှုန်",
  T_46_META_WS_E_RIGHT: "မှန်တယ်",
  T_46_META_WS_E_RIGHTTRAPEZOID: "ထောင့်မှန် ထောင့်ကွက်",
  T_46_META_WS_E_RING: "링 메커니즘",
  T_46_META_WS_E_RINGPREDISCARDED: "အသံမြည်ခြင်းကို ကြိုတင်စွန့်ပစ်ထားသည်။",
  T_46_META_WS_E_RIPTIDERHYTHM: "ကျွမ်းကျင်မှု ၉",
  T_46_META_WS_E_RISINGPARTICLE: "တက်လာသော အမှုန်များ",
  T_46_META_WS_E_ROADBLOCK: "ဘာရီကိတ်",
  T_46_META_WS_E_ROTATE: "회전하다",
  T_46_META_WS_E_RUNNING: "လည်ပတ်နေသည်",
  T_46_META_WS_E_RUSHTIME: "နတ်ဆိုးကြီး",
  T_46_META_WS_E_SAMURAI: "စမူရိုင်း",
  T_46_META_WS_E_SANDA: "모래 A",
  T_46_META_WS_E_SANDSTRUCTURE: "모래 조각",
  T_46_META_WS_E_SCALE: "스케일",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "ဟောကြား",
  T_46_META_WS_E_SCISSORS: "ကတ်ကြေး",
  T_46_META_WS_E_SCOPE2X: "2x 조준경",
  T_46_META_WS_E_SCOPE4X: "4x 조준경",
  T_46_META_WS_E_SCROLLPANEL: "အရွေ့နောက်ပြား",
  T_46_META_WS_E_SECONDARYWEAPON: "ဒုတိယလက်နက်",
  T_46_META_WS_E_SENSESSHOCKWAVE: "ကျွမ်းကျင်မှု ၁၀",
  T_46_META_WS_E_SERVER: "ဆာဗာ",
  T_46_META_WS_E_SET: "ခန္ဓာကိုယ်ဝတ်စုံ",
  T_46_META_WS_E_SETTING: "တည်ဆောက်သည်",
  T_46_META_WS_E_SETTINGS: "ဆက်တင်များ",
  T_46_META_WS_E_SG: "산탄총",
  T_46_META_WS_E_SGAMMO: "SN 탄약",
  T_46_META_WS_E_SHARPMECHANICAL: "စိန်အတူအပေါ်မှတည်ထောင်မှု ၁",
  T_46_META_WS_E_SHIELD: "ကာကွယ်ရေး",
  T_46_META_WS_E_SHIELDBROKEN: "အကာအရံများကို ဖောက်ထွင်းတိုက်ခိုက်သည်။",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "ဒိုင်းတိုက်ခိုက်မှု",
  T_46_META_WS_E_SHOCKWAVE: "shock wave ၊",
  T_46_META_WS_E_SHOES: "ဖိနပ်",
  T_46_META_WS_E_SHOOTINGTARGET: "이동 표적",
  T_46_META_WS_E_SHORTDATE: "နောက်ဆုံးရက်စွဲ",
  T_46_META_WS_E_SHORTDATETIME: "နောက်ဆုံးရက်စွဲနှင့်အချိန်",
  T_46_META_WS_E_SHORTTIME: "နောက်ဆုံးအချိန်",
  T_46_META_WS_E_SHOTGUN: "သေနတ်ပြောင်း",
  T_46_META_WS_E_SHOTGUNAMMO: "မော်တော်ဆင်ထွက်ပြေးဂုတ်အမြောက်ကျည်ဆံ",
  T_46_META_WS_E_SHOTGUNMUZZLE: "ရှော့ဂန် မဇလ်",
  T_46_META_WS_E_SHOW: "ပြပါ",
  T_46_META_WS_E_SHRUB: "덤불로 덮인 긴 나무 상자",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "ဘေးမှကြည့်ရန်ကင်မရာ",
  T_46_META_WS_E_SIGNAL: "သင်္ကေတ",
  T_46_META_WS_E_SIGNOUT: "အလုပ်ထွက်",
  T_46_META_WS_E_SILENCER: "အသံတိတ်",
  T_46_META_WS_E_SIMPLE: "ရိုးရှင်း",
  T_46_META_WS_E_SIMPLEWIDGET: "ရိုးရှင်းသော ဝိဇ္ဇာ",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "တစ်ခု",
  T_46_META_WS_E_SITEHUT: "컨테이너 하우스",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "AWM2",
  T_46_META_WS_E_SKILLRECOVER: "ကျွမ်းကျင်မှုပြန်လည်ရရှိခြင်း",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Knockdown ကိုကျော်ပါ။",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "ဖြတ်",
  T_46_META_WS_E_SLOPE: "ढलान",
  T_46_META_WS_E_SLOWHEARTBEAT: "သေးငယ်သောစိတ်ခုန်",
  T_46_META_WS_E_SMG: "SMG",
  T_46_META_WS_E_SMGAMMO: "SMG 탄약",
  T_46_META_WS_E_SMGMUZZLE: "SMG မဇလ်",
  T_46_META_WS_E_SMILEY: "အပြုံးမျက်နှာ",
  T_46_META_WS_E_SMOKE: "မီးခိုး",
  T_46_META_WS_E_SMOKEGRENADE: "연막탄",
  T_46_META_WS_E_SMOKEY: "မီးခိုး",
  T_46_META_WS_E_SMOOTH: "ပုံမှန်ဖြစ်ပေါ်ခြင်း",
  T_46_META_WS_E_SNAMMO: "SN 탄약",
  T_46_META_WS_E_SNARES: "스네어 드럼",
  T_46_META_WS_E_SNEAKERS: "အပြေးဖိနပ် VFX",
  T_46_META_WS_E_SNIPER: "စနိုက်ပါရိုင်ဖယ်",
  T_46_META_WS_E_SNIPERAMMO: "ထောက်လှမ်းရိုက် ကွင်းဗန်းအမြောက်ကျည်ဆံ",
  T_46_META_WS_E_SNOWA: "눈 A",
  T_46_META_WS_E_SNOWFLAKE: "နှင်းပွင့်",
  T_46_META_WS_E_SOCCER: "ဘောလုံး",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "လူမှုရေးကိရိယာ",
  T_46_META_WS_E_SOLARPANEL: "태양광 패널",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "အကြောင်းအရာ",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "အနိမ့်ဆုံးစီစဉ်",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Spawn Point VFX",
  T_46_META_WS_E_SPEAKER: "ဟော်ပေါင်းစည်းမှု",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "VSK94",
  T_46_META_WS_E_SPECIALGUN: "အထူးသီးသန့် သေနတ်",
  T_46_META_WS_E_SPHERE: "စက်လုံး",
  T_46_META_WS_E_SPHERETRIGGER: "ဘောလုံးတိုက်မှုထိန်းချုပ်သူ",
  T_46_META_WS_E_SPIDERWEB: "ကျွမ်းကျင်မှု VFX",
  T_46_META_WS_E_SPORTSCAR: "အားကစားကား",
  T_46_META_WS_E_SPOTLIGHT: "အလင်း",
  T_46_META_WS_E_SPREADOFPOISONGAS: "အဆိပ်ဓာတ်ငွေ့ကို ဖြန့်ထုတ်ခြင်း။",
  T_46_META_WS_E_SPRINT: "ရွှန်းလဲ့",
  T_46_META_WS_E_SQUARE: "စတုရန်း",
  T_46_META_WS_E_SQUAREBOX: "정사각형 나무 상자",
  T_46_META_WS_E_SR: "저격소총",
  T_46_META_WS_E_STABLE: "အဘိဿယအိမ်",
  T_46_META_WS_E_STAIRS: "မိုးကျောကြိုး",
  T_46_META_WS_E_STANDING: "ရပ်နေသည်။",
  T_46_META_WS_E_STAR: "ကြယ်ပွင့်",
  T_46_META_WS_E_STATIC: "များသော",
  T_46_META_WS_E_STATUSTRIGGER: "သေမှု သို့မဟုတ် မပြတ်တောက်မှု ကိရိယာ",
  T_46_META_WS_E_STEP: "လက်သုံးရင်ခွင့်",
  T_46_META_WS_E_STEPTRIGGER: "ထောင်ချောက်ပေါ်တက်",
  T_46_META_WS_E_STOCK_S: "စတော့ခ် S",
  T_46_META_WS_E_STOCK_SR: "စတော့ခ် SR",
  T_46_META_WS_E_STOCK1: "စတော့ခ်1",
  T_46_META_WS_E_STOCK2: "စတော့ခ်2",
  T_46_META_WS_E_STOCK3: "စတော့ခ်3",
  T_46_META_WS_E_STONE: "ကျောက်စာ",
  T_46_META_WS_E_STONEBRIDGE: "သရေချယ်တံတား",
  T_46_META_WS_E_STONELANTERN: "궁전 등불",
  T_46_META_WS_E_STONESPLASH: "ပျံသန်းနေသော အပျက်အစီးများ",
  T_46_META_WS_E_STORE: "ဆိုင်",
  T_46_META_WS_E_STREETLAMP: "가로등",
  T_46_META_WS_E_STYLEA: "စတိုင် A",
  T_46_META_WS_E_STYLEB: "စတိုင် B",
  T_46_META_WS_E_STYLEC: "စတိုင် C",
  T_46_META_WS_E_SUBMACHINEGUN: "SMG",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "ဆိုင်စုံသေနတ်အမြောက်ကျည်ဆံ",
  T_46_META_WS_E_SUCCESSFULHIT: "ရိုက်တယ်။",
  T_46_META_WS_E_SUN: "နေ",
  T_46_META_WS_E_SUNSHADE: "ပင်လယ်ပြင်အရပ်နဲ့စုစည်းမှု",
  T_46_META_WS_E_SUPERCAR: "အားကစားကား",
  T_46_META_WS_E_SUPERMARKET: "စူပါမားကတ်",
  T_46_META_WS_E_SURPRISEFIND: "အခိုက်အတန့်ကိုရှာဖွေပါ",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "အမြန်လက်နက်ပြောင်းလဲခြင်း",
  T_46_META_WS_E_SWIMRING: "ရေကူးလက်စွပ်",
  T_46_META_WS_E_SWORD: "ဓား",
  T_46_META_WS_E_SYMBOLIC: "မြေပြင်အမှတ်အသား",
  T_46_META_WS_E_TANKZOMBIE: "တိုက်တပ်ဆင်ဇွန်းဘီ",
  T_46_META_WS_E_TAP: "ဖိအား",
  T_46_META_WS_E_TAPPINGBUTTON: "ထိခိုက်မှု",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "AWM",
  T_46_META_WS_E_TEAM: "팀",
  T_46_META_WS_E_TEAMMATESINFO: "အသင်းဖော်အချက်အလက်",
  T_46_META_WS_E_TELEPORT: "တယ်လီပို့",
  T_46_META_WS_E_TELEPORTCORRECT: "အထူးလက်ကျွမ်းရောင်ဖန်တီး",
  T_46_META_WS_E_TELEPORTWRONG: "ပစ္စည်းရယူပါ",
  T_46_META_WS_E_TEXT: "စာသား",
  T_46_META_WS_E_TEXTOBJECT: "စာသား",
  T_46_META_WS_E_TEXTUREWIDGET: "ဖျားယွင်း",
  T_46_META_WS_E_THERMALSCOPE: "열화상 조준경",
  T_46_META_WS_E_THIRDPERSON: "တတိယပုဂ္ဂိုလ်အမြင်ကင်မရာ",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "တတိယပုဂ္ဂိုလ်အမြင်ကင်မရာ (ရှေးဟောင်း)",
  T_46_META_WS_E_THIRDPERSONLOCK: "တတိယပုဂ္ဂိုလ်ဖြင့်တည်ငြိမ်သောကင်မရာ",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "တွဲဖက်စွမ်းဆောင်ရည်များအတွက် ပစ်ဓား2",
  T_46_META_WS_E_THRILLBATTLE: "ကျွမ်းကျင်မှု ၅",
  T_46_META_WS_E_THROWATTACK: "ဂရိနိတ်ပစ်ပေးပါ",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "အနီရောင် ပစ်ဇွန်းဘီ",
  T_46_META_WS_E_THROWZOMBIE: "ပစ်ဇွန်းဘီ",
  T_46_META_WS_E_THUMBSUP: "ကြိုက်တယ်။",
  T_46_META_WS_E_THUNDER: "လျှပ်စစ်ရှော့ခ်",
  T_46_META_WS_E_TILEA: "타일 A",
  T_46_META_WS_E_TILEB: "타일 B",
  T_46_META_WS_E_TILEC: "타일 C",
  T_46_META_WS_E_TILED: "အပြုံး",
  T_46_META_WS_E_TIPSSOUND: "မှန်ကန်သောရေချိုးသည်ဒသမထွက်ခြင်း",
  T_46_META_WS_E_TOGGLEWIDGET: "ခလုတ်ပြောင်းလဲမှု",
  T_46_META_WS_E_TOILETBOWL: "변기",
  T_46_META_WS_E_TONEA: "돌 A",
  T_46_META_WS_E_TOP: "အထက်ပိုင်းဝတ်စုံ",
  T_46_META_WS_E_TOPDOWN: "အထက်မှကြည့်ရန်ကင်မရာ",
  T_46_META_WS_E_TORII: "토리",
  T_46_META_WS_E_TOUCHPADWIDGET: "လက်သုံးထိုးကြိုး",
  T_46_META_WS_E_TOWER: "ရဲတိုက်",
  T_46_META_WS_E_TPIPE: "T 파이프",
  T_46_META_WS_E_TRACINGSTEPS: "ကျွမ်းကျင်မှု ၃",
  T_46_META_WS_E_TRAILER: "트레일러",
  T_46_META_WS_E_TRANSFORMATION: "ရုပ်ပြောင်းလဲမှု",
  T_46_META_WS_E_TRANSPARENT: "ပေါ့ပါးသော",
  T_46_META_WS_E_TRAPEZOID: "trapezoid",
  T_46_META_WS_E_TRASHCAN: "쓰레기통",
  T_46_META_WS_E_TRIANGLE: "တြိဂံ",
  T_46_META_WS_E_TRIGGERS: "အစပျိုး",
  T_46_META_WS_E_TRIPLE: "သုံးဆ",
  T_46_META_WS_E_TROPHY: "ဆုဖလား",
  T_46_META_WS_E_TRUE: "ဟုတ်တယ်",
  T_46_META_WS_E_TUKTUK: "tuk tuk",
  T_46_META_WS_E_TUTUCAR: "တက်တက်",
  T_46_META_WS_E_TYRANTZOMBIE: "အကြမ်းဖက်ဇွန်းဘီ",
  T_46_META_WS_E_UAVLITE: "ပေါ့ပါးသော UAV",
  T_46_META_WS_E_UIFINISH: "ဂိမ်းရပ်နားမှု ၂",
  T_46_META_WS_E_UITAP: "Interface ကိုနှိပ်ပါ။",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "ဦးစီးထုတ်လုပ်သူ",
  T_46_META_WS_E_UPWARDTURBULENCE: "အဆင့်မြှင့်တင်မှု",
  T_46_META_WS_E_USP: "GOLD_M1014_I",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "ကျော်ပြေးခြင်း",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "ယာဉ်",
  T_46_META_WS_E_VEHICLEEXPLODE: "ယာဉ်ပေါက်ကွဲမှု",
  T_46_META_WS_E_VELOCITY: "속도",
  T_46_META_WS_E_VENDINGMACHINE: "အရောင်းစက်",
  T_46_META_WS_E_VERTICAL: "တိုက်ခိုက်",
  T_46_META_WS_E_VEST: "ကာကွယ်ရေးဝတ်စုံ",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "ကာကွယ်ရေးဝတ်စုံ4",
  T_46_META_WS_E_VISUALEFFECTS: "ဗိသုကာဆန်းသစ်မှုများ",
  T_46_META_WS_E_VSK94: "GOLD_SCAR_II",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "벽 A",
  T_46_META_WS_E_WALLBRAWL: "ကျွမ်းကျင်မှု ၂",
  T_46_META_WS_E_WARNING: "သတိပေး",
  T_46_META_WS_E_WATERRING: "ရေပက်",
  T_46_META_WS_E_WAVE1: "လှိုင်း1",
  T_46_META_WS_E_WAVE2: "လှိုင်း2",
  T_46_META_WS_E_WAVE3: "လှိုင်း3",
  T_46_META_WS_E_WEAPONGENERATOR: "လက်နက်",
  T_46_META_WS_E_WEAPONSLOT: "လက်နက်တပ်ဆင်ရာနေရာ",
  T_46_META_WS_E_WHISTLE: "အစားထိုးသွင်းပါ",
  T_46_META_WS_E_WIDERANGE: "ကျယ်ပြန့်သည်။",
  T_46_META_WS_E_WIN: "အနိုင်ရရှိခြင်း",
  T_46_META_WS_E_WINDATTACK: "လေပွေ",
  T_46_META_WS_E_WOODA: "나무 A",
  T_46_META_WS_E_WOODCUTZOMBIE: "သစ်ခုတ်ဇွန်းဘီ",
  T_46_META_WS_E_WOODENPLANK: "나무 다리",
  T_46_META_WS_E_WORLDPOSITION: "ကမ္ဘာ့စနစ်",
  T_46_META_WS_E_WRECKEDBUS: "폐버스",
  T_46_META_WS_E_WRECKEDCAR: "폐차",
  T_46_META_WS_E_WRONG: "မှားတယ်။",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "ဇိုမီး",
  T_46_META_WS_E_ZOMBIES: "သစ်သီး",
  T_46_META_WS_E_ZOOM: "ရှုထောင့်ထိန်းညှိခြင်း",
  T_46_META_WS_ELIMINATE: "သတ်ခြင်း",
  T_46_META_WS_ELIMINATEDENTITY: "ဖယ်ရှားခံရသောအဖွဲ့",
  T_46_META_WS_ELIMINATEDPLAYER: "ဖယ်ရှားခံရသူကစားသမား",
  T_46_META_WS_ENABLEDEFAULTBTREE: "ကုန္ဆုံးလုပ်ဆောင်မှုသစ်ကိုဖွင့်ပါ",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "လှုပ်ရှားလုံခြုံဒေသဖွင့်ခြင်း",
  T_46_META_WS_ENABLESAFEZONE: "လုံခြုံဒေသဖွင့်ခြင်း",
  T_46_META_WS_ENDCURRENTPHASE: "လက်ရှိအဆင့်အဆုံးသတ်ခြင်း",
  T_46_META_WS_ENDMORPH: "ပြောင်းလဲမှုကိုဖျက်ပါ",
  T_46_META_WS_ENDPOSITION: "နောက်ဆုံးနေရာ",
  T_46_META_WS_ENTERVEHICLE: "ကားထဲသို့ ဝင်",
  T_46_META_WS_ENTITY: "အဖွဲ့ဝင်",
  T_46_META_WS_EQUIPMENTID: "ပစ္စည်း ID",
  T_46_META_WS_EULERANGLETOQUATERNION: "သံချပ်မှ ကွာတွန်း",
  T_46_META_WS_EXITVEHICLE: "ပစ္စည်းကို လွှတ်ပါ",
  T_46_META_WS_EXPONENTIATION: "မျှင် အမြတ်နှုန်း",
  T_46_META_WS_FILTERENTITY: "အစိတ်အပိုင်းကိုစီမံပါ",
  T_46_META_WS_FILTERLEVELOBJECTS: "အဆင့်အလိုက်အရာဝတ္ထုများစစ်ထုတ်ခြင်း",
  T_46_META_WS_FIND: "ရှာပါ",
  T_46_META_WS_FINDAT: "သည်နေရာတွင်ရှာပါ",
  T_46_META_WS_FINDPATH: "လမ်းညွှန်မှု ရှာဖွေ",
  T_46_META_WS_FLOOR: "ထောက်ပံ့မူမတည်သူများ",
  T_46_META_WS_FOOTBALLGOAL: "ဘောလုံးဂိုး",
  T_46_META_WS_FORMAT: "စာသားဖော်မတ်ပြောင်းခြင်း",
  T_46_META_WS_GETALLKEYS: "key အားလုံးရယူခြင်း",
  T_46_META_WS_GETALLPLAYERS: "ကစားသမားအားလုံး",
  T_46_META_WS_GETALLSHOPS: "အပေါ်တွင်စျေးနှုန်းများရယူပါ",
  T_46_META_WS_GETALLTEAMS: "အသင်းအားလုံး",
  T_46_META_WS_GETATTACKABLEENTITY: "ရှုံးနိုင်သောအရာများရယူပါ",
  T_46_META_WS_GETATTACKABLEFACTIONS: "လုပ်ဆောင်ရန်နိုင်သောအဖွဲ့ရယူပါ",
  T_46_META_WS_GETBACKPACKSKIN: "အိတ်အသားရေ ဖယ်ရှား",
  T_46_META_WS_GETBLACKBOARDVALUE: "အနက်တံများ ရယူ",
  T_46_META_WS_GETBUFFS: "Buff ရယူ",
  T_46_META_WS_GETCHATCHANNEL: "စကားဝိုင်းချန်နယ်ရယူပါ",
  T_46_META_WS_GETCHILDBYINDEX: "နံပါတ်နှင့်ကလေးရယူ",
  T_46_META_WS_GETCHILDBYNAME: "နာမည်နှင့်ကလေးရယူ",
  T_46_META_WS_GETCHILDREN: "ကလေးများရယူ",
  T_46_META_WS_GETCOLORCHANNEL: "အရောင်နယ်စွဲကိုရယူပါ",
  T_46_META_WS_GETCONSUMABLES: "သုံးစွဲပစ္စည်းရယူ",
  T_46_META_WS_GETCULLINGMASK: "ကင်မရာ Mask ကို ရယူ",
  T_46_META_WS_GETCURRENTCAMERA: "လက်ရှိကင်မရာကိုရယူပါ",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "လက်ရှိစကားဝိုင်းချန်နယ်ရယူပါ",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "အရေးကြီးမှု ရှာဖွေမှု",
  T_46_META_WS_GETDYEDCOUNT: "ဆေးခြယ်မှုရေတွက်",
  T_46_META_WS_GETDYEDSTATUS: "ဆေးခြယ်ခြင်းအခြေအနေ",
  T_46_META_WS_GETEQUIPMENTS: "အကိရိယာရယူ",
  T_46_META_WS_GETFACTION: "အဖွဲ့စည်းရယူပါ",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "အဆောက်အအုံဖန်တီး",
  T_46_META_WS_GETITEMCOUNT: "ထုတ်ယူထားသောကိရိယာ",
  T_46_META_WS_GETLOADEDSCENES: "ဖိန်းဆော့တီ",
  T_46_META_WS_GETLOCALAIMDIRECTION: "ဖိန်းဆော့တီ ဖန်တီး",
  T_46_META_WS_GETLOCALPLAYER: "မိမိမှတ်တမ်းပြုလုပ်",
  T_46_META_WS_GETLOCALTIMESTAMP: "စည်းမျဉ်းပြုလုပ်",
  T_46_META_WS_GETMAPID: "မြေပုံ ID ရယူပါ",
  T_46_META_WS_GETMINIMAP: "မိုဃ်းကုပြဇာတ်ရယူပါ",
  T_46_META_WS_GETMONEY: "ငွေရယူပါ",
  T_46_META_WS_GETMONEYCOUNT: "ငွေရေအားအရေအတွက်ရယူပါ",
  T_46_META_WS_GETMORPH: "ပြောင်းလဲမှုရယူပါ",
  T_46_META_WS_GETNODEVARIABLE: "Node ပြုပြင်မှု ရယူ",
  T_46_META_WS_GETOUTFIT: "အဝတ်ပြင်",
  T_46_META_WS_GETOWNER: "စမ်းသပ်မှတ်တမ်းများ",
  T_46_META_WS_GETPARENT: "မိဘရယူ",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "ထုတ်ယူမှုများ",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "ပြီးစီးခြင်း",
  T_46_META_WS_GETRESULTFROMCURVE: "အသံ ဖျက်",
  T_46_META_WS_GETSCENESKYBOX: "ရှင်ဆဲဘော့ကိုရယူပါ",
  T_46_META_WS_GETSERVERREGION: "ကြိမ်နှုန်းထိရောက်မှု",
  T_46_META_WS_GETSERVERTIMESTAMP: "ထိရောက်သောစမ်းသပ်မှု",
  T_46_META_WS_GETSKELETONPARTBYNAME: "အမှတ်နှစ်ဖက်ဖြင့်",
  T_46_META_WS_GETSKILLS: "ကျွမ်းကျင်မှုရယူ",
  T_46_META_WS_GETSLEEPTHRESHOLD: "အိပ်ရာထိန်းသိမ်း",
  T_46_META_WS_GETTOKENCOUNT: "Token အရေအတွက်ရယူခြင်း",
  T_46_META_WS_GETTOKENCOUNTTODAY: "ယနေ့ Token အရေအတွက်ရယူခြင်း",
  T_46_META_WS_GETTYPE: "အမျိုးအစားရယူပါ",
  T_46_META_WS_GETVEHICLESKIN: "ကားဖုံးရေတွက်",
  T_46_META_WS_GETWALLET: "ဘဏ်အိတ်ရယူပါ",
  T_46_META_WS_GETWEAPONSKIN: "အမူကြေးနွယ်ပြင်",
  T_46_META_WS_GETWIDGETBYPATH: "လမ်းကြောင်းမှ ဝစ်ဂျက်ရယူပါ",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "လုံခြုံမှတ်တမ်းများ",
  T_46_META_WS_GIVEJAILBREAKITEM: "ထောင်ပြတ်ပစ္စည်းပေး",
  T_46_META_WS_GIVEJAILBREAKREWARD: "ထောင်ပြတ်ဆုပေး",
  T_46_META_WS_HASAOISPECIALFOLLOW: "အထူးပြုလို့",
  T_46_META_WS_HASCOMPONENT: "ပိုင်းခြားရေးတစ်ခုရှိသည်",
  T_46_META_WS_HASSCRIPT: "စာမူရှိပါသလား",
  T_46_META_WS_HASTAG: "အမှတ်အသားပါသလား",
  T_46_META_WS_HELPEDPLAYER: "ကူညီခံရသူကစားသမား",
  T_46_META_WS_HELPPLAYER: "ကူညီသူကစားသမား",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "အရုပ်အဆင်ပြင်စုကိုဖျောက်ပါ",
  T_46_META_WS_HITENTITY: "ထိမှန်သောအဖွဲ့ဝင်",
  T_46_META_WS_HITFLY: "အဝတ်ရယူ",
  T_46_META_WS_HITNORMAL: "ထိခိုက်မှုရိုးတံ",
  T_46_META_WS_HITOBJECT: "ထိခိုက်သောပစ္စည်း",
  T_46_META_WS_HITPOSITION: "ထိခိုက်သောနေရာ",
  T_46_META_WS_INDEXOF: "ပေါင်းထည့်မှုများ",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "ထိရောက်သောကိရိယာ",
  T_46_META_WS_INSERT: "ထည့်ပါ",
  T_46_META_WS_ISATTACKABLE: "ရှုံးနိုင်ပါသလား",
  T_46_META_WS_ISCHATCHANNELEMPTY: "စကားဝိုင်းချန်နယ်ထုတ်လား",
  T_46_META_WS_ISEQUAL: "တူညီပါ",
  T_46_META_WS_ISFRIEND: "ပုံမှန် စီမံထိန်းသိမ်းမှု",
  T_46_META_WS_ISHIT: "ထိမှန်သော်",
  T_46_META_WS_ISINSIDEBOX: "အထူဖြစ်ခြင်း",
  T_46_META_WS_ISINSIDECYLINDER: "ဆလင်ဒါအတွင်းရှိခြင်း",
  T_46_META_WS_ISINSIDESECTOR: "စက်ကွင်းအတွင်းရှိခြင်း",
  T_46_META_WS_ISINSIDESPHERE: "ကွင်းဝိုင်းအတွင်းရှိခြင်း",
  T_46_META_WS_ISSLEEPING: "အိပ်နေမှုရှိ",
  T_46_META_WS_ISSUBTYPEOF: "အမျိုးအစားရောက်သည်",
  T_46_META_WS_ITEM: "အဖွဲ့ဝင်",
  T_46_META_WS_ITEMID: "ပစ္စည်း ID",
  T_46_META_WS_JOIN: "ပေါင်းပါ",
  T_46_META_WS_JOINCHATCHANNEL: "စကားဝိုင်းချန်နယ်တွင်ဝင်ပါ",
  T_46_META_WS_JOINFACTION: "အဖွဲ့စည်းတွင်ဝင်ပါ",
  T_46_META_WS_LASTINDEXOF: "အပေါ်ယံလမ်းကြောင်း",
  T_46_META_WS_LENGTH: "အရှည်",
  T_46_META_WS_LERP: "တံဆိပ်ခတ်",
  T_46_META_WS_LOADSCENE: "အစင်ကိုโหลดပါ",
  T_46_META_WS_LOGARITHM: "ရောဂါ ရှာဖွေမှု",
  T_46_META_WS_LOGERROR: "ကြော်ငြာကိုဖန်တီးပါ",
  T_46_META_WS_LOGINFO: "အချက်အလက်မှတ်သားခြင်း",
  T_46_META_WS_LOGWARNING: "ထိုအတွက် ဆောင်းပါးပြုလုပ်",
  T_46_META_WS_LOOKROTATION: "ပစ်မှတ်သို့ လှည့်ကြည့်မှု",
  T_46_META_WS_MAGNITUDE: "စာရင်းများကိုအရေးပေးထား",
  T_46_META_WS_MAKER: "ဖန်တီးသူ",
  T_46_META_WS_MAX: "အနိမ့်ဆုံး",
  T_46_META_WS_MECHANISM: "စက်ရုပ်",
  T_46_META_WS_MIN: "ကိန်းတွက်ချက်",
  T_46_META_WS_MONSTERUSESKILL: "ကျွမ်းကျင်မှု အသုံးပြုပါ",
  T_46_META_WS_MORPHOBJECT: "ပုံသဏ္ဌာန်ပြောင်းသောပစ္စည်း",
  T_46_META_WS_MORPHTO: "ပုံစံသို့ပြောင်းပါ",
  T_46_META_WS_MORPHTOBYITEMID: "ပစ္စည်း ID ဖြင့် ပြောင်းပါ",
  T_46_META_WS_MOVECCT: "CCT ပြောင်း",
  T_46_META_WS_MOVEPOSITION: "အရပ်သတ်မှတ်",
  T_46_META_WS_MOVEROTATION: "အရပ်တိုက်",
  T_46_META_WS_MULTIPLYQUATERNION: "ကွာတွန်းများမြှင့်တင်",
  T_46_META_WS_MULTIRAYCAST: "ဆန့်စမ်းချက်များ",
  T_46_META_WS_NEGATE: "ထိထိရောက်ရောက်သောမှတ်တမ်းများ",
  T_46_META_WS_NEW: "တင်ထားသည့်မက်စ်",
  T_46_META_WS_NODENAME: "နုဒ်အမည်",
  T_46_META_WS_NORMALIZE: "ကွဲပြားချက်တွေထည့်ထားတဲ့ကိရိယာ",
  T_46_META_WS_NOTIFYPLAYEFFECT: "ပျက်စီးသောစာမျက်နှာ",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "အစိတ်အပိုင်းတိုးချဲ့",
  T_46_META_WS_NOTIFYPLAYSOUND: "ပျက်စီးမှုများ",
  T_46_META_WS_NOTIFYSHOWTIPS: "အဆုံးသတ်ပြီးစီးမှု",
  T_46_META_WS_NUMTOSTRING: "နံပါတ်ကို စာသားအဖြစ်ပြောင်းပါ",
  T_46_META_WS_ONACCESSEQUIPMENT: "စက်ကိရိယာဝင်ရောက်ခြင်း",
  T_46_META_WS_ONACCESSITEM: "ပစ္စည်းရယူ",
  T_46_META_WS_ONACCESSWEAPON: "လက်နက်ရ",
  T_46_META_WS_ONACE: "အခြေအနေပြန်လည်ထိန်းချုပ်ခြင်း",
  T_46_META_WS_ONAIMED: "ညွှန်ပြပြီး",
  T_46_META_WS_ONAIMING: "ညွှန်ပြ",
  T_46_META_WS_ONASSIST: "အကူညီပေးခြင်း",
  T_46_META_WS_ONATTACK: "တိုက်ခိုက်",
  T_46_META_WS_ONATTACKSTOP: "တိုက်ခိုက်ရပ်",
  T_46_META_WS_ONAWAKE: "ဖျက်သိမ်းခြင်း",
  T_46_META_WS_ONBEKNOCKEDDOWN: "အရာဝတ္ထုပျက်စီးခြင်း",
  T_46_META_WS_ONBOUNCEDBYTIRE: "ဘီးပြန်လှန်",
  T_46_META_WS_ONBOUNCEENTITY: "ပြန်လှန်",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "အရာဝတ္ထုထွက်ခွာခြင်း",
  T_46_META_WS_ONBULLETHIT: "ကျည်ဆံထိ",
  T_46_META_WS_ONCAMERARAYCAST: "ကင်မရာရေခံ",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "ပြီးဆုံး",
  T_46_META_WS_ONCHASE: "လိုက်လံခြင်း",
  T_46_META_WS_ONCHASESTOP: "လိုက်လံရပ်",
  T_46_META_WS_ONCLIPEND: "ကလစ်ဖျက်",
  T_46_META_WS_ONCOLLISIONENTER: "ကြိုးစားခြင်း",
  T_46_META_WS_ONCOLLISIONEXIT: "ကြိုးစားမှုမတိုင်မီ",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "အကန့်သတ်ပြည့်စုံ",
  T_46_META_WS_ONCREEP: "မြေချ",
  T_46_META_WS_ONCROUCH: "ထိုင်",
  T_46_META_WS_ONDEALDAMAGE: "ကစားသမားဝင်ရောက်ခြင်း",
  T_46_META_WS_ONDESTROY: "ဖွင့်လှစ်ခြင်း",
  T_46_META_WS_ONDISABLE: "ဖျက်သိမ်းခြင်း",
  T_46_META_WS_ONDISCONNECT: "ချိတ်ပြတ်",
  T_46_META_WS_ONDOUBLETAPPED: "နှစ်ချက်နှိပ်",
  T_46_META_WS_ONDRAG: "ဆွဲချည်",
  T_46_META_WS_ONDRAGEND: "ဆွဲချည်ပြီးဆုံး",
  T_46_META_WS_ONDRAGSTART: "ဆွဲချည်စတင်",
  T_46_META_WS_ONDRIVED: "ယာဉ်မောင်း",
  T_46_META_WS_ONDRIVEVEHICLE: "ယာဉ်မောင်း",
  T_46_META_WS_ONDROPCONSUMABLE: "ပစ္စည်းလွှင့်",
  T_46_META_WS_ONDROPPED: "လွှတ်ပစ်",
  T_46_META_WS_ONDROPWEAPON: "လက်နက်လွှင့်",
  T_46_META_WS_ONEACHLOOP: "တစ်ခါတိုင်းအကြိမ်",
  T_46_META_WS_ONELIMINATE: "ကစားသမားထွက်ခွာခြင်း",
  T_46_META_WS_ONELIMINATED: "ထိခိုက်မှုသိမ်းဆည်းခြင်း",
  T_46_META_WS_ONENABLE: "ပိတ်သိမ်းခြင်း",
  T_46_META_WS_ONEND: "ပြီးဆုံးခြင်း",
  T_46_META_WS_ONENTERED: "ယာဉ်ဝင်",
  T_46_META_WS_ONENTERVEHICLE: "ယာဉ်ဝင်",
  T_46_META_WS_ONENTITYENTER: "ပစ်မှတ်ဝင်ရောက်ခြင်း",
  T_46_META_WS_ONENTITYEXIT: "ပစ်မှတ်ထွက်ခွာခြင်း",
  T_46_META_WS_ONEQUIPARMOR: "လက်နက်ကာကွယ်ရေးဝတ်ဆင်ခြင်း",
  T_46_META_WS_ONEQUIPED: "ဝတ်ဆင်",
  T_46_META_WS_ONEQUIPWEAPON: "လက်နက်ဝတ်ဆင်ခြင်း",
  T_46_META_WS_ONEXPLODE: "ပေါက်ကွဲ",
  T_46_META_WS_ONFALL: "ကျောသွားသောအခါ",
  T_46_META_WS_ONFALLSTOP: "ကျောသွားခြင်းအပြီးတွင်",
  T_46_META_WS_ONFIRE: "အကြိမ်တိုင်းပစ်ခတ်",
  T_46_META_WS_ONFIXEDUPDATE: "အချိန်ပြင်မီမွမ်းမံ",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "ဘောလုံးတိုက်",
  T_46_META_WS_ONFRIENDSUPDATE: "သူငယ်ချင်းအခြေအနေမွမ်းမံ",
  T_46_META_WS_ONGAMEEND: "ဂိမ်းအဆုံးသတ်ခြင်း",
  T_46_META_WS_ONGAMEPAUSE: "ဂိမ်းရပ်တန့်",
  T_46_META_WS_ONGAMERESUME: "ဂိမ်းပြန်လည်စ",
  T_46_META_WS_ONGAMESTART: "ဂိမ်းစတင်ခြင်း",
  T_46_META_WS_ONGOAL: "ဂိုးသွင်း",
  T_46_META_WS_ONHITBYBULLET: "ကျည်ဆံထိ",
  T_46_META_WS_ONHITFLY: "ပျံထိ",
  T_46_META_WS_ONHITFLYENTITY: "ပျံထိ",
  T_46_META_WS_ONHOOKGUNFIRE: "ခေါင်းမောင်းပစ်ခြင်း",
  T_46_META_WS_ONIDLE: "ပျက်ကွက်",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "ကျဉ်းထောင်ပြတ်စတင်",
  T_46_META_WS_ONJAILBREAKAREAEND: "ကျဉ်းထောင်ပြတ်ဆုံး",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "ကျဉ်းထောင်ပြတ်ဝင်",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "ကျဉ်းထောင်ပြတ်ထွက်",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "ဝိုင်းဝင်အောင်",
  T_46_META_WS_ONJOYSTICKMOVE: "ဂျိုစတစ်ရွေ့ခြင်း",
  T_46_META_WS_ONJOYSTICKPRESSED: "ဖိမိ",
  T_46_META_WS_ONJOYSTICKRELEASED: "လွှတ်လိုက်",
  T_46_META_WS_ONJUMP: "ခုန်",
  T_46_META_WS_ONJUMPSTOP: "အဖျက်အပြီးတွင်",
  T_46_META_WS_ONLANDMINEACTIVE: "မြေမြေပေါ်မိုင်းစတင်",
  T_46_META_WS_ONLANDMINETRIGGER: "မြေမြေပေါ်မိုင်းဖွင့်",
  T_46_META_WS_ONLEAVECHATCHANNEL: "စကားဝိုင်းထွက်",
  T_46_META_WS_ONLEAVEVEHICLE: "ယာဉ်ထွက်",
  T_46_META_WS_ONLEFT: "ယာဉ်ထွက်",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "အရာပြောင်း",
  T_46_META_WS_ONMOVE: "ရွေ့လျား",
  T_46_META_WS_ONNODEENTER: "နုဝင်",
  T_46_META_WS_ONNODEEXIT: "နုထွက်",
  T_46_META_WS_ONPAUSE: "အချိန်ရပ်တန့်",
  T_46_META_WS_ONPHASEEND: "အဆင့်အဆုံးသတ်ခြင်း",
  T_46_META_WS_ONPHASESTART: "အဆင့်စတင်ခြင်း",
  T_46_META_WS_ONPICKEDUP: "ကောက်ယူ",
  T_46_META_WS_ONPLAYERASSIST: "ကစားသမားအကူညီပေးခြင်း",
  T_46_META_WS_ONPLAYERBEELIMINATED: "ကစားသမားဖြတ်တောက်ခြင်း",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "ကစားသမားပြန်လည်ရောက်ရှိခြင်း",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "ကစားသမားထိခိုက်ခြင်း",
  T_46_META_WS_ONPLAYERELIMINATE: "ကစားသမားထိခိုက်မှုပေးခြင်း",
  T_46_META_WS_ONPLAYERENTER: "အင်တာဖေ့စ်ခလုတ်နှိပ်ခြင်း",
  T_46_META_WS_ONPLAYERJOIN: "ကစားသမားပူးပေါင်းခြင်း",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "ဝိုင်းမအောင်",
  T_46_META_WS_ONPLAYERLEAVE: "အရာဝတ္ထုဝင်ရောက်ခြင်း",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "တောင်းဆို",
  T_46_META_WS_ONPLAYERQUIT: "ကစားသမားထွက်ခွာခြင်း",
  T_46_META_WS_ONPLAYERRANKCHANGE: "ကစားသမားစရဏာပြောင်းလဲခြင်း",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "ဝယ်ယူတောင်းဆိုမှုပြည့်မီ",
  T_46_META_WS_ONPLAYERREVIVED: "ကစားသမားပြန်လည်ကယ်ဆယ်ခြင်း",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "ပြန်လည်ဝင်",
  T_46_META_WS_ONPLAYERSCORECHANGE: "ကစားသမားရမှတ်ပြောင်းလဲခြင်း",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "မြင်ကွင်းပြောင်း",
  T_46_META_WS_ONPREDEALDAMAGE: "ဖျက်သိမ်းခြင်း",
  T_46_META_WS_ONPREPURCHASE: "ဝယ်မီ",
  T_46_META_WS_ONPRESSED: "ဖိမိ",
  T_46_META_WS_ONPRETAKEDAMAGE: "ထိခိုက်မှုဖြေရှင်းခြင်း",
  T_46_META_WS_ONPURCHASE: "ဝယ်ယူမှုဖြစ်",
  T_46_META_WS_ONRANKCHANGED: "အဖွဲ့စရဏာပြောင်းလဲခြင်း",
  T_46_META_WS_ONRECONNECT: "ပြန်ချိတ်",
  T_46_META_WS_ONRELEASED: "လွှတ်မိ",
  T_46_META_WS_ONRELOAD: "ပြန်ဖြည့်",
  T_46_META_WS_ONRESUME: "ပြန်လည်စတင်ခြင်း",
  T_46_META_WS_ONREVIVED: "ပြန်လည်ဝင်",
  T_46_META_WS_ONROUNDEND: "လှည့်ပတ်အဆုံးသတ်ခြင်း",
  T_46_META_WS_ONROUNDSTART: "လှည့်ပတ်စတင်ခြင်း",
  T_46_META_WS_ONSCENELOAD: "မြင်ကွင်းတင်",
  T_46_META_WS_ONSCENESWITCH: "မြင်ကွင်းပြောင်း",
  T_46_META_WS_ONSCORECHANGE: "အဖွဲ့ရမှတ်ပြောင်းလဲခြင်း",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "ဘောလုံးပစ်ခံ",
  T_46_META_WS_ONSLEEP: "အိပ်စက်",
  T_46_META_WS_ONSPAWN: "ဖန်တီး",
  T_46_META_WS_ONSPRAY: "ပက်ဆေး",
  T_46_META_WS_ONSPRAYED: "စတင်ပက်ဆေး",
  T_46_META_WS_ONSPRINT: "အရှိန်ပြေး",
  T_46_META_WS_ONSPRINTSTOP: "အရှိန်ပြေးရပ်",
  T_46_META_WS_ONSTANDUP: "ကစားသမားထကိုင်",
  T_46_META_WS_ONSTART: "စတင်ခြင်း",
  T_46_META_WS_ONSTARTFIRE: "ပစ်စ",
  T_46_META_WS_ONSTATEEND: "အခြေအနေဆုံး",
  T_46_META_WS_ONSURFING: "ရေတွင်စီး",
  T_46_META_WS_ONSURFINGSTOP: "ရေတွင်စီးရပ်",
  T_46_META_WS_ONSWITCHHANDHELD: "လက်ပြောင်းခြင်း",
  T_46_META_WS_ONTAKEDAMAGE: "ထိခိုက်မှုမတိုင်မီ",
  T_46_META_WS_ONTAPPED: "အသုံးပြုခြင်း",
  T_46_META_WS_ONTEAMACE: "အဖွဲ့အဆုံးသတ်ခြင်း",
  T_46_META_WS_ONTEAMADD: "အဖွဲ့ထည့်သွင်းခြင်း",
  T_46_META_WS_ONTEAMREMOVE: "အဖွဲ့ဖယ်ရှားခြင်း",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "အဖွဲ့အဆင့်ပြောင်းလဲခြင်း",
  T_46_META_WS_ONTEAMSCORECHANGE: "အဖွဲ့ရမှတ်ပြောင်းလဲခြင်း",
  T_46_META_WS_ONTELEPORTENTITY: "ဖြစ်ပွား",
  T_46_META_WS_ONTEXTCHANGE: "စာသားပြောင်းလဲ",
  T_46_META_WS_ONTHROWABLEEXPLODE: "ပစ္စည်းပစ်လွှတ်",
  T_46_META_WS_ONTOGGLE: "အခြေအနေပြောင်းလဲ",
  T_46_META_WS_ONTOUCHDOWN: "ဖိမိ",
  T_46_META_WS_ONTOUCHUP: "လွှတ်လိုက်",
  T_46_META_WS_ONUIHIDE: "UI ဖျောက်",
  T_46_META_WS_ONUISHOW: "UI ပြသ",
  T_46_META_WS_ONUPDATE: "မွမ်းမံ",
  T_46_META_WS_ONUSEAVATARSKILL: "စွမ်းအားအသုံးပြု",
  T_46_META_WS_ONUSECONSUMABLE: "ကားမောင်းခြင်း ",
  T_46_META_WS_ONUSED: "အသုံးပြု",
  T_46_META_WS_ONUSEPORTAL: "ပေါင်တယ်အသုံးပြု",
  T_46_META_WS_ONWAKEUP: "နိုးထ",
  T_46_META_WS_ONWEAPONBEEQUIPED: "လက်နက်သုံး",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "လက်နက်ဒဏ်ရာ",
  T_46_META_WS_ONWEAPONELIMINATE: "လက်နက်ဖျက်",
  T_46_META_WS_ONWEAPONSTOPFIRING: "ပစ်ခတ်ရပ်စဲ",
  T_46_META_WS_OWNER: "ပိုင်ရှင်",
  T_46_META_WS_P_ACCELERATE: "အမြန်နှုန်းတိုးမြှင့်ခြင်း",
  T_46_META_WS_P_ACCELERATION: "အရှိန်မြန်",
  T_46_META_WS_P_ACCOUNTID: "အကောင့် ID",
  T_46_META_WS_P_ACCURACY: "အချိန်လုံးကို မြှုပ်နှံမှု",
  T_46_META_WS_P_ACTIONTYPE: "အာနုဏ်ကိန်း",
  T_46_META_WS_P_ACTIVATEDALPHA: "လုပ်ဆောင်ထားသောထင်ရှားမှု",
  T_46_META_WS_P_ACTIVE: "အကျုံး",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "အဆင့်အတန်းတွင် အပြုံး",
  T_46_META_WS_P_ACTIVESELF: "ակտիվ స్వీయ",
  T_46_META_WS_P_ACTIVETEXT: "အသက်ဝင်စာသား",
  T_46_META_WS_P_ACTUALPOSITION: "အပြန်အလှန်",
  T_46_META_WS_P_AFTERACCUMULATOR: "နောက်ပိုင်း စုဆောင်းသူ",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "အကူအညီအယ်လ်စက္ကူများ",
  T_46_META_WS_P_AIMASSISTDISTANCE: "လမ်းညွှန်အကူအညီ အကွာအဝေး",
  T_46_META_WS_P_AIMASSISTTYPE: "ရည်မှတ်အကူအညီ",
  T_46_META_WS_P_AIRDROPSTATE: "လုပ်ငန်းအမည်",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "အနားခံအတိုင်းအတာ",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "အထွတ်အထိမ်းအတိုင်းအတာ",
  T_46_META_WS_P_ALLITEMS: "တိကျသော အရာများ",
  T_46_META_WS_P_ALLMEMBERS: "အဖွဲ့ဝင်များလုံး",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "အကူအညီဖြင့် လွတ်မြောက်ပါ",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "အပြင်မိန့်တားခံခြင်း",
  T_46_META_WS_P_ALLPLAYERS: "ကစားသမားလုံးလုံး",
  T_46_META_WS_P_ALLTEAMMATES: "အပြုံးသတင်းများ",
  T_46_META_WS_P_ALPHA: "မှိုတိ",
  T_46_META_WS_P_ALWAYSSHOWMARK: "နောက်ခံ အရောင် 1",
  T_46_META_WS_P_AMBIENTCOLOR: "ပတ်ဝန်းကျင်အရောင်",
  T_46_META_WS_P_AMMOCLIPSIZE: "မြောက်မှတ်တိုင်အရွယ်အစား",
  T_46_META_WS_P_AMMOMAGSIZE: "အကြိုးအလုံး အရွယ်အစား",
  T_46_META_WS_P_AMMOPERSHOT: "တစ်ချက်လျှင် သန့်ရှင်းမှု",
  T_46_META_WS_P_AMMOTYPE: "ခလုတ်အမျိုးအစား",
  T_46_META_WS_P_ANCHORMAX: "အများဆုံးအနား",
  T_46_META_WS_P_ANCHORMIN: "အနည်းဆုံးအနား",
  T_46_META_WS_P_ANCHOROBJECT: "သင့်ထားသောအရာ",
  T_46_META_WS_P_ANCHORPOSITION: "အပြုသဘောပြုမှု",
  T_46_META_WS_P_ANCHORTYPE: "UITweener စက်မှုစီမံခန့်ခွဲမှု ဖွင့်ပါ",
  T_46_META_WS_P_ANGLE: "အနွယ်",
  T_46_META_WS_P_ANGLEDOWN: "အလုံးစုံအကွေ့အခြား",
  T_46_META_WS_P_ANGLEUP: "အကွေ့အခြားသောကြား",
  T_46_META_WS_P_ANGULARDRAG: "အချင်းမြန်နှုန်းအပေါ်ခံဆန့်ကျင်မှု",
  T_46_META_WS_P_ANGULARSPEED: "မျှတမှုနိမ့်သော အချိုးအစား",
  T_46_META_WS_P_ANGULARVELOCITY: "အချင်းမြန်နှုန်း (ရေဒီယန်/စက္ကန့်)",
  T_46_META_WS_P_ANIMATIONCLIP: "သုံးစွဲရန် အထူးရင်းအမြစ်",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "အထူးသီးသန့် သရုပ်ပြထိန်းချုပ်သူ",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "သရုပ်ပြထိန်းချုပ်သူ အရင်းအမြစ် ID",
  T_46_META_WS_P_ARMORPENETRATION: "ပွင့်ရပ်မှုအရည်အသွေး",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "ကာကွယ်မှု ကျော်လွှားမှု အချက်အလက်",
  T_46_META_WS_P_ARMORTYPE: "ဂရမ်အမျိုးအစား",
  T_46_META_WS_P_ARROWOFFSET: "လမ်းပြအပြောင်းအလဲ",
  T_46_META_WS_P_ARROWSIZE: "လမ်းပြအရွယ်အစား",
  T_46_META_WS_P_ARROWSPRITE: "လမ်းပြပုံစံ",
  T_46_META_WS_P_ASKBUYTARGET: "ရောင်းရန်ပစ္စည်းကို မေးမြန်းခြင်း",
  T_46_META_WS_P_ATTACHTARGET: "ခြေရာခံပန်းကန်",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "ထိခိုက်နိုင်သော ဘက်",
  T_46_META_WS_P_ATTACKDAMAGE: "တိုက်ခိုက်မှု အစာရှောင်",
  T_46_META_WS_P_ATTACKINTERVAL: "ခြားနားကာလ",
  T_46_META_WS_P_ATTACKRANGE: "ခြားနားအကွာအဝေး",
  T_46_META_WS_P_ATTACKTARGET: "အထိခိုက်မှု ရည်ရွယ်ချက်",
  T_46_META_WS_P_ATTTACKABLETARGETS: "တိုက်ခိုက်နိုင်သော ရည်မှတ်များ",
  T_46_META_WS_P_AUTOPLAY: "အလိုအလျောက်ပလေးအခြေအနေ",
  T_46_META_WS_P_AVAILABLEPOINT: "အသုံးပြုနိုင်သော အချက်အမှတ်",
  T_46_META_WS_P_AVATAR: "သုံးရန် အစိတ်အပိုင်း",
  T_46_META_WS_P_AVATARID: "ပုံအပြင် ID",
  T_46_META_WS_P_BACKGROUND: "မူလတန်ဖိုး",
  T_46_META_WS_P_BACKGROUNDALPHA: "နောက်ခံထင်ရှားမှု",
  T_46_META_WS_P_BACKGROUNDCOLOR: "နောက်ခံအရောင်",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "ဘယ်ဘက် အမှတ်",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "ညာဘက် အမှတ်",
  T_46_META_WS_P_BACKGROUNDFILL: "နောက်ခံဖြည့်ခြင်း",
  T_46_META_WS_P_BACKGROUNDICONNAME: "နောက်ခံအိုင်ကွန်းအမည်",
  T_46_META_WS_P_BACKGROUNDNAME: "နောက်ခံအမည်",
  T_46_META_WS_P_BACKGROUNDOFFSET: "နောက်ခံပုံစံ",
  T_46_META_WS_P_BACKGROUNDRADIUS: "နောက်ခံရေဒီယတ်",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "နောက်ခံအရွယ်အစား",
  T_46_META_WS_P_BACKGROUNDSPRITE: "နောက်ခံပုံစံ",
  T_46_META_WS_P_BACKPACK: "အိတ်",
  T_46_META_WS_P_BACKPACKSKINID: "အိတ်အရောင် ID",
  T_46_META_WS_P_BACKWARDSPEED: "အဆုတ်ပိုး အမြင့်",
  T_46_META_WS_P_BANNERID: "ဘန်နာ ID",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "မူလအောက်လမ်းအမြန်နှုန်း",
  T_46_META_WS_P_BASEMULTIPLIER: "အခြေခံအကြိမ်အနှုန်း",
  T_46_META_WS_P_BASETIME: "အခြေခံစတင်ချိန်",
  T_46_META_WS_P_BASEVERTICALSPEED: "မူလအထူးအမြန်နှုန်း",
  T_46_META_WS_P_BEFOREACCUMULATOR: "အရှေ့ပိုင်း စုဆောင်းသူ",
  T_46_META_WS_P_BEVTREEID: "အပြုအမူအပင် ID",
  T_46_META_WS_P_BINDPROPERTYID: "တရားဝင်ပစ္စည်း ID",
  T_46_META_WS_P_BODY: "ကိုယ်ထည်",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "ကိုယ်ခန္ဓာ ထိခိုက်မှုအချက်",
  T_46_META_WS_P_BONEPOSITION: "အရိုးတည်နေရာ",
  T_46_META_WS_P_BONESCALE: "အရိုးအရွယ်အစား",
  T_46_META_WS_P_BOOSTCD: "ဘုတ်အားချိန်အချိန်",
  T_46_META_WS_P_BOOSTDURATION: "ဘုတ်အားတည်ရှိချိန်",
  T_46_META_WS_P_BOOSTSPEED: "မြှင့်တင်အမြန်နှုန်း",
  T_46_META_WS_P_BORDERLR: "ဘေးဘောင်ဘယ်ဘက်နဲ့ညာဘက်",
  T_46_META_WS_P_BORDERTB: "ဘေးဘောင်အထက်နဲ့အောက်",
  T_46_META_WS_P_BOTTOMALPHA: "အောက်တန်းထင်ရှားမှု",
  T_46_META_WS_P_BOUNDWALLET: "HUD Anchor အမျိုးအစား",
  T_46_META_WS_P_BRAKEHORSEPOWER: "ဘရိတ်၏ အား",
  T_46_META_WS_P_BRAKETORQUE: "ဘရိတ်၏ အာရုံလှိမ့်",
  T_46_META_WS_P_BRRANK: "BR အဆင့်",
  T_46_META_WS_P_BUFFTYPE: "ဘာဖ်အမျိုးအစား",
  T_46_META_WS_P_BURNDAMAGE: "အပူထွက်မှု အာရုံလှိမ့်",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "အပူထွက်မှု အတွင်းပိုင်း",
  T_46_META_WS_P_BURNTIME: "အပူထွက်ချိန်",
  T_46_META_WS_P_BUTTOM: "အောက်ခြေ",
  T_46_META_WS_P_BUTTONCOLORS: "ခလုတ်အရောင်များ",
  T_46_META_WS_P_BUTTONNAMES: "ခလုတ်အမည်များ",
  T_46_META_WS_P_BUTTONSTYLE: "ခလုတ်ပုံစံ",
  T_46_META_WS_P_CAMERABLOCKMODE: "ကင်မရာ ပိတ်ဆို့မှု အမျိုးအစား",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "ကင်မရာ ပရိုကျရှင်း အမျိုးအစား",
  T_46_META_WS_P_CAMERATYPE: "ကင်မရာ",
  T_46_META_WS_P_CANCELDRAGIFFITS: "စိတ်ကြိုက်ကိုဖျက်ပါ",
  T_46_META_WS_P_CANCOSTDURABILITY: "တည်ငြိမ်မှု ကုန်ကျနိုင်သည်",
  T_46_META_WS_P_CANDAMAGED: "အားနာရနိုင်သည်",
  T_46_META_WS_P_CANDESTROY: "ဖျက်စီးနိုင်သည်",
  T_46_META_WS_P_CANDESTROYED: "ဖျက်ဆီးနိုင်သည်",
  T_46_META_WS_P_CANSELFTRIGGER: "ကိုယ်တိုင်စတင်နိုင်သည်",
  T_46_META_WS_P_CANTEAMTRIGGER: "အသင်းမှတက်နိုင်သည်",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "ကိုယ်တိုင်မိမိကိုယ် ပြုလုပ်နိုင်သလား",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "အသင်းသားမှ ပြုလုပ်နိုင်သလား",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "ယာဉ်မှ ပြုလုပ်နိုင်သလား",
  T_46_META_WS_P_CANVEHICLETRIGGER: "ရေနံကားများမှတက်နိုင်သည်",
  T_46_META_WS_P_CELLSIZE: "အထွေထူးအရွယ်အစား",
  T_46_META_WS_P_CELLSPACE: "အထွေထူးအကြီးအကျယ်",
  T_46_META_WS_P_CENTER: "အက်ဉ်းပြု မြေပုံကို အတည်ပြုပါ",
  T_46_META_WS_P_CENTERINVISIBLE: "စင်တာမမြင်နိုင်",
  T_46_META_WS_P_CENTEROFFSET: "အင်အားမှတ်တမ်းပေးရန်",
  T_46_META_WS_P_CENTEROFMASS: "အလေးချိန်မှတ်သားရာနေရာ",
  T_46_META_WS_P_CENTERRANGE: "အလယ်အာရုံအကွာအဝေး",
  T_46_META_WS_P_CENTRALFLASHTIME: "အခြားအစိတ်အပိုင်း မီးပွိုင့် အချိန်",
  T_46_META_WS_P_CENTRALLINEACTIVE: "အထက်တန်းလိုက်",
  T_46_META_WS_P_CENTRALLINEPOSITION: "အပေါ်မှာ",
  T_46_META_WS_P_CHANNELID: "ဆက်သွယ်ရေးချန်နယ်အမှတ်",
  T_46_META_WS_P_CHARGEMAX: "အများဆုံးအားသွင်းမှု",
  T_46_META_WS_P_CHASETARGET: "အကျိုးထိန်းသိမ်းမှု ရည်ရွယ်ချက်",
  T_46_META_WS_P_CHATCHANNEL: "စကားပြောချိတ်ဆက်ချက်",
  T_46_META_WS_P_CHECKPOINTID: "စစ်ဆေးမှုအချက်အမှတ်",
  T_46_META_WS_P_CHILDINDEX: "လိပ်ပြာ အညွှန်း",
  T_46_META_WS_P_CHIPEXP: "ချစ်ပ်မှတ်ပညာ",
  T_46_META_WS_P_CLICKSIZE: "နှိပ်ခြင်းအရွယ်အစား",
  T_46_META_WS_P_CLIPLENGTH: "ကလစ်အရှည်",
  T_46_META_WS_P_CLIPPINGTYPE: "ဖြတ်ရှင်းမှုအမျိုးအစား",
  T_46_META_WS_P_COLLIDERID: "ပေါင်းစည်းထားသော ကိရိယာအမှတ်",
  T_46_META_WS_P_CONSTRAIN: "ကန့်သတ်မှု",
  T_46_META_WS_P_CONSTRAINT: "အတားအဆီး",
  T_46_META_WS_P_CONSTRAINTCOUNT: "အတားအဆီးအရေအတွက်",
  T_46_META_WS_P_CONSUMABLETYPE: "စားသုံးစရာအမျိုးအစား",
  T_46_META_WS_P_CONTENT: "အကြောင်းအရာ",
  T_46_META_WS_P_CONTENTORIGIN: "အကြောင်းအရာအစစ်အမှန်",
  T_46_META_WS_P_CONTROLPOINTS: "ထိန်းချုပ်မည့်ပွိုင့်များ",
  T_46_META_WS_P_COORDINATESYSTEM: "ကိုဩဒိနိတ်စနစ်",
  T_46_META_WS_P_COUNT: "လိုက်လျောတောမှု",
  T_46_META_WS_P_COUNTDOWNENDTIME: "ပစ်ချမှတ် အချိန် (မီလီစက္ကန့်)",
  T_46_META_WS_P_COUNTDOWNKEY: "နောက်ကျောအမှတ် Key",
  T_46_META_WS_P_COUNTDOWNTIME: "နောက်ကျောအချိန်",
  T_46_META_WS_P_COUNTPERWAVE: "လှိုင်းတစ်ခုလျှင် အရေအတွက်",
  T_46_META_WS_P_CRASHMAXDAMAGE: "အများဆုံး တိုက်ခိုက်မှု အရည်အသွေး",
  T_46_META_WS_P_CRASHMAXSPEED: "အမြင့်ဆုံး တိုက်ခိုက်မှု အရည်အသွေး",
  T_46_META_WS_P_CRASHMESSFACTOR: "တိုက်ခိုက်မှု အရည်အသွေး အရောင်ပြန်လည်",
  T_46_META_WS_P_CRASHMINDAMAGE: "အနိမ့်ဆုံး တိုက်ခိုက်မှု အရည်အသွေး",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "기어가는 이동 속도 비율",
  T_46_META_WS_P_CREATEDENTITY: "ဖန်တီးထားသောအရာ",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "꿇어 앉았을 때 이동 속도 비율",
  T_46_META_WS_P_CSRANK: "CS အဆင့်",
  "T_46_META_WS_P_CURRENT AMMO": "လက်ရှိအကြိုးအလုံး",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "လက်ရှိအနီမေးရှင်းရင်းမြစ်",
  T_46_META_WS_P_CURRENTCLIP: "လက်ရှိကလစ်",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "လက်ရှိကလစ်တိုးချဲ့မှု",
  T_46_META_WS_P_CURRENTDURABILITY: "လက်ရှိ သက်သေအား",
  T_46_META_WS_P_CURRENTENERGY: "လက်ရှိအင်အား",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "လက်ဝတ်အကြောင်း",
  T_46_META_WS_P_CURRENTHP: "ဒေသခံ တည်နေရာလား",
  T_46_META_WS_P_CURRENTPHASEINDEX: "လက်ရှိအဆင့်ညွှန်ပြချက်",
  T_46_META_WS_P_CURRENTPROGRESS: "လက်ရှိတိုးတက်မှု",
  T_46_META_WS_P_CURRENTROUNDINDEX: "လက်ရှိအဆင့်ညွှန်ပြချက်",
  T_46_META_WS_P_CURRENTSTATE: "လက်ရှိအခြေအနေ",
  T_46_META_WS_P_CURRENTVALUE: "အများဆုံးတန်ဖိုး",
  T_46_META_WS_P_CURRENTWAVE: "လက်ရှိလှိုင်း",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "အသုံးပြုသူစိတ်ကြိုက်ကောင်စံအရင်းအမြစ်",
  T_46_META_WS_P_CUSTOMGAMERESULT: "အပြင်ဆင်သည့်ဂိမ်းရလဒ်",
  T_46_META_WS_P_CUSTOMGRAVITY: "အထူးပေးအပ်ရနံ့",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "ကိုယ်ရေးကိုယ်တာပေးသော အားလုံး",
  T_46_META_WS_P_CUSTOMXY: "စိတ်ကြိုက် XY",
  T_46_META_WS_P_DAMAGE: "ထိခိုက်မှု",
  "T_46_META_WS_P_DAMAGE RANGE": "အပေါ်တွင်",
  T_46_META_WS_P_DAMAGEFACTOR: "ပျက်စီးမှုအချိုးအစား",
  T_46_META_WS_P_DAMAGEINTERVAL: "အဆုံးအချိန် (မီလီစက္ကန့်)",
  T_46_META_WS_P_DAMAGERADIUS: "ပျက်စီးမှုနယ်",
  T_46_META_WS_P_DAMAGERATIOHEAD: "ဦးခေါင်းထိခိုက်မှုအချိုး",
  T_46_META_WS_P_DAMAGERATIOLIMB: "ကိုယ်အစိတ်အပိုင်းထိခိုက်မှုအချိုး",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "အန္တရာယ် လျော့ချမှု အချက်အလက်",
  T_46_META_WS_P_DAMAGETAKENPCT: "ခံ受ရသည့် အရွယ်အစား",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "ရရှိသည့်ထိခိုက်မှု ရာခိုင်နှုန်း",
  T_46_META_WS_P_DAMAGEVALUE: "အစောပိုင်း အနယ်နယ်",
  T_46_META_WS_P_DARKNESS: "အမှိုက်",
  T_46_META_WS_P_DECELERATIONPERCENT: "အနှေးကွေးရာခိုင်နှုန်း",
  T_46_META_WS_P_DEFAULTTEXT: "အခြေခံစာသား",
  T_46_META_WS_P_DEFENSE: "ကာကွယ်မှုရေဒီယတ်",
  T_46_META_WS_P_DEFENSERATE: "ကာကွယ်မှုနှုန်း",
  T_46_META_WS_P_DELTA: "Δ",
  T_46_META_WS_P_DELTATIME: "ဒယ်လ်တာ အချိန်",
  T_46_META_WS_P_DELTAVALUE: "Δ တန်ဖိုး",
  T_46_META_WS_P_DEPTH: "နက်ရှိုင်းမှု",
  T_46_META_WS_P_DESC: "အဖွဲ့အစည်း",
  T_46_META_WS_P_DESCRIPTION: "ဖော်ပြချက်",
  T_46_META_WS_P_DESCRIPTIONKEY: "အဖွဲ့ခေါင်းစဉ် Key",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "အကြံပြုချက် Parameter",
  T_46_META_WS_P_DESTVAL: "ကန့်သတ်အနည်းဆုံးကန့်သတ်",
  T_46_META_WS_P_DETECTRANGE: "ရှာဖွေရေး အကွာအဝေး",
  T_46_META_WS_P_DIFFUSEALPHA: "ဖြန့်ဖြူးသော အယ်ဖာ",
  T_46_META_WS_P_DIFFUSECOLOR: "ဖြန့်ဖြူးသော အရောင်",
  T_46_META_WS_P_DIFFUSETEXTURE: "ဖြန့်ဖြူးသည့် အထည်",
  T_46_META_WS_P_DISABLECOLOR: "သုံးနိုင်သည့်အရောင်",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "ရပ်တန့်မှုရမည့်အကျိုးသက်ရောက်မှု",
  T_46_META_WS_P_DISABLEITEMDROP: "အရာဝတ္ထုကိုပျံ့နှံ့ခြင်းပိတ်ပါ",
  T_46_META_WS_P_DISABLEITEMPICKUP: "အရာဝတ္ထုယူခြင်းပိတ်ပါ",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "ကိုယ်တိုင်ပိတ်ခြင်း ပိတ်ရန်",
  T_46_META_WS_P_DISABLEQUICKCHAT: "အမြန်ချက်ကိုပိတ်ပါ",
  T_46_META_WS_P_DISABLERECIPROCATING: "ပြန်အောင်မလုပ်သော လှုပ်ရှားမှု",
  T_46_META_WS_P_DISABLEVOICECHAT: "အသံစကားပြောချိတ်ဆက်မှု",
  T_46_META_WS_P_DISTANCE: "အကွာအဝေး",
  T_46_META_WS_P_DOUBLEGUNTYPE: "ငါးလုံးအပြုံး အမျိုးအစား",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "기어가는 이동 속도 비율",
  T_46_META_WS_P_DOWNSPEED: "ရိုက်ပစ် အနယ်နယ်",
  T_46_META_WS_P_DRAG: "လမ်းကြောင်းအပေါ်ခံဆန့်ကျင်မှု",
  T_46_META_WS_P_DRIVER: "မောင်းသူ",
  T_46_META_WS_P_DROPITEMS: "လေကြောင်း အစီအစဉ်",
  T_46_META_WS_P_DURABILITY: "စွမ်းတော်",
  T_46_META_WS_P_DURABILITYRECOVERY: "တာရှည်ခံနိုင်မှု ပြန်လည်ရယူမှု",
  T_46_META_WS_P_DURATION: "ကြာချိန်",
  T_46_META_WS_P_EDGEFLASHTIME: "ဖလက်ရှ်ဘန့် သက်ရောက်မှု အဝိုင်း",
  T_46_META_WS_P_EFFECTACTIVE: "စာသားအရောင်",
  T_46_META_WS_P_EFFECTCOLOR: "မြေပုံ အရွယ်အစား",
  T_46_META_WS_P_EFFECTDURATION: "စက်ကိရိယာ ဖွင့်ချိန်",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "ထိရောက်သောအချိန်အကွာအဝေး",
  T_46_META_WS_P_EFFECTRESID: "အကျိုးသက်ရောက်မှုရင်းမြစ်လမ်းကြောင်း",
  T_46_META_WS_P_ENABLE: "ဖွင့်ပါ",
  T_46_META_WS_P_ENABLEATTACK: "လုပ်ငန်းဆောင်ရွက်မှုရှိသည်",
  T_46_META_WS_P_ENABLEBOTREVIVE: "ဗော့တ်ပြန်လည်ပြင်ဆင်ရန်",
  T_46_META_WS_P_ENABLEDEPTHMAP: "တစ်ချိန်တွင် တိပ်ဖြစ်ခြင်း",
  T_46_META_WS_P_ENABLEDROPONDEATH: "သေဆုံးစဉ် အကြောင်းပြန်ကျခြင်း လား",
  T_46_META_WS_P_ENABLELOCALIZATION: "ဘာသာစကားပြောင်းပေးပါ",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "လေတွင် ရွေ့လျားနိုင်",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "ကစားသမားပြန်လည်အသက်ဝင်ခြင်းကို အတည်ပြုပါ",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "သုံးစွဲသူအမြင်ကို ဖွင့်ပါ",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "ဆယ်ဝန်းနဲ့ ရှုထောင့်ပြောင်းပါ",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "သက်ဆိုင်ရာ ပရိသတ်များကို ဖွင့်ပါ",
  T_46_META_WS_P_ENABLESWINGING: "လှုပ်ရှားမှုဖွင့်ပါ",
  T_46_META_WS_P_ENABLETRACTION: "ဆွဲယူမှုဖွင့်ပါ",
  T_46_META_WS_P_ENDPOSITION: "အဆုံးအနေအထား",
  T_46_META_WS_P_ENDRADIUS: "အထက်နှင့် အောက်ရှိ အလျှံ",
  T_46_META_WS_P_ENDTIME: "ချိန်ထိရောက်သော အချိန် (မီလီစက္ကန့်)",
  T_46_META_WS_P_ENDTIMES: "သတ်မှတ်သတ်မှတ်",
  T_46_META_WS_P_ENDVALUE: "အဆုံးတန်ဖိုး",
  T_46_META_WS_P_ENERGY: "စွမ်းအင်",
  T_46_META_WS_P_ENERGYCOST: "အင်အားကုန်ကျမှု",
  T_46_META_WS_P_ENERGYRECOVERY: "အင်အားပြန်လည်ရရှိမှု",
  T_46_META_WS_P_ENGINEHORSEPOWER: "အင်ဂျင်၏ အား",
  T_46_META_WS_P_ENGINETORQUE: "အင်ဂျင်၏ အာရုံလှိမ့်",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "အများဆုံး EP",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "EP ပြန်လည်ရရှိမှုပမာဏ",
  T_46_META_WS_P_EVENTS: "အချိန်ရေတွက်ခြင်း (စက္ကန့်)",
  T_46_META_WS_P_EXPLODEDAMAGE: "ပေါက်ပျက်မှု အာရုံလှိမ့်",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "ပေါက်ကွဲမှုဆိုင်ရာ ချို့ယွင်းမှု အချက်အလက်",
  T_46_META_WS_P_EXPLODEDELAY: "ပေါက်ပျက်မှု လျို့ဝှက်ချိန်",
  T_46_META_WS_P_EXPLODERANGE: "ပေါက်ပျက်မှု အကျယ်အဝန်း",
  T_46_META_WS_P_EXPLOSIONDELAY: "အလယ်ပိုင်း မီးပွိုင့် အချိန်",
  T_46_META_WS_P_EXPLOSIONRANGE: "လှိုင်းဖြတ်မှု အကွာအဝေး",
  T_46_META_WS_P_EXPLOSIONTIME: "ဖျက်သိမ်းမှု နောက်ကျမှု",
  T_46_META_WS_P_EXPPERDAMAGE: "ထိခိုက်မှုနှုန်းနှုန်းအလိုက် အတွေ့အကြုံ",
  T_46_META_WS_P_EXPPERMOVEMILE: "ရွေ့လျားသည့်မိုင်အလိုက် အတွေ့အကြုံ",
  T_46_META_WS_P_EXPPERSECOND: "တစ်စက္ကန့်အလိုက် အတွေ့အကြုံ",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "အပိုပစ္စည်းသိုလှောင်မှု",
  T_46_META_WS_P_EXTRABAGCAPACITY: "အထူးသီးသန့်ဘက်ပါကွေ့နေရာ",
  T_46_META_WS_P_EXTRAHPRATIO: "အပို HP အချိုး",
  T_46_META_WS_P_FACEPAINT: "မျက်နှာဖိနပ်",
  T_46_META_WS_P_FACTION: "တိုင်းရင်းသား",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "အကျော့ဒဏ်နှုန်း",
  T_46_META_WS_P_FALLSPEED: "ကျိုးလျှပ်စစ်မှတ်",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "အလိုအလျောက်ပြန်လည်တင်သွင်းခြင်းအမြန်နှုန်း",
  T_46_META_WS_P_FILEID: "ဖိုင် ID",
  T_46_META_WS_P_FILL: "ပြည့်စုံသော",
  T_46_META_WS_P_FILLAMOUNT: "ဖြည့်တန်ဖိုး",
  T_46_META_WS_P_FILLDIRECTION: "ဖြည့်လမ်းကြောင်း",
  T_46_META_WS_P_FILLTYPE: "ဖြည့်သည့်အမျိုးအစား",
  T_46_META_WS_P_FIREANGLELIMIT: "ရှေ့မှတ်ပုံအထူကို ကန့်သတ်",
  T_46_META_WS_P_FIRETYPE: "မီးပွားမှု အမျိုးအစား",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "ပထမအကြိမ်အမှတ်ပေးသော ပရိုပါရာမီတာ",
  T_46_META_WS_P_FIRSTSCORETITLE: "ပထမအကြိမ်အမှတ်ခေါင်းစဉ်",
  T_46_META_WS_P_FIRSTSCOREVALUE: "ပထမအကြိမ်အမှတ်တန်ဖိုး",
  T_46_META_WS_P_FIXEDDELTATIME: "တိတိကျကျဒယ်လ်တာအချိန်",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "အကျိုးသက်ရောက်မှု ကာလ",
  T_46_META_WS_P_FLIP: "မိုတိ",
  T_46_META_WS_P_FLIPTYPE: "ဖလစ်ပုံစံ",
  T_46_META_WS_P_FLYMAXHEIGHT: "အမြင့်ဆုံးလှေ့လာမှု",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "အထိအမြန်နှုန်း",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "အထိအမြန်နှုန်း",
  T_46_META_WS_P_FOGCOLOR: "မိုးလုံးရောင်",
  T_46_META_WS_P_FOLLOWTARGET: "လက်ရှိတန်ဖိုး",
  T_46_META_WS_P_FONT: "အက္ခရာပုံစံ",
  T_46_META_WS_P_FONTSIZE: "ဖောင့်အရွယ်အစား",
  T_46_META_WS_P_FONTSTYLE: "ဇယားပုံစံ",
  T_46_META_WS_P_FONTTYPE: "ဇယားအမျိုးအစား",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Client နှင့် အတူ တိုးတက်စွာ ချိတ်ဆက်ပါ",
  T_46_META_WS_P_FORWARD: "ရှေ့",
  T_46_META_WS_P_FORWARDSPEED: "နောက်ခံ အမြင့်",
  T_46_META_WS_P_FOV: "ကြည့်မြင်ကွင်း",
  T_46_META_WS_P_FREEZEDURATION: "အေးခဲမှုကာလ (စက္ကန့်)",
  T_46_META_WS_P_FRIENDFACTIONS: "မိတ်ကောင်း ဘက်",
  T_46_META_WS_P_FRIENDLYPLAYERS: "မိတ်ဆက်ကစားသမား",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "အပြုံးအပြုံး အကွာအဝေး",
  T_46_META_WS_P_FUNCTIONTYPE: "လုပ်ဆောင်ချက်အမျိုးအစား",
  T_46_META_WS_P_GAINHPCOLOR: "ကျန်းမာရေး စုစည်းမှု",
  T_46_META_WS_P_GAMEFRAMECOUNT: "အမျိုးသားအရေအတွက်",
  T_46_META_WS_P_GAMETIMECOUNT: "ဂိမ်းအချိန်",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "စက်ရုံပြောင်းလဲမှုနောက်ပြင်ထား",
  T_46_META_WS_P_GENDER: "လိင်",
  T_46_META_WS_P_GETONBOOSTCD: "ဘုတ်အားအပေါ်တက်သော CD",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "ဘုတ်အားအပေါ်တက်သော CD ဆီဝစ်",
  T_46_META_WS_P_GETONSKATEBOARDCD: "ကျင်းပမှုအတွက် CD",
  T_46_META_WS_P_GRADIENT: "ရှုထောင့်အပြောင်းအလဲ",
  T_46_META_WS_P_GRADIENTBOTTOM: "အနောက်ဆုံးအပြောင်းအလဲ",
  T_46_META_WS_P_GRADIENTTOP: "အထိမ်းအမှတ်အပြောင်းအလဲ",
  T_46_META_WS_P_GRAVITY: "ဆယ်ဝန်း",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "လေကြောင်း တိုက်ခိုက်မှု အများဆုံး",
  T_46_META_WS_P_GRENADEMINDAMAGE: "လေကြောင်း တိုက်ခိုက်မှု အနည်းဆုံး",
  T_46_META_WS_P_GRENADERANGE: "လေကြောင်း တိုက်ခိုက်မှု အကွာအဝေး",
  T_46_META_WS_P_GROUPID: "အဖွဲ့အမှတ်",
  T_46_META_WS_P_HEAD: "ဦးနားအင်္ကျီ",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "ဦးခေါင်းထိခိုက်မှုအချက်",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "ဦးခေါင်းထိခိုက်မှုကာကွယ်မှု",
  T_46_META_WS_P_HEIGHT: "အမြင့်",
  T_46_META_WS_P_HELMET: "ကပ်ပိုး",
  T_46_META_WS_P_HIGHESTBRRANK: "အမြင့်ဆုံး BR အဆင့်",
  T_46_META_WS_P_HIGHESTCSRANK: "အမြင့်ဆုံး CS အဆင့်",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "အနိမ့်ဆုံး မြင့်မားမှု အချိုး",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "မြန်နှုန်းမြင့် စည်းကမ်းပြုမှု",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "မြန်နှုန်းမြင့် စည်းကမ်းပြုမှု အခြားအဆင့်",
  T_46_META_WS_P_HITPOINTEFFECT: "ထိမှန်မှုအကျိုးသက်ရောက်မှု",
  T_46_META_WS_P_HORIZONTALBAR: "အတိုင်းအတာ",
  T_46_META_WS_P_HORIZONTALOFFSET: "အနားကွက်",
  T_46_META_WS_P_HOSTILETEAMS: "မိတ်ဖက်မရှိသောအဖွဲ့များ",
  T_46_META_WS_P_HOSTTEAM: "မိမိအဖွဲ့",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "အကြွင်းရှိသော အမှတ်",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "HP ပြန်လည်ရရှိမှုပမာဏ",
  T_46_META_WS_P_HPRECOVERYSPEED: "HP ပြန်လည်ထူထောင်မှုနှုန်း (ms)",
  T_46_META_WS_P_ICON: "သင်္ကေတ",
  T_46_META_WS_P_ICONCOLOR: "အရေအတွက်",
  T_46_META_WS_P_ICONNAME: "အိုင်ကွန်းအမည်",
  T_46_META_WS_P_ICONRESOURCE: "BTree Debug ကို ခွင့်ပြုပါ",
  T_46_META_WS_P_ID: "အမှတ်",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "တိုက်ခိုက်မှုအချိုးအစား (စက္ကန့်)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "အကြံပေးရောထွက်မှုမရှိ",
  T_46_META_WS_P_INACTIVATEDALPHA: "မလုပ်ဆောင်ထားသောထင်ရှားမှု",
  T_46_META_WS_P_INDEX: "အညွှန်းကိန်း",
  T_46_META_WS_P_INITIALMAGCOUNT: "အစောပိုင်း သင့်ထိန်းသိမ်းမှု အရေအတွက်",
  T_46_META_WS_P_INITIALSPEED: "အစောပိုင်းအရှိန်",
  T_46_META_WS_P_INITIALVALUE: "အတွင်း",
  T_46_META_WS_P_INITIALWORLDPOSITION: "အစောပိုင်းလောကပစ္စည်းပွိုင့်",
  T_46_META_WS_P_INSCENE: "ရှုခင်းအတွင်း",
  T_46_META_WS_P_INSTANCEID: "အချက်အလက် ID",
  T_46_META_WS_P_INTENSITY: "အလင်းအပြုံး",
  T_46_META_WS_P_INVERTFILL: "ပြန်လည်ဖြည့်ခြင်း",
  T_46_META_WS_P_INVINCIBLE: "အနိုင်ရသူ",
  "T_46_META_WS_P_IS SHOW": "ပြသပါသလား",
  T_46_META_WS_P_IS3D: "3D ဖြစ်/မဖြစ်",
  T_46_META_WS_P_ISACE: "ACE ဖြစ်ပါသလား",
  T_46_META_WS_P_ISACED: "အပြုံးလုံးစွာ",
  T_46_META_WS_P_ISAI: "AI ဖြစ်ပါသလား",
  T_46_META_WS_P_ISALWAYSINSCREEN: "အမြဲဖန်သားပြင်ပေါ်တွင်",
  T_46_META_WS_P_ISAPPLYSHADOW: "အရောင်စွမ်းရည်",
  T_46_META_WS_P_ISATTACKABLE: "တိုက်ခိုက်နိုင်သော",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "ရန်သူကို အလိုအလျောက်လိုက်ရှာခြင်း",
  T_46_META_WS_P_ISAUTOPLAY: "အမှတ်တံဆိပ်ကို ပြပါ",
  T_46_META_WS_P_ISAUTOTELEPORT: "အလိုအလျောက် သယ်ပို့မှု လား",
  T_46_META_WS_P_ISBILLBOARD: "အမြဲဗီဒီယိုထဲတွင်",
  T_46_META_WS_P_ISBOLD: "အထူ",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "အောက်မှ ထိန်းချုပ်မှု",
  T_46_META_WS_P_ISCENTERPOS: "အလိုအလျောက် ပြသမှု",
  T_46_META_WS_P_ISCONSUMEAMMO: "ပစ္စည်းများ သုံးစွဲမှု",
  T_46_META_WS_P_ISCONTINUOUS: "အဆက်မပြတ်ပေါ်လာမှုလား",
  T_46_META_WS_P_ISCOUNTDOWN: "ပစ်ချမှတ် အရာများ",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "လက်ရှိအနီမေးရှင်းလူပ်မဟုတ်ပါ",
  T_46_META_WS_P_ISDEADDROP: "သေဆုံးမှုထောက်ခံမှု",
  T_46_META_WS_P_ISDEATHTRIGGER: "သေဆုံးမှု ကိုယ်တိုင် ဖြစ်စေသော အရာလား",
  T_46_META_WS_P_ISDEBUG: "ဖြစ်ရပ် အပြီး",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "မူရင်းမွေးဖွားရာ အချက်အမှတ်လား",
  T_46_META_WS_P_ISDROPONELIMINATED: "သေစေသောအခါ ပစ္စည်းအားလုံး ပျောက်ဆုံးသွားမည်",
  T_46_META_WS_P_ISEND: "နောက်ဆုံး",
  T_46_META_WS_P_ISFEBUTTON: "FE အချက်အလက်",
  T_46_META_WS_P_ISGREY: "ရည်မှန်းချက်အချိန်",
  T_46_META_WS_P_ISGROUNDED: "မြေတွင် ရောက်ရှိသည်",
  T_46_META_WS_P_ISIGNOREDEPTH: "အနက်ကိုလျစ်လျူရှုပါ",
  T_46_META_WS_P_ISINVINCIBLE: "မဖြတ်နိုင်သော",
  T_46_META_WS_P_ISITALIC: "အကြီးအကျယ်",
  T_46_META_WS_P_ISLASTROUND: "နောက်ဆုံးအဆင့်",
  T_46_META_WS_P_ISLOCALPOS: "ချိန်တိုင်း အချိန် (မီလီစက္ကန့်)",
  T_46_META_WS_P_ISLOOP: "လုပ်ဆောင်မှုများလည်ပတ်",
  T_46_META_WS_P_ISMATCHPOINT: "ပြိုင်ပွဲအမှတ်",
  T_46_META_WS_P_ISMOVEABLE: "လှုပ်ရှားနိုင်ပါသည်",
  T_46_META_WS_P_ISOCCUPIED: "သုံးစွဲထားပါသလား",
  T_46_META_WS_P_ISOPENTWEEN: "ကြည့်ရှုနိုင်သော ကစားသမားများ",
  T_46_META_WS_P_ISPLAYING: "ဖွင့်လှစ်နေသည်",
  T_46_META_WS_P_ISPURCHASABLE: "အရောင်းအရာများ",
  T_46_META_WS_P_ISREVERSE: "ပေးဆောင်ရန်ထောက်ခံ",
  T_46_META_WS_P_ISSERVERDRIVEN: "ဆာဗာမှ မောင်းနှင်ခြင်း",
  T_46_META_WS_P_ISSHOW: "ပြရန်",
  T_46_META_WS_P_ISSHOWHUDNAME: "HUD အမည်ပြရန်",
  T_46_META_WS_P_ISSHOWMAPINFO: "မြေပုံအချက်အလက်ပြရန်",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "အရှိန်မြန်စာတိုများပြရန်",
  T_46_META_WS_P_ISSHOWSCAN: "စကန်ပြရန်",
  T_46_META_WS_P_ISSHOWTAG: "တပ်အမှတ်များပြရန်",
  T_46_META_WS_P_ISSIDECOLLIDING: "ဘေးမှ ထိန်းချုပ်မှု",
  T_46_META_WS_P_ISSILENCE: "ဂူလ်ယားဆင်ယင်မှု",
  T_46_META_WS_P_ISSINGLESHOT: "တစ်ခါတည်း ငါးလုံးများ",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "ခြံခင်းမီးလေးဖျက်ပါ",
  T_46_META_WS_P_ISSLIDING: "လျင်မြန်မှုရှိပါသလား",
  T_46_META_WS_P_ISTOPCOLLIDING: "အထက်မှ ထိန်းချုပ်မှု",
  T_46_META_WS_P_ISUNDERLINE: "အောက်စဖျာ",
  T_46_META_WS_P_ISVISIBLE: "မြင်ရသည်",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "အရာဝတ္ထုနောက်ခံအရောင်များ",
  T_46_META_WS_P_ITEMBACKGROUNDS: "အရာဝတ္ထုနောက်ခံများ",
  T_46_META_WS_P_ITEMCOUNTS: "ဝယ်ယူနိုင်သည်",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "အရာဝတ္ထုအပြောအဆိုများ",
  T_46_META_WS_P_ITEMICONS: "အရာဝတ္ထုအိုင်ကွန်းများ",
  T_46_META_WS_P_ITEMID: "အမျိုးအစား ID",
  T_46_META_WS_P_ITEMIDS: "ပစ္စည်း ID များ",
  T_46_META_WS_P_ITEMNAMES: "အရာဝတ္ထုအမည်များ",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "ပစ္စည်းထိန်းသိမ်းမှုစာရင်း",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "ဂိမ်းဂုဏ်ထူးလမ်းကြောင်း",
  T_46_META_WS_P_JOYSTICKIMAGE: "ဂိမ်းဂုဏ်ထူးပုံရိပ်",
  T_46_META_WS_P_JOYSTICKRADIUS: "ဂိမ်းဂုဏ်ထူးရေဒီယတ်",
  T_46_META_WS_P_JUMPCD: "ချန်ပေါက်ချိန်",
  T_46_META_WS_P_JUMPHEIGHT: "ခုန်ထက်မြင့်",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "သိုးထိုးခြင်းအရေအတွက်",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "ရှုပ်ထွေးမှု ထိခိုက်မှု",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "ချောက်ခေါက်အခြေအနေ",
  T_46_META_WS_P_LABEL: "အမှတ်တံဆိပ်",
  T_46_META_WS_P_LABELCOLOR: "အဖြစ်အပျက်အရောင်",
  T_46_META_WS_P_LABELKEY: "အမှတ်တံဆိပ် Key",
  T_46_META_WS_P_LABELPARAMS: "အမှတ်တံဆိပ် Parameter များ",
  T_46_META_WS_P_LASTCHECKPOINTID: "လက်ရှိစစ်ဆေးမှတ်တမ်း ID",
  T_46_META_WS_P_LASTSURVIVALTIME: "နောက်ဆုံးခံစားစေရန်",
  T_46_META_WS_P_LAYERTYPE: "အလွှာအမျိုးအစား",
  T_46_META_WS_P_LAYOUTTYPE: "အစီအစဉ်အမျိုးအစား",
  T_46_META_WS_P_LEFTARM: "ဘယ်ဘက်လက်",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "ဘယ်ဘက်နောက်ခံအရောင်",
  T_46_META_WS_P_LEFTCOLOR: "ဘယ်ဖက်ရောင်",
  T_46_META_WS_P_LEFTDESCRIPTION: "ဘယ်ဘက်အဖွဲ့ဖော်ပြချက်",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "ဘယ်ဘက်ရုပ်သွင်းမှု",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "ဘယ်ဖက်မှပစ်ခတ်မှုကွေ့ညှိမှု",
  T_46_META_WS_P_LEFTFOOT: "ဘယ်ဘက်ခြေဖဝါး",
  T_46_META_WS_P_LEFTHAND: "ဘယ်ဘက်လက်ကောက်",
  T_46_META_WS_P_LEFTICON: "ဘယ်ဘက် အမှတ်",
  T_46_META_WS_P_LEFTICONNAME: "ဘယ်ဘက်အိုင်ကွန်းအမည်",
  T_46_META_WS_P_LEFTLEG: "ဘယ်ဘက်ခြေထောက်",
  T_46_META_WS_P_LEFTPLAYERS: "ဘယ်ဘက်ကစားသမားများ",
  T_46_META_WS_P_LEFTSCORE: "ဘယ်ဘက် နောက်ဆုံးအမှတ်",
  T_46_META_WS_P_LEFTSCOREAFTER: "မူလ အရောင်",
  T_46_META_WS_P_LEFTSCORETEXT: "ညာဘက် စာသား",
  T_46_META_WS_P_LEFTTEAM: "ညာဘက်အဖွဲ့",
  T_46_META_WS_P_LEFTTEAMINDEX: "ဘယ်ဘက်အဖွဲ့ အညွှန်း",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "ဘယ်ဘက်ဇာတ်ကောင်ဘဝရေ",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "ဘယ်ဘက်အဖွဲ့ဝင်လိပ်ပြာများ",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "ဘယ်ဘက်အဖွဲ့ဝင်အခြေအနေ",
  T_46_META_WS_P_LEFTTEAMNAME: "ဘယ်ဘက်အဖွဲ့အမည်",
  T_46_META_WS_P_LEFTTEAMSCORE: "ဘယ်ဘက်အဖွဲ့အမှတ်",
  T_46_META_WS_P_LEFTTEXT: "ညာဘက် အလံ",
  T_46_META_WS_P_LENGTH: "အမည်",
  T_46_META_WS_P_LENSFLARE: "လင်စ် ဖလယ်",
  T_46_META_WS_P_LEVEL: "အဆင့်",
  T_46_META_WS_P_LIFETIME: "အသက်တာ (စက္ကန့်)",
  T_46_META_WS_P_LIGHTCOLOR: "အလင်းရောင်",
  T_46_META_WS_P_LIGHTINTENSITY: "အလင်းအင်တင်စတီ",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "လက် ခြေထောက် ထိခိုက်မှုအချက်",
  T_46_META_WS_P_LINESPACING: "စာကြောင်းအကြားအလွှာ",
  T_46_META_WS_P_LOCALPOSITION: "အခြားအနေအထား",
  T_46_META_WS_P_LOCALROTATION: "ဒေသဆိုင်ရာ လှည့်ပတ်မှု",
  T_46_META_WS_P_LOCALROTATIONQ: "ဒေသဆိုင်ရာ လှည့်ပတ်မှုကွတ်တားနီယန်",
  T_46_META_WS_P_LOCALSCALE: "ဒေသဆိုင်ရာ အရွယ်အစား",
  T_46_META_WS_P_LOCKEY: "ဒေသစကားရပ်တစ်ခု",
  T_46_META_WS_P_LOOPCOUNT: "အချိန်ရေတွက်ခြင်း",
  T_46_META_WS_P_LOOTSOCCER: "လုတ်ဘောလုံး",
  T_46_META_WS_P_LOSEHPCOLOR: "ကစားသမား အမည်",
  T_46_META_WS_P_LOSEMVPS: "ဆုံးရှုံးသူ MVP",
  T_46_META_WS_P_LOSETEXT: "အရှုံးစာသား",
  "T_46_META_WS_P_MAIN CAMERA": "မိမိကင်မရာ",
  T_46_META_WS_P_MAINCOLOR: "အထိမ်းအမှတ် တိုးပွားသော အရောင်",
  T_46_META_WS_P_MAINSCORELIST: "အဓိက အမှတ်များ",
  T_46_META_WS_P_MAINSCORETITLE: "အဓိက အမှတ်ခေါင်းစဉ်",
  T_46_META_WS_P_MAINWEAPON: "အဓိကအကြောင်းအရာ",
  T_46_META_WS_P_MAPSIZE: "အလံအရင်းအမြစ်",
  T_46_META_WS_P_MASK: "မျက်နှာဖုံး",
  T_46_META_WS_P_MASKNAME: "မျက်နှာသစ်နာမည်",
  T_46_META_WS_P_MASS: "အရေအတွက် (ကီလိုဂရမ်)",
  T_46_META_WS_P_MATCHTITLELEFT: "အပြိုင်အခွင့်အမည် ဘယ်ဘက်",
  T_46_META_WS_P_MATCHTITLERIGHT: "အပြိုင်အခွင့်အမည် ညာဘက်",
  T_46_META_WS_P_MAXCAPACITY: "အမြင့်ဆုံး အရေအတွက်",
  T_46_META_WS_P_MAXCOUNT: "အများဆုံးရေတွက်မှု",
  T_46_META_WS_P_MAXDAMAGE: "အမြင့်ဆုံး အထိ ရရှိနိုင်သော အကြွေး",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "အမြင့်ဆုံးမချမှုထောင့်",
  T_46_META_WS_P_MAXDISPLACEMENT: "အမြင့်ဆုံးသွားအနည်းဆုံး",
  T_46_META_WS_P_MAXDISTANCE: "အများဆုံးအကွာအဝေး",
  T_46_META_WS_P_MAXDURABILITY: "အမြင့်ဆုံး သက်သေအား",
  T_46_META_WS_P_MAXDURABILITYRATIO: "အများဆုံးခံနိုင်ရည်အချိုး",
  T_46_META_WS_P_MAXENERGY: "အများဆုံးအင်အား",
  T_46_META_WS_P_MAXEP: "အများဆုံးအင်ပါလီစီ",
  T_46_META_WS_P_MAXHP: "HP အများဆုံး",
  T_46_META_WS_P_MAXJUMPCOUNT: "အကြိမ်ရေမြင့်ဆုံး",
  T_46_META_WS_P_MAXJUMPHEIGHT: "အမြင့်ဆုံးခုန်ခြင်း",
  T_46_META_WS_P_MAXLENGTH: "အထူးအရှုပ်သက်သာမှု",
  T_46_META_WS_P_MAXPROGRESS: "အမြင့်ဆုံးတိုးတက်မှု",
  T_46_META_WS_P_MAXSCATTERRATIO: "အများဆုံးပြန့်နှံ့မှုနှုန်း",
  T_46_META_WS_P_MAXSPEED: "အမြင့်ဆုံးအရပ်အမြန်နှုန်း",
  T_46_META_WS_P_MAXTURRETCOUNT: "အများဆုံးအပွဲအမှတ်",
  T_46_META_WS_P_MAXVALUE: "တက်ကြွ",
  T_46_META_WS_P_MAXWIDGETID: "MaxWidgetID",
  T_46_META_WS_P_MINDAMAGE: "အနိမ့်ဆုံး အထိခိုက်မှု",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "အနိမ့်ဆုံး အထိခိုက်မှု အကွာအဝေး",
  T_46_META_WS_P_MINDISTANCE: "အနည်းဆုံးအကွာအဝေး",
  T_46_META_WS_P_MINELEVATIONANGLE: "အနိမ့်ဆုံးမြှင့်တင်မှုထောင့်",
  T_46_META_WS_P_MINENDHEIGHT: "အနိမ့်ဆုံးဆုံးမအမြင့်",
  T_46_META_WS_P_MINFLYHEIGHT: "အနိမ့်ဆုံးလှေ့လာမှု",
  T_46_META_WS_P_MINMOVEDISTANCE: "အနည်းဆုံးရွေ့လျားမှုအကွာအဝေး",
  T_46_META_WS_P_MINVALUE: "အနိမ့်ဆုံး အရေအတွက်",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "မိုင်းဆီလ် အများဆုံး နာကျင်မှု",
  T_46_META_WS_P_MISSILEMINDAMAGE: "မိုင်းဆီလ် အနည်းဆုံး နာကျင်မှု",
  T_46_META_WS_P_MISSILERANGE: "မိုင်းဆီလ် အကွာအဝေး",
  T_46_META_WS_P_MODEL: "မော်ဒယ်",
  T_46_META_WS_P_MODELVISIBILITY: "မော်ဒယ် ကြည့်မြင်နိုင်မှု",
  T_46_META_WS_P_MODELVISIBLE: "မော်ဒယ် ရှိ/မရှိ",
  T_46_META_WS_P_MONEY: "ငွေ",
  T_46_META_WS_P_MONEYLIST: "ငွေရင်းစာရင်း",
  T_46_META_WS_P_MONEYS: "ချိတ်ဆက်ထားသော ဘဏ်",
  T_46_META_WS_P_MONEYTYPE: "ငွေသွင်းအမျိုးအစား",
  T_46_META_WS_P_MONSTERTYPE: "သတ္တဝါအမျိုးအစား",
  T_46_META_WS_P_MOTIONTYPE: "လှုပ်ရှားမှု အမျိုးအစား",
  T_46_META_WS_P_MOTIONVALUEX: "X အတိုင်းအတာ",
  T_46_META_WS_P_MOTIONVALUEY: "Y အတိုင်းအတာ",
  T_46_META_WS_P_MOTIONVALUEZ: "Z အတိုင်းအတာ",
  T_46_META_WS_P_MOVEMENTDURATION: "လှုပ်ရှားမှု အထူးပေါ်",
  T_46_META_WS_P_MULTIPLIER: "အကြိမ်အနှုန်း",
  T_46_META_WS_P_MUSICELEMENTTYPE: "ဂီတပုဂ္ဂိုလ်အမျိုးအစား",
  T_46_META_WS_P_MUZZLEVELOCITY: "လက်နက်ပေါက်အမြန်နှုန်း",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "ပွဲဆောင်ရရှိမှု",
  T_46_META_WS_P_NEXTROUNDINDEX: "နောက်ဆုံးအဆင့်အညွှန်း",
  T_46_META_WS_P_NICKNAME: "အမည်",
  T_46_META_WS_P_NORMALCOLOR: "ပုံမှန်အရောင်",
  T_46_META_WS_P_NORMALIZEDPOSITION: "နိယာမမော်ဒယ်",
  T_46_META_WS_P_NUMBERINFACTION: "ဖရိကရှင်းအတွင်းအရေအတွက်",
  T_46_META_WS_P_OBJECTID: "အရာဝတ္ထု ID",
  T_46_META_WS_P_OFFSET: "အပြောင်းအလဲ",
  T_46_META_WS_P_OPTIONS: "ရွေးချယ်မှုများ",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "အခြား ထိခိုက်မှုအချက်",
  T_46_META_WS_P_OUTFIT: "ကစားသမားအဝတ်အထည်",
  T_46_META_WS_P_OVERFLOW: "စာသားထွက်စေခြင်း",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "အထက်မတ်တော်ကိုကျော်ပြီးလျှော့စီးမှု",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "ကစားသူ ပြင်ဆင်မှု အထောက်အထား",
  T_46_META_WS_P_OWNER: "ပိုင်ရှင်",
  T_46_META_WS_P_PARAMS: "Parameter များ",
  T_46_META_WS_P_PARENT: "မိဘ",
  T_46_META_WS_P_PARENTID: "မူရင်း UI ID",
  T_46_META_WS_P_PARENTUI: "မူရင်း UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "မိဘ ဝစ်ဂျက် Entity ID",
  T_46_META_WS_P_PARENTWIDGETFILEID: "မိမိရှေ့တွင်စက်ဘီးအိုင်ဒီ",
  T_46_META_WS_P_PARTMASKA: "အစိတ်အပိုင်းမျက်နှာဖုံး 1",
  T_46_META_WS_P_PASSENGERS: "ခရီးသည်များ",
  T_46_META_WS_P_PATHID: "လမ်းကြောင်း ID",
  T_46_META_WS_P_PAUSEEVENT: "ကိန်းရိုးများ",
  T_46_META_WS_P_PERSONAID: "တင်သွင်းခြင်း အမြင့်",
  T_46_META_WS_P_PHASEDURATION: "ကြာချိန် (မီလီစက္ကန့်)",
  T_46_META_WS_P_PHASEENDTIME: "အဆုံးချိန် (မီလီစက္ကန့်)",
  T_46_META_WS_P_PHYSICALLAYER: "ရုပ်ပိုင်းဆိုင်ရာအဆင့်",
  T_46_META_WS_P_PINID: "ပင်မှတ် ID",
  T_46_META_WS_P_PITCH: "ညီညာမျက်နှာပြင်",
  T_46_META_WS_P_PIVOT: "နောက်ခံ",
  T_46_META_WS_P_PLAYER: "ကစားသမား",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "ကစားသမားရည်ညွှန်းမှုအမြန်နှုန်းအချိုး",
  T_46_META_WS_P_PLAYERLIST: "ကစားသမားစာရင်း",
  T_46_META_WS_P_PLAYERNAME: "လက်ရှိ ကျန်းမာရေး",
  T_46_META_WS_P_PLAYERRANK: "ကစားသမား အဆင့်",
  T_46_META_WS_P_PLAYERRANKS: "ကစားသမားအဆင့်များ",
  T_46_META_WS_P_PLAYERS: "ကစားသမားများ",
  T_46_META_WS_P_PLAYERSCORETYPES: "သုံးစွဲသူအမှတ်အမျိုးအစားများ",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "ဂိမ်းသမား၏ အလွှာအပြောင်း အကြောင်းအရာ",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "မောင်းနှင်မှု လျှပ်စစ် သက်ရောက်မှု",
  T_46_META_WS_P_PLAYERSTATUS: "ကစားသမားအခြေအနေ",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "ကစားသမားဆွဲယူမှုအမြန်နှုန်း",
  T_46_META_WS_P_PLAYINGSTATUS: "ကစားနေမှုအခြေအနေ",
  T_46_META_WS_P_PLAYSPEED: "အင်္ဂါရပ် အချိန်",
  T_46_META_WS_P_POINTPOSITION: "အချက်အမှတ် အနေအထား",
  T_46_META_WS_P_POINTS: "အမှတ်",
  T_46_META_WS_P_POSITION: "အနေအထား",
  T_46_META_WS_P_PREFABID: "ပရိဖက် ID",
  T_46_META_WS_P_PRESSEDCOLOR: "သက်သာတဲ့အရောင်",
  T_46_META_WS_P_PRESSEDSPRITE: "ပိုင်းခြားပုံစံ",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "ပိုင်းခြားပုံစံအမျိုးအစား",
  T_46_META_WS_P_PRICE: "စျေးနှုန်း",
  T_46_META_WS_P_PRIORITY: "အထွေအထွေ",
  T_46_META_WS_P_PROFILEINFO: "ပရိုဖိုင်အချက်အလက်",
  T_46_META_WS_P_PROGRESS: "အကျိုးသက်ရောက်မှု အလုပ်လုပ်နေသည်",
  T_46_META_WS_P_PROGRESSICON: "တိုးတက်မှုသင်္ကေတ",
  T_46_META_WS_P_PROGRESSICONNAME: "တိုးတက်မှုသင်္ကေတအမည်",
  T_46_META_WS_P_PROPID: "အကျိုးပြုပွိုင့် အမှတ်",
  T_46_META_WS_P_PURCHASELIMIT: "ဝယ်ယူနိုင်သော အများအတွက်",
  T_46_META_WS_P_RADIUS: "အချင်း",
  T_46_META_WS_P_RANGE: "အပျော်အစား",
  T_46_META_WS_P_RANK: "အဆင့်",
  T_46_META_WS_P_RATIOSELFFACTOR: "ကိုယ်ပိုင်ထိခိုက်မှုအချိုး",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "မိတ်ဆွေများထိခိုက်မှုအချိုး",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "ယာဉ်ထိခိုက်မှုအချိုး",
  T_46_META_WS_P_REFRESHTIME: "ဘာဖ် ပြန်လည်ရယူမှု အချိန် (စက္ကန့်)",
  T_46_META_WS_P_RELOADSPEED: "ပြန်လည်တင်သွင်းခြင်းအမြန်နှုန်း",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "ပြန်လည်လွှတ်မှု လျှပ်စစ်",
  T_46_META_WS_P_REMAINJUMPCOUNT: "မကျန်ရှိသောခုန်အကြိမ်ရေ",
  T_46_META_WS_P_REMAINQUANTITY: "ကျန်သော အရေအတွက်",
  T_46_META_WS_P_RENDERTYPE: "ရူပါရုံအမျိုးအစား",
  T_46_META_WS_P_REPEATTIMES: "ထပ်မံလုပ်ဆောင်မှုအကြိမ်ရေ",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "အစားထိုးမူရွေးချယ်မှု",
  T_46_META_WS_P_REQUESTEDITEMLIST: "တုံ့ပြန်သော အရာဝတ္ထု ID",
  T_46_META_WS_P_REQUESTTYPE: "တောင်းဆိုထားသော အရောင်းအရာများစာရင်း",
  T_46_META_WS_P_RESETPERROUND: "တစ်ခုချင်းစီအကြိမ်ရုန်းပြန်ဖြစ်အောင်ပြုလုပ်ရန်",
  T_46_META_WS_P_RESETPOSITION: "ပြန်လည်တပ်ဆင်မှု တည်နေရာ",
  T_46_META_WS_P_RESETTIME: "ပြန်လည်တပ်ဆင်ခြင်း အချိန်",
  T_46_META_WS_P_RESOURCE: "အရင်းအမြစ်",
  T_46_META_WS_P_RESOURCEID: "ရင်းမြစ်အိုင်ဒီ",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "ပန်လည်သတ်မှတ်မှု",
  T_46_META_WS_P_RESULT: "ရလဒ်",
  T_46_META_WS_P_RESULTTYPE: "အကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_46_META_WS_P_REVIVALPOINT: "ပြန်လည်ဖျက်သိမ်းမှု",
  T_46_META_WS_P_REVIVECD: "နောက်ခံကြာချိန်",
  T_46_META_WS_P_RIGHT: "ညာ",
  T_46_META_WS_P_RIGHTARM: "ညာဘက်လက်",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "ညာဘက်နောက်ခံအရောင်",
  T_46_META_WS_P_RIGHTCOLOR: "ညာဖက်ရောင်",
  T_46_META_WS_P_RIGHTDESCRIPTION: "ညာဘက်အဖွဲ့ဖော်ပြချက်",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "ညာဘက်ရုပ်သွင်းမှု",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "ညာဖက်မှပစ်ခတ်မှုကွေ့ညှိမှု",
  T_46_META_WS_P_RIGHTFOOT: "ညာဘက်ခြေဖဝါး",
  T_46_META_WS_P_RIGHTHAND: "ညာဘက်လက်ကောက်",
  T_46_META_WS_P_RIGHTICON: "ညာဘက် အမှတ်",
  T_46_META_WS_P_RIGHTICONNAME: "ညာဘက်အိုင်ကွန်းအမည်",
  T_46_META_WS_P_RIGHTLEG: "ညာဘက်ခြေထောက်",
  T_46_META_WS_P_RIGHTPLAYERS: "ညာဘက်ကစားသမားများ",
  T_46_META_WS_P_RIGHTSCORE: "ညာဘက် နောက်ဆုံးအမှတ်",
  T_46_META_WS_P_RIGHTSCOREAFTER: "အထိမ်းအမှတ် ပျောက်ဆုံးသွားသော အရောင်",
  T_46_META_WS_P_RIGHTSCORETEXT: "စာသား",
  T_46_META_WS_P_RIGHTTEAM: "ခေါင်းစဉ်များ",
  T_46_META_WS_P_RIGHTTEAMINDEX: "ညာဘက်အဖွဲ့ အညွှန်း",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "ညာဘက်ဇာတ်ကောင်ဘဝရေ",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "အပေါင်းထိပ်ကျန်ဖလက်ဦးရေ",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "ညာဘက်အဖွဲ့ဝင်အခြေအနေ",
  T_46_META_WS_P_RIGHTTEAMNAME: "ညာဘက်အဖွဲ့အမည်",
  T_46_META_WS_P_RIGHTTEAMSCORE: "ညာဘက်အဖွဲ့အမှတ်",
  T_46_META_WS_P_RIGHTTEXT: "အပျော် [0,1]",
  T_46_META_WS_P_RIMALPHA: "အနားအယ်ဖာ",
  T_46_META_WS_P_RIMCOLOR: "အနားအရောင်",
  T_46_META_WS_P_RIMTEXTURE: "အနားအထည်",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "လည်ပတ်မှု အပြုံး ရှုထောင့်",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "အကြောင်းအရာတွင် အပြုံး ရှုထောင့်",
  T_46_META_WS_P_ROTATION: "ရွှေ့ပြောင်းမှု",
  T_46_META_WS_P_ROTATIONANGLE: "လှည့်လျားမှု ကိုဏ်း",
  T_46_META_WS_P_ROTATIONQ: "လှည့်ပတ်မှုကွတ်တားနီယန်",
  T_46_META_WS_P_ROUNDINCOME: "ပြိုင်ပွဲဝင်အကျုံး",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "လှည့်ကြေးအသေးစိတ်ဂဏန်းများ",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "လှည့်ကြေးအသေးစိတ်ခေါင်းစဉ်များ",
  T_46_META_WS_P_ROUNDINCOMETITLE: "ပြိုင်ပွဲဝင်ဘဝခေါင်းစဉ်",
  T_46_META_WS_P_ROUNDNUM: "အကြိမ်ရေ",
  T_46_META_WS_P_ROUNDNUMKEY: "အကြိမ်ရေကီး",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "အကြိမ်ရေ အပြောင်းအလဲ",
  T_46_META_WS_P_RUNSPEED: "chạyလျင်မြန်မှု",
  T_46_META_WS_P_RUNSPEEDSCALE: "วิရန်အကျယ်",
  T_46_META_WS_P_RUSHDISTANCE: "ရွတ်ရှင်အကွာအဝေး",
  T_46_META_WS_P_RUSHENERGYCOST: "ရွတ်ရှင်အင်အားကုန်ကျမှု",
  T_46_META_WS_P_RUSHVERTICALSPEED: "ရွတ်ရှင်အထူးအမြန်နှုန်း",
  T_46_META_WS_P_SCALE: "အတိုင်းအတာ",
  T_46_META_WS_P_SCATTERINCREASESPEED: "ပြန့်နှံ့မှု တိုးတက်မှုအမြန်နှုန်း",
  T_46_META_WS_P_SCATTERMAX: "အများဆုံးပြန့်နှံ့ခြင်း",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "လှုပ်ရှားနေချိန်တွင် ပြန့်နှံ့မှု မျက်နှာပြင်ဖောက်ခြင်း",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "ပြန့်နှံ့မှု ပြန်လည်ထူထောင်ခြင်း အမြန်နှုန်း",
  T_46_META_WS_P_SCATTERSPEED: "အမြန်နှုန်းပြန့်နှံ့ခြင်း",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "ချိုးဖောက်စရာ နှင့် ပြန့်နှံ့ခြင်းအတွင်းအမြန်နှုန်း",
  T_46_META_WS_P_SCATTERTHRESHOLD: "ပြန့်နှံ့မှုစံနှုန်း",
  T_46_META_WS_P_SCOPETYPE: "ကြည့်ကွင်းအမျိုးအစား",
  T_46_META_WS_P_SCORE: "အမှတ်",
  T_46_META_WS_P_SCORES1: "အမှတ်စာရင်း 1",
  T_46_META_WS_P_SCORES2: "အမှတ်စာရင်း 2",
  T_46_META_WS_P_SCORES3: "အမှတ်စာရင်း 3",
  T_46_META_WS_P_SCORES4: "အမှတ်စာရင်း 4",
  T_46_META_WS_P_SCORES5: "အမှတ်စာရင်း 5",
  T_46_META_WS_P_SCORETEXTKEY: "အမှတ်စာသား Key",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "အမှတ်စာသား Key Parameter များ",
  T_46_META_WS_P_SCROLLCONTINUITY: "အဆက်မပြတ်လှုပ်ရှားမှု",
  T_46_META_WS_P_SCROLLDIRECTION: "စီရင်မှုလမ်းကြောင်း",
  T_46_META_WS_P_SCROLLEFFECT: "လွှမ်းမိုးမှု",
  T_46_META_WS_P_SCROLLWHEELSPEED: "ရှုပ်ထွေးမှုအရှိန်",
  T_46_META_WS_P_SECONDSCORETITLE: "ဒုတိယအကြိမ်အမှတ်ခေါင်းစဉ်",
  T_46_META_WS_P_SECONDSCOREVALUE: "ဒုတိယအကြိမ်အမှတ်တန်ဖိုး",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "ဒုတိယအကြိမ်အမှတ်ပေးသော ပရိုပါရာမီတာ",
  T_46_META_WS_P_SELECTEDCOLOR: "အာဏာရှိသောအရောင်",
  T_46_META_WS_P_SELECTEDINDEX: "ရွေးချယ်ထားသောအညွှန်း",
  T_46_META_WS_P_SELECTEDSPRITE: "အာဏာရှိသောပုံစံ",
  T_46_META_WS_P_SELECTEDTYPE: "အာဏာရှိသောအမျိုးအစား",
  T_46_META_WS_P_SELF: "ကိုယ်တိုင်",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "အကျိုးသက်ရောက်မှု ရာနှုန်း",
  T_46_META_WS_P_SET: "စုံတန်း",
  T_46_META_WS_P_SHADERNAME: "စက်နည်းပညာနာမည်",
  T_46_META_WS_P_SHADOWCOLOR: "အရောင်တင်ပါ",
  T_46_META_WS_P_SHADOWOFFSET: "အရောင်ပြောင်းထားမှု",
  T_46_META_WS_P_SHADOWSTRENGTH: "ရှေ့လေးမှတ်",
  T_46_META_WS_P_SHELFS: "လက်တွေ့ပိတ်ဆိုတာ ဖျက်သိမ်းထားသည်",
  T_46_META_WS_P_SHOES: "အပေါက်",
  T_46_META_WS_P_SHOOTANGLEMAX: "အမြင့်ဆုံး အပေါ်မှ ဂြိုလ်",
  T_46_META_WS_P_SHOOTANGLEMIN: "အနိမ့်ဆုံးသွားပျံမှု အထိ",
  T_46_META_WS_P_SHOP: "ဆိုင်",
  T_46_META_WS_P_SHOPITEMS: "ရှယ်ဖွယ်များ",
  T_46_META_WS_P_SHOWADDFRIEND: "သူငယ်ချင်းများထည့်ရန်ပြရန်",
  T_46_META_WS_P_SHOWATTACKGRENADE: "စီးပွားရေးပြပါ",
  T_46_META_WS_P_SHOWBACKGROUND: "နောက်ခံကိုပြပါ",
  T_46_META_WS_P_SHOWCROUCH: "သေးသိုက်ခြင်းပြပါ",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "အထိခိုက်မှုနံပါတ်ပြပါ",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "အိုင်ကွန်းအရောင်",
  T_46_META_WS_P_SHOWECCONOMY: "အပြင်ဈေးကွက်ပြရန်",
  T_46_META_WS_P_SHOWECONOMY: "အပြင်ဈေးကွက်ပြရန်",
  T_46_META_WS_P_SHOWFIRE: "ဖျက်ဆီးခြင်းပြပါ",
  T_46_META_WS_P_SHOWFRAME: "အနားစေ့",
  T_46_META_WS_P_SHOWGIFT: "လက်ဆောင်ပြရန်",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "ထိမှန်မှုအကျိုးသက်ရောက်မှုကိုပြပါ",
  T_46_META_WS_P_SHOWJUMP: "ကြိုးအထွေထွေပြပါ",
  T_46_META_WS_P_SHOWLIKE: "Like ပြရန်",
  T_46_META_WS_P_SHOWLOBBY: "လော့ဘီပြရန်",
  T_46_META_WS_P_SHOWMAPEVALUATE: "မြေပုံအဆင့်သတ်မှတ်ချက်ပြရန်",
  T_46_META_WS_P_SHOWMATCHDETAIL: "ပြိုင်ပွဲအသေးစိတ်ပြရန်",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "လှန်ဆွဲခြင်းပြပါ",
  T_46_META_WS_P_SHOWNAME: "အမည်ပြသခြင်း",
  T_46_META_WS_P_SHOWPIN: "စံသင့်ပြသခြင်း",
  T_46_META_WS_P_SHOWPRONE: "တစ်ချိန်လုံးသောက်ပါ",
  T_46_META_WS_P_SHOWRANK: "အဆင့်ပြသခြင်း",
  T_46_META_WS_P_SHOWREPLAY: "နောက်ခံပြန်လည်ကြိုးစားမှုပြရန်",
  T_46_META_WS_P_SHOWREPORT: "အစီရင်ခံစာပြရန်",
  T_46_META_WS_P_SHOWSHARE: "မျှဝေရန်ပြရန်",
  T_46_META_WS_P_SHOWSPRINT: "အရွယ်အစား",
  T_46_META_WS_P_SHOWTAG: "အထူး အမှတ်တံဆိပ် အရောင်များ",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "ငြိမ်းချမ်းရေးပြပါ",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "အဖွဲ့ဝင်အခြေအနေကို ဖော်ပြပါ",
  T_46_META_WS_P_SHOWTEAMSCORE: "အဖွဲ့အမှတ်ကို ဖော်ပြပါ",
  T_46_META_WS_P_SHOWTIMETYPE: "အချိန်အမျိုးအစားကို ဖော်ပြပါ",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "နှစ်အဖွဲ့အမှတ်ကို ဖော်ပြပါ",
  T_46_META_WS_P_SHRINKDURATION: "ထိခိုက်မှု တန်ဖိုး",
  T_46_META_WS_P_SHRINKENDTIME: "လျှပ်စစ် အစ (မီလီစက္ကန့်)",
  T_46_META_WS_P_SHRINKSPEED: "စုဝေးခြင်းနှုန်း",
  T_46_META_WS_P_SHRINKSTARTTIME: "အမြင့်",
  T_46_META_WS_P_SIGHTAIMASSIST: "ADS အာရုံစူးစိုက်မှုကိုခွင့်ပြုပါ",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "အာရုံစူးစိုက်မှုအကွာအဝေးလျော့နည်းမှုအချိုး (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "အာရုံစူးစိုက်မှုအကွာအဝေးအချိုးကိုထိခိုက်မှု",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "အမြင့်ဆုံးအာရုံစူးစိုက်မှုအကွာအဝေး",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "အနိမ့်ဆုံးအာရုံစူးစိုက်မှုအကွာအဝေး",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "အာရုံစူးစိုက်မှုအကွာအဝေးရွေးချယ်မှုကိုခွင့်ပြုပါ",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "အာရုံစူးစိုက်မှုဆွဲဆောင်မှုအချိုး (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "မြင်ကွင်းချဲ့ခြင်းအချိုး",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "မြင်ကွင်းထောင့်ချဲ့မှု (FOV)",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ADS လည်ပတ်မှုခံစားမှု",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ADS အနာတရအနိမ့်ဆုံးအကွာအဝေးပြင်ဆင်ချက်",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "ADS ချဲ့ထွင်ချိန် (စက္ကန့်)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "ADS ချဲ့ထွင်မှု",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "ADS ပြန်လည်ထူထောင်ချိန် (စက္ကန့်)",
  T_46_META_WS_P_SIZE: "အပြုံးအတွက်",
  T_46_META_WS_P_SIZEDELTA: "အရွယ်အစားဒelta",
  T_46_META_WS_P_SKELETON: "အရိုး",
  T_46_META_WS_P_SKIN: "အသား",
  T_46_META_WS_P_SKINID: "အရေပြား ID",
  T_46_META_WS_P_SKINWIDTH: "အပြင်အဆင်အထူ",
  T_46_META_WS_P_SKYBOXENV: "အနိမ့်သတ္တိ",
  T_46_META_WS_P_SKYBOXRESOURCE: "အကွာအဝေးဘောက်စ် အရင်းအမြစ်",
  T_46_META_WS_P_SLOPELIMIT: "အတင်းအလွန်မောင်းမှု",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "စတင်ရန်မိုက်သတ်မှု",
  T_46_META_WS_P_SOFTNESS: "နူးညံ့မှု",
  T_46_META_WS_P_SORTTYPE: "စီမံခန့်ခွဲမှုအမျိုးအစား",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "လှိုင်းတစ်ခုလျှင် ဖွင့်လှစ်မှုအရေအတွက်",
  T_46_META_WS_P_SPAWNPOINT: "စတင်နေရာ",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "ပေါ်လာစေရန် အချက်အမှတ်အရေအတွက်",
  T_46_META_WS_P_SPAWNPOSITION: "ဗဟို အနေအထား",
  T_46_META_WS_P_SPEED: "အရှိန်",
  T_46_META_WS_P_SPEEDWHILEAIMING: "မြင်ကွင်းအတွင်း လမ်းလျှောက်မှု အဆင့်",
  T_46_META_WS_P_SPRAYCOLOR: "လေ့ကျင့်မှုပန်းစုံ",
  T_46_META_WS_P_SPRINTENERGYCOST: "စပရင့်အင်အားကုန်ကျမှု",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "စပရင့်အတိုင်းအမြန်နှုန်း",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "스프린트 시 이동 속도 비율",
  T_46_META_WS_P_SPRITENAME: "ပုံစံပုံစံ",
  T_46_META_WS_P_SPRITERESOURCE: "ပုံစံအရင်းအမြစ်",
  T_46_META_WS_P_SRCVAL: "အစကိုတန်ဖိုး",
  T_46_META_WS_P_STARTDROPTIME: "ဂြိုဟ်ဗေဒ အနေအထားလား",
  T_46_META_WS_P_STARTEVENT: "ဖြစ်ရပ် အပယ်",
  T_46_META_WS_P_STARTPOSITION: "စတင်အနေအထား",
  T_46_META_WS_P_STARTRADIUS: "အဆုံး အနယ်နယ်",
  T_46_META_WS_P_STARTSPAWNTIME: "မော်ဒယ်စတင်ချိန် (စက္ကန့်)",
  T_46_META_WS_P_STARTTIME: "ဖြစ်ရပ်များ",
  T_46_META_WS_P_STARTVALUE: "စတင်တန်ဖိုး",
  T_46_META_WS_P_STATICICONCOLORS: "အကြောင်းအရာ",
  T_46_META_WS_P_STATICICONS: "အမှတ်တံဆိပ်ကို တရားဝင် ပြသပါ",
  T_46_META_WS_P_STATUS: "အခြေအနေ မီနီစင်ထရီ",
  T_46_META_WS_P_STEPOFFSET: "ခြေထောက်အချိုးလွတ်ခြင်း",
  T_46_META_WS_P_STOPDURATION: "ရပ်တန့်ချိန်",
  T_46_META_WS_P_STOPEVENT: "စတင်ချိန်",
  T_46_META_WS_P_STORE: "ဆိုင်",
  T_46_META_WS_P_STROPID: "ရပ်ကွက်အမှတ်",
  T_46_META_WS_P_STYLE: "စတိုင်",
  T_46_META_WS_P_SUBTITLE: "နောက်ခံ အရောင် 2",
  T_46_META_WS_P_SUMMULTIPLIER: "စုဆောင်းခြင်း",
  T_46_META_WS_P_SWINGEXITACCELERATION: "လှုပ်ရှားမှုမှထွက်ရန်အမြန်နှုန်း",
  T_46_META_WS_P_SWINGINGSPEED: "လှုပ်ရှားမှုအမြန်နှုန်း",
  T_46_META_WS_P_TAGS: "တံဆိပ်",
  T_46_META_WS_P_TARGETCHECKPOINTID: "ရည်မှတ်စစ်ဆေးမှတ်တမ်း ID",
  T_46_META_WS_P_TARGETICONCOLORS: "တည်ငြိမ်သော အမှတ်တံဆိပ် အရောင်များ",
  T_46_META_WS_P_TARGETICONS: "တည်ငြိမ်သော အမှတ်တံဆိပ်များ",
  T_46_META_WS_P_TARGETID: "ပစ်မှတ် ID",
  T_46_META_WS_P_TARGETITEMID: "เป้าหมายရောဂါအမှတ်",
  T_46_META_WS_P_TARGETROTATION: "เป้าหมายหมุน",
  T_46_META_WS_P_TARGETSCALE: "เป้าหมายအရွယ်အစား",
  T_46_META_WS_P_TEAMCOLOR: "အဖွဲ့ရောင်",
  T_46_META_WS_P_TEAMCOLORS: "အဖွဲ့ရောင်များ",
  T_46_META_WS_P_TEAMINDEXS: "အဖွဲ့အညွှန်းများ",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "အဖွဲ့ဝင် အပျက်အကျုံး အချက်အလက်",
  T_46_META_WS_P_TEAMMEMBERNUM: "အဖွဲ့ဝင်များအရေအတွက်",
  T_46_META_WS_P_TEAMNUM: "အသင်းအရေအတွက်",
  T_46_META_WS_P_TEAMRANK: "အဖွဲ့ အဆင့်",
  T_46_META_WS_P_TEAMRANKDISPLAY: "အဖွဲ့အဆင့်ပြသမှု",
  T_46_META_WS_P_TEAMRANKS: "အဖွဲ့အဆင့်များ",
  T_46_META_WS_P_TEAMSCORES: "အဖွဲ့အမှတ်များ",
  T_46_META_WS_P_TEAMSEQ: "အဖွဲ့အစည်း",
  T_46_META_WS_P_TEMPLATEENTITY: "အဖြစ်အပျက်သမား စံပြ",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "ယာဉ်စီးအတွက် အပြုံးအစုံ",
  T_46_META_WS_P_TERRAINWETNESS: "မြေပြင်စိုစွတ်မှု",
  T_46_META_WS_P_TEXT: "အနက်ရောင်",
  T_46_META_WS_P_TEXTCOLOR: "အကျိုးသက်ရောက်မှု အရောင်",
  T_46_META_WS_P_TEXTKEY: "အကြောင်းအရာကီး",
  T_46_META_WS_P_TEXTKEYPARAMS: "အကြောင်းအရာကီးပေးသော ပရိုပါရာမီတာ",
  T_46_META_WS_P_TEXTURERESOURCE: "ဓာတ်ပုံအရင်းအမြစ်",
  T_46_META_WS_P_THEMECOLOR: "စနစ်အရောင်",
  T_46_META_WS_P_THROWABLETYPE: "ပစ်ချင်တတ်သော အမျိုးအစား",
  T_46_META_WS_P_THROWINGSPEED: "ပစ်ချခြင်း၏ အနိမ့်ဆုံး အား",
  T_46_META_WS_P_THROWSPEED: "ပစ်ချခြင်းအမြန်နှုန်း",
  T_46_META_WS_P_TICKINTERVAL: "ဖြစ်ရပ် အစ",
  T_46_META_WS_P_TIMEREQUIRED: "လိုအပ်သောအချိန် (milliseconds)",
  T_46_META_WS_P_TIPSTYPE: "အကြံပြုချက်အမျိုးအစား",
  T_46_META_WS_P_TITLE: "ခေါင်းစဉ်",
  T_46_META_WS_P_TITLELIST: "ခေါင်းစဉ်များ",
  T_46_META_WS_P_TITLES: "အမှတ်တရ1",
  T_46_META_WS_P_TOP: "အထက်အစီး",
  T_46_META_WS_P_TOPALPHA: "အထက်တန်းထင်ရှားမှု",
  T_46_META_WS_P_TOTALHP: "OpenTween သုံးပါ",
  T_46_META_WS_P_TOTALLEVEL: "စုစုပေါင်းအဆင့်",
  T_46_META_WS_P_TOTALROUNDCOUNT: "ဆုံးဖြတ်လှုပ်ရှားမှုအရေအတွက်",
  T_46_META_WS_P_TOWSPEED: "ဆွဲယူမှုအမြန်နှုန်း",
  T_46_META_WS_P_TRANSITIONSTAGE: "အဆင့်ပြောင်းလဲမှု",
  T_46_META_WS_P_TRANSITIONTYPE: "ပြောင်းလဲမှုအမျိုးအစား",
  T_46_META_WS_P_TRIGGERPLAYERID: "ငွေ",
  T_46_META_WS_P_TRIGGERRADIUS: "မီးလောင်မှု အကွာအဝေး",
  T_46_META_WS_P_TRIGGERRANGE: "တိုက်ခိုက်မှုအကွာအဝန်း",
  T_46_META_WS_P_TRIGGERTIME: "ခေါ်သိမ်းချိန်",
  T_46_META_WS_P_TURNSPEED: "ပြန်လည်ရောင်းမှုပမာဏ",
  T_46_META_WS_P_TWEENERENABLED: "ဘယ်ဘက်အဖွဲ့",
  T_46_META_WS_P_TWEENSTYLE: "Tween စတိုင်",
  T_46_META_WS_P_TYPE: "အမျိုးအစား",
  T_46_META_WS_P_UNSELECTEDCOLOR: "မအာဏာရှိသောအရောင်",
  T_46_META_WS_P_UNSELECTEDSPRITE: "မအာဏာရှိသောပုံစံ",
  T_46_META_WS_P_UNSELECTEDTYPE: "မအာဏာရှိသောအမျိုးအစား",
  T_46_META_WS_P_UP: "အထက်",
  T_46_META_WS_P_UPDATETYPE: "အပ်ဒိတ်အမျိုးအစား",
  T_46_META_WS_P_UPENERGYCOST: "အပျော်ဖို့ကုန်ကျစရိတ်",
  T_46_META_WS_P_UPSPEED: "အဆုတ်ပိုး အမြင့်",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "ကိုယ်ရေးကိုယ်တာပေးသော အားလုံးသုံးပါ",
  T_46_META_WS_P_USECUSTOMRESOURCE: "အထူး အမှတ်တံဆိပ်များ",
  T_46_META_WS_P_USEDCAPACITY: "အသုံးပြုထားသော အရေအတွက်",
  T_46_META_WS_P_USEGRAVITY: "အလှိုင်းလွှတ်မှုကို အသုံးပြုပါ",
  T_46_META_WS_P_USEPHYSICALCCT: "ရုပ်ပိုင်းဆိုင်ရာ CCT ကို အသုံးပြုပါ",
  T_46_META_WS_P_USERUID: "အသုံးပြုသူ UID",
  T_46_META_WS_P_UVOFFSET: "UV ဖြတ်",
  T_46_META_WS_P_UVSIZE: "UV အရွယ်အစား",
  T_46_META_WS_P_VALUE: "တန်ဖိုး",
  T_46_META_WS_P_VAULTDISTANCE: "ကိုယ်ပိုင် ID",
  T_46_META_WS_P_VAULTHEIGHT: "အတွင်းပုံ",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "သတ်မှတ်သည် အထူးအချက်အလက်",
  T_46_META_WS_P_VEHICLESKINID: "မော်တော်ယာဉ် အရောင် ID",
  T_46_META_WS_P_VEHICLESKINIDS: "ယာဉ်သုံးအထည်အလိပ် ID",
  T_46_META_WS_P_VELOCITY: "လမ်းကြောင်းမြန်နှုန်း (မီတာ/စက္ကန့်)",
  T_46_META_WS_P_VELOCITYXZ: "XZ အမြန်နှုန်း",
  T_46_META_WS_P_VELOCITYY: "Y အမြန်နှုန်း",
  T_46_META_WS_P_VERTICALBAR: "ကွေးပုံစံ",
  T_46_META_WS_P_VERTICALOFFSET: "အတောက်ပကာ",
  T_46_META_WS_P_VEST: "ရဲရဲလေး",
  T_46_META_WS_P_VFXTEXTURETYPE: "VFX ဖွဲ့စည်းပုံအမျိုးအစား",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "ကြည့်မြင်မှု ကန့်သတ်ချက်",
  T_46_META_WS_P_VISIBILITYLAYER: "မြင်နိုင်မှု အလွှာ",
  T_46_META_WS_P_VISIBLE: "မြင်ရနိုင်",
  T_46_META_WS_P_VISIBLEONBACK: "ကိုယ်ပိုင်တွင် ပေါ်နေသည်",
  T_46_META_WS_P_VISIBLEPLAYERS: "ထိခိုက်မှု အတွင်း (မီလီစက္ကန့်)",
  T_46_META_WS_P_VOLUME: "အသံအတိုးအကျယ်",
  T_46_META_WS_P_WALLETID: "ပိုက်ဆံအိတ် ID",
  T_46_META_WS_P_WANDERRANGE: "လှုပ်ရှားမှုပမာဏ",
  T_46_META_WS_P_WAVECOUNT: "လှိုင်းအရေအတွက်",
  T_46_META_WS_P_WAVEINTERVAL: "လှိုင်းအကြားအချိန်",
  T_46_META_WS_P_WEAPONDAMAGERATE: "အကျိုးသက်ရောက်မှုအပျက်ဖြစ်စေ",
  T_46_META_WS_P_WEAPONSKINIDS: "အထည်အလိပ် ID",
  T_46_META_WS_P_WEAPONSUBTYPE: "လက်နက် အမျိုးအစား",
  T_46_META_WS_P_WEAPONTYPE: "အပစ္စည်းအမျိုးအစား",
  T_46_META_WS_P_WIDTH: "အကျယ်",
  T_46_META_WS_P_WINMVPS: "အနိုင်ရသူ MVP",
  T_46_META_WS_P_WINTEXT: "အနိုင်စာသား",
  T_46_META_WS_P_WORDWRAP: "စာကြောင်းဖွင့်",
  T_46_META_WS_P_WORLDPOSITION: "ကမ္ဘာ့နေရာ",
  T_46_META_WS_P_YAW: "လှည့်ရုံ",
  T_46_META_WS_PATROLALONG: "လမ်းကြောင်းဖြတ်၍ လှည့်ပတ်ပါ",
  T_46_META_WS_PATROLTO: "လမ်းကြောင်းသွားပါ",
  T_46_META_WS_PAUSE: "နားခို",
  T_46_META_WS_PAUSEEMOTE: "ပေါင်းထည့်မှုများ",
  T_46_META_WS_PAUSEFIXEDUPDATE: "ထုံးစံ တစ်ခုဖန်တီး",
  T_46_META_WS_PHASE: "အဆင့်",
  T_46_META_WS_PLAY: "ပြန်လည်စတင်",
  T_46_META_WS_PLAYANIMATION: "အနုပညာကိုပြပါ",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "ကစားသမားအနုပညာအပိုင်းကိုပြပါ",
  T_46_META_WS_PLAYEMOTE: "စာမျက်နှာခင်းများ",
  T_46_META_WS_PLAYER: "ကစားသမား",
  T_46_META_WS_PORTAL: "တံခါးပေါက်",
  T_46_META_WS_POSE: "ကိုယ်ဟန်",
  T_46_META_WS_POSITION: "တည်နေရာ",
  T_46_META_WS_PREPOSE: "မူရင်းကိုယ်ဟန် ",
  T_46_META_WS_PROFANITYFILTER: "မသင့်တော်သော စစ်ဆင်မှုဖြတ်ဖျက်",
  T_46_META_WS_PURSUITTARGET: "လိုက်လျောစေသောရည်ရွယ်ချက်",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "ပြန်လည်သတ်မှတ်",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Euler မှ ကွာတွန်း",
  T_46_META_WS_QUITCHATCHANNEL: "စကားဝိုင်းချန်နယ်မှထွက်ပါ",
  T_46_META_WS_QUITFACTION: "အဖွဲ့စည်းမှထွက်ပါ",
  T_46_META_WS_QUITGAME: "ဂိမ်းထွက်",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "ထောင်ပြတ် MiniGame ထွက်",
  T_46_META_WS_RANDOMFLOAT: "စွမ်းဆောင်ရည်နံပါတ်များ",
  T_46_META_WS_RANDOMINT: "ကွင်းအတွင်းအနေဖြင့်ရှိခြင်း",
  T_46_META_WS_RANK: "အဆင့်",
  T_46_META_WS_READCSV: "စာရင်းဖတ်",
  T_46_META_WS_READCSVCELL: "ဆဲလ်ဖတ်",
  T_46_META_WS_READCSVCELLBYNAME: "အမည်အတန်းဆဲလ်ဖတ်",
  T_46_META_WS_READCSVCELLFROMSERVER: "ဆာဗာဆဲလ်ဖတ်",
  T_46_META_WS_READCSVCOLUMN: "ကော်လံဖတ်",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "ဆာဗာကော်လံဖတ်",
  T_46_META_WS_READCSVFROMSERVER: "ဆာဗာစာရင်းဖတ်",
  T_46_META_WS_READCSVROW: "အတန်းဖတ်",
  T_46_META_WS_READCSVROWBYKEY: "ကီးအတန်းဖတ်",
  T_46_META_WS_READCSVROWFROMSERVER: "ဆာဗာအတန်းဖတ်",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "စုဆောင်းထားသောဒေတာစတိုးမှ ဖတ်ပါ",
  T_46_META_WS_READFROMDATASTORE: "ဒေတာစတိုးမှ ဖတ်ပါ",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "လီဒ်ဘုတ်ဒေတာစတိုးမှ ဖတ်ပါ",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "အဆင့်ဖြင့် လီဒ်ဘုတ်ဒေတာစတိုးမှ ဖတ်ပါ",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "ကြောင်ချွတ်မှု",
  T_46_META_WS_REMOVEBACKPACKSKIN: "လက်နက်ပုံပြင်",
  T_46_META_WS_REMOVEBUFF: "Buff ဖယ်ရှား",
  T_46_META_WS_REMOVECOMPONENT: "နေပြည်တော်မှ",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "ရုပ်ပြသရုပ်ပွဲအထူးဓာတ်ခွဲကို ဖျက်ပါ",
  T_46_META_WS_REMOVEOUTFIT: "အမူကြေးနွယ်ဖယ်",
  T_46_META_WS_REMOVESCRIPT: "စာမူဖျက်ပါ",
  T_46_META_WS_REMOVEVEHICLESKIN: "ကားဖုံးဖယ်ရှား",
  T_46_META_WS_REMOVEWEAPONSKIN: "အမြင့်ဆုံး",
  T_46_META_WS_REPLACE: "အစားထိုးပါ",
  T_46_META_WS_REQUESTMATCHMAKING: "သက်ဆိုင်ရာပေါင်းစုံ တောင်းဆို",
  T_46_META_WS_RESET: "ပြန်သတ်မှတ်",
  T_46_META_WS_RESETBACKPACKSKIN: "မိဘတည်နေရာသတ်မှတ်",
  T_46_META_WS_RESETDYEING: "ဆေးခြယ်ခြင်းပြန်လည်သတ်မှတ်",
  T_46_META_WS_RESETJERSEY: "ရာဇဝင်ကိုပြန်လည်သတ်မှတ်ပါ",
  T_46_META_WS_RESETOUTFIT: "အမူကြေးနွယ်ရယူ",
  T_46_META_WS_RESETVEHICLESKIN: "ကားဖုံး ပြန်ထား",
  T_46_META_WS_RESETWEAPONSKIN: "စီးဆင်းအကာအကွယ်",
  T_46_META_WS_RESUMEFIXEDUPDATE: "ပေါင်းစပ်မှု ဖန်တီး",
  T_46_META_WS_REVERSE: "အကြောင်းပြန်ပါ",
  T_46_META_WS_REVIVALSOURCE: "ပြန်လည်ရှင်သန်ရေးအရင်းအမြစ်",
  T_46_META_WS_REVIVE: "ပင်မစနစ်အခြေအနေ",
  T_46_META_WS_ROUND: "ကြီးစားကိရိယာများ",
  T_46_META_WS_ROUNDINDEX: "ရက်ပတ်ညွှန်းကိန်း",
  T_46_META_WS_SAMPLEONCURVE: "အသံ ဖန်တီး",
  T_46_META_WS_SCENENAME: "မြင်ကွင်းအမည်",
  T_46_META_WS_SCORE: "အမှတ်",
  T_46_META_WS_SCORER: "ဂိုးသွင်းသူ",
  T_46_META_WS_SCORETYPE: "အမှတ်အမျိုးအစား",
  T_46_META_WS_SCREENMULTIRAYCAST: "ရောင်ခြည်များကိုရယူပါ",
  T_46_META_WS_SCREENSINGLERAYCAST: "ရောင်ခြည် တစ်ခုရယူပါ",
  T_46_META_WS_SCREENTOUCHRAY: "မျက်နှာပြင်ထိမှန် ရောင်ခြည်",
  T_46_META_WS_SCREENTOWORLDPOINT: "မျက်နှာပြင်မှ ကမ္ဘာသို့",
  T_46_META_WS_SENDEVENT: "ထိခိုက်မှုသတ်မှတ်",
  T_46_META_WS_SETACTIVE: "အခြေအနေသတ်မှတ်",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "ကစားသမားလှုပ်ရှားမှုပြောင်းခြင်း",
  T_46_META_WS_SETATTACKABLEENTITY: "ရှုံးနိုင်သောအရာများသတ်မှတ်ပါ",
  T_46_META_WS_SETATTACKABLEFACTION: "လုပ်ဆောင်ရန်နိုင်သောအဖွဲ့သတ်မှတ်ပါ",
  T_46_META_WS_SETATTACKABLETEAM: "လုပ်ဆောင်ရန်နိုင်သောအဖွဲ့သတ်မှတ်ပါ",
  T_46_META_WS_SETBACKPACKSKIN: "အရိုးနာမည်များ",
  T_46_META_WS_SETBEHAVIORSTATUS: "ဥပဒေစာတမ်းစနစ်ကိုသတ်မှတ်ပါ",
  T_46_META_WS_SETBLACKBOARDVALUE: "အနက်တံများ သတ်မှတ်",
  T_46_META_WS_SETBUNDLE: "အဝတ်ဖယ်",
  T_46_META_WS_SETCAMERAFOCUS: "ကင်မရာအာရုံစိုက်",
  T_46_META_WS_SETCAMERAFOLLOW: "ကင်မရာလိုက်",
  T_46_META_WS_SETCHARACTER: "ဇာတ်ကောင်ကိုသတ်မှတ်ပါ",
  T_46_META_WS_SETCULLINGMASK: "ကင်မရာ Mask ကို သတ်မှတ်",
  T_46_META_WS_SETCULLINGMASKLAYER: "Mask အလွှာ သတ်မှတ်",
  T_46_META_WS_SETDEFAULTUISTATUS: "ပုံမှန် UI ကို သတ်မှတ်ပါ",
  T_46_META_WS_SETDROPSTATUS: "လက်ပစ်မှုအခြေအနေသတ်မှတ်ပါ",
  T_46_META_WS_SETFALLINGDAMAGE: "ထိခိုက်မှု သတ်မှတ်",
  T_46_META_WS_SETFOOTBALLPOSITION: "ဘောလုံးနေရာကိုသတ်မှတ်ပါ",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "ရုပ်ပြသရုပ်ပွဲကို တိကျစွာစီမံပါ",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "ရုပ်ပြသရုပ်ပွဲကို ဆက်စပ်အတိုင်းစီမံပါ",
  T_46_META_WS_SETFORWARD: "အရှေ့ဘက်သတ်မှတ်",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "အိပ်ရာမျိုးစုံ",
  T_46_META_WS_SETINVINCIBILITY: "အစီအစဉ်ပြန်လည်စတင်မှု",
  T_46_META_WS_SETJERSEY: "ရာဇဝင်ကိုသတ်မှတ်ပါ",
  T_46_META_WS_SETOUTFIT: "အဝတ်ပြန်ထား",
  T_46_META_WS_SETPARENT: "မိဘပြောင်း",
  T_46_META_WS_SETPARENTCLIENT: "ဦးပေါင်းပြုပြင်မှု",
  T_46_META_WS_SETPICKUPSTATUS: "လက်ခံမှုအခြေအနေသတ်မှတ်ပါ",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "ကစားသမားမြန်နှုန်းစက်ရုံအခြေအနေကိုသတ်မှတ်ပါ",
  T_46_META_WS_SETPLAYERVOICESTATUS: "ကစားသမားအသံအခြေအနေကိုသတ်မှတ်ပါ",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "ပျော့ပြောင်း",
  T_46_META_WS_SETSKILLS: "ကျွမ်းကျင်မှုသတ်မှတ်",
  T_46_META_WS_SETSKYBOX: "ပေါင်းထည့်ချက်",
  T_46_META_WS_SETSLEEPTHRESHOLD: "အိပ်ရာစမ်းသပ်",
  T_46_META_WS_SETSPECIALITEMSTATUS: "အထူးအရာဝတ္ထုအခြေအနေပြောင်းခြင်း",
  T_46_META_WS_SETVEHICLESKIN: "ကားဖုံး သတ်မှတ်",
  T_46_META_WS_SETWEAPONSKIN: "အမူကြေးနွယ်ပြန်ထား",
  T_46_META_WS_SETWIDGETPARENT: "မိဘအသတ်မှတ်",
  T_46_META_WS_SHOPITEM: "ဆိုင်ပစ္စည်း",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "အရုပ်အဆင်ပြင်စုကိုပြပါ",
  T_46_META_WS_SHUFFLE: "ရှုလှမ်းပါ",
  T_46_META_WS_SIN: "ဖန်တီးမှုများ",
  T_46_META_WS_SINGLERAYCAST: "တစ်ချက်ပစ်စမ်း",
  T_46_META_WS_SKILL: "ကျွမ်းကျင်မှု",
  T_46_META_WS_SLEEP: "အိပ်စိမ်း",
  T_46_META_WS_SLERPQUATERNION: "ကွာတွန်းစုံကွက်",
  T_46_META_WS_SPAWNABLES: "ဖန်တီးနိုင်သောပစ္စည်းများ",
  T_46_META_WS_SPAWNEDITEM: "ဖန်တီးထားသောပစ္စည်း",
  T_46_META_WS_SPAWNNEXTWAVE: "နောက်ထပ်လှိုင်းကိုဖန်တီးပါ",
  T_46_META_WS_SPHERECAST: "ဂြိုဟ်စမ်း",
  T_46_META_WS_SPHEREOVERLAP: "ဂြိုဟ်အတွင်းခေါင်းစူး",
  T_46_META_WS_SPLIT: "ခွဲပါ",
  T_46_META_WS_SQRT: "ဖျောက်ထုတ်ထားသော",
  T_46_META_WS_STARTPARACHUTE: "နောက်ဆုံးသတ်မှတ်",
  T_46_META_WS_STARTPOSITION: "စတင်နေရာ",
  T_46_META_WS_STATENAME: "အခြေအနေအမည်",
  T_46_META_WS_STATUS: "အခြေအနေ",
  T_46_META_WS_STRINGTOFLOAT: "စာသားကို Float သို့ပြောင်း",
  T_46_META_WS_STRINGTOINT: "စာသားကို Int သို့ပြောင်း",
  T_46_META_WS_STRIP: "စာသားနှစ်ဖက်မှ ရှင်းလင်းပါ",
  T_46_META_WS_SUB: "အပြုံးပါ",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "AOI Proxy အစီရင်ခံသူကို လဲလှယ်ပါ",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "အရုပ်အဆင်ပြင်စုကိုပြောင်းပါ",
  T_46_META_WS_SWITCHAREA: "ဒေသကိုပြောင်းပါ",
  T_46_META_WS_SWITCHCAMERA: "ကင်မရာကိုပြောင်းပါ",
  T_46_META_WS_SWITCHPHASE: "အဆင့်ပြောင်းခြင်း",
  T_46_META_WS_SWITCHSCENE: "အစင်ပြောင်းပါ",
  T_46_META_WS_SWITCHWEAPON: "အဝတ်အစားလဲပါ",
  T_46_META_WS_TAN: "စည်းမျဉ်းများကိုစစ်ထုတ်ခြင်း",
  T_46_META_WS_TARGET: "ပစ်မှတ်",
  T_46_META_WS_TEAM: "အသင်း",
  T_46_META_WS_TELEPORT: "လွှတ်ထားသောစာမျက်နှာ",
  T_46_META_WS_TELEPORTCCT: "အရပ်ပြောင်း",
  T_46_META_WS_TEXT: "စာသား",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "အချိန်မှတ်ဒေသိဇ်ကို ရယူ",
  T_46_META_WS_TIRE: "ဘီး",
  T_46_META_WS_TOLOWER: "နိမ့်ကျသောအရေအတွက်သို့ပြောင်းပါ",
  T_46_META_WS_TOSTRING: "string အဖြစ်ပြောင်းပါ",
  T_46_META_WS_TOUPPER: "အထက်စကားလုံးသို့ပြောင်းပါ",
  T_46_META_WS_TRANSFERMONEY: "ငွေပေးပို့ပါ",
  T_46_META_WS_TRIGGER: "အမျိုးသား",
  T_46_META_WS_TYPEIS: "အမျိုးအစားဖြစ်ပါသည်",
  T_46_META_WS_UNLOADSCENE: "အစင်ကိုမလိုက်ပါ",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "ထောင်ပြတ်မစ်ရှင်မွမ်းမံ",
  T_46_META_WS_UPLOADGAMERESULT: "အကျိုးသက်ရောက်မှု ဖန်တီး",
  T_46_META_WS_VALUE: "ထိခိုက်မှု",
  T_46_META_WS_VECTOR2ANGLE: "တည်ငြိမ်မှုချိန်ညှိမှုများ",
  T_46_META_WS_VECTOR2DISTANCE: "အမြင်အာရုံစွမ်းဆောင်ရည်",
  T_46_META_WS_VECTOR2DOT: "အသေးစိတ်ကိုထုတ်ယူခြင်း",
  T_46_META_WS_VECTOR2MAGNITUDE: "ပေါင်းထည့်မှုများ",
  T_46_META_WS_VECTOR2NORMALIZE: "ပြီးပြည့်စုံမှု",
  T_46_META_WS_VECTOR2REFLECT: "ထုတ်ယူထားသည့်အချိန်",
  T_46_META_WS_VECTOR2TOVECTOR3: "စီစဉ်ထားသည့်အစီအစဉ်",
  T_46_META_WS_VECTOR3REFLECT: "ထိရောက်သောကိရိယာ",
  T_46_META_WS_VECTOR3TOVECTOR2: "စမ်းသပ်ထားသည်",
  T_46_META_WS_VEHICLE: "ယာဉ်",
  T_46_META_WS_VELOCITY: "အရှိန်",
  T_46_META_WS_WAITFORMILESECOND: "မိစက္ကန့်စာမစောင့်ခြင်း",
  T_46_META_WS_WAITFORNEXTFRAME: "နောက်ကျပ်မှတ်တမ်းတင်ရန်စောင့်ခြင်း",
  T_46_META_WS_WAKEUP: "နိုးထ",
  T_46_META_WS_WAVES: "လှိုင်းများ",
  T_46_META_WS_WEAPON: "လက်နက်",
  T_46_META_WS_WORLDTOSCREENPOINT: "ကမ္ဘာမှ မျက်နှာပြင်သို့",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "စုဆောင်းထားသောဒေတာစတိုးတွင် ရေးပါ",
  T_46_META_WS_WRITETODATASTORE: "ဒေတာစတိုးတွင် ရေးပါ",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "လီဒ်ဘုတ်ဒေတာစတိုးတွင် ရေးပါ",
  T_48_META_API_1_D: "လက်ရှိဂိမ်းရှိ ကစားသမားအားလုံးကို ရယူပြီး ကစားသမားစာရင်းသို့ ပြန်သွားပါ။",
  T_48_META_API_1_R_D: "ကစားသမားစာရင်း",
  T_48_META_API_10_D: "မြင်ကွင်းပစ္စည်းများကို ရယူပါ။",
  T_48_META_API_10_P0_D: "စစ်ထုတ်ရမည့် မြင်ကွင်းအရာဝတ္ထု အမျိုးအစား",
  T_48_META_API_10_R_D: "မြင်ကွင်းအရာဝတ္ထုစာရင်း",
  T_48_META_API_100_D: "ဇာတ်ဝင်ခန်းများ တင်ပေးခြင်းသည် တင်ပြီးသား မြင်ကွင်းများကို အလိုအလျောက် ပြန်ဖြုတ်မည်မဟုတ်ပါ။",
  T_48_META_API_100_P0_D: "တင်ရန် Scene ID",
  T_48_META_API_10000_D: "လက်ရှိ script နှင့် ချည်ထားသော အကြောင်းအရာကို ပြန်ပေးသည်။",
  T_48_META_API_10000_R_D: "အကြောင်းအရာသည် လက်ရှိ script နှင့် ချိတ်ဆက်ထားသည်။",
  T_48_META_API_10001_D: "အမှုအရာရဲ့ အမှတ်သတ်ကို အသုံးပြုပြီး နှိုင်းယှဉ်သော အမှုအရာကို ရှာဖွေရန်။ ဤ API ကို အက်ဒီတာ ကနေသာ အသုံးပြုနိုင်ပြီး အသုံးပြုသူဘက်က ဤ API ကို အသုံးပြုသည့်အခါ ၎င်း၏ အညီအယှဉ်မှုကို အာမခံချက်မပြုနိုင်ပါ။ ဥပမာအားဖြင့် ဖယ်ရှားခြင်း သို့မဟုတ် အညီအယှဉ်များကို ပြော",
  T_48_META_API_10001_P0_D: "ပစ်မှတ်အဖွဲ့အစည်း ID",
  T_48_META_API_10001_R_D: "ဘဘ",
  T_48_META_API_10002_D: "ဂိမ်း၏ ကမ္ဘာလုံးဆိုင်ရာ အကြောင်းအရာကို ရယူပါ။",
  T_48_META_API_10002_R_D: "ကမ္ဘာလုံးဆိုင်ရာအဖွဲ့အစည်း",
  T_48_META_API_10003_D: "ကစားသမားအား တိကျသော သြဒိနိတ်များဆီသို့ တယ်လီပို့ပါ ( အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ တယ်လီပို့ကို အသုံးပြုပါ)",
  T_48_META_API_10003_P0_D: "တယ်လီပို့ ဘာညာ",
  T_48_META_API_10003_P1_D: "တယ်လီပို့ပွိုင့်၏ သြဒီနိတ်များ",
  T_48_META_API_10004_D: "အသင်းဖော်များအနီးတွင် နေရာရယူပြီး မခံမရပ်နိုင်သော ကစားသမားများ၏ အနေအထားကို ရှောင်ကြဉ်ပါ ( အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ GetTeammateNearPosition ကိုသုံးပါ)",
  T_48_META_API_10004_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_10004_R_D: "အသင်းဖော်တွေနဲ့ နီးနီးကပ်ကပ် ညှိနှိုင်းပါ။",
  T_48_META_API_10005_D: "အဖွဲ့အစည်းကို ပိုင်ဆိုင်သော ကစားသမားကို ရယူပါ။",
  T_48_META_API_10005_P0_D: "ပစ်မှတ်အဖွဲ့အစည်း၊ အကြောင်းအရာသည် ၎င်းပိုင်ဆိုင်သည့် ပလေယာနှင့်သာ ထပ်တူပြုပါမည်။",
  T_48_META_API_10005_R_D: "ပစ်မှတ်အဖွဲ့အစည်းပိုင် ကစားသမား",
  T_48_META_API_10006_D: "ကစားသမားကို တွန်းလှန်နိုင်ပါစေ။",
  T_48_META_API_10006_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_10006_P1_D: "မအောင်မြင်နိုင်သောအကျိုးသက်ရောက်မှုကြာချိန်၊ စက္ကန့်",
  T_48_META_API_10007_D: "ရွေးချယ်ထားသော အဖွဲ့အစည်းနှင့် ၎င်း၏ဂုဏ်သတ္တိများအားလုံးကို ၎င်း၏မူရင်းတည်နေရာတွင် ပုံတူပွားပါ။",
  T_48_META_API_10007_P0_D: "အကြောင်းအရာကို ဖန်တီးထားသည်။",
  T_48_META_API_10007_P1_D: "ကိုယ်ပွားလုပ်ရမည့်အရာ",
  T_48_META_API_10008_D: "ထိခိုက်မှုအရင်းအမြစ်ကို မရွေးချယ်ပါက၊ ပစ်မှတ်သည် စနစ်မှ ပျက်စီးမှုကို ဖြစ်ပေါ်စေသည်။",
  T_48_META_API_10008_P0_D: "ပျက်စီးနေသောဂိမ်းဘဘ",
  T_48_META_API_10008_P1_D: "ပျက်စီးမှုကို ဖြစ်စေသော ဂိမ်းတစ်ခု",
  T_48_META_API_10008_P2_D: "ပျက်စီးမှုအမျိုးအစား",
  T_48_META_API_10008_P3_D: "ပျက်စီးခြင်း။",
  T_48_META_API_10009_D: "သတ်မှတ်ထားသောကစားသမား၏ရှင်ပြန်ထမြောက်ခြင်း။",
  T_48_META_API_10009_P0_D: "ရှင်ပြန်ထမြောက်သောကစားသမား",
  T_48_META_API_1001_D: "အခြေအနေများနှင့်ကိုက်ညီပါက IF အောက်ရှိ node ကို run လိမ့်မည်။ အခြေအနေများနှင့် မကိုက်ညီပါက ELSE ရှိပါက ELSE အောက်ရှိ node ကို run ပါ၊ သို့မဟုတ်ပါက IF ကြေညာချက်ကို အဆုံးသတ်ပါ။",
  T_48_META_API_1001_P0_D: "အခြေအနေစာရင်းသည် လုပ်ငန်းစဉ်ခွဲစာရင်းများ (ယုတ္တိဗေဒဌာနခွဲစာရင်းများ) အရေအတွက်နှင့် ကိုက်ညီရန် လိုအပ်ပါသည်။",
  T_48_META_API_10010_D: "သတ်မှတ်ထားသော တည်နေရာတွင် အကြောင်းအရာတစ်ခု သို့မဟုတ် ပစ္စည်းများစာရင်းကို ဖန်တီးပါ။",
  T_48_META_API_10010_P0_D: "ပစ္စည်းဖန်တီးမှုတည်နေရာ",
  T_48_META_API_10010_P1_D: "ဖန်တီးထားသည့်အရာ သို့မဟုတ် ပစ္စည်းများစာရင်း",
  T_48_META_API_10010_P2_D: "ပစ္စည်းစာရင်းကို ဖန်တီးသည့်အခါ၊ ပစ္စည်းစာရင်း၏ အစီအစဥ်နှင့် ကိုက်ညီသော ပစ္စည်းအရေအတွက်စာရင်းကို ဖြည့်ရန် လိုအပ်သည်။",
  T_48_META_API_10011_D: "ပစ်မှတ်ဆီသို့ AI entity ကင်းလှည့်သည်။",
  T_48_META_API_10011_P0_D: "ပစ်မှတ် AI အဖွဲ့အစည်း",
  T_48_META_API_10011_P1_D: "ရွေ့လျားပစ်မှတ်",
  T_48_META_API_10011_P2_D: "အစမှတ်ကို ပြန်သွားမလား။",
  T_48_META_API_10011_P3_D: "ကင်းလှည့်နေစဉ် ရန်လိုသောပစ်မှတ်များကို ရှာဖွေပြီး တိုက်ခိုက်ခြင်းရှိမရှိ",
  T_48_META_API_10012_D: "ညှိနှိုင်းစာရင်းအရ AI အဖွဲ့အစည်းများ ကင်းလှည့်ခြင်း။",
  T_48_META_API_10012_P0_D: "ပစ်မှတ် AI အဖွဲ့အစည်း",
  T_48_META_API_10012_P1_D: "ရွေ့လျားသြဒိနိတ်အမှတ်စာရင်း",
  T_48_META_API_10012_P2_D: "လှည့်ကင်းအမျိုးအစား၊ သင်သည် တစ်ခုတည်း၊ အသွားအပြန် သို့မဟုတ် စက်ဘီးကို ရွေးချယ်နိုင်သည်။",
  T_48_META_API_10012_P3_D: "ကင်းလှည့်နေစဉ် ရန်လိုသောပစ်မှတ်များကို ရှာဖွေပြီး တိုက်ခိုက်ခြင်းရှိမရှိ",
  T_48_META_API_10013_D: "ဂျင်နရေတာသည် နောက်ထပ်ယူနစ်တစ်ခု၏လှိုင်းကို ချက်ချင်းပြန်လည်လန်းဆန်းစေသည်။",
  T_48_META_API_10013_P0_D: "ဂျင်နရေတာ ဘဘ",
  T_48_META_API_10014_D: "တွက်ချက်နိုင်သော အရည်အချင်းများ အတွက် တွက်ချက်နိုင်သော ကိန်းဂဏန်းများ ပေါင်းထည့်ထားသော အချက်များဖြင့် ဖွဲ့စည်းထားသော ဖော်မြူလာမှ နောက်ဆုံးရလဒ်ကို တွက်ချက်ပါမည်။",
  T_48_META_API_10014_P0_D: "ပစ်မှတ်",
  T_48_META_API_10014_P1_D: "တွက်ချက်နိုင်သော ပစ္စည်းအမျိုးအစားများ",
  T_48_META_API_10014_P2_D: "ကိန်းဂဏန်းအမျိုးအစားကို တွက်ချက်ပါ။",
  T_48_META_API_10014_P3_D: "ကိန်းဂဏန်းတန်ဖိုးများကို တွက်ချက်ပါ။",
  T_48_META_API_10015_D: "တွက်ချက်ဂုဏ်သတ္တိများအတွက် တွက်ချက်မှုဆိုင်ရာ အချက်များအား ရှင်းလင်းပါ။",
  T_48_META_API_10015_P0_D: "ပစ်မှတ်",
  T_48_META_API_10015_P1_D: "တွက်ချက်နိုင်သော ပစ္စည်းအမျိုးအစားများ",
  T_48_META_API_10016_D: "ပစ်မှတ်အဖွဲ့အစည်း၏ တွက်ချက်ထားသော ဂုဏ်သတ္တိအားလုံးအတွက် တွက်ချက်ထားသော အချက်အားလုံးကို ရှင်းပါ။",
  T_48_META_API_10016_P0_D: "ပစ်မှတ်",
  T_48_META_API_10017_D: "အရည်အချင်းများကို ပြုပြင်ပါ။",
  T_48_META_API_10017_P0_D: "ပစ်မှတ်",
  T_48_META_API_10017_P1_D: "အိမ်ခြံမြေအမျိုးအစား",
  T_48_META_API_10017_P2_D: "ပြုပြင်မွမ်းမံနည်း",
  T_48_META_API_10017_P3_D: "တန်ဖိုး",
  T_48_META_API_10018_D: "တွက်ချက်ထားသော ပိုင်ဆိုင်မှုတန်ဖိုးကို သတ်မှတ်ပါ။",
  T_48_META_API_10018_P0_D: "ပစ်မှတ်",
  T_48_META_API_10018_P1_D: "အိမ်ခြံမြေအမျိုးအစား",
  T_48_META_API_10018_P2_D: "တန်ဖိုး",
  T_48_META_API_10019_D: "တစ်ခုတည်းသော တွက်ချက်ထားသော ပိုင်ဆိုင်မှု ပြုပြင်မွမ်းမံမှုကို ရှင်းလင်းပါ။",
  T_48_META_API_10019_P0_D: "ပစ်မှတ်",
  T_48_META_API_10019_P1_D: "အိမ်ခြံမြေအမျိုးအစား",
  T_48_META_API_1002_D: "ပါရာမီတာကို ကျွန်ုပ်သည် အနိမ့်ဆုံးတန်ဖိုးမှ စတင်ပြီး အောက် node ကို လုပ်ဆောင်သည့်အခါတိုင်း၊ ကျွန်ုပ်သည် အမြင့်ဆုံးတန်ဖိုးထက် ကြီးသည် သို့မဟုတ် ညီမျှသည်အထိ အဆင့်တန်ဖိုးကို တိုးပေးပါသည်။",
  T_48_META_API_1002_P0_D: "local variable ပေါ်ရှိ loop အညွှန်းတန်ဖိုးကို ရယူရန် အသုံးပြုနိုင်သည့် loop index ၏ အမည်",
  T_48_META_API_1002_P1_D: "loop ကနဦးတန်ဖိုး",
  T_48_META_API_1002_P2_D: "loop အဆုံးတန်ဖိုး",
  T_48_META_API_1002_P3_D: "Loop အဆင့်အရွယ်အစား၊ စတင်တန်ဖိုးသည် အဆုံးတန်ဖိုးထက်နည်းသောအခါ၊ စတင်တန်ဖိုးသည် အဆုံးတန်ဖိုးထက် ကြီးသောအခါ၊ အဆင့်အရွယ်အစားသည် 0 ထက် ပိုနေသင့်သည်။",
  T_48_META_API_10020_D: "စစ်ထုတ်မှု အခြေအနေများနှင့် ကိုက်ညီသော ဂိမ်းရှိ အရာအားလုံးကို ရယူပါ။",
  T_48_META_API_10020_P0_D: "စစ်ထုတ်ခြင်းရလဒ်များတွင် ဤကန့်သတ်သတ်မှတ်ချက်တွင် ထည့်သွင်းထားသော အမျိုးအစား ပါဝင်ရပါမည်။",
  T_48_META_API_10020_P1_D: "စစ်ထုတ်ခြင်းရလဒ်များတွင် ဤကန့်သတ်သတ်မှတ်ချက်တွင် ထည့်သွင်းထားသော အမျိုးအစား မပါဝင်ရပါ။",
  T_48_META_API_10020_P2_D: "စစ်ထုတ်ခြင်းရလဒ်များတွင် ဤကန့်သတ်သတ်မှတ်ချက်တွင် ထည့်သွင်းထားသော အမျိုးအစားများထဲမှ အနည်းဆုံးတစ်ခု ပါဝင်ပါသည်။",
  T_48_META_API_10020_R_D: "ရလဒ်စာရင်းကို စစ်ထုတ်ပါ။",
  T_48_META_API_10021_D: "ဘောလုံးကို အရှိန်ထည့်လိုက်သည် အရှိန်သည် တူညီသော ဦးတည်ချက်ကြောင့် ပြောင်းလဲသွားမည်ဖြစ်သည်။",
  T_48_META_API_10021_P0_D: "ဂိုးဘောလုံး",
  T_48_META_API_10021_P1_D: "3D အာကာသအလျင်ကို ပေါင်းထည့်ထားသည်။",
  T_48_META_API_10022_D: "သတ်မှတ်ထားသော entity ကို ဖျက်ပါ။",
  T_48_META_API_10022_P0_D: "ပစ်မှတ်ကို ဖျက်ဆီးပစ်မယ်။",
  T_48_META_API_10023_D: "တဂ်များထည့်ပါ။",
  T_48_META_API_10023_P0_D: "ပစ်မှတ်",
  T_48_META_API_10023_P1_D: "စိတ်ကြိုက်တံဆိပ်များ",
  T_48_META_API_10024_D: "အညွှန်းများကို ပစ္စည်းများမှ ဖယ်ရှားပါ။",
  T_48_META_API_10024_P0_D: "ပစ်မှတ်",
  T_48_META_API_10024_P1_D: "စိတ်ကြိုက်တံဆိပ်များ",
  T_48_META_API_10025_D: "ပစ်မှတ်တွင် သတ်မှတ်ထားသော tag ပါဝင်ခြင်း ရှိ၊ မရှိ ဆုံးဖြတ်ပါ။",
  T_48_META_API_10025_P0_D: "ပစ်မှတ်",
  T_48_META_API_10025_P1_D: "စိတ်ကြိုက်တံဆိပ်များ",
  T_48_META_API_10025_R_D: "သတ်မှတ်ထားသော tag ကို ထည့်သွင်းမလား။",
  T_48_META_API_10026_D: "ဘောလုံး အနေအထား သတ်မှတ်ပါ။",
  T_48_META_API_10026_P0_D: "ဘောလုံးအသင်း",
  T_48_META_API_10026_P1_D: "တည်နေရာ",
  T_48_META_API_10026_P2_D: "အရှိန်ကိုထိန်းသိမ်းပါ။",
  T_48_META_API_10027_D: "ပစ်မှတ်ကစားသမားမှ လက်ရှိအသုံးပြုနေသော ကင်မရာကို ရယူပါ။",
  T_48_META_API_10027_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_10027_R_D: "လက်ရှိအသုံးပြုနေသည့် ကင်မရာပစ္စည်း",
  T_48_META_API_10028_D: "ပစ်မှတ်ကစားသမား၏ကင်မရာကို ပစ်မှတ်ကင်မရာသို့ ပြောင်းပါ၊",
  T_48_META_API_10028_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_10028_P1_D: "ပစ်မှတ်ကင်မရာ",
  T_48_META_API_10028_P2_D: "မုဒ်ပြောင်းခြင်း၊ မူရင်းယုတ္တိကို ထိန်းသိမ်းရန် သို့မဟုတ် တိုးတက်မှုကို ရွေးချယ်နိုင်သည်။",
  T_48_META_API_10028_P3_D: "ပြောင်းလဲချိန်သည် တိုးတက်မှုမုဒ်တွင် ကင်မရာများကို ပြောင်းရန်အချိန်ဖြစ်သည်။",
  T_48_META_API_10029_D: "ကင်မရာဖန်တီးပါ။",
  T_48_META_API_10029_P0_D: "ကင်မရာအမျိုးအစား ဖန်တီးထားသည်။",
  T_48_META_API_10029_P1_D: "ကင်မရာပစ္စည်းကို ဖန်တီးထားသည်။",
  T_48_META_API_1003_D: "ဒေတာကွန်တိန်နာ၏ ဖြတ်ကျော်ခြင်းကို အကောင်အထည်ဖော်ပါ၊ ဒြပ်စင်ခွဲတစ်ခုစီကို ရယူကာ ပတ်စဥ်ခွဲများပါရှိသည်။",
  T_48_META_API_1003_P0_D: "ကလေးဒြပ်စင်၏အမည်သို့ ဖြတ်သွားပါ၊ စက်တွင်းကိန်းရှင်ပေါ်ရှိ ကလေးဒြပ်စင်တန်ဖိုးကို ရယူရန် ၎င်းကို သင်အသုံးပြုနိုင်ပါသည်။",
  T_48_META_API_1003_P1_D: "local variable ပေါ်ရှိ loop အညွှန်းတန်ဖိုးကို ရယူရန် အသုံးပြုနိုင်သည့် loop index ၏ အမည်",
  T_48_META_API_1003_P2_D: "ဖြတ်သန်းရမည့်ဒေတာကွန်တိန်နာသည် လက်ရှိတွင် အောက်ပါအမျိုးအစားများကို ပံ့ပိုးပေးသည်- array အမျိုးအစား",
  T_48_META_API_10030_D: "တိုက်ခိုက်နိုင်သော အရာများကို သတ်ပစ်ပါ။",
  T_48_META_API_10030_P0_D: "ပစ်မှတ်ထားသည့်အရာ၊ တိုက်ခိုက်နိုင်သောအဖွဲ့အစည်းဖြစ်ရမည်။",
  T_48_META_API_10031_D: "မလှုပ်ရှားနိုင်သော အရာများ၏ ရရှိနိုင်မှု၊ မြင်နိုင်စွမ်း၊ တိုက်မိခြင်း စသည်တို့ကို ပစ်မှတ်အဖွဲ့အစည်းနှင့် ၎င်း၏ ကလေးဆုံမှတ်များ၏ လုပ်ဆောင်ချက် အခြေအနေကို သတ်မှတ်ပါ။",
  T_48_META_API_10031_P0_D: "ပစ်မှတ်",
  T_48_META_API_10031_P1_D: "တက်ကြွနေပါသလား။",
  T_48_META_API_10032_D: "ပစ်မှတ်ကို အမြဲလိုက်ရန် ကင်မရာ၏ အနေအထားကို သတ်မှတ်ပါ။",
  T_48_META_API_10032_P0_D: "ပစ်မှတ်ကင်မရာအဖွဲ့အစည်း",
  T_48_META_API_10032_P1_D: "လိုက်နာရမည့် ပစ်မှတ်",
  T_48_META_API_10032_P2_D: "ပစ်မှတ် entity သြဒိနိတ်များမှ offset",
  T_48_META_API_10032_P3_D: "offset coordinate စနစ်",
  T_48_META_API_10033_D: "ပစ်မှတ်ကို အမြဲရင်ဆိုင်ရန် ကင်မရာကို သတ်မှတ်ပါ။",
  T_48_META_API_10033_P0_D: "ပစ်မှတ်ကင်မရာအဖွဲ့အစည်း",
  T_48_META_API_10033_P1_D: "ပစ်မှတ်",
  T_48_META_API_10033_P2_D: "ပစ်မှတ် သြဒိနိတ်များမှ fixation point ၏ offset",
  T_48_META_API_10033_P3_D: "offset coordinate စနစ်",
  T_48_META_API_10034_D: "Tweens ဖန်တီးပါ။",
  T_48_META_API_10034_P0_D: "ပစ်မှတ်",
  T_48_META_API_10034_P1_D: "ပိုင်ဆိုင်မှု ID",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "စတိုင်",
  T_48_META_API_10034_P5_D: "မျဉ်းကွေး",
  T_48_META_API_10034_P6_D: "သင်တန်းကာလ",
  T_48_META_API_10034_P7_D: "tween ဘဘ",
  T_48_META_API_10035_D: "Parent node ကို သတ်မှတ်ပါ၊ မိဘနှင့် ကလေး နှစ်ခုလုံးတွင် Transform အစိတ်အပိုင်းများ ရှိရန် လိုအပ်သည်။",
  T_48_META_API_10035_P0_D: "parent node",
  T_48_META_API_10035_P1_D: "ကလေး node",
  T_48_META_API_10035_P2_D: "လက်ရှိကမ္ဘာ့အနေအထားကို ဆက်ထိန်းထားရန်ရှိမရှိ၊ ကလေး node များ၏ လှည့်ခြင်းနှင့် အတိုင်းအတာကို UI ကို သတ်မှတ်သည့်အခါ ဤအရာသည် မမှန်ကန်ပါ။",
  T_48_META_API_10036_D: "NewCurve (ကန့်ကွက်ထားသည်၊ ကျေးဇူးပြု၍ CreateTweenCurve ကိုသုံးပါ)",
  T_48_META_API_10036_P0_D: "ControlPoints",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "ကစားနိုင်သော အစိတ်အပိုင်းများ ပါရှိရမည့် ပစ်မှတ်အား ကစားရန် ကြိုးပမ်းမှုများ",
  T_48_META_API_10037_P0_D: "ပစ်မှတ်ကစားနိုင်သော အရာ",
  T_48_META_API_10037_P1_D: `ပြန်ဖွင့်ရန်ရှိမရှိ
True- ပြန်ဖွင့်ခြင်း
False- ဆက်လက်ကစားပါ။`,
  T_48_META_API_10038_D: "ကစားနိုင်သော အရာအား ခေတ္တရပ်ပါ။",
  T_48_META_API_10038_P0_D: "ပစ်မှတ်ကစားနိုင်သော အရာ",
  T_48_META_API_10039_D: "ပစ်မှတ်အား ကနဦးအလျင်နှင့် ဦးတည်ချက်ဖြင့် အရှိန်ပေးမည့် ပဲ့ထိန်းလှုပ်ရှားမှုကို ဖန်တီးပါ။",
  T_48_META_API_10039_P0_D: "ပစ်မှတ်",
  T_48_META_API_10039_P1_D: "ရွေ့လျားမှု၏ ကနဦးအလျင်",
  T_48_META_API_10039_P2_D: "ရွေ့လျားမှုအရှိန်",
  T_48_META_API_10039_P3_D: "အများဆုံးရွှေ့ပြောင်းအကွာအဝေး",
  T_48_META_API_10039_P4_D: "ပဲ့ထိန်းဒုံးကျည်လှုပ်ရှားမှုကို ဖန်တီးခဲ့သည်။",
  T_48_META_API_10039_P5_D: "ဖန်တီးပြီးနောက် အလိုအလျောက် စတင်ကစားမလား။",
  T_48_META_API_1004_D: "လက်ရှိ ကွင်းဆက်လုပ်ငန်းစဉ်ကို နှောင့်ယှက်ပြီး ကွင်းဆက်မှ ထွက်ပါ။",
  T_48_META_API_10040_D: "ရွေ့လျားမှုအောက်ပါ အနေအထားကို ဖန်တီးပါ၊ ပစ်မှတ်သည် သတ်မှတ်ထားသော အရာဝတ္ထု၏ ရွေ့လျားမှုကို လိုက်လျှောက်ပါမည်။",
  T_48_META_API_10040_P0_D: "ပစ်မှတ်",
  T_48_META_API_10040_P1_D: "ရွေ့လျားမှုနောက်သို့လိုက်သော အရာဝတ္ထုများ",
  T_48_META_API_10040_P2_D: "အကွာအဝေးသည် ပစ်မှတ်ကို သြဒိနိတ်များ၏ offset ကို လိုက်နာသည်။",
  T_48_META_API_10040_P3_D: "Coordinate စနစ်ကို သုံးတယ်။",
  T_48_META_API_10040_P4_D: "အောက်ပါ လှုပ်ရှားမှုကို ဖန်တီးထားသည်။",
  T_48_META_API_10040_P5_D: "ဖန်တီးပြီးနောက် အလိုအလျောက် စတင်ကစားမလား။",
  T_48_META_API_10041_D: "ပစ်မှတ်သည် သတ်မှတ်ထားသော အရာဝတ္တုကို မျက်နှာမူလျက် ရှိနေမည့် ငေးကြည့်ပြီးနောက် လှုပ်ရှားမှုတစ်ခုကို ဖန်တီးပါ။",
  T_48_META_API_10041_P0_D: "ပစ်မှတ်",
  T_48_META_API_10041_P1_D: "စောင့်ကြည့်နေသည့် အရာဝတ္ထု",
  T_48_META_API_10041_P2_D: "အရာဝတ္ထု entity မှ စူးစူးစိုက်စိုက်ကြည့်သည့်အချက်",
  T_48_META_API_10041_P3_D: "Coordinate စနစ်ကို သုံးတယ်။",
  T_48_META_API_10041_P4_D: "ငေးကြည့်ရင်း လှုပ်ရှားမှုကို ဖန်တီးထားသည်။",
  T_48_META_API_10041_P5_D: "ဖန်တီးပြီးနောက် အလိုအလျောက် စတင်ကစားမလား။",
  T_48_META_API_10042_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_10042_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_10042_P1_D: "ပွဲရလဒ်",
  T_48_META_API_10042_P2_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_10042_P3_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_10042_P4_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_10043_D: "ပစ်မှတ် entity ၏ ဂုဏ်သတ္တိများကို ချောမွေ့စွာ သတ်မှတ်ခြင်း သတ္တိများသည် ချက်ချင်းပြောင်းလဲသွားမည်ဖြစ်ပြီး၊ သို့သော် client သည် ချောမွေ့သော အကူးအပြောင်း စွမ်းဆောင်ရည်ကို ကစားပါမည်။",
  T_48_META_API_10043_P0_D: "ပစ်မှတ်",
  T_48_META_API_10043_P1_D: "ပစ်မှတ်တစ်ခု၏ အရည်အချင်းတစ်ခု",
  T_48_META_API_10043_P2_D: "ရည်မှန်းချက်ကို သတ်မှတ်သောအခါ လိုအပ်သော အမျိုးအစားနှင့် ကိုက်ညီရန် ပစ်မှတ်တန်ဖိုးသည် လိုအပ်သည်။",
  T_48_META_API_10044_D: "ဓာတ်မှန်ရိုက်ခြင်းအား ထောက်လှမ်းမှုပြုလုပ်ပြီး ဓာတ်မှန်ရိုက်သည့်လမ်းကြောင်းတွင် ပထမဆုံးသော အရာအား ပြန်ပို့ပေးပါသည်။",
  T_48_META_API_10044_P0_D: "အနေအထား သြဒိနိတ်များကို စတင်ပါ။",
  T_48_META_API_10044_P1_D: "ဓာတ်ရောင်ခြည် ထောက်လှမ်းမှု ဦးတည်ချက်",
  T_48_META_API_10044_P2_D: "ဓာတ်မှန်ရိုက်ခြင်း ထောက်လှမ်းခြင်း အကွာအဝေးကိုသာ အပြုသဘောဆောင်သော တန်ဖိုးများကို လက်ခံပါသည်။",
  T_48_META_API_10044_P3_D: "Ray detection layer mask၊ ဖြည့်သွင်းထားသော အဆင့်များသာ scan တွင် ပါဝင်မည်ဖြစ်ပြီး၊ အဆင့်အားလုံးသည် စကင်န်တွင် ပါဝင်မည်ဖြစ်သည်",
  T_48_META_API_10044_P4_D: "အစပျိုးမှုများကို စကင်န်ဖတ်ရန် ဖြစ်နိုင်ပါသလား။",
  T_48_META_API_10044_P5_D: "ဘဘ ရိုက်တယ်။",
  T_48_META_API_10044_P6_D: "hit point သြဒိနိတ်များ",
  T_48_META_API_10044_P7_D: "hit point မှ start point သို့ အကွာအဝေး",
  T_48_META_API_10044_P8_D: "မျက်နှာပြင်ကို ပုံမှန်ထိလိုက်ပါ။",
  T_48_META_API_10045_D: "ဓာတ်ရောင်ခြည် ထောက်လှမ်းမှုကို လုပ်ဆောင်ပြီး ဓာတ်မှန်ရိုက်သည့် အရာအားလုံးကို အနီးမှ အဝေးသို့ ပြန်ပို့ပါ။",
  T_48_META_API_10045_P0_D: "အနေအထား သြဒိနိတ်များကို စတင်ပါ။",
  T_48_META_API_10045_P1_D: "ဓာတ်ရောင်ခြည် ထောက်လှမ်းမှု ဦးတည်ချက်",
  T_48_META_API_10045_P2_D: "ဓာတ်မှန်ရိုက်ခြင်း ထောက်လှမ်းခြင်း အကွာအဝေးကိုသာ အပြုသဘောဆောင်သော တန်ဖိုးများကို လက်ခံပါသည်။",
  T_48_META_API_10045_P3_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများသာ စကင်ဖတ်ခြင်းတွင် ပါဝင်မည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ စကင်ဖတ်ခြင်းတွင် အလွှာအားလုံး ပါဝင်လိမ့်မည်",
  T_48_META_API_10045_P4_D: "အစပျိုးမှုများကို သိရှိနိုင်ပါသလား။",
  T_48_META_API_10045_P5_D: "hit entities စာရင်း",
  T_48_META_API_10045_P6_D: "hit list",
  T_48_META_API_10045_P7_D: "ပွိုင့်အကွာအဝေး စတင်အမှတ်အကွာအဝေးစာရင်း",
  T_48_META_API_10045_P8_D: "မျက်နှာပြင်ကို ပုံမှန်ထိလိုက်ပါ။",
  T_48_META_API_10046_D: "prefabs ကို အသုံးပြု၍ နမူနာများအတွက် entities ဖန်တီးပါ။",
  T_48_META_API_10046_P0_D: "အကြောင်းအရာကို ဖန်တီးထားသည်။",
  T_48_META_API_10046_P1_D: "Prefab ID",
  T_48_META_API_10047_D: "ဆေးဆိုးခြင်း။",
  T_48_META_API_10047_P0_D: "အရာဝတ္ထုကို ပုံမှန်သတ်မှတ်ပါ။",
  T_48_META_API_10047_P1_D: "ဆေးဆိုးရန်အချက်များ သတ်မှတ်ပါ။",
  T_48_META_API_10047_P2_D: "အရောင်",
  T_48_META_API_10048_D: "စွန်းထင်းမှုအခြေအနေ",
  T_48_META_API_10048_P0_D: "ဆေးဆိုးရန်အချက်များ သတ်မှတ်ပါ။",
  T_48_META_API_10048_P1_D: "ဦးတည်ချက်သတ်မှတ်ပါ။",
  T_48_META_API_10048_P2_D: "အကွာအဝေးကို သတ်မှတ်ပါ။",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "အစွန်းအထင်းစာရင်းဇယား",
  T_48_META_API_10049_P0_D: "အရောင်",
  T_48_META_API_10049_R_D: "ဆေးဆိုးခြင်း ပမာဏ",
  T_48_META_API_1005_D: "ကျန်ရှိသော ကွင်းဆက်အကြောင်းအရာကို ကျော်ပြီး နောက်ထပ်ကွင်းဆက်သို့ တိုက်ရိုက်သွားပါ။",
  T_48_META_API_10050_D: "Planar range စွန်းထင်းခြင်း။",
  T_48_META_API_10050_P0_D: "အရာဝတ္ထုကို ပုံမှန်သတ်မှတ်ပါ။",
  T_48_META_API_10050_P1_D: "ဆေးဆိုးရန်အချက်များ သတ်မှတ်ပါ။",
  T_48_META_API_10050_P2_D: "ဆေးဆိုးခြင်းအပိုင်းကို သတ်မှတ်ပါ။",
  T_48_META_API_10050_P3_D: "အရောင်",
  T_48_META_API_10050_P4_D: "ဆေးဆိုးခြင်း ပမာဏ",
  T_48_META_API_10051_D: "ဧရိယာ စွန်းထင်းခြင်း။",
  T_48_META_API_10051_P0_D: "အရာဝတ္ထုကို ပုံမှန်သတ်မှတ်ပါ။",
  T_48_META_API_10051_P1_D: "ဆေးဆိုးရန်အချက်များ သတ်မှတ်ပါ။",
  T_48_META_API_10051_P2_D: "ဆေးဆိုးခြင်းအပိုင်းကို သတ်မှတ်ပါ။",
  T_48_META_API_10051_P3_D: "အရောင်",
  T_48_META_API_10051_P4_D: "စွန်းထင်းနေသောနေရာကို ပုံသေ",
  T_48_META_API_10051_P5_D: "ကျပန်းကိန်း",
  T_48_META_API_10051_P6_D: "ကျပန်း လျှော့တွက်သောကိန်း",
  T_48_META_API_10051_P7_D: "ဆေးဆိုးခြင်း ပမာဏ",
  T_48_META_API_10052_D: "ပစ်မှတ် parent node entity ၏ ကလေး node အားလုံးကို ရယူပါ။",
  T_48_META_API_10052_P0_D: "parent node entity",
  T_48_META_API_10052_R_D: "ကလေးဆုံမှတ်များစာရင်း",
  T_48_META_API_10053_D: "ညွှန်းကိန်းအပေါ်အခြေခံ၍ ပစ်မှတ် parent node entity ၏ သတ်မှတ်ထားသော ကလေး node ကို ရယူပါ။",
  T_48_META_API_10053_P0_D: "parent node entity",
  T_48_META_API_10053_P1_D: "ကလေး node အညွှန်း",
  T_48_META_API_10053_R_D: "ကလေး node entity",
  T_48_META_API_10054_D: "ပစ်မှတ်ကလေး node entity ၏ parent node ကိုရယူပါ။",
  T_48_META_API_10054_P0_D: "ကလေး node entity",
  T_48_META_API_10054_R_D: "parent node entity",
  T_48_META_API_10055_D: "သတ်မှတ်ထားသော parent node entity အောက်တွင် ကလေး node အားလုံးကို ဖျက်ပါ။",
  T_48_META_API_10055_P0_D: "parent node entity",
  T_48_META_API_10056_D: "တယ်လီပို့ပစ်မှတ်သည် သတ်မှတ်ထားသောနေရာသို့ ပို့သည်။",
  T_48_META_API_10056_P0_D: "တယ်လီပို့ထားသော ယူနစ်",
  T_48_META_API_10056_P1_D: "တယ်လီပို့ပွိုင့် သြဒိနိတ်",
  T_48_META_API_10056_P2_D: "တယ်လီပို့ခြင်းပြီးနောက် ယူနစ်၏ တိမ်းညွှတ်မှု",
  T_48_META_API_10057_D: "ကျပန်းအသင်းဖော်များအနီးရှိ တည်နေရာကိုရယူပါ၊ အသင်းဖော်များမရှိသည့်အခါ သင့်အနီးရှိ သြဒိနိတ်များကို ပြန်ပေးကာ မခံမရပ်နိုင်သောကစားသမားများ၏တည်နေရာကို ရှောင်ကြဉ်ပါ။",
  T_48_META_API_10057_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_10057_R_D: "ပစ်မှတ်ကစားသမား၏ အသင်းဖော်များအနီးတွင် ညှိနှိုင်းပါ။",
  T_48_META_API_10058_D: "စွန်းထင်းမှု အခြေအနေကို ရှင်းလင်းပါ။",
  T_48_META_API_10059_D: "သတ်မှတ်ထားသော အသံအကျိုးသက်ရောက်မှုကို ဖွင့်ရန် သတ်မှတ်ရန် လိုအပ်သော ရည်ညွှန်းချက်များ ပိုများပါက၊ ၎င်း၏ entity attribute များကို entity မှတဆင့် သတ်မှတ်ပါ။",
  T_48_META_API_10059_P0_D: "ကုဒ်သည် အသံအကျိုးသက်ရောက်မှုကို ဖန်တီးပေးသည့် တရားဝင် ကန့်သတ်ဘောင်၏ အမည်ကို ကိုယ်စားပြုရန်အတွက် အသုံးပြုပြီး ၎င်း၏ သက်ဆိုင်ရာ ဒေသဆိုင်ရာ ပြောင်းလဲနိုင်သော တန်ဖိုးသည် အသံအကျိုးသက်ရောက်မှုကို ဖန်တီးပေးသည့် အရာဖြစ်သည်။",
  T_48_META_API_10059_P1_D: "၎င်းပိုင်ဆိုင်သည့် ကစားသမားအဖွဲ့အစည်းကို ဤကစားသမားကသာ မြင်နိုင်သည်။",
  T_48_META_API_10059_P2_D: "အသံအကျိုးသက်ရောက်မှုအမျိုးအစား၊ ကစားသမားများရွေးချယ်နိုင်သော အသံအကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_48_META_API_1006_D: "လက်ရှိလုပ်ဆောင်မှုလုပ်ငန်းစဉ်ကို အဆုံးသတ်ပြီး ဖုန်းခေါ်ဆိုသည့်တည်နေရာသို့ တိုက်ရိုက်ပြန်သွားနိုင်ပါသည်။",
  T_48_META_API_1006_P0_D: "ခေါ်ဆိုနေသည့် တည်နေရာသို့ ပြန်သွားမည့် ဒေတာ",
  T_48_META_API_10060_D: "ပစ်မှတ်ကစားသမားကို ဂိမ်းမှ ကန်ထုတ်ပါ။",
  T_48_META_API_10060_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_10060_P1_D: "ငွေပေးချေမှုအချက်အလက်ကို ပြသရန်ရှိမရှိ",
  T_48_META_API_10061_D: "ပစ်မှတ်ကစားသမားသည် သတ်မှတ်ထားသောမြေပုံနှင့် ကိုက်ညီရန် တောင်းဆိုသည်။",
  T_48_META_API_10061_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_10061_P1_D: "စစ်မြေပြင်ကုဒ်",
  T_48_META_API_10061_P2_D: "ပွဲပယ်ဖျက်လိုက်သောအခါတွင် ပေါ့ပ်အပ်ဝင်းဒိုးတစ်ခုက သင့်အား မူလဂိမ်းသို့ ပြန်သွားရန် နှိုးဆော်ခြင်းရှိမရှိ",
  T_48_META_API_10062_D: "ဖွင့်နေသော အသံအကျိုးသက်ရောက်မှုအား အနှောင့်အယှက်ပေးသည်။",
  T_48_META_API_10062_P0_D: "ခေတ္တရပ်ရန် လိုအပ်သော အသံအကျိုးသက်ရောက်မှု အကြောင်းအရာ",
  T_48_META_API_10063_D: "အသံအကျိုးသက်ရောက်မှုကို ဆက်ကစားရန်၊ အစမှစတီးခြင်းရှိမရှိ သင်ရွေးချယ်နိုင်ပါသည်။",
  T_48_META_API_10063_P0_D: "ခေတ္တရပ်ပြီးနောက် ဆက်လက်ဖွင့်ရန် လိုအပ်သည့် အသံအကျိုးသက်ရောက်မှုများ",
  T_48_META_API_10063_P1_D: "အစကနေစမှာလား။",
  T_48_META_API_10064_D: "Airdrop ဖန်တီးခြင်းတွင် အဆင့်သုံးဆင့်ပါရှိသည်- 1. ကြိုတင်ပြင်ဆင်ခြင်း၊ 2. ပြုတ်ကျခြင်း၊ 3. ဆင်းသက်ခြင်း 1. လေလွင့်ခြင်းဆိုင်ရာ အရည်အချင်းများကို အခြေအနေ 1 တွင်သာ ပြုပြင်နိုင်ပါသည်။",
  T_48_META_API_10064_P0_D: "airdrop box entity ကို ဖန်တီးထားသည်။",
  T_48_META_API_1007_D: "အခြေအနေမှန်သလား၊ အခြေအနေမှားပြီး ကွင်းဆက်အဆုံးသတ်သည်အထိ အခြေအနေမှန်ရှိမရှိအပေါ် အခြေခံ၍ ဆက်လက်လုပ်ဆောင်သည့် ကွင်းဆက်တစ်ခုကို အကောင်အထည်ဖော်ပါ။",
  T_48_META_API_1007_P0_D: "အခြေအနေမှန်သောအခါ၊ ကွင်းဆက်သည် ဆက်လက်တည်ရှိပြီး အခြေအနေမှန်သည် ကွင်းဆက်သည် ပြီးဆုံးသွားပါသည်။",
  T_48_META_API_1008_D: `လာမည့် logical frame ၏အစအထိ စောင့်ပါ
ဆာဗာတွင်၊ ဖရိမ်နှုန်းနည်းသောမုဒ်ကို ဖွင့်ထားပါက၊ စောင့်ဆိုင်းချိန်သည် ပိုကြာလိမ့်မည်
 client တွင်၊ စောင့်ဆိုင်းချိန်သည် စက်စွမ်းဆောင်ရည်နှင့် လက်ရှိ frame ၏ logic ရှုပ်ထွေးမှုများကြောင့် သက်ရောက်မှုရှိသည်
အသုံးပြုခြ`,
  T_48_META_API_1009_D: "အချိန်အတိုင်းအတာတစ်ခုအထိ စောင့်ဆိုင်းပြီးနောက်၊ ဤ API ကို အသုံးပြုသည့် လုပ်ဆောင်ချက်ကို ဆက်စပ်မှုအဖြစ် ကြေညာရန် လိုအပ်သည်။",
  T_48_META_API_1009_P0_D: "စောင့်ဆိုင်းချိန်၊ မီလီစက္ကန့်အတွင်း",
  T_48_META_API_101_D: "သတ်မှတ်ထားသော မြင်ကွင်းကို ဖြုတ်ပါ။",
  T_48_META_API_101_P0_D: "မြင်ကွင်း ID ကို ဖြုတ်ပစ်ရန်",
  T_48_META_API_1010: "Event Callback",
  T_48_META_API_1010_D: "ဖြစ်ရပ်တစ်ခု ဖြစ်ပေါ်လာသောအခါ လုပ်ဆောင်ချက်တစ်ခု စတင်ခဲ့သည်။",
  T_48_META_API_1010_P0: "Event Parameter Names",
  T_48_META_API_1010_P0_D: "ဒေသတွင်း ကိန်းရှင်တွင် အမှန်တကယ် ပါရာမီတာတန်ဖိုးကို ရယူနိုင်သည့် ဖြစ်ရပ်ပါရာမီတာ၏ တရားဝင် ကန့်သတ်ချက်အမည်၊",
  T_48_META_API_1011: "Code Block",
  T_48_META_API_1011_D: "APIs များ ပေါင်းစပ်ပါဝင်သည့် ကုဒ်ဘလော့တစ်ခု",
  T_48_META_API_1011_P0: "Parameter Names",
  T_48_META_API_1011_P0_D: "ကုဒ်ပိတ်ဆို့ခြင်းသည် စိတ်ကြိုက်လုပ်ဆောင်မှုတစ်ခု ဖြစ်သောအခါ တရားဝင် ကန့်သတ်ချက်အမည်များ",
  T_48_META_API_1012: "Find and Invoke Custom API with Serial",
  T_48_META_API_1012_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်ကို အမှတ်စဉ်ပုံစံဖြင့် ခေါ်ဆိုပါ",
  T_48_META_API_1012_P0_D: "စိတ်ကြိုက်လုပ်ဆောင်မှုနေထိုင်သည့်အရာ",
  T_48_META_API_1012_P1: "Graph ID",
  T_48_META_API_1012_P1_D: "စိတ်ကြိုက်လုပ်ဆောင်မှုတည်ရှိရာ Script ID",
  T_48_META_API_1012_P2: "Function ID",
  T_48_META_API_1012_P2_D: "ပစ်မှတ်မှ ခေါ်သော လုပ်ဆောင်ချက် ID",
  T_48_META_API_1012_P3_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်သို့ ဖြတ်တောက်ထားသော အကြောင်းပြချက်များစာရင်း",
  T_48_META_API_1013: "Find and Invoke Custom API with Parallel",
  T_48_META_API_1013_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်ကို အပြိုင်ခေါ်ဆိုခြင်း စိတ်ကြိုက်လုပ်ဆောင်မှုတွင် စောင့်ဆိုင်းခြင်းရှိမရှိ၊ ၎င်းသည် ခေါ်ဆိုမှုတည်နေရာသို့ ချက်ချင်းပြန်သွားမည်ဖြစ်ပြီး ဆက်လက်လုပ်ဆောင်မည်ဖြစ်သည်။",
  T_48_META_API_1013_P0_D: "စိတ်ကြိုက်လုပ်ဆောင်မှုနေထိုင်သည့်အရာ",
  T_48_META_API_1013_P1: "Graph ID",
  T_48_META_API_1013_P1_D: "စိတ်ကြိုက်လုပ်ဆောင်မှုတည်ရှိရာ Script ID",
  T_48_META_API_1013_P2: "Function ID",
  T_48_META_API_1013_P2_D: "ပစ်မှတ်မှ ခေါ်သော လုပ်ဆောင်ချက် ID",
  T_48_META_API_1013_P3_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်သို့ ဖြတ်တောက်ထားသော အကြောင်းပြချက်များစာရင်း",
  T_48_META_API_1014: "Find and Invoke Self Custom API with Serial",
  T_48_META_API_1014_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်တွင် စောင့်ဆိုင်းနေပါက လက်ရှိ script တွင် စိတ်ကြိုက်လုပ်ဆောင်ချက်ကို ခေါ်ဆိုပါ။",
  T_48_META_API_1014_P0: "Function ID",
  T_48_META_API_1014_P0_D: "ပစ်မှတ်မှ ခေါ်သော လုပ်ဆောင်ချက် ID",
  T_48_META_API_1014_P1_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်သို့ ဖြတ်တောက်ထားသော အကြောင်းပြချက်များစာရင်း",
  T_48_META_API_1015: "Find and Invoke Self Custom API with Parallel",
  T_48_META_API_1015_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်ကို အပြိုင်ခေါ်ဆိုခြင်း စိတ်ကြိုက်လုပ်ဆောင်မှုတွင် စောင့်ဆိုင်းခြင်းရှိမရှိ၊ ၎င်းသည် ခေါ်ဆိုမှုတည်နေရာသို့ ချက်ချင်းပြန်သွားမည်ဖြစ်ပြီး ဆက်လက်လုပ်ဆောင်မည်ဖြစ်သည်။",
  T_48_META_API_1015_P0: "Set Local Variable by Index",
  T_48_META_API_1015_P0_D: "ပစ်မှတ်မှ ခေါ်သော လုပ်ဆောင်ချက် ID",
  T_48_META_API_1015_P1_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်သို့ ဖြတ်တောက်ထားသော အကြောင်းပြချက်များစာရင်း",
  T_48_META_API_1016_D: "ဤ API ကို ခေါ်သောအခါ ပစ်မှတ်အမျိုးအစားကို ရယူပါ။",
  T_48_META_API_1016_P0_D: "ပစ်မှတ်ကို မေးမြန်းခြင်းဖြစ်ပါသည်။",
  T_48_META_API_1016_R_D: "ပြောင်းလဲနိုင်သောအမျိုးအစား",
  T_48_META_API_1017_D: "ပစ်မှတ် ကိန်းရှင်သည် သတ်မှတ်ထားသော အမျိုးအစားမှ ဟုတ်မဟုတ် ဆုံးဖြတ်ပါ။",
  T_48_META_API_1017_P0_D: "ပစ်မှတ်ကို မေးမြန်းခြင်းဖြစ်ပါသည်။",
  T_48_META_API_1017_P1_D: "နှိုင်းယှဉ်ထားသောအမျိုးအစား",
  T_48_META_API_1017_R_D: "ကိုက်ညီမှုရှိပါသလား။",
  T_48_META_API_1018_D: "ပစ်မှတ်ကိန်းရှင်သည် အမျိုးအစားတစ်ခု၏ အမျိုးအစားခွဲတစ်ခုဟုတ်မဟုတ် ဆုံးဖြတ်ပါ၊ ပြန်လာတန်ဖိုးသည် Boolean တန်ဖိုးတစ်ခုဖြစ်သည်။",
  T_48_META_API_1018_P0_D: "ပစ်မှတ်ကိန်းရှင်ကို မေးမြန်းနေပါသည်။",
  T_48_META_API_1018_P1_D: "နှိုင်းယှဉ်ထားသောအမျိုးအစား",
  T_48_META_API_1018_R_D: "subclass ပဲဖြစ်ဖြစ်၊",
  T_48_META_API_1019_D: "ပစ်မှတ်မှ သတ်မှတ်ထားသော စိတ်ကြိုက်ဖြစ်ရပ်ကို အစပျိုးစေပါသည်။",
  T_48_META_API_1019_P0_D: "စိတ်ကြိုက်ဖြစ်ရပ် ID ပို့လိုက်ပါပြီ။",
  T_48_META_API_1019_P1_D: "ပစ်မှတ်",
  T_48_META_API_1019_P2_D: "ကန့်သတ်စာရင်း",
  T_48_META_API_102_D: "သတ်မှတ်ထားသော မြင်ကွင်းသို့ ပြောင်းခြင်းဖြင့် အခြားတင်ထားသော မြင်ကွင်းများကို ဖြုတ်လိုက်ပါမည်။",
  T_48_META_API_102_P0_D: "ပြောင်းရန် Scene ID",
  T_48_META_API_1020_D: "ကွန်တိန်နာတစ်ခု၏ဖြတ်ကျော်မှုကို အကောင်အထည်ဖော်ပြီး လုပ်ငန်းစဉ်ခွဲများအပါအဝင် သော့တန်ဖိုးအတွဲတစ်ခုစီကို ရယူပါ။ loop body သည် လုပ်ငန်းစဉ်ခွဲဖြစ်သည်။",
  T_48_META_API_1020_P0_D: "သော့အမည်သို့ ဖြတ်ကျော်ကာ၊ local variable ပေါ်ရှိ သော့တန်ဖိုးကို ရယူရန် ၎င်းကို သင်အသုံးပြုနိုင်ပါသည်။",
  T_48_META_API_1020_P1_D: "local variable ပေါ်ရှိတန်ဖိုးကို ရယူရန် အသုံးပြုနိုင်သည့် တန်ဖိုး၏အမည်သို့ ကူးပြောင်းပါ။",
  T_48_META_API_1020_P2_D: "ဖြတ်သန်းရန် ကွန်တိန်နာ",
  T_48_META_API_1021_D: "Bot ကိုဖျက်ပါ။",
  T_48_META_API_1021_P0_D: "Bot player entity ကို ဖျက်ပါ။",
  T_48_META_API_1022_D: "ပစ်မှတ်ကစားသမားကို ယာဉ်မှထွက်ခွာရန် အတင်းအကျပ် ဖိအားပေးပါ။",
  T_48_META_API_1022_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1023_D: "ပျက်စီးဆုံးရှုံးမှုစကားလုံးဖန်တီးပါ။",
  T_48_META_API_1023_P0_D: "စကားလုံးအကြောင်းအရာကို ကျော်ပါ။",
  T_48_META_API_1023_P1_D: "ဖောင့်အရွယ်အစား",
  T_48_META_API_1023_P2_D: "ဖောင့်အရောင်",
  T_48_META_API_1023_P3_D: "ဆက်နေရန် ကြာချိန် မီလီစက္ကန့်",
  T_48_META_API_1023_P4_D: "ထိခိုက်နစ်နာစေသော ဘဘ",
  T_48_META_API_1023_P5_D: "ပစ်မှတ်အဖွဲ့အစည်း၏ ကမ္ဘာ့သြဒိနိတ်များနှင့် ဆက်စပ်နေသော ပျက်စီးမှုခုန်စကားလုံး၏ နှိမ်ချမှု",
  T_48_META_API_1023_P6_D: "ပျက်စီးခုန်နှုန်းအနေအထားတွင် ကျပန်းအနေအထား တည့်မတ်မှု၏ အပိုင်းအခြားအရွယ်အစား",
  T_48_META_API_1023_P7_D: "tween ကာတွန်းကို ဖျော်ဖြေမှာလား။",
  T_48_META_API_1024_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_1024_P0_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_1024_P1_D: "ပစ်မှတ်",
  T_48_META_API_1024_P2_D: "ရွေးချယ်ပြီးနောက်၊ ဆာဗာပေါ်တွင်ခေါ်ဆိုပါက၊ ၎င်းကို client ထံပေးပို့မည်ဖြစ်ပြီး၊ client ကိုခေါ်ဆိုပါက၊ ၎င်းကို server သို့ပေးပို့မည်ဖြစ်သည်။",
  T_48_META_API_1024_P3_D: "ကန့်သတ်စာရင်း",
  T_48_META_API_1025_D: "စိတ်ကြိုက်လုပ်ဆောင်စရာတိုးတက်မှုကို မေးမြန်းပါ။",
  T_48_META_API_1025_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1025_P1_D: "စိတ်ကြိုက်လုပ်ဆောင်စရာ ID",
  T_48_META_API_1025_R_D: "အလုပ်အဆင့်",
  T_48_META_API_1026_D: "ပစ်မှတ်ကစားသမား၏ကျောပိုးအိတ်အရေပြားကိုရယူပါ။",
  T_48_META_API_1026_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1026_R_D: "ကျောပိုးအိတ်အရေပြား ID",
  T_48_META_API_1027_D: "ပစ်မှတ်ကစားသမား၏ကျောပိုးအိတ်အရေပြားကို သတ်မှတ်ပါ။",
  T_48_META_API_1027_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1027_P1_D: "ကျောပိုးအိတ်အရေပြား ID",
  T_48_META_API_1028_D: "ပစ်မှတ်ကစားသမား၏ကျောပိုးအိတ်အရေပြားကို မူရင်းပြင်ပဖွဲ့စည်းမှုသို့ ပြန်လည်ရယူပါ။",
  T_48_META_API_1028_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1029_D: "ပစ်မှတ်ကစားသမား၏ ကျောပိုးအိတ်အရေပြားကို ရှင်းလင်းပါ။",
  T_48_META_API_1029_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_103_D: "ဂိမ်း၏ skybox ပတ်ဝန်းကျင်စတိုင်ကို ပြောင်းလဲပါ၊ နေ့၊ ည၊ ည စသည်ဖြင့် ရွေးချယ်နိုင်ပါသည်။",
  T_48_META_API_103_P0_D: "Skybox အမျိုးအစား",
  T_48_META_API_1030_D: "အမည်ဖြင့် အရိုးဆွဲထားသောနေရာကို ရယူပါ။",
  T_48_META_API_1030_P0_D: "ပစ်မှတ်",
  T_48_META_API_1030_P1_D: "အရိုးဆွဲ အမှတ် မည်၏။",
  T_48_META_API_1030_R_D: "အရိုးအထည်",
  T_48_META_API_1031_D: "Transform၊ SkeletonPart၊ Player နှင့် MountPoint အစိတ်အပိုင်းများဖြင့် တပ်ဆင်ထားသည့် အရာဝတ္ထုများကို ပံ့ပိုးပေးသည့် အရာဝတ္ထု၏ ပင်မနိတ်ကို သတ်မှတ်ပါ။",
  T_48_META_API_1031_P0_D: "parent node",
  T_48_META_API_1031_P1_D: "ကလေး node",
  T_48_META_API_1031_P2_D: "လက်ရှိကမ္ဘာ့အနေအထား၊ လည်ပတ်မှုနှင့် ကလေးဆုံမှတ်များ၏ စကေးကို ဆက်လက်ထိန်းသိမ်းထားရန် ရှိမရှိ။ ဤကန့်သတ်ချက်များသည် UI ဆက်တင်များတွင် အကျိုးသက်ရောက်မှုမရှိပါ။",
  T_48_META_API_1032_D: "အိုင်ကွန် ကာတွန်းအကျိုးသက်ရောက်မှုကို ဖွင့်ပါ၊ အိုင်ကွန်သည် ပြန်ဖွင့်နှုန်းဖြင့် စတင်သည့်နေရာမှ အဆုံးအနေအထားသို့ ဘာသာပြန်ပါသည်။",
  T_48_META_API_1032_P0_D: "အိုင်ကွန် အရင်းအမြစ် ID",
  T_48_META_API_1032_P1_D: "အရောင်",
  T_48_META_API_1032_P2_D: "အိုင်ကွန်ကို ချုံ့ချဲ့ပါ။",
  T_48_META_API_1032_P3_D: "စတင်အနေအထားဗဟို",
  T_48_META_API_1032_P4_D: "စတင်ဧရိယာအပိုင်းအခြား",
  T_48_META_API_1032_P5_D: "တည်နေရာဗဟို",
  T_48_META_API_1032_P6_D: "အဆုံးအနေအထားအပိုင်းအခြား",
  T_48_META_API_1032_P7_D: "ပြန်ဖွင့်နှုန်းသည် အိုင်ကွန်ရွှေ့သည့် တစ်စက္ကန့်အကွာအဝေးဖြစ်သည်။",
  T_48_META_API_1033_D: "ထောင့်ကိုရရှိရန် artangent လုပ်ဆောင်ချက်ကို လုပ်ဆောင်ပါ။",
  T_48_META_API_1033_P0_D: "Y ဝင်ရိုး သြဒိနိတ်",
  T_48_META_API_1033_P1_D: "X-axis သြဒိနိတ်",
  T_48_META_API_1033_R_D: "ထောင့်၊ အပိုင်းအခြား (-180၊ 180]",
  T_48_META_API_1034_D: "အသုံးပြုသူဖန်တီးထားသော စိတ်ကြိုက်အစိတ်အပိုင်းများကိုသာ အစိတ်အပိုင်းများထည့်ပါ။",
  T_48_META_API_1034_P0_D: "ပစ်မှတ်",
  T_48_META_API_1034_P1_D: "အစိတ်အပိုင်းအမျိုးအစား ID၊ အသုံးပြုသူဖန်တီးထားသော စိတ်ကြိုက်အစိတ်အပိုင်းများကိုသာ ပံ့ပိုးပေးပါသည်။",
  T_48_META_API_1034_P2_D: "၎င်းကို အောင်မြင်စွာ ထည့်သွင်းသည်ဖြစ်စေ ရှိပြီးသား အစိတ်အပိုင်းများ သို့မဟုတ် စိတ်ကြိုက်မဟုတ်သော အစိတ်အပိုင်းများကို ထည့်သွင်းရန် ပျက်ကွက်မည်ဖြစ်သည်။",
  T_48_META_API_1035_D: "အစိတ်အပိုင်းများမှ အစိတ်အပိုင်းများကို ဖယ်ရှားပြီး စိတ်ကြိုက်အစိတ်အပိုင်းများကိုသာ ပံ့ပိုးပါ။",
  T_48_META_API_1035_P0_D: "ပစ်မှတ်",
  T_48_META_API_1035_P1_D: "အစိတ်အပိုင်းအမျိုးအစား ID၊ အသုံးပြုသူဖန်တီးထားသော စိတ်ကြိုက်အစိတ်အပိုင်းများကိုသာ ပံ့ပိုးပေးပါသည်။",
  T_48_META_API_1035_P2_D: "ဖယ်ရှားခြင်း အောင်မြင်သည်ဖြစ်စေ မတည်ရှိသော အစိတ်အပိုင်းများ သို့မဟုတ် စိတ်ကြိုက်မဟုတ်သော အစိတ်အပိုင်းများကို ဖယ်ရှားမည်မဟုတ်ပါ။",
  T_48_META_API_1036_D: "ပလေယာမှ ထွက်ပေါက်ကြားဖေ့စ်ကို စိတ်ကြိုက်ပြင်ဆင်ပါ။",
  T_48_META_API_1036_P0_D: "ခေါင်းစဉ်",
  T_48_META_API_1036_P1_D: "အကြောင်းအရာ",
  T_48_META_API_1036_P2_D: "ရွေးချယ်စရာများ",
  T_48_META_API_1036_P3_D: "နောက်ခံကို ပြမလား။",
  T_48_META_API_1037_D: "လက်ရှိတင်ထားသော မြင်ကွင်းများအားလုံးကို ရယူလိုက်ပါ။",
  T_48_META_API_1037_R_D: "မြင်ကွင်းစာရင်း",
  T_48_META_API_1038_D: "ကစားသမား၏ ဒေသန္တရ ပန်းတိုင်ကို ရယူပါ။",
  T_48_META_API_1038_R_D: "ဦးတည်ချက်",
  T_48_META_API_1039_D: "ဒေသတွင်းအချိန်တံဆိပ်ကို ရယူပါ။",
  T_48_META_API_1039_R_D: "အချိန်တံဆိပ်",
  T_48_META_API_104_D: "သတ်မှတ်ထားသော မြင်ကွင်းများ၏ သတ်မှတ်ထားသော အနေအထားသို့ ပြောင်းလဲ၍ မဖွင့်ရသေးသော မြင်ကွင်းများကို အလိုအလျောက် တင်ပေးမည်ဖြစ်ပြီး၊ တင်ထားသည့် မြင်ကွင်းများကို အလိုအလျောက် ဖြုတ်မည်မဟုတ်ပါ။",
  T_48_META_API_104_P0_D: "ကစားသမား",
  T_48_META_API_104_P1_D: "တင်ရန် Scene ID",
  T_48_META_API_104_P2_D: "အခင်းအကျင်းသစ်တွင် ကစားသမား၏ အနေအထား",
  T_48_META_API_104_P3_D: "အခင်းအကျင်းအသစ်တွင် ကစားသမား၏ တိမ်းညွှတ်မှု",
  T_48_META_API_1040_D: "လက်ရှိပလပ်ဖောင်း၏ ပုံသေဘောင်အပ်ဒိတ်ကို ခေတ္တရပ်ထားပြီးနောက် ခေတ္တရပ်ပြီးနောက်၊ ပလပ်ဖောင်း၏ ပုံသေဘောင်အပ်ဒိတ်ဖြစ်ရပ်ကို စတင်မည်မဟုတ်ပါ။",
  T_48_META_API_1041_D: "ပြန်လည်ရယူပြီးနောက်၊ ပလပ်ဖောင်း၏ ပုံသေဘောင်အပ်ဒိတ်ဖြစ်ရပ်သည် ပြန်လည်စတင်သည်။",
  T_48_META_API_1042_D: "ပစ်မှတ်ပလေယာနှင့် လက်ရှိအသုံးပြုသူ ပလေယာကြားရှိ သူငယ်ချင်းဆက်ဆံရေးကို သတ်မှတ်ပါ လက်ရှိဖောက်သည်ကိုယ်တိုင်က လက်ရှိအသုံးပြုသူ၏ မိတ်ဆွေမဟုတ်ပေ။",
  T_48_META_API_1042_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1042_R_D: "သင်သည် လက်ရှိ client နှင့် သူငယ်ချင်းဖြစ်မဖြစ်",
  T_48_META_API_1043_D: "စိတ်ကြိုက်ဖြစ်ရပ်ကို အစပျိုးပါ။",
  T_48_META_API_1043_P0_D: "စိတ်ကြိုက်ဖြစ်ရပ် ID",
  T_48_META_API_1043_P1_D: "ပစ်မှတ်",
  T_48_META_API_1043_P2_D: "လည်ပတ်နေသော ပလပ်ဖောင်းသည် ဆာဗာ သို့မဟုတ် ကလိုင်းယင့်ဖြစ်သည်။",
  T_48_META_API_1043_P3_D: "ကန့်သတ်စာရင်း",
  T_48_META_API_1044_D: "မိုးပျံခုန်ခြင်း စတင်ပါ။",
  T_48_META_API_1044_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1044_P1_D: "ဤအမြင့်အောက်တွင် လေထီးကို ဖွင့်ခိုင်းလိမ့်မည်။",
  T_48_META_API_1044_P2_D: "လျှောချသည့်အခါ အမြန်နှုန်း၊ X အစိတ်အပိုင်းသည် အလျားလိုက်အမြန်နှုန်းကို ကိုယ်စားပြုပြီး Y အစိတ်အပိုင်းသည် ဒေါင်လိုက်အမြန်နှုန်းကို ကိုယ်စားပြုသည်။",
  T_48_META_API_1044_P3_D: "ရေငုပ်သည့်အခါ အမြန်နှုန်း၊ X အစိတ်အပိုင်းသည် အလျားလိုက်အမြန်နှုန်းကို ကိုယ်စားပြုပြီး Y အစိတ်အပိုင်းသည် ဒေါင်လိုက်အမြန်နှုန်းကို ကိုယ်စားပြုသည်။",
  T_48_META_API_1044_P4_D: "ထီးကိုဖွင့်သည့်အခါ အမြန်နှုန်း၊ X အစိတ်အပိုင်းသည် အလျားလိုက်အမြန်နှုန်းကို ကိုယ်စားပြုပြီး Y အစိတ်အပိုင်းသည် ဒေါင်လိုက်အမြန်နှုန်းကို ကိုယ်စားပြုသည်။",
  T_48_META_API_1045_D: "ဒေတာဇယားရှိ သတ်မှတ်ထားသော သတ်မှတ်ထားသော အမှတ်အသားနှင့် သက်ဆိုင်သည့် တန်ဖိုးကို ဖတ်ပါ။",
  T_48_META_API_1045_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_1045_P1_D: "ကစားသမားသီးသန့် ID",
  T_48_META_API_1045_P2_D: "ခွဲခြားသတ်မှတ်ပါ။",
  T_48_META_API_1045_P3_D: "ရလဒ်များကိုဖတ်ပါ။",
  T_48_META_API_1045_P4_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1045_P5_D: "အမှားကုဒ်",
  T_48_META_API_1046_D: "အဆင့်သတ်မှတ်ချက်ဒေတာဇယားရှိ သတ်မှတ်ထားသော သတ်မှတ်ထားသော အမှတ်အသားနှင့် သက်ဆိုင်သည့် တန်ဖိုးကို ဖတ်ပါ။",
  T_48_META_API_1046_P0_D: "ဒေတာဘေ့စ်တွင် ဇယားအမည် အဆင့်သတ်မှတ်ခြင်း။",
  T_48_META_API_1046_P1_D: "ခွဲခြားသတ်မှတ်ပါ။",
  T_48_META_API_1046_P2_D: "ရလဒ်များကိုဖတ်ပါ။",
  T_48_META_API_1046_P3_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1046_P4_D: "အမှားကုဒ်",
  T_48_META_API_1047_D: "အဆင့်သတ်မှတ်ချက်ဒေတာဇယားရှိ သတ်မှတ်ထားသော အဆင့်သတ်မှတ်ကာလ၏တန်ဖိုးကို ဖတ်ပါ။",
  T_48_META_API_1047_P0_D: "ဒေတာဘေ့စ်တွင် ဇယားအမည် အဆင့်သတ်မှတ်ခြင်း။",
  T_48_META_API_1047_P1_D: "စတင်သည့်အဆင့်သည် အဆုံးအဆင့်ထက် နည်းရမည် သို့မဟုတ် ညီမျှရမည်ဖြစ်ပြီး အဆင့်သည် 1 မှ စတင်သည်။",
  T_48_META_API_1047_P2_D: "အဆင့်သတ်မှတ်ချက်",
  T_48_META_API_1047_P3_D: "ရလဒ်များကိုဖတ်ပါ။",
  T_48_META_API_1047_P4_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1047_P5_D: "အမှားကုဒ်",
  T_48_META_API_1048_D: "စုစည်းဒေတာဇယားရှိ သတ်မှတ်ထားသော သတ်မှတ်ထားသော အမှတ်အသားနှင့် သက်ဆိုင်သည့် တန်ဖိုးကို ဖတ်ပါ။",
  T_48_META_API_1048_P0_D: "ဒေတာဘေ့စ်တွင် စုဆောင်းထားသော ဒေတာဇယားအမည်",
  T_48_META_API_1048_P1_D: "ခွဲခြားသတ်မှတ်ပါ။",
  T_48_META_API_1048_P2_D: "ရလဒ်များကိုဖတ်ပါ။",
  T_48_META_API_1048_P3_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1048_P4_D: "အမှားကုဒ်",
  T_48_META_API_1049_D: "ဒေတာဇယားတွင် သတ်မှတ်ထားသော သတ်မှတ်ထားသော အမှတ်အသားနှင့် သက်ဆိုင်သည့် တန်ဖိုးကို ရေးပါ။",
  T_48_META_API_1049_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_1049_P1_D: "ကစားသမားသီးသန့် ID",
  T_48_META_API_1049_P2_D: "ခွဲခြားသတ်မှတ်ပါ။",
  T_48_META_API_1049_P3_D: "ရေးထားတဲ့တန်ဖိုး",
  T_48_META_API_1049_P4_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1049_P5_D: "အမှားကုဒ်",
  T_48_META_API_105_D: "မြင်ကွင်း၏ skybox ကိုရယူပါ။",
  T_48_META_API_105_P0_D: "မြင်ကွင်း ID",
  T_48_META_API_105_R_D: "skybox",
  T_48_META_API_1050_D: "စာရင်းထဲရှိ အစိတ်အပိုင်းအရေအတွက်ကို ရယူပါ။",
  T_48_META_API_1050_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1050_R_D: "ဒြပ်စင်အရေအတွက်",
  T_48_META_API_1051_D: "စာရင်းရှိ သတ်မှတ်ထားသော အညွှန်းတွင် ဒြပ်စင်တန်ဖိုးကို ရယူပါ။",
  T_48_META_API_1051_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1051_P1_D: "အညွှန်းတန်ဖိုး 0 မှစတင်သည်။",
  T_48_META_API_1051_R_D: "ဒြပ်စင်တန်ဖိုး",
  T_48_META_API_1052_D: "စာရင်းရှိ သတ်မှတ်ထားသော အညွှန်းနှင့် သက်ဆိုင်သော အစိတ်အပိုင်းတန်ဖိုးကို သတ်မှတ်သည်။",
  T_48_META_API_1052_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1052_P1_D: "အညွှန်းတန်ဖိုး 0 မှစတင်သည်။",
  T_48_META_API_1052_P2_D: "ဒြပ်စင်တန်ဖိုး",
  T_48_META_API_1053_D: "စာရင်း၏အဆုံးတွင် အစိတ်အပိုင်းများကို ပေါင်းထည့်ပါ။",
  T_48_META_API_1053_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1053_P1_D: "ထည့်ရန်ဒြပ်စင်များ",
  T_48_META_API_1054_D: "သတ်မှတ်ထားသော အညွှန်းနှင့် သက်ဆိုင်သည့် ဒြပ်စင်ကို စာရင်းမှ ဖယ်ရှားသည်။",
  T_48_META_API_1054_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1054_P1_D: "အညွှန်းတန်ဖိုး 0 မှစတင်သည်။",
  T_48_META_API_1055_D: "စာရင်းထဲရှိ အစိတ်အပိုင်းအားလုံးကို ရှင်းလင်းပါ။",
  T_48_META_API_1055_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1056_D: "သတ်မှတ်ထားသောစာရင်းကို ပြောင်းပြန်လှန်ပါ။",
  T_48_META_API_1056_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1057_D: "စာရင်းတစ်ခုကို ကူးယူပါ။",
  T_48_META_API_1057_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1057_R_D: "စာရင်းအသစ်ကို ကူးယူထားသည်။",
  T_48_META_API_1058_D: "စာရင်းရှိ သတ်မှတ်ထားသော အညွှန်းအနေအထားတွင် ဒြပ်စင်အသစ်တစ်ခုကို ထည့်သွင်းပြီး မူလအညွှန်းအနေအထားနှင့် နောက်သို့ အနေအထားတစ်ခုသို့ ရွေ့သွားပါမည်။",
  T_48_META_API_1058_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1058_P1_D: "ထည့်သွင်းရမည့် အညွှန်းအနေအထား၊ အညွှန်းကိန်းကို 0 မှ တွက်ချက်သည်။",
  T_48_META_API_1058_P2_D: "ထည့်သွင်းရန် ဒြပ်စင်တန်ဖိုးအသစ်",
  T_48_META_API_1059_D: "စာရင်းထဲရှိ အစိတ်အပိုင်းများကို ကျပန်းပြန်စီပါ။",
  T_48_META_API_1059_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1060_D: "နှစ်ဖက်စလုံးရှိ ဘောင်များကို နှိုင်းယှဉ်ပြီး မှန်သည်ဖြစ်စေ၊ မှားသည်ဖြစ်စေ ပြန်ပေးသည်။",
  T_48_META_API_1060_P0_D: "နှိုင်းယှဉ်ရန်အတွက် အသုံးပြုသောတန်ဖိုး",
  T_48_META_API_1060_P1_D: "နှိုင်းယှဉ်မှုနည်းလမ်းသည် အောက်ပါနည်းလမ်းများကို ပံ့ပိုးပေးသည်- >,>=,==,!=,<=,<,and (limited bool type), သို့မဟုတ် (limited bool type)",
  T_48_META_API_1060_P2_D: "နှိုင်းယှဉ်ရန်အတွက် အသုံးပြုသောတန်ဖိုး",
  T_48_META_API_1060_R_D: "ရလဒ်များကို နှိုင်းယှဉ်ပါ။",
  T_48_META_API_1061_D: "အခြေခံဂဏန်းသင်္ချာ လုပ်ဆောင်ချက် လေးခုတွင် ပေါင်းခြင်း၊ နုတ်ခြင်း၊ မြှောက်ခြင်း၊ ပိုင်းခြားခြင်းနှင့် အကြွင်းများ ပါဝင်သည်။ အကြွင်းလုပ်ဆောင်ချက်သည် ကိန်းပြည့်များကိုသာ ပံ့ပိုးပေးပြီး ကျန်လုပ်ဆောင်ချက်များသည် ကိန်းပြည့် သို့မဟုတ် ဒဿမများကို ပံ့ပိုးပေးသည်။",
  T_48_META_API_1061_P0_D: "လည်ပတ်မှုတန်ဖိုး",
  T_48_META_API_1061_P1_D: "ဂဏန်းသင်္ချာ လုပ်ဆောင်ချက် လေးမျိုးသည် ပေါင်းခြင်း၊ နုတ်ခြင်း၊ မြှောက်ခြင်း၊ ပိုင်းခြားခြင်း နှင့် အကြွင်း ကိန်းဂဏန်းများကို ပံ့ပိုးပေးခြင်း မရှိပါ။",
  T_48_META_API_1061_P2_D: "လည်ပတ်မှုတန်ဖိုး",
  T_48_META_API_1061_R_D: "တွက်ချက်မှုရလဒ်",
  T_48_META_API_1062_D: "အငယ်ဆုံး ကိန်းပြည့် (ပါဝင်) နှင့် အကြီးဆုံး ကိန်းပြည့် (သီးသန့်) အကြား ကိန်းပြည့်ကို ကျပန်းထုတ်ပေးသည်",
  T_48_META_API_1062_P0_D: "ကျပန်းအကွာအဝေး၏ ဘယ်ဘက်ကြားကာလ၊ ဖြည့်ထားသောတန်ဖိုးကို ကျပန်းရောက်ရှိရန် ဖြစ်နိုင်သည်။",
  T_48_META_API_1062_P1_D: "ကျပန်းအပိုင်းအခြား၏ ညာဘက်အကွာအဝေးသည် ဖြည့်စွက်တန်ဖိုးသို့ ကျပန်းဖြစ်မည်မဟုတ်ပါ။",
  T_48_META_API_1062_R_D: "ကျပန်းရလဒ်၊ ကိန်းပြည့်",
  T_48_META_API_1063_D: "အသေးငယ်ဆုံး ဒဿမတန်ဖိုး (ပါဝင်သည်) နှင့် အကြီးဆုံးဒဿမတန်ဖိုး (သီးသန့်) ကြားတွင် ကျပန်းဒဿမတစ်ခုထုတ်ပေးသည်",
  T_48_META_API_1063_P0_D: "ကျပန်းအကွာအဝေး၏ ဘယ်ဘက်ကြားကာလ၊ ဖြည့်စွက်တန်ဖိုးသည် ကျပန်းဖြစ်ရန် အခွင့်အလမ်းအနည်းငယ်ရှိပါသည်။",
  T_48_META_API_1063_P1_D: "ကျပန်းအပိုင်းအခြား၏ ညာဘက်အကွာအဝေးသည် ဖြည့်စွက်တန်ဖိုးသို့ ကျပန်းဖြစ်မည်မဟုတ်ပါ။",
  T_48_META_API_1063_R_D: "ကျပန်းရလဒ်၊ ဒဿမ၊ ဒဿမ ၇ နေရာအထိ တိကျသည်။",
  T_48_META_API_1064_D: "အရာဝတ္တုသည် ဗလာရှိမရှိ ဆုံးဖြတ်ပါ။",
  T_48_META_API_1064_P0_D: "စီရင်ရမည့်အရာဝတ္ထုချည်းဖြစ်သည်။",
  T_48_META_API_1064_R_D: "ဗလာ",
  T_48_META_API_1065_D: "ယုတ္တိဗေဒ ငြင်းဆိုခြင်း၊ ထည့်သွင်းတန်ဖိုး- မှန် သို့မဟုတ် အမှား၊ ပြန်တန်ဖိုး- မှား သို့မဟုတ် မှန်သည်။",
  T_48_META_API_1065_P0_D: "မဟုတ်တဲ့တန်ဖိုးကို ရှာဖို့ လိုပါတယ်။",
  T_48_META_API_1065_R_D: "အနုတ်လက္ခဏာရလဒ်",
  T_48_META_API_1066_D: "ပကတိတန်ဖိုးကို ယူပါ၊ ကိန်းပြည့်များနှင့် ဒဿမများကို ပံ့ပိုးပါ။",
  T_48_META_API_1066_P0_D: "တန်ဖိုး၏ ပကတိတန်ဖိုးကို ရှာဖွေရန် လိုအပ်သည်။",
  T_48_META_API_1066_R_D: "ပကတိတန်ဖိုးကိုယူခြင်း၏ရလဒ်",
  T_48_META_API_1067_D: "နှစ်ထပ်ကိန်းကို တွက်ချက်ပါ။",
  T_48_META_API_1067_P0_D: "တန်ဖိုး၏ နှစ်ထပ်ကိန်းကို ရှာရန် လိုအပ်သည်။",
  T_48_META_API_1067_R_D: "နှစ်ထပ်ကိန်းကိုရှာဖွေခြင်း၏ရလဒ်",
  T_48_META_API_1068_D: "အနှုတ်တန်ဖိုးများကို တွက်ချက်ပါ။",
  T_48_META_API_1068_P0_D: "အနုတ်လက္ခဏာတန်ဖိုးကိုရှာဖွေရန်လိုအပ်သည်။",
  T_48_META_API_1068_R_D: "အနုတ်လက္ခဏာရလဒ်",
  T_48_META_API_1069_D: "ကြိုးနှစ်ချောင်းကို ပေါင်းစည်းပါ။",
  T_48_META_API_1069_P0_D: "ကြိုးတန်းတန်ဖိုး",
  T_48_META_API_1069_P1_D: "string rvalue",
  T_48_META_API_1069_R_D: "စာကြောင်းတွဲ ရလဒ်",
  T_48_META_API_1070_D: "ကြိုးအရှည်ကိုရယူပါ။",
  T_48_META_API_1070_P0_D: "ကြိုးတစ်ချောင်း",
  T_48_META_API_1070_R_D: "ကြိုးအရှည်",
  T_48_META_API_1071_D: "သတ်မှတ်ထားသော တန်ဖိုးကို အနီးဆုံး ကိန်းပြည့်သို့ ညှိသည်။",
  T_48_META_API_1071_P0_D: "တန်ဖိုးကို ဝိုင်းချရန် လိုအပ်သည်။",
  T_48_META_API_1071_R_D: "ဆင်းခြင်း၏ရလဒ်",
  T_48_META_API_1072_D: "သတ်မှတ်ထားသော တန်ဖိုးကို အနီးဆုံး ကိန်းပြည့်သို့ ညှိသည်။",
  T_48_META_API_1072_P0_D: "တန်ဖိုးကို စုစည်းရန် လိုအပ်သည်။",
  T_48_META_API_1072_R_D: "စုဆောင်းခြင်း၏ရလဒ်",
  T_48_META_API_1073_D: "သတ်မှတ်ထားသောတန်ဖိုးကို ကိန်းပြည့်တစ်ခုသို့ ညှိသည်။",
  T_48_META_API_1073_P0_D: "တန်ဖိုးတွေကို လုံးဝန်းဖို့ လိုပါတယ်။",
  T_48_META_API_1073_R_D: "လုံးဝန်းသောရလဒ်",
  T_48_META_API_1074_D: "ပစ်မှတ်စာကြောင်းရှိ သတ်မှတ်ထားသော စာကြောင်းများအားလုံးကို အစားထိုးပြီးနောက် လိုင်းအသစ်ကို ထုတ်ပါ။",
  T_48_META_API_1074_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1074_P1_D: "ကြိုးဟောင်းကို အစားထိုးရမည်။",
  T_48_META_API_1074_P2_D: "ကြိုးအသစ်ဖြင့် အစားထိုးရန်",
  T_48_META_API_1074_R_D: "ပြီးခဲ့သော စာကြောင်းကို အစားထိုးပါ။",
  T_48_META_API_1075_D: "သတ်မှတ်ထားသောစာကြောင်း၏ ပထမဆုံးပေါ်ပေါက်မှုအတွက် ပစ်မှတ်စာကြောင်းကို ရှာဖွေပါ။",
  T_48_META_API_1075_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1075_P1_D: "ရှာရန် သတ်မှတ်ထားသော စာကြောင်း",
  T_48_META_API_1075_P2_D: "စတင်သည့်အနေအထားမှ string ကိုရှာပါ၊ string position ကို 0 မှတွက်ချက်သည်။",
  T_48_META_API_1075_R_D: "ပစ်မှတ် string တွင် string ၏ ပထမဆုံး ဖြစ်ပေါ်မှု အနေအထားကို string position ကို 0 မှ တွက်ချက်သည်။",
  T_48_META_API_1076_D: "သတ်မှတ်ထားသော အနေအထားမှ စတင်၍ သတ်မှတ်ထားသော အရှည်၏ စာကြောင်းတစ်ကြောင်းကို ကြားဖြတ်ပြီးနောက်၊ ကြိုးအသစ်တစ်ခုကို ထုတ်ပါ။",
  T_48_META_API_1076_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1076_P1_D: "ကြားဖြတ်စတင်သည့် အနေအထား string position ကို 0 မှ တွက်ချက်သည်။",
  T_48_META_API_1076_P2_D: "ပုံမှန်အားဖြင့် အရှည်ကို ဖြတ်ပါ။",
  T_48_META_API_1076_R_D: "ကြားဖြတ် ကြိုးတစ်ချောင်း",
  T_48_META_API_1077_D: "စာရင်းနှစ်ခု၏ အစိတ်အပိုင်းများသည် အတိအကျတူညီခြင်းရှိမရှိ နှိုင်းယှဉ်ခြင်း စာရင်းစွမ်းရည်သည် နှိုင်းယှဉ်မှုရလဒ်အပေါ် သက်ရောက်မှုမရှိပါ။",
  T_48_META_API_1077_P0_D: "နှိုင်းယှဉ်မှုအတွက် အသုံးပြုသော တန်ဖိုးများကို စာရင်းပြုစုပါ။",
  T_48_META_API_1077_P1_D: "နှိုင်းယှဉ်မှုအတွက် အသုံးပြုသော တန်ဖိုးများကို စာရင်းပြုစုပါ။",
  T_48_META_API_1077_R_D: "ရလဒ်များကို နှိုင်းယှဉ်ပါက၊ အကြောင်းအရာများ ကိုက်ညီပါက True ပြန်ပေးပါမည်။",
  T_48_META_API_1078_D: "သတ်မှတ်ထားသော မျဉ်းသားချက်အဖြစ် သတ်မှတ်ထားသော စာကြောင်းကို အသုံးပြု၍ ပစ်မှတ်စာကြောင်းကို အချပ်များစွာသို့ ဖြတ်ပြီး ဆက်တိုက် N မျဉ်းသားချက်အသစ်တစ်ခုကို N-1 အကျယ်အဝန်းများအဖြစ် ဖြတ်တောက်ပြီး string list အစိတ်အပိုင်းများအဖြစ် အထွက်ကို ထုတ်ပေးပါမည်။",
  T_48_META_API_1078_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1078_P1_D: "အနားသတ်မျဉ်း",
  T_48_META_API_1078_R_D: "အထွက်စာကြောင်းစာရင်းသည် အကျယ်တစ်ဝက် နေရာလွတ်ဒြပ်စင်ဖြင့် အမြဲတမ်းအဆုံးသတ်သည်။",
  T_48_META_API_1079_D: "string position list အရ စာလုံးများကို ထုတ်ယူပြီး string output အသစ်တစ်ခုသို့ ပေါင်းစပ်ပါ။",
  T_48_META_API_1079_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1079_P1_D: "string positions များစာရင်း၊ string positions များကို 0 မှ စတင်တွက်ချက်ပါသည်။",
  T_48_META_API_1079_R_D: "output string",
  T_48_META_API_1080_D: "ပစ်မှတ်စာတန်းအက္ခရာများကို စာလုံးအကြီးအဖြစ် ပြောင်းပါ။",
  T_48_META_API_1080_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1080_R_D: "output string",
  T_48_META_API_1081_D: "ပစ်မှတ်စာကြောင်းအက္ခရာအားလုံးကို စာလုံးအသေးအဖြစ် ပြောင်းပါ။",
  T_48_META_API_1081_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1081_R_D: "output string",
  T_48_META_API_1082_D: "ပထမနေရာမဟုတ်သော စာလုံးရှေ့နှင့် ပစ်မှတ်စာကြောင်း၏ နောက်ဆုံးနေရာမဟုတ်သည့် ဇာတ်ကောင်နောက်မှ နေရာလွတ်အားလုံးကို ဖယ်ရှားပါ။",
  T_48_META_API_1082_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1082_R_D: "output string",
  T_48_META_API_1083_D: "သတ်မှတ်ထားသော identifier နှင့် ချိတ်ဆက်ပြီးနောက် စာကြောင်းအသစ်ကို ထုတ်သည်။",
  T_48_META_API_1083_P0_D: "ပစ်မှတ် စာကြောင်းစာရင်း",
  T_48_META_API_1083_P1_D: "strings များကို ပေါင်းစပ်ရန် အသုံးပြုသော သတ်မှတ်ထားသော အမှတ်အသား",
  T_48_META_API_1083_R_D: "output string",
  T_48_META_API_1084_D: "အဆင့်သတ်မှတ်ချက်ဒေတာဇယားတွင် သတ်မှတ်ထားသော သတ်မှတ်ထားသော အမှတ်အသားနှင့် သက်ဆိုင်သည့် တန်ဖိုးကို ရေးပါ။",
  T_48_META_API_1084_P0_D: "ဒေတာဘေ့စ်တွင် ဇယားအမည် အဆင့်သတ်မှတ်ခြင်း။",
  T_48_META_API_1084_P1_D: "ခွဲခြားသတ်မှတ်ပါ။",
  T_48_META_API_1084_P2_D: "ရေးထားတဲ့တန်ဖိုး",
  T_48_META_API_1084_P3_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1084_P4_D: "အမှားကုဒ်",
  T_48_META_API_1085_D: "စုစည်းဒေတာဇယားတွင် သတ်မှတ်ထားသော သတ်မှတ်ထားသော အမှတ်အသားနှင့် သက်ဆိုင်သည့် အော့ဖ်ဆက်တန်ဖိုးကို ရေးပါ။",
  T_48_META_API_1085_P0_D: "ဒေတာဘေ့စ်တွင် စုဆောင်းထားသော ဒေတာဇယားအမည်",
  T_48_META_API_1085_P1_D: "ခွဲခြားသတ်မှတ်ပါ။",
  T_48_META_API_1085_P2_D: "ဂဏန်းသင်္ချာ လုပ်ဆောင်ချက် လေးမျိုး",
  T_48_META_API_1085_P3_D: "Offset value ရေးထားတယ်။",
  T_48_META_API_1085_P4_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1085_P5_D: "အမှားကုဒ်",
  T_48_META_API_1086_D: "ဒေတာဇယားရှိ သတ်မှတ်ထားသော သတ်မှတ်ထားသော အမှတ်အသားနှင့် သက်ဆိုင်သည့် တန်ဖိုးကို ဖျက်ပါ။",
  T_48_META_API_1086_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_1086_P1_D: "ကစားသမားသီးသန့် ID",
  T_48_META_API_1086_P2_D: "ခွဲခြားသတ်မှတ်ပါ။",
  T_48_META_API_1086_P3_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1086_P4_D: "အမှားကုဒ်",
  T_48_META_API_1087_D: "အဆင့်သတ်မှတ်ချက်ဒေတာဇယားရှိ သတ်မှတ်ထားသော သတ်မှတ်ထားသော အမှတ်အသားနှင့် သက်ဆိုင်သည့် တန်ဖိုးကို ဖျက်ပါ။",
  T_48_META_API_1087_P0_D: "ဒေတာဘေ့စ်တွင် ဇယားအမည် အဆင့်သတ်မှတ်ခြင်း။",
  T_48_META_API_1087_P1_D: "ခွဲခြားသတ်မှတ်ပါ။",
  T_48_META_API_1087_P2_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1087_P3_D: "အမှားကုဒ်",
  T_48_META_API_1088_D: "အဆင့်သတ်မှတ်ချက်ဒေတာဇယားရှိ သတ်မှတ်ထားသော အဆင့်သတ်မှတ်ချက်နှင့် သက်ဆိုင်သည့်တန်ဖိုးကို ဖျက်ပါ။",
  T_48_META_API_1088_P0_D: "ဒေတာဘေ့စ်တွင် ဇယားအမည် အဆင့်သတ်မှတ်ခြင်း။",
  T_48_META_API_1088_P1_D: "အဆင့်သတ်မှတ်ပါ။",
  T_48_META_API_1088_P2_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_1088_P3_D: "အမှားကုဒ်",
  T_48_META_API_1089_D: "Persona သို့ အသုံးပြုသူ မက်ဆေ့ချ် ပို့ပါ။",
  T_48_META_API_1089_P0_D: "ပုဂ္ဂိုလ်ရေး ID ပစ်မှတ်",
  T_48_META_API_1089_P1_D: "မက်ဆေ့ခ်ျအကြောင်းအရာ",
  T_48_META_API_1090_D: "Persona သို့ စနစ်မက်ဆေ့ချ်များ ပို့ပါ။",
  T_48_META_API_1090_P0_D: "ပုဂ္ဂိုလ်ရေး ID ပစ်မှတ်",
  T_48_META_API_1090_P1_D: "မက်ဆေ့ခ်ျအကြောင်းအရာ",
  T_48_META_API_1091_D: "Persona Memory ကိုရှင်းလင်းပါ။",
  T_48_META_API_1091_P0_D: "အမှားကုဒ်",
  T_48_META_API_1092_D: "အဖွဲ့ဝင်စင်တာကိုနှိုးဆော်",
  T_48_META_API_1092_P0_D: "အမှားကုဒ်",
  T_48_META_API_1093_D: "အသင်းဝင်သက်တမ်းကုန်ဆုံးချိန်တံဆိပ်ကို ရယူပါ။",
  T_48_META_API_1093_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1093_P1_D: "အချိန်တံဆိပ်",
  T_48_META_API_1093_P2_D: "အမှားကုဒ်",
  T_48_META_API_1094_D: "ကစားသမားသည် အဖွဲ့ဝင်ဖြစ်မဖြစ် ဆုံးဖြတ်ပါ။",
  T_48_META_API_1094_P0_D: "အမှားကုဒ်",
  T_48_META_API_1094_P1_D: "သင်သည် အဖွဲ့ဝင်ဖြစ်ပါသလား။",
  T_48_META_API_1095_D: "အသင်းဝင်သက်တမ်းကုန်ဆုံးချိန်တံဆိပ်ကို ရယူပါ။",
  T_48_META_API_1095_P0_D: "အချိန်တံဆိပ်",
  T_48_META_API_1095_P1_D: "အမှားကုဒ်",
  T_48_META_API_1096_D: "ကစားသမားသည် အဖွဲ့ဝင်ဖြစ်မဖြစ် ဆုံးဖြတ်ပါ။",
  T_48_META_API_1096_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1096_P1_D: "အမှားကုဒ်",
  T_48_META_API_1096_P2_D: "သင်သည် အဖွဲ့ဝင်ဖြစ်ပါသလား။",
  T_48_META_API_1097_D: "အဖွဲ့ဝင်စင်တာကိုနှိုးဆော်",
  T_48_META_API_1097_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_1097_P1_D: "အမှားကုဒ်",
  T_48_META_API_1099_D: "Persona စောင့်ကြည့်လေ့လာသူကို သတ်မှတ်ပြီး Persona နှင့် နောက်ဆက်တွဲ စကားဝိုင်းများကို လေ့လာသူထံ ပေးပို့ပါမည်။",
  T_48_META_API_1099_P0_D: "ပုဂ္ဂိုလ်ရေး ID ပစ်မှတ်",
  T_48_META_API_1099_P1_D: "လေ့လာသူစာရင်း",
  T_48_META_API_11_D: "လက်ရှိအဆင့်ကို အဆုံးသတ်ပြီး နောက်တစ်ဆင့်ကို ဝင်ပါ။",
  T_48_META_API_1100_D: "တိုက်ရိုက်ထုတ်လွှင့်မှုကို အသုံးပြု၍ Persona သို့ သုံးစွဲသူမက်ဆေ့ချ်များ ပေးပို့ပါ။",
  T_48_META_API_1100_P0_D: "ပုဂ္ဂိုလ်ရေး ID ပစ်မှတ်",
  T_48_META_API_1100_P1_D: "မက်ဆေ့ခ်ျအကြောင်းအရာ",
  T_48_META_API_1101_D: "တိုက်ရိုက်ထုတ်လွှင့်မှုကို အသုံးပြု၍ Persona သို့ စနစ်မက်ဆေ့ချ်များ ပေးပို့ပါ။",
  T_48_META_API_1101_P0_D: "ပုဂ္ဂိုလ်ရေး ID ပစ်မှတ်",
  T_48_META_API_1101_P1_D: "မက်ဆေ့ခ်ျအကြောင်းအရာ",
  T_48_META_API_1101_P2_D: "အကြောင်းပြန်ရမည်။",
  T_48_META_API_1103_D: "ကျပန်းမျိုးစေ့ကိုဖန်တီးပါ။",
  T_48_META_API_1103_P0_D: "မျိုးစေ့",
  T_48_META_API_1103_R_D: "ကျပန်းနံပါတ်မီးစက်",
  T_48_META_API_1104_D: "သတ်မှတ်ထားသော ကျပန်းနံပါတ် မီးစက်မှ နောက်ကျပန်းနံပါတ်ကို ရယူပါ၊ အမြင့်ဆုံးတန်ဖိုးမှာ 32767 ဖြစ်သည်။",
  T_48_META_API_1104_P0_D: "ကျပန်းနံပါတ်မီးစက်",
  T_48_META_API_1104_P1_D: "အနိမ့်ဆုံးအပိုင်း",
  T_48_META_API_1104_P2_D: "အတိုင်းအတာ အများဆုံး",
  T_48_META_API_1104_R_D: "ကျပန်းနံပါတ်",
  T_48_META_API_1108_D: "Get the client language used by the player ",
  T_48_META_API_12_D: "ကွန်ဆိုးလ်သို့ မှတ်တမ်းကို ပရင့်ထုတ်ပါ။",
  T_48_META_API_12_P0_D: "ပုံနှိပ်ဖို့ ဘာတွေ လိုအပ်လဲ။",
  T_48_META_API_13_D: "ကန့်သတ်ချက်များဖြင့် စာကြောင်းတစ်ခု ထုတ်ပါ။",
  T_48_META_API_13_P0_D: "ကန့်သတ်ချက်တစ်ခုကို ကိုယ်စားပြုရန် %v နေရာကို အသုံးပြုပါ။",
  T_48_META_API_13_P1_D: "ဖော်မတ်ဖော်ပြချက်တွင် ပါဝင်သော ကန့်သတ်ချက်စာရင်းသည် %v အရေအတွက်နှင့် ကိုက်ညီရန် လိုအပ်သည်။",
  T_48_META_API_13_R_D: "output string",
  T_48_META_API_14_D: "သေတ္တာများ၊ ဖန်တီးထားသည့်အရာများ၊ နေရာချထားသည့်အရာများ၊ ကျည်ဆန်အကြွင်းအကျန်များ အပါအဝင် မြေပုံအရာဝတ္တုအကြွင်းအကျန်များကို ရှင်းလင်းပါ။",
  T_48_META_API_15_D: "သုံးစွဲသူအတွေ့အကြုံဒေတာခွဲခြမ်းစိတ်ဖြာမှုအတွက် ပြိုင်ဆိုင်မှုအမှတ်များမှတ်တမ်းကို စိတ်ကြိုက်ပြင်ဆင်ပါ။",
  T_48_META_API_15_P0_D: "အစီရင်ခံမည့် နယ်ပယ်အမည်များစာရင်း",
  T_48_META_API_15_P1_D: "အစီရင်ခံရမည့် အကွက်တန်ဖိုးများစာရင်း",
  T_48_META_API_1500_D: "သုံးဖက်မြင် vector တစ်ခု၏ X အစိတ်အပိုင်းကို ရယူပါ။",
  T_48_META_API_1500_P0_D: "3D vector",
  T_48_META_API_1500_R_D: "သုံးဖက်မြင် vector X အစိတ်အပိုင်း",
  T_48_META_API_1501_D: "သုံးဖက်မြင် vector တစ်ခု၏ Y အစိတ်အပိုင်းကို ရယူပါ။",
  T_48_META_API_1501_P0_D: "3D vector",
  T_48_META_API_1501_R_D: "သုံးဖက်မြင် vector Y အစိတ်အပိုင်း",
  T_48_META_API_1502_D: "သုံးဖက်မြင် vector တစ်ခု၏ Z အစိတ်အပိုင်းကို ရယူပါ။",
  T_48_META_API_1502_P0_D: "3D vector",
  T_48_META_API_1502_R_D: "သုံးဖက်မြင် vector Z အစိတ်အပိုင်း",
  T_48_META_API_1503_D: "သုံးဖက်မြင် vector တစ်ခု၏ X အစိတ်အပိုင်းကို သတ်မှတ်သည်။",
  T_48_META_API_1503_P0_D: "3D vector",
  T_48_META_API_1503_P1_D: "X အစိတ်အပိုင်း",
  T_48_META_API_1504_D: "သုံးဖက်မြင် vector တစ်ခု၏ Y အစိတ်အပိုင်းကို သတ်မှတ်သည်။",
  T_48_META_API_1504_P0_D: "3D vector",
  T_48_META_API_1504_P1_D: "Y အစိတ်အပိုင်း",
  T_48_META_API_1505_D: "သုံးဖက်မြင် vector တစ်ခု၏ Z အစိတ်အပိုင်းကို သတ်မှတ်သည်။",
  T_48_META_API_1505_P0_D: "3D vector",
  T_48_META_API_1505_P1_D: "Z အစိတ်အပိုင်း",
  T_48_META_API_1506_D: "သုံးဖက်မြင် vector နှစ်ခုထည့်ပါ။",
  T_48_META_API_1506_P0_D: "ซ้าย",
  T_48_META_API_1506_P1_D: "ขวา",
  T_48_META_API_1506_R_D: "သုံးဖက်မြင် vector ပေါင်းထည့်မှုရလဒ်",
  T_48_META_API_1507_D: "သုံးဖက်မြင် ပုံနှစ်ခုကို နုတ်ပါ။",
  T_48_META_API_1507_P0_D: "ซ้าย",
  T_48_META_API_1507_P1_D: "ขวา",
  T_48_META_API_1507_R_D: "သုံးဖက်မြင် vector ၏ lvalue မှ rvalue ကို နုတ်ခြင်း၏ရလဒ်",
  T_48_META_API_1508_D: "သုံးဖက်မြင် vector ကို ချိန်ညှိခြင်း။",
  T_48_META_API_1508_P0_D: "ချိန်ညှိရန် 3D vector",
  T_48_META_API_1508_P1_D: "3D vector အတိုင်းအတာပမာဏ",
  T_48_META_API_1508_R_D: "3D vector အတိုင်းအတာ ရလဒ်များ",
  T_48_META_API_1509_D: "အစက်ထုတ်ကုန်၏ သုံးဖက်မြင် ကွက်လပ်နှစ်ခု၊ အစက်ထုတ်ကုန်၏ရလဒ်သည် စကေးတစ်ခုဖြစ်သည်။",
  T_48_META_API_1509_P0_D: "ซ้าย",
  T_48_META_API_1509_P1_D: "ขวา",
  T_48_META_API_1509_R_D: "အစက်ပွားခြင်းရလဒ်",
  T_48_META_API_1510_D: "သုံးဖက်မြင် ဗက်နှစ်ခုကို ဖြတ်ကျော်၍ မြှောက်ခြင်း၏ ရလဒ်သည် ကိန်းဂယက်နှစ်ခု တည်ရှိသည့် လေယာဉ်နှင့် ထောင့်မှန်ကျသည်။",
  T_48_META_API_1510_P0_D: "ซ้าย",
  T_48_META_API_1510_P1_D: "ขวา",
  T_48_META_API_1510_R_D: "လက်ဝါးကပ်တိုင်ထုတ်ကုန်၏ရလဒ်၊ ဦးတည်ချက်သည် လည်ပတ်မှုတွင်ပါဝင်သော vector နှစ်ခုတည်ရှိရာ လေယာဉ်နှင့် ထောင့်မှန်ပါသည်။",
  T_48_META_API_1511_D: "သုံးဖက်မြင် ကွက်လပ်များကို ပုံမှန်ပြုလုပ်ပါ။",
  T_48_META_API_1511_P0_D: "3D vector",
  T_48_META_API_1511_R_D: "ပုံမှန်လုပ်ထားသော vector အသစ်ကို ပြန်ပေးသည်။ မှိုအရှည်မှာ ၁",
  T_48_META_API_1512_D: "Modulo သည် သုံးဖက်မြင် vector ဖြစ်သည်။",
  T_48_META_API_1512_P0_D: "3D vector",
  T_48_META_API_1512_R_D: "modulo ရလဒ်သည် vector module ၏အရှည်ဖြစ်သည်။",
  T_48_META_API_1513_D: "သုံးဖက်မြင် vector နှစ်ခု၏ Euclidean အကွာအဝေးကို တွက်ချက်ပါ။",
  T_48_META_API_1513_P0_D: "ซ้าย",
  T_48_META_API_1513_P1_D: "ขวา",
  T_48_META_API_1513_R_D: "vector နှစ်ခုကို နုတ်ပြီးနောက် ရလာတဲ့ vector ရဲ့ module အရှည်",
  T_48_META_API_1514_D: "သုံးဖက်မြင် vector နှစ်ခုကြားရှိ ထောင့်ကို တွက်ချက်ပါ။",
  T_48_META_API_1514_P0_D: "ซ้าย",
  T_48_META_API_1514_P1_D: "ขวา",
  T_48_META_API_1514_R_D: "Vector angle၊ angle range 0-180",
  T_48_META_API_1515_D: "3D vector ဖန်တီးပါ။",
  T_48_META_API_1515_P0_D: "သုံးဖက်မြင် vector တစ်ခု၏ X အစိတ်အပိုင်း",
  T_48_META_API_1515_P1_D: "သုံးဖက်မြင် vector တစ်ခု၏ Y အစိတ်အပိုင်း",
  T_48_META_API_1515_P2_D: "သုံးဖက်မြင် vector ၏ Z အစိတ်အပိုင်း",
  T_48_META_API_1515_R_D: "သုံးဖက်မြင် vector ကိုဖန်တီးခဲ့သည်။",
  T_48_META_API_1516_D: "အသစ်တည်ဆောက်ထားသော ဦးတည်ချက်အမှတ်ကို ရယူပါ (ကန့်ကွက်ထားသည်၊ မသုံးပါနှင့်)",
  T_48_META_API_1516_P0_D: "တည်နေရာ",
  T_48_META_API_1516_P1_D: "ဆီသို့",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "ဦးတည်ချက်အမှတ် အနေအထားကို ရယူပါ ( အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ မသုံးပါနှင့် )",
  T_48_META_API_1517_P0_D: "ဦးတည်ချက်အမှတ်",
  T_48_META_API_1517_R_D: "ရာထူး",
  T_48_META_API_1518_D: "ဦးတည်ချက်အမှတ်ကို ရယူပါ ( အသုံးမပြုတော့ပါ၊ အသုံးမပြုပါနှင့် )",
  T_48_META_API_1518_P0_D: "ဦးတည်ချက်အမှတ်",
  T_48_META_API_1518_R_D: "ရှေ့သို့",
  T_48_META_API_1519_D: "စာရင်းတစ်ခုဖန်တီးပါ။",
  T_48_META_API_1519_P0_D: "စာရင်း၏ကနဦးအလျားသည် ကနဦးစွမ်းရည်ထက် နည်းရမည် သို့မဟုတ် ညီမျှရမည်။",
  T_48_META_API_1519_P1_D: "စာရင်း၏ကနဦးစွမ်းရည်သည် ကနဦးအရှည်ထက် ကြီးသည် သို့မဟုတ် ညီမျှရပါမည်။ စွမ်းရည်ကို ဒိုင်းနမစ်ဖြင့် ချဲ့ထွင်နိုင်သော်လည်း ၎င်းသည် တည်ဆောက်ရာတွင် သင့်လျော်သောတန်ဖိုးကို သတ်မှတ်ရန် အကြံပြုထားသည်။",
  T_48_META_API_1519_R_D: "ဖန်တီးထားသောစာရင်း",
  T_48_META_API_1520_D: "စာရင်းတွင် သတ်မှတ်ထားသော ဒြပ်စင်များ ပါဝင်ခြင်း ရှိမရှိ စစ်ဆေးပါ။",
  T_48_META_API_1520_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1520_P1_D: "စစ်ဆေးရန်သတ်မှတ်ထားသောဒြပ်စင်",
  T_48_META_API_1520_R_D: "သတ်မှတ်ထားသော ဒြပ်စင်ပါ၀င်မလား။",
  T_48_META_API_1521_D: "ပစ်မှတ်စာရင်း၏အဆုံးတွင် အစိတ်အပိုင်းများစွာကို ပေါင်းထည့်ပါ။",
  T_48_META_API_1521_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1521_P1_D: "စာရင်းနောက်ဆက်တွဲ",
  T_48_META_API_1522_D: "သတ်မှတ်ထားသော အစိတ်အပိုင်းကို စာရင်းမှ ဖယ်ရှားသည်။",
  T_48_META_API_1522_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1522_P1_D: "ဖယ်ရှားရန်ဒြပ်စင်တန်ဖိုး",
  T_48_META_API_1523_D: "စာရင်းထဲရှိ ဒြပ်စင် ပထမပေါ်လာသည့် အနေအထားအညွှန်းကို ရယူပါ။",
  T_48_META_API_1523_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1523_P1_D: "ဒြပ်စင်တန်ဖိုး",
  T_48_META_API_1523_R_D: "တည်နေရာအညွှန်း",
  T_48_META_API_1524_D: "စာရင်းထဲရှိ ပစ်မှတ်ဒြပ်စင်မရှိလျှင် -1 ကို ပြန်ပေးသည်။",
  T_48_META_API_1524_P0_D: "ပစ်မှတ်စာရင်း",
  T_48_META_API_1524_P1_D: "ဒြပ်စင်တန်ဖိုး",
  T_48_META_API_1524_R_D: "တည်နေရာအညွှန်း",
  T_48_META_API_1525_D: "ထောင့်တစ်ခု၏ sine ကိုရှာပါ။",
  T_48_META_API_1525_P0_D: "ထောင့်၊ 360 သည် 360 ဒီဂရီကိုကိုယ်စားပြုသည်။",
  T_48_META_API_1525_R_D: "sine တန်ဖိုး",
  T_48_META_API_1526_D: "ထောင့်တစ်ခု၏ cosine ကိုရှာပါ။",
  T_48_META_API_1526_P0_D: "ထောင့်၊ 360 သည် 360 ဒီဂရီကိုကိုယ်စားပြုသည်။",
  T_48_META_API_1526_R_D: "ကိုsine",
  T_48_META_API_1527_D: "ထောင့်တစ်ခု၏ tangent ကိုရှာပါ။",
  T_48_META_API_1527_P0_D: "ထောင့်၊ 360 သည် 360 ဒီဂရီကိုကိုယ်စားပြုသည်။",
  T_48_META_API_1527_R_D: "tangent",
  T_48_META_API_1528_D: "ဒဿမ 255 တွင် ပွင့်လင်းမြင်သာမှုဖြင့် အရောင်တန်ဖိုးတစ်ခုတည်ဆောက်ပါ။ ပထမဦးစွာ ချန်နယ်ကို binary နံပါတ်အဖြစ်သို့ 8 bits တစ်ခုစီကို R, G, B ဖြင့် ကိုယ်စားပြုပြီး ပွင့်လင်းမြင်သာမှုအရ binary number ကို Int32 အမျိုးအစားအဖြစ်သို့ ပြောင်းပါ။ ပြန်ပေးပါ။",
  T_48_META_API_1528_P0_D: "အရောင်၏ အနီရောင်ချန်နယ်တန်ဖိုး၊ တန်ဖိုးအပိုင်းအခြားသည် [0,255] ဖြစ်ပြီး ၎င်းသည် အပိုင်းအခြားကိုကျော်လွန်ပါက၊ ၎င်းကို တရားဝင်တန်ဖိုးအဖြစ် ချိတ်ဆွဲမည်ဖြစ်သည်။",
  T_48_META_API_1528_P1_D: "အရောင်၏ အစိမ်းရောင်ချန်နယ်တန်ဖိုး၊ တန်ဖိုးအပိုင်းအခြားသည် [0,255] ဖြစ်ပြီး ၎င်းသည် အပိုင်းအခြားကိုကျော်လွန်ပါက၊ ၎င်းကို တရားဝင်တန်ဖိုးအဖြစ် ချိတ်ဆွဲမည်ဖြစ်သည်။",
  T_48_META_API_1528_P2_D: "အရောင်၏ အပြာရောင်ချန်နယ်တန်ဖိုး၊ တန်ဖိုးသည် [0,255] အပိုင်းအခြားထက်ကျော်လွန်ပါက၊ ၎င်းကို တရားဝင်တန်ဖိုးအဖြစ် ချိတ်ဆွဲမည်ဖြစ်သည်။",
  T_48_META_API_1528_R_D: "တည်ဆောက်ထားသော အရောင်တန်ဖိုး",
  T_48_META_API_1529_D: "ထောင့်ရရှိရန် arcsine လုပ်ဆောင်ချက်ကို လုပ်ဆောင်ပါ။",
  T_48_META_API_1529_P0_D: "arcsine လုပ်ဆောင်ချက်အတွက် တန်ဖိုး၊ တန်ဖိုးအပိုင်းအခြားသည် [-1,1] ဖြစ်သည်။",
  T_48_META_API_1529_R_D: "ထောင့်",
  T_48_META_API_1530_D: "ထောင့်ကိုရရှိရန် arc cosine လုပ်ဆောင်ချက်ကို လုပ်ဆောင်ပါ။",
  T_48_META_API_1530_P0_D: "arc cosine လုပ်ဆောင်ချက်အတွက် တန်ဖိုး၊ တန်ဖိုးအပိုင်းအခြားသည် [-1,1] ဖြစ်သည်။",
  T_48_META_API_1530_R_D: "ထောင့်",
  T_48_META_API_1531_D: "ထောင့်ကိုရရှိရန် artangent လုပ်ဆောင်ချက်ကို လုပ်ဆောင်ပါ။",
  T_48_META_API_1531_P0_D: "Arctangent လုပ်ဆောင်ချက်ကို လုပ်ဆောင်ရန် တန်ဖိုး",
  T_48_META_API_1531_R_D: "ထောင့်",
  T_48_META_API_1532_D: "ပစ်မှတ်သည် သတ်မှတ်ထားသော စက်လုံးအကွာအဝေးအတွင်းတွင် ရှိ၊ မရှိ ဆုံးဖြတ်ပါ။",
  T_48_META_API_1532_P0_D: "ပစ်မှတ်",
  T_48_META_API_1532_P1_D: "စက်လုံး၏ဗဟိုကို သတ်မှတ်သည်။",
  T_48_META_API_1532_P2_D: "စက်လုံး၏ အချင်းဝက်ကို သတ်မှတ်သည်။",
  T_48_META_API_1532_R_D: "စီရင်ချက်ရလဒ်",
  T_48_META_API_1533_D: "ပစ်မှတ်သည် သတ်မှတ်ထားသော ဆလင်ဒါအကွာအဝေးအတွင်းတွင် ရှိ၊ မရှိ ဆုံးဖြတ်ပါ။",
  T_48_META_API_1533_P0_D: "ပစ်မှတ်",
  T_48_META_API_1533_P1_D: "ဆလင်ဒါ၏ဗဟိုအမှတ်ကို သတ်မှတ်သည်။",
  T_48_META_API_1533_P2_D: "ဆလင်ဒါ၏ အပိုင်းလိုက် အချင်းဝက်ကို သတ်မှတ်သည်။",
  T_48_META_API_1533_P3_D: "ဆလင်ဒါ၏ အမြင့်ကို သတ်မှတ်သည်။",
  T_48_META_API_1533_P4_D: "ဆလင်ဒါ၏ဗဟိုပွိုင့်တစ်ဝိုက်ရှိ ဆလင်ဒါ၏လည်ပတ်မှုသုံးဖက်မြင် Euler ထောင့်ကို သတ်မှတ်သည်",
  T_48_META_API_1533_R_D: "စီရင်ချက်ရလဒ်",
  T_48_META_API_1534_D: "ပစ်မှတ်သည် သတ်မှတ်ထားသော cube အကွာအဝေးအတွင်းတွင် ရှိမရှိ ဆုံးဖြတ်ပါ။",
  T_48_META_API_1534_P0_D: "ပစ်မှတ်",
  T_48_META_API_1534_P1_D: "cube ၏ဗဟိုအမှတ်ကို သတ်မှတ်သည်။",
  T_48_META_API_1534_P2_D: "cube ၏ အရှည်ကို သတ်မှတ်သည်။",
  T_48_META_API_1534_P3_D: "cube ၏ အကျယ်ကို သတ်မှတ်သည်။",
  T_48_META_API_1534_P4_D: "cube ၏ အမြင့်ကို သတ်မှတ်သည်။",
  T_48_META_API_1534_P5_D: "ဗဟိုပွိုင့်တစ်ဝိုက်ရှိ Cube ၏ သုံးဖက်မြင်လှည့်ပတ်မှု Euler ထောင့်ကို သတ်မှတ်သည်။",
  T_48_META_API_1534_R_D: "စီရင်ချက်ရလဒ်",
  T_48_META_API_1535_D: "ပစ်မှတ်သည် သတ်မှတ်ထားသောကဏ္ဍဆလင်ဒါအကွာအဝေးအတွင်းတွင်ရှိမရှိ ဆုံးဖြတ်ပါ။",
  T_48_META_API_1535_P0_D: "ပစ်မှတ်",
  T_48_META_API_1535_P1_D: "ကဏ္ဍပုံသဏ္ဍာန် ဆလင်ဒါ၏ အလယ်ဗဟိုကို သတ်မှတ်သည်။",
  T_48_META_API_1535_P2_D: "ကဏ္ဍပုံသဏ္ဍာန် ဆလင်ဒါ၏ အလယ်အခြမ်းကို သတ်မှတ်သည်။",
  T_48_META_API_1535_P3_D: "စမ်းသပ်မထားသည့် ကဏ္ဍပုံသဏ္ဍာန် ဆလင်ဒါ၏ ဖြတ်ပိုင်းအချင်းဝက်အား စက်ဝိုင်း၏ဗဟိုအဖြစ် ဗဟိုအမှတ်ဖြင့်၊ အသေးစားကဏ္ဍပုံသဏ္ဌာန်ဆလင်ဒါဧရိယာအား စမ်းသပ်မည်မဟုတ်ပါ၊ သတ်မှတ်ထားသည့်ကဏ္ဍပုံသဏ္ဍာန်ဆလင်ဒါနှင့် ကွာခြားချက်သာလျှင် သေးငယ်သော ကဏ္ဍပုံသဏ္ဍာန် ဆောင်ပုဒ်ကို ရှာဖွ",
  T_48_META_API_1535_P4_D: "ကဏ္ဍဆလင်ဒါ၏ အမြင့်ကို သတ်မှတ်သည်။",
  T_48_META_API_1535_P5_D: "ထောက်လှမ်းရန်အတွက် ကဏ္ဍပုံသဏ္ဍာန် ဆလင်ဒါ၏ အပိုင်း၏ ဗဟိုထောင့်သည် 360 ထက် ကြီးပါက၊ ၎င်းသည် 0 ထက်နည်းပါက ထောက်လှမ်းမှုဧရိယာ 0 ဖြစ်လိမ့်မည်။",
  T_48_META_API_1535_P6_D: "ဗဟိုပွိုင့်တစ်ဝိုက်တွင် ကဏ္ဍဆလင်ဒါ၏ လည်ပတ်မှုသုံးဖက်မြင် Euler ထောင့်ကို သတ်မှတ်သည်",
  T_48_META_API_1535_R_D: "စီရင်ချက်ရလဒ်",
  T_48_META_API_1536_D: "ဂဏန်းနှစ်လုံး၏ တန်ဖိုးများကို နှိုင်းယှဉ်ပြီး ပိုကြီးသော တစ်လုံးကို ပြန်ပေးသည်။",
  T_48_META_API_1536_P0_D: "ซ้าย",
  T_48_META_API_1536_P1_D: "ขวา",
  T_48_META_API_1536_R_D: "ပိုကြီးတဲ့ အရေအတွက်",
  T_48_META_API_1537_D: "စာရင်းရှိ အများဆုံးတန်ဖိုးကို ပြန်ပေးသည်။",
  T_48_META_API_1537_P0_D: "ပစ်မှတ်စာရင်း၊ စာရင်းဒြပ်စင်အမျိုးအစားကို နံပါတ်အဖြစ်သာ လက်ခံသည်။",
  T_48_META_API_1537_P1_D: "နှိုင်းယှဉ်မှုရလဒ်များ စာရင်းတွင် ဂဏန်းမဟုတ်ပါက၊ နှိုင်းယှဥ်မှုပျက်သွားကာ အမှားကို ပြန်ပေးသည်။",
  T_48_META_API_1537_P2_D: "နှိုင်းယှဉ်မှုအောင်မြင်ပါက စာရင်းရှိ အကြီးဆုံးတန်ဖိုးကို ပြန်ပေးမည်ဖြစ်ပြီး နှိုင်းယှဉ်မှုမအောင်မြင်ပါက 0 ပြန်ပေးသည်။",
  T_48_META_API_1538_D: "ဂဏန်းနှစ်လုံး၏တန်ဖိုးများကို နှိုင်းယှဉ်ပြီး အသေးတစ်လုံးကို ပြန်ပေးသည်။",
  T_48_META_API_1538_P0_D: "ซ้าย",
  T_48_META_API_1538_P1_D: "ขวา",
  T_48_META_API_1538_R_D: "ပိုသေးငယ်တဲ့ နံပါတ်",
  T_48_META_API_1539_D: "စာရင်းရှိ အနည်းဆုံးတန်ဖိုးကို ပြန်ပေးသည်။",
  T_48_META_API_1539_P0_D: "ပစ်မှတ်စာရင်း၊ စာရင်းဒြပ်စင်အမျိုးအစားကို နံပါတ်အဖြစ်သာ လက်ခံသည်။",
  T_48_META_API_1539_P1_D: "နှိုင်းယှဉ်မှုရလဒ်များ စာရင်းတွင် ဂဏန်းမဟုတ်ပါက၊ နှိုင်းယှဥ်မှုပျက်သွားကာ အမှားကို ပြန်ပေးသည်။",
  T_48_META_API_1539_P2_D: "နှိုင်းယှဉ်မှုအောင်မြင်ပါက စာရင်းအတွင်းရှိ အသေးငယ်ဆုံးတန်ဖိုးကို ပြန်ပေးကာ နှိုင်းယှဉ်မှုမအောင်မြင်ပါက 0 ကို ပြန်ပေးသည်။",
  T_48_META_API_1540_D: "linear interpolation၊ စတင်တန်ဖိုးနှင့် ပစ်မှတ်တန်ဖိုးကြား အပြန်အလှန်ပေါင်းစပ်မှုတိုးတက်မှုအတွက် သက်ဆိုင်သည့်တန်ဖိုးကို ပြန်ပေးသည်၊ interpolation coefficient [0,1]",
  T_48_META_API_1540_P0_D: "ပေါင်းစည်းခြင်းတိုးတက်မှုသည် 0 ဖြစ်သောအခါ ဤတန်ဖိုးကို ပြန်ပေးသည်။",
  T_48_META_API_1540_P1_D: "linear interpolation ပစ်မှတ်တန်ဖိုး၊ interpolation တိုးတက်မှုသည် 1 ဖြစ်သောအခါ ဤတန်ဖိုးကို ပြန်ပေးသည်။",
  T_48_META_API_1540_P2_D: "ပေါင်းစည်းခြင်းတိုးတက်မှု၊ တန်ဖိုးအပိုင်းအခြား [0,1]၊ တန်ဖိုးသည် 0 ဖြစ်သောအခါ၊ စတင်တန်ဖိုးကို ပြန်ပေးသည်၊ တန်ဖိုးသည် 1 ဖြစ်သောအခါ၊ ပစ်မှတ်တန်ဖိုးကို ပြန်ပေးသည်၊ တန်ဖိုးသည် 0.5 ဖြစ်သောအခါ၊ ပျမ်းမျှတန်ဖိုးနှင့် ပစ်မှတ် တန်ဖိုးကို ပြန်ပေးတယ်။",
  T_48_META_API_1540_R_D: "linear interpolation return တန်ဖိုး",
  T_48_META_API_1541_D: "ပစ်မှတ်တန်ဖိုး၏ အကွာအဝေးကို ကန့်သတ်ပြီး ထည့်သွင်းမှုဘောင် သုံးခုအကြား အလယ်တန်ဖိုးကို ရယူရန် ၎င်း၏လုပ်ဆောင်ချက်မှာ ပစ်မှတ်တန်ဖိုးကို သတ်မှတ်ထားသည့် အတိုင်းအတာအထိ ကန့်သတ်ရန်ဖြစ်သည်။ ပစ်မှတ်တန်ဖိုးသည် အမြင့်ဆုံးတန်ဖိုးထက် ပိုကြီးသည်၊ အမြင့်ဆုံးတန်ဖိုးသည် အကွ",
  T_48_META_API_1541_P0_D: "ပစ်မှတ်တန်ဖိုး",
  T_48_META_API_1541_P1_D: "ကန့်သတ်ဘောင်၏ အနည်းဆုံးတန်ဖိုး",
  T_48_META_API_1541_P2_D: "ကန့်သတ်ဘောင်၏ အမြင့်ဆုံးတန်ဖိုး",
  T_48_META_API_1541_R_D: "ကန့်သတ်ပြီးနောက် တန်ဖိုးကို ပြန်ပေးပါ။",
  T_48_META_API_1542_D: "ပစ်မှတ်အရောင်၏ ချန်နယ်တန်ဖိုးများကို ရယူပါ။",
  T_48_META_API_1542_P0_D: "ပစ်မှတ်အရောင်",
  T_48_META_API_1542_P1_D: "အရောင်၏ R တန်ဖိုး၊ အပိုင်းအခြား [0, 255]",
  T_48_META_API_1542_P2_D: "အရောင်၏ G တန်ဖိုး၊ အပိုင်းအခြား [0၊ 255]",
  T_48_META_API_1542_P3_D: "အရောင်၏ B တန်ဖိုး၊ အပိုင်းအခြား [0, 255]",
  T_48_META_API_1542_P4_D: "အရောင်တန်ဖိုး၊ အပိုင်းအခြား [0၊ 255]",
  T_48_META_API_1543_D: "အညွှန်းကိန်း",
  T_48_META_API_1543_P0_D: "အခြေခံ",
  T_48_META_API_1543_P1_D: "အညွှန်း",
  T_48_META_API_1543_R_D: "တွက်ချက်မှုရလဒ်",
  T_48_META_API_1544_D: "လော့ဂရစ်သမ်လုပ်ဆောင်ချက်များ",
  T_48_META_API_1544_P0_D: "အခြေခံ",
  T_48_META_API_1544_P1_D: "နံပါတ်အစစ်",
  T_48_META_API_1544_R_D: "တွက်ချက်မှုရလဒ်",
  T_48_META_API_1545_D: "ဦးတည်ချက် vector ကို Euler ထောင့်",
  T_48_META_API_1545_P0_D: "ဦးတည်ချက် vector",
  T_48_META_API_1545_R_D: "Euler ဆိုတာပါပဲ။",
  T_48_META_API_1546_D: "Euler angle rotation direction vector",
  T_48_META_API_1546_P0_D: "Euler ဆိုတာပါပဲ။",
  T_48_META_API_1546_R_D: "ဦးတည်ချက် vector",
  T_48_META_API_1547_D: "ကိန်းပြည့်မှ ရေပေါ်အမှတ်အထိ",
  T_48_META_API_1547_P0_D: "ကိန်းပြည့်",
  T_48_META_API_1547_R_D: "floating point နံပါတ်",
  T_48_META_API_1548_D: "quaternion အရ ပစ်မှတ် vector ကို လှည့်ပါ။",
  T_48_META_API_1548_P0_D: "ပစ်မှတ် vector",
  T_48_META_API_1548_P1_D: "Quaternion ကိုလှည့်ပါ။",
  T_48_META_API_1548_R_D: "အလှည့်ကျ vector",
  T_48_META_API_1549_D: "ပစ်မှတ်နံပါတ်ကို စာကြောင်းအဖြစ် ပြောင်းပါ။",
  T_48_META_API_1549_P0_D: "ပစ်မှတ်နံပါတ်ကို စာကြောင်းတစ်ခုအဖြစ်သို့ ပြောင်းလဲရန်",
  T_48_META_API_1549_P1_D: "ဂဏန်းစာတန်းဖော်မတ်ကို ထုတ်ပါ။",
  T_48_META_API_1549_R_D: "ကြိုးတစ်ချောင်း",
  T_48_META_API_1598_D: "ဆာဗာအချိန်တံဆိပ်ကို ရယူပါ။",
  T_48_META_API_1598_R_D: "0:00:00 ဇန်နဝါရီ 1970 တွင် 0:00:00 ကတည်းက စက္ကန့်အရေအတွက်ကို ပြန်ပေးသည်။",
  T_48_META_API_1599_D: "ဆာဗာဧရိယာကိုရယူပါ။",
  T_48_META_API_1599_R_D: "ဒေသအတိုကောက် (BR, SAC, ID, NA, US, IND, SG, BD, VN, TH, ME, RU, EU, PK, TW) ကို ပြန်ပေးသည်",
  T_48_META_API_16_D: "သုံးစွဲသူအတွေ့အကြုံဒေတာခွဲခြမ်းစိတ်ဖြာမှုအတွက် စိတ်ကြိုက်အသုံးပြုသူခြေရာခံမှတ်တမ်းများ",
  T_48_META_API_16_P0_D: "ကစားသမားတွေကို အစီရင်ခံပါတယ်။",
  T_48_META_API_16_P1_D: "အစီရင်ခံမည့် နယ်ပယ်အမည်များစာရင်း",
  T_48_META_API_16_P2_D: "အစီရင်ခံရမည့် အကွက်တန်ဖိုးများစာရင်း",
  T_48_META_API_1601_D: "အဘိဓာန်ဖန်တီးပါ။",
  T_48_META_API_1601_R_D: "အဘိဓာန်ကို ဖန်တီးခဲ့သည်။",
  T_48_META_API_1602_D: "အဘိဓာန်ရှိ သတ်မှတ်ထားသော သော့နှင့် သက်ဆိုင်သော တန်ဖိုးကို ရယူပါ။",
  T_48_META_API_1602_P0_D: "ပစ်မှတ်အဘိဓာန်",
  T_48_META_API_1602_P1_D: "ခေါင်းစဉ်",
  T_48_META_API_1602_R_D: "နည်း",
  T_48_META_API_1603_D: "အဘိဓာန်ရှိ သတ်မှတ်ထားသော သော့နှင့် သက်ဆိုင်သော တန်ဖိုးကို သတ်မှတ်သည်။",
  T_48_META_API_1603_P0_D: "ပစ်မှတ်အဘိဓာန်",
  T_48_META_API_1603_P1_D: "ခေါင်းစဉ်",
  T_48_META_API_1603_P2_D: "နည်း",
  T_48_META_API_1604_D: "သတ်မှတ်ထားသော သော့-တန်ဖိုးအတွဲကို အဘိဓာန်မှ ဖယ်ရှားပါ။",
  T_48_META_API_1604_P0_D: "ပစ်မှတ်အဘိဓာန်",
  T_48_META_API_1604_P1_D: "ခေါင်းစဉ်",
  T_48_META_API_1605_D: "အဘိဓာန်ရှိ သော့-တန်ဖိုးအတွဲများအားလုံးကို ရှင်းလင်းပါ။",
  T_48_META_API_1605_P0_D: "ပစ်မှတ်အဘိဓာန်",
  T_48_META_API_1606_D: "အဘိဓာန်တွင် သော့-တန်ဖိုးအတွဲများ အရေအတွက်ကို ရယူပါ။",
  T_48_META_API_1606_P0_D: "ပစ်မှတ်အဘိဓာန်",
  T_48_META_API_1606_R_D: "Dictionary အရှည်",
  T_48_META_API_1607_D: "အဘိဓာန်တွင် သော့ရှိမရှိ ဆုံးဖြတ်ပါ။",
  T_48_META_API_1607_P0_D: "ပစ်မှတ်အဘိဓာန်",
  T_48_META_API_1607_P1_D: "ခေါင်းစဉ်",
  T_48_META_API_1607_R_D: "ရှိမရှိ",
  T_48_META_API_1608_D: "အဘိဓာန်၏သော့အားလုံးကို ရယူပြီး စာရင်းအဖြစ် ပြန်ပေးသည်။",
  T_48_META_API_1608_P0_D: "ပစ်မှတ်အဘိဓာန်",
  T_48_META_API_1608_R_D: "သော့တန်ဖိုးများစာရင်း",
  T_48_META_API_17_D: "ထောက်လှမ်းရန်အတွက် အကွက်ပုံသဏ္ဍာန်ရှိသော မျဉ်းသားရွေ့လျားမှုဧရိယာကို အသုံးပြုပြီး အနီးမှအဝေးသို့ လမ်းကြောင်းပေါ်ရှိ အရာအားလုံးကို ပြန်ပို့မည်ဆိုပါက ၎င်းတို့ကို ရှာဖွေတွေ့ရှိမည်မဟုတ်ပါ။ .",
  T_48_META_API_17_P0_D: "အကွက်ဧရိယာ၏ ထောင့်သုံးဘက်အလျား၏ ထက်ဝက်သည်သာ အပြုသဘောတန်ဖိုးများကို လက်ခံသည်။",
  T_48_META_API_17_P1_D: "အကွက်ဧရိယာ၏ဗဟိုအမှတ်",
  T_48_META_API_17_P2_D: "Box ဧရိယာ လည်ပတ်မှု",
  T_48_META_API_17_P3_D: "ဘောက်ထော်ဧရိယာ ခရီးသွားလမ်းညွှန်",
  T_48_META_API_17_P4_D: "ဘောက်စ်ဧရိယာ ခရီးအကွာအဝေးကိုသာ အပြုသဘောတန်ဖိုးများကို လက်ခံပါသည်။",
  T_48_META_API_17_P5_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများသာ စကင်ဖတ်ခြင်းတွင် ပါဝင်မည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ စကင်ဖတ်ခြင်းတွင် အလွှာအားလုံး ပါဝင်လိမ့်မည်",
  T_48_META_API_17_P6_D: "အစပျိုးမှုများကို သိရှိနိုင်ပါသလား။",
  T_48_META_API_17_P7_D: "hit entities စာရင်း",
  T_48_META_API_1700_D: "သတ်မှတ်ထားသော စာကြောင်းကို ကိန်းပြည့်အဖြစ် ပြောင်းပါ။",
  T_48_META_API_1700_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1700_P1_D: "ရလဒ် ကိန်းပြည့်",
  T_48_META_API_1700_P2_D: "ပြောင်းလဲခြင်း အောင်မြင်ပါသလား။",
  T_48_META_API_1701_D: "သတ်မှတ်ထားသော စာကြောင်းကို ရေပေါ်အမှတ်နံပါတ်သို့ ပြောင်းပါ။",
  T_48_META_API_1701_P0_D: "ပစ်မှတ်ကြိုး",
  T_48_META_API_1701_P1_D: "ရလဒ် မျှော",
  T_48_META_API_1701_P2_D: "ပြောင်းလဲခြင်း အောင်မြင်ပါသလား။",
  T_48_META_API_18_D: "ထောက်လှမ်းရန်အတွက် မျဉ်းဖြောင့်ရွေ့လျားနေသော စက်လုံးဝိုင်းဧရိယာကို အသုံးပြုပြီး စက်ဝိုင်းဧရိယာလမ်းကြောင်းတွင် ကြုံတွေ့ရသည့်အရာအားလုံးကို အနီးမှအဝေးသို့ ပြန်ပို့မည်ဆိုပါက ၎င်းတို့ကို လုံးပတ်ဧရိယာအတွင်း၌ တွေ့ရှိမည်မဟုတ်ပါ။",
  T_48_META_API_18_P0_D: "စက်ဝိုင်းဧရိယာ၏ အချင်းဝက်၊ အပြုသဘောတန်ဖိုးများကိုသာ လက်ခံသည်။",
  T_48_META_API_18_P1_D: "စက်ဝိုင်းဧရိယာ၏ဗဟိုအမှတ်",
  T_48_META_API_18_P2_D: "စက်ဝိုင်းဧရိယာ၏ ခရီးဦးတည်ချက်",
  T_48_META_API_18_P3_D: "လုံးပတ်ဧရိယာဖြင့် ခရီးအကွာအဝေးတွင်သာ အပြုသဘောတန်ဖိုးများကို လက်ခံသည်။",
  T_48_META_API_18_P4_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများသာ စကင်ဖတ်ခြင်းတွင် ပါဝင်မည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ စကင်ဖတ်ခြင်းတွင် အလွှာအားလုံး ပါဝင်လိမ့်မည်",
  T_48_META_API_18_P5_D: "အစပျိုးမှုများကို သိရှိနိုင်ပါသလား။",
  T_48_META_API_18_P6_D: "hit entities စာရင်း",
  T_48_META_API_19_D: "ထောက်လှမ်းရန်အတွက် linearly ရွေ့လျားနေသော capsule area ကိုသုံးပါ၊ နှင့် capsule area ၏လမ်းကြောင်းပေါ်ရှိအရာအားလုံးကို အနီးမှအဝေးသို့ ပြန်ပို့ပါက၊ ၎င်းတို့သည် capsule area အတွင်းတွင်ရှိနေပါက၊ ၎င်းတို့ကို တွေ့ရှိမည်မဟုတ်ပါ။",
  T_48_META_API_19_P0_D: "capsule ဧရိယာ၏ အစွန်းနှစ်ဖက်ရှိ hemispheres ၏ အချင်းဝက်သည် အပေါင်းတန်ဖိုးများကိုသာ လက်ခံသည်၊",
  T_48_META_API_19_P1_D: "ဆေးတောင့်ဧရိယာ၏အစွန်းနှစ်ဖက်ရှိ hemispheres ၏ဗဟိုများကြားရှိ အကွာအဝေးသည် ဤတန်ဖိုးသည် hemispheres ၏ အချင်းဝက်ထက် နှစ်ဆပိုနေရပါမည်။",
  T_48_META_API_19_P2_D: "ဆေးတောင့်ဧရိယာ၏ အလယ်ဗဟို",
  T_48_META_API_19_P3_D: "ဆေးတောင့်ဧရိယာ လှည့်ခြင်း။",
  T_48_META_API_19_P4_D: "capsule ဧရိယာ၏ခရီးသွားလမ်းညွှန်",
  T_48_META_API_19_P5_D: "ကက်စဉ်းအနီးတည်ထောင်ထားသောအကွာအဝေးကာလအားလုံးကိုယ်တိုင်သည်ပိုက်သောအနည်းငယ်ကိုယ်တိုင်သည်။",
  T_48_META_API_19_P6_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများသာ စကင်ဖတ်ခြင်းတွင် ပါဝင်မည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ စကင်ဖတ်ခြင်းတွင် အလွှာအားလုံး ပါဝင်လိမ့်မည်",
  T_48_META_API_19_P7_D: "အစပျိုးမှုများကို သိရှိနိုင်ပါသလား။",
  T_48_META_API_19_P8_D: "hit entities စာရင်း",
  T_48_META_API_2_D: "လက်ရှိဂိမ်းရှိ အသင်းအားလုံးကို ရယူပြီး အသင်းစာရင်းသို့ ပြန်သွားပါ။",
  T_48_META_API_2_R_D: "အသင်းလူစာရင်း",
  T_48_META_API_20_D: "ဘောက်ပုံသဏ္ဍာန်ဧရိယာအတွင်းရှိ အရာအားလုံးကို ရှာဖွေတွေ့ရှိရန်နှင့် ပြန်ပို့ရန်အတွက် ငုတ်တုတ်ပုံသဏ္ဍာန်ဧရိယာကို အသုံးပြုပါ။",
  T_48_META_API_20_P0_D: "အကွက်ဧရိယာ၏ ထောင့်သုံးဘက်အလျား၏ ထက်ဝက်သည်သာ အပြုသဘောတန်ဖိုးများကို လက်ခံသည်။",
  T_48_META_API_20_P1_D: "အကွက်ဧရိယာ၏ဗဟိုအမှတ်",
  T_48_META_API_20_P2_D: "Box ဧရိယာ လည်ပတ်မှု",
  T_48_META_API_20_P3_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများသာ စကင်ဖတ်ခြင်းတွင် ပါဝင်မည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ စကင်ဖတ်ခြင်းတွင် အလွှာအားလုံး ပါဝင်လိမ့်မည်",
  T_48_META_API_20_P4_D: "အစပျိုးမှုများကို သိရှိနိုင်ပါသလား။",
  T_48_META_API_20_P5_D: "hit entities စာရင်း",
  T_48_META_API_2000_D: "ရည်ညွှန်းချက်ကို သတ်မှတ်ရန်လိုအပ်သည့် ပစ်မှတ်အဖွဲ့အစည်း၏ attribute တန်ဖိုးကို သတ်မှတ်ပါ။",
  T_48_META_API_2000_P0_D: "ပစ်မှတ်",
  T_48_META_API_2000_P1_D: "ပစ်မှတ်တစ်ခု၏ အရည်အချင်းတစ်ခု",
  T_48_META_API_2000_P2_D: "ရည်မှန်းချက်ကို သတ်မှတ်သောအခါ လိုအပ်သော အမျိုးအစားနှင့် ကိုက်ညီရန် ပစ်မှတ်တန်ဖိုးသည် လိုအပ်သည်။",
  T_48_META_API_2000_P3_D: "လုပ်ဆောင်ချက်မုဒ်၊ အမျိုးအစားအားလုံးသည် assignment ကို ပံ့ပိုးပေးသည်၊ နှင့် ကိန်းဂဏာန်း အမျိုးအစားများသည် ကိုယ်တိုင်ပေါင်းထည့်ခြင်း၊ ကိုယ်တိုင်နုတ်ခြင်း၊ မိမိဘာသာ ပွားခြင်း၊ မိမိဘာသာ ပိုင်းခြားခြင်းနှင့် မိမိအကြွင်းမဲ့ တို့ကိုလည်း ပံ့ပိုးပေးပါသည်။",
  T_48_META_API_2001_D: "ပစ္စည်းတစ်ခု၏ အရည်အချင်းတန်ဖိုးကို ရယူပါ။",
  T_48_META_API_2001_P0_D: "ပစ်မှတ်",
  T_48_META_API_2001_P1_D: "အဖွဲ့အစည်း၏ ရည်ညွှန်းချက် ID",
  T_48_META_API_2001_R_D: "attribute တန်ဖိုး",
  T_48_META_API_2002: "Set Graph Property",
  T_48_META_API_2002_D: "script variable များကို သတ်မှတ်ပါ။",
  T_48_META_API_2002_P0_D: "ပစ်မှတ်",
  T_48_META_API_2002_P1: "Graph ID",
  T_48_META_API_2002_P1_D: "ပစ်မှတ် ဇာတ်ညွှန်း ID",
  T_48_META_API_2002_P2: "Property ID",
  T_48_META_API_2002_P2_D: "script တွင်သတ်မှတ်ထားသောအဖွဲ့ဝင် attribute ID",
  T_48_META_API_2002_P3: "Property Value",
  T_48_META_API_2002_P3_D: "ရည်မှန်းချက်ကို သတ်မှတ်သောအခါ လိုအပ်သော အမျိုးအစားနှင့် ကိုက်ညီရန် ပစ်မှတ်တန်ဖိုးသည် လိုအပ်သည်။",
  T_48_META_API_2002_P4_D: "လုပ်ဆောင်ချက်မုဒ်၊ အမျိုးအစားအားလုံးသည် assignment ကို ပံ့ပိုးပေးသည်၊ နှင့် ကိန်းဂဏာန်း အမျိုးအစားများသည် ကိုယ်တိုင်ပေါင်းထည့်ခြင်း၊ ကိုယ်တိုင်နုတ်ခြင်း၊ မိမိဘာသာ ပွားခြင်း၊ မိမိဘာသာ ပိုင်းခြားခြင်းနှင့် မိမိအကြွင်းမဲ့ တို့ကိုလည်း ပံ့ပိုးပေးပါသည်။",
  T_48_META_API_2003: "Get Graph Property",
  T_48_META_API_2003_D: "script variable များကို ရယူပါ။",
  T_48_META_API_2003_P0_D: "ပစ်မှတ်",
  T_48_META_API_2003_P1: "Graph ID",
  T_48_META_API_2003_P1_D: "ပစ်မှတ် ဇာတ်ညွှန်း ID",
  T_48_META_API_2003_P2: "Property ID",
  T_48_META_API_2003_P2_D: "ပစ်မှတ် ရည်ညွှန်းချက် ID",
  T_48_META_API_2003_R_D: "attribute တန်ဖိုး",
  T_48_META_API_2004_D: "local variable ကို သတ်မှတ်ပြီး အစပြုပါ။ local variable ၏ scope သည် declaration position မှ statement block ၏အဆုံးအထိဖြစ်သည်။",
  T_48_META_API_2004_P0_D: "ပြောင်းလဲနိုင်သောအမည်",
  T_48_META_API_2004_P1_D: "ပြောင်းလဲနိုင်သော ကနဦးတန်ဖိုး",
  T_48_META_API_2004_P2_D: "ပြောင်းလဲနိုင်သော ကြေငြာအမျိုးအစားကို တန်ဖိုးသတ်မှတ်သည့်အခါ၊ ၎င်းသည် ကြေညာထားသောအမျိုးအစားနှင့် ကိုက်ညီရန် လိုအပ်သည်။",
  T_48_META_API_2005_D: "Local variable တစ်ခု၏တန်ဖိုးကို သတ်မှတ်ပေးသည့် local variable တစ်ခု၏ scope သည် declaration position မှ statement block ၏အဆုံးအထိဖြစ်သည်။",
  T_48_META_API_2005_P0_D: "ပြောင်းလဲနိုင်သောအမည်",
  T_48_META_API_2005_P1: "Variable Value",
  T_48_META_API_2005_P1_D: "ပြောင်းလဲနိုင်သောတန်ဖိုး",
  T_48_META_API_2005_P2_D: "လုပ်ဆောင်ချက်မုဒ်၊ အမျိုးအစားအားလုံးသည် assignment ကို ပံ့ပိုးပေးသည်၊ နှင့် ကိန်းဂဏာန်း အမျိုးအစားများသည် ကိုယ်တိုင်ပေါင်းထည့်ခြင်း၊ ကိုယ်တိုင်နုတ်ခြင်း၊ မိမိဘာသာ ပွားခြင်း၊ မိမိဘာသာ ပိုင်းခြားခြင်းနှင့် မိမိအကြွင်းမဲ့ တို့ကိုလည်း ပံ့ပိုးပေးပါသည်။",
  T_48_META_API_2006: "Get Local Variable",
  T_48_META_API_2006_D: "local variable တစ်ခု၏တန်ဖိုးကို ရယူပါ။ local variable တစ်ခု၏ scope သည် declaration position မှ statement block ၏အဆုံးအထိဖြစ်သည်။",
  T_48_META_API_2006_P0: "Variable Name",
  T_48_META_API_2006_P0_D: "ပြောင်းလဲနိုင်သောအမည်",
  T_48_META_API_2006_R_D: "ပြောင်းလဲနိုင်သောတန်ဖိုး",
  T_48_META_API_2009: "Find and Invoke Global Custom API with Serial",
  T_48_META_API_2009_D: "စိတ်ကြိုက်လုပ်ဆောင်မှုတွင် စောင့်ဆိုင်းနေစဉ် ကမ္ဘာလုံးဆိုင်ရာ စိတ်ကြိုက်လုပ်ဆောင်ချက်ကို နံပါတ်စဉ်အတိုင်း ခေါ်ဆိုပါ။",
  T_48_META_API_2009_P0: "Graph ID",
  T_48_META_API_2009_P0_D: "စိတ်ကြိုက်လုပ်ဆောင်မှုတည်ရှိရာ Script ID",
  T_48_META_API_2009_P1: "Function ID",
  T_48_META_API_2009_P1_D: "စိတ်ကြိုက် function ID ဟုခေါ်သည်။",
  T_48_META_API_2009_P2_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်သို့ ကန့်သတ်ချက်များစာရင်း",
  T_48_META_API_2010: "Find and Invoke Global Custom API with Parallel",
  T_48_META_API_2010_D: "ကမ္ဘာလုံးဆိုင်ရာ စိတ်ကြိုက်လုပ်ဆောင်ချက်ကို တပြိုင်တည်းခေါ်ဆို၍ စိတ်ကြိုက်လုပ်ဆောင်မှုတွင် စောင့်ဆိုင်းခြင်းရှိမရှိ၊ ၎င်းသည် ခေါ်ဆိုမှုတည်နေရာသို့ ချက်ချင်းပြန်သွားကာ ဆက်လက်လုပ်ဆောင်မည်ဖြစ်သည်။",
  T_48_META_API_2010_P0: "Graph ID",
  T_48_META_API_2010_P0_D: "စိတ်ကြိုက်လုပ်ဆောင်မှုတည်ရှိရာ Script ID",
  T_48_META_API_2010_P1: "Function ID",
  T_48_META_API_2010_P1_D: "စိတ်ကြိုက် function ID ဟုခေါ်သည်။",
  T_48_META_API_2010_P2_D: "စိတ်ကြိုက်လုပ်ဆောင်ချက်သို့ ကန့်သတ်ချက်များစာရင်း",
  T_48_META_API_2013: "Set Self Graph Property",
  T_48_META_API_2013_D: "လက်ရှိ script အတွက် ကိန်းရှင်များကို သတ်မှတ်ပါ။",
  T_48_META_API_2013_P0: "Property ID",
  T_48_META_API_2013_P0_D: "ပစ်မှတ် ရည်ညွှန်းချက် ID",
  T_48_META_API_2013_P1: "Property Value",
  T_48_META_API_2013_P1_D: "ပစ်မှတ်တန်ဖိုး",
  T_48_META_API_2013_P2_D: "လုပ်ဆောင်ချက်မုဒ်၊ အမျိုးအစားအားလုံးသည် assignment ကို ပံ့ပိုးပေးသည်၊ နှင့် ကိန်းဂဏာန်း အမျိုးအစားများသည် ကိုယ်တိုင်ပေါင်းထည့်ခြင်း၊ ကိုယ်တိုင်နုတ်ခြင်း၊ မိမိဘာသာ ပွားခြင်း၊ မိမိဘာသာ ပိုင်းခြားခြင်းနှင့် မိမိအကြွင်းမဲ့ တို့ကိုလည်း ပံ့ပိုးပေးပါသည်။",
  T_48_META_API_2014: "Get Self Graph Property",
  T_48_META_API_2014_D: "လက်ရှိ script ၏ ကွဲလွဲချက်များကို ရယူပါ။",
  T_48_META_API_2014_P0: "Property ID",
  T_48_META_API_2014_P0_D: "ပစ်မှတ် ရည်ညွှန်းချက် ID",
  T_48_META_API_2014_R_D: "attribute တန်ဖိုး",
  T_48_META_API_21_D: "ထောက်လှမ်းရန်နှင့် လုံးပတ်ဧရိယာအတွင်းရှိ အရာအားလုံးကို ပြန်ပို့ရန်အတွက် ငုတ်လျှိုးနေသော စက်ဝိုင်းဧရိယာကို အသုံးပြုပါ။",
  T_48_META_API_21_P0_D: "စက်ဝိုင်းဧရိယာ၏ အချင်းဝက်၊ အပြုသဘောတန်ဖိုးများကိုသာ လက်ခံသည်။",
  T_48_META_API_21_P1_D: "စက်ဝိုင်းဧရိယာ၏ဗဟိုအမှတ်",
  T_48_META_API_21_P2_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများသာ စကင်ဖတ်ခြင်းတွင် ပါဝင်မည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ စကင်ဖတ်ခြင်းတွင် အလွှာအားလုံး ပါဝင်လိမ့်မည်",
  T_48_META_API_21_P3_D: "အစပျိုးမှုများကို သိရှိနိုင်ပါသလား။",
  T_48_META_API_21_P4_D: "hit entities စာရင်း",
  T_48_META_API_22_D: "ထောက်လှမ်းရန်နှင့် ဆေးတောင့်ဧရိယာအတွင်းရှိ အရာအားလုံးကို ပြန်ပို့ရန်အတွက် ငုတ်လျှိုးနေသော ဆေးတောင့်ဧရိယာကို အသုံးပြုပါ။",
  T_48_META_API_22_P0_D: "capsule ဧရိယာ၏ အစွန်းနှစ်ဖက်ရှိ hemispheres ၏ အချင်းဝက်သည် အပေါင်းတန်ဖိုးများကိုသာ လက်ခံသည်၊",
  T_48_META_API_22_P1_D: "ဆေးတောင့်ဧရိယာ၏အစွန်းနှစ်ဖက်ရှိ hemispheres ၏ဗဟိုများကြားရှိ အကွာအဝေးသည် ဤတန်ဖိုးသည် hemispheres ၏ အချင်းဝက်ထက် နှစ်ဆပိုနေရပါမည်။",
  T_48_META_API_22_P2_D: "ဆေးတောင့်ဧရိယာ၏ အလယ်ဗဟို",
  T_48_META_API_22_P3_D: "ဆေးတောင့်ဧရိယာ လှည့်ခြင်း။",
  T_48_META_API_22_P4_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများသာ စကင်ဖတ်ခြင်းတွင် ပါဝင်မည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ စကင်ဖတ်ခြင်းတွင် အလွှာအားလုံး ပါဝင်လိမ့်မည်",
  T_48_META_API_22_P5_D: "အစပျိုးမှုများကို သိရှိနိုင်ပါသလား။",
  T_48_META_API_22_P6_D: "hit entities စာရင်း",
  T_48_META_API_23_D: "ကစားသမားအတွက် အထူးပစ္စည်းအခြေအနေကို သတ်မှတ်ပါ။",
  T_48_META_API_23_P0_D: "ကစားသမား",
  T_48_META_API_23_P1_D: "ပစ္စည်း ID",
  T_48_META_API_23_P2_D: "ဤအရာကိုဖွင့်ရန်ရှိမရှိ",
  T_48_META_API_23_P3_D: "အထူးပစ္စည်း entity",
  T_48_META_API_24_D: "ရုပ်ပိုင်းဆိုင်ရာ အရာဝတ္ထုဖြစ်ရမည်၊ ပစ်မှတ်သို့ အင်အားတစ်ခု သက်ရောက်ပါ။",
  T_48_META_API_24_P0_D: "ပစ်မှတ်ရုပ်ပိုင်းဆိုင်ရာအရာဝတ္ထု",
  T_48_META_API_24_P1_D: "force vector",
  T_48_META_API_24_P2_D: "အင်အားအမျိုးအစား",
  T_48_META_API_25_D: "တစ်ချိန်ကျရင် အင်အားတစ်ခုကို တစ်ကြိမ် အသုံးချပါ၊ ပစ်မှတ်ဟာ တောင့်တင်းတဲ့ ခန္ဓာကိုယ် ဖြစ်ရမယ်။",
  T_48_META_API_25_P0_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို ပစ်မှတ်ထား",
  T_48_META_API_25_P1_D: "force vector",
  T_48_META_API_25_P2_D: "အတင်းအကြပ် လျှောက်ထားသည့် အနေအထား",
  T_48_META_API_25_P3_D: "အင်အားအမျိုးအစား",
  T_48_META_API_26_D: "တောင့်တင်းသောကိုယ်ထည်ဖြစ်ရမည့် ပစ်မှတ်သို့ torque ကို အသုံးချပါ။",
  T_48_META_API_26_P0_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို ပစ်မှတ်ထား",
  T_48_META_API_26_P1_D: "Torque",
  T_48_META_API_26_P2_D: "အတင်းရိုက်သည်။",
  T_48_META_API_27_D: "ပစ်မှတ်အား တောင့်တင်းသော ခန္ဓာကိုယ်အား သတ်မှတ်ထားသော အနေအထားသို့ ရွှေ့ပါ။",
  T_48_META_API_27_P0_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို ပစ်မှတ်ထား",
  T_48_META_API_27_P1_D: "တည်နေရာကိုသတ်မှတ်ပါ။",
  T_48_META_API_28_D: "ပစ်မှတ်ကို လှည့်၍ တောင့်တင်းသော ခန္ဓာကိုယ်၊",
  T_48_META_API_28_P0_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို ပစ်မှတ်ထား",
  T_48_META_API_28_P1_D: "Quaternion ကိုလှည့်ပါ။",
  T_48_META_API_29_D: "ပေါင်းစပ်ထားသော လှုပ်ရှားမှုကို ဖန်တီးပါ၊ နှင့် ပစ်မှတ်အဖွဲ့အစည်း၏ သတ်မှတ်ထားသော အရည်အချင်းများသည် ဆက်တင်များနှင့်အညီ ချောမွေ့စွာ ရွေ့လျားမည်ဖြစ်သည်။",
  T_48_META_API_29_P0_D: "ပစ်မှတ်",
  T_48_META_API_29_P1_D: "ပြောင်းလဲရန် လိုအပ်သော အရည်အချင်း ID",
  T_48_META_API_29_P2_D: "attribute စတင်တန်ဖိုး",
  T_48_META_API_29_P3_D: "attribute အဆုံးတန်ဖိုး",
  T_48_META_API_29_P4_D: `တစ်ခုတည်း၊ သံသရာနှင့် အပြန်အလှန်အားဖြင့် သင်ရွေးချယ်နိုင်သည်။ 
Loop ဆိုသည်မှာ ရွေ့လျားမှုတစ်ခုစီကို ပြီးမြောက်ပြီးနောက်၊ အကြောင်းအရာသည် စတင်တန်ဖိုးမှ ထပ်မံရွေ့လျားမည်ဖြစ်သည်။ အပြန်အလှန်အားဖြင့် ဆိုလိုသည်မှာ စတင်တန်ဖိုးမှ ပစ်မှတ်တန်ဖိုးသို့ ရွေ့လျားမှုပြီ`,
  T_48_META_API_29_P5_D: "Bezier မျဉ်းကွေးထိန်းချုပ်မှုအမှတ်",
  T_48_META_API_29_P6_D: "ပြောင်းလဲမှုတစ်ခု၏ကြာချိန်၊ မီလီစက္ကန့်အတွင်း",
  T_48_META_API_29_P7_D: "ပေါင်းစပ်ထားသော လှုပ်ရှားမှုကို ဖန်တီးထားသည်။",
  T_48_META_API_29_P8_D: "ဖန်တီးပြီးနောက် အလိုအလျောက် စတင်ကစားမလား။",
  T_48_META_API_3_D: "ဂိမ်းကို ပစ်မှတ်အဆင့်သို့ ပြောင်းပါ၊ အဝိုင်းသည် အထူးအဆင့်တစ်ခုဖြစ်သည်။ အလှည့်တစ်ခုအတွင်း အဆင့်တစ်ခုသို့ ပြောင်းသောအခါ အလှည့်အပြောင်းသည် 0 ဖြစ်သည်။",
  T_48_META_API_3_P0_D: "ပစ်မှတ်အဝိုင်း သို့မဟုတ် အဆင့်၏ အညွှန်း",
  T_48_META_API_30_D: "ပစ်မှတ်ကစားသမားအား သတ်မှတ်ထားသောယာဉ်သို့ ဝင်ရောက်ရန် အတင်းအကြပ်ပြုလုပ်ပါ။",
  T_48_META_API_30_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_30_P1_D: "ယာဉ်အဖွဲ့အစည်း",
  T_48_META_API_30_P2_D: "ထိုင်ခုံနံပါတ်",
  T_48_META_API_30_P3_D: "ကစားသမားကို ယာဉ်ထဲသို့ အောင်မြင်စွာ ဝင်ရောက်ခွင့်ပြုခြင်း ရှိ၊ မရှိ၊",
  T_48_META_API_3001_D: "ပစ်မှတ်ကစားသမားသည် အရာများကို လွှတ်ချစေသည်။",
  T_48_META_API_3001_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3001_P1_D: "ကုသိုလ်ကံ ဘဘ",
  T_48_META_API_3002_D: "အပြည့်အဝမသိမ်းပိုက်ရသေးသော လက်ရှိရရှိနိုင်သည့် ကျပန်းပေါက်အမှတ်အတွင်း ရရှိနိုင်သော သြဒီနိတ်များကို ရယူပါ (အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ GetRandomSpawnPosition ကိုသုံးပါ)",
  T_48_META_API_3002_P0_D: "သားပေါက်ဧရိယာသတ်မှတ်ရန် လိုအပ်သော ကစားသမားများ",
  T_48_META_API_3002_R_D: "ကျပန်းသတ်မှတ်ထားသော ကျပန်းအမှတ် သြဒိနိတ်များ",
  T_48_META_API_3003_D: "ကစားသမား၏ သတ်မှတ်ထားသော အမှတ်အမျိုးအစား၏ စုစုပေါင်းရမှတ်တန်ဖိုးကို ရယူပါ။",
  T_48_META_API_3003_P0_D: "ကစားသမား",
  T_48_META_API_3003_P1_D: "အမှတ်အမျိုးအစား",
  T_48_META_API_3003_R_D: "အမှတ်တန်ဖိုး",
  T_48_META_API_3004_D: "ကစားသမားသတ်မှတ်ထားသော အမှတ်အမျိုးအစားအတွက် အဝိုင်းအမှတ်တန်ဖိုးကို သတ်မှတ်ပါ။",
  T_48_META_API_3004_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_3004_P1_D: "အမှတ်အမျိုးအစား",
  T_48_META_API_3004_P2_D: "အမှတ်တန်ဖိုး",
  T_48_META_API_3005_D: "အဖွဲ့အတွက် သတ်မှတ်ထားသော အမှတ်အမျိုးအစား၏ စုစုပေါင်းရမှတ်တန်ဖိုးကို ရယူပါ။",
  T_48_META_API_3005_P0_D: "အသင်းဘဘ",
  T_48_META_API_3005_P1_D: "အမှတ်အမျိုးအစား",
  T_48_META_API_3005_R_D: "အမှတ်တန်ဖိုး",
  T_48_META_API_3006_D: "အသင်း၏ သတ်မှတ်ထားသော အမှတ်အမျိုးအစားအတွက် အဝိုင်းအမှတ်တန်ဖိုးကို သတ်မှတ်ပါ။",
  T_48_META_API_3006_P0_D: "အသင်းဘဘ",
  T_48_META_API_3006_P1_D: "အမှတ်အမျိုးအစား",
  T_48_META_API_3006_P2_D: "အမှတ်တန်ဖိုး",
  T_48_META_API_3007_D: "သတ်မှတ်ထားသော အဝိုင်းနှင့် အမှတ်အမျိုးအစားအတွက် ကစားသမား၏အမှတ်ကို ရယူပါ။",
  T_48_META_API_3007_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_3007_P1_D: "အဝိုင်းအညွှန်း",
  T_48_META_API_3007_P2_D: "အမှတ်အမျိုးအစား",
  T_48_META_API_3007_R_D: "အမှတ်တန်ဖိုး",
  T_48_META_API_3008_D: "သတ်မှတ်ထားသော အဝိုင်းနှင့် အမှတ်အမျိုးအစားအတွက် အသင်း၏အမှတ်များကို ရယူပါ။",
  T_48_META_API_3008_P0_D: "အသင်းဘဘ",
  T_48_META_API_3008_P1_D: "အဝိုင်းအညွှန်း",
  T_48_META_API_3008_P2_D: "အမှတ်အမျိုးအစား",
  T_48_META_API_3008_R_D: "အမှတ်တန်ဖိုး",
  T_48_META_API_3009_D: "ကစားသမား၏ စုစုပေါင်းဂိမ်းအဆင့်ကို ရယူပါ။",
  T_48_META_API_3009_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_3009_R_D: "အဆင့်သတ်မှတ်ချက်",
  T_48_META_API_3011_D: "အသင်း၏ ဂိမ်းအားလုံး၏ အဆင့်ကို ရယူပါ။",
  T_48_META_API_3011_P0_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_3011_R_D: "အဆင့်သတ်မှတ်ချက်",
  T_48_META_API_3013_D: "ကစားသမား၏ သတ်မှတ်ထားသော ပတ်ပတ်လည် အဆင့်ကို ရယူပါ။",
  T_48_META_API_3013_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_3013_P1_D: "အဝိုင်းအညွှန်း",
  T_48_META_API_3013_R_D: "အဆင့်သတ်မှတ်ချက်",
  T_48_META_API_3014_D: "အသင်း၏ သတ်မှတ်ထားသော အဆင့်သတ်မှတ်ချက်ကို ရယူပါ။",
  T_48_META_API_3014_P0_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_3014_P1_D: "အဝိုင်းအညွှန်း",
  T_48_META_API_3014_R_D: "အဆင့်သတ်မှတ်ချက်",
  T_48_META_API_3015_D: "ပစ်မှတ်အဖွဲ့အစည်း၏ ပိုက်ဆံအိတ်ကို ရယူပါ။",
  T_48_META_API_3015_P0_D: "ပစ်မှတ်",
  T_48_META_API_3015_P1_D: "ပိုက်ဆံအိတ်ရှိပါသလား။",
  T_48_META_API_3015_P2_D: "ပိုက်ဆံအိတ် entity ကို ရယူခဲ့သည်။",
  T_48_META_API_3016_D: "ပစ်မှတ်ကစားသမားအတွက် ပိုက်ဆံအိတ်တစ်ခုဖန်တီးပါ။",
  T_48_META_API_3016_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3016_P1_D: "ပိုက်ဆံအိတ်ပိုင်ရှင်က ပိုက်ဆံအိတ်နဲ့ ချိတ်ထားတယ်။",
  T_48_META_API_3016_P2_D: "ပိုက်ဆံအိတ် ဘဘ",
  T_48_META_API_3017_D: "သတ်မှတ်ထားသော ပိုက်ဆံအိတ်သို့ ငွေကြေးထည့်ပါ။",
  T_48_META_API_3017_P0_D: "ပစ်မှတ်ပိုက်ဆံအိတ်",
  T_48_META_API_3017_P1_D: "ထည့်ထားသော ငွေကြေးအမျိုးအစားများ",
  T_48_META_API_3017_P2_D: "ငွေကြေးပမာဏ တိုးလာသည်။",
  T_48_META_API_3018_D: "သတ်မှတ်ထားသော ပိုက်ဆံအိတ်အတွက် ငွေကြေးကို လျှော့ပါ။",
  T_48_META_API_3018_P0_D: "ပစ်မှတ်ပိုက်ဆံအိတ်",
  T_48_META_API_3018_P1_D: "လျှော့ချထားသော ငွေကြေးအမျိုးအစားများ",
  T_48_META_API_3018_P2_D: "ငွေပမာဏကို လျှော့ချခဲ့သည်။",
  T_48_META_API_3019_D: "ပိုက်ဆံအိတ်တစ်ခုမှ အခြားငွေကြေးကို လွှဲပြောင်းပါ။",
  T_48_META_API_3019_P0_D: "ငွေကြေးလွှဲပြောင်းရန် ပိုက်ဆံအိတ်",
  T_48_META_API_3019_P1_D: "လွှဲပြောင်းသည့်ငွေကြေးအမျိုးအစား",
  T_48_META_API_3019_P2_D: "လွှဲပြောင်းသည့်ငွေကြေးပမာဏ",
  T_48_META_API_3019_P3_D: "ငွေကြေးလွှဲပြောင်းရန် ပိုက်ဆံအိတ်",
  T_48_META_API_3020_D: "သတ်မှတ်ထားသော ပိုက်ဆံအိတ်တွင် သတ်မှတ်ထားသော ငွေကြေးအမျိုးအစား၏ ပမာဏကို ရယူပါ။",
  T_48_META_API_3020_P0_D: "ပစ်မှတ်ပိုက်ဆံအိတ်",
  T_48_META_API_3020_P1_D: "Query ငွေကြေးအမျိုးအစား",
  T_48_META_API_3020_R_D: "ငွေကြေးပမာဏ",
  T_48_META_API_3021_D: "သတ်မှတ်ထားသော ပိုက်ဆံအိတ်တွင် သတ်မှတ်ထားသော ငွေကြေးအမျိုးအစား၏ အကြောင်းအရာကို ရယူပါ။",
  T_48_META_API_3021_P0_D: "ပစ်မှတ်ပိုက်ဆံအိတ်",
  T_48_META_API_3021_P1_D: "Query ငွေကြေးအမျိုးအစား",
  T_48_META_API_3021_R_D: "ငွေကြေးအဖွဲ့အစည်း",
  T_48_META_API_3022_D: "ဂိမ်းရှိစတိုးဆိုင်အားလုံးကို ရယူပါ၊ စာရင်းအဖြစ် ပြန်ပေးလိုက်ပါ။",
  T_48_META_API_3022_R_D: "Store entity စာရင်း",
  T_48_META_API_3023_D: "ပစ်မှတ်ကစားသမား၏အသွင်အပြင်ကို သတ်မှတ်ထားသော မြင်ကွင်းအရာဝတ္တု၏အသွင်အပြင်ဖြင့် အစားထိုးပါ။",
  T_48_META_API_3023_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3023_P1_D: "အစားထိုးပစ်မှတ် မြင်ကွင်း အရာဝတ္ထု",
  T_48_META_API_3023_P2_D: "အစားထိုးပြီးနောက် ဖန်တီးထားသော ကစားသမားအသွင်ပြောင်းသည့် အစိတ်အပိုင်းကို ရုပ်ဖျက်ပါ။",
  T_48_META_API_3024_D: "ကစားသမား၏ ရုပ်ဖျက်မှုအခြေအနေကို ပယ်ဖျက်ပါ။",
  T_48_META_API_3024_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3025_D: "ပစ်မှတ်ကစားသမားတွင် အခင်းအကျင်းတစ်ခု၏ကိုယ်ပွားတစ်ခု ဖန်တီးပါ။",
  T_48_META_API_3025_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3025_P1_D: "ကိုယ်ပွားရုပ်ပုံများအတွက် အသုံးပြုသည့် မြင်ကွင်းတစ်ခု",
  T_48_META_API_3025_P2_D: "ကိုယ်ပွားအဖွဲ့အစည်းကို ဖန်တီးခဲ့သည်။",
  T_48_META_API_3026_D: "ကစားသမား၏ ရုပ်ဖျက်ထားသော အဖွဲ့အစည်းကို ရယူပါ။",
  T_48_META_API_3026_P0_D: "ကစားသမား",
  T_48_META_API_3026_R_D: "ဘာညာ ဘဘ",
  T_48_META_API_3027_D: "အညွှန်းအပေါ်အခြေခံ၍ ချတ်ချန်နယ်အကြောင်းအရာကို ရယူပါ။",
  T_48_META_API_3027_P0_D: "ချတ်ချန်နယ်အညွှန်းကိန်း၊ အပိုင်းအခြား [1,8]",
  T_48_META_API_3027_R_D: "ချတ်ချန်နယ် entity",
  T_48_META_API_3028_D: "သတ်မှတ်ထားသော ပလေယာလက်ရှိတည်ရှိရာ ချတ်ချန်နယ်ကို ရယူပါ။",
  T_48_META_API_3028_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3028_R_D: "ချတ်ချန်နယ် entity",
  T_48_META_API_3029_D: "ကစားသမားအား သတ်မှတ်ထားသော ချတ်ချန်နယ်တွင် ပါဝင်ခွင့်ပေးပါ။",
  T_48_META_API_3029_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3029_P1_D: "ချတ်ချန်နယ် entity",
  T_48_META_API_3030_D: "ပလေယာသည် လက်ရှိချန်နယ်မှ ထွက်ပြီးနောက် မည်သည့် ချတ်ချန်နယ်တွင်မှ မပါဝင်နိုင်သည့် အခြေအနေတွင် ရှိနေသည်။",
  T_48_META_API_3030_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3031_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_3031_P0_D: "ချန်နယ်တွင် ကစားသမားများမရှိသည့်အခါ ချတ်ချန်နယ်တွင် အလွတ်ဖြစ်သည်။",
  T_48_META_API_3032_D: "ကစားသမား၏ အပြုအမူအခြေအနေကို သတ်မှတ်ပါ။",
  T_48_META_API_3032_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3032_P1_D: "ကစားသမား အပြုအမူ အမျိုးအစား",
  T_48_META_API_3032_P2_D: `ဖွင့်ထားသည်- HUD ခလုတ်တစ်ခုရှိပြီး ပုံမှန်အတိုင်းအသုံးပြုနိုင်သည်
ပိတ်ထားသည်- HUD ခလုတ်ကို ပိတ်ထားပြီး အပြုအမူဆိုင်ရာ အခြေအနေအား တက်ကြွစွာ သို့မဟုတ် တက်ကြွစွာ မထည့်နိုင်ပါ
Shield- HUD ခလုတ်ကို ဝှက်ထားပြီး အပြုအမူဆိုင်ရာ အခြေအနေသို့ တက်ကြွစွာ မဝင်နိုင်သေ`,
  T_48_META_API_3033_D: "ကစားသမားသည် သတ်မှတ်ထားသော မြင်ကွင်းအရာဝတ္တုအဖြစ် ပြောင်းလဲသည်။",
  T_48_META_API_3033_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3033_P1_D: "အရာဝတ္ထုအဖြစ်အသွင်ပြောင်းရန်",
  T_48_META_API_3033_P2_D: "အသွင်ပြောင်းပြီးနောက် ဖန်တီးထားသော အရာ",
  T_48_META_API_3034_D: "ကစားသမားများသည် ၎င်းတို့ကိုယ်တိုင် ကိုယ်ပွားဖန်တီးကြသည်။",
  T_48_META_API_3034_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3034_P1_D: "ကိုယ်ပွားအဖွဲ့အစည်းကို ဖန်တီးခဲ့သည်။",
  T_48_META_API_3035_D: "စတိုးဆိုင်၏နောက်ထပ်အဆင့်မှာ စင်များဖြစ်သည့် စိတ်ကြိုက်စတိုးဆိုင်တစ်ခုကို ဖန်တီးပါ။",
  T_48_META_API_3035_P0_D: "စတိုးဆိုင်ကို ဖန်တီးထားသည်။",
  T_48_META_API_3036_D: "စိတ်ကြိုက်စင်တစ်ခု ဖန်တီးပါ။",
  T_48_META_API_3036_P0_D: "စင်တစ်ခု ဖန်တီးထားသည်။",
  T_48_META_API_3037_D: "ပစ္စည်းများထည့်နိုင်သော စိတ်ကြိုက်ထုတ်ကုန်တစ်ခုကို ဖန်တီးပါ။",
  T_48_META_API_3037_P0_D: "ထုတ်ကုန်တစ်ခု ဖန်တီးထားသည်။",
  T_48_META_API_3038_D: "ထုတ်ကုန်တစ်ခုသို့ ပစ္စည်းများထည့်ရန် အကြိမ်များစွာ အသုံးပြုခြင်းဖြင့် ထုတ်ကုန်တစ်ခုသို့ ထည့်နိုင်သည်။",
  T_48_META_API_3038_P0_D: "ကုန်စည်ဒိုင်",
  T_48_META_API_3038_P1_D: "ထည့်ရမည့်အရာများ",
  T_48_META_API_3038_P2_D: "ပစ္စည်း အရေအတွက်",
  T_48_META_API_3039_D: "Jailbreak ဆုလာဘ်များပေးပါ။",
  T_48_META_API_3039_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_3039_P1_D: "ပမာဏ",
  T_48_META_API_3039_P2_D: "တကယ့်ပိုက်ဆံ",
  T_48_META_API_3040_D: "jailbreak လုပ်ဆောင်စရာများကို အပ်ဒိတ်လုပ်ထားသည်။",
  T_48_META_API_3040_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_3040_P1_D: "Task ID",
  T_48_META_API_3040_P2_D: "တန်ဖိုး",
  T_48_META_API_3041_D: "ကျပန်း spawn point သြဒိနိတ်များကို ရယူခြင်းသည် အပြည့်အဝ မသိမ်းပိုက်နိုင်သော ရရှိနိုင်သော spawn point များမှ ကျပန်းသာ ဖြစ်ပါမည်။",
  T_48_META_API_3041_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3041_R_D: "အခြေအနေများနှင့်ကိုက်ညီသော မွေးရာပါအမှတ်မရှိလျှင် ကျပန်းမွေးဖွားအမှတ် သြဒိနိတ်များ (0၊ 0၊ 0) နှင့် နီးစပ်သော အနေအထားကို ပြန်ပေးပါမည်။",
  T_48_META_API_3042_D: "jailbreak mini-game မှထွက်ပါ။",
  T_48_META_API_3042_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_3042_P1_D: "Task ID",
  T_48_META_API_3043_D: "jailbreak props များအပေါ်အခြေခံသည်။",
  T_48_META_API_3043_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_3043_P1_D: "Prop အမျိုးအစား",
  T_48_META_API_3043_P2_D: "Prop ID",
  T_48_META_API_31_D: "နှိုင်းယှဥ်သော ကိုယ်ပိုင်လှုပ်ရှားမှုကို ဖန်တီးပါ၊ နှင့် ပစ်မှတ်သည် အကြိမ်တိုင်း ၎င်း၏ လက်ရှိ ရည်ညွှန်းချက်တန်ဖိုးနှင့် ဆက်စပ်မှု ပြောင်းလဲပါသည်။",
  T_48_META_API_31_P0_D: "ပစ်မှတ်",
  T_48_META_API_31_P1_D: "ရွေ့လျားပြောင်းလဲမှုများ လိုအပ်သည့် အရည်အချင်းများ",
  T_48_META_API_31_P2_D: "ရွေ့လျားမှုအလိုက် ပြောင်းလဲမှုပမာဏ",
  T_48_META_API_31_P3_D: "Bezier မျဉ်းကွေးထိန်းချုပ်မှုအမှတ်",
  T_48_META_API_31_P4_D: `Single- ရည်ညွှန်းချက်သည် Delta ပမာဏကို ပြောင်းလဲသည့်အခါ ရပ်ပါ
Loop- လှုပ်ရှားမှုကို ပြန်လုပ်ပါ၊ ရည်ညွှန်းချက်က Delta ပမာဏကို ပြောင်းတိုင်း`,
  T_48_META_API_31_P5_D: "ပြောင်းလဲမှုတစ်ခု၏ကြာချိန်၊ မီလီစက္ကန့်အတွင်း",
  T_48_META_API_31_P6_D: "ဖန်တီးထားသော ဆွေမျိုးကိုယ်တိုင် ရွေ့လျားနိုင်သော အရာ",
  T_48_META_API_31_P7_D: "ဖန်တီးပြီးနောက် အလိုအလျောက် စတင်ကစားမလား။",
  T_48_META_API_3100_D: "ပစ်မှတ်သည် သတ်မှတ်ထားသော အခြေအနေတွင် ကာတွန်းကို ပြသသည်။",
  T_48_META_API_3100_P0_D: "အန်နီမေးရှင်းကစားရန် ကာတွန်းထိန်းချုပ်ကိရိယာဖြင့် တပ်ဆင်နိုင်သည့် အရာတစ်ခု",
  T_48_META_API_3100_P1_D: "ကာတွန်းထိန်းချုပ်ကိရိယာ၏ သတ်မှတ်ထားသော အခြေအနေ",
  T_48_META_API_3100_P2_D: "အန်နီမေးရှင်း ပြန်ဖွင့်ခြင်း အရှိန်မြှင့်ခြင်း။",
  T_48_META_API_3100_P3_D: "Loop အမျိုးအစား၊ အန်နီမေးရှင်း၏ မူရင်းယုတ္တိကို ထိန်းထားနိုင်သည်၊ ၎င်းကို တစ်ကြိမ်သာ ကစားနိုင်သည် သို့မဟုတ် ၎င်းကို ကွင်းဆက်တွင် ကစားနိုင်သည်။",
  T_48_META_API_3101_D: "ဇာတ်ကောင်ကာတွန်းကိုဖွင့်ပြီး စိတ်ကြိုက်ကာတွန်းအရင်းအမြစ်များကို ပံ့ပိုးပါ။",
  T_48_META_API_3101_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3101_P1_D: "စိတ်ကြိုက် ကာတွန်း အရင်းအမြစ် ID",
  T_48_META_API_3101_P2_D: "loop ပတ်မလား။",
  T_48_META_API_3102_D: "သတ်မှတ်ထားသော ကစားသမား၏ ဇာတ်ကောင်ရင်းမြစ်များကို သတ်မှတ်ပါ။",
  T_48_META_API_3102_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3102_P1_D: "စိတ်ကြိုက်အခန်းကဏ္ဍ အရင်းအမြစ် ID",
  T_48_META_API_3109_D: "အဆုံးမှတ်သို့ ချောမွေ့စွာရွှေ့မည့် ဘေးကင်းသောနေရာကို ဖွင့်ပါ။",
  T_48_META_API_3109_P0_D: "လုံခြုံဇုန်၏စတင်အနေအထား",
  T_48_META_API_3109_P1_D: "ဘေးကင်းရေးဇုန်အဆုံး အနေအထား",
  T_48_META_API_3109_P2_D: "ဘေးကင်းဇုန်၏ ကနဦးအချင်းဝက်",
  T_48_META_API_3109_P3_D: "ဘေးကင်းဇုန်၏နောက်ဆုံးအချင်းဝက်",
  T_48_META_API_3109_P4_D: "ဘေးကင်းဇုန်သည် ၎င်း၏နောက်ဆုံးအခြေအနေသို့ရောက်ရှိရန် စက္ကန့်ပိုင်းအတွင်း လိုအပ်သည်။",
  T_48_META_API_3109_P5_D: "ဘေးကင်းဇုန်အပြင်ဘက် တစ်စက္ကန့်လျှင် ပျက်စီးဆုံးရှုံးမှုပမာဏ",
  T_48_META_API_3110_D: "ဇာတ်ကောင်အသွင်အပြင်အုပ်စုကိုပြောင်းပါ။",
  T_48_META_API_3110_P0_D: "ပစ်မှတ်",
  T_48_META_API_3110_P1_D: "အသွင်အပြင်အုပ်စု",
  T_48_META_API_3111_D: "ဇာတ်ကောင်အသွင်အပြင် အုပ်စုကို ပြပါ။",
  T_48_META_API_3111_P0_D: "ပစ်မှတ်",
  T_48_META_API_3111_P1_D: "အသွင်အပြင်အုပ်စု",
  T_48_META_API_3112_D: "ဇာတ်ကောင်အသွင်အပြင် အုပ်စုကို ဖျောက်ပါ။",
  T_48_META_API_3112_P0_D: "ပစ်မှတ်",
  T_48_META_API_3112_P1_D: "အသွင်အပြင်အုပ်စု",
  T_48_META_API_3121_D: "အခိုင်အမာရလဒ်များကို Craftland Studio PC စာရင်းအင်းအသုံးပြုမှုသို့ ပေးပို့ပါ။",
  T_48_META_API_3121_P0_D: "အခိုင်အမာဖော်ပြချက်",
  T_48_META_API_3121_P1_D: "အရိပ်အမြွက်",
  T_48_META_API_32_D: "ကစားသမား၏ ယနေ့ တိုကင်ဒေတာကို ရယူပါ။",
  T_48_META_API_32_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_32_P1_D: "တိုကင်အိုင်ဒီ",
  T_48_META_API_32_P2_D: "တိုကင်နံပါတ်",
  T_48_META_API_32_P3_D: "primitive ကို အောင်မြင်စွာ ခေါ်မလား။",
  T_48_META_API_3200_D: "ပလေယာသို့ ပစ္စည်းများထည့်ကာ ထုတ်ပေးသည့်အရာများစာရင်းကို ပြန်ပေးသည်။",
  T_48_META_API_3200_P0_D: "ကစားသမား",
  T_48_META_API_3200_P1_D: "ပစ္စည်း ID",
  T_48_META_API_3200_P2_D: "ပစ္စည်း အရေအတွက်",
  T_48_META_API_3200_P3_D: "ပလေယာအတွက် ထည့်ထားသည့်အရာများစာရင်း၊ တစ်ခုတည်းသောအရာကို ထည့်ထားသော်လည်း စာရင်းအဖြစ် ပြန်ပေးသည်။",
  T_48_META_API_3201_D: "သွေးပမာဏ၏ အထက်ကန့်သတ်ချက်ထက် မကျော်လွန်ဘဲ သတ်မှတ်ထားသော ကစားသမား၏ သွေးပမာဏကို ပြန်လည်ရယူပါ။",
  T_48_META_API_3201_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3201_P1_D: "ကစားသမားသို့ သွေးထည့်ခြင်းအတွက် တန်ဖိုးကို အပေါင်းလက္ခဏာများသာ လက်ခံသည်။",
  T_48_META_API_3202_D: "ပစ်မှတ်ကစားသမား၏ ကျွမ်းကျင်မှုစာရင်းကို သတ်မှတ်ပါ။",
  T_48_META_API_3202_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3202_P1_D: "ကျွမ်းကျင်မှုစာရင်း",
  T_48_META_API_3203_D: "ပစ်မှတ်ကစားသမား၏ကျွမ်းကျင်မှုစာရင်းကိုရယူပါ။",
  T_48_META_API_3203_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3203_R_D: "ကျွမ်းကျင်မှုစာရင်း",
  T_48_META_API_3205_D: "ပလေယာမှ အချို့သော အရာများကို ဖျက်ပါ။",
  T_48_META_API_3205_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3205_P1_D: "ဖျက်ရန် အမျိုးအစား",
  T_48_META_API_3205_P2_D: "ဖျက်ပစ်ရမည့် ပမာဏသည် ကစားသမားက ကိုင်ထားသည့် ပမာဏထက် ကျော်လွန်ပါက၊ သိမ်းဆည်းထားသည့် အရာများကိုသာ ဖျက်ပစ်မည်ဖြစ်သည်။",
  T_48_META_API_3206_D: "ကစားသမားက သတ်မှတ်ထားသော ပစ္စည်းအရေအတွက်ကို ရယူပါ။",
  T_48_META_API_3206_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3206_P1_D: "ပစ္စည်းအမျိုးအစား",
  T_48_META_API_3206_R_D: "ကစားသမားကကိုင်တဲ့ပမာဏ",
  T_48_META_API_3207_D: "ကစားသမားသည် လက်ရှိစစ်ဆေးရေးဂိတ်ကို အစပျိုးနိုင်သလား စစ်ဆေးပါ။",
  T_48_META_API_3207_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3207_P1_D: "အစပျိုး",
  T_48_META_API_3207_R_D: "True- အစပျိုးနိုင်သည်၊ False- အစပျိုး၍မရပါ။",
  T_48_META_API_3208_D: "ပိုးမုဒ် ဖုတ်ကောင်ဆင့်ကဲဖြစ်စဉ်",
  T_48_META_API_3208_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3209_D: "AI အဖွဲ့အစည်းများသည် ပုံသေအပြုအမူသစ်ပင်ကို ရပ်တန့်/လုပ်ဆောင်သည်။",
  T_48_META_API_3209_P0_D: "အပြုအမူသစ်ပင်ပန်းတိုင်များကိုဖွင့်ရန်",
  T_48_META_API_3209_P1_D: "ပုံသေအမူအကျင့်သစ်ကို လုပ်ဆောင်ရန်ရှိမရှိ",
  T_48_META_API_3210_D: "AI အဖွဲ့အစည်းများသည် သတ်မှတ်ထားသော ပစ်မှတ်များကို လိုက်ဖမ်းသည်။",
  T_48_META_API_3210_P0_D: "လိုက်စားမှုကို လုပ်ဆောင်ပေးသော AI entity ၊",
  T_48_META_API_3210_P1_D: "ပစ်မှတ်ကို လိုက်နေပါသည်။",
  T_48_META_API_3211_D: "ပလေယာပစ္စည်းများကို ဖျက်ပါ (ကန့်ကွက်ထားသော၊ DeleteEquipment ကိုသုံးပါ)",
  T_48_META_API_3211_P0_D: "ပစ္စည်းဖျက်ဆီးခံရသော ကစားသမား",
  T_48_META_API_3211_P1_D: "ဖျက်ဆီးထားသော ပစ္စည်းအမျိုးအစား",
  T_48_META_API_3211_P2_D: "လက်နက်အထိုင်၊ လက်နက်များအတွက်သာထိရောက်သည်။",
  T_48_META_API_3212_D: "ဂျာစီပြောင်း",
  T_48_META_API_3212_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3212_P1_D: "အဝတ်စတိုင်",
  T_48_META_API_3212_P2_D: "အဓိကအရောင်တစ်ခု",
  T_48_META_API_3212_P3_D: "အဓိကအရောင်နှစ်ရောင်",
  T_48_META_API_3212_P4_D: "ဖွဲ့စည်းမှု",
  T_48_META_API_3213_D: "ကစားသမား၏ဂျာစီကို နဂိုအခြေအနေသို့ပြန်ယူပါ။",
  T_48_META_API_3213_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3214_D: "ပလေယာအသံချတ်ကို အဖွင့်အပိတ်ပြောင်းပါ။",
  T_48_META_API_3214_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3214_P1_D: "အသံချတ်ကို ပိတ်ရန်ရှိမရှိ၊ True- ပိတ်ရန် False- ဖွင့်ပါ။",
  T_48_META_API_3215_D: "ကစားသမားအမြန်ချတ်ကို ပြောင်းပါ။",
  T_48_META_API_3215_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3215_P1_D: "အမြန်ချတ်ကို ပိတ်ရန်ရှိမရှိ၊ True- ပိတ်ရန် False- ဖွင့်ပါ။",
  T_48_META_API_3216_D: "ပစ်မှတ်ကစားသမားသည် ပစ္စည်းများကို ကောက်ယူနိုင်၊ မရှိ သတ်မှတ်ပါ။",
  T_48_META_API_3216_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3216_P1_D: "ပစ္စည်းယူခြင်းကို တားမြစ်သည်ဖြစ်စေ ၊ မှန်သည် ၊ ပစ္စည်းများ ကောက်ယူခြင်းကို တားမြစ်သည် ၊ မှားသည် ၊ ကောက်ယူနိုင်သည် ။",
  T_48_META_API_3217_D: "ပစ်မှတ်ကစားသမားသည် အရာများကို ချပေးနိုင်ခြင်းရှိမရှိ သတ်မှတ်ပါ။",
  T_48_META_API_3217_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3217_P1_D: "ပစ္စည်းများချခြင်းကို တားမြစ်သည်ဖြစ်စေ ၊ မှန်သည် ၊ ကောက်ခြင်းမှ တားမြစ်သည်ဖြစ်စေ ၊ မှားသည် : ကောက်ယူနိုင်သည်။",
  T_48_META_API_3218_D: "ကစားသမား၏သတ်မှတ်ထားသောအထိုင်တွင်လက်နက်ကိုဖျက်ပါ။",
  T_48_META_API_3218_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3218_P1_D: "ဖျက်ဆီးရန် လက်နက်အထိုင်",
  T_48_META_API_3218_P2_D: "ဖျက်ဆီးရန် ပမာဏ",
  T_48_META_API_3218_P3_D: "အောင်မြင်သည်ဖြစ်စေ မဖျက်ဆီးသည်ဖြစ်စေ လက်နက်အပေါက်တွင် တပ်ဆင်ထားခြင်း မရှိပါက ဖျက်ဆီးမှု ပျက်ပြားမည်ဖြစ်သည်။",
  T_48_META_API_3219_D: "တပ်ဆင်ထားသောပစ္စည်းများအပါအဝင် ပစ်မှတ်ကစားသမား၏ကျောပိုးအိတ်မှအရာအားလုံးကို ရှင်းလင်းပါ။",
  T_48_META_API_3219_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3220_D: "ကစားသမားဦးတည်ချက် သတ်မှတ်ပါ။",
  T_48_META_API_3220_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3220_P1_D: "ကစားသမားဦးတည်ချက်",
  T_48_META_API_3221_D: "(ကန့်ကွက်ထားသည်၊ ကျေးဇူးပြု၍ မသုံးပါနှင့်။ ဆက်စပ်အချက်အလက်များအတွက်၊ attribute <Player>:Skeleton ကိုကြည့်ပါ)",
  T_48_META_API_3221_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_3221_P1_D: "zoom အပိုင်း",
  T_48_META_API_3221_P2_D: "zoom တန်ဖိုး",
  T_48_META_API_3222_D: "ကစားသမားအား ခရိုက်ထွန်းမှုအောင်မြင်သည် ၊ ခရိုက်ထားသော ကစားသမားသည် အခြေခံထားသော အမြန်နှုန်းဖြင့် အောက်သို့ နှိုးသွားသည် ။ ယခုအောင်မြင်သည် အောင်မြင်သည် ။",
  T_48_META_API_3222_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3222_P1_D: "ဦးတည်ချက်ပျံ",
  T_48_META_API_3222_P2_D: "ခေါက်တက်ကြာချိန်",
  T_48_META_API_3222_P3_D: "ပျံသန်းသောအခါ Y-ဝင်ရိုး၏ ကနဦးအလျင်",
  T_48_META_API_3222_P4_D: "XZ လေယာဉ်ပျံ၏ ကနဦးအလျင်",
  T_48_META_API_3222_P5_D: "ကစားသမားရဲ့ တိမ်းညွှတ်မှုကို ပြောင်းလဲမှာလား။",
  T_48_META_API_3223_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC ၏ အဝတ်အစား ID ကို ရယူပါ။",
  T_48_META_API_3223_P0_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC",
  T_48_META_API_3223_P1_D: "အဝတ်အစားအမျိုးအစား",
  T_48_META_API_3223_R_D: "အဝတ်အစား ID",
  T_48_META_API_3224_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC ၏ အဝတ်အစား ID ကို သတ်မှတ်ပါ။",
  T_48_META_API_3224_P0_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC",
  T_48_META_API_3224_P1_D: "အဝတ်အစား ID",
  T_48_META_API_3225_D: "NPC များတွင် အသုံးမပြုနိုင်သော ပစ်မှတ်ကစားသမား၏ မူရင်းအဝတ်အစားကို ပြန်လည်ရယူသည်။",
  T_48_META_API_3225_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3226_D: "AI သည် သတ်မှတ်ထားသော ပစ်မှတ်ကို တိုက်ခိုက်သည်။",
  T_48_META_API_3226_P0_D: "တိုက်ခိုက်မှုကို လုပ်ဆောင်ပေးသော AI အဖွဲ့အစည်း",
  T_48_META_API_3226_P1_D: "တိုက်ခိုက်မှု၏ပစ်မှတ်",
  T_48_META_API_3227_D: "ကစားသမား၏လက်နက်ကို သတ်မှတ်ထားသော အပေါက်ရှိ လက်နက်သို့ ပြောင်းပါ။",
  T_48_META_API_3227_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3227_P1_D: "ပြောင်းရန် လက်နက်အထိုင်",
  T_48_META_API_3227_P2_D: "ခလုတ်အောင်မြင်သည်ဖြစ်စေ မအောင်မြင်သည်ဖြစ်စေ လက်နက်အပေါက်တွင် လက်နက်တပ်ဆင်ထားခြင်း မရှိပါက၊ ခလုတ်သည် ပျက်သွားမည်ဖြစ်သည်။",
  T_48_META_API_3228_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC ၏လက်နက်အရေပြားကိုရယူပါ။",
  T_48_META_API_3228_P0_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC",
  T_48_META_API_3228_P1_D: "လက်နက်အရေပြား ID",
  T_48_META_API_3228_R_D: "လက်နက်အရေပြား ID",
  T_48_META_API_3229_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC ၏လက်နက်အရေပြားကို သတ်မှတ်ပါ။",
  T_48_META_API_3229_P0_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC",
  T_48_META_API_3229_P1_D: "လက်နက်အရေပြား ID",
  T_48_META_API_3230_D: "NPC များတွင် အသုံးမပြုနိုင်သော ပစ်မှတ်ကစားသမား၏ မူရင်းလက်နက်အရေပြားကို ပြန်လည်ရယူသည်။",
  T_48_META_API_3230_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3230_P1_D: "လက်နက် ID",
  T_48_META_API_3231_D: "ကစားသမားဝတ်စုံများ တပ်ဆင်ပါ။",
  T_48_META_API_3231_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3231_P1_D: "မတ်မတ်စာရင်း",
  T_48_META_API_3232_D: "သတ်မှတ်ထားသော အဝတ်အစားအမျိုးအစား၏ အဝတ်အစားအားလုံးကို ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC မှ ဖယ်ရှားပါ။",
  T_48_META_API_3232_P0_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC",
  T_48_META_API_3232_P1_D: "အဝတ်အစားအမျိုးအစား",
  T_48_META_API_3233_D: "ကစားသမား သို့မဟုတ် NPC မှ သတ်မှတ်ထားသည့် လက်နက်၏အရေပြားကို ဖယ်ရှားပါ။",
  T_48_META_API_3233_P0_D: "ပစ်မှတ်ကစားသမား သို့မဟုတ် NPC",
  T_48_META_API_3233_P1_D: "လက်နက် ID",
  T_48_META_API_3234_D: "ပစ်မှတ်သို့ buff ထည့်ပါ။",
  T_48_META_API_3234_P0_D: "ပစ်မှတ်အဖွဲ့အစည်းသည် Buffs များထည့်နိုင်သည့်အရာဖြစ်ရမည်။",
  T_48_META_API_3234_P1_D: "Buff ID",
  T_48_META_API_3235_D: "ပစ်မှတ်မှ buff ကိုဖယ်ရှားပါ။",
  T_48_META_API_3235_P0_D: "ပစ်မှတ်အဖွဲ့အစည်းသည် Buffs များထည့်နိုင်သည့်အရာဖြစ်ရမည်။",
  T_48_META_API_3235_P1_D: "Buff ID",
  T_48_META_API_3236_D: "ပစ်မှတ်၏လက်ရှိ Buff ကိုရယူပါ။",
  T_48_META_API_3236_P0_D: "ပစ်မှတ်အဖွဲ့အစည်းသည် Buffs များထည့်နိုင်သည့်အရာဖြစ်ရမည်။",
  T_48_META_API_3236_R_D: "Buff စာရင်း",
  T_48_META_API_3237_D: "ပစ်မှတ်ကစားသမား၏ကျောပိုးအိတ်၏စာရင်းတွင် ပစ္စည်းများရယူပါ။",
  T_48_META_API_3237_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3237_P1_D: "ကျားကန်စာရင်း",
  T_48_META_API_3238_D: "သတ်မှတ်ထားသောအပေါက်တွင် လက်နက်အား ဆက်စပ်ပစ္စည်းများထည့်ပါ အပေါက်နှင့်မကိုက်ညီသော ဆက်စပ်ပစ္စည်းများကို ထပ်ထည့်မည်မဟုတ်သော်လည်း ဆက်စပ်ပစ္စည်းများသည် မူရင်းဆက်စပ်ပစ္စည်းများကို ကစားသမား၏ကျောပိုးအိတ်သို့ ပေးပို့ပါမည်။ မူရင်း ဆက်စပ်ပစ္စည်းများကို ပလေယာ၏ လက်ရှိ",
  T_48_META_API_3238_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3238_P1_D: "စက်ပစ္စည်းအထိုင်",
  T_48_META_API_3238_P2_D: "ဆက်စပ်ပစ္စည်းများ",
  T_48_META_API_3238_P3_D: `ဆက်စပ်ပစ္စည်းများကို အောင်မြင်စွာထည့်သွင်းခြင်းရှိမရှိ
အမှန်- ဆက်စပ်အထိုင်ရှိ လက်နက်တွင် ဆက်စပ်ပစ္စည်းကို တပ်ဆင်ထားသည်
False- ဆက်စပ်ပစ္စည်းများကို ထည့်၍မရဖြစ်ကာ ကစားသမား၏ကျောပိုးအိတ်တွင် ပေါ်လာမည်မဟုတ်ပါ။`,
  T_48_META_API_3238_P4_D: "မအောင်မြင်ပါက အပိုပစ္စည်းများကို ကွက်လပ်ထည့်ပါ။",
  T_48_META_API_3239_D: "ကျောပိုးအိတ် ကိရိယာ ကော်လံရှိ ပစ္စည်းများကို ရယူပါ။",
  T_48_META_API_3239_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3239_P1_D: "စက်ပစ္စည်းအထိုင်",
  T_48_META_API_3239_P2_D: "သတ်မှတ်ထားသော အထိုင်ရှိ စက်ပစ္စည်းများ မရှိပါက၊ ၎င်းသည် အလွတ်ဖြစ်နေပါမည်။",
  T_48_META_API_3239_P3_D: "ဤကိရိယာအတွက် ဆက်စပ်ပစ္စည်းအားလုံး",
  T_48_META_API_3240_D: "နှစ်ဘက်မြင် vector တစ်ခု၏ X အစိတ်အပိုင်းကို ယူပါ။",
  T_48_META_API_3240_P0_D: "2D vector",
  T_48_META_API_3240_R_D: "နှစ်ဘက်မြင် vector X အစိတ်အပိုင်း",
  T_48_META_API_3241_D: "နှစ်ဘက်မြင် vector တစ်ခု၏ Y အစိတ်အပိုင်းကို ယူပါ။",
  T_48_META_API_3241_P0_D: "2D vector",
  T_48_META_API_3241_R_D: "နှစ်ဘက်မြင် vector Y အစိတ်အပိုင်း",
  T_48_META_API_3242_D: "2D vector သည် X အစိတ်အပိုင်းကို သတ်မှတ်သည်။",
  T_48_META_API_3242_P0_D: "2D vector",
  T_48_META_API_3242_P1_D: "နှစ်ဘက်မြင် vector X အစိတ်အပိုင်း",
  T_48_META_API_3243_D: "2D vector သည် Y အစိတ်အပိုင်းကို သတ်မှတ်ပေးသည်။",
  T_48_META_API_3243_P0_D: "2D vector",
  T_48_META_API_3243_P1_D: "နှစ်ဘက်မြင် vector Y အစိတ်အပိုင်း",
  T_48_META_API_3244_D: "2D vector နှစ်ခုထည့်ပါ။",
  T_48_META_API_3244_P0_D: "ซ้าย",
  T_48_META_API_3244_P1_D: "ขวา",
  T_48_META_API_3244_R_D: "နှစ်ဘက်မြင် vector ပေါင်းထည့်မှုရလဒ်",
  T_48_META_API_3245_D: "2D vector နှစ်ခုကို နုတ်ပါ။",
  T_48_META_API_3245_P0_D: "ซ้าย",
  T_48_META_API_3245_P1_D: "ขวา",
  T_48_META_API_3245_R_D: "နှစ်ဘက်မြင် vector နုတ်ရလဒ်",
  T_48_META_API_3246_D: "နှစ်ဘက်မြင် ကွက်လပ်များကို မြှောက်ပါ။",
  T_48_META_API_3246_P0_D: "2D vector",
  T_48_META_API_3246_P1_D: "2D vector အတိုင်းအတာတန်ဖိုး",
  T_48_META_API_3246_R_D: "နှစ်ဘက်မြင် ကိန်းဂဏန်း ကိန်းဂဏန်း ရလဒ်",
  T_48_META_API_3247_D: "အစက် ထုတ်ကုန် နှစ်ဘက်မြင် ကွက်လပ်နှစ်ခု၏ ရလဒ်သည် အစက်နှစ်ခုကြားရှိ ထောင့်ကို ကိုယ်စားပြုသည့် စကေးတစ်ခုဖြစ်သည်။",
  T_48_META_API_3247_P0_D: "ซ้าย",
  T_48_META_API_3247_P1_D: "ขวา",
  T_48_META_API_3247_R_D: "အစက်ပွားခြင်းရလဒ်",
  T_48_META_API_3248_D: "2D vector နှစ်ခု၏ Euclidean အကွာအဝေးကို တွက်ချက်ပါ။",
  T_48_META_API_3248_P0_D: "ซ้าย",
  T_48_META_API_3248_P1_D: "ขวา",
  T_48_META_API_3248_R_D: "vector နှစ်ခုကို နုတ်ပြီးနောက် ရလာတဲ့ vector ရဲ့ module အရှည်",
  T_48_META_API_3249_D: "နှစ်ဘက်မြင် ကွက်လပ်နှစ်ခုကြားရှိ ထောင့်ကို တွက်ချက်ပါ။",
  T_48_META_API_3249_P0_D: "ซ้าย",
  T_48_META_API_3249_P1_D: "ขวา",
  T_48_META_API_3249_R_D: "Vector angle၊ angle range 0-180",
  T_48_META_API_3250_D: "2D vector ကို ပုံမှန်လုပ်ပါ။",
  T_48_META_API_3250_P0_D: "2D vector",
  T_48_META_API_3250_R_D: "ပုံမှန်ရလဒ်သည် တူညီသောဦးတည်ချက်တွင် 1 မီတာအရှည်ရှိသော vector တစ်ခုဖြစ်သည်။",
  T_48_META_API_3251_D: "Modulo သည် နှစ်ဘက်မြင် vector ဖြစ်သည်။",
  T_48_META_API_3251_P0_D: "2D vector",
  T_48_META_API_3251_R_D: "modulo ရလဒ်သည် vector ၏အရှည်ဖြစ်သည်။",
  T_48_META_API_3252_D: "ပုံမှန်ဒေါင်လိုက်ဖြောင့်မျဉ်းဖြင့် ထင်ဟပ်သော နှစ်ဘက်မြင် vector ၏ vector ကို တွက်ချက်ပါ။",
  T_48_META_API_3252_P0_D: "အဖြစ်အပျက် 2D အားနည်းချက်",
  T_48_META_API_3252_P1_D: "ပုံမှန် 2D vector",
  T_48_META_API_3252_R_D: "ရောင်ပြန်ဟပ်မှု 2D အားနည်းချက်",
  T_48_META_API_3253_D: "ပုံမှန်နှင့် ထောင့်မှန်ကျသော လေယာဉ်ဖြင့် ထင်ဟပ်လာသော သုံးဖက်မြင် vector ၏ vector ကို တွက်ချက်ပါ။",
  T_48_META_API_3253_P0_D: "သုံးဖက်မြင် အဖြစ်အပျက်",
  T_48_META_API_3253_P1_D: "ပုံမှန် 3D vector",
  T_48_META_API_3253_R_D: "ရောင်ပြန်ဟပ်မှု 3D အားနည်းချက်",
  T_48_META_API_3254_D: "သုံးဖက်မြင် vector တစ်ခုကို နှစ်ဖက်မြင် vector သို့ ပြောင်းပြီး သုံးဖက်မြင် vector ၏ Z အစိတ်အပိုင်းကို ဖျက်ပါ",
  T_48_META_API_3254_P0_D: "ပစ်မှတ် 3D vector",
  T_48_META_API_3254_R_D: "နှစ်ဘက်မြင် ပုံပြောင်း",
  T_48_META_API_3255_D: "နှစ်ဘက်မြင် vector တစ်ခုကို သုံးဖက်မြင် vector သို့ ပြောင်းပြီး သုံးဖက်မြင် vector ၏ Z အစိတ်အပိုင်းကို 0 သို့ သတ်မှတ်ပါ။",
  T_48_META_API_3255_P0_D: "ပစ်မှတ် 2D vector",
  T_48_META_API_3255_R_D: "သုံးဖက်မြင် ပုံပြောင်း",
  T_48_META_API_3256_D: "2D vector ဖန်တီးပါ။",
  T_48_META_API_3256_P0_D: "နှစ်ဘက်မြင် vector တစ်ခု၏ X အစိတ်အပိုင်း",
  T_48_META_API_3256_P1_D: "နှစ်ဘက်မြင် vector တစ်ခု၏ Y အစိတ်အပိုင်း",
  T_48_META_API_3256_R_D: "နှစ်ဘက်မြင် vector ကို ဖန်တီးထားသည်။",
  T_48_META_API_3257_D: "သုံးစွဲသူအတွေ့အကြုံဒေတာခွဲခြမ်းစိတ်ဖြာမှုအတွက် ပြိုင်ဆိုင်မှုအမှတ်များမှတ်တမ်းကို စိတ်ကြိုက်ပြင်ဆင်ပါ။",
  T_48_META_API_3257_P0_D: "မှတ်တမ်း",
  T_48_META_API_3258_D: "သုံးစွဲသူအတွေ့အကြုံဒေတာခွဲခြမ်းစိတ်ဖြာမှုအတွက် ပြိုင်ဆိုင်မှုအမှတ်များမှတ်တမ်းကို စိတ်ကြိုက်ပြင်ဆင်ပါ။",
  T_48_META_API_3258_P0_D: "ကစားသမားတွေကို အစီရင်ခံပါတယ်။",
  T_48_META_API_3258_P1_D: "မှတ်တမ်း",
  T_48_META_API_33_D: "ညစ်ပတ်သောစကားလုံးစစ်ထုတ်ခြင်း။",
  T_48_META_API_33_P0_D: "ညစ်ညမ်းသောစကားလုံးများအတွက် စစ်ထုတ်ရန်လိုအပ်သော မူရင်းစာသား",
  T_48_META_API_33_R_D: "စစ်ထုတ်ထားသော စာသား",
  T_48_META_API_3301_D: "စခန်းတစ်ခု ဖန်တီးပါ။",
  T_48_META_API_3301_P0_D: "ဂိုဏ်းခွဲဘဘ",
  T_48_META_API_3302_D: "ပစ်မှတ်သည် သတ်မှတ်ထားသော စခန်းသို့ ချိတ်ဆက်သည်။",
  T_48_META_API_3302_P0_D: "ပစ်မှတ်",
  T_48_META_API_3302_P1_D: "ဂိုဏ်းခွဲဘဘ",
  T_48_META_API_3303_D: "စခန်း၏တိုက်ခိုက်နိုင်သောစခန်းကိုရယူပါ။",
  T_48_META_API_3303_P0_D: "တိုက်ခိုက်ရေးစခန်း",
  T_48_META_API_3303_R_D: "အဖွဲ့ခွဲများစာရင်း",
  T_48_META_API_3304_D: "စခန်းချ၍ တိုက်ခိုက်နိုင်သော စခန်း၊",
  T_48_META_API_3304_P0_D: "တိုက်ခိုက်ရေးစခန်း",
  T_48_META_API_3304_P1_D: "ပစ်မှတ်စခန်း",
  T_48_META_API_3304_P2_D: "တိုက်ခိုက်နိုင်ပါသလား။",
  T_48_META_API_3305_D: "ကစားသမားများကို တိုက်ခိုက်ရန် ပြင်ဆင်ပါ။",
  T_48_META_API_3305_P0_D: "ကစားသမား",
  T_48_META_API_3305_P1_D: "ကစားသမားတွေကို တိုက်ခိုက်နိုင်တယ်။",
  T_48_META_API_3305_P2_D: "တိုက်ခိုက်နိုင်ပါသလား။",
  T_48_META_API_3306_D: "အသင်း၏ တိုက်ခိုက်နိုင်သော အသင်းများကို သတ်မှတ်ပါ။",
  T_48_META_API_3306_P0_D: "တိုက်စစ်အဖွဲ့",
  T_48_META_API_3306_P1_D: "ပစ်မှတ်အဖွဲ့",
  T_48_META_API_3306_P2_D: "တိုက်ခိုက်နိုင်ပါသလား။",
  T_48_META_API_3307_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_3307_P0_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_3307_R_D: "ကစားသမားစာရင်း",
  T_48_META_API_3308_D: "သတ်မှတ်ထားသော အဖွဲ့အစည်းသည် လက်ရှိစခန်းမှ ထွက်ခွာသည်။",
  T_48_META_API_3308_P0_D: "ပစ်မှတ်",
  T_48_META_API_3309_D: "ပစ်မှတ်၏အဖွဲ့ခွဲကိုရယူပါ။",
  T_48_META_API_3309_P0_D: "ပစ်မှတ်",
  T_48_META_API_3309_R_D: "ဂိုဏ်းခွဲဘဘ",
  T_48_META_API_3310_D: "ပစ်မှတ်ကို တိုက်ခိုက်နိုင်သလားဆိုတာ ဆုံးဖြတ်ပါ။",
  T_48_META_API_3310_P0_D: "တိုက်ခိုက်သူ",
  T_48_META_API_3310_P1_D: "ပစ်မှတ်",
  T_48_META_API_3310_R_D: "တိုက်ခိုက်နိုင်ပါသလား။",
  T_48_META_API_3311_D: "အဖွဲ့အစည်းများအတွက် တိုက်ခိုက်နိုင်သော ပစ်မှတ်များကို သတ်မှတ်ပါ။",
  T_48_META_API_3311_P0_D: "တိုက်ခိုက်သူ",
  T_48_META_API_3311_P1_D: "ပစ်မှတ်",
  T_48_META_API_3311_P2_D: "တိုက်ခိုက်နိုင်ပါသလား။",
  T_48_META_API_3312_D: "အဖွဲ့အစည်းတစ်ခု၏ တိုက်ခိုက်နိုင်သော ပစ်မှတ်များကို ရယူပါ။",
  T_48_META_API_3312_P0_D: "တိုက်ခိုက်သူ",
  T_48_META_API_3312_R_D: "တိုက်ခိုက်နိုင်သော အရာများစာရင်း",
  T_48_META_API_34_D: "ပစ်မှတ်တွင် အစိတ်အပိုင်းများ ရှိမရှိ ဆုံးဖြတ်ပါ။",
  T_48_META_API_34_P0_D: "ပစ်မှတ်",
  T_48_META_API_34_P1_D: "အစိတ်အပိုင်းအမျိုးအစား",
  T_48_META_API_34_R_D: "ရှိမရှိ",
  T_48_META_API_35_D: "Bot ထည့်ပါ။",
  T_48_META_API_35_P0_D: "အောက်ခြေအခက်အခဲအဆင့်",
  T_48_META_API_35_P1_D: "Bot ပိုင်တဲ့အဖွဲ့",
  T_48_META_API_35_P2_D: "ဖန်တီးထားသော Bot Player entity",
  T_48_META_API_3500_D: "ကစားသမား တိုကင်ဒေတာကို ရယူပါ။",
  T_48_META_API_3500_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3500_P1_D: "တိုကင်အိုင်ဒီ",
  T_48_META_API_3500_P2_D: "တိုကင်နံပါတ်",
  T_48_META_API_3500_P3_D: "အောင်မြင်သလား။",
  T_48_META_API_3501_D: "ကစားသမားများသို့ တိုကင်ဒေတာထည့်ပါ။",
  T_48_META_API_3501_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3501_P1_D: "တိုကင်အိုင်ဒီ",
  T_48_META_API_3501_P2_D: "တိုကင်နံပါတ်",
  T_48_META_API_3501_P3_D: "primitive ကို အောင်မြင်စွာ ခေါ်မလား။",
  T_48_META_API_3502_D: "ပစ်မှတ်ကစားသမား တိုကင်ကို သုံးပါ။",
  T_48_META_API_3502_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3502_P1_D: "တိုကင်အိုင်ဒီ",
  T_48_META_API_3502_P2_D: "တိုကင်နံပါတ်",
  T_48_META_API_3502_P3_D: "primitive ကို အောင်မြင်စွာ ခေါ်မလား။",
  T_48_META_API_3503_D: "သတ်မှတ်ထားသောနေရာတွင် တိုကင်ထည့်ပါ။",
  T_48_META_API_3503_P0_D: "တည်နေရာ",
  T_48_META_API_3503_P1_D: "တိုကင်အိုင်ဒီ",
  T_48_META_API_3503_P2_D: "တိုကင်နံပါတ်",
  T_48_META_API_3503_P3_D: "primitive ကို အောင်မြင်စွာ ခေါ်မလား။",
  T_48_META_API_3504_D: "ပစ်မှတ် AI သည် သတ်မှတ်ထားသော အရည်အချင်းများကို ထုတ်ပြန်သည်။",
  T_48_META_API_3504_P0_D: "AI ပစ်မှတ်",
  T_48_META_API_3504_P1_D: "ကျွမ်းကျင်မှု",
  T_48_META_API_3504_P2_D: "ကျွမ်းကျင်မှုပန်းတိုင်",
  T_48_META_API_3504_P3_D: "အတတ်ပညာကို အောင်မြင်စွာ ထုတ်ပြန်နိုင်မလား။",
  T_48_META_API_3505_D: "အတားအဆီးများကိုကျော်ဖြတ်ကာ AI လမ်းကြောင်းရှာဖွေခြင်းအတွက် အသုံးပြုနိုင်သည့် အစမှတ်မှ အဆုံးမှတ်အထိ လမ်းကြောင်းရှာဖွေခြင်းလမ်းကြောင်းကို ဖန်တီးပါ။",
  T_48_META_API_3505_P0_D: "စမှတ်ကို သြဒိနိတ်များ",
  T_48_META_API_3505_P1_D: "အဆုံးအမှတ် သြဒိနိတ်များ",
  T_48_META_API_3505_P2_D: "လမ်းကြောင်းရှာဖွေရေး လမ်းကြောင်းကို အောင်မြင်စွာ ထူထောင်နိုင်မလား။",
  T_48_META_API_3505_P3_D: "လမ်းရှာဖွေမှုအမှတ်စုဆောင်းခြင်း။",
  T_48_META_API_3506_D: "အပြုအမူသစ်ပင် ကျောက်သင်ပုန်း variable များကို သတ်မှတ်ပါ။",
  T_48_META_API_3506_P0_D: "ပစ်မှတ်အပြုအမူသစ်ပင်",
  T_48_META_API_3506_P1_D: "ပြောင်းလဲနိုင်သောအမည်",
  T_48_META_API_3506_P2_D: "ပြောင်းလဲနိုင်သောတန်ဖိုး",
  T_48_META_API_3507_D: "အပြုအမူသစ်ပင် ကျောက်သင်ပုန်း variables ကို ရယူပါ။",
  T_48_META_API_3507_P0_D: "ပစ်မှတ်အပြုအမူသစ်ပင်",
  T_48_META_API_3507_P1_D: "ပြောင်းလဲနိုင်သောအမည်",
  T_48_META_API_3507_P2_D: "ပြောင်းလဲနိုင်သောတန်ဖိုး",
  T_48_META_API_3508_D: "အပြုအမူ tree node ဘောင်များကို ရယူပါ။",
  T_48_META_API_3508_P0_D: "ပစ်မှတ်အပြုအမူ tree node",
  T_48_META_API_3508_P1_D: "ကန့်သတ်အမည်",
  T_48_META_API_3508_P2_D: "ကန့်သတ်တန်ဖိုး",
  T_48_META_API_3509_D: "ပစ်မှတ်ကစားသမား၏ ယာဉ်အရေပြားကို ရယူပါ။",
  T_48_META_API_3509_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3509_P1_D: "ယာဉ် ID",
  T_48_META_API_3509_R_D: "ယာဉ်အရေပြား",
  T_48_META_API_3510_D: "ပစ်မှတ်ကစားသမား၏ ယာဉ်အရေပြားကို သတ်မှတ်ပါ။",
  T_48_META_API_3510_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3510_P1_D: "ယာဉ်အရေပြား ID",
  T_48_META_API_3511_D: "၏ ဖော်ပြထားသော ကား၏ အရောင်ကို ရှင်းလင်းပါ",
  T_48_META_API_3511_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3511_P1_D: "ယာဉ် ID",
  T_48_META_API_3512_D: "ပစ်မှတ်ကစားသမား၏ ပုံသေယာဉ်အရေပြားကို ပြန်လည်ရယူပါ။",
  T_48_META_API_3512_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_3512_P1_D: "ယာဉ် ID",
  T_48_META_API_36_D: "အိပ်စက်ခြင်းပစ်မှတ်၊ ဒိုင်းနမစ်အမျိုးအစား တောင့်တင်းသောကိုယ်ထည်များအတွက်သာ အသုံးပြုနိုင်ပါသည်။",
  T_48_META_API_36_P0_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို ပစ်မှတ်ထား",
  T_48_META_API_37_D: "ပစ်မှတ်ကို နှိုးပါ၊ Dynamic အမျိုးအစား တောင့်တင်းသော ခန္ဓာကိုယ်များအတွက်သာ အသုံးပြုနိုင်ပါသည်။",
  T_48_META_API_37_P0_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို ပစ်မှတ်ထား",
  T_48_META_API_38_D: "ပစ်မှတ် တောင့်တင်းသော ခန္ဓာကိုယ်သည် အိပ်နေသလား စစ်ဆေးပါ။",
  T_48_META_API_38_P0_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို ပစ်မှတ်ထား",
  T_48_META_API_38_R_D: "အိပ်နေတာလား။",
  T_48_META_API_39_D: "အိပ်ချိန်သတ်မှတ်ပါ။",
  T_48_META_API_39_P0_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို ပစ်မှတ်ထား",
  T_48_META_API_39_P1_D: "အိပ်စက်ခြင်းအဆင့်သည် တောင့်တင်းသောခန္ဓာကိုယ်သည် ၎င်း၏လှုပ်ရှားမှုနှင့် လှည့်ပတ်မှုအချိန်အတိုင်းအတာတစ်ခုအထိ လျော့နည်းပြီးနောက် တောင့်တင်းသောခန္ဓာကိုယ်သည် ရုပ်ပိုင်းဆိုင်ရာတွက်ချက်မှုများကို လုပ်ဆောင်တော့မည်မဟုတ်ပါ။",
  T_48_META_API_4_D: "ကစားသမားအားလုံး ပြောင်းရွှေ့နိုင်မလား။",
  T_48_META_API_4_P0_D: `True- ရွှေ့နိုင်သည်
False- ရွှေ့၍မရပါ။`,
  T_48_META_API_40_D: "အိပ်စက်ခြင်းအဆင့်ကို ရယူပါ။",
  T_48_META_API_40_P0_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို ပစ်မှတ်ထား",
  T_48_META_API_40_R_D: "အိပ်စက်ခြင်းအဆင့်သည် တောင့်တင်းသောခန္ဓာကိုယ်သည် ၎င်း၏လှုပ်ရှားမှုနှင့် လှည့်ပတ်မှုအချိန်အတိုင်းအတာတစ်ခုအထိ လျော့နည်းပြီးနောက် တောင့်တင်းသောခန္ဓာကိုယ်သည် ရုပ်ပိုင်းဆိုင်ရာတွက်ချက်မှုများကို လုပ်ဆောင်တော့မည်မဟုတ်ပါ။",
  T_48_META_API_4000_D: "ဇယားတစ်ခုလုံး၏ အကြောင်းအရာများကို ဖတ်ပြီး အတန်းအစီအစဥ်ဖြင့် နှစ်ဖက်မြင် ခင်းကျင်းတစ်ခုကို ပြန်ပေးပါ။",
  T_48_META_API_4000_P0_D: "ဇယားအမည်",
  T_48_META_API_4000_R_D: "ဇယားအကြောင်းအရာများ",
  T_48_META_API_4001_D: "ဇယား၏အတန်းတစ်ခု၏အကြောင်းအရာများကိုဖတ်ပြီး array တစ်ခုကိုပြန်ပေးပါ။",
  T_48_META_API_4001_P0_D: "ဇယားအမည်",
  T_48_META_API_4001_P1_D: "1 မှ စတင်၍ ဖတ်ရန် အတန်းအရေအတွက်",
  T_48_META_API_4001_R_D: "ဇယားသည် အတန်းတစ်ခု၏ အကြောင်းအရာများကို သတ်မှတ်သည်။",
  T_48_META_API_4002_D: "ဇယား၏ကော်လံတစ်ခု၏အကြောင်းအရာများကိုဖတ်ပြီး array တစ်ခုကိုပြန်ပေးပါ။",
  T_48_META_API_4002_P0_D: "ဇယားအမည်",
  T_48_META_API_4002_P1_D: "1 မှစတင်၍ ဖတ်ရန် ကော်လံအရေအတွက်",
  T_48_META_API_4002_R_D: "ဇယားသည် ကော်လံတစ်ခု၏ အကြောင်းအရာများကို သတ်မှတ်သည်။",
  T_48_META_API_4003_D: "ဇယားဆဲလ်တစ်ခု၏ အကြောင်းအရာများကို ဖတ်ပါ။",
  T_48_META_API_4003_P0_D: "ဇယားအမည်",
  T_48_META_API_4003_P1_D: "1 မှ စတင်၍ ဖတ်ရန် အတန်းအရေအတွက်",
  T_48_META_API_4003_P2_D: "1 မှစတင်၍ ဖတ်ရန် ကော်လံအရေအတွက်",
  T_48_META_API_4003_R_D: "ဇယားရှိ သတ်မှတ်ထားသော ဆဲလ်များ၏ အကြောင်းအရာများ",
  T_48_META_API_4004_D: "အတန်းနံပါတ်နှင့် ကော်လံအမည်ဖြင့် ဇယားရှိ အချို့ဆဲလ်များ၏ အကြောင်းအရာများကို ဖတ်ပါ။",
  T_48_META_API_4004_P0_D: "ဇယားအမည်",
  T_48_META_API_4004_P1_D: "1 မှ စတင်၍ ဖတ်ရန် အတန်းအရေအတွက်",
  T_48_META_API_4004_P2_D: "ဖတ်ရန်ကော်လံအမည်",
  T_48_META_API_4004_R_D: "ဇယားရှိ သတ်မှတ်ထားသော ဆဲလ်များ၏ အကြောင်းအရာများ",
  T_48_META_API_4005_D: "ဇယားတစ်ခုလုံး၏ အကြောင်းအရာများကို ဖတ်ရှုပြီး နှစ်ဘက်မြင် ခင်းကျင်းတစ်ခုကို ပြန်ပေးပါ။",
  T_48_META_API_4005_P0_D: "ဇယားအမည်",
  T_48_META_API_4005_R_D: "ဇယားပါ အကြောင်းအရာများ၊ နှစ်ဘက်မြင် ခင်းကျင်းခြင်း။",
  T_48_META_API_4006_D: "ဇယားတစ်ခုလုံး၏ အတန်းတစ်ခု၏ အကြောင်းအရာများကို ဖတ်ပြီး array တစ်ခုကို ပြန်ပေးသည်။",
  T_48_META_API_4006_P0_D: "ဇယားအမည်",
  T_48_META_API_4006_P1_D: "1 မှ စတင်၍ ဖတ်ရန် အတန်းအရေအတွက်",
  T_48_META_API_4006_R_D: "ဇယားသည် အတန်းတစ်ခု၊ ခင်းကျင်းမှုတစ်ခု၏ အကြောင်းအရာများကို သတ်မှတ်ပေးသည်။",
  T_48_META_API_4007_D: "ဇယားတစ်ခုလုံး၏ကော်လံတစ်ခု၏အကြောင်းအရာများကိုဖတ်ပြီး array တစ်ခုကိုပြန်ပေးပါ။",
  T_48_META_API_4007_P0_D: "ဇယားအမည်",
  T_48_META_API_4007_P1_D: "1 မှစတင်၍ ဖတ်ရန် ကော်လံအရေအတွက်",
  T_48_META_API_4007_R_D: "ဇယားသည် ကော်လံတစ်ခု၊ ခင်းကျင်းမှုတစ်ခု၏ အကြောင်းအရာများကို သတ်မှတ်သည်။",
  T_48_META_API_4008_D: "ဇယားဆဲလ်တစ်ခု၏ အကြောင်းအရာများကို ဖတ်ပါ။",
  T_48_META_API_4008_P0_D: "ဇယားအမည်",
  T_48_META_API_4008_P1_D: "1 မှ စတင်၍ ဖတ်ရန် အတန်းအရေအတွက်",
  T_48_META_API_4008_P2_D: "1 မှစတင်၍ ဖတ်ရန် ကော်လံအရေအတွက်",
  T_48_META_API_4008_R_D: "ဇယားရှိ သတ်မှတ်ထားသော ဆဲလ်များ၏ အကြောင်းအရာများ",
  T_48_META_API_4009_D: "ကော်လံနံပါတ်နှင့် ဆဲလ်တန်ဖိုးအလိုက် သတ်မှတ်ထားသည့်အတန်းကို ရှာပါ။",
  T_48_META_API_4009_P0_D: "ဇယားအမည်",
  T_48_META_API_4009_P1_D: "ဖတ်ရန် ကော်လံအရေအတွက်",
  T_48_META_API_4009_P2_D: "ရှာရန်ဆဲလ်တန်ဖိုး",
  T_48_META_API_4009_R_D: "အတန်း၊ ခင်းကျင်းရာတွင် တွေ့ရသော အကြောင်းအရာ",
  T_48_META_API_4010_D: "ကော်လံအမည်ဖြင့် ကော်လံနံပါတ်ကို ရယူပါ။",
  T_48_META_API_4010_P0_D: "ဇယားအမည်",
  T_48_META_API_4010_P1_D: "အမှတ်စဉ်နံပါတ်စစ်ဆေးရန် ကော်လံအမည်",
  T_48_META_API_4010_R_D: "1 မှရေတွက်သောကော်လံအရေအတွက်",
  T_48_META_API_41_D: "အသစ်ထုတ်လုပ်ထားသော Dynamic အမျိုးအစား တောင့်တင်းသော ခန္ဓာကိုယ်များအတွက်သာ အကျုံးဝင်သည့် ကမ္ဘာလုံးဆိုင်ရာ အိပ်စက်မှုအဆင့်ကို သတ်မှတ်ပါ။",
  T_48_META_API_41_P0_D: "အိပ်စက်ခြင်းအဆင့်သည် တောင့်တင်းသောခန္ဓာကိုယ်သည် ၎င်း၏လှုပ်ရှားမှုနှင့် လှည့်ပတ်မှုအချိန်အတိုင်းအတာတစ်ခုအထိ လျော့နည်းပြီးနောက် တောင့်တင်းသောခန္ဓာကိုယ်သည် ရုပ်ပိုင်းဆိုင်ရာတွက်ချက်မှုများကို လုပ်ဆောင်တော့မည်မဟုတ်ပါ။",
  T_48_META_API_42_D: "ကမ္ဘာလုံးဆိုင်ရာ အိပ်စက်မှုအဆင့်ကို ရယူပါ။",
  T_48_META_API_42_R_D: "အိပ်စက်ခြင်းအဆင့်၊ ပုံသေ 0.005 သည် အချိန်အတိုင်းအတာတစ်ခုအထိ ရွေ့လျားမှုနှင့် လည်ပတ်မှုနှုန်းထက်နည်းပြီးနောက် တောင့်တင်းသောခန္ဓာကိုယ်သည် အိပ်စက်ခြင်းအခြေအနေသို့ ဝင်ရောက်မည်ဖြစ်သည်။",
  T_48_META_API_43_D: "ပေးထားသော quaternion ကို Euler ထောင့်များအဖြစ်သို့ ပြောင်းပါ Euler angles ၏ rotation order သည် YXZ ဖြစ်သည်",
  T_48_META_API_43_P0_D: "ထည့်သွင်းမှု quaternion",
  T_48_META_API_43_R_D: "Euler ပြန်လာခဲ့တယ် ဆိုတာပါပဲ။",
  T_48_META_API_44_D: "ပေးထားသော Euler ထောင့်များကို quaternions အဖြစ်ပြောင်းပါ။",
  T_48_META_API_44_P0_D: "Euler ထောင့်များကို ထည့်သွင်းပါ။",
  T_48_META_API_44_R_D: "Quaternion ပြန်လာခဲ့သည်။",
  T_48_META_API_45_D: "ဝင်ရိုးထောင့်ဖြင့် ကိုယ်စားပြုသော လှည့်ခြင်းကို quaternion သို့ ပြောင်းပါ။",
  T_48_META_API_45_P0_D: "လည်ပတ်၏ဝင်ရိုး",
  T_48_META_API_45_P1_D: "လည်ပတ်ဝင်ရိုးတစ်ဝိုက်တွင် လက်ယာရစ်လည်ပတ်မှု၏ထောင့်",
  T_48_META_API_45_R_D: "Quaternion ပြန်လာခဲ့သည်။",
  T_48_META_API_46_D: "quaternion ကို ဝင်ရိုးထောင့်ကိုယ်စားပြုမှုသို့ ပြောင်းပါ။",
  T_48_META_API_46_P0_D: "ထည့်သွင်းမှု quaternion",
  T_48_META_API_46_P1_D: "လည်ပတ်၏ဝင်ရိုး",
  T_48_META_API_46_P2_D: "လည်ပတ်ဝင်ရိုးတစ်ဝိုက်တွင် လက်ယာရစ်လည်ပတ်မှု၏ထောင့်",
  T_48_META_API_47_D: "စိတ်ကြိုက်လုပ်ဆောင်စရာ ပြီးစီးမှု တိုးတက်မှုကို သတ်မှတ်ပါ။",
  T_48_META_API_47_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_47_P1_D: "Task ID",
  T_48_META_API_47_P2_D: "ပြီးစီးမှုတိုးတက်မှု၊ အနှုတ်နံပါတ်များကို ခွင့်မပြုပါ။",
  T_48_META_API_48_D: "ရွေ့လျားမှုကို ပေါင်းစပ်ရန် အသုံးပြုနိုင်သည့် Bezier မျဉ်းကွေးကို ဖန်တီးပါ။",
  T_48_META_API_48_P0_D: "မျဉ်းကွေးထိန်းချုပ်မှုအချက်များ",
  T_48_META_API_48_R_D: "Bezier မျဉ်းကွေး",
  T_48_META_API_49_D: "မြင်ကွင်းမြေပုံ ID ကိုရယူပါ။",
  T_48_META_API_49_P0_D: "မြင်ကွင်း ID",
  T_48_META_API_49_R_D: "မြေပုံ ID",
  T_48_META_API_5_D: "အခင်းဖြစ်ပွားရာနေရာရှိ အရာများကို ဖျက်ပါ ( အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ DeleteEntity ကိုသုံးပါ)",
  T_48_META_API_5_P0_D: "ဖျက်ပစ်ရမည့် အရာဝတ္ထု",
  T_48_META_API_50_D: "ဖရိမ်တိုင်းနှင့် သက်ဆိုင်သည့် ရွေ့လျားမှုတစ်ခုကို ဖန်တီးပါ။ ပစ်မှတ်သည် ဖရိမ်တိုင်းတွင် ၎င်း၏ ကိုယ်ပိုင်အရည်အချင်းများကို ပြောင်းလဲပြီး ၎င်း၏လက်ရှိ ရည်ညွှန်းချက်တန်ဖိုးနှင့် နှိုင်းယှဉ်လိုက်တိုင်း ပြောင်းလဲသည်။",
  T_48_META_API_50_P0_D: "ပစ်မှတ်",
  T_48_META_API_50_P1_D: "ရွေ့လျားပြောင်းလဲမှုများ လိုအပ်သည့် အရည်အချင်းများ",
  T_48_META_API_50_P2_D: "ရွေ့လျားမှုအလိုက် ပြောင်းလဲမှုပမာဏ",
  T_48_META_API_50_P3_D: `အခြားသော ရွေ့လျားမှုမုဒ်များနှင့် ပေါင်းစပ်အသုံးပြုသည့်အခါ ဖွဲ့စည်းမှုပုံစံ
True- နှိုင်းရရွေ့လျားမှုနှင့် ပေါင်းစပ်အသုံးပြုနိုင်သည်
False- ပကတိရွေ့လျားမှုနှင့် ပေါင်းစပ်အသုံးပြုနိုင်သည်`,
  T_48_META_API_50_P4_D: "ဖန်တီးထားသော ရွေ့လျားမှု entity သည် ဖရိန်တစ်ခုစီတွင် သူ့အလိုလို ဆက်စပ်နေသည်။",
  T_48_META_API_50_P5_D: "ဖန်တီးပြီးနောက် အလိုအလျောက် စတင်ကစားမလား။",
  T_48_META_API_5000_D: "ဒေတာဘေ့စ်ရှိ ဇယားရှိ ကီးတစ်ခုနှင့် သက်ဆိုင်သည့် တန်ဖိုးကို ဖတ်ပါ။",
  T_48_META_API_5000_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_5000_P1_D: "ကစားသမားများကို အမှတ်အသားလုပ်ပြီး တူညီသောအခြေအနေများကို ကိုင်တွယ်ပါ။",
  T_48_META_API_5000_P2_D: "ဒေတာကို ဖော်ထုတ်ရန် အသုံးပြုသည့် စိတ်ကြိုက်အမည်တစ်ခု",
  T_48_META_API_5000_P3_D: "ဖတ်ပြီးသောရလဒ်ကို ပြန်ပေးပါ။",
  T_48_META_API_5000_P4_D: "ဒေတာဘေ့စ်နှင့်မတူညီသောစစ်ကွင်းကုဒ်",
  T_48_META_API_5001_D: "ဒေတာဘေ့စ်ရှိ ဇယားတစ်ခုရှိ ကီးတစ်ခုနှင့် သက်ဆိုင်သော တန်ဖိုးကို ရေးပါ။",
  T_48_META_API_5001_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_5001_P1_D: "ကစားသမားများကို အမှတ်အသားလုပ်ပြီး တူညီသောအခြေအနေများကို ကိုင်တွယ်ပါ။",
  T_48_META_API_5001_P2_D: "ဒေတာကို ဖော်ထုတ်ရန် အသုံးပြုသည့် စိတ်ကြိုက်အမည်တစ်ခု",
  T_48_META_API_5001_P3_D: "ရေးထားတဲ့တန်ဖိုး",
  T_48_META_API_5001_P4_D: "ကွက်လပ်ဖြည့်နိုင်သည့် ဒေတာဘေ့စ်နှင့် သက်ဆိုင်သည့် စစ်မြေပြင်ကုဒ်သည် လက်ရှိမြေပုံ၏ စစ်မြေပြင်ကုဒ်ကို ကိုယ်စားပြုသည်",
  T_48_META_API_5002_D: "ဒေတာဘေ့စ်ရှိ ဇယားတစ်ခုရှိ အချို့သောကီးတစ်ခုနှင့် သက်ဆိုင်သည့်တန်ဖိုးကို ဖျက်ပါ။",
  T_48_META_API_5002_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_5002_P1_D: "ကစားသမားများကို အမှတ်အသားလုပ်ပြီး တူညီသောအခြေအနေများကို ကိုင်တွယ်ပါ။",
  T_48_META_API_5002_P2_D: "ဒေတာကို ဖော်ထုတ်ရန် အသုံးပြုသည့် စိတ်ကြိုက်အမည်တစ်ခု",
  T_48_META_API_5002_P3_D: "ဒေတာဘေ့စ်နှင့်မတူညီသောစစ်ကွင်းကုဒ်",
  T_48_META_API_5003_D: "ဒေတာဘေ့စ်ရှိ အဆင့်သတ်မှတ်ချက်ဇယားရှိ သော့တစ်ခုနှင့် သက်ဆိုင်သည့်တန်ဖိုးကို ဖတ်ပါ။",
  T_48_META_API_5003_P0_D: "ဒေတာဘေ့စ်တွင် ဇယားအမည် အဆင့်သတ်မှတ်ခြင်း။",
  T_48_META_API_5003_P1_D: "ဒေတာကို ဖော်ထုတ်ရန် အသုံးပြုသည့် စိတ်ကြိုက်အမည်တစ်ခု",
  T_48_META_API_5003_P2_D: "ဖတ်ပြီးသောရလဒ်ကို ပြန်ပေးပါ။",
  T_48_META_API_5003_P3_D: "ဒေတာဘေ့စ်နှင့်မတူညီသောစစ်ကွင်းကုဒ်",
  T_48_META_API_5004_D: "ဒေတာဘေ့စ်ရှိ အဆင့်သတ်မှတ်ဇယားတွင် သော့တစ်ခုနှင့် သက်ဆိုင်သည့်တန်ဖိုးကို ရေးပါ။",
  T_48_META_API_5004_P0_D: "ဒေတာဘေ့စ်တွင် ဇယားအမည် အဆင့်သတ်မှတ်ခြင်း။",
  T_48_META_API_5004_P1_D: "ဒေတာကို ဖော်ထုတ်ရန် အသုံးပြုသည့် စိတ်ကြိုက်အမည်တစ်ခု",
  T_48_META_API_5004_P2_D: "ရေးထားတဲ့တန်ဖိုး",
  T_48_META_API_5004_P3_D: "ဒေတာဘေ့စ်နှင့်မတူညီသောစစ်ကွင်းကုဒ်",
  T_48_META_API_5005_D: "ဒေတာဘေ့စ်ရှိ အဆင့်သတ်မှတ်ဇယားရှိ ကီးတစ်ခုနှင့် သက်ဆိုင်သည့်တန်ဖိုးကို ဖျက်ပါ။",
  T_48_META_API_5005_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_5005_P1_D: "ဒေတာကို ဖော်ထုတ်ရန် အသုံးပြုသည့် စိတ်ကြိုက်အမည်တစ်ခု",
  T_48_META_API_5005_P2_D: "ဒေတာဘေ့စ်နှင့်မတူညီသောစစ်ကွင်းကုဒ်",
  T_48_META_API_5006_D: "ဒေတာဘေ့စ်ရှိ အဆင့်သတ်မှတ်ချက်ဇယားတစ်ခုရှိ အချို့သောအဆင့်သတ်မှတ်ချက်နှင့် သက်ဆိုင်သည့်တန်ဖိုးကို ဖျက်ပါ။",
  T_48_META_API_5006_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_5006_P1_D: "ဦးဆောင်သူစာရင်း",
  T_48_META_API_5006_P2_D: "ဒေတာဘေ့စ်နှင့်မတူညီသောစစ်ကွင်းကုဒ်",
  T_48_META_API_5007_D: "ဒေတာဘေ့စ်ရှိ အဆင့်သတ်မှတ်ခြင်းဇယားတစ်ခုရှိ အဆင့်သတ်မှတ်ချက်တစ်ခုမှ အချို့သောအဆင့်အထိ တန်ဖိုးများကို ဖတ်ပါ။",
  T_48_META_API_5007_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_5007_P1_D: "စတင်အဆင့်",
  T_48_META_API_5007_P2_D: "အဆင့်သတ်မှတ်ချက်",
  T_48_META_API_5007_P3_D: "ဖတ်ပြီးသောရလဒ်ကို ပြန်ပေးပါ။",
  T_48_META_API_5007_P4_D: "ဒေတာဘေ့စ်နှင့်မတူညီသောစစ်ကွင်းကုဒ်",
  T_48_META_API_5008_D: "စုစည်းမှုဒေတာဘေ့စ်ရှိ ဇယားတစ်ခုရှိ ကီးတစ်ခုနှင့် သက်ဆိုင်သည့်တန်ဖိုးကို ဖတ်ပါ။",
  T_48_META_API_5008_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_5008_P1_D: "ဒေတာကို ဖော်ထုတ်ရန် အသုံးပြုသည့် စိတ်ကြိုက်အမည်တစ်ခု",
  T_48_META_API_5008_P2_D: "ဖတ်ပြီးသောရလဒ်ကို ပြန်ပေးပါ။",
  T_48_META_API_5008_P3_D: "ဒေတာဘေ့စ်နှင့်မတူညီသောစစ်ကွင်းကုဒ်",
  T_48_META_API_5009_D: "စုစည်းဒေတာဘေ့စ်ရှိ ဇယားတစ်ခုရှိ သော့တစ်ခုနှင့် သက်ဆိုင်သော အော့ဖ်ဆက်တန်ဖိုးကို ရေးပါ။",
  T_48_META_API_5009_P0_D: "ဒေတာဘေ့စ်တွင်ဇယားအမည်",
  T_48_META_API_5009_P1_D: "ဒေတာကို ဖော်ထုတ်ရန် အသုံးပြုသည့် စိတ်ကြိုက်အမည်တစ်ခု",
  T_48_META_API_5009_P2_D: "ဂဏန်းသင်္ချာလုပ်ငန်းအမျိုးအစား လေးခုသည် လက်ရှိတွင် အောက်ပါအမျိုးအစားများကို ပံ့ပိုးပေးသည်- Int အမျိုးအစားသည် ပေါင်းထည့်ခြင်း၊ နုတ်ခြင်း၊ မြှောက်ခြင်း၊ ပိုင်းခြားခြင်းနှင့် အကြွင်းအား ပံ့ပိုးပေးသည်။",
  T_48_META_API_5009_P3_D: "Offset value ရေးထားတယ်။",
  T_48_META_API_5009_P4_D: "ဒေတာဘေ့စ်နှင့်မတူညီသောစစ်ကွင်းကုဒ်",
  T_48_META_API_51_D: "ကစားနိုင်သောအကြောင်းအရာကို ပြန်လည်သတ်မှတ်ပြီး ဖွင့်နိုင်သောအခြေအနေအား မပြောင်းလဲဘဲ ၎င်း၏ကနဦးပုံစံသို့ ပြန်လည်ရယူပါ။",
  T_48_META_API_51_P0_D: "ပစ်မှတ်ကစားနိုင်သော အရာ",
  T_48_META_API_52_D: "A*B သည် A ကို ဦးစွာ လှည့်ပြီးနောက် B ကို လှည့်ပါသည်။ မတူညီသော လှည့်ခြင်း အမှာစာများ သည် မတူညီသော ရလဒ်များကို ဖြစ်ပေါ်စေပါသည်။",
  T_48_META_API_52_P0_D: "တန်ဖိုး quaternion",
  T_48_META_API_52_P1_D: "rvalue quaternion",
  T_48_META_API_52_R_D: "ရလဒ် quaternion",
  T_48_META_API_53_D: "သတ်မှတ်ထားသော ဦးတည်ရာကို မျက်နှာမူသော လှည့်ပတ်မှုတစ်ခုကို ဖန်တီးပါ။",
  T_48_META_API_53_P0_D: "ဦးတည်ချက်သတ်မှတ်ပါ။",
  T_48_META_API_53_P1_D: "အထက်ဦးတည်ချက်",
  T_48_META_API_53_R_D: "သတ်မှတ်ထားသော ဦးတည်ရာသို့ ချိန်ညှိရန် လှည့်ပတ်မှုပမာဏ",
  T_48_META_API_54_D: "လေးပုံတစ်ပုံ လုံးပတ် ပေါင်းစပ်မှု A မှ B",
  T_48_META_API_54_P0_D: "တန်ဖိုးတစ်ခု",
  T_48_META_API_54_P1_D: "B တန်ဖိုး",
  T_48_META_API_54_P2_D: "ပေါင်းစည်းခြင်းတိုးတက်မှု၊ တန်ဖိုးအပိုင်းအခြား [0,1]၊ တန်ဖိုးသည် 0 ဖြစ်သောအခါ၊ စတင်တန်ဖိုးကို ပြန်ပေးသည်၊ တန်ဖိုးသည် 1 ဖြစ်သောအခါ၊ ပစ်မှတ်တန်ဖိုးကို ပြန်ပေးသည်",
  T_48_META_API_54_R_D: "ရလဒ် quaternion",
  T_48_META_API_57_D: "သတိပေးချက်အဖြစ် ပစ်မှတ်ဒေတာကို ကွန်ဆိုးလ်သို့ ပရင့်ထုတ်ပါ။",
  T_48_META_API_57_P0_D: "ပုံနှိပ်ဖို့ ဘာတွေ လိုအပ်လဲ။",
  T_48_META_API_58_D: "ပစ်မှတ်ဒေတာကို အမှားပုံစံဖြင့် ကွန်ဆိုးသို့ ပရင့်ထုတ်ပါ။",
  T_48_META_API_58_P0_D: "ပုံနှိပ်ဖို့ ဘာတွေ လိုအပ်လဲ။",
  T_48_META_API_59_D: "မျဉ်းကွေးပေါ်တွင် တန်ဖိုးကို ရယူပါ။",
  T_48_META_API_59_P0_D: "မျဉ်းကွေး",
  T_48_META_API_59_P1_D: "နမူနာအမှတ်၊ တန်ဖိုးအပိုင်းအခြား [0,1]",
  T_48_META_API_59_R_D: "ရလဒ်",
  T_48_META_API_6_D: "သတ်မှတ်ထားသော သြဒိနိတ်များအတွက် မြင်ကွင်းအရာဝတ္ထုများကို ဖန်တီးပါ။",
  T_48_META_API_6_P0_D: "မြင်ကွင်းအရာဝတ္တုကို ဖန်တီးထားသည်။",
  T_48_META_API_6_P1_D: "အရာဝတ္ထုကို ထုတ်ပေးသည့်နေရာ",
  T_48_META_API_6_P2_D: "ကုဒ်စခရစ်များတွင် ဖန်တီးထားသော အရာဝတ္ထုအမျိုးအစား ID ကို အသုံးပြုသည့်အခါ၊ ပိုင်ဆိုင်မှုစာရင်းသွင်းခြင်းတွင် အဆင့်အရာဝတ္ထုစာရင်းကောက်ယူခြင်းကို ကြိုတင်စာရင်းသွင်းရန် လိုအပ်သည်။",
  T_48_META_API_60_D: "မျဉ်းကွေးများမှ ပေါင်းစပ်ပါ။",
  T_48_META_API_60_P0_D: "တန်ဖိုးအမျိုးအစား",
  T_48_META_API_60_P1_D: "စတင်တန်ဖိုး",
  T_48_META_API_60_P2_D: "ပစ်မှတ်တန်ဖိုး",
  T_48_META_API_60_P3_D: "မျဉ်းကွေး",
  T_48_META_API_60_P4_D: "နမူနာအမှတ်၊ တန်ဖိုးအပိုင်းအခြား [0,1]",
  T_48_META_API_60_R_D: "ရလဒ်",
  T_48_META_API_6000_D: "ပစ်မှတ်အကြောင်းအရာအတွက် script ကိုထည့်ပါ။",
  T_48_META_API_6000_P0_D: "ပစ်မှတ်",
  T_48_META_API_6000_P1_D: "ဇာတ်ညွှန်း ID",
  T_48_META_API_6001_D: "ပစ်မှတ်အကြောင်းအရာအတွက် script ကို ဖြုတ်ပါ။",
  T_48_META_API_6001_P0_D: "ပစ်မှတ်",
  T_48_META_API_6001_P1_D: "ဇာတ်ညွှန်း ID",
  T_48_META_API_6002_D: "သတ်မှတ်ထားသော script သည် ပစ်မှတ်တွင်ရှိမရှိ စစ်ဆေးပါ။",
  T_48_META_API_6002_P0_D: "ပစ်မှတ်",
  T_48_META_API_6002_P1_D: "ဇာတ်ညွှန်း ID",
  T_48_META_API_6002_R_D: "သတ်မှတ်ထားသော script ရှိမရှိ၊",
  T_48_META_API_61_D: "UI ထိန်းချုပ်မှု၏ ပင်မနေရာအား သတ်မှတ်ပါ။",
  T_48_META_API_61_P0_D: "Parent node၊ သင်သည် UI ထိန်းချုပ်မှုများ သို့မဟုတ် စိတ်ကြိုက် UI ကို သတ်မှတ်နိုင်သည်။",
  T_48_META_API_61_P1_D: "ကလေး node",
  T_48_META_API_62_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_62_P0_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_62_P1_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_62_P2_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_62_P3_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_62_P4_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_63_D: "လက်ရှိကင်မရာမှ ဖန်သားပြင် ထိတွေ့မှုအမှတ်အထိ ဓာတ်မှန်ရိုက်ပါ။",
  T_48_META_API_63_P0_D: "မျက်နှာပြင်ထိတွေ့မှုအချက်များ",
  T_48_META_API_63_P1_D: "အစမှတ်",
  T_48_META_API_63_P2_D: "ဓာတ်မှန်ရိုက်ရန်",
  T_48_META_API_64_D: "စိတ်ကြိုက်ငွေပေးချေမှု အချက်အလက်ကို အပ်လုဒ်လုပ်ပါ။",
  T_48_META_API_64_P0_D: "ကစားသမား ဘဘ",
  T_48_META_API_64_P1_D: "ပွဲရလဒ်",
  T_48_META_API_64_P2_D: "အမှတ်ခေါင်းစဉ်",
  T_48_META_API_64_P3_D: "အမှတ်တန်ဖိုး",
  T_48_META_API_65_D: "သတ်မှတ်ထားသော အသံအကျိုးသက်ရောက်မှုကို ဖွင့်ရန် သတ်မှတ်ရန် လိုအပ်သော ဂုဏ်သတ္တိများရှိပါက၊ ၎င်း၏ entity ဂုဏ်သတ္တိများကို သင် သတ်မှတ်နိုင်သည်။",
  T_48_META_API_65_P0_D: "အသံအကျိုးသက်ရောက်မှုကို ဖန်တီးထားသည်။",
  T_48_META_API_65_P1_D: "ပစ်မှတ်ကစားသမား၊ ပစ်မှတ်ကစားသမားသာလျှင် အသံအကျိုးသက်ရောက်မှုကို ကြားနိုင်သည်။",
  T_48_META_API_65_P2_D: "အသံအကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_48_META_API_65_P3_D: "ကွင်းအမျိုးအစား",
  T_48_META_API_65_P4_D: "ချက်ချင်းဆော့မလား။",
  T_48_META_API_66_D: "သတ်မှတ်ရန် လိုအပ်သော ဂုဏ်သတ္တိများ ရှိပါက၊ ၎င်း၏ entity ဂုဏ်သတ္တိများကို သင် သတ်မှတ်နိုင်သည်။",
  T_48_META_API_66_P0_D: "အထူးအကျိုးသက်ရောက်မှုများ ဖန်တီးထားသည်။",
  T_48_META_API_66_P1_D: "ပစ်မှတ်ကစားသမား၊ ပစ်မှတ်ကစားသမားကိုသာ မြင်နိုင်သည်။",
  T_48_META_API_66_P2_D: "အထူးအကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_48_META_API_66_P3_D: "ကွင်းအမျိုးအစား",
  T_48_META_API_66_P4_D: "ချက်ချင်းဆော့မလား။",
  T_48_META_API_67_D: "သတ်မှတ်ထားသော အသံအကျိုးသက်ရောက်မှုကို ဖန်တီးရန် သတ်မှတ်ရန် လိုအပ်သော ဂုဏ်သတ္တိများရှိပါက၊ ၎င်း၏ entity ဂုဏ်သတ္တိများကို သင် သတ်မှတ်နိုင်သည်။",
  T_48_META_API_67_P0_D: "အသံအကျိုးသက်ရောက်မှုကို ဖန်တီးထားသည်။",
  T_48_META_API_67_P1_D: "အသံအကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_48_META_API_67_P2_D: "ကွင်းအမျိုးအစား",
  T_48_META_API_67_P3_D: "ချက်ချင်းဆော့မလား။",
  T_48_META_API_68_D: "ကမ္ဘာကြီးကို သြဒိနိတ်များကို မျက်နှာပြင် သြဒိနိတ်များအဖြစ် ပြောင်းပါ။",
  T_48_META_API_68_P0_D: "ကမ္ဘာ့ သြဒိနိတ်များ",
  T_48_META_API_68_P1_D: "စခရင်ပေါ်မှာ မြေပုံဆွဲမလား။",
  T_48_META_API_68_P2_D: "မြေပုံတည်နေရာ",
  T_48_META_API_69_D: "မျက်နှာပြင် သြဒိနိတ်များကို ကမ္ဘာ့သြဒိနိတ်များအဖြစ် ပြောင်းပါ။",
  T_48_META_API_69_P0_D: "မျက်နှာပြင် သြဒိနိတ်များ",
  T_48_META_API_69_P1_D: "မျက်နှာပြင်မှအကွာအဝေး",
  T_48_META_API_69_P2_D: "ကမ္ဘာ့ သြဒိနိတ်များ",
  T_48_META_API_7_D: "ပစ်မှတ်တန်ဖိုးကို စာကြောင်းအဖြစ် ပြောင်းပါ။",
  T_48_META_API_7_P0_D: "ပစ်မှတ်တန်ဖိုးကို စာကြောင်းတစ်ခုအဖြစ်သို့ ပြောင်းလဲရန်",
  T_48_META_API_7_R_D: "ကြိုးတစ်ချောင်း",
  T_48_META_API_70_D: "ဖန်သားပြင်ထိတွေ့မှုမှတစ်ဆင့် ဓာတ်မှန်ရိုက်ခြင်းသိရှိနိုင်မှုကို လုပ်ဆောင်ပြီး ပထမဆုံး hit entity ကို ပြန်ပေးပါ။",
  T_48_META_API_70_P0_D: "ပင်မစခရင်ကို ထိပါ။",
  T_48_META_API_70_P1_D: "ထောက်လှမ်းအကွာအဝေး",
  T_48_META_API_70_P2_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများသာ စကင်ဖတ်ခြင်းတွင် ပါဝင်မည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ စကင်ဖတ်ခြင်းတွင် အလွှာအားလုံး ပါဝင်လိမ့်မည်",
  T_48_META_API_70_P3_D: "အစပျိုးမှုများကို သိရှိနိုင်ပါသလား။",
  T_48_META_API_70_P4_D: "ဘဘ ရိုက်တယ်။",
  T_48_META_API_70_P5_D: "hit point သြဒိနိတ်များ",
  T_48_META_API_70_P6_D: "hit point မှ start point သို့ အကွာအဝေး",
  T_48_META_API_70_P7_D: "မျက်နှာပြင်ကို ပုံမှန်ထိလိုက်ပါ။",
  T_48_META_API_71_D: "မျက်နှာပြင်ထိတွေ့မှုမှတစ်ဆင့် ဓာတ်မှန်ရိုက်ခြင်းသိရှိနိုင်ခြင်း၊ ထိမှန်သောအရာအားလုံးကို ပြန်ပေးသည်။",
  T_48_META_API_71_P0_D: "ပင်မစခရင်ကို ထိပါ။",
  T_48_META_API_71_P1_D: "ထောက်လှမ်းအကွာအဝေး",
  T_48_META_API_71_P2_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများသာ စကင်ဖတ်ခြင်းတွင် ပါဝင်မည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ စကင်ဖတ်ခြင်းတွင် အလွှာအားလုံး ပါဝင်လိမ့်မည်",
  T_48_META_API_71_P3_D: "အစပျိုးမှုများကို သိရှိနိုင်ပါသလား။",
  T_48_META_API_71_P4_D: "hit entities စာရင်း",
  T_48_META_API_71_P5_D: "ပွိုင့်သြဒိနိတ်စာရင်းကို နှိပ်ပါ။",
  T_48_META_API_71_P6_D: "hit point နှင့် start point အကြားအကွာအဝေးများစာရင်း",
  T_48_META_API_71_P7_D: "မျက်နှာပြင်ပုံမှန်စာရင်းကိုနှိပ်ပါ။",
  T_48_META_API_72_D: "သတ်မှတ်ရန် လိုအပ်သော ဂုဏ်သတ္တိများ ရှိပါက၊ ၎င်း၏ entity ဂုဏ်သတ္တိများကို သင် သတ်မှတ်နိုင်သည်။",
  T_48_META_API_72_P0_D: "အထူးအကျိုးသက်ရောက်မှုများ ဖန်တီးထားသည်။",
  T_48_META_API_72_P1_D: "အထူးအကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_48_META_API_72_P2_D: "ကွင်းအမျိုးအစား",
  T_48_META_API_72_P3_D: "ချက်ချင်းဆော့မလား။",
  T_48_META_API_73_D: "အခြား client များနှင့် ထပ်တူပြု၍မရသော built-in UI ကိုဖန်တီးပါ။",
  T_48_META_API_73_P0_D: "Built-in UI ကို ဖန်တီးထားသည်။",
  T_48_META_API_73_P1_D: "Built-in UI အမျိုးအစားများ",
  T_48_META_API_74_D: "အခြား client များနှင့် ထပ်တူပြုမည်မဟုတ်သော စိတ်ကြိုက် UI ကို ဖန်တီးပါ။",
  T_48_META_API_74_P0_D: "စိတ်ကြိုက် UI အကြောင်းအရာများကို ဖန်တီးထားသည်။",
  T_48_META_API_74_P1_D: "စိတ်ကြိုက် UI အညွှန်း",
  T_48_META_API_75_D: "လက်ရှိအသုံးပြုသူနှင့် သက်ဆိုင်သည့် ကစားသမားကို ရယူပါ။",
  T_48_META_API_75_R_D: "ကစားသမား ဘဘ",
  T_48_META_API_76_D: "AI ဘီလူးများကိုဖန်တီးပါ။",
  T_48_META_API_76_P0_D: "AI ပစ်မှတ်",
  T_48_META_API_76_P1_D: "တည်နေရာဖန်တီးပါ။",
  T_48_META_API_76_P2_D: "AI အမျိုးအစား",
  T_48_META_API_76_P3_D: "အဖွဲ",
  T_48_META_API_76_P4_D: "ရန်သူတွေကို အလိုအလျောက် ရှာဖွေမှာလား။",
  T_48_META_API_76_P5_D: "တိုက်ခိုက်ရေးမုဒ်",
  T_48_META_API_76_P6_D: "ခရီးသွားလမ်းကြောင်း",
  T_48_META_API_77_D: "vector ၏ပထမအစိတ်အပိုင်းကိုသတ်မှတ်ပါ။",
  T_48_META_API_77_P0_D: "vector",
  T_48_META_API_77_P1_D: "ပထမအစိတ်အပိုင်းတန်ဖိုး",
  T_48_META_API_77_R_D: "Vector ကိုပြုပြင်ပြီးနောက်ပထမအစိတ်အပိုင်း",
  T_48_META_API_78_D: "vector ၏ ဒုတိယအစိတ်အပိုင်းကို သတ်မှတ်သည်။",
  T_48_META_API_78_P0_D: "vector",
  T_48_META_API_78_P1_D: "ဒုတိယအစိတ်အပိုင်းတန်ဖိုး",
  T_48_META_API_78_R_D: "Vector ဒုတိယအစိတ်အပိုင်းကို ပြုပြင်ပြီးနောက်",
  T_48_META_API_79_D: "vector ၏တတိယအစိတ်အပိုင်းကိုသတ်မှတ်သည်။",
  T_48_META_API_79_P0_D: "vector",
  T_48_META_API_79_P1_D: "တတိယအစိတ်အပိုင်းတန်ဖိုး",
  T_48_META_API_79_R_D: "Vector ၏တတိယအစိတ်အပိုင်းကိုမွမ်းမံပြီးနောက်",
  T_48_META_API_8_D: "ဗဟိုသြဒိနိတ်အမှတ်သို့ ကျုံ့သွားမည့် ဘေးကင်းသောဧရိယာကို ဖွင့်ပါ။",
  T_48_META_API_8_P0_D: "လုံခြုံဇုန်၏ဗဟိုအချက်",
  T_48_META_API_8_P1_D: "ဘေးကင်းဇုန်၏အချင်းဝက်",
  T_48_META_API_8_P2_D: "စောင့်ဆိုင်းချိန်၊ စက္ကန့်ပိုင်းအတွင်း၊ ထို့နောက် ဘေးကင်းသောဇုန်သည် ဗဟိုပွိုင့်ဆီသို့ စတင်ကျုံ့သွားမည်ဖြစ်သည်။",
  T_48_META_API_8_P3_D: "လုံခြုံသောဧရိယာသည် ဗဟိုပွိုင့်သို့ ကျုံ့ရန် လိုအပ်သည့်အချိန် စက္ကန့်ပိုင်းအတွင်း",
  T_48_META_API_8_P4_D: "ဘေးကင်းဇုန်အပြင်ဘက် တစ်စက္ကန့်လျှင် ပျက်စီးဆုံးရှုံးမှုပမာဏ",
  T_48_META_API_80_D: "နှစ်ဘက်မြင် vector တစ်ခု၏ ပထမအစိတ်အပိုင်းကို သတ်မှတ်သည်။",
  T_48_META_API_80_P0_D: "2D vector",
  T_48_META_API_80_P1_D: "ပထမအစိတ်အပိုင်းတန်ဖိုး",
  T_48_META_API_80_R_D: "ပထမအစိတ်အပိုင်းကို မွမ်းမံပြီးနောက် နှစ်ဖက်မြင် vector",
  T_48_META_API_81_D: "2D vector ၏ ဒုတိယ အစိတ်အပိုင်းကို သတ်မှတ်သည်။",
  T_48_META_API_81_P0_D: "2D vector",
  T_48_META_API_81_P1_D: "ဒုတိယအစိတ်အပိုင်းတန်ဖိုး",
  T_48_META_API_81_R_D: "ဒုတိယအစိတ်အပိုင်းကို မွမ်းမံပြီးနောက် နှစ်ဘက်မြင် vector",
  T_48_META_API_82_D: "ဇာတ်ကောင်ထိန်းချုပ်သူကို သတ်မှတ်ထားသည့် အနေအထားသို့ ရွှေ့ပါက ကစားသမားကို အကျိုးသက်ရောက်ပါက၊ ကစားသူသည် ရုပ်ပိုင်းဆိုင်ရာသက်ရောက်မှုများကို အသုံးပြုသည့် ပလေယာထိန်းချုပ်ကိရိယာကို ဖွင့်ရပါမည်။",
  T_48_META_API_82_P0_D: "ပစ်မှတ်ဇာတ်ကောင်ထိန်းချုပ်ကိရိယာ",
  T_48_META_API_82_P1_D: "တည်နေရာကိုသတ်မှတ်ပါ။",
  T_48_META_API_83_D: "၎င်း၏အမည်ပေါ်အခြေခံ၍ ပစ်မှတ်မိဘဆုံမှတ်၏ သတ်မှတ်ထားသော ကလေး node ကိုရယူပါ။",
  T_48_META_API_83_P0_D: "parent node entity",
  T_48_META_API_83_P1_D: "ကလေး node အမည်",
  T_48_META_API_83_R_D: "ကလေး node entity",
  T_48_META_API_84_D: "AOI အထူးအာရုံစူးစိုက်မှုကို ထည့်ပါ၊ အကွာအဝေးမခွဲခြားဘဲ အမြဲထပ်တူပြုပါ။",
  T_48_META_API_84_P0_D: "အထူးစိုးရိမ်ဖွယ် ပစ်မှတ်များ",
  T_48_META_API_84_P1_D: "လေ့လာသူ",
  T_48_META_API_85_D: "AOI အထူးအာရုံစိုက်မှုကို ဖယ်ရှားပြီး ပြင်ပမှ AOI ထပ်တူပြုခြင်းကို ပယ်ဖျက်ပါ။",
  T_48_META_API_85_P0_D: "အထူးစိုးရိမ်ဖွယ် ပစ်မှတ်များ",
  T_48_META_API_85_P1_D: "လေ့လာသူ",
  T_48_META_API_86_D: "သတ်မှတ်ထားသော ပစ်မှတ်၏ AOI အားလုံးကို ရှင်းလင်းပါ။",
  T_48_META_API_86_P0_D: "အထူးစိုးရိမ်ဖွယ် ပစ်မှတ်များ",
  T_48_META_API_87_D: "AOI အထူးစိုးရိမ်စရာရှိမရှိ ဆုံးဖြတ်ပါ။",
  T_48_META_API_87_P0_D: "အထူးစိုးရိမ်ဖွယ် ပစ်မှတ်များ",
  T_48_META_API_87_P1_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_API_87_R_D: "ရှိမရှိ",
  T_48_META_API_88_D: "ကစားသူ၏ ပရောက်စီစောင့်ကြည့်သူကို ပြောင်းရန်",
  T_48_META_API_88_P0_D: "ကစားသမား",
  T_48_META_API_88_P1_D: "proxy လေ့လာသူ",
  T_48_META_API_89_D: "ဇာတ်ကောင် ထိန်းချုပ်ကိရိယာကို တစ်ကြိမ် ရွှေ့လိုက်လျှင် ကစားသမားကို အကျိုးသက်ရောက်ပါက၊ ကစားသူသည် ရုပ်ပိုင်းဆိုင်ရာ သက်ရောက်မှုများကို အသုံးပြုသည့် ပလေယာ ထိန်းချုပ်ကိရိယာကို ဖွင့်ရပါမည်။",
  T_48_META_API_89_P0_D: "ပစ်မှတ်အရာဝတ္ထုသည် ကစားသမားဖြစ်လျှင် အကျိုးသက်ရောက်မှုရှိစေရန်အတွက် ရူပဗေဒကိုအသုံးပြု၍ ကစားသူထိန်းချုပ်ကိရိယာကို ကစားသမားကဖွင့်ရပါမည်။",
  T_48_META_API_89_P1_D: "displacement vector",
  T_48_META_API_9_D: "ဘေးကင်းဇုန်ယန္တရားကို ပိတ်ပါ ဘေးကင်းဇုန်ကို အနိမ့်ဆုံးသို့ လျှော့ချလိုက်သောအခါ ဘေးကင်းဇုန်ပြင်ပရှိ ကစားသမားများသည် ဘေးကင်းသောဇုန်ယန္တရားအား ပိတ်ပြီးနောက် ကစားသမားများ ပြန်လည်ဘေးကင်းမည်ဖြစ်သည်။",
  T_48_META_API_90_D: "ကစားသမားများ လွတ်လပ်စွာ ထွက်ခွင့်ရှိမရှိ သတ်မှတ်ပါ။",
  T_48_META_API_90_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_90_P1_D: "လွတ်လွတ်လပ်လပ် ထွက်နိုင်ပါ့မလား။",
  T_48_META_API_9000_D: "သတ်မှတ်ထားသော ကစားသမားများသာ မြင်နိုင်သော built-in UI ကို ဖန်တီးပါ။",
  T_48_META_API_9000_P0_D: "Built-in UI ကို ဖန်တီးထားသည်။",
  T_48_META_API_9000_P1_D: "UI ပါ၀င်သည့် ပလေယာ entity ကို ဤကစားသမားမှသာ မြင်နိုင်သည်။",
  T_48_META_API_9000_P2_D: "Built-in UI အမျိုးအစားများ",
  T_48_META_API_9001_D: "built-in ဂိမ်း UI ကို ဖယ်ရှားပါ။",
  T_48_META_API_9001_P0_D: "ဖယ်ရှားရန် Built-in UI entity",
  T_48_META_API_9002_D: "သတ်မှတ်ထားသော အိုင်ကွန်အမျိုးအစားကို အသုံးပြု၍ အိုင်ကွန်တစ်ခု ဖန်တီးရန် သတ်မှတ်ရန် လိုအပ်သော ဂုဏ်သတ္တိများ ရှိပါက၊ entity မှတစ်ဆင့် ၎င်း၏ entity ဂုဏ်သတ္တိများကို ထပ်မံသတ်မှတ်ပါ ( အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ CreateLevelObject ကို အသုံးပြုပါ)။",
  T_48_META_API_9002_P0_D: "ကုဒ်ကို အိုင်ကွန်ကို ဖန်တီးပေးသည့် တရားဝင် ကန့်သတ်ဘောင်၏ အမည်ကို ကိုယ်စားပြုရန် အသုံးပြုပြီး ၎င်း၏ သက်ဆိုင်ရာ ဒေသဆိုင်ရာ ပြောင်းလဲနိုင်သော တန်ဖိုးသည် အိုင်ကွန်ကို ဖန်တီးသည့် အရာဖြစ်သည်။",
  T_48_META_API_9002_P1_D: "၎င်းပိုင်ဆိုင်သည့် ကစားသမားအဖွဲ့အစည်းကို ဤကစားသမားကသာ မြင်နိုင်သည်။",
  T_48_META_API_9002_P2_D: "အရင်းအမြစ်လမ်းကြောင်း၊ ပလေယာမှရွေးချယ်ထားသောအိုင်ကွန်နှင့်သက်ဆိုင်သည့် အရင်းအမြစ်လမ်းကြောင်း",
  T_48_META_API_9003_D: "သတ်မှတ်ထားသော အိုင်ကွန်ကို ဖယ်ရှားပါ (ကန့်ကွက်ထားသော၊ ကျေးဇူးပြု၍ DeleteEntity ကိုသုံးပါ)",
  T_48_META_API_9003_P0_D: "ဖယ်ရှားရန် သင်္ကေတ",
  T_48_META_API_9004_D: "သတ်မှတ်ထားသော စာသားအကြောင်းအရာကို အသုံးပြု၍ စာသားတစ်ခုဖန်တီးရန် သတ်မှတ်ရန် လိုအပ်သော ဂုဏ်သတ္တိများရှိပါက၊ ၎င်း၏ entity ဂုဏ်သတ္တိများကို entity မှတဆင့် ထပ်မံသတ်မှတ်ပါ ( အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ CreateLevelObject ကို အသုံးပြုပါ)။",
  T_48_META_API_9004_P0_D: "ကုဒ်ကို စာသားအကြောင်းအရာကို ဖန်တီးပေးသည့် တရားဝင် ကန့်သတ်ဘောင်၏ အမည်ကို ကိုယ်စားပြုရန် အသုံးပြုပြီး ၎င်း၏ သက်ဆိုင်ရာ ဒေသဆိုင်ရာ ပြောင်းလဲနိုင်သော တန်ဖိုးသည် စာသားကို ဖန်တီးသည့် အရာဖြစ်သည်။",
  T_48_META_API_9004_P1_D: "၎င်းပိုင်ဆိုင်သည့် ကစားသမားအဖွဲ့အစည်းကို ဤကစားသမားကသာ မြင်နိုင်သည်။",
  T_48_META_API_9004_P2_D: "ပြန်ဆိုရမည့် စာသားအကြောင်းအရာ",
  T_48_META_API_9005_D: "သတ်မှတ်ထားသော စာသားကို ဖယ်ရှားပါ (ကန့်ကွက်ထားသော၊ ကျေးဇူးပြု၍ DeleteEntity ကိုသုံးပါ)",
  T_48_META_API_9005_P0_D: "ဖယ်ရှားရန် စာသားအကြောင်းအရာ",
  T_48_META_API_9006_D: "သတ်မှတ်ထားသော အကျိုးသက်ရောက်မှု အမျိုးအစားကို အသုံးပြု၍ အိုင်ကွန်တစ်ခု ဖန်တီးရန် သတ်မှတ်ရန် လိုအပ်သော ဂုဏ်သတ္တိများရှိပါက၊ ၎င်း၏ entity ဂုဏ်သတ္တိများကို entity မှတဆင့် ထပ်မံသတ်မှတ်ပါ ( အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ CreateEffect ကို အသုံးပြုပါ)။",
  T_48_META_API_9006_P0_D: "ကုဒ်ကို အထူးအကျိုးသက်ရောက်မှုအဖွဲ့အစည်းကို ဖန်တီးပေးသည့် တရားဝင် ကန့်သတ်ဘောင်၏အမည်ကို ကိုယ်စားပြုရန် အသုံးပြုပြီး ၎င်း၏ သက်ဆိုင်ရာ ဒေသဆိုင်ရာ ပြောင်းလဲနိုင်သော တန်ဖိုးသည် အထူးအကျိုးသက်ရောက်မှုကို ဖန်တီးပေးသည့် အရာဖြစ်သည်။",
  T_48_META_API_9006_P1_D: "၎င်းပိုင်ဆိုင်သည့် ကစားသမားအဖွဲ့အစည်းကို ဤကစားသမားကသာ မြင်နိုင်သည်။",
  T_48_META_API_9006_P2_D: "အထူးအကျိုးသက်ရောက်မှုအမျိုးအစား၊ ကစားသမားရွေးချယ်နိုင်သောအထူးအကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_48_META_API_9007_D: "သတ်မှတ်ထားသောအကျိုးသက်ရောက်မှုကို ဖယ်ရှားပါ (ကန့်ကွက်ထားသော၊ ကျေးဇူးပြု၍ DeleteEntity ကိုသုံးပါ)",
  T_48_META_API_9007_P0_D: "ဖယ်ရှားရန် အကျိုးသက်ရောက်မှုရှိခြင်း။",
  T_48_META_API_9008_D: "သတ်မှတ်ထားသော ကစားသမားများသာ မြင်နိုင်သော စိတ်ကြိုက် UI ကို ဖန်တီးပါ။",
  T_48_META_API_9008_P0_D: "စိတ်ကြိုက် UI အကြောင်းအရာများကို ဖန်တီးထားသည်။",
  T_48_META_API_9008_P1_D: "UI ပါ၀င်သည့် ပလေယာ entity ကို ဤကစားသမားမှသာ မြင်နိုင်သည်။",
  T_48_META_API_9008_P2_D: "စိတ်ကြိုက် UI အညွှန်း",
  T_48_META_API_9009_D: "စိတ်ကြိုက်ဂိမ်း UI ကို ဖယ်ရှားပါ။",
  T_48_META_API_9009_P0_D: "ဖယ်ရှားရန် စိတ်ကြိုက် UI အကြောင်းအရာ",
  T_48_META_API_9010_D: "စိတ်ကြိုက် UI မှ UI ထိန်းချုပ်မှုများကို ရယူပါ။",
  T_48_META_API_9010_P0_D: "UI ပိုင်သည့် ပလေယာပစ္စည်း",
  T_48_META_API_9010_P1_D: "စိတ်ကြိုက် UI ပစ္စည်းများ",
  T_48_META_API_9010_P2_D: "ထူးခြားသောအညွှန်းကိုထိန်းချုပ်ပါ။",
  T_48_META_API_9010_R_D: "UI ထိန်းချုပ်မှုစနစ်",
  T_48_META_API_9011_D: "သတ်မှတ်ထားသော အသံအကျိုးသက်ရောက်မှုကို သတ်မှတ်ရန် လိုအပ်သည့် နောက်ထပ် ဂုဏ်သတ္တိများရှိပါက၊ entity မှတဆင့် ၎င်း၏ entity ဂုဏ်သတ္တိများကို ထပ်မံသတ်မှတ်ပါ ( အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ CreateSound ကို အသုံးပြုပါ)။",
  T_48_META_API_9011_P0_D: "ကုဒ်သည် အသံအကျိုးသက်ရောက်မှုကို ဖန်တီးပေးသည့် တရားဝင် ကန့်သတ်ဘောင်၏ အမည်ကို ကိုယ်စားပြုရန်အတွက် အသုံးပြုပြီး ၎င်း၏ သက်ဆိုင်ရာ ဒေသဆိုင်ရာ ပြောင်းလဲနိုင်သော တန်ဖိုးသည် အသံအကျိုးသက်ရောက်မှုကို ဖန်တီးပေးသည့် အရာဖြစ်သည်။",
  T_48_META_API_9011_P1_D: "၎င်းပိုင်ဆိုင်သည့် ကစားသမားအဖွဲ့အစည်းကို ဤကစားသမားကသာ မြင်နိုင်သည်။",
  T_48_META_API_9011_P2_D: "အသံအကျိုးသက်ရောက်မှုအမျိုးအစား၊ ကစားသမားများရွေးချယ်နိုင်သော အသံအကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_48_META_API_9012_D: "သတ်မှတ်ထားသော အသံအကျိုးသက်ရောက်မှုကို ဖယ်ရှားပါ (ကန့်ကွက်ထားသော၊ ကျေးဇူးပြု၍ DeleteEntity ကိုသုံးပါ)",
  T_48_META_API_9012_P0_D: "သံယောဇဉ် အလျောက် ဖယ်ရှားရန်",
  T_48_META_API_9013_D: "စိတ်ကြိုက် UI မှ လမ်းကြောင်းကို အသုံးပြု၍ UI ထိန်းချုပ်မှုကို ရယူပါ။",
  T_48_META_API_9013_P0_D: "UI ပိုင်သည့် ပလေယာပစ္စည်း",
  T_48_META_API_9013_P1_D: "စိတ်ကြိုက် UI",
  T_48_META_API_9013_P2_D: "ထိန်းချုပ်ရေးလမ်းကြောင်း",
  T_48_META_API_9013_R_D: "UI ထိန်းချုပ်မှုစနစ်",
  T_48_META_API_9014_D: "ဖွင့်နေသည့် အသံဖိုင်ကို အနှောင့်အယှက်ပေးသည် (ကန့်ကွက်ထားသည်၊ ခေတ္တနားရန် အသံကို အသုံးပြုပါ)",
  T_48_META_API_9014_P0_D: "ခေတ္တရပ်ရန် လိုအပ်သော အသံအကျိုးသက်ရောက်မှု အကြောင်းအရာ",
  T_48_META_API_9015_D: "အသံအကျိုးသက်ရောက်မှုကို ဆက်ကစားရန်၊ အစမှစတင်တီးခြင်းရှိမရှိ သင်ရွေးချယ်နိုင်သည် ( အသုံးမပြုတော့ပါ၊ ResumeSound ကိုအသုံးပြုပါ)",
  T_48_META_API_9015_P0_D: "ခေတ္တရပ်ပြီးနောက် ဆက်လက်ဖွင့်ရန် လိုအပ်သည့် အသံအကျိုးသက်ရောက်မှုများ",
  T_48_META_API_9015_P1_D: "အစကနေစမှာလား။",
  T_48_META_API_9016_D: "စိတ်ကြိုက် UI ထိန်းချုပ်မှုများကို ဖန်တီးပါ။",
  T_48_META_API_9016_P0_D: "စိတ်ကြိုက်ထိန်းချုပ်မှုတစ်ခုကို ဖန်တီးထားသည်။",
  T_48_META_API_9016_P1_D: "ဖန်တီးထားတဲ့ ထိန်းချုပ်မှုအမျိုးအစား",
  T_48_META_API_9016_P2_D: "UI အဖွဲ့အစည်းနှင့် သက်ဆိုင်သည်။",
  T_48_META_API_9016_P3_D: "၎င်းပိုင်ဆိုင်သည့် ပင်မထိန်းချုပ်မှုအား ဗလာဖြင့် ချန်ထားခဲ့ပါက ၎င်းတွင် ပိုင်ဆိုင်သည့် UI သည် ပင်မညိတ်ဖြစ်လိမ့်မည်။",
  T_48_META_API_9017_D: "ပစ်မှတ်ကင်မရာအလွှာမျက်နှာဖုံးကို သတ်မှတ်ပါ။",
  T_48_META_API_9017_P0_D: "ပစ်မှတ်ကင်မရာအဖွဲ့အစည်း",
  T_48_META_API_9017_P1_D: "အလွှာမျက်နှာဖုံး၊ ဖြည့်ထားသော အလွှာများကိုသာ ပစ်မှတ်ကင်မရာတွင် ပြသမည်ဖြစ်ပြီး အလွတ်ထား၍ ဆိုလိုသည်မှာ အလွှာအားလုံးကို ပြသမည်ဖြစ်သည်။",
  T_48_META_API_9018_D: "ပစ်မှတ်ကင်မရာအလွှာမျက်နှာဖုံးကို ရယူပါ။",
  T_48_META_API_9018_P0_D: "ပစ်မှတ်ကင်မရာအဖွဲ့အစည်း",
  T_48_META_API_9018_R_D: "အလွှာမျက်နှာဖုံး၊ အလွှာမျက်နှာဖုံးအတွင်းရှိ အလွှာများကိုသာ ပစ်မှတ်ကင်မရာတွင် ပြသပါမည်။",
  T_48_META_API_9019_D: "သတ်မှတ်ထားသောအဆင့်ကို ပစ်မှတ်ကင်မရာတွင် မြင်နိုင်မလား။",
  T_48_META_API_9019_P0_D: "ပစ်မှတ်ကင်မရာအဖွဲ့အစည်း",
  T_48_META_API_9019_P1_D: "မြင်နိုင်စွမ်းအဆင့်",
  T_48_META_API_9019_P2_D: "မြင်နိုင်သည်ဖြစ်စေ၊",
  T_48_META_API_9020_D: "ပစ်မှတ်ကစားသမား၏ ပုံသေအင်တာဖေ့စ်မြင်နိုင်မှုအခြေအနေကို သတ်မှတ်ပါ။",
  T_48_META_API_9020_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_9020_P1_D: "ပလေယာ အင်တာဖေ့စ် အမျိုးအစား ကစားသမား အင်တာဖေ့စ် အမျိုးအစား သည် ကစားသမားများနှင့် ကစားသမားနှင့် ပတ်သက်သည့် အကြောင်းအရာကို ထိန်းချုပ်ရန် အသုံးပြုသည့် UI အစိတ်အပိုင်း တစ်ခု ဖြစ်သည်။",
  T_48_META_API_9020_P2_D: "ခလုတ်တန်ဖိုးသည် ပလေယာအင်တာဖေ့စ်၏ မြင်နိုင်စွမ်းကို ဆုံးဖြတ်သည်။",
  T_48_META_API_9021_D: "အချိန်တံဆိပ်ကို ဒေသန္တရပြုထားသော စာကြောင်းတစ်ခု ဖန်တီးပါ။",
  T_48_META_API_9021_P0_D: "အချိန်တံဆိပ်",
  T_48_META_API_9021_P1_D: "ဖော်မတ်ပုံစံ",
  T_48_META_API_9021_R_D: "တိုင်းမ်တံဆိပ်ကို ဒေသအလိုက်သတ်မှတ်ခြင်း စာကြောင်း",
  T_48_META_API_9022_D: "မြေပုံအသေးစားအိုင်ကွန် ဖန်တီးပါ။",
  T_48_META_API_9022_P0_D: "မြေပုံအသေးစားအိုင်ကွန်ကို ဖန်တီးထားသည်။",
  T_48_META_API_9022_P1_D: "ဖန်တီးထားသည့် မြေပုံအသေးစားအိုင်ကွန်ကို ကစားသူနှင့်သာ သက်ဆိုင်ပါသည်။",
  T_48_META_API_9022_P2_D: "Minimap icon အရင်းအမြစ်လမ်းကြောင်း",
  T_48_META_API_9023_D: "သတ်မှတ်ထားသော အထူးအကျိုးသက်ရောက်မှု အမျိုးအစားကို အသုံးပြု၍ သတ်မှတ်ရန် လိုအပ်သော ဂုဏ်သတ္တိများ ရှိပါက၊ entity မှတဆင့် ၎င်း၏ entity ဂုဏ်သတ္တိများကို ထပ်မံသတ်မှတ်ပါ။",
  T_48_META_API_9023_P0_D: "ကုဒ်ကို အထူးအကျိုးသက်ရောက်မှုအဖွဲ့အစည်းကို ဖန်တီးပေးသည့် တရားဝင် ကန့်သတ်ဘောင်၏အမည်ကို ကိုယ်စားပြုရန် အသုံးပြုပြီး ၎င်း၏ သက်ဆိုင်ရာ ဒေသဆိုင်ရာ ပြောင်းလဲနိုင်သော တန်ဖိုးသည် အထူးအကျိုးသက်ရောက်မှုကို ဖန်တီးပေးသည့် အရာဖြစ်သည်။",
  T_48_META_API_9023_P1_D: "၎င်းပိုင်ဆိုင်သည့် ကစားသမားအဖွဲ့အစည်းကို ဤကစားသမားကသာ မြင်နိုင်သည်။",
  T_48_META_API_9023_P2_D: "အထူးအကျိုးသက်ရောက်မှုအမျိုးအစား၊ ကစားသမားရွေးချယ်နိုင်သောအထူးအကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_48_META_API_9024_D: "သတ်မှတ်ထားသောအကျိုးသက်ရောက်မှုကို ဖယ်ရှားပါ (ကန့်ကွက်ထားသော၊ ကျေးဇူးပြု၍ DeleteEntity ကိုသုံးပါ)",
  T_48_META_API_9024_P0_D: "ဖယ်ရှားရန် အကျိုးသက်ရောက်မှုရှိခြင်း။",
  T_48_META_API_9025_D: "ပစ်မှတ်အရာဝတ္တုအတွက် မြေပုံပေါ်တွင် အငြိမ်ပစ်ဇယ်များကို ဖန်တီးခြင်းများသည် ပစ်မှတ်အရာဝတ္ထုနှင့်အတူ ရွေ့လျားမည်မဟုတ်ပါ။",
  T_48_META_API_9025_P0_D: "static pixel entity ကို ဖန်တီးထားသည်။",
  T_48_META_API_9025_P1_D: "ကစားသမားပိုင်၊ ဖန်တီးထားသည့် အငြိမ်ပစ်ဇယ်ကို ပလေယာမှသာ မြင်နိုင်သည်။",
  T_48_META_API_9025_P2_D: "ပစ်မှတ်အရာဝတ္တု",
  T_48_META_API_9026_D: "ပစ်မှတ်ကစားသမား၏ မြေပုံအသေးစားကို ရယူပါ။",
  T_48_META_API_9026_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_9026_R_D: "လက်ရှိကစားသမားအသေးစားမြေပုံ",
  T_48_META_API_9027_D: "ကစားသမား၏ပြိုလဲပျက်စီးမှုကိုသတ်မှတ်ရန်ကွဲပြားခြားနားသောအပျက်အစီးများကိုအမြင့်အလိုက်သတ်မှတ်နိုင်သည်။",
  T_48_META_API_9027_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_9027_P1_D: "အလွန်ခွဲခြားထားသောစာရင်း",
  T_48_META_API_9027_P2_D: "ပျက်စီးဆုံးရှုံးမှုစာရင်း",
  T_48_META_API_91_D: "သတ်မှတ်ထားသောအဖွဲ့သို့ ပစ်မှတ်ကို ပေါင်းထည့်ခြင်းသည် ပစ်မှတ်ကို မူလအဖွဲ့မှ ထွက်ခွာသွားစေမည်ဖြစ်သည်။",
  T_48_META_API_91_P0_D: "အသင်းအတွက် လိုအပ်သောဂိုးများ",
  T_48_META_API_91_P1_D: "ပါဝင်မည့်အဖွဲ့များ",
  T_48_META_API_91_P2_D: "အောင်မြင်သလား။",
  T_48_META_API_92_D: "ပစ်မှတ်ကို အသင်းသစ်တစ်ခုသို့ ပေါင်းထည့်ခြင်းဖြင့် ပစ်မှတ်သည် မူလအသင်းမှ ထွက်ခွာသွားမည်ဖြစ်သည်။",
  T_48_META_API_92_P0_D: "အသင်းအတွက် လိုအပ်သောဂိုးများ",
  T_48_META_API_92_P1_D: "အသင်းနာမည်အသစ်",
  T_48_META_API_92_P2_D: "အောင်မြင်သလား။",
  T_48_META_API_94_D: "Set the value of a local variable by index; before setting, the variable must be defined in the current call process ",
  T_48_META_API_94_P0: "Index",
  T_48_META_API_94_P0_D: "Get a variable by index ",
  T_48_META_API_94_P1: "Variable Value",
  T_48_META_API_94_P1_D: "Target variable value ",
  T_48_META_API_94_P2: "Arithmetic Type",
  T_48_META_API_94_P2_D: "Operation method; all types support assignment, and numeric types also support increment, decrement, multiplication, division, and modulus operations ",
  T_48_META_API_94_P3: "Variable Name",
  T_48_META_API_94_P3_D: "Target variable name. Used only for error output ",
  T_48_META_API_95: "Get Local Variable by Index",
  T_48_META_API_95_D: "Get the value of a local variable; before getting, the variable must be defined in the current call process ",
  T_48_META_API_95_P0: "Index",
  T_48_META_API_95_P0_D: "Variable index ",
  T_48_META_API_95_P1: "Variable Name",
  T_48_META_API_95_P1_D: "Target variable name. Used only for error output ",
  T_48_META_API_9500_D: "အထူးအကျိုးသက်ရောက်မှုများကိုကစားရန် ပစ်မှတ်ကစားသမား၏ဖောက်သည်အား အသိပေးပါ။",
  T_48_META_API_9500_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_9500_P1_D: "အထူးသက်ရောက်မှု အရင်းအမြစ်လမ်းကြောင်း",
  T_48_META_API_9500_P2_D: "အရောင်",
  T_48_META_API_9500_P3_D: "ဇူးမ်အရွယ်အစား၊ မူရင်းမှာ 1 ဖြစ်သည်။",
  T_48_META_API_9500_P4_D: "Binding Object၊ အထူးအကျိုးသက်ရောက်မှုများကို ၎င်း၏ကလေးဆုံမှတ်များအဖြစ် ပူးတွဲလုပ်ဆောင်ပါမည်။",
  T_48_META_API_9500_P5_D: "ကမ်မနိတ် နှိုင်းယှဥ် နှောင်ဖွဲ့သည်။",
  T_48_META_API_9501_D: "အသံအကျိုးသက်ရောက်မှုကို ဖွင့်ရန် ပစ်မှတ်ကစားသမား၏ သုံးစွဲသူအား အသိပေးသည်။",
  T_48_META_API_9501_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_9501_P1_D: "အသံအကျိုးသက်ရောက်မှုအမျိုးအစား",
  T_48_META_API_9502_D: "floating ဟူသောစကားလုံးကိုပြသရန်ပစ်မှတ်ကစားသမား၏ဖောက်သည်အားအကြောင်းကြားပါ။",
  T_48_META_API_9502_P0_D: "ပစ်မှတ်ကစားသမားများ",
  T_48_META_API_9502_P1_D: "Piaozi အကြောင်းအရာ",
  T_48_META_API_9502_P2_D: "စာလုံး၏အရောင်၊ အမျိုးအစားသည် အရောင်ဖြစ်သည်။",
  T_48_META_API_9502_P3_D: "ရေပေါ်ဇာတ်ကောင်များ၏ ကြာချိန်သည် မီလီစက္ကန့်များဖြစ်သည်။",
  T_48_META_API_9503_D: "ပစ်မှတ်ယူနစ်အား Emote လုပ်ဆောင်ချက်ဖော်ပြချက်ကို တစ်ကြိမ်ဖွင့်စေပါသည်။",
  T_48_META_API_9503_P0_D: "Emote ကစားရန် ပန်းတိုင်",
  T_48_META_API_9503_P1_D: "Emote အမျိုးအစား",
  T_48_META_API_9504_D: "ယူနစ်၏ Emote လုပ်ဆောင်ချက်ဖော်ပြချက်ကို ခေတ္တရပ်ရန်/ပြန်လည်စတင်ပါ။",
  T_48_META_API_9504_P0_D: "Emote ပစ်မှတ်များကို ခဏရပ်/ပြန်စပါ။",
  T_48_META_API_9504_P1_D: "မှန်သည်- ပြန်ဖွင့်ခြင်းကို ခေတ္တရပ်ပါ၊ မှားသည်- ပြန်ဖွင့်ပါ။",
  T_48_META_EVT_1_D: "ဂိမ်းစတင်သောအခါတွင် ဆာဗာသည် ကလိုင်းယင့်ထက် အချိန်အနည်းငယ်စောပြီး အသင့်ဖြစ်လိမ့်မည်။",
  T_48_META_EVT_10_D: "လက်ရှိအဖွဲ့အစည်းသည် ပျက်စီးမှုမဖြစ်မီ အစပျိုးမှုများ",
  T_48_META_EVT_10_P0_D: "Attacker entity သည် ဗလာဖြစ်နိုင်သည်။",
  T_48_META_EVT_10_P1_D: "ပျက်စီးမှုအမျိုးအစား",
  T_48_META_EVT_10_P2_D: "ပျက်စီးဆုံးရှုံးမှုပမာဏ",
  T_48_META_EVT_10_P3_D: "ဒဏ်ရာရတဲ့အပိုင်း",
  T_48_META_EVT_1000_D: "ကစားသမား အမှတ်များ ပြောင်းလဲသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_1000_P0_D: "အမှတ်များ ပြောင်းလဲသွားသော ကစားသမားများ",
  T_48_META_EVT_1000_P1_D: "ပြောင်းလဲမှုအချက်များ အမျိုးအစား",
  T_48_META_EVT_1000_P2_D: "ပေါင်းစည်းပြောင်းလဲမှုပြီးနောက် ပေါင်းစပ်တန်ဖိုး",
  T_48_META_EVT_1001_D: "အသင်းရမှတ်များ ပြောင်းလဲသောအခါ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_1001_P0_D: "အမှတ်များသောအသင်းများ ပြောင်းလဲခြင်း။",
  T_48_META_EVT_1001_P1_D: "ပြောင်းလဲမှုအချက်များ အမျိုးအစား",
  T_48_META_EVT_1001_P2_D: "ပေါင်းစည်းပြောင်းလဲမှုပြီးနောက် ပေါင်းစပ်တန်ဖိုး",
  T_48_META_EVT_1002_D: "ကစားသမားအဆင့်သတ်မှတ်ချက် ပြောင်းလဲသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_1002_P0_D: "အဆင့်သတ်မှတ်ချက် ပြောင်းလဲသွားသော ကစားသမားများ",
  T_48_META_EVT_1002_P1_D: "အဆင့်သတ်မှတ်ပြီးနောက် အဆင့်ပြောင်းလဲခြင်း။",
  T_48_META_EVT_1003_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_EVT_1003_P0_D: "ကန့်ကွက်ထားသည်။",
  T_48_META_EVT_1003_P1_D: "အဆင့်သတ်မှတ်ပြီးနောက် အဆင့်ပြောင်းလဲခြင်း။",
  T_48_META_EVT_11_D: "ကစားသမား ထွက်သွားသောအခါ မီးလောင်သည်။",
  T_48_META_EVT_11_P0_D: "နုတ်ထွက်ခဲ့တဲ့ ကစားသမားတွေပါ။",
  T_48_META_EVT_12_D: "ပလေယာထိန်းချုပ်သူသည် အရာတစ်ခုအား ထိသောအခါတွင် ထိန်းချုပ်ကိရိယာကို တက်ကြွစွာ လှုပ်ရှားသည့်အခါမှသာ အစပျိုးမည်ဖြစ်သည်။",
  T_48_META_EVT_12_P0_D: "အဖွဲ့အစည်းများ ကြုံတွေ့ခဲ့ရသည်။",
  T_48_META_EVT_13_D: "လက်ရှိအဖွဲ့အစည်းသည် ပျက်စီးဆုံးရှုံးမှုများကို မဖြေရှင်းမီ အစပျိုးမှုများ",
  T_48_META_EVT_13_P0_D: "ဘဘ နစ်နာတယ်။",
  T_48_META_EVT_13_P1_D: "ပျက်စီးမှုအမျိုးအစား",
  T_48_META_EVT_13_P2_D: "ပျက်စီးဆုံးရှုံးမှုပမာဏ",
  T_48_META_EVT_13_P3_D: "ဒဏ်ရာရတဲ့အပိုင်း",
  T_48_META_EVT_14_D: "playable entity loops သည် အချိန်တိုင်း အစပျိုးသည်",
  T_48_META_EVT_2_D: "ယုတ္တိဘောင်ကို အပ်ဒိတ်လုပ်သောအခါ အစပျိုးလိုက်သည့် အကြိမ်ရေသည် ပလက်ဖောင်းနှင့် ဆက်တင်များပေါ်မူတည်၍ ကွဲပြားလိမ့်မည်။",
  T_48_META_EVT_2002_D: "ကစားသမားသေဆုံးသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_2002_P0_D: "ကစားသမားသေ",
  T_48_META_EVT_2003_D: "ကစားသမားတစ်ဦးရဲ့ ပံ့ပိုးမှုပေးတဲ့အခါ အစပျိုးခဲ့ပါတယ်။",
  T_48_META_EVT_2003_P0_D: "ပံ့ပိုးကူညီမှုရရှိသော ကစားသမားများ",
  T_48_META_EVT_2003_P1_D: "အသတ်ခံရတဲ့ကစားသမား",
  T_48_META_EVT_2004_D: "ကစားသမားက ပျက်စီးမှု ပေးတဲ့အခါ အစပျိုးပါတယ်။",
  T_48_META_EVT_2004_P0_D: "ပျက်စီးစေသော ကစားသမား",
  T_48_META_EVT_2004_P1_D: "ကစားသမားတွေ ထိခိုက်ဒဏ်ရာရတယ်။",
  T_48_META_EVT_2004_P2_D: "ပျက်စီးမှုအမျိုးအစား",
  T_48_META_EVT_2004_P3_D: "ပျက်စီးခြင်း။",
  T_48_META_EVT_2004_P4_D: "ဒဏ်ရာရတဲ့အပိုင်း",
  T_48_META_EVT_2005_D: "ကစားသမားတစ်ဦးကိုသတ်ပစ်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_2005_P0_D: "အသတ်ခံရသော ကစားသမား",
  T_48_META_EVT_2005_P1_D: "အသတ်ခံရတဲ့ကစားသမား",
  T_48_META_EVT_2005_P2_D: "ပျက်စီးမှုအမျိုးအစား",
  T_48_META_EVT_2006_D: "ကစားသမားတစ်ဦးသည် ဂိမ်းတွင်ပါဝင်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_2006_P0_D: "ဂိမ်းတွင်ပါဝင်သည့်ကစားသမားများ",
  T_48_META_EVT_2007_D: "ကစားသမား ပြန်လည်ရှင်သန်လာသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_2007_P0_D: "ရှင်ပြန်ထမြောက်သောကစားသမား",
  T_48_META_EVT_2007_P1_D: "ရှင်ပြန်ထမြောက်ခြင်းအရင်းအမြစ်",
  T_48_META_EVT_2008_D: "ကစားသမား ပြုတ်ကျသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_2008_P0_D: "downed player",
  T_48_META_EVT_2008_P1_D: "တိုက်စစ်ကစားသမား",
  T_48_META_EVT_2009_D: "ပလေယာ ချိတ်ဆက်မှု ပြတ်တောက်သွားသောအခါတွင် မီးပွင့်သည်။",
  T_48_META_EVT_2009_P0_D: "အဆက်ပြတ်သွားလေရာ",
  T_48_META_EVT_2010_D: "ပလေယာ ပြန်လည်ချိတ်ဆက်သောအခါတွင် မီးလောင်ကျွမ်းသည်။",
  T_48_META_EVT_2010_P0_D: "ကစားသမားများ ပြန်လည်ချိတ်ဆက်ခြင်း။",
  T_48_META_EVT_2100_D: "အသင်းကို ဖယ်ရှားလိုက်တာနဲ့ အစပျိုးခဲ့ပါတယ်။",
  T_48_META_EVT_2100_P0_D: "အဖွဲ့ကို ဖယ်ရှားခဲ့သည်။",
  T_48_META_EVT_2101_D: "အဖွဲ့တစ်ဖွဲ့ပေါင်းထည့်သောအခါ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_2101_P0_D: "အသင်းတွေ ထပ်ထည့်တယ်။",
  T_48_META_EVT_2102_D: "အသင်းပျက်တဲ့အခါ အစပျိုးတယ်။",
  T_48_META_EVT_2102_P0_D: "သုတ်သင်ခံခဲ့ရသောအဖွဲ့",
  T_48_META_EVT_3_D: "ဂိမ်းပြီးဆုံးသည့်အခါ ဤအစီအစဉ်ကို ဆာဗာပေါ်တွင် ဂိမ်းမပြီးဆုံးမီ အလုပ်ထုတ်သည်။",
  T_48_META_EVT_30_D: "မြင်ကွင်းကို အောင်မြင်စွာ တင်ပေးသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_30_P0_D: "မြင်ကွင်းအမည်",
  T_48_META_EVT_3000_D: "လက်ရှိအကြောင်းအရာကို ဖန်တီးပြီးနောက် မီးလောင်မှုများ",
  T_48_META_EVT_3001_D: "လက်ရှိအဖွဲ့အစည်းကို မဖျက်ဆီးမီ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3002_D: "ပလေယာသည် ခလုတ်ကို ဝင်လာသောအခါ မီးလောင်သည်။",
  T_48_META_EVT_3002_P0_D: "player သည် trigger ကိုဝင်ရောက်သည်။",
  T_48_META_EVT_3003_D: "ကစားသမားက ခလုတ်ကို ထွက်သွားတဲ့အခါ မီးလောင်တယ်။",
  T_48_META_EVT_3003_P0_D: "player တွေ ထွက်လာတယ်။",
  T_48_META_EVT_3004_D: "UI ခလုတ်ကို နှိပ်ပြီးနောက် ထိန်းချုပ်မှုကို ဖယ်ရှားခဲ့သည်။",
  T_48_META_EVT_3004_P0_D: "ဘာညာ ကလစ်",
  T_48_META_EVT_3005_D: "Built-in UI တွင် ခလုတ်တစ်ခုကို နှိပ်လိုက်သောအခါ အလုပ်ထုတ်သည်",
  T_48_META_EVT_3005_P0_D: "နှိပ်ထားသော ခလုတ်၏ အမည်ကို ထိန်းချုပ်ပါ။",
  T_48_META_EVT_3006_D: "ကစားသမားသည် Wakeboard ကိုအသုံးပြုသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3007_D: "လက်ရှိ entity ရရှိနိုင်ပြီးနောက် မီးလောင်မှုများ",
  T_48_META_EVT_3008_D: "လက်ရှိအဖွဲ့အစည်းကို မရရှိနိုင်ပြီးနောက် မီးလောင်မှုများ",
  T_48_META_EVT_3009_D: "အဖွဲ့အစည်းသည် အစပျိုးမှုထဲသို့ ဝင်ရောက်သည့်အခါ ဖြစ်ရပ်ကို အစပျိုးလိုက်သောအခါ၊ ပါတီနှစ်ခုလုံးသည် အဖြစ်အပျက်ကို လက်ခံရရှိသည် ။",
  T_48_META_EVT_3009_P0_D: "အစပျိုး ဖြစ်ရပ် ဖြစ်ပွားသည့်အခါ ပြိုင်ဘက်အဖွဲ့အစည်း",
  T_48_META_EVT_3010_D: "ဖြစ်ရပ်ကို အစပျိုးလိုက်သောအခါတွင် အဖွဲ့အစည်းက အစပျိုးလိုက်သောအခါ၊ ပါတီနှစ်ခုလုံးသည် အဖြစ်အပျက်ကို လက်ခံရရှိသည် ။",
  T_48_META_EVT_3010_P0_D: "အစပျိုး ဖြစ်ရပ် ဖြစ်ပွားသည့်အခါ ပြိုင်ဘက်အဖွဲ့အစည်း",
  T_48_META_EVT_3011_D: "လက်ရှိအဖွဲ့အစည်းကို ဖျက်ဆီးပြီးနောက် အစပျိုးသည်။",
  T_48_META_EVT_3011_P0_D: "Attacker entity သည် ဗလာဖြစ်နိုင်သည်။",
  T_48_META_EVT_3011_P1_D: "ပျက်စီးမှုအမျိုးအစား",
  T_48_META_EVT_3011_P2_D: "ဒဏ်ရာရတဲ့အပိုင်း",
  T_48_META_EVT_3012_D: "လက်ရှိအဖွဲ့အစည်းကို တိုက်ခိုက်ပြီးနောက် အစပျိုးသည်။",
  T_48_META_EVT_3012_P0_D: "Attacker entity သည် ဗလာဖြစ်နိုင်သည်။",
  T_48_META_EVT_3012_P1_D: "ပျက်စီးမှုအမျိုးအစား",
  T_48_META_EVT_3012_P2_D: "ပျက်စီးဆုံးရှုံးမှုပမာဏ",
  T_48_META_EVT_3012_P3_D: "ဒဏ်ရာရတဲ့အပိုင်း",
  T_48_META_EVT_3013_D: "လက်ရှိ entity သည် ပျက်စီးမှုကို ပေးဆောင်ပြီးနောက် အစပျိုးမှုများ",
  T_48_META_EVT_3013_P0_D: "ဘဘ နစ်နာတယ်။",
  T_48_META_EVT_3013_P1_D: "ပျက်စီးမှုအမျိုးအစား",
  T_48_META_EVT_3013_P2_D: "ပျက်စီးဆုံးရှုံးမှုပမာဏ",
  T_48_META_EVT_3013_P3_D: "ဒဏ်ရာရတဲ့အပိုင်း",
  T_48_META_EVT_3014_D: "လက်ရှိအဖွဲ့အစည်းသည် အခြားအရာများကို ဖျက်ဆီးပြီးနောက် အစပျိုးသည်။",
  T_48_META_EVT_3014_P0_D: "ဖျက်ဆီးခံရသည့်အလျောက်",
  T_48_META_EVT_3014_P1_D: "ဒဏ်ရာရတဲ့အပိုင်း",
  T_48_META_EVT_3015_D: "ကစားသမား ပြန်လည်ရှင်သန်လာသောအခါတွင် အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3015_P0_D: "ကစားသမား ရှင်ပြန်ထမြောက်ခြင်း အရင်းအမြစ် အမျိုးအစား",
  T_48_META_EVT_3016_D: "ဂျင်နရေတာမှ ပစ္စည်းတစ်ခုထုတ်ပေးသောအခါ မီးလောင်ကျွမ်းသည်။",
  T_48_META_EVT_3016_P0_D: "ထုတ်ပေးသည့် အဖွဲ့အစည်းစာရင်း",
  T_48_META_EVT_3016_P1_D: "လှိုင်းနံပါတ်",
  T_48_META_EVT_3017_D: "ကစားသမားသည် ဒူးထောက်သည့်အနေအထားသို့ ရောက်သွားသောအခါ ခေါ်သည်။",
  T_48_META_EVT_3018_D: "အဖွဲ့သားအားလုံးသေဆုံးသောအခါ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3019_D: "ခမောက်၊ ကိုယ်ထည် ချပ်ဝတ်တန်ဆာ သို့မဟုတ် ကျောပိုးအိတ် တပ်ဆင်ထားသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3019_P0_D: "စက်ပစ္စည်း ID",
  T_48_META_EVT_3020_D: "လက်သီးပြောင်းသည့်အခါ အပါအဝင် အဓိက၊ အလယ်တန်း သို့မဟုတ် မီလီလက်နက်ကို ကိုင်ဆောင်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3020_P0_D: "အစပျိုးချိန်မှာ တပ်ဆင်ထားတဲ့ လက်နက်",
  T_48_META_EVT_3021_D: "prop ကိုအသုံးပြုပြီးနောက် အစပျိုးလိုက်သည်မှာ အချိန်လိုအပ်သော Props များကို အသုံးပြုပြီးပါက ဤဖြစ်ရပ်ကို အစပျိုးပေးမည်ဖြစ်သည်။",
  T_48_META_EVT_3021_P0_D: "Prop ID",
  T_48_META_EVT_3021_P1_D: "prop entity သည် ဗလာဖြစ်နိုင်သည်။",
  T_48_META_EVT_3021_P2_D: "props များကို အသုံးပြု၍ ဖန်တီးထားသော prop entity အသစ်သည် ဗလာဖြစ်နိုင်သည်။",
  T_48_META_EVT_3022_D: "ပစ္စည်းတစ်ခုရရှိသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3022_P0_D: "ပစ္စည်းအမျိုးအစား",
  T_48_META_EVT_3022_P1_D: "အရာဝတ္တုသည် ဗလာဖြစ်နိုင်သည်။",
  T_48_META_EVT_3023_D: "အကြောင်းအရာ ရမှတ်များ ပြောင်းလဲသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3023_P0_D: "ပြောင်းလဲမှုအချက်များ အမျိုးအစား",
  T_48_META_EVT_3023_P1_D: "ပေါင်းစည်းပြောင်းလဲမှုပြီးနောက် ပေါင်းစပ်တန်ဖိုး",
  T_48_META_EVT_3024_D: "အဖွဲ့အစည်းတစ်ခု၏ အဆင့်သတ်မှတ်ချက် ပြောင်းလဲသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3024_P0_D: "အဆင့်သတ်မှတ်ပြီးနောက် အဆင့်ပြောင်းလဲခြင်း။",
  T_48_META_EVT_3025_D: "အကူအညီဖြင့် အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3025_P0_D: "အသတ်ခံရသော အရာဝတ္ထု",
  T_48_META_EVT_3026_D: "ယာဉ်မောင်းနှင့် ခရီးသည်အဖြစ် အပါအဝင် အဖွဲ့အစည်းတစ်ခုမှ ယာဉ်ထဲသို့ ဝင်ရောက်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3026_P0_D: "ယာဉ်ကို ဝင်လာသူ",
  T_48_META_EVT_3026_P1_D: "ကားအဝင်",
  T_48_META_EVT_3027_D: "ယာဉ်မှထွက်ခွာသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3027_P0_D: "ယာဉ်ပေါ်မှ ထွက်ခွာသွားသည်။",
  T_48_META_EVT_3027_P1_D: "ထွက်ခွာယာဉ်",
  T_48_META_EVT_3028_D: "ယာဉ်မောင်းနှင်သူသည် ယာဉ်ပေါ်ရှိ ယာဉ်မောင်းဖြစ်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3028_P0_D: "ယာဉ်ကို မောင်းနှင်သော အဖွဲ့အစည်း",
  T_48_META_EVT_3028_P1_D: "ယာဉ်မောင်းနှင်ခြင်း။",
  T_48_META_EVT_3029_D: "ယာဉ်ကို ပစ္စည်းတစ်ခုမှ ဝင်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3029_P0_D: "ဘဘ အစပျိုးသည်။",
  T_48_META_EVT_3030_D: "ယာဉ်ထွက်ခွာသွားသောအခါ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3030_P0_D: "ဘဘ အစပျိုးသည်။",
  T_48_META_EVT_3031_D: "ယာဉ်ကို ပစ္စည်းတစ်ခုမှ မောင်းနှင်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3031_P0_D: "ဘဘ အစပျိုးသည်။",
  T_48_META_EVT_3032_D: "အဖွဲ့အစည်းသည် တယ်လီပို့ရန် ပေါ်တယ်ကို အသုံးပြုပြီးနောက် အစပျိုးခဲ့သည် ( အသုံးမပြုတော့ပါ၊ ကျေးဇူးပြု၍ OnBouncesOffTire ကို အသုံးပြုပါ)",
  T_48_META_EVT_3032_P0_D: "ပေါ်တယ်များကို အသုံးပြုနေသော အရာများ",
  T_48_META_EVT_3032_P1_D: "Portal ကိုသုံးတယ်။",
  T_48_META_EVT_3033_D: "ပစ္စည်းပြန်တက်လာသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3033_P0_D: "ဘဘ အစပျိုးသည်။",
  T_48_META_EVT_3033_P1_D: "ခုန်နေတဲ့ အရာဝတ္ထုကို သုံးတယ်။",
  T_48_META_EVT_3034_D: "ပေါ်တယ်တယ်လီပို့တ်ပြီးနောက် အစပျိုးသည်။",
  T_48_META_EVT_3034_P0_D: "ပို့လွှတ်ခြင်း အလျောက်",
  T_48_META_EVT_3035_D: "တာယာက ခုန်ပြီး ဘဘ အစပျိုးတယ်။",
  T_48_META_EVT_3035_P0_D: "ဘောင်းဘီဘဘ",
  T_48_META_EVT_3036_D: "ယန္တရားသည် အရာဝတ္တုအား လေထဲသို့ ခေါက်လိုက်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3036_P0_D: "ဖြုတ်ချခံခဲ့ရသော အဖွဲ့အစည်းများ",
  T_48_META_EVT_3036_P1_D: "စက်ပစ္စည်းများ",
  T_48_META_EVT_3037_D: "ပစ္စည်းတစ်ခုသည် အစပျိုးထဲသို့ ဝင်လာသောအခါ မီးလောင်သည်။",
  T_48_META_EVT_3037_P0_D: "ဝင်ရောက်မှုအစပျိုး",
  T_48_META_EVT_3038_D: "အရာဝတ္ထုတစ်ခုက အစပျိုးထွက်သွားသောအခါ မီးလောင်ကျွမ်းသည်။",
  T_48_META_EVT_3038_P0_D: "ထွက်ခွာမှုအစပျိုး",
  T_48_META_EVT_3039_D: "လက်နက်တစ်ခုရရှိသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3039_P0_D: "လက်နက်အဖွဲ့အစည်း",
  T_48_META_EVT_3040_D: "ယန္တရားတစ်ခုဖြင့် entity ကို ဖယ်လိုက်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3040_P0_D: "ဖြုတ်ချခံခဲ့ရသော အဖွဲ့အစည်းများ",
  T_48_META_EVT_3040_P1_D: "စက်ပစ္စည်းများ",
  T_48_META_EVT_3041_D: "ပစ်မှတ်ထားနိုင်သော အရာတစ်ခုကို ပစ်မှတ်ထားသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3041_P0_D: "ပစ်မှတ်ထားသည့်အရာ",
  T_48_META_EVT_3042_D: "ကစားသမားတစ်ဦးမှ ပစ်မှတ်ထားသည့်အခါ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3042_P0_D: "ရည်မှန်းချက် ပန်းတိုင်ကို ရောက်နေတဲ့ ကစားသမား",
  T_48_META_EVT_3043_D: "ကျည်ဆန်က ပစ်မှတ်ကို ထိလိုက်တာနဲ့ အစပျိုးလိုက်တာ",
  T_48_META_EVT_3043_P0_D: "ပစ်မှတ်ကို ထိတယ်။",
  T_48_META_EVT_3043_P1_D: "ကျည်ဆန်ထိမှန်သည့်နေရာကို ကမ္ဘာ့သြဒိနိတ်ဖြစ်သည်။",
  T_48_META_EVT_3044_D: "လက်နက်ဖြင့် ထိမှန်သောအခါ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3044_P0_D: "လက်နက်များ",
  T_48_META_EVT_3044_P1_D: "ထိမှန်သောဧရိယာ၏ကမ္ဘာ့သြဒိနိတ်များ",
  T_48_META_EVT_3045_D: "ဤအဆင့်ရှိ အရာဝတ္ထုတစ်ခုအဖြစ် ပြောင်းလဲရန် ကစားသမားက ရွေးချယ်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3045_P0_D: "ကစားသူသည် မြင်ကွင်းအရာဝတ္တုကိုယ်တိုင်မဟုတ်ဘဲ အရာဝတ္ထုတစ်ခုအဖြစ် ပြောင်းလဲသည်။",
  T_48_META_EVT_3046_D: "ကစားသမားသည် ဤပြန်ပေါက်သည့်နေရာ၌ ပြန်လည်ရှင်သန်လာသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3046_P0_D: "ကစားသမားများသည် ဤပြန်လည်ရှင်သန်သည့်နေရာ၌ ပြန်လည်ရှင်သန်လာကြသည်။",
  T_48_META_EVT_3047_D: "ကစားသမားသည် လက်နက်ချသောအခါ ဖြစ်ပေါ်လာသည်။",
  T_48_META_EVT_3047_P0_D: "လက်နက်ကို စွန့်ပစ်ပါ။",
  T_48_META_EVT_3048_D: "ကစားသမားသည် လက်နက်မဟုတ်သည့် အခြားအရာတစ်ခုကို ပစ်ချလိုက်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3048_P0_D: "ပစ္စည်းအမျိုးအစား",
  T_48_META_EVT_3048_P1_D: "အရာဝတ္တုသည် ဗလာဖြစ်နိုင်သည်။",
  T_48_META_EVT_3049_D: "ဘောလုံးသေနတ်ဖြင့် ထိမှန်ချိန်တွင် အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3049_P0_D: "ကစားသမား",
  T_48_META_EVT_3049_P1_D: "တိုက်ခံရပြီးနောက်အရှိန်",
  T_48_META_EVT_3050_D: "ဘောလုံးပွဲတစ်ခုနှင့် တိုက်မိသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3050_P0_D: "ယာဉ်တိုက်မှု ရှိကြပါတယ်။",
  T_48_META_EVT_3050_P1_D: "တိုက်မိပြီးနောက်အရှိန်",
  T_48_META_EVT_3051_D: "ပလေယာသည် အသံချန်နယ်သို့ အောင်မြင်စွာပါဝင်လာသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3051_P0_D: "Voice ချန်နယ် ဘဘ",
  T_48_META_EVT_3052_D: "ပလေယာသည် အသံချန်နယ်တွင် ပါဝင်ရန် ပျက်ကွက်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3052_P0_D: "Voice ချန်နယ် ဘဘ",
  T_48_META_EVT_3053_D: "ပလေယာသည် အသံချန်နယ်မှ ထွက်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3053_P0_D: "Voice ချန်နယ် ဘဘ",
  T_48_META_EVT_3054_D: "ဘောလုံးက ဂိုးဝင်သွားတဲ့အခါ ဖြစ်ပေါ်လာတာပါ။",
  T_48_META_EVT_3054_P0_D: "ပန်းတိုင်",
  T_48_META_EVT_3054_P1_D: "ဂိုးသွင်းသူ၊ ဂိုးမသွင်းမီ ဘောလုံးကိုထိသည့် နောက်ဆုံးကစားသမား",
  T_48_META_EVT_3054_P2_D: "Assister၊ ဂိုးမဝင်မီ ဘောလုံးကို ထိသော နောက်ဆုံးကစားသမား",
  T_48_META_EVT_3055_D: "ပလေယာသည် မီးခလုတ်ကို နှိပ်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3056_D: "ကစားသမား ခုန်ချသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3057_D: "ကစားသမားသည် ဝပ်နေချိန်တွင် ဖြစ်ပေါ်လာသည်။",
  T_48_META_EVT_3058_D: "ကစားသမားသည် မှောက်လျက်သားဖြစ်နေသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3059_D: "ကစားသမားပြေးသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3060_D: "စတိုးဆိုင်တွင် ပစ္စည်းတစ်ခုကို အောင်မြင်စွာ ဝယ်ယူသောအခါတွင် အစပျိုးသည်။",
  T_48_META_EVT_3060_P0_D: "ကုန်ပစ္စည်းဝယ်ယူသော ကစားသမားများ",
  T_48_META_EVT_3060_P1_D: "ကုန်စည်",
  T_48_META_EVT_3061_D: "ကစားသမားက လက်နက်တပ်ဆင်ထားတဲ့အခါ ဖြစ်ပေါ်လာတာပါ။",
  T_48_META_EVT_3061_P0_D: "လက်နက်တပ်ဆင်ထားသော ကစားသမားများ",
  T_48_META_EVT_3062_D: "ဤလက်နက်ဖြင့် ယူနစ်တစ်ခုကို သတ်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3062_P0_D: "ဘဘ အသတ်ခံရတယ်။",
  T_48_META_EVT_3063_D: "ယူနစ်တစ်ခုကို ပျက်စီးစေရန် ဤလက်နက်ကို အသုံးပြုသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3063_P0_D: "ထိခိုက်နစ်နာစေသော ဘဘ",
  T_48_META_EVT_3063_P1_D: "ပျက်စီးခြင်း။",
  T_48_META_EVT_3064_D: "လက်နက်က ကျည်ဆန်ပြောင်းတဲ့အခါ အစပျိုးပါတယ်။",
  T_48_META_EVT_3065_D: "အဖွဲ့အစည်းတစ်ခုက ယာဉ်ထဲသို့ ဝင်သည့်အခါ ဤဖြစ်ရပ်ကို ယာဉ်မောင်း သို့မဟုတ် ခရီးသည်အဖြစ် အစပျိုးနိုင်သည်။",
  T_48_META_EVT_3065_P0_D: "ကားအဝင်",
  T_48_META_EVT_3066_D: "ယာဉ်မှထွက်ခွာသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3066_P0_D: "ထွက်ခွာယာဉ်",
  T_48_META_EVT_3067_D: "အဖွဲ့အစည်းတစ်ခုက ယာဉ်တစ်စီးကို မောင်းနှင်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3067_P0_D: "ယာဉ်မောင်းနှင်ခြင်း။",
  T_48_META_EVT_3068_D: "ပေါ်တယ်ကို အသုံးပြု၍ အဖွဲ့အစည်းတစ်ခုမှ တယ်လီပို့တ်ပြီးနောက် အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3068_P0_D: "Portal ကိုသုံးတယ်။",
  T_48_META_EVT_3069_D: "တာယာဖြင့် ခုန်ပေါက်ပြီးနောက် အစပျိုးသည်။",
  T_48_META_EVT_3069_P0_D: "တာယာတွေ သုံးတယ်။",
  T_48_META_EVT_3070_D: "ယန္တရားတစ်ခုဖြင့် entity ကို ဖယ်လိုက်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3070_P0_D: "စက်ပစ္စည်းများ",
  T_48_META_EVT_3071_D: "ပလေယာမှ UI ခလုတ်ထိန်းချုပ်မှုကို နှိပ်ပြီးနောက် အစပျိုးသည်။",
  T_48_META_EVT_3071_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3072_D: "UI ခလုတ် ထိန်းချုပ်မှု မြှင့်ပြီးနောက် မီးလောင်သည်။",
  T_48_META_EVT_3072_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3073_D: "ပလေယာမှ UI ခလုတ်ကို နှစ်ချက်နှိပ်ပြီးနောက် အစပျိုးသည်။",
  T_48_META_EVT_3073_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3074_D: "Jailbreak ဧရိယာစတင်သည်။",
  T_48_META_EVT_3075_D: "jailbreak ဧရိယာအဆုံးသတ်",
  T_48_META_EVT_3076_D: "ပလေယာက ဝိတ်ဘုတ်အသုံးမပြုတော့သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3077_D: "ပလေယာမှ UI ထည့်သွင်းသည့်ဘောက်စ် ထိန်းချုပ်မှု၏ စာသားအကြောင်းအရာကို ပြောင်းလဲသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3077_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3077_P1_D: "စာသားအကြောင်းအရာကို ပြောင်းထားသည်။",
  T_48_META_EVT_3078_D: "ကစားနိုင်သော အရာတစ်ခု စတင်ဖွင့်သောအခါတွင် မီးလောင်သည်။",
  T_48_META_EVT_3078_P0_D: "ဘဘ",
  T_48_META_EVT_3079_D: "playable entity သည် play ပြီးဆုံးသောအခါတွင် အစပျိုးနိုင်သည်",
  T_48_META_EVT_3079_P0_D: "ဘဘ",
  T_48_META_EVT_3080_D: "ကစားနိုင်သော အရာသည် ဆက်ကစားနေသည့်အခါတွင် မီးပိတ်ပါ။",
  T_48_META_EVT_3080_P0_D: "ဘဘ",
  T_48_META_EVT_3081_D: "ဖွင့်နိုင်သောအကြောင်းအရာသည် ပြန်ဖွင့်ခြင်းကို ခေတ္တရပ်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3081_P0_D: "ဘဘ",
  T_48_META_EVT_3082_D: "Jailbreak လုပ်ထားသော ကစားသမားများ ပါဝင်ပါ။",
  T_48_META_EVT_3082_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3083_D: "Jailbreak လုပ်ထားသော ကစားသမားများ ထွက်ပေါက်",
  T_48_META_EVT_3083_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3084_D: "နှစ်သစ်ရဲ့အဆုံးမှာ မီးတွေလောင်တယ်။",
  T_48_META_EVT_3084_P0_D: "ဘဘပိုင်ဆိုင်သည်။",
  T_48_META_EVT_3085_D: "ပစ္စည်းတစ်ခုကို ကောက်ယူသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3085_P0_D: "ကစားသမားက ပစ္စည်းကို ကောက်တယ်။",
  T_48_META_EVT_3086_D: "ပစ္စည်းတစ်ခုပြုတ်ကျသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3086_P0_D: "ပစ္စည်းတွေ ပြုတ်ကျတဲ့ ကစားသမား",
  T_48_META_EVT_3087_D: "ဤပစ္စည်းကို တပ်ဆင်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3088_D: "မိုင်းဖန်တီးပြီးနောက် အရာဝတ္ထုစတင်သည့်အခါ မီးလောင်သည်။",
  T_48_META_EVT_3089_D: "မိုင်းဖန်တီးပြီးနောက် အရာဝတ္ထုက အစပျိုးသည့်အခါ မီးလောင်သည်။",
  T_48_META_EVT_3089_P0_D: "မိုင်းဖန်တီးပြီးနောက် အရာဝတ္ထု၏ ပစ်မှတ်ကို အစပျိုးပါ။",
  T_48_META_EVT_3090_D: "စတိုးဆိုင်တွင် ပစ္စည်းမဝယ်မီ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3090_P0_D: "ကုန်ပစ္စည်းဝယ်ယူသော ကစားသမားများ",
  T_48_META_EVT_3090_P1_D: "ကုန်စည်",
  T_48_META_EVT_3091_D: "ဤစက်ပစ္စည်းကို အသုံးပြုနေချိန်တွင် မီးလောင်ကျွမ်းသည်။",
  T_48_META_EVT_3092_D: "လုံးထွေးသေနတ်ကို ပစ်လွှတ်လိုက်သောအခါတွင် ပေါ်ပေါက်လာခဲ့သည်။",
  T_48_META_EVT_3093_D: "ပစ်ချခံရပြီးနောက် ကျည်ဆန်ပေါက်ကွဲသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3093_P0_D: "ပေါက်ကွဲမှုအချက်",
  T_48_META_EVT_3094_D: "မှုတ်သေနတ်ဖြင့် ထိမှန်သောအခါ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3094_P0_D: "မှုတ်သေနတ် ဘဘ",
  T_48_META_EVT_3094_P1_D: "hit point",
  T_48_META_EVT_3094_P2_D: "ပုံမှန်ရိုက်တယ်။",
  T_48_META_EVT_3095_D: "ဆေးသေနတ်နဲ့ ထိလိုက်တာနဲ့ အစပျိုးခဲ့တာပါ။",
  T_48_META_EVT_3095_P0_D: "အရာဝတ္ထုကိုထိမှန်",
  T_48_META_EVT_3095_P1_D: "hit point",
  T_48_META_EVT_3095_P2_D: "ပုံမှန်ရိုက်တယ်။",
  T_48_META_EVT_3096_D: "ယာဉ် သို့မဟုတ် ဆိုးဆေးစည် ပေါက်ကွဲသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3096_P0_D: "ပေါက်ကွဲအောင်လုပ်တဲ့ ကစားသမားပါ။",
  T_48_META_EVT_3096_P1_D: "ပေါက်ကွဲမှုကြောင့် ထိခိုက်ခဲ့တဲ့ ကစားသမားစာရင်း",
  T_48_META_EVT_3097_D: "ပစ်ခတ်မှုရပ်သွားသောအခါတွင် ပစ်ခတ်သည်။",
  T_48_META_EVT_3097_P0_D: "ပစ်ခတ်ရပ်စဲသည့်အခါ လက်ရှိ မဂ္ဂဇင်းတွင် ကျန်ရှိသည့် ကျည်ပမာဏ",
  T_48_META_EVT_3098_D: "လိုက်ရှာသည့်ပစ်မှတ်သည် လိုက်ရှာသည့်အကွာအဝေးသို့ ဝင်ရောက်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3099_D: "လိုက်ရှာသည့်ပစ်မှတ်သည် လိုက်ရှာသည့်အကွာအဝေးမှထွက်သွားသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_31_D: "အခင်းအကျင်းပြောင်းခြင်း အောင်မြင်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_31_P0_D: "မြင်ကွင်းအမည်",
  T_48_META_EVT_3100_D: "တိုက်ခိုက်မှုပစ်မှတ်သည် တိုက်ခိုက်မှုအကွာအဝေးသို့ ဝင်ရောက်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3101_D: "တိုက်ခိုက်မှုပစ်မှတ်သည် တိုက်ခိုက်မှုအကွာအဝေးမှ ထွက်သွားသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3102_D: "ကလိုင်းယင့်ကလစ်ဖြစ်ရပ်တစ်ခုမှတစ်ဆင့် ကင်မရာဓာတ်ရောင်ခြည်ရှာဖွေတွေ့ရှိမှုကို အစပျိုးသည့်အခါ ဤဖြစ်ရပ်ကို အစပျိုးသည်။",
  T_48_META_EVT_3102_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3102_P1_D: "ကင်မရာရောင်ခြည်သည် အရာဝတ္တုကို ထိမှန်သလား",
  T_48_META_EVT_3102_P2_D: "ကင်မရာရောင်ခြည်သည် တည်နေရာကို ထိမှန်သည်။",
  T_48_META_EVT_3102_P3_D: "လိုင်းကင်မရာ တိမ်းညွတ်မှု",
  T_48_META_EVT_3102_P4_D: "လိုင်းကင်မရာ အနေအထား",
  T_48_META_EVT_3102_P5_D: "ဘဘ ရိုက်တယ်။",
  T_48_META_EVT_3103_D: "စတိုးအင်တာဖေ့စ်ကိုဖွင့်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3103_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3104_D: "စတိုးအင်တာဖေ့စ်ကို ပိတ်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3104_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3105_D: "အပြုအမူသစ်ပင် လော့ဂျစ်သည် ဤ node သို့ ဝင်ရောက်သောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3105_P0_D: "Node အမည်",
  T_48_META_EVT_3105_P1_D: "ဘဘပိုင်ဆိုင်သည်။",
  T_48_META_EVT_3106_D: "အပြုအမူ tree logic သည် node မှ ထွက်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3106_P0_D: "Node အမည်",
  T_48_META_EVT_3106_P1_D: "ဘဘပိုင်ဆိုင်သည်။",
  T_48_META_EVT_3107_D: "တောင့်တင်းသော ခန္ဓာကိုယ်ကို နိုးထလာသောအခါ ဖြစ်ပေါ်လာသည်။",
  T_48_META_EVT_3108_D: "တောင့်တင်းသော ခန္ဓာကိုယ်သည် အိပ်ပျော်သွားသောအခါ ဖြစ်ပေါ်လာသည်။",
  T_48_META_EVT_3109_D: "ကစားသမား ရွှေ့တဲ့အခါ အစပျိုးပါတယ်။",
  T_48_META_EVT_3109_P0_D: "သဘောထား",
  T_48_META_EVT_3110_D: "ကစားသမားသည် ရပ်နားထားချိန်တွင် အစပျိုးသည်။",
  T_48_META_EVT_3110_P0_D: "သဘောထား",
  T_48_META_EVT_3111_D: "ကစားသမားက ကျွမ်းကျင်မှုတစ်ခုကို အသုံးပြုတဲ့အခါ အစပျိုးပါတယ်။",
  T_48_META_EVT_3111_P0_D: "အတတ်ပညာများကို အသုံးပြုခဲ့သည်။",
  T_48_META_EVT_3112_D: "ကစားသမားသည် ပြေးခြင်းပြီးဆုံးသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3113_D: "SwitchEquipSlot စာရင်းကောက်မှုအောက်ရှိ slot နှင့်သက်ဆိုင်သည့်အရာအား ရယူသောအခါ အစပျိုးခဲ့သည်",
  T_48_META_EVT_3113_P0_D: "ရရှိသောပစ္စည်း",
  T_48_META_EVT_3114_D: "လက်သီးများပြောင်းသည့်အခါ အပါအဝင် လက်ကိုင်ပစ္စည်းများကို ပြောင်းသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3114_P0_D: "ကူးပြောင်းပြီးနောက် ကိုင်ထားသော အရာ၏ အကြောင်းအရာ",
  T_48_META_EVT_3115_D: "စတိုးဆိုင်ရှိ ကစားသမားတစ်ဦးမှ အခြားပစ္စည်းများဝယ်ယူရန် တောင်းဆိုသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3115_P0_D: "ကစားသမားက ကုန်ပစ္စည်းကို တောင်းဆိုတယ်။",
  T_48_META_EVT_3115_P1_D: "ကုန်စည်",
  T_48_META_EVT_3116_D: "စတိုးဆိုင်ရှိ ကစားသမားတစ်ဦးမှ အခြားပစ္စည်းများကို ဝယ်ယူရန် တောင်းဆိုပြီး တောင်းဆိုမှုကို လက်ခံသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3116_P0_D: "ကူဝယ်ပေးသော ကစားသမားများ",
  T_48_META_EVT_3116_P1_D: "ကစားသမားများ ဝယ်ယူရန် အကူအညီ တောင်းခံခြင်း။",
  T_48_META_EVT_3116_P2_D: "ကုန်စည်",
  T_48_META_EVT_3117_D: "ပုံသေဘောင်တစ်ခုကို အပ်ဒိတ်လုပ်သောအခါ အစပျိုးသောအခါ၊ ကြိမ်နှုန်းကို တစ်စက္ကန့်လျှင် အကြိမ် 30 ဖြင့် သတ်မှတ်သည်။",
  T_48_META_EVT_3118_D: "ခဏရပ်ဂိမ်း API ကိုခေါ်ဆိုပြီးနောက် အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3119_D: "ပြန်လည်စတင်သည့်ဂိမ်း API ကိုခေါ်ဆိုပြီးနောက် အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3120_D: "ကစားသူတစ်ဦးက သူငယ်ချင်းများကို ထည့်သည့်အခါ သို့မဟုတ် ဖျက်သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3121_D: "Persona အချက်အလက်ကို လက်ခံရရှိသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3121_P0_D: "အချက်အလက် အကြောင်းအရာ",
  T_48_META_EVT_3121_P1_D: "ပေးပို့သူ ပုဂ္ဂိုလ်ရေး",
  T_48_META_EVT_3122_D: "ကစားသမားရဲ့ ခုန်မှုအဆုံးမှာ မီးလောင်တယ်။",
  T_48_META_EVT_3123_D: "ကစားသမားပြုတ်ကျတဲ့အခါ အစပျိုးခဲ့ပါတယ်။",
  T_48_META_EVT_3124_D: "ကစားသမား ပြုတ်ကျချိန်မှာ အစပျိုးခဲ့ပါတယ်။",
  T_48_META_EVT_3125_D: "Persona အပြုအမူကို လက်ခံသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3125_P0_D: "အနေအထိုင်",
  T_48_META_EVT_3125_P1_D: "ပေးပို့သူ ပုဂ္ဂိုလ်ရေး",
  T_48_META_EVT_3126_D: "အဖွဲ့ဝင်အချက်အလက်ပြောင်းလဲသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3126_P0_D: "ပြောင်းလဲပြီးနောက် အဖွဲ့ဝင်အခြေအနေ",
  T_48_META_EVT_3127_D: "အဖွဲ့ဝင်စင်တာသို့ ဝင်ရောက်သောအခါ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3128_D: "အဖွဲ့ဝင်စင်တာမှ ထွက်ခွာသည့်အခါ အစပျိုးခဲ့သည်။",
  T_48_META_EVT_3129_D: "ကစားသမားသည် ပြုတ်ကျသည့်အခြေအနေသို့ ရောက်သွားသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3129_P0_D: "Attacker entity သည် ဗလာဖြစ်နိုင်သည်။",
  T_48_META_EVT_3130_D: "Persona အခြေအနေကို လက်ခံရရှိသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3130_P0_D: "ပေးပို့သူ ပုဂ္ဂိုလ်ရေး",
  T_48_META_EVT_3130_P1_D: "အမှားကုဒ်",
  T_48_META_EVT_3131_D: "UI မှတစ်ဆင့် Persona သို့ အချက်အလက်ပေးပို့သည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_3131_P0_D: "အချက်အလက် အကြောင်းအရာ",
  T_48_META_EVT_3131_P1_D: "ပေးပို့သူ ပုဂ္ဂိုလ်ရေး",
  T_48_META_EVT_3132_D: "Persona ၏အဆုံးကိုလက်ခံရရှိသောအခါအစပျိုးခဲ့သည်။",
  T_48_META_EVT_3132_P0_D: "ပေးပို့သူ ပုဂ္ဂိုလ်ရေး",
  T_48_META_EVT_3132_P1_D: "အမှားကုဒ်",
  T_48_META_EVT_32_D: "ပလေယာသည် မြင်ကွင်းများကို ပြောင်းသည့်အခါ အစပျိုးသည်။",
  T_48_META_EVT_32_P0_D: "မြင်ကွင်းအမည်",
  T_48_META_EVT_3200_D: "ကာတွန်းအပိုင်းကို ဖွင့်ပြီးသောအခါတွင် မီးပိတ်ပါ။",
  T_48_META_EVT_3200_P0_D: "အန်နီမေးရှင်းအပိုင်းအမည်",
  T_48_META_EVT_3201_D: "ကာတွန်းအခြေအနေ ပြန်ဖွင့်ခြင်းပြီးသွားသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3201_P0_D: "Animation အခြေအနေအမည်",
  T_48_META_EVT_3204_D: "Toggle ထိန်းချုပ်မှု အခြေအနေ ပြောင်းလဲသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3204_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3204_P1_D: "ပြည်နယ်",
  T_48_META_EVT_3260_D: "ပလေယာမှ touchpad ကို နှိပ်လိုက်သောအခါ မီးလောင်သည်။",
  T_48_META_EVT_3260_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3260_P1_D: "အနေအထားကိုနှိပ်ပါ။",
  T_48_META_EVT_3261_D: "ထိတွေ့ပက်ဒ်ကို မြှင့်လိုက်သောအခါတွင် မီးပွင့်သည်။",
  T_48_META_EVT_3261_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3261_P1_D: "ရာထူးတိုးသည်။",
  T_48_META_EVT_3262_D: "ထိတွေ့မျက်နှာပြင် လျှောကျလာသောအခါတွင် မီးစတင်လောင်ပါသည်။",
  T_48_META_EVT_3262_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3262_P1_D: "လျှောအနေအထားကို စတင်ပါ။",
  T_48_META_EVT_3263_D: "touchpad လျှောကျနေစဉ်အတွင်း၊ ဤဖြစ်ရပ်ကို ဖရိန်တိုင်းတွင် စတင်လုပ်ဆောင်ပါမည်။",
  T_48_META_EVT_3263_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3263_P1_D: "လျှောအနေအထားကို စတင်ပါ။",
  T_48_META_EVT_3263_P2_D: "နေရာရွှေ့ပြောင်းခြင်း။",
  T_48_META_EVT_3264_D: "touchpad ဆလိုက်၏အဆုံးတွင် မီးလောင်သည်။",
  T_48_META_EVT_3264_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3264_P1_D: "ချော်လဲနေသော အနေအထားကို အဆုံးသတ်ပါ။",
  T_48_META_EVT_3265_D: "JoyStick ကို နှိပ်လိုက်သောအခါတွင် မီးပွင့်သည်။",
  T_48_META_EVT_3265_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3266_D: "JoyStick ကို ရုတ်သိမ်းလိုက်သောအခါတွင် မီးလောင်ကျွမ်းသည်။",
  T_48_META_EVT_3266_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3267_D: "JoyStick ကိုအသုံးပြုသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_3267_P0_D: "အစပျိုးကစားသမား",
  T_48_META_EVT_3267_P1_D: "အထွက်နေရာရွှေ့ပြောင်းခြင်း။",
  T_48_META_EVT_3268_D: "ကစားသမားသည် အခြားရပ်တည်ချက်တစ်ခုမှ မတ်တပ်ရပ်လိုက်သောအခါ ဖြစ်ပေါ်လာသည်။",
  T_48_META_EVT_3268_P0_D: "မတ်တပ်မရပ်မီ ကစားသမား၏ ကိုယ်ဟန်အနေအထား",
  T_48_META_EVT_3269_D: "လက်နက်ကြီး ပစ်ခတ်လိုက်တာနဲ့ ပေါက်ကွဲထွက်လာတယ်။",
  T_48_META_EVT_4_D: "အကြိမ်တိုင်း၏အစတွင် အစပျိုးခဲ့သည်။",
  T_48_META_EVT_4_P0_D: "အဝိုင်းအညွှန်း 0 မှစတင်သည်။",
  T_48_META_EVT_5_D: "အဝိုင်းတစ်ခုစီ၏အဆုံးတွင် အစပျိုးသည်။",
  T_48_META_EVT_5_P0_D: "အဝိုင်းအညွှန်း 0 မှစတင်သည်။",
  T_48_META_EVT_6_D: "ခိုင်မာသောကိုယ်ထည်အစိတ်အပိုင်းများ တပ်ဆင်ထားသော အရာများနှင့်သာ တိုက်မိသောအခါ အစပျိုးသည်။",
  T_48_META_EVT_6_P0_D: "အဖွဲ့အစည်းများ ကြုံတွေ့ခဲ့ရသည်။",
  T_48_META_EVT_7_D: "အဆင့်တစ်ခုစီ၏အစတွင် အစပျိုးခဲ့သည်။",
  T_48_META_EVT_7_P0_D: "ဇာတ်ခုံ",
  T_48_META_EVT_8_D: "အဆင့်တစ်ခုစီ၏အဆုံးတွင် အစပျိုးခဲ့သည်။",
  T_48_META_EVT_8_P0_D: "ဇာတ်ခုံ",
  T_48_META_EVT_9_D: "ခိုင်မာသောကိုယ်ထည်အစိတ်အပိုင်းများ တပ်ဆင်ထားသော အရာများသာလျှင် ဤဖြစ်ရပ်ကို ပံ့ပိုးပေးပါသည်။",
  T_48_META_EVT_9_P0_D: "အဖွဲ့အစည်းများ ကြုံတွေ့ခဲ့ရသည်။",
  T_49_META_TYP_10_I1_D: "Tag List",
  T_49_META_TYP_10_I2_D: "Is it available for itself",
  T_49_META_TYP_10_I3_D: "Available in all parents",
  T_49_META_TYP_10_I4_D: "Whether it is available in the Scene or not",
  T_49_META_TYP_10_I5_D: "Whether logic update is turned on, when it is turned off, the script on this entity stops updating every frame",
  T_49_META_TYP_10_I6_D: "Entity name",
  T_49_META_TYP_10_I7_D: "Region filtering options, 0 for automatic calculation of controlled or uncontrolled, 1 for uncontrolled always synchronized, 2 for controlled",
  T_49_META_TYP_100_I0_D: "Setting the trigger range",
  T_49_META_TYP_100_I1_D: "Model Visibility",
  T_49_META_TYP_101_I0_D: "Player",
  T_49_META_TYP_101_I1_D: "TargetItemID",
  T_49_META_TYP_101_I2_D: "TargetRotation",
  T_49_META_TYP_101_I3_D: "TargetScale",
  T_49_META_TYP_1010_I1_D: "Timing duration in seconds",
  T_49_META_TYP_1010_I2_D: "The start time of the timings, in seconds of the game moment",
  T_49_META_TYP_1010_I3_D: "The update type of the timer, see `EUITimeUpdateType`, can be static, timed, or countdown.",
  T_49_META_TYP_1010_I4_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinates.",
  T_49_META_TYP_1011_I10_D: "Progress Icon Name",
  T_49_META_TYP_1011_I2_D: "Theme Color",
  T_49_META_TYP_1011_I3_D: "Whether to enable localized display",
  T_49_META_TYP_1011_I4_D: "Title",
  T_49_META_TYP_1011_I5_D: "Description",
  T_49_META_TYP_1011_I6_D: "Icon resource name",
  T_49_META_TYP_1011_I7_D: "Max Progress",
  T_49_META_TYP_1011_I8_D: "Current Progress",
  T_49_META_TYP_1011_I9_D: "Progress Icon",
  T_49_META_TYP_1012_I1_D: "Enable or disable localization",
  T_49_META_TYP_1012_I2_D: "Number of rounds text",
  T_49_META_TYP_1012_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1012_I5_D: "LeftColor",
  T_49_META_TYP_1012_I6_D: "RightColor",
  T_49_META_TYP_1013_I2_D: "Round Count Text",
  T_49_META_TYP_1013_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1014_I2_D: "First Score Title Text",
  T_49_META_TYP_1014_I3_D: "First Score",
  T_49_META_TYP_1014_I4_D: "First Score Params",
  T_49_META_TYP_1014_I5_D: "Title of the second score",
  T_49_META_TYP_1014_I6_D: "Second score value",
  T_49_META_TYP_1014_I7_D: "Second Score Value Params",
  T_49_META_TYP_1016_I1_D: "Show the corresponding status according to the value, Victory (1), Defeat (2), Tie (3), Booyah (4)",
  T_49_META_TYP_1016_I2_D: "Show if the score of 2 teams is true, otherwise hidden",
  T_49_META_TYP_1016_I3_D: "Left Team Score",
  T_49_META_TYP_1016_I4_D: "Right Team Score",
  T_49_META_TYP_1016_I5_D: "Phase end timestamps",
  T_49_META_TYP_1017_I1_D: "Left Team Name",
  T_49_META_TYP_1017_I2_D: "Left Description",
  T_49_META_TYP_1017_I3_D: "Right Team Name",
  T_49_META_TYP_1017_I4_D: "Right Description",
  T_49_META_TYP_1018_I1_D: "Round Num",
  T_49_META_TYP_1018_I4_D: "Left team score",
  T_49_META_TYP_1018_I6_D: "Score of the right team",
  T_49_META_TYP_1019_I1_D: "1 2 3 for win/loss/tie",
  T_49_META_TYP_102_I0_D: "Resurrection source type, player resurrects from death",
  T_49_META_TYP_102_I1_D: "Resurrection source type, player resurrects from downed state",
  T_49_META_TYP_1020_I2_D: "Text key to be displayed",
  T_49_META_TYP_1020_I3_D: "Array of parameters corresponding to the text key",
  T_49_META_TYP_1021_I1_D: "Base time in seconds",
  T_49_META_TYP_1021_I2_D: "Duration in seconds",
  T_49_META_TYP_1021_I3_D: "Display position, when there is a target to follow, it is the offset of the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0).",
  T_49_META_TYP_1022_I2_D: "the key of the text to be displayed",
  T_49_META_TYP_1022_I3_D: "Array of parameters corresponding to the text key.",
  T_49_META_TYP_1023_I1_D: "show team score if it is true, otherwise it will be closed.",
  T_49_META_TYP_1023_I4_D: "If the status of the team is true, then display, otherwise it will be closed.",
  T_49_META_TYP_1023_I5_D: "Left player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I6_D: "Right player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I7_D: "Left Teammate Flag Count",
  T_49_META_TYP_1023_I8_D: "Right Teammate Flag Count",
  T_49_META_TYP_1024_I2_D: "Offset",
  T_49_META_TYP_1024_I3_D: "Rank",
  T_49_META_TYP_1024_I4_D: "Team Color",
  T_49_META_TYP_1024_I5_D: "Icon Name",
  T_49_META_TYP_1024_I6_D: "Displayed if border is true, otherwise it is off.",
  T_49_META_TYP_1024_I7_D: "Score Text Key",
  T_49_META_TYP_1024_I8_D: "Score Text Key Params",
  T_49_META_TYP_1028_I1_D: "Left Teammate Alive Num",
  T_49_META_TYP_1028_I2_D: "Right Teammate Alive Num",
  T_49_META_TYP_1028_I3_D: "Left Background Color",
  T_49_META_TYP_1028_I4_D: "Right Background Color",
  T_49_META_TYP_1028_I5_D: "Left Icon Name",
  T_49_META_TYP_1028_I6_D: "Right Icon Name",
  T_49_META_TYP_1029_I1_D: "Icon Name",
  T_49_META_TYP_1029_I2_D: "Background Icon Name",
  T_49_META_TYP_103_I0_D: "Primary Weapon A",
  T_49_META_TYP_103_I1_D: "Primary WeaponB",
  T_49_META_TYP_103_I10_D: "Freeze Bomb",
  T_49_META_TYP_103_I11_D: "Ice Wall",
  T_49_META_TYP_103_I12_D: "Landmine",
  T_49_META_TYP_103_I13_D: "Auto Turret",
  T_49_META_TYP_103_I14_D: "DummyGrenade",
  T_49_META_TYP_103_I16_D: "Skateboard, Camo ....",
  T_49_META_TYP_103_I2_D: "Secondary Weapon",
  T_49_META_TYP_103_I3_D: "Blast Weapon",
  T_49_META_TYP_103_I5_D: "HeavyWeapon",
  T_49_META_TYP_1030_I3_D: "Left Teammate Alive Num",
  T_49_META_TYP_1030_I4_D: "Right Teammate Alive Num",
  T_49_META_TYP_1030_I5_D: "Left team icon name",
  T_49_META_TYP_1030_I6_D: "Right team icon name",
  T_49_META_TYP_1031_I2_D: "Description of the message",
  T_49_META_TYP_1031_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_1031_I4_D: "Description Params",
  T_49_META_TYP_1032_I1_D: "Tips Type",
  T_49_META_TYP_1032_I3_D: "Params",
  T_49_META_TYP_1033_I1_D: "Toggles phases, 0 for current round and 1 for next round",
  T_49_META_TYP_1033_I10_D: "Defeat prompt text, not filled in as default",
  T_49_META_TYP_1033_I11_D: "Round Income Title",
  T_49_META_TYP_1033_I12_D: "Round Income",
  T_49_META_TYP_1033_I13_D: "Round Income Detail Titles",
  T_49_META_TYP_1033_I14_D: "Round revenue value detail list, corresponding to the above detail title list one by one",
  T_49_META_TYP_1033_I15_D: "MVP Player Nickname",
  T_49_META_TYP_1033_I16_D: "Next Round Index",
  T_49_META_TYP_1033_I17_D: "Is Match Point",
  T_49_META_TYP_1033_I18_D: "Is Last Round",
  T_49_META_TYP_1033_I6_D: "Left team icon name",
  T_49_META_TYP_1033_I7_D: "Right team icon name",
  T_49_META_TYP_1033_I8_D: "Depending on the value, the corresponding status will be displayed, Victory (1), Defeat (2).",
  T_49_META_TYP_1033_I9_D: "Victory prompt text, default if not filled in",
  T_49_META_TYP_1036_I1_D: "Indicates how many levels there are in total",
  T_49_META_TYP_1036_I2_D: "Indicates the current bot level",
  T_49_META_TYP_1037_I1_D: "Indicates how many points are displayed",
  T_49_META_TYP_1039_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_104_I0_D: "Style A",
  T_49_META_TYP_104_I1_D: "Style B",
  T_49_META_TYP_104_I2_D: "Style C",
  T_49_META_TYP_1040_I10_D: "ItemDescriptions",
  T_49_META_TYP_1040_I11_D: "Index of the selected item, start from 0, less than 0 means deselected.",
  T_49_META_TYP_1040_I12_D: "ButtonNames",
  T_49_META_TYP_1040_I13_D: "ButtonColors",
  T_49_META_TYP_1040_I2_D: "Count Down Key",
  T_49_META_TYP_1040_I3_D: "Countdown Time",
  T_49_META_TYP_1040_I4_D: "Description Key",
  T_49_META_TYP_1040_I5_D: "Array of description parameters",
  T_49_META_TYP_1040_I6_D: "ItemBackgrounds",
  T_49_META_TYP_1040_I7_D: "ItemBackgroundColors",
  T_49_META_TYP_1040_I8_D: "ItemIcons",
  T_49_META_TYP_1040_I9_D: "ItemNames",
  T_49_META_TYP_1041_I2_D: "Position",
  T_49_META_TYP_1041_I3_D: "Icon",
  T_49_META_TYP_1041_I4_D: "Label",
  T_49_META_TYP_1041_I5_D: "Background Color",
  T_49_META_TYP_1042_I1_D: "Local Position",
  T_49_META_TYP_1043_I4_D: "Color",
  T_49_META_TYP_1043_I5_D: "Label Key",
  T_49_META_TYP_1043_I6_D: "Label Params",
  T_49_META_TYP_1045_I2_D: "Button icon",
  T_49_META_TYP_1045_I3_D: "Icon Color",
  T_49_META_TYP_1045_I4_D: "Size, same width and height",
  T_49_META_TYP_1045_I5_D: "Position of the button relative to the anchor point in the lower right corner.",
  T_49_META_TYP_1045_I6_D: "Number of charge, less than 0 means hidden",
  T_49_META_TYP_1045_I7_D: "CD start time, in milliseconds",
  T_49_META_TYP_1045_I8_D: "CD duration, in milliseconds",
  T_49_META_TYP_1045_I9_D: "True, the button will be grayed out, False, it will be restored.",
  T_49_META_TYP_106_I1_D: "Enable",
  T_49_META_TYP_106_I2_D: "Disable",
  T_49_META_TYP_109_I0_D: "Chat Channel ID",
  T_49_META_TYP_109_I1_D: "Player List",
  T_49_META_TYP_11_I0_D: "Whether the current game is in illegal state, when it is in illegal state, it means the game has lost the value of confrontation, so it is recommended to end the game directly.",
  T_49_META_TYP_11_I1_D: "The length of the current game, in milliseconds.",
  T_49_META_TYP_11_I10_D: "Whether or not to reset equipment every round",
  T_49_META_TYP_11_I11_D: "Whether or not to enable out-of-zone mechanic",
  T_49_META_TYP_11_I12_D: "Safe Zone Size",
  T_49_META_TYP_11_I13_D: "Shrinking Start Time",
  T_49_META_TYP_11_I14_D: "Shrinking Duration",
  T_49_META_TYP_11_I15_D: "Out-of-Zone Damage",
  T_49_META_TYP_11_I18_D: "Revival Type",
  T_49_META_TYP_11_I2_D: "Current round index, through this value you can get the current round entity.",
  T_49_META_TYP_11_I27_D: "Total Round Count",
  T_49_META_TYP_11_I3_D: "Current phase index, by this value you can get the current phase entity.",
  T_49_META_TYP_11_I32_D: "Number of coins gained at the start of the round",
  T_49_META_TYP_11_I33_D: "Number of coins at kill",
  T_49_META_TYP_11_I34_D: "Number of coins when you win",
  T_49_META_TYP_11_I35_D: "Whether to show wallet UI",
  T_49_META_TYP_11_I36_D: "Skybox Entity",
  T_49_META_TYP_11_I37_D: "Cumulative running frames since game start",
  T_49_META_TYP_11_I38_D: "Enable Move",
  T_49_META_TYP_11_I39_D: "Whether to customize the settlement",
  T_49_META_TYP_11_I4_D: "Preset template ID for UGC mode.",
  T_49_META_TYP_11_I40_D: "Whether to allow joining in the middle of the game",
  T_49_META_TYP_11_I41_D: "Enable low frame rate mode, the game will run at 15FPS, otherwise 30FPS",
  T_49_META_TYP_11_I42_D: "Logical frame update interval between two game server updates",
  T_49_META_TYP_11_I43_D: "Fixed frame update interval in milliseconds",
  T_49_META_TYP_11_I5_D: "Disable player resurrection if off",
  T_49_META_TYP_11_I6_D: "Disable Bot resurrection if off",
  T_49_META_TYP_11_I7_D: "Resurrection time in seconds",
  T_49_META_TYP_11_I8_D: "Total number of teams in the game",
  T_49_META_TYP_11_I9_D: "Number of members in each team",
  T_49_META_TYP_110_I0_D: "ChannelA",
  T_49_META_TYP_110_I1_D: "ChannelB",
  T_49_META_TYP_110_I2_D: "ChannelC",
  T_49_META_TYP_110_I3_D: "ChannelD",
  T_49_META_TYP_110_I4_D: "ChannelE",
  T_49_META_TYP_110_I5_D: "ChannelF",
  T_49_META_TYP_111_I1_D: "Sprint",
  T_49_META_TYP_111_I2_D: "Attack",
  T_49_META_TYP_111_I3_D: "Jump",
  T_49_META_TYP_111_I4_D: "Window Jump",
  T_49_META_TYP_111_I5_D: "Drive",
  T_49_META_TYP_111_I6_D: "Enter Vehicle",
  T_49_META_TYP_111_I7_D: "Exit Vehicle",
  T_49_META_TYP_111_I8_D: "Dirve Vehicle",
  T_49_META_TYP_112_I0_D: "Enable",
  T_49_META_TYP_112_I1_D: "Disable",
  T_49_META_TYP_112_I2_D: "Invisible",
  T_49_META_TYP_117_I0_D: "Claps",
  T_49_META_TYP_117_I1_D: "Hihats",
  T_49_META_TYP_117_I2_D: "Kick",
  T_49_META_TYP_117_I3_D: "OpenHihats",
  T_49_META_TYP_117_I4_D: "Rides",
  T_49_META_TYP_117_I5_D: "Snares",
  T_49_META_TYP_118_I0_D: "Whether all members of the camp are in death",
  T_49_META_TYP_118_I1_D: "List of all team members",
  T_49_META_TYP_118_I2_D: "Allied Factions",
  T_49_META_TYP_118_I3_D: "Attackable Factions",
  T_49_META_TYP_118_I4_D: "Whether to show UI name",
  T_49_META_TYP_118_I5_D: "Whether to show map information",
  T_49_META_TYP_118_I6_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I7_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I8_D: "All Members",
  T_49_META_TYP_118_I9_D: "Is Show Quick Message",
  T_49_META_TYP_119_I0_D: "Yes",
  T_49_META_TYP_119_I1_D: "No",
  T_49_META_TYP_120_I1_D: "Target entity to follow, default is empty",
  T_49_META_TYP_120_I2_D: "UI color",
  T_49_META_TYP_120_I3_D: "UI length",
  T_49_META_TYP_120_I4_D: "Current progress value,0 to 1.0",
  T_49_META_TYP_120_I5_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0)",
  T_49_META_TYP_121_I0_D: "3s",
  T_49_META_TYP_121_I1_D: "5s",
  T_49_META_TYP_121_I2_D: "10s",
  T_49_META_TYP_121_I3_D: "15s",
  T_49_META_TYP_121_I4_D: "30s",
  T_49_META_TYP_121_I5_D: "9999s",
  T_49_META_TYP_122_I0_D: "Skybox Resource",
  T_49_META_TYP_122_I1_D: "Light Color",
  T_49_META_TYP_122_I10_D: "The GUID of the sub-scene it belongs to",
  T_49_META_TYP_122_I11_D: "Fog function switch",
  T_49_META_TYP_122_I12_D: "Fog Effect Mode",
  T_49_META_TYP_122_I13_D: "Exponential fog density",
  T_49_META_TYP_122_I14_D: "Start distance of linear fog",
  T_49_META_TYP_122_I15_D: "End distance of linear fog",
  T_49_META_TYP_122_I16_D: "Turn on the fog effect feature",
  T_49_META_TYP_122_I17_D: "Rotation angle of main light source",
  T_49_META_TYP_122_I18_D: "Enable the main light source rotation angle feature",
  T_49_META_TYP_122_I2_D: "Light Intensity",
  T_49_META_TYP_122_I3_D: "Darkness",
  T_49_META_TYP_122_I4_D: "Shadow Strength",
  T_49_META_TYP_122_I5_D: "Terrain Wetness",
  T_49_META_TYP_122_I6_D: "Lens Flare",
  T_49_META_TYP_122_I7_D: "Fog Color",
  T_49_META_TYP_122_I8_D: "Ambient Color",
  T_49_META_TYP_123_I0_D: "Day",
  T_49_META_TYP_123_I1_D: "Night",
  T_49_META_TYP_123_I2_D: "Dusk",
  T_49_META_TYP_123_I3_D: "City View",
  T_49_META_TYP_123_I4_D: "Colorful Sky",
  T_49_META_TYP_123_I5_D: "Frost Moon",
  T_49_META_TYP_124_I0_D: "Close Range",
  T_49_META_TYP_124_I1_D: "Medium Range",
  T_49_META_TYP_124_I2_D: "Long range",
  T_49_META_TYP_125_I0_D: "Diffuse Color",
  T_49_META_TYP_125_I2_D: "Diffuse Texture",
  T_49_META_TYP_125_I4_D: "Diffuse Alpha",
  T_49_META_TYP_126_I1_D: "Name",
  T_49_META_TYP_126_I2_D: "Current progress value",
  T_49_META_TYP_126_I3_D: "Maximum progress value",
  T_49_META_TYP_126_I4_D: "Screen coordinate, default is Vector3(0).",
  T_49_META_TYP_126_I5_D: "length of the progress bar, default is the length of the UI on the prefab.",
  T_49_META_TYP_127_I0_D: "Panning along an axis can be combined with three axes.",
  T_49_META_TYP_127_I1_D: "Rotate along an axis, three combinations possible",
  T_49_META_TYP_127_I2_D: "Zoom along an axis, three combinations possible",
  T_49_META_TYP_128_I0_D: "Bushes",
  T_49_META_TYP_128_I1_D: "Pumpkin",
  T_49_META_TYP_128_I2_D: "Scarecrow",
  T_49_META_TYP_128_I3_D: "Cabinet",
  T_49_META_TYP_129_I0_D: "Random Loot",
  T_49_META_TYP_129_I1_D: "AR Ammo",
  T_49_META_TYP_129_I2_D: "SMG Ammo",
  T_49_META_TYP_129_I3_D: "SN Ammo",
  T_49_META_TYP_129_I4_D: "HG Ammo",
  T_49_META_TYP_129_I5_D: "SG Bullets",
  T_49_META_TYP_129_I6_D: "Bow Ammo",
  T_49_META_TYP_13_I1_D: "Anchor coordinates relative to the parent node.",
  T_49_META_TYP_13_I10_D: "Widget and anchor frame size difference",
  T_49_META_TYP_13_I11_D: "Pivot",
  T_49_META_TYP_13_I12_D: "Depth",
  T_49_META_TYP_13_I14_D: "Order of all children in the same parent node",
  T_49_META_TYP_13_I15_D: "ParentID",
  T_49_META_TYP_13_I16_D: "UniqueID",
  T_49_META_TYP_13_I17_D: "Priority",
  T_49_META_TYP_13_I18_D: "Actual Position",
  T_49_META_TYP_13_I2_D: "Width",
  T_49_META_TYP_13_I4_D: "Z-axis rotation angle",
  T_49_META_TYP_13_I6_D: "Internal ID of the widget in the prefab",
  T_49_META_TYP_13_I7_D: "UI entity where it is located",
  T_49_META_TYP_13_I8_D: "Anchor Min",
  T_49_META_TYP_13_I9_D: "Anchor Max",
  T_49_META_TYP_130_I0_D: "Random Consumable Loot",
  T_49_META_TYP_130_I1_D: "MedKit",
  T_49_META_TYP_130_I2_D: "Repair Kit",
  T_49_META_TYP_130_I3_D: "Horizaline",
  T_49_META_TYP_130_I4_D: "Inhaler",
  T_49_META_TYP_131_I0_D: "Random Armor Loot",
  T_49_META_TYP_131_I1_D: "Level 1 Armor",
  T_49_META_TYP_131_I2_D: "Class II Armor",
  T_49_META_TYP_131_I3_D: "Tier 3 Armor",
  T_49_META_TYP_132_I0_D: "Random Throwing Object Loot",
  T_49_META_TYP_132_I1_D: "Grenade",
  T_49_META_TYP_132_I4_D: "Flash Freeze",
  T_49_META_TYP_133_I0_D: "Random Multiplier Loot",
  T_49_META_TYP_133_I1_D: "2x Scope",
  T_49_META_TYP_133_I2_D: "4x Scope",
  T_49_META_TYP_133_I3_D: "Thermal Scope",
  T_49_META_TYP_134_I0_D: "Random Weapon Loot",
  T_49_META_TYP_134_I5_D: "Shotgun",
  T_49_META_TYP_134_I8_D: "Football Gun",
  T_49_META_TYP_135_I0_D: "Loot bullet points",
  T_49_META_TYP_136_I0_D: "Loot Consumable Points",
  T_49_META_TYP_137_I0_D: "Loot Consumable Points",
  T_49_META_TYP_138_I0_D: "Loot Multiplier Points",
  T_49_META_TYP_139_I0_D: "Loot Armor Points",
  T_49_META_TYP_14_I0_D: "Player's current blood level",
  T_49_META_TYP_14_I1_D: "Player's current blood maximum",
  T_49_META_TYP_14_I11_D: "The player's camp",
  T_49_META_TYP_14_I12_D: "The player's damage multiplier, e.g. 2x configured as 2.0",
  T_49_META_TYP_14_I13_D: "Use the exact same rig as the male or female character, 0 means no model replacement",
  T_49_META_TYP_14_I14_D: "Does not conflict with existing velocity scaling",
  T_49_META_TYP_14_I15_D: "Does not conflict with existing jump height scaling",
  T_49_META_TYP_14_I16_D: "Identity,0 Normal Player,1 Hunter,2 Matrix Zombie,3 Normal Zombie,4 Evolved Zombie Type 1, 5 Evolved Zombie Type 2,6 Evolved Zombie Type 3",
  T_49_META_TYP_14_I17_D: "Zombie level, 1~3",
  T_49_META_TYP_14_I19_D: "Player's nickname",
  T_49_META_TYP_14_I2_D: "Determine the current player is AI player, AI is usually NPC or PVE monster",
  T_49_META_TYP_14_I20_D: "Percentage of damage dealt when taking damage, can be reduced or increased",
  T_49_META_TYP_14_I21_D: "Player's current EP",
  T_49_META_TYP_14_I22_D: "Player's maximum EP",
  T_49_META_TYP_14_I23_D: "Primary weapon currently in hand.",
  T_49_META_TYP_14_I24_D: "Is Drop on Eliminated",
  T_49_META_TYP_14_I26_D: "Aim Assist Type",
  T_49_META_TYP_14_I27_D: "Allow Lock by Aim Assist",
  T_49_META_TYP_14_I28_D: "Switch voice chat on/off: true to turn off voice, false to turn on voice",
  T_49_META_TYP_14_I29_D: "Switch quick chat: trueClose voice, falseOpen voice",
  T_49_META_TYP_14_I3_D: "Player Status",
  T_49_META_TYP_14_I30_D: "Channel",
  T_49_META_TYP_14_I35_D: "Switch pickup: trueCan't pickup, falseCan pickup",
  T_49_META_TYP_14_I36_D: "Toggle Discard Item: trueCan't discard, falseCan discard",
  T_49_META_TYP_14_I37_D: "Attackable Targets",
  T_49_META_TYP_14_I38_D: "Friendly Players",
  T_49_META_TYP_14_I39_D: "Faction",
  T_49_META_TYP_14_I4_D: "The player's survival time, if the player dies, the time will be recalculated.",
  T_49_META_TYP_14_I40_D: "Number in Faction",
  T_49_META_TYP_14_I41_D: "Camera the player is using",
  T_49_META_TYP_14_I42_D: "Custom Gravity",
  T_49_META_TYP_14_I43_D: "Helmet",
  T_49_META_TYP_14_I44_D: "Vest",
  T_49_META_TYP_14_I5_D: "Player's invincibility",
  T_49_META_TYP_14_I52_D: "User UID",
  T_49_META_TYP_14_I53_D: "Headshot Damage Reduction",
  T_49_META_TYP_14_I54_D: "AVATAR the player is bound to",
  T_49_META_TYP_14_I55_D: "Gender",
  T_49_META_TYP_14_I56_D: "Weapon Skin IDs",
  T_49_META_TYP_14_I57_D: "Player's spwan point",
  T_49_META_TYP_14_I58_D: "Player's resurrection point, if no checkpoints are recorded then the spwan point is used, otherwise checkpoints are used",
  T_49_META_TYP_14_I59_D: "Player's current position",
  T_49_META_TYP_14_I6_D: "The entity of the team the player belongs to",
  T_49_META_TYP_14_I60_D: "The player's current orientation",
  T_49_META_TYP_14_I61_D: "The node used to access the skinned rigs",
  T_49_META_TYP_14_I62_D: "Backpack",
  T_49_META_TYP_14_I63_D: "Temporary Shield Points",
  T_49_META_TYP_14_I64_D: "Vehicle Skin ID",
  T_49_META_TYP_14_I65_D: "Is Skip Stagger Animation",
  T_49_META_TYP_14_I66_D: "Is No Fall Damage",
  T_49_META_TYP_14_I67_D: "Current Handheld Item",
  T_49_META_TYP_14_I68_D: "Item Pickup Banlist",
  T_49_META_TYP_14_I69_D: "Player's resource ID",
  T_49_META_TYP_14_I7_D: "Current checkpoint ID",
  T_49_META_TYP_14_I70_D: "The target to which the Request Purchase message was sent",
  T_49_META_TYP_14_I71_D: "The resource ID of the currently playing Emote",
  T_49_META_TYP_14_I72_D: "Whether the currently playing Emote is looping or not",
  T_49_META_TYP_14_I73_D: "Handling of knockdown status",
  T_49_META_TYP_14_I74_D: "Whether to enable damage skipping, the default is True, which means it's enabled.",
  T_49_META_TYP_14_I76_D: "Whether to quit in the middle of the game",
  T_49_META_TYP_14_I77_D: "Clothing information to be kept when the player transforms into another character",
  T_49_META_TYP_14_I8_D: "ID of the checkpoint the target is traveling to",
  T_49_META_TYP_140_I0_D: "Wave 1",
  T_49_META_TYP_140_I1_D: "Wave 2",
  T_49_META_TYP_140_I2_D: "Wave 3",
  T_49_META_TYP_140_I3_D: "Continuous",
  T_49_META_TYP_141_I0_D: "Loot Soccer Random",
  T_49_META_TYP_141_I1_D: "Loot Soccer Shield",
  T_49_META_TYP_141_I2_D: "Freezing Grenade",
  T_49_META_TYP_142_I0_D: "Loot Soccer",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (Shooting)",
  T_49_META_TYP_147_I1_D: "Third Person",
  T_49_META_TYP_147_I2_D: "First Person (Shooting)",
  T_49_META_TYP_147_I3_D: "Top-down perspective",
  T_49_META_TYP_147_I4_D: "Horizontal Scroll",
  T_49_META_TYP_147_I5_D: "Custom",
  T_49_META_TYP_147_I6_D: "Backchase",
  T_49_META_TYP_147_I7_D: "Player-controlled, free-moving camera",
  T_49_META_TYP_147_I8_D: "New version of the first person view camera",
  T_49_META_TYP_148_I0_D: "Provide many preset camera types and customized camera types.",
  T_49_META_TYP_148_I1_D: "Field of view is the camera's viewing angle",
  T_49_META_TYP_148_I10_D: "Camera Switch Animation Type",
  T_49_META_TYP_148_I11_D: "Transition time to this camera in milliseconds, only if the switch type is smooth.",
  T_49_META_TYP_148_I12_D: "Motion mode of the camera when there is an occlusion between the camera and the target.",
  T_49_META_TYP_148_I13_D: "How the camera renders the screen",
  T_49_META_TYP_148_I14_D: "Follow object offset reference coordinate system",
  T_49_META_TYP_148_I15_D: "Observing object offset reference coordinate system",
  T_49_META_TYP_148_I16_D: "The camera's rendering layer mask, which allows filtering the camera's rendered objects by visibility level",
  T_49_META_TYP_148_I17_D: "Viewing Angle Restriction",
  T_49_META_TYP_148_I2_D: "Generally refers to the offset of the camera's position from the player's home position, with different meanings for different camera types.",
  T_49_META_TYP_148_I3_D: "FOV is the offset of the camera's focus point from the player's home position, which varies by camera type.",
  T_49_META_TYP_148_I4_D: "Angle of rotation of the camera in the vertical direction",
  T_49_META_TYP_148_I5_D: "The angle of rotation of the camera in the horizontal direction.",
  T_49_META_TYP_148_I7_D: "The target that the camera is following",
  T_49_META_TYP_148_I8_D: "The target that the camera is looking at",
  T_49_META_TYP_148_I9_D: "The player who is using the camera",
  T_49_META_TYP_15_I0_D: "Whether all players in the team are currently dead",
  T_49_META_TYP_15_I1_D: "List of all players in the team",
  T_49_META_TYP_15_I3_D: "Hostile team list",
  T_49_META_TYP_15_I4_D: "List of friendly teams",
  T_49_META_TYP_15_I5_D: "Team number",
  T_49_META_TYP_150_I0_D: "Durability",
  T_49_META_TYP_150_I1_D: "The radius of the hemispheres at the ends of the capsule body.",
  T_49_META_TYP_150_I2_D: "Damage Factor",
  T_49_META_TYP_152_I1_D: "Custom Gravity",
  T_49_META_TYP_152_I2_D: "If or not need to show the trigger, True is show.",
  T_49_META_TYP_154_I0_D: "Cannot be dual-wielded",
  T_49_META_TYP_154_I1_D: "Can only be dual-wielded in combination with the same gun",
  T_49_META_TYP_154_I2_D: "Can be combo dual-wielded with another weapon as well as yourself",
  T_49_META_TYP_155_I0_D: "Level",
  T_49_META_TYP_155_I1_D: "Max. Durability",
  T_49_META_TYP_155_I2_D: "Current Durability",
  T_49_META_TYP_155_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_155_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_155_I5_D: "Can Cost Durability",
  T_49_META_TYP_155_I6_D: "Can Destroy",
  T_49_META_TYP_156_I1_D: "Max. Durability",
  T_49_META_TYP_156_I2_D: "Current Durability",
  T_49_META_TYP_156_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_156_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_156_I5_D: "Can Cost Durability",
  T_49_META_TYP_156_I6_D: "Can Destroy",
  T_49_META_TYP_157_I0_D: "No Animation",
  T_49_META_TYP_157_I1_D: "Smooth",
  T_49_META_TYP_158_I2_D: "UI anchor type enumeration, default value is 9 (Center)",
  T_49_META_TYP_158_I6_D: "Label Key",
  T_49_META_TYP_158_I7_D: "Label Params",
  T_49_META_TYP_158_I8_D: "Tweener Enabled",
  T_49_META_TYP_16_I1_D: "Item ID of the entity",
  T_49_META_TYP_16_I2_D: "Only for static loading of objects, to determine if the NavMesh is statically generated.",
  T_49_META_TYP_16_I3_D: "Whether it is dynamic blocking of NavMesh or not",
  T_49_META_TYP_16_I4_D: "Asynchronous loading",
  T_49_META_TYP_160_I0_D: "Brick A",
  T_49_META_TYP_160_I1_D: "Tile A",
  T_49_META_TYP_160_I10_D: "Sand A",
  T_49_META_TYP_160_I11_D: "Snow A",
  T_49_META_TYP_160_I12_D: "Wood A",
  T_49_META_TYP_160_I13_D: "Stone A",
  T_49_META_TYP_160_I14_D: "Lawn B",
  T_49_META_TYP_160_I15_D: "Brick B",
  T_49_META_TYP_160_I16_D: "Brick C",
  T_49_META_TYP_160_I17_D: "Clear",
  T_49_META_TYP_160_I2_D: "Tile B",
  T_49_META_TYP_160_I3_D: "Tile C",
  T_49_META_TYP_160_I4_D: "Bamboo A",
  T_49_META_TYP_160_I5_D: "Cement A",
  T_49_META_TYP_160_I6_D: "Container A",
  T_49_META_TYP_160_I7_D: "Lawn A",
  T_49_META_TYP_160_I8_D: "Ice A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Whether to enable collision",
  T_49_META_TYP_165_I1_D: "Whether or not to act as a trigger",
  T_49_META_TYP_165_I2_D: "Physical layers, configure layers in the physics module, up to 16.",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "VFX Texture Type",
  T_49_META_TYP_170_I0_D: "Visible or not, client stops rendering the target when it is not visible.",
  T_49_META_TYP_170_I1_D: "Visibility level, value in the range [0,15], affects the visibility in the camera.",
  T_49_META_TYP_171_I0_D: "Energy",
  T_49_META_TYP_172_I0_D: "Number of bullets",
  T_49_META_TYP_173_I0_D: "Extra Backpack Capacity",
  T_49_META_TYP_173_I1_D: "Priority of Skin configuration outside of the player's station.",
  T_49_META_TYP_173_I2_D: "Skin ID of the backpack, Skin configuration of the backpack itself",
  T_49_META_TYP_174_I2_D: "Max. Damage",
  T_49_META_TYP_174_I4_D: "Throw Speed",
  T_49_META_TYP_174_I5_D: "Explosion delay, in seconds",
  T_49_META_TYP_174_I6_D: "Self-Damage Factor",
  T_49_META_TYP_174_I7_D: "Friendly Fire DMG Coeff.",
  T_49_META_TYP_174_I8_D: "Ratio Vehicle Factor",
  T_49_META_TYP_174_I9_D: "Skin",
  T_49_META_TYP_175_I0_D: "Freeze Zone Radius",
  T_49_META_TYP_175_I1_D: "Frozen area duration in seconds",
  T_49_META_TYP_176_I0_D: "Weapon's primary type",
  T_49_META_TYP_176_I1_D: "Weapon Subtype",
  T_49_META_TYP_177_I0_D: "When there is an obstacle between the camera and the object to be followed, the camera will not change.",
  T_49_META_TYP_177_I1_D: "When there is an obstacle between the camera and the object to follow, the camera will be pushed closer to the object to follow.",
  T_49_META_TYP_177_I2_D: "When there is an occlusion between the camera and the object, the occlusion will become translucent.",
  T_49_META_TYP_178_I0_D: "When the camera looks at the object, the near object is big and the far object is small",
  T_49_META_TYP_178_I1_D: "Near and far objects are the same size when the camera is looking at them.",
  T_49_META_TYP_184_I0_D: "The UUID of the resource to be rendered.",
  T_49_META_TYP_185_I0_D: "Model mesh to use for rendering",
  T_49_META_TYP_185_I1_D: "The list of materials to use for rendering",
  T_49_META_TYP_187_I0_D: "Item ID",
  T_49_META_TYP_190_I0_D: "Open status",
  T_49_META_TYP_190_I1_D: "Match result",
  T_49_META_TYP_190_I10_D: "Scores1",
  T_49_META_TYP_190_I11_D: "Scores2",
  T_49_META_TYP_190_I12_D: "Scores3",
  T_49_META_TYP_190_I13_D: "Win MVPs",
  T_49_META_TYP_190_I14_D: "Lose MVPs",
  T_49_META_TYP_190_I15_D: "Show Match Details",
  T_49_META_TYP_190_I16_D: "Show Map Ratings",
  T_49_META_TYP_190_I17_D: "Show Gift",
  T_49_META_TYP_190_I18_D: "Show Report",
  T_49_META_TYP_190_I19_D: "Show Replay",
  T_49_META_TYP_190_I20_D: "Show Share",
  T_49_META_TYP_190_I21_D: "Show Lobby",
  T_49_META_TYP_190_I22_D: "Show Like",
  T_49_META_TYP_190_I23_D: "Show Add Friend",
  T_49_META_TYP_190_I24_D: "Show Ecconomy",
  T_49_META_TYP_190_I4_D: "Left Team",
  T_49_META_TYP_190_I5_D: "Right Team",
  T_49_META_TYP_190_I6_D: "Player Rank",
  T_49_META_TYP_190_I9_D: "Titles",
  T_49_META_TYP_191_I0_D: "Center Range",
  T_49_META_TYP_191_I4_D: "Center flash duration in milliseconds",
  T_49_META_TYP_191_I5_D: "Edge flash duration in milliseconds",
  T_49_META_TYP_191_I6_D: "Flashbang Hit Effect Switch",
  T_49_META_TYP_192_I3_D: "Duration of effect, in seconds",
  T_49_META_TYP_193_I1_D: "Match Title Left",
  T_49_META_TYP_193_I10_D: "Scores1",
  T_49_META_TYP_193_I11_D: "Scores2",
  T_49_META_TYP_193_I12_D: "Scores3",
  T_49_META_TYP_193_I13_D: "Scores4",
  T_49_META_TYP_193_I14_D: "Scores5",
  T_49_META_TYP_193_I15_D: "Win MVPs",
  T_49_META_TYP_193_I16_D: "Lose MVPs",
  T_49_META_TYP_193_I17_D: "Show Match Details",
  T_49_META_TYP_193_I18_D: "Show Map Ratings",
  T_49_META_TYP_193_I19_D: "Show Gift",
  T_49_META_TYP_193_I2_D: "Match Title Right",
  T_49_META_TYP_193_I20_D: "Show Report",
  T_49_META_TYP_193_I21_D: "Show Replay",
  T_49_META_TYP_193_I22_D: "Show Share",
  T_49_META_TYP_193_I23_D: "Show Lobby",
  T_49_META_TYP_193_I24_D: "Show Like",
  T_49_META_TYP_193_I25_D: "Show Add Friend",
  T_49_META_TYP_193_I26_D: "Show Ecconomy",
  T_49_META_TYP_193_I3_D: "Match result",
  T_49_META_TYP_193_I4_D: "Team Rank",
  T_49_META_TYP_193_I5_D: "Player Rank",
  T_49_META_TYP_193_I6_D: "Name of the team",
  T_49_META_TYP_193_I7_D: "Main Score Title",
  T_49_META_TYP_193_I8_D: "Main Scores",
  T_49_META_TYP_193_I9_D: "Titles",
  T_49_META_TYP_194_I0_D: "Time for the mine to take effect, in seconds",
  T_49_META_TYP_194_I1_D: "Trigger radius",
  T_49_META_TYP_194_I2_D: "Length of time it takes to trigger a mine within the mine's range, in seconds",
  T_49_META_TYP_194_I3_D: "Can Self Trigger",
  T_49_META_TYP_194_I4_D: "Can Teammates Trigger",
  T_49_META_TYP_194_I5_D: "Can Triggered by Vehicle",
  T_49_META_TYP_194_I6_D: "Duration of the mine's existence, which automatically explodes when it ends, from the time it is dropped, in units of seconds",
  T_49_META_TYP_194_I7_D: "Is Attackable",
  T_49_META_TYP_194_I8_D: "Life value",
  T_49_META_TYP_195_I0_D: "Once",
  T_49_META_TYP_195_I2_D: "Reciprocation",
  T_49_META_TYP_197_I0_D: "Whether the wave is playing or not",
  T_49_META_TYP_197_I1_D: "Flag bit",
  T_49_META_TYP_197_I2_D: "If checked, it will be played automatically upon creation.",
  T_49_META_TYP_198_I0_D: "The prop id of the accessory.",
  T_49_META_TYP_199_I0_D: "Max EP",
  T_49_META_TYP_199_I1_D: "Energy Cost",
  T_49_META_TYP_199_I10_D: "Fall Damage Ratio",
  T_49_META_TYP_199_I11_D: "Current Energy",
  T_49_META_TYP_199_I2_D: "UpEnergy Cost",
  T_49_META_TYP_199_I3_D: "Sprint Energy Cost",
  T_49_META_TYP_199_I4_D: "Rush Energy Cost",
  T_49_META_TYP_199_I5_D: "Base Horizontal Speed",
  T_49_META_TYP_199_I6_D: "Sprint Horizontal Speed",
  T_49_META_TYP_199_I7_D: "Base Vertical Speed",
  T_49_META_TYP_199_I8_D: "Sprint Vertical Speed",
  T_49_META_TYP_199_I9_D: "Sprint Distance",
  T_49_META_TYP_200_I0_D: "Area ID",
  T_49_META_TYP_200_I1_D: "Game ID",
  T_49_META_TYP_201_I0_D: "Percentage of slowdown: Percentage of slowdown of movement speed in open water for water objects",
  T_49_META_TYP_203_I0_D: "target entity",
  T_49_META_TYP_203_I1_D: "Prop ID",
  T_49_META_TYP_203_I10_D: "The moment when the game server starts ticking",
  T_49_META_TYP_203_I11_D: "Start Value",
  T_49_META_TYP_203_I12_D: "End Value",
  T_49_META_TYP_203_I13_D: "Percentage passed",
  T_49_META_TYP_203_I4_D: "Tween Style",
  T_49_META_TYP_203_I6_D: "Duration (s)",
  T_49_META_TYP_203_I7_D: "Is Reverse",
  T_49_META_TYP_203_I8_D: "Control Points",
  T_49_META_TYP_203_I9_D: "Forced synchronization of the game server state",
  T_49_META_TYP_204_I0_D: "Max. Double Jump Height",
  T_49_META_TYP_204_I1_D: "Fall Damage Percentage",
  T_49_META_TYP_204_I2_D: "Energy Recovery",
  T_49_META_TYP_204_I3_D: "Energy consumption",
  T_49_META_TYP_204_I4_D: "Max. Energy",
  T_49_META_TYP_205_I0_D: "Min. Fly Height",
  T_49_META_TYP_205_I1_D: "Min. End Height",
  T_49_META_TYP_205_I2_D: "Horizontal Glide Speed",
  T_49_META_TYP_205_I3_D: "Vertical Glide Speed",
  T_49_META_TYP_205_I4_D: "Fall Speed",
  T_49_META_TYP_205_I5_D: "Turning Speed",
  T_49_META_TYP_205_I6_D: "Fly Max. Height",
  T_49_META_TYP_205_I7_D: "Overheight Fall Speed",
  T_49_META_TYP_205_I8_D: "Speed change acceleration",
  T_49_META_TYP_206_I0_D: "Velocity",
  T_49_META_TYP_206_I1_D: "Acceleration",
  T_49_META_TYP_206_I10_D: "Maximum steering angle at high speed",
  T_49_META_TYP_206_I11_D: "Tween base rate of high speed steering angle",
  T_49_META_TYP_206_I2_D: "Sprint Speed",
  T_49_META_TYP_206_I3_D: "Duration of sprint, in seconds",
  T_49_META_TYP_206_I4_D: "Sprint cooldown, in seconds",
  T_49_META_TYP_206_I6_D: "Jump CD, in seconds",
  T_49_META_TYP_206_I7_D: "Sprint CD after boarding, in seconds",
  T_49_META_TYP_206_I8_D: "Get On Boost CD Switch",
  T_49_META_TYP_206_I9_D: "Get on board CD, in seconds",
  T_49_META_TYP_207_I1_D: "Start Index",
  T_49_META_TYP_207_I2_D: "End Position",
  T_49_META_TYP_207_I3_D: "Slide ID",
  T_49_META_TYP_207_I4_D: "Group ID",
  T_49_META_TYP_207_I5_D: "End or not",
  T_49_META_TYP_21_I0_D: "The base level of the UI",
  T_49_META_TYP_210_I1_D: "Initial Velocity",
  T_49_META_TYP_210_I2_D: "Acceleration",
  T_49_META_TYP_210_I3_D: "Max. Displacement",
  T_49_META_TYP_210_I4_D: "InitialWorldPosition",
  T_49_META_TYP_210_I5_D: "Forced synchronization of position information by game server",
  T_49_META_TYP_211_I0_D: "Local Position",
  T_49_META_TYP_211_I1_D: "World Position",
  T_49_META_TYP_212_I0_D: "Self",
  T_49_META_TYP_212_I2_D: "Offset coordinate",
  T_49_META_TYP_213_I0_D: "Self",
  T_49_META_TYP_213_I2_D: "Offset coordinate",
  T_49_META_TYP_215_I0_D: "Victory",
  T_49_META_TYP_215_I1_D: "Defeat",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Draw",
  T_49_META_TYP_218_I0_D: "Intensity",
  T_49_META_TYP_218_I1_D: "Range",
  T_49_META_TYP_218_I2_D: "Light color",
  T_49_META_TYP_22_I0_D: "Displayed if on is true, off otherwise",
  T_49_META_TYP_22_I1_D: "Prefab ID",
  T_49_META_TYP_22_I2_D: "The ID of the current largest widget",
  T_49_META_TYP_22_I3_D: "Base level of UI",
  T_49_META_TYP_22_I4_D: "Enable Player View",
  T_49_META_TYP_22_I5_D: "World Position",
  T_49_META_TYP_22_I6_D: "Whether or not it is in the Scene",
  T_49_META_TYP_22_I7_D: "Rotation in the world coordinate system",
  T_49_META_TYP_22_I8_D: "Zoom in the world coordinate system",
  T_49_META_TYP_221_I0_D: "The larger the value, the slower the speed of gear change.",
  T_49_META_TYP_222_I0_D: "Gear switching delay, the larger this value is, the slower the gear changes.",
  T_49_META_TYP_225_I0_D: "Turret Damage",
  T_49_META_TYP_225_I1_D: "Damage Interval (s)",
  T_49_META_TYP_225_I10_D: "Fire only at an angle",
  T_49_META_TYP_225_I11_D: "Damage Reduction Rate",
  T_49_META_TYP_225_I12_D: "Armor Penetration",
  T_49_META_TYP_225_I2_D: "Accuracy",
  T_49_META_TYP_225_I3_D: "Range",
  T_49_META_TYP_225_I4_D: "Angular Speed",
  T_49_META_TYP_225_I5_D: "Angle Up",
  T_49_META_TYP_225_I6_D: "Angle Down",
  T_49_META_TYP_225_I7_D: "Max. HP",
  T_49_META_TYP_225_I8_D: "Life Time (s)",
  T_49_META_TYP_225_I9_D: "Max. Turret Count",
  T_49_META_TYP_226_I0_D: "Turret current life value",
  T_49_META_TYP_226_I1_D: "Enable Attack",
  T_49_META_TYP_227_I0_D: "Simple Widget",
  T_49_META_TYP_227_I1_D: "Image Widget",
  T_49_META_TYP_227_I10_D: "Texture Widget",
  T_49_META_TYP_227_I11_D: "Profile Widget",
  T_49_META_TYP_227_I12_D: "Toggle Widget",
  T_49_META_TYP_227_I13_D: "Touch Pad Widget",
  T_49_META_TYP_227_I14_D: "Joystick Widget",
  T_49_META_TYP_227_I15_D: "Social Button Widget",
  T_49_META_TYP_227_I2_D: "Label Widget",
  T_49_META_TYP_227_I3_D: "Button Widget",
  T_49_META_TYP_227_I4_D: "Input Label Widget",
  T_49_META_TYP_227_I5_D: "Panel",
  T_49_META_TYP_227_I6_D: "Scroll Panel",
  T_49_META_TYP_227_I7_D: "Grid",
  T_49_META_TYP_227_I8_D: "Layout Widget",
  T_49_META_TYP_227_I9_D: "Container Widget",
  T_49_META_TYP_231_I0_D: "Durability Recovery",
  T_49_META_TYP_231_I1_D: "Effective time interval, in seconds",
  T_49_META_TYP_233_I2_D: "Time to expiration, in seconds",
  T_49_META_TYP_233_I4_D: "Icon resource name",
  T_49_META_TYP_234_I0_D: "Trigger time, in seconds",
  T_49_META_TYP_234_I1_D: "Can Self Trigger",
  T_49_META_TYP_234_I10_D: "Current life value",
  T_49_META_TYP_234_I2_D: "Can Teammates Trigger",
  T_49_META_TYP_234_I3_D: "Can Triggered by Vehicle",
  T_49_META_TYP_234_I4_D: "Duration in seconds",
  T_49_META_TYP_234_I5_D: "Is Attackable",
  T_49_META_TYP_234_I6_D: "Life value",
  T_49_META_TYP_235_I0_D: "Maximum life value",
  T_49_META_TYP_235_I2_D: "Max. Count",
  T_49_META_TYP_237_I0_D: "Throw Speed",
  T_49_META_TYP_237_I1_D: "Player Traction Speed",
  T_49_META_TYP_238_I0_D: "Spray Color",
  T_49_META_TYP_239_I0_D: "Initial speed",
  T_49_META_TYP_239_I1_D: "Acceleration speed (e.g. gravity)",
  T_49_META_TYP_24_I0_D: "Melee",
  T_49_META_TYP_24_I1_D: "Gun",
  T_49_META_TYP_24_I10_D: "Airdrop hit damage, monster suicide damage",
  T_49_META_TYP_24_I11_D: "Burning Damage on Vehicle Explosion",
  T_49_META_TYP_24_I12_D: "Oil Drum Explosion",
  T_49_META_TYP_24_I13_D: "Missile-Type Weapon",
  T_49_META_TYP_24_I14_D: "Monster",
  T_49_META_TYP_24_I15_D: "Damage Zone",
  T_49_META_TYP_24_I17_D: "Character Skill",
  T_49_META_TYP_24_I2_D: "Throw Attack",
  T_49_META_TYP_24_I3_D: "Safe Zone",
  T_49_META_TYP_24_I4_D: "Vehicle",
  T_49_META_TYP_24_I5_D: "Falling",
  T_49_META_TYP_24_I6_D: "KillZone",
  T_49_META_TYP_24_I7_D: "Exit",
  T_49_META_TYP_24_I8_D: "Disconnect",
  T_49_META_TYP_24_I9_D: "Vehicle Explosion",
  T_49_META_TYP_241_I0_D: "Traction speed",
  T_49_META_TYP_241_I1_D: "Swing speed",
  T_49_META_TYP_241_I2_D: "Turn on traction button",
  T_49_META_TYP_241_I3_D: "Turn on swing button",
  T_49_META_TYP_241_I4_D: "Motion anchor point",
  T_49_META_TYP_241_I5_D: "Swing Exit Acceleration",
  T_49_META_TYP_242_I2_D: "Left Effect Active",
  T_49_META_TYP_242_I3_D: "Right Effect Active",
  T_49_META_TYP_242_I4_D: "Central Line Active",
  T_49_META_TYP_242_I5_D: "Value",
  T_49_META_TYP_242_I7_D: "UI position, only the XY component is active",
  T_49_META_TYP_242_I8_D: "Position of the median [0,1]",
  T_49_META_TYP_243_I0_D: "Top Wear",
  T_49_META_TYP_243_I1_D: "Bottom Wear",
  T_49_META_TYP_243_I2_D: "Shoes",
  T_49_META_TYP_243_I3_D: "Facepaint",
  T_49_META_TYP_243_I4_D: "Headwear",
  T_49_META_TYP_243_I5_D: "Bodysuit",
  T_49_META_TYP_243_I6_D: "Facepaint",
  T_49_META_TYP_244_I0_D: "Text content to be displayed",
  T_49_META_TYP_244_I10_D: "List of players who can see this entity",
  T_49_META_TYP_244_I11_D: "Display level",
  T_49_META_TYP_244_I2_D: "Follow Target",
  T_49_META_TYP_244_I3_D: "When depth is ignored it can be displayed through the wall, otherwise it won't work",
  T_49_META_TYP_244_I4_D: "Always Facing Camera",
  T_49_META_TYP_244_I5_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_244_I6_D: "Font Style",
  T_49_META_TYP_244_I7_D: "Font type",
  T_49_META_TYP_244_I8_D: "Font size",
  T_49_META_TYP_245_I0_D: "Effect Resource Path",
  T_49_META_TYP_245_I11_D: "Display Layers",
  T_49_META_TYP_245_I3_D: "When ignore depth, it can be displayed through the wall, otherwise it won't work.",
  T_49_META_TYP_245_I4_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_245_I5_D: "Always Facing Camera",
  T_49_META_TYP_245_I6_D: "Render Type",
  T_49_META_TYP_245_I7_D: "Width",
  T_49_META_TYP_246_I0_D: "Orange",
  T_49_META_TYP_246_I1_D: "Purple",
  T_49_META_TYP_246_I2_D: "Red",
  T_49_META_TYP_246_I3_D: "Green",
  T_49_META_TYP_246_I4_D: "Blue",
  T_49_META_TYP_247_I1_D: "Sprint",
  T_49_META_TYP_247_I14_D: "Emote",
  T_49_META_TYP_247_I15_D: "Quick Chat",
  T_49_META_TYP_247_I16_D: "Pickups",
  T_49_META_TYP_247_I17_D: "Quick Chat Show",
  T_49_META_TYP_247_I18_D: "HP",
  T_49_META_TYP_247_I19_D: "EP",
  T_49_META_TYP_247_I2_D: "Attack",
  T_49_META_TYP_247_I20_D: "Armor",
  T_49_META_TYP_247_I21_D: "Reload",
  T_49_META_TYP_247_I22_D: "Quick Change Button",
  T_49_META_TYP_247_I23_D: "Carrier Speaker Button",
  T_49_META_TYP_247_I24_D: "Enable/disable voice (microphone) button",
  T_49_META_TYP_247_I25_D: "Enable/disable marker button",
  T_49_META_TYP_247_I27_D: "Enable/disable network signal button",
  T_49_META_TYP_247_I28_D: "Active Skill",
  T_49_META_TYP_247_I29_D: "Crosshair",
  T_49_META_TYP_247_I3_D: "Jump",
  T_49_META_TYP_247_I30_D: "Passive Skill",
  T_49_META_TYP_247_I4_D: "Killing Tips",
  T_49_META_TYP_247_I5_D: "Weapon Slot",
  T_49_META_TYP_247_I6_D: "Mini Map",
  T_49_META_TYP_247_I7_D: "Backpack UI",
  T_49_META_TYP_247_I8_D: "Medical Items",
  T_49_META_TYP_247_I9_D: "Displayed when True, otherwise turned off",
  T_49_META_TYP_249_I3_D: "Demolition weapons",
  T_49_META_TYP_249_I5_D: "HeavyWeapon",
  T_49_META_TYP_249_I8_D: "Freeze Bomb",
  T_49_META_TYP_249_I9_D: "DummyGrenade",
  T_49_META_TYP_25_I0_D: "Index of the current phase, corresponding to the index in the flow editor",
  T_49_META_TYP_25_I1_D: "Start time of the current phase, in ms.",
  T_49_META_TYP_25_I2_D: "The end time of the current phase in ms.",
  T_49_META_TYP_25_I3_D: "Duration of the current phase in ms.",
  T_49_META_TYP_250_I1_D: "Special effect color, RGBA four channels, single channel value range 0~255, stored in an Int32.",
  T_49_META_TYP_250_I3_D: "VFX Texture Type",
  T_49_META_TYP_250_I4_D: "Diffuse Alpha",
  T_49_META_TYP_2500_I1_D: "Is Default Spawn Point",
  T_49_META_TYP_2500_I3_D: "Whether or not a player has already been born in the birth point area.",
  T_49_META_TYP_2500_I4_D: "The coordinates of the currently assignable birth point location",
  T_49_META_TYP_2502_I0_D: "Whether it is a death trigger, when it is not a death trigger it is an invincibility trigger. (This is a legacy issue from OB32, please split the function in the future!)",
  T_49_META_TYP_2502_I1_D: "Whether to show trigger border, true for show",
  T_49_META_TYP_2503_I0_D: "Checkpoint ID",
  T_49_META_TYP_2503_I2_D: "Location of checkpoints",
  T_49_META_TYP_2507_I0_D: "Which camp the tower belongs to, if it is the same as the player, it won't attack the player.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "Object ID",
  T_49_META_TYP_2507_I2_D: "Max. HP",
  T_49_META_TYP_2507_I3_D: "Attack damage, the damage that can be done to the player by a single attack.",
  T_49_META_TYP_2507_I4_D: "The interval between attacks, in seconds.",
  T_49_META_TYP_2507_I5_D: "Attacks can be made in a radius from the center of the tower.",
  T_49_META_TYP_2507_I6_D: "Damage reduction rate, a decimal number less than 1, the final damage is the damage multiplied by (1 - damage reduction rate)",
  T_49_META_TYP_2507_I7_D: "Attack Target",
  T_49_META_TYP_2507_I8_D: "Angle",
  T_49_META_TYP_2507_I9_D: "Mini Sentry Status",
  T_49_META_TYP_2508_I0_D: "How many zombies will be spawned in each wave",
  T_49_META_TYP_2508_I1_D: "How many waves of zombies will be spawned in total",
  T_49_META_TYP_2508_I2_D: "Whether to spawn continuously, but there will be an upper limit for the same screen.",
  T_49_META_TYP_2508_I3_D: "How many waves will be spawned in the current wave?",
  T_49_META_TYP_2508_I5_D: "What kind of zombies are spawned in the current wave",
  T_49_META_TYP_2508_I6_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_2508_I7_D: "Start Spawn Time (s)",
  T_49_META_TYP_2508_I8_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I0_D: "The number of unit bodies that will be generated in each wave",
  T_49_META_TYP_2509_I1_D: "How many waves of unit generators will be generated in total",
  T_49_META_TYP_2509_I2_D: "How many waves are currently generated",
  T_49_META_TYP_2509_I4_D: "Which entity will be used as a template for each wave of generation",
  T_49_META_TYP_2509_I5_D: "When the units will start generating",
  T_49_META_TYP_2509_I6_D: "Whether or not to spawn consecutively, but there will be an upper limit of the same screen",
  T_49_META_TYP_2509_I7_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I8_D: "The prefabID of the template",
  T_49_META_TYP_2510_I0_D: "Spawn Point Count",
  T_49_META_TYP_252_I1_D: "Left Icon",
  T_49_META_TYP_252_I2_D: "Left Text",
  T_49_META_TYP_252_I3_D: "Left Score",
  T_49_META_TYP_252_I5_D: "Right Icon",
  T_49_META_TYP_252_I6_D: "Right Text",
  T_49_META_TYP_252_I7_D: "Right Score",
  T_49_META_TYP_252_I8_D: "Progress [0,1]",
  T_49_META_TYP_253_I0_D: "Select Icon",
  T_49_META_TYP_253_I1_D: "Text",
  T_49_META_TYP_253_I2_D: "Show Effect",
  T_49_META_TYP_253_I3_D: "UI position",
  T_49_META_TYP_254_I1_D: "For example, 1.25 means 1.25 times the normal speed.",
  T_49_META_TYP_254_I2_D: "Color",
  T_49_META_TYP_256_I0_D: "Completely stationary. Minimum Performance",
  T_49_META_TYP_256_I1_D: "Normal force application. Least performance",
  T_49_META_TYP_256_I2_D: "Motion can be controlled by scripting and can be considered as mass infinite",
  T_49_META_TYP_257_I0_D: "Functions of different types of rigid bodies",
  T_49_META_TYP_257_I1_D: "Use Gravity",
  T_49_META_TYP_257_I2_D: "Mass (kg), the minimum effective mass is 0.001kg, if it is 0, then it is infinite mass and will not move under force.",
  T_49_META_TYP_257_I3_D: "Position of the center of gravity, local coordinate system",
  T_49_META_TYP_257_I4_D: "Linear velocity of rigid body motion",
  T_49_META_TYP_257_I5_D: "Angular velocity of rigid body motion",
  T_49_META_TYP_257_I6_D: "Coefficient of natural decay of linear velocity, the larger the coefficient, the faster the decay of velocity.",
  T_49_META_TYP_257_I7_D: "Angular velocity natural decay coefficient, the larger the coefficient, the faster the velocity decays.",
  T_49_META_TYP_257_I8_D: "The constraints imposed on the rigid body, a collection of RigidbodyConstrainType.",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Background",
  T_49_META_TYP_259_I1_D: "Text",
  T_49_META_TYP_259_I2_D: "UI position",
  T_49_META_TYP_259_I4_D: "Text Color",
  T_49_META_TYP_260_I0_D: "Select Icon",
  T_49_META_TYP_260_I1_D: "Progress bar color",
  T_49_META_TYP_260_I2_D: "Value",
  T_49_META_TYP_260_I3_D: "Speed in m/s",
  T_49_META_TYP_260_I4_D: "Whether to display special effects",
  T_49_META_TYP_260_I5_D: "UI position [0,1].",
  T_49_META_TYP_260_I6_D: "Initial progress of the skill, value [0, 1], the progress will be synchronized to the current progress immediately after the UI is created.",
  T_49_META_TYP_260_I7_D: "Effect Color",
  T_49_META_TYP_260_I8_D: "Set the object scaling value",
  T_49_META_TYP_265_I1_D: "Background fill or not",
  T_49_META_TYP_265_I2_D: "Background Name",
  T_49_META_TYP_265_I3_D: "Background Color",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Crop type",
  T_49_META_TYP_265_I7_D: "Mask type is the name of the image selected for masking",
  T_49_META_TYP_265_I8_D: "Edge softening unit",
  T_49_META_TYP_267_I0_D: "Scroll start point, default is top left corner.",
  T_49_META_TYP_267_I1_D: "Support multiple scrolling directions",
  T_49_META_TYP_267_I10_D: "Horizontal Bar",
  T_49_META_TYP_267_I11_D: "Show position",
  T_49_META_TYP_267_I2_D: "XY direction drag component",
  T_49_META_TYP_267_I3_D: "Support multiple dragging effects",
  T_49_META_TYP_267_I4_D: "Scroll factor, the larger the value, the faster the scrolling.",
  T_49_META_TYP_267_I5_D: "Inertia factor, the larger the value, the larger the inertia when scrolling.",
  T_49_META_TYP_267_I6_D: "If or not the drag is limited to the viewport, default is checked.",
  T_49_META_TYP_267_I7_D: "When checked, the drag will start to move slowly, if unchecked, the drag will start to move at the speed of the mouse.",
  T_49_META_TYP_267_I8_D: "Exit dragging when it fits in the viewport.",
  T_49_META_TYP_267_I9_D: "Vertical Bar",
  T_49_META_TYP_268_I0_D: "Default",
  T_49_META_TYP_268_I1_D: "Close",
  T_49_META_TYP_268_I2_D: "Show",
  T_49_META_TYP_269_I0_D: "Owner",
  T_49_META_TYP_269_I1_D: "Set ID",
  T_49_META_TYP_269_I2_D: "Headwear ID",
  T_49_META_TYP_269_I3_D: "Face ID",
  T_49_META_TYP_269_I4_D: "Makeup ID",
  T_49_META_TYP_269_I5_D: "Upper Body ID",
  T_49_META_TYP_269_I6_D: "Bottom ID",
  T_49_META_TYP_269_I7_D: "Shoe ID",
  T_49_META_TYP_272_I0_D: "Female",
  T_49_META_TYP_272_I1_D: "Male",
  T_49_META_TYP_273_I0_D: "World coordinates of the center of the mini-map",
  T_49_META_TYP_273_I1_D: "Size of the mini-map, same width and height",
  T_49_META_TYP_273_I2_D: "Enable or disable the depth map display mode of the mini-map",
  T_49_META_TYP_274_I1_D: "Zoom size",
  T_49_META_TYP_274_I4_D: "Icon display level",
  T_49_META_TYP_275_I0_D: "Skeleton Scale",
  T_49_META_TYP_275_I1_D: "World coordinates of rig nodes",
  T_49_META_TYP_276_I0_D: "Head",
  T_49_META_TYP_276_I1_D: "Left Arm",
  T_49_META_TYP_276_I2_D: "Left Hand",
  T_49_META_TYP_276_I3_D: "Right Arm",
  T_49_META_TYP_276_I4_D: "Right Hand",
  T_49_META_TYP_276_I5_D: "Torso",
  T_49_META_TYP_276_I6_D: "Left Leg",
  T_49_META_TYP_276_I7_D: "Left Foot",
  T_49_META_TYP_276_I8_D: "Right Leg",
  T_49_META_TYP_276_I9_D: "Right Foot",
  T_49_META_TYP_277_I1_D: "Distance for camera ray detection",
  T_49_META_TYP_277_I2_D: "Collision layer mask for camera ray detection",
  T_49_META_TYP_277_I3_D: "Button position offset",
  T_49_META_TYP_277_I4_D: "Icon resource ID",
  T_49_META_TYP_277_I5_D: "Click area size",
  T_49_META_TYP_277_I6_D: "Whether objects are displayed at the target point",
  T_49_META_TYP_277_I7_D: "Objects displayed at the target point",
  T_49_META_TYP_278_I0_D: "Target entity for generating map pixels",
  T_49_META_TYP_28_I0_D: "Whether or not the team can reset every round.",
  T_49_META_TYP_280_I0_D: "Sphere radius",
  T_49_META_TYP_281_I0_D: "The radius of the hemispheres at both ends of the capsule.",
  T_49_META_TYP_29_I0_D: "Sphere",
  T_49_META_TYP_29_I1_D: "Light Beam",
  T_49_META_TYP_29_I10_D: "A pillar of light under the feet, now used for feedback when entering the finish line",
  T_49_META_TYP_29_I11_D: "Freeze",
  T_49_META_TYP_29_I12_D: "Light",
  T_49_META_TYP_29_I13_D: "Updraft",
  T_49_META_TYP_29_I14_D: "Gas Explosion",
  T_49_META_TYP_29_I15_D: "Hider Eliminated",
  T_49_META_TYP_29_I16_D: "Rampage",
  T_49_META_TYP_29_I17_D: "Clone Death",
  T_49_META_TYP_29_I18_D: "Shooting Feedback",
  T_49_META_TYP_29_I19_D: "Clone Death",
  T_49_META_TYP_29_I2_D: "Boom",
  T_49_META_TYP_29_I20_D: "Clone",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "Flashbang Smoke",
  T_49_META_TYP_29_I23_D: "Fireball",
  T_49_META_TYP_29_I24_D: "Burning in a Loop",
  T_49_META_TYP_29_I25_D: "Poison Gas",
  T_49_META_TYP_29_I26_D: "Heart",
  T_49_META_TYP_29_I29_D: "Door",
  T_49_META_TYP_29_I30_D: "Fireworks",
  T_49_META_TYP_29_I31_D: "Running Shoes VFX",
  T_49_META_TYP_29_I32_D: "Explosion VFX",
  T_49_META_TYP_29_I33_D: "Spawn Point VFX",
  T_49_META_TYP_29_I34_D: "Laser VFX",
  T_49_META_TYP_29_I35_D: "Skill Cast VFX",
  T_49_META_TYP_29_I36_D: "Bullet VFX",
  T_49_META_TYP_29_I37_D: "Bullet Hit VFX",
  T_49_META_TYP_29_I38_D: "Shooting VFX",
  T_49_META_TYP_29_I39_D: "Skill VFX",
  T_49_META_TYP_29_I40_D: "Halo",
  T_49_META_TYP_29_I41_D: "Bubbles",
  T_49_META_TYP_29_I42_D: "Smoke and Dust",
  T_49_META_TYP_29_I43_D: "Flying Debris",
  T_49_META_TYP_29_I44_D: "Lines",
  T_49_META_TYP_29_I45_D: "Flicker",
  T_49_META_TYP_29_I47_D: "Rising Particles",
  T_49_META_TYP_29_I48_D: "Smoke",
  T_49_META_TYP_29_I49_D: "Talisman",
  T_49_META_TYP_29_I50_D: "Frozen Area",
  T_49_META_TYP_29_I51_D: "Fog",
  T_49_META_TYP_29_I52_D: "Snowflake",
  T_49_META_TYP_29_I53_D: "Fire",
  T_49_META_TYP_29_I54_D: "Light Beam",
  T_49_META_TYP_29_I55_D: "Diffusing Poison Gas",
  T_49_META_TYP_29_I56_D: "Poison Gas",
  T_49_META_TYP_29_I57_D: "Explosion Flames",
  T_49_META_TYP_29_I58_D: "Light Effect",
  T_49_META_TYP_29_I59_D: "Star",
  T_49_META_TYP_29_I6_D: "Foot Halo",
  T_49_META_TYP_29_I60_D: "Blazing Bonfire",
  T_49_META_TYP_29_I61_D: "Water Splash",
  T_49_META_TYP_29_I62_D: "Electric Shock",
  T_49_META_TYP_29_I63_D: "Ink VFX",
  T_49_META_TYP_29_I64_D: "Blackhole VFX",
  T_49_META_TYP_29_I65_D: "Blackhole Explosion VFX",
  T_49_META_TYP_29_I66_D: "Crystal Ball VFX",
  T_49_META_TYP_29_I67_D: "Laser bullet effect",
  T_49_META_TYP_29_I68_D: "Drag effects",
  T_49_META_TYP_29_I69_D: "Clouds",
  T_49_META_TYP_29_I7_D: "Ground Marker",
  T_49_META_TYP_29_I8_D: "Smoke",
  T_49_META_TYP_29_I9_D: "Talisman Explosion",
  T_49_META_TYP_290_I0_D: "Refresh interval, the larger the number, the slower the refresh, in milliseconds.",
  T_49_META_TYP_290_I1_D: "Whether to enable debugging",
  T_49_META_TYP_291_I0_D: "Condition Node",
  T_49_META_TYP_291_I1_D: "Action Node",
  T_49_META_TYP_293_I0_D: "Behavior Tree ID",
  T_49_META_TYP_293_I1_D: "Attach Target",
  T_49_META_TYP_294_I1_D: "Layout Type",
  T_49_META_TYP_294_I10_D: "Sort Order",
  T_49_META_TYP_294_I2_D: "Content Origin",
  T_49_META_TYP_294_I3_D: "Alignment direction",
  T_49_META_TYP_294_I4_D: "Width and height of the sub-item grid",
  T_49_META_TYP_294_I5_D: "Cell Space",
  T_49_META_TYP_294_I6_D: "Constraint",
  T_49_META_TYP_294_I7_D: "Constraint Count",
  T_49_META_TYP_294_I8_D: "Vertical offset",
  T_49_META_TYP_294_I9_D: "Horizontal offset",
  T_49_META_TYP_295_I2_D: "Play Speed",
  T_49_META_TYP_296_I1_D: "Clip Length",
  T_49_META_TYP_297_I0_D: "Bound objects",
  T_49_META_TYP_297_I4_D: "Resource ID",
  T_49_META_TYP_298_I0_D: "Default",
  T_49_META_TYP_298_I2_D: "Once",
  T_49_META_TYP_30_I0_D: "Square",
  T_49_META_TYP_30_I1_D: "Quadrilateral",
  T_49_META_TYP_30_I10_D: "Arrow",
  T_49_META_TYP_30_I11_D: "Callout",
  T_49_META_TYP_30_I12_D: "Rock",
  T_49_META_TYP_30_I13_D: "Scissors",
  T_49_META_TYP_30_I14_D: "Paper",
  T_49_META_TYP_30_I15_D: "Like",
  T_49_META_TYP_30_I16_D: "Right",
  T_49_META_TYP_30_I17_D: "Wrong",
  T_49_META_TYP_30_I18_D: "Plus",
  T_49_META_TYP_30_I19_D: "Lightning",
  T_49_META_TYP_30_I2_D: "Right-Angled Trapezoid",
  T_49_META_TYP_30_I20_D: "Hearts",
  T_49_META_TYP_30_I21_D: "Star",
  T_49_META_TYP_30_I22_D: "Moon",
  T_49_META_TYP_30_I23_D: "Sun",
  T_49_META_TYP_30_I24_D: "Glasses",
  T_49_META_TYP_30_I25_D: "Key",
  T_49_META_TYP_30_I26_D: "Trophy",
  T_49_META_TYP_30_I27_D: "Flag",
  T_49_META_TYP_30_I28_D: "Hourglass",
  T_49_META_TYP_30_I29_D: "Folder",
  T_49_META_TYP_30_I3_D: "Trapezoid",
  T_49_META_TYP_30_I30_D: "Open Folder",
  T_49_META_TYP_30_I31_D: "House",
  T_49_META_TYP_30_I32_D: "Rest",
  T_49_META_TYP_30_I33_D: "Refresh",
  T_49_META_TYP_30_I34_D: "Loop",
  T_49_META_TYP_30_I35_D: "Magnifier",
  T_49_META_TYP_30_I36_D: "Trash Can",
  T_49_META_TYP_30_I37_D: "Return",
  T_49_META_TYP_30_I38_D: "Diamond",
  T_49_META_TYP_30_I39_D: "Swim Ring",
  T_49_META_TYP_30_I4_D: "Hexagon",
  T_49_META_TYP_30_I40_D: "Money",
  T_49_META_TYP_30_I41_D: "Lock",
  T_49_META_TYP_30_I42_D: "Settings",
  T_49_META_TYP_30_I43_D: "Exit",
  T_49_META_TYP_30_I44_D: "Dialogue",
  T_49_META_TYP_30_I45_D: "Crosshairs",
  T_49_META_TYP_30_I46_D: "Guns",
  T_49_META_TYP_30_I47_D: "Sword",
  T_49_META_TYP_30_I48_D: "Explosion",
  T_49_META_TYP_30_I49_D: "Aim",
  T_49_META_TYP_30_I5_D: "Circles",
  T_49_META_TYP_30_I50_D: "Cross",
  T_49_META_TYP_30_I51_D: "Defense",
  T_49_META_TYP_30_I52_D: "Zombie",
  T_49_META_TYP_30_I53_D: "Recycle",
  T_49_META_TYP_30_I54_D: "Gift",
  T_49_META_TYP_30_I55_D: "Clothes",
  T_49_META_TYP_30_I56_D: "Game",
  T_49_META_TYP_30_I57_D: "Player",
  T_49_META_TYP_30_I58_D: "Store",
  T_49_META_TYP_30_I59_D: "Exit",
  T_49_META_TYP_30_I6_D: "Triangle",
  T_49_META_TYP_30_I60_D: "Warning",
  T_49_META_TYP_30_I61_D: "Text",
  T_49_META_TYP_30_I62_D: "Timer Objects",
  T_49_META_TYP_30_I63_D: "Bell",
  T_49_META_TYP_30_I64_D: "Pet",
  T_49_META_TYP_30_I65_D: "Bomb",
  T_49_META_TYP_30_I66_D: "Repair",
  T_49_META_TYP_30_I67_D: "Smiling Face",
  T_49_META_TYP_30_I68_D: "Speaker",
  T_49_META_TYP_30_I7_D: "Exclamation Mark",
  T_49_META_TYP_30_I70_D: "Crown",
  T_49_META_TYP_30_I71_D: "Battle",
  T_49_META_TYP_30_I72_D: "Guild",
  T_49_META_TYP_30_I73_D: "Heartbeat",
  T_49_META_TYP_30_I74_D: "Music",
  T_49_META_TYP_30_I75_D: "Vehicle",
  T_49_META_TYP_30_I76_D: "Melee",
  T_49_META_TYP_30_I77_D: "Pistol",
  T_49_META_TYP_30_I78_D: "Rifle",
  T_49_META_TYP_30_I79_D: "Sniper Rifle",
  T_49_META_TYP_30_I8_D: "Question Mark",
  T_49_META_TYP_30_I80_D: "Shotgun",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Healing Gun",
  T_49_META_TYP_30_I83_D: "Shatter Armor",
  T_49_META_TYP_30_I84_D: "Headshot",
  T_49_META_TYP_30_I85_D: "Skill 1",
  T_49_META_TYP_30_I86_D: "Skill 2",
  T_49_META_TYP_30_I87_D: "Skill 3",
  T_49_META_TYP_30_I88_D: "Skill 4",
  T_49_META_TYP_30_I89_D: "Skill 5",
  T_49_META_TYP_30_I9_D: "Mark",
  T_49_META_TYP_30_I90_D: "Skill 6",
  T_49_META_TYP_30_I91_D: "Skill 7",
  T_49_META_TYP_30_I92_D: "Skill 8",
  T_49_META_TYP_30_I93_D: "Skill 9",
  T_49_META_TYP_30_I94_D: "Skill 10",
  T_49_META_TYP_300_I0_D: "Resource ID",
  T_49_META_TYP_300_I2_D: "Rotation",
  T_49_META_TYP_300_I3_D: "Created Entity",
  T_49_META_TYP_301_I1_D: "Self-Destruct",
  T_49_META_TYP_301_I2_D: "Dash Attack",
  T_49_META_TYP_301_I3_D: "Shock Wave",
  T_49_META_TYP_301_I4_D: "Tornado Attack",
  T_49_META_TYP_301_I5_D: "Jump Attack",
  T_49_META_TYP_301_I6_D: "Shield Up",
  T_49_META_TYP_301_I7_D: "Shield Broken",
  T_49_META_TYP_302_I5_D: "Backpack",
  T_49_META_TYP_302_I7_D: "Skateboard, Camo ....",
  T_49_META_TYP_303_I0_D: "Add Max. Player HP",
  T_49_META_TYP_303_I1_D: "Restore Player HP Continuously",
  T_49_META_TYP_305_I0_D: "Finish",
  T_49_META_TYP_305_I1_D: "Running",
  T_49_META_TYP_307_I0_D: "Exp Per Damage",
  T_49_META_TYP_307_I1_D: "Exp Per Move Mile",
  T_49_META_TYP_307_I2_D: "EXP per Second",
  T_49_META_TYP_307_I3_D: "Chip Exp",
  T_49_META_TYP_307_I4_D: "Charge Max",
  T_49_META_TYP_308_I0_D: "Gel Maker",
  T_49_META_TYP_31_I0_D: "Grenade Explosion",
  T_49_META_TYP_31_I1_D: "Gun Sound",
  T_49_META_TYP_31_I10_D: "Hit Damage Sound",
  T_49_META_TYP_31_I11_D: "Upgrade Sound",
  T_49_META_TYP_31_I12_D: "Weakness hit sound effect",
  T_49_META_TYP_31_I13_D: "Player stepping sound effect",
  T_49_META_TYP_31_I14_D: "Equipment Repair Sound Effect",
  T_49_META_TYP_31_I15_D: "Equipment repair sound effect",
  T_49_META_TYP_31_I16_D: "Missing or lost sound effect",
  T_49_META_TYP_31_I17_D: "Reminder Sound",
  T_49_META_TYP_31_I18_D: "Soccer Ball Landing Sound Effect",
  T_49_META_TYP_31_I19_D: "Cheers Sound Effect",
  T_49_META_TYP_31_I2_D: "Countdown Beep",
  T_49_META_TYP_31_I20_D: "Bomb Alert Sound Effect",
  T_49_META_TYP_31_I21_D: "Bomb Before Explosion Sound Effect",
  T_49_META_TYP_31_I22_D: "Hunter Appearance Sound Effect",
  T_49_META_TYP_31_I23_D: "Final BGM Sound Effect",
  T_49_META_TYP_31_I24_D: "Resupply Box Refresh Sound Effect",
  T_49_META_TYP_31_I25_D: "Accelerator sound effect",
  T_49_META_TYP_31_I26_D: "Disappearing Sound",
  T_49_META_TYP_31_I27_D: "Visual Effects",
  T_49_META_TYP_31_I28_D: "Night Bugs",
  T_49_META_TYP_31_I29_D: "Dull percussion sound effect",
  T_49_META_TYP_31_I3_D: "UI Tap",
  T_49_META_TYP_31_I30_D: "Response Sound Effect",
  T_49_META_TYP_31_I31_D: "Discovery Surprise sound effect",
  T_49_META_TYP_31_I32_D: "Ghosts playing sound effect",
  T_49_META_TYP_31_I33_D: "Phase Start Sound Effect",
  T_49_META_TYP_31_I34_D: "Zombie sound effect",
  T_49_META_TYP_31_I35_D: "Scary sound effect",
  T_49_META_TYP_31_I36_D: "Transformation sound effect",
  T_49_META_TYP_31_I37_D: "Fast Heartbeat Sound Effect",
  T_49_META_TYP_31_I38_D: "Medium Heartbeat",
  T_49_META_TYP_31_I39_D: "Slow heartbeat sound effect",
  T_49_META_TYP_31_I4_D: "Female Screaming on Hit",
  T_49_META_TYP_31_I40_D: "Stampede sound effect",
  T_49_META_TYP_31_I41_D: "Clicking Sound",
  T_49_META_TYP_31_I42_D: "Skill Recovery Sound",
  T_49_META_TYP_31_I43_D: "Join Game Sound Effects",
  T_49_META_TYP_31_I44_D: "Mechanism Echo Sound",
  T_49_META_TYP_31_I45_D: "Mosquito sound effect",
  T_49_META_TYP_31_I46_D: "Clank 1 sound effect",
  T_49_META_TYP_31_I47_D: "Clank 2 sound effect",
  T_49_META_TYP_31_I48_D: "Mechanism opening sound effect",
  T_49_META_TYP_31_I49_D: "Energy Charge 1 sound effect",
  T_49_META_TYP_31_I5_D: "Male Screaming on Hit",
  T_49_META_TYP_31_I50_D: "Footsteps sound effect",
  T_49_META_TYP_31_I51_D: "Mission Success 1 sound effect",
  T_49_META_TYP_31_I52_D: "Danger Tone 1 sound effect",
  T_49_META_TYP_31_I53_D: "Danger tone 2 sound effect",
  T_49_META_TYP_31_I54_D: "Countdown 3 sound effect",
  T_49_META_TYP_31_I55_D: "Show Tips sound effect",
  T_49_META_TYP_31_I56_D: "Crow cawing ambient sound effect",
  T_49_META_TYP_31_I57_D: "Sound effect of teleporting to the wrong area with a teleport point",
  T_49_META_TYP_31_I58_D: "Sound effect of teleporting to the right area with a teleport point",
  T_49_META_TYP_31_I59_D: "Teleport sound effect",
  T_49_META_TYP_31_I6_D: "Gold Pickup Sound",
  T_49_META_TYP_31_I60_D: "Electric shock sound effect",
  T_49_META_TYP_31_I61_D: "Consumable sound effect",
  T_49_META_TYP_31_I62_D: "Electronic Fantasy Cute Background Music Sound Effects",
  T_49_META_TYP_31_I63_D: "Casual Game Background Music Sound Effects",
  T_49_META_TYP_31_I64_D: "Open Box",
  T_49_META_TYP_31_I65_D: "Level Up",
  T_49_META_TYP_31_I66_D: "Max. Level",
  T_49_META_TYP_31_I67_D: "Tap Button",
  T_49_META_TYP_31_I68_D: "Countdown",
  T_49_META_TYP_31_I69_D: "Defeat Enemy",
  T_49_META_TYP_31_I7_D: "Race past the finish line trigger sound effect",
  T_49_META_TYP_31_I70_D: "End",
  T_49_META_TYP_31_I71_D: "Forward",
  T_49_META_TYP_31_I72_D: "Victory",
  T_49_META_TYP_31_I73_D: "Training Base Checkpoints",
  T_49_META_TYP_31_I74_D: "Countdown",
  T_49_META_TYP_31_I75_D: "Game Start",
  T_49_META_TYP_31_I76_D: "Get Big Gold",
  T_49_META_TYP_31_I77_D: "Get Medium Gold",
  T_49_META_TYP_31_I78_D: "Get Small Gold",
  T_49_META_TYP_31_I79_D: "Join the Fray",
  T_49_META_TYP_31_I8_D: "Trigger Trigger Sound",
  T_49_META_TYP_31_I80_D: "Guild Supply",
  T_49_META_TYP_31_I81_D: "Speaker",
  T_49_META_TYP_31_I82_D: "Impeach Guild Leader",
  T_49_META_TYP_31_I83_D: "Save Warehouse",
  T_49_META_TYP_31_I84_D: "Special Gun Sound",
  T_49_META_TYP_31_I85_D: "Bullet Hit",
  T_49_META_TYP_31_I86_D: "Move",
  T_49_META_TYP_31_I87_D: "Tap Disable Button",
  T_49_META_TYP_31_I88_D: "Skill Charge Complete",
  T_49_META_TYP_31_I89_D: "Laser Skill",
  T_49_META_TYP_31_I9_D: "Degradation Sound",
  T_49_META_TYP_31_I90_D: "Get Consumable 2",
  T_49_META_TYP_31_I91_D: "Countdown 3",
  T_49_META_TYP_31_I92_D: "Game Over 2",
  T_49_META_TYP_31_I93_D: "Elimination Prompt",
  T_49_META_TYP_31_I94_D: "Explosion",
  T_49_META_TYP_31_I95_D: "Energy Orb Skill",
  T_49_META_TYP_31_I96_D: "Crimson Pool Skill",
  T_49_META_TYP_311_I1_D: "Max. Damage",
  T_49_META_TYP_311_I3_D: "The speed of the projectile after it is released, in m/s.",
  T_49_META_TYP_311_I4_D: "The time interval between when the projectile is released and when it takes effect, in seconds.",
  T_49_META_TYP_313_I0_D: "Zone Radius",
  T_49_META_TYP_313_I1_D: "Duration of countermeasure area, in seconds",
  T_49_META_TYP_314_I0_D: "Animation controller resource ID.",
  T_49_META_TYP_314_I1_D: "Animation Controller",
  T_49_META_TYP_315_I0_D: "The owner of the backpack.",
  T_49_META_TYP_315_I1_D: "The space of the backpack.",
  T_49_META_TYP_315_I2_D: "Used Capacity",
  T_49_META_TYP_315_I3_D: "All Supplies",
  T_49_META_TYP_316_I0_D: "Texture Resource",
  T_49_META_TYP_316_I1_D: "Shader Name",
  T_49_META_TYP_316_I11_D: "Flip method",
  T_49_META_TYP_316_I2_D: "UV Offset",
  T_49_META_TYP_316_I3_D: "UV Size",
  T_49_META_TYP_316_I4_D: "Fill Type",
  T_49_META_TYP_316_I5_D: "Border Left Right",
  T_49_META_TYP_316_I6_D: "Border Top Bottom",
  T_49_META_TYP_317_I0_D: "None",
  T_49_META_TYP_317_I1_D: "Freeze Position X",
  T_49_META_TYP_317_I2_D: "Freeze Position Y",
  T_49_META_TYP_317_I3_D: "Freeze Position Z",
  T_49_META_TYP_317_I4_D: "Restricted rotation around X-axis",
  T_49_META_TYP_317_I5_D: "Restriction of rotation around the Y-axis",
  T_49_META_TYP_317_I6_D: "Limit rotation around the Z-axis",
  T_49_META_TYP_317_I7_D: "Freeze Position",
  T_49_META_TYP_317_I8_D: "Freeze Rotation",
  T_49_META_TYP_317_I9_D: "Freeze All",
  T_49_META_TYP_318_I0_D: "Range",
  T_49_META_TYP_318_I1_D: "Full Damage Distance",
  T_49_META_TYP_318_I10_D: "Player Aiming Speed Factor",
  T_49_META_TYP_318_I11_D: "Scope Zoom-In Factor",
  T_49_META_TYP_318_I12_D: "FOV Magnification",
  T_49_META_TYP_318_I13_D: "ADS Magnification",
  T_49_META_TYP_318_I14_D: "ADS Magnification Time (s)",
  T_49_META_TYP_318_I15_D: "ADS Recovery Time (s)",
  T_49_META_TYP_318_I16_D: "Scope Min Damage Distance correction factor.",
  T_49_META_TYP_318_I17_D: "Allow ADS Aim Assist",
  T_49_META_TYP_318_I18_D: "Aim Assist Crosshairs Screen Range Attraction Ratio (0-1)",
  T_49_META_TYP_318_I19_D: "Aim Assist Distance Attenuation Coefficient (0-1)",
  T_49_META_TYP_318_I2_D: "Min. Damage Distance",
  T_49_META_TYP_318_I20_D: "Allow Aim Assist Distance First",
  T_49_META_TYP_318_I21_D: "Aim Assist Distance Priority Min. Distance",
  T_49_META_TYP_318_I22_D: "Aim Assist Distance Priority Max. Distance",
  T_49_META_TYP_318_I23_D: "Aim Assist Distance Priority Impact Coefficient (>=1)",
  T_49_META_TYP_318_I24_D: "ADS Rotation Sensitivity",
  T_49_META_TYP_318_I25_D: "Shrink Speed",
  T_49_META_TYP_318_I3_D: "Ammo Clip Size",
  T_49_META_TYP_318_I4_D: "Attack Interval",
  T_49_META_TYP_318_I5_D: "Reload Speed",
  T_49_META_TYP_318_I6_D: "Auto Reload Speed",
  T_49_META_TYP_318_I7_D: "Scatter Speed",
  T_49_META_TYP_318_I8_D: "Scattering rate when crouching and lying down, per 0.1 means 10% range increase per bullet aiming",
  T_49_META_TYP_318_I9_D: "Max. Spread",
  T_49_META_TYP_319_I0_D: "Simple",
  T_49_META_TYP_319_I1_D: "Sliced",
  T_49_META_TYP_319_I2_D: "Tiled",
  T_49_META_TYP_319_I3_D: "Filled",
  T_49_META_TYP_319_I4_D: "Fit",
  T_49_META_TYP_32_I0_D: "Player in normal active state",
  T_49_META_TYP_32_I1_D: "Player is knocked down",
  T_49_META_TYP_32_I2_D: "Player is dead",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertical",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "The maximum distance at which the targeting assist will be triggered.",
  T_49_META_TYP_321_I1_D: "The offset of the collimator when triggering targeting, if the offset point is not in the solid, the targeting will be disabled.",
  T_49_META_TYP_322_I0_D: "No",
  T_49_META_TYP_322_I1_D: "Head",
  T_49_META_TYP_322_I2_D: "Body",
  T_49_META_TYP_322_I3_D: "Limb",
  T_49_META_TYP_323_I0_D: "Scale",
  T_49_META_TYP_323_I1_D: "Account ID",
  T_49_META_TYP_323_I2_D: "Player Profile Information",
  T_49_META_TYP_323_I3_D: "Style",
  T_49_META_TYP_323_I4_D: "Show Rank",
  T_49_META_TYP_323_I5_D: "Show Pin",
  T_49_META_TYP_323_I6_D: "Show Nickname",
  T_49_META_TYP_324_I0_D: "Generate a specified amount of force",
  T_49_META_TYP_324_I1_D: "Generate an acceleration of a specified magnitude",
  T_49_META_TYP_324_I2_D: "Generate an impulse of a specified magnitude",
  T_49_META_TYP_324_I3_D: "Generate a specified amount of velocity",
  T_49_META_TYP_326_I0_D: "Account ID",
  T_49_META_TYP_326_I1_D: "Avatar ID",
  T_49_META_TYP_326_I2_D: "Banner ID",
  T_49_META_TYP_326_I3_D: "Pin ID",
  T_49_META_TYP_326_I4_D: "Player's nickname",
  T_49_META_TYP_326_I5_D: "BR Rank",
  T_49_META_TYP_326_I6_D: "Highest BR rank",
  T_49_META_TYP_326_I7_D: "CS Rank",
  T_49_META_TYP_326_I8_D: "Highest CS rank",
  T_49_META_TYP_327_I0_D: "Resource ID",
  T_49_META_TYP_327_I1_D: "Part Mask 1",
  T_49_META_TYP_327_I2_D: "Part Mask 2",
  T_49_META_TYP_327_I3_D: "Part Mask 3",
  T_49_META_TYP_327_I4_D: "Part Mask 4",
  T_49_META_TYP_329_I0_D: "Driver",
  T_49_META_TYP_329_I1_D: "Passenger A",
  T_49_META_TYP_329_I2_D: "Passenger B",
  T_49_META_TYP_329_I3_D: "Passenger C",
  T_49_META_TYP_33_I0_D: "Ascending order ignores zero values, zero values come last",
  T_49_META_TYP_33_I1_D: "Descending order, large to small",
  T_49_META_TYP_33_I2_D: "Ascending, smallest to largest",
  T_49_META_TYP_330_I4_D: "Duration of invincibility effect (in s)",
  T_49_META_TYP_330_I5_D: "Control Points",
  T_49_META_TYP_330_I8_D: "Delta Value",
  T_49_META_TYP_332_I0_D: "Is Loop",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Resource path, default is empty",
  T_49_META_TYP_335_I1_D: "Play count, default is 1",
  T_49_META_TYP_335_I2_D: "Volume, default is 50",
  T_49_META_TYP_335_I3_D: "Max. Distance",
  T_49_META_TYP_335_I4_D: "Min. Distance",
  T_49_META_TYP_335_I5_D: "Whether the music is 3D or not",
  T_49_META_TYP_335_I6_D: "Priority",
  T_49_META_TYP_335_I7_D: "Wait time before start, in seconds",
  T_49_META_TYP_335_I8_D: "Is Playing",
  T_49_META_TYP_338_I0_D: "Movement status",
  T_49_META_TYP_338_I1_D: "Sprint",
  T_49_META_TYP_338_I2_D: "Attack",
  T_49_META_TYP_338_I3_D: "Jump",
  T_49_META_TYP_338_I4_D: "Overrun",
  T_49_META_TYP_338_I5_D: "Enter vehicle (driver)",
  T_49_META_TYP_338_I6_D: "Enter Carrier (Passenger)",
  T_49_META_TYP_338_I7_D: "Exit Vehicle",
  T_49_META_TYP_338_I8_D: "Drive",
  T_49_META_TYP_339_I0_D: "Damage Ratio Limb",
  T_49_META_TYP_339_I1_D: "Headshot DMG Coefficient",
  T_49_META_TYP_339_I2_D: "Max. Durability Multiplier",
  T_49_META_TYP_339_I3_D: "Extra HP Ratio",
  T_49_META_TYP_339_I4_D: "Additional Blast Damage Reduction Factor (%)",
  T_49_META_TYP_339_I5_D: "Extra Backpack Capacity",
  T_49_META_TYP_339_I6_D: "Replacement Priority",
  T_49_META_TYP_34_I0_D: "Default Fist",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Shotgun",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Hand Cannon",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Shield Gun",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "Shield Gun",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Kar98K-Ⅲ - Kar98K-III",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Flame Grenade Gun",
  T_49_META_TYP_34_I133_D: "Flashbang",
  T_49_META_TYP_34_I134_D: "Smoke Grenade",
  T_49_META_TYP_34_I135_D: "Freezing Grenade",
  T_49_META_TYP_34_I136_D: "Bulletproof Vest Lv1",
  T_49_META_TYP_34_I137_D: "Body armor Lv2",
  T_49_META_TYP_34_I138_D: "Body armor Lv3",
  T_49_META_TYP_34_I139_D: "Helmet Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Helmet Lv2",
  T_49_META_TYP_34_I141_D: "Helmet Lv3",
  T_49_META_TYP_34_I142_D: "Explosion-proof Armor",
  T_49_META_TYP_34_I143_D: "Backpack Lv1",
  T_49_META_TYP_34_I144_D: "Backpack Lv2",
  T_49_META_TYP_34_I145_D: "Backpack Lv3",
  T_49_META_TYP_34_I146_D: "Muzzle Lv1",
  T_49_META_TYP_34_I147_D: "Muzzle Lv2",
  T_49_META_TYP_34_I148_D: "Muzzle Lv3",
  T_49_META_TYP_34_I149_D: "Silencer",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Assault Muzzle",
  T_49_META_TYP_34_I151_D: "Wide Muzzle",
  T_49_META_TYP_34_I152_D: "Magazine Lv1",
  T_49_META_TYP_34_I153_D: "Magazine Lv2",
  T_49_META_TYP_34_I154_D: "Magazine Lv3",
  T_49_META_TYP_34_I155_D: "Double Bundle Magazine",
  T_49_META_TYP_34_I156_D: "Chain Magazine",
  T_49_META_TYP_34_I157_D: "Grip Lv1",
  T_49_META_TYP_34_I158_D: "Grip Lv2",
  T_49_META_TYP_34_I159_D: "Grip Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Folding Bracket",
  T_49_META_TYP_34_I161_D: "Shooter's Rifle Grip",
  T_49_META_TYP_34_I162_D: "Shotgun Stocks",
  T_49_META_TYP_34_I163_D: "Sniper Stocks",
  T_49_META_TYP_34_I164_D: "Thermal Imaging Scope",
  T_49_META_TYP_34_I165_D: "Stock Lv1",
  T_49_META_TYP_34_I166_D: "Stock Lv2",
  T_49_META_TYP_34_I167_D: "Stock Lv3",
  T_49_META_TYP_34_I168_D: "Shield Expander",
  T_49_META_TYP_34_I169_D: "Full Body Armor",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Excess Jacket",
  T_49_META_TYP_34_I171_D: "Explosion-proof Jacket",
  T_49_META_TYP_34_I172_D: "Backpack Expander",
  T_49_META_TYP_34_I173_D: "Healing Breather",
  T_49_META_TYP_34_I174_D: "Horizaline",
  T_49_META_TYP_34_I175_D: "MedKit",
  T_49_META_TYP_34_I176_D: "Armor Repair Kit",
  T_49_META_TYP_34_I177_D: "An AI sentry tower made of high-tech materials that actively searches and attacks enemies within a certain range",
  T_49_META_TYP_34_I178_D: "Level 1 Mushroom",
  T_49_META_TYP_34_I179_D: "Level 2 Mushroom",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Level 3 Mushroom",
  T_49_META_TYP_34_I181_D: "Level 4 Mushroom",
  T_49_META_TYP_34_I182_D: "Personal UAV",
  T_49_META_TYP_34_I184_D: "Sensor Mines",
  T_49_META_TYP_34_I185_D: "Jet Flying Shoes",
  T_49_META_TYP_34_I186_D: "Bouncing Power Shoes",
  T_49_META_TYP_34_I187_D: "Glider",
  T_49_META_TYP_34_I188_D: "Bait Grenade",
  T_49_META_TYP_34_I189_D: "Maglev Skateboard",
  T_49_META_TYP_34_I19_D: "Desert Eagle",
  T_49_META_TYP_34_I190_D: "Bomb Disposal Pliers",
  T_49_META_TYP_34_I191_D: "Gun Upgrader",
  T_49_META_TYP_34_I192_D: "Rifle Ammo",
  T_49_META_TYP_34_I193_D: "Pistol Ammo",
  T_49_META_TYP_34_I194_D: "Sniper Rifle Ammo",
  T_49_META_TYP_34_I195_D: "Shotgun Ammo",
  T_49_META_TYP_34_I196_D: "SMG Ammo",
  T_49_META_TYP_34_I197_D: "Arrows",
  T_49_META_TYP_34_I198_D: "M79 Grenade",
  T_49_META_TYP_34_I199_D: "Flamethrower Bullets",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "THROWINGKNIFE2",
  T_49_META_TYP_34_I201_D: "Hook",
  T_49_META_TYP_34_I202_D: "Football Gun",
  T_49_META_TYP_34_I203_D: "Boxing",
  T_49_META_TYP_34_I204_D: "Flamethrower",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleCard",
  T_49_META_TYP_34_I208_D: "GraffitistCard",
  T_49_META_TYP_34_I209_D: "DetectiveCard",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ProfessorCard",
  T_49_META_TYP_34_I211_D: "BountyHunterCard",
  T_49_META_TYP_34_I212_D: "SuperstarCard",
  T_49_META_TYP_34_I213_D: "XtremeCard",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "VillainCard",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Loot Soccer Shield",
  T_49_META_TYP_34_I30_D: "Superheated Energy Gun",
  T_49_META_TYP_34_I31_D: "Superheated Gun-I",
  T_49_META_TYP_34_I32_D: "Superheat Gun-II",
  T_49_META_TYP_34_I33_D: "Superheat Gun-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Heal Pistol-Y",
  T_49_META_TYP_34_I36_D: "Heal Sniper",
  T_49_META_TYP_34_I37_D: "Heal Pistol",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "Groza",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "Groza",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "Pan",
  T_49_META_TYP_34_I44_D: "Machete",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Baseball Bat",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Samurai Sword",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Power Hook Gun",
  T_49_META_TYP_34_I71_D: "FF Knife",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "1887 with 3 bullets",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Woodpecker",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Scythe",
  T_49_META_TYP_34_I87_D: "Big Head Hammer",
  T_49_META_TYP_34_I88_D: "Flying Dagger (pickable)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Easy",
  T_49_META_TYP_340_I1_D: "Simple",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Moderate",
  T_49_META_TYP_340_I4_D: "Hard",
  T_49_META_TYP_340_I5_D: "Inferno",
  T_49_META_TYP_342_I0_D: "Start Event",
  T_49_META_TYP_342_I1_D: "Stop Event",
  T_49_META_TYP_342_I2_D: "Pause Event",
  T_49_META_TYP_342_I3_D: "How long to wait after being created to start the timer, in milliseconds",
  T_49_META_TYP_342_I4_D: "Loop Count",
  T_49_META_TYP_342_I5_D: "Events",
  T_49_META_TYP_342_I6_D: "Countdown or positive timing",
  T_49_META_TYP_342_I7_D: "Player Status",
  T_49_META_TYP_342_I8_D: "Timing end time in seconds",
  T_49_META_TYP_345_I10_D: "Hand Cannon",
  T_49_META_TYP_345_I12_D: "Ice Wall Gun",
  T_49_META_TYP_345_I13_D: "Flamethrower",
  T_49_META_TYP_345_I4_D: "Shotgun",
  T_49_META_TYP_345_I6_D: "Special Gun",
  T_49_META_TYP_345_I8_D: "Accumulator",
  T_49_META_TYP_346_I0_D: "Rifle Ammo",
  T_49_META_TYP_346_I1_D: "Pistol Ammo",
  T_49_META_TYP_346_I2_D: "Sniper Rifle Ammo",
  T_49_META_TYP_346_I3_D: "Shotgun Ammo",
  T_49_META_TYP_346_I4_D: "SMG Ammo",
  T_49_META_TYP_346_I5_D: "Arrows",
  T_49_META_TYP_346_I6_D: "M79 Grenade",
  T_49_META_TYP_346_I7_D: "Hook",
  T_49_META_TYP_346_I8_D: "M79 Specialized Grenade",
  T_49_META_TYP_347_I3_D: "Can be combined with Relative Motion if true, must be combined with Absolute Motion if false, otherwise the property will not take effect correctly.",
  T_49_META_TYP_347_I6_D: "Delta Value",
  T_49_META_TYP_350_I0_D: "Sports Car",
  T_49_META_TYP_350_I1_D: "Motorbike",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Monster Truck",
  T_49_META_TYP_350_I5_D: "Mutant Truck",
  T_49_META_TYP_352_I1_D: "Unselected Sprite",
  T_49_META_TYP_352_I2_D: "Unchecked image type",
  T_49_META_TYP_352_I3_D: "Unselected Color",
  T_49_META_TYP_352_I4_D: "Selected Sprite",
  T_49_META_TYP_352_I5_D: "Selected Image Type",
  T_49_META_TYP_352_I6_D: "Selected Color",
  T_49_META_TYP_353_I0_D: "HP Recovery Amount",
  T_49_META_TYP_353_I1_D: "HP Recovery Speed (ms)",
  T_49_META_TYP_353_I2_D: "Time Required (ms)",
  T_49_META_TYP_354_I0_D: "EP Recovery Amount",
  T_49_META_TYP_355_I0_D: "HP Recovery Amount",
  T_49_META_TYP_355_I1_D: "EP Recovery Amount",
  T_49_META_TYP_355_I2_D: "Time Required (ms)",
  T_49_META_TYP_356_I0_D: "Drop Items",
  T_49_META_TYP_356_I1_D: "Drop box drop time ms",
  T_49_META_TYP_356_I2_D: "Airdrop State",
  T_49_META_TYP_357_I0_D: "Surface",
  T_49_META_TYP_357_I1_D: "Boundary",
  T_49_META_TYP_359_I0_D: "Whether to use a player controller with physics effects",
  T_49_META_TYP_359_I1_D: "Placed on a slope above this angle, it will slide downward",
  T_49_META_TYP_359_I10_D: "This gravity acceleration is only applied to this player's controller.",
  T_49_META_TYP_359_I11_D: "Mass in kg",
  T_49_META_TYP_359_I12_D: "If the slope exceeds the maximum uphill angle, the capsule will slide downward.",
  T_49_META_TYP_359_I16_D: "When enabled, movement is controlled by server-side blocks or scripts.",
  T_49_META_TYP_359_I17_D: "When enabled, the force applied when the character pushes on a rigid body can be customized.",
  T_49_META_TYP_359_I18_D: "The amount of force applied when the character pushes the rigid body",
  T_49_META_TYP_359_I19_D: "True when the lower part of the body touches the collision body, usually used to determine if the player is on the ground.",
  T_49_META_TYP_359_I2_D: "Only obstacles above this height will have a blocking effect, in the range [0,Height]",
  T_49_META_TYP_359_I20_D: "Customizable physics level, value [0,15].",
  T_49_META_TYP_359_I21_D: "Enable Rotate With Gravity",
  T_49_META_TYP_359_I3_D: "Allows embedding to change the depth of the capsule body. It can prevent the character from getting stuck or shaking, and is not recommended to be changed without special needs. Value range (0,Radius]",
  T_49_META_TYP_359_I4_D: "Minimum movement distance, any movement less than this value will not be executed. If there is no special need, it is recommended to keep it at 0.",
  T_49_META_TYP_359_I5_D: "The offset of the center of the collision box from the local coordinate origin.",
  T_49_META_TYP_359_I6_D: "Radius of the capsule, minimum value 0.01.",
  T_49_META_TYP_359_I7_D: "Total height of the capsule, including the upper and lower hemispheres, min. 2*Radius",
  T_49_META_TYP_359_I8_D: "Current linear velocity, in m/s",
  T_49_META_TYP_360_I0_D: "Left Firing Arc Angle",
  T_49_META_TYP_360_I1_D: "Right Firing Arc Angle",
  T_49_META_TYP_360_I2_D: "Min. Elevation Angle",
  T_49_META_TYP_360_I3_D: "Max. Depression Angle",
  T_49_META_TYP_360_I4_D: "Muzzle Velocity",
  T_49_META_TYP_362_I0_D: "Freeze time caused by hitting the player, in seconds",
  T_49_META_TYP_363_I0_D: "Disable Hud Request Purchase",
  T_49_META_TYP_363_I1_D: "Request help from team to buy",
  T_49_META_TYP_363_I2_D: "Purchase by requesting help from a camp",
  T_49_META_TYP_364_I0_D: "Is Center Position",
  T_49_META_TYP_364_I1_D: "Whether to loop playback",
  T_49_META_TYP_364_I2_D: "Animation name",
  T_49_META_TYP_364_I3_D: "Whether or not to autoplay",
  T_49_META_TYP_364_I4_D: "Use Custom Resource",
  T_49_META_TYP_366_I0_D: "Specifies the UUID of the Batch resource to render.",
  T_49_META_TYP_367_I1_D: "Show Tag",
  T_49_META_TYP_367_I2_D: "Icon style for marker targets",
  T_49_META_TYP_367_I3_D: "Overlay color of icons displayed on marked targets",
  T_49_META_TYP_367_I4_D: "Icon style displayed on a scale",
  T_49_META_TYP_367_I5_D: "Overlay color of the icon displayed on a scale",
  T_49_META_TYP_367_I6_D: "Always Show Mark",
  T_49_META_TYP_370_I0_D: "Main title",
  T_49_META_TYP_370_I1_D: "Subtitle",
  T_49_META_TYP_370_I2_D: "Upper background color",
  T_49_META_TYP_370_I3_D: "Bottom background color",
  T_49_META_TYP_371_I2_D: "Left Score",
  T_49_META_TYP_371_I3_D: "Right Score",
  T_49_META_TYP_371_I4_D: "The last score on the left, used to play the score switching Animation",
  T_49_META_TYP_371_I5_D: "The last score on the right, used to play the score toggle Animation",
  T_49_META_TYP_372_I0_D: "Standing",
  T_49_META_TYP_372_I1_D: "Show Crouch",
  T_49_META_TYP_372_I10_D: "High fall",
  T_49_META_TYP_372_I11_D: "Low fall, e.g. jumping",
  T_49_META_TYP_372_I12_D: "Flying shoes",
  T_49_META_TYP_372_I13_D: "Two jump jumps",
  T_49_META_TYP_372_I14_D: "Sitting on a chair",
  T_49_META_TYP_372_I15_D: "Ejected by catapult",
  T_49_META_TYP_372_I16_D: "Catapult preparation phase",
  T_49_META_TYP_372_I17_D: "Gliding on the consumable",
  T_49_META_TYP_372_I18_D: "Gliding prop drop",
  T_49_META_TYP_372_I19_D: "Bounced by tires",
  T_49_META_TYP_372_I2_D: "Running",
  T_49_META_TYP_372_I20_D: "Bounced by human tires",
  T_49_META_TYP_372_I21_D: "An Animation in the Party Zone",
  T_49_META_TYP_372_I22_D: "Ride a Flying Machine",
  T_49_META_TYP_372_I23_D: "Entering a Cannon",
  T_49_META_TYP_372_I24_D: "This is the state when coming out of a Cannon, Carrier, etc. if the ride object is flying",
  T_49_META_TYP_372_I25_D: "After jumping from a springboard",
  T_49_META_TYP_372_I26_D: "After getting off the zipline",
  T_49_META_TYP_372_I27_D: "Not used",
  T_49_META_TYP_372_I3_D: "Down and Crawl",
  T_49_META_TYP_372_I4_D: "Swimming",
  T_49_META_TYP_372_I5_D: "Falling vertically",
  T_49_META_TYP_372_I6_D: "Over the wall",
  T_49_META_TYP_372_I7_D: "Unused",
  T_49_META_TYP_372_I8_D: "Knocked down but not dead",
  T_49_META_TYP_372_I9_D: "Water Skateboarding",
  T_49_META_TYP_374_I0_D: "Life, level and stroke colors",
  T_49_META_TYP_374_I1_D: "When the life value decreases, the lost portion is briefly shown in this color.",
  T_49_META_TYP_374_I10_D: "Offset relative to the target to be followed",
  T_49_META_TYP_374_I11_D: "The amount of life between each line, if less than or equal to 0, it will not be shown.",
  T_49_META_TYP_374_I12_D: "Total HP",
  T_49_META_TYP_374_I13_D: "Current HP",
  T_49_META_TYP_374_I14_D: "When enabled, blood changes will be colored differently.",
  T_49_META_TYP_374_I15_D: "When enabled, the offset property is transferred to the world coordinate system using the local coordinate system.",
  T_49_META_TYP_374_I2_D: "When the life value increases, the increased part is briefly displayed in this color.",
  T_49_META_TYP_374_I3_D: "The color of the life value border and the bottom of the vignette.",
  T_49_META_TYP_374_I4_D: "Range 0~1, the transparency of the overall UI.",
  T_49_META_TYP_374_I5_D: "Determines the overall UI scaling, and the font will be scaled as well.",
  T_49_META_TYP_374_I6_D: "Indicates the name of the current blood bar owner",
  T_49_META_TYP_374_I8_D: "The length of the bloodstain portion on the screen",
  T_49_META_TYP_374_I9_D: "Must follow an entity with a Transform component.",
  T_49_META_TYP_375_I1_D: "Battle Entity",
  T_49_META_TYP_376_I1_D: "Battle Entity",
  T_49_META_TYP_38_I0_D: "Alpha",
  T_49_META_TYP_382_I0_D: "Default",
  T_49_META_TYP_382_I1_D: "Skip the knockdown state and just die",
  T_49_META_TYP_382_I2_D: "No Skip Knockdown",
  T_49_META_TYP_387_I1_D: "Allow Pressed Outside",
  T_49_META_TYP_389_I0_D: "Default offset of the base",
  T_49_META_TYP_389_I1_D: "Background Sprite",
  T_49_META_TYP_389_I10_D: "Inactivated Alpha",
  T_49_META_TYP_389_I2_D: "Background Radius",
  T_49_META_TYP_389_I3_D: "Joystick Cap Image",
  T_49_META_TYP_389_I4_D: "Joystick Cap Radius",
  T_49_META_TYP_389_I5_D: "Joystick Cap Drag Radius",
  T_49_META_TYP_389_I6_D: "Arrow Sprite",
  T_49_META_TYP_389_I7_D: "Arrow Size",
  T_49_META_TYP_389_I8_D: "Arrow Offset",
  T_49_META_TYP_389_I9_D: "Activated Alpha",
  T_49_META_TYP_39_I1_D: "Sprite Shape",
  T_49_META_TYP_39_I10_D: "Gradient Top",
  T_49_META_TYP_39_I11_D: "Gradient Bottom",
  T_49_META_TYP_39_I12_D: "Top Alpha",
  T_49_META_TYP_39_I13_D: "Bottom Alpha",
  T_49_META_TYP_39_I3_D: "Flip",
  T_49_META_TYP_39_I4_D: "Filled",
  T_49_META_TYP_39_I5_D: "Center Invisible",
  T_49_META_TYP_39_I6_D: "Fill Direction",
  T_49_META_TYP_39_I7_D: "Fill Value",
  T_49_META_TYP_39_I8_D: "Invert Fill",
  T_49_META_TYP_39_I9_D: "Gradient",
  T_49_META_TYP_392_I0_D: "Default is 0, unit is ms.",
  T_49_META_TYP_392_I1_D: "The time it takes to shrink the circle, in ms",
  T_49_META_TYP_392_I10_D: "The end time of the reduced circle, in ms",
  T_49_META_TYP_392_I12_D: "Radius of out-of-zone end circle.",
  T_49_META_TYP_392_I13_D: "Shrinking Start Time",
  T_49_META_TYP_392_I14_D: "Damage Interval (ms)",
  T_49_META_TYP_392_I3_D: "The amount of damage done to players in the out-of-zone in a single turn.",
  T_49_META_TYP_392_I4_D: "List of players in the safe zone",
  T_49_META_TYP_392_I5_D: "Safe zone disappearance time, no safe zone will be generated when the safe zone disappearance time is less than the effective time.",
  T_49_META_TYP_392_I6_D: "Group ID",
  T_49_META_TYP_392_I7_D: "Radius of the out-of-zone starting circle",
  T_49_META_TYP_392_I8_D: "End state",
  T_49_META_TYP_392_I9_D: "Status",
  T_49_META_TYP_394_I0_D: "Value is about 3.1416",
  T_49_META_TYP_394_I1_D: "Value about 2.7183",
  T_49_META_TYP_396_I0_D: "Title",
  T_49_META_TYP_396_I1_D: "Content",
  T_49_META_TYP_396_I2_D: "Options",
  T_49_META_TYP_396_I3_D: "ShowBackground",
  T_49_META_TYP_399_I0_D: "Jump Height",
  T_49_META_TYP_399_I1_D: "The number of consecutive jumps that can be performed before landing",
  T_49_META_TYP_399_I2_D: "How many jumps can be performed before landing",
  T_49_META_TYP_399_I3_D: "Enable Move In Midair",
  T_49_META_TYP_40_I1_D: "Label",
  T_49_META_TYP_40_I10_D: "Line Spacing",
  T_49_META_TYP_40_I11_D: "Overflow method",
  T_49_META_TYP_40_I12_D: "Font Style",
  T_49_META_TYP_40_I13_D: "Is Apply Shadow",
  T_49_META_TYP_40_I14_D: "Shadow Color",
  T_49_META_TYP_40_I15_D: "Shadow Offset",
  T_49_META_TYP_40_I3_D: "Localized Key, can be used in multiple languages",
  T_49_META_TYP_40_I5_D: "Alignment method",
  T_49_META_TYP_40_I6_D: "Alignment Vertical",
  T_49_META_TYP_40_I7_D: "Is Bold",
  T_49_META_TYP_40_I8_D: "Is Italic",
  T_49_META_TYP_40_I9_D: "Is Underline",
  T_49_META_TYP_400_I0_D: "Active",
  T_49_META_TYP_400_I1_D: "Passive",
  T_49_META_TYP_400_I2_D: "No Attack",
  T_49_META_TYP_401_I0_D: "Cannot fire.",
  T_49_META_TYP_401_I1_D: "Can fire continuously",
  T_49_META_TYP_401_I2_D: "Fires once per attack command",
  T_49_META_TYP_401_I3_D: "Three times per attack command.",
  T_49_META_TYP_401_I4_D: "Fires twice per attack command",
  T_49_META_TYP_401_I5_D: "Parry",
  T_49_META_TYP_402_I0_D: "Targets to friend",
  T_49_META_TYP_402_I1_D: "Function Type",
  T_49_META_TYP_402_I2_D: "Style",
  T_49_META_TYP_403_I0_D: "Add Friend",
  T_49_META_TYP_403_I1_D: "Report",
  T_49_META_TYP_404_I0_D: "Light",
  T_49_META_TYP_404_I1_D: "Dark",
  T_49_META_TYP_405_I0_D: "By Hierarchy",
  T_49_META_TYP_405_I1_D: "By Priority High To Low",
  T_49_META_TYP_405_I2_D: "By Priority Low To High",
  T_49_META_TYP_406_I0_D: "Control the distance of player's Animation.",
  T_49_META_TYP_406_I1_D: "Controls the height of the player's body during the move.",
  T_49_META_TYP_407_I0_D: "Local",
  T_49_META_TYP_407_I1_D: "Client",
  T_49_META_TYP_407_I2_D: "Server",
  T_49_META_TYP_407_I3_D: "Both",
  T_49_META_TYP_409_I0_D: "No errors",
  T_49_META_TYP_409_I1_D: "Data storage timeout, mainly for read operations",
  T_49_META_TYP_409_I10_D: "Failed team change - invalid target team",
  T_49_META_TYP_409_I11_D: "Failed team change - Dead player not allowed to change teams",
  T_49_META_TYP_409_I12_D: "Failed team change - not allowed to change team in vehicle",
  T_49_META_TYP_409_I2_D: "Data storage read/write frequency exceeds the limit",
  T_49_META_TYP_409_I3_D: "Parameter exceptions",
  T_49_META_TYP_409_I4_D: "Room creation failed: no valid PersonaIDs available",
  T_49_META_TYP_409_I5_D: "Undefined error status",
  T_49_META_TYP_409_I6_D: "Commercialization service shut down, users can no longer use the developer's service",
  T_49_META_TYP_409_I7_D: "Failed to change team - mode not supported",
  T_49_META_TYP_409_I8_D: "Failed to change team-Currently already in target team",
  T_49_META_TYP_409_I9_D: "Queue change failed-invalid target",
  T_49_META_TYP_41_I0_D: "Sprite Shape",
  T_49_META_TYP_41_I19_D: "Disable collision box",
  T_49_META_TYP_41_I3_D: "Disable Color",
  T_49_META_TYP_41_I4_D: "Pressed Color",
  T_49_META_TYP_41_I5_D: "Fill Type",
  T_49_META_TYP_41_I6_D: "Is FE Button",
  T_49_META_TYP_41_I7_D: "Pressed Sprite",
  T_49_META_TYP_41_I8_D: "Pressed Sprite Type",
  T_49_META_TYP_41_I9_D: "Flip Type",
  T_49_META_TYP_411_I0_D: "Forward Speed",
  T_49_META_TYP_411_I1_D: "Backward Speed",
  T_49_META_TYP_411_I2_D: "Up Speed",
  T_49_META_TYP_411_I3_D: "Down Speed",
  T_49_META_TYP_411_I4_D: "Grenade Min Damage",
  T_49_META_TYP_411_I5_D: "Grenade Max Damage",
  T_49_META_TYP_411_I6_D: "Grenade Range",
  T_49_META_TYP_412_I0_D: "Horsepower gained by the vehicle when using the gas button",
  T_49_META_TYP_412_I1_D: "Horsepower gained by the vehicle when using the reverse/brake button",
  T_49_META_TYP_412_I2_D: "Maximum steering angle at high speed",
  T_49_META_TYP_412_I3_D: "Speed threshold applied to the maximum steering angle at high speeds",
  T_49_META_TYP_412_I4_D: "After reaching the maximum speed, the carrier does not provide any more horsepower, but the carrier may exceed that maximum speed (e.g. through a downhill)",
  T_49_META_TYP_412_I5_D: "When the carrier is not being maneuvered, decelerate the carrier by multiplying IdleBrakeInput by BrakeTorque",
  T_49_META_TYP_412_I6_D: "Damage calculation for crashes, applying the parameters of the damage formula",
  T_49_META_TYP_412_I7_D: "Damage calculation for crashing, damage will not be increased even if the speed is exceeded.",
  T_49_META_TYP_412_I8_D: "Damage calculation for ramming, minimum damage",
  T_49_META_TYP_412_I9_D: "Damage calculation for ramming, maximum damage",
  T_49_META_TYP_413_I0_D: "Player (NPC) transformed costume",
  T_49_META_TYP_414_I1_D: "Wide Range",
  T_49_META_TYP_415_I0_D: "Persona ID",
  T_49_META_TYP_415_I1_D: "Nickname",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "The Persona to which it is bound.",
  T_49_META_TYP_416_I2_D: "Offset",
  T_49_META_TYP_416_I3_D: "Height",
  T_49_META_TYP_416_I4_D: "Whether to reply to system messages",
  T_49_META_TYP_416_I5_D: "Persona nickname",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Nickname of the user",
  T_49_META_TYP_416_I8_D: "User Avatar",
  T_49_META_TYP_417_I0_D: "Resource ID",
  T_49_META_TYP_418_I0_D: "Membership expiration",
  T_49_META_TYP_418_I1_D: "Become a member",
  T_49_META_TYP_418_I2_D: "Renew membership",
  T_49_META_TYP_42_I0_D: "Default Text",
  T_49_META_TYP_42_I1_D: "Active Text",
  T_49_META_TYP_42_I10_D: "Max Length",
  T_49_META_TYP_42_I14_D: "Pressed Color",
  T_49_META_TYP_42_I16_D: "Localized Key, available in multiple languages",
  T_49_META_TYP_42_I3_D: "Alignment method",
  T_49_META_TYP_42_I4_D: "Alignment Vertical",
  T_49_META_TYP_42_I5_D: "Is Bold",
  T_49_META_TYP_42_I6_D: "Is Italic",
  T_49_META_TYP_42_I7_D: "Is Underline",
  T_49_META_TYP_42_I8_D: "Line Spacing",
  T_49_META_TYP_42_I9_D: "Word Wrap",
  T_49_META_TYP_424_I0_D: "Linear Fog",
  T_49_META_TYP_424_I1_D: "Exponential Fog",
  T_49_META_TYP_424_I2_D: "Exponential Square Fog",
  T_49_META_TYP_426_I0_D: "Intensity",
  T_49_META_TYP_426_I1_D: "Range",
  T_49_META_TYP_426_I2_D: "The angle of the cone in degrees.",
  T_49_META_TYP_426_I3_D: "Light color",
  T_49_META_TYP_428_I0_D: "Weapon Skin IDs",
  T_49_META_TYP_428_I2_D: "Suit ID",
  T_49_META_TYP_428_I3_D: "Headwear ID",
  T_49_META_TYP_428_I4_D: "Face ID",
  T_49_META_TYP_428_I5_D: "Makeup ID",
  T_49_META_TYP_428_I6_D: "Upper Body ID",
  T_49_META_TYP_428_I7_D: "Bottom ID",
  T_49_META_TYP_428_I8_D: "Shoe ID",
  T_49_META_TYP_431_I1_D: "The trajectory of the target entity",
  T_49_META_TYP_431_I3_D: "Movement speed, unit m/s",
  T_49_META_TYP_431_I4_D: `Whether the movement is toward the tangent line of the path or not 
Default is False, the movement of the object will not change the direction 
 If True, the movement of the object will face the path forward direction`,
  T_49_META_TYP_431_I5_D: "Played Percentage",
  T_49_META_TYP_432_I0_D: "Rollover angle, affects the radial rotation of the path from both sides of this point",
  T_49_META_TYP_432_I1_D: "The relative position of the tangent control point to the waypoint, which determines the path tangent.",
  T_49_META_TYP_433_I0_D: "Tween straight lines between path points",
  T_49_META_TYP_433_I1_D: "Tween curves between path points for smooth motion.",
  T_49_META_TYP_433_I2_D: "Supports manual adjustment of tangents to curve points",
  T_49_META_TYP_434_I0_D: "Path type",
  T_49_META_TYP_434_I1_D: "Total length of the path",
  T_49_META_TYP_434_I2_D: "Whether the path begins and ends at the same time",
  T_49_META_TYP_434_I3_D: "Collection of waypoints",
  T_49_META_TYP_437_I3_D: "Left Players",
  T_49_META_TYP_437_I4_D: "Right Players",
  T_49_META_TYP_437_I5_D: "Array of points type names",
  T_49_META_TYP_437_I6_D: "Left points array (List 1D: player; List 2D: points data filled according to customized points type)",
  T_49_META_TYP_437_I7_D: "Array of points on the right (List 1D: players; List 2D: points data filled in according to customized points types)",
  T_49_META_TYP_438_I1_D: "Grouped players array",
  T_49_META_TYP_438_I2_D: "Grouped Ranking Array",
  T_49_META_TYP_438_I3_D: "Array of grouped scores",
  T_49_META_TYP_438_I4_D: "Array of point type names",
  T_49_META_TYP_438_I5_D: "Grouped colors array",
  T_49_META_TYP_438_I6_D: "Array of players' points (corresponding to their order when not grouped)",
  T_49_META_TYP_442_I1_D: "Left Score",
  T_49_META_TYP_442_I10_D: "Right death icon",
  T_49_META_TYP_442_I2_D: "Right Score",
  T_49_META_TYP_442_I3_D: "Number of survivors on the left",
  T_49_META_TYP_442_I4_D: "Survivors on the right",
  T_49_META_TYP_442_I5_D: "Left Dead",
  T_49_META_TYP_442_I6_D: "Right Deaths",
  T_49_META_TYP_442_I7_D: "Left survivor icon",
  T_49_META_TYP_442_I8_D: "Right Survival Icon",
  T_49_META_TYP_442_I9_D: "Left Dead Icon",
  T_49_META_TYP_444_I0_D: "English",
  T_49_META_TYP_444_I1_D: "Simplified Chinese",
  T_49_META_TYP_444_I10_D: "French",
  T_49_META_TYP_444_I11_D: "German",
  T_49_META_TYP_444_I12_D: "Turkish",
  T_49_META_TYP_444_I13_D: "Hindi",
  T_49_META_TYP_444_I14_D: "Japanese",
  T_49_META_TYP_444_I15_D: "Romanian",
  T_49_META_TYP_444_I16_D: "Romanian",
  T_49_META_TYP_444_I17_D: "Burmese",
  T_49_META_TYP_444_I18_D: "Urdu",
  T_49_META_TYP_444_I19_D: "Bengali",
  T_49_META_TYP_444_I2_D: "Traditional Chinese",
  T_49_META_TYP_444_I3_D: "Thai",
  T_49_META_TYP_444_I4_D: "Vietnamese",
  T_49_META_TYP_444_I5_D: "Indonesian",
  T_49_META_TYP_444_I6_D: "Chinese (Simplified)",
  T_49_META_TYP_444_I7_D: "Spanish",
  T_49_META_TYP_444_I8_D: "Russian",
  T_49_META_TYP_444_I9_D: "Korean",
  T_49_META_TYP_51_I0_D: "Normal Zombie",
  T_49_META_TYP_51_I1_D: "Axe Zombie",
  T_49_META_TYP_51_I10_D: "Fly Bomb Bee",
  T_49_META_TYP_51_I11_D: "Zombie Dragon",
  T_49_META_TYP_51_I2_D: "Tossing Zombie",
  T_49_META_TYP_51_I3_D: "Self-Explode Zombie",
  T_49_META_TYP_51_I4_D: "Tyrant Zombie",
  T_49_META_TYP_51_I5_D: "Throw Red Zombie",
  T_49_META_TYP_51_I6_D: "MrV",
  T_49_META_TYP_51_I7_D: "Tank Zombie",
  T_49_META_TYP_51_I8_D: "Drill Zombie",
  T_49_META_TYP_51_I9_D: "Samurai",
  T_49_META_TYP_56_I10_D: "Explosion Delay",
  T_49_META_TYP_56_I11_D: "Explosion Range",
  T_49_META_TYP_56_I12_D: "Explosion Damage",
  T_49_META_TYP_56_I13_D: "Burning Time",
  T_49_META_TYP_56_I14_D: "Burning Damage",
  T_49_META_TYP_56_I15_D: "Burning Damage Interval",
  T_49_META_TYP_56_I17_D: "Vehicle Pilot",
  T_49_META_TYP_56_I18_D: "All passengers on the vehicle",
  T_49_META_TYP_56_I19_D: "Vehicle Skin ID",
  T_49_META_TYP_56_I20_D: "Prioritize Player Configuration",
  T_49_META_TYP_56_I21_D: "Max. HP",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Whether to teleport manually or automatically (default is manual)",
  T_49_META_TYP_58_I0_D: "Type of buff generated",
  T_49_META_TYP_58_I1_D: "The time in seconds from when the buff is picked up to when the next buff is generated.",
  T_49_META_TYP_59_I0_D: "Motion Type",
  T_49_META_TYP_59_I1_D: "Motion Value X",
  T_49_META_TYP_59_I2_D: "Motion Value Y",
  T_49_META_TYP_59_I3_D: "Motion Value Z",
  T_49_META_TYP_59_I4_D: "Movement Duration",
  T_49_META_TYP_59_I5_D: "Stop Duration",
  T_49_META_TYP_59_I6_D: "Disable Reciprocating",
  T_49_META_TYP_60_I0_D: "Loot weapon points",
  T_49_META_TYP_61_I0_D: "Bound Store",
  T_49_META_TYP_61_I1_D: "Setting the trigger range",
  T_49_META_TYP_61_I2_D: "Model Visibility",
  T_49_META_TYP_62_I0_D: "Velocity XZ",
  T_49_META_TYP_62_I1_D: "Velocity Y",
  T_49_META_TYP_64_I0_D: "Music component type",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "Path Point",
  T_49_META_TYP_68_I0_D: "AI's current blood level",
  T_49_META_TYP_68_I1_D: "AI's current maximum blood level",
  T_49_META_TYP_68_I10_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_68_I11_D: "Whether the AI is currently invincible",
  T_49_META_TYP_68_I12_D: "Percentage of damage dealt to the AI when it takes damage, can be reduced or increased",
  T_49_META_TYP_68_I13_D: "Type of AI",
  T_49_META_TYP_68_I14_D: "Whether to automatically search for enemies",
  T_49_META_TYP_68_I15_D: "0 is auto attack, 1 is defense attack, 2 is no attack at all.",
  T_49_META_TYP_68_I16_D: "Path ID",
  T_49_META_TYP_68_I17_D: "Chase Target",
  T_49_META_TYP_68_I18_D: "Attack Target",
  T_49_META_TYP_68_I19_D: "AI's birth point coordinates",
  T_49_META_TYP_68_I2_D: "Get the entity of the AI's team.",
  T_49_META_TYP_68_I20_D: "The team's camp number",
  T_49_META_TYP_68_I4_D: "Can only modify the attack power of normal attacks, skill attacks don't count.",
  T_49_META_TYP_68_I7_D: "AI's free movement range, can only modify the base value, if there is extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I8_D: "AI's range to detect enemies, can only modify the base value, if there is an extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I9_D: "True movement speed, if there is a skill acceleration it will be multiplied by it.",
  T_49_META_TYP_70_I0_D: "ID of the target entity that the formula works on, used by internal implementations, invisible to the player.",
  T_49_META_TYP_70_I1_D: "ID of the target entity property on which the formula works, used by internal implementations, not visible to the player",
  T_49_META_TYP_70_I2_D: "Minimum value allowed",
  T_49_META_TYP_70_I3_D: "Maximum value allowed",
  T_49_META_TYP_70_I4_D: "Base Coefficient",
  T_49_META_TYP_70_I5_D: "Pre-Accumulator",
  T_49_META_TYP_70_I6_D: "Multiplier",
  T_49_META_TYP_70_I7_D: "Multiply Accumulate",
  T_49_META_TYP_70_I8_D: "Post-Accumulator",
  T_49_META_TYP_71_I0_D: "Shop item number",
  T_49_META_TYP_71_I1_D: "Price",
  T_49_META_TYP_71_I10_D: "Is Purchasable",
  T_49_META_TYP_71_I2_D: "Money Type",
  T_49_META_TYP_71_I3_D: "Overall limit",
  T_49_META_TYP_71_I4_D: "Current overall limit",
  T_49_META_TYP_71_I5_D: "Shop item name",
  T_49_META_TYP_71_I6_D: "Shop Item Description",
  T_49_META_TYP_71_I7_D: "Shop Item List",
  T_49_META_TYP_71_I8_D: "ItemCounts",
  T_49_META_TYP_71_I9_D: "Resource path, empty by default",
  T_49_META_TYP_72_I1_D: "Shop Items",
  T_49_META_TYP_73_I1_D: "Shelfs",
  T_49_META_TYP_74_I0_D: "Weapon",
  T_49_META_TYP_74_I1_D: "Helmet",
  T_49_META_TYP_74_I2_D: "Vest",
  T_49_META_TYP_74_I3_D: "Grenade",
  T_49_META_TYP_75_I0_D: "One Way",
  T_49_META_TYP_75_I1_D: "Back And Forth",
  T_49_META_TYP_76_I0_D: "Patrols only, no attacks on targets along the way",
  T_49_META_TYP_76_I1_D: "Patrol While Attack",
  T_49_META_TYP_79_I0_D: "Weapon Attack Power",
  T_49_META_TYP_79_I1_D: "Attack Range",
  T_49_META_TYP_79_I10_D: "Bullet Spread Start Count",
  T_49_META_TYP_79_I11_D: "Weapon ID",
  T_49_META_TYP_79_I12_D: "Minimum wait time in seconds between shots, multiple bullets may be fired per shot depending on shot type",
  T_49_META_TYP_79_I13_D: "The player who owns the weapon",
  T_49_META_TYP_79_I14_D: "Is Consume Ammo",
  T_49_META_TYP_79_I15_D: "Dual wielding type (0 not dual wielding 1 and self 2 and any weapon)",
  T_49_META_TYP_79_I16_D: "Armor damage factor",
  T_49_META_TYP_79_I17_D: "Player movement speed effects",
  T_49_META_TYP_79_I18_D: "Damage percentage for hitting the torso",
  T_49_META_TYP_79_I19_D: "Percentage of damage that hits the head",
  T_49_META_TYP_79_I2_D: "The length of time to wait between bullets, in seconds.",
  T_49_META_TYP_79_I20_D: "Damage percentage for hitting limbs",
  T_49_META_TYP_79_I21_D: "Extra Damage Ratio (Vehicle, Oil Drum, Ice Wall)",
  T_49_META_TYP_79_I22_D: "Visible On Back",
  T_49_META_TYP_79_I23_D: "Extra damage for hitting the ground",
  T_49_META_TYP_79_I24_D: "Ammo per Shot",
  T_49_META_TYP_79_I25_D: "Bullet change speed (base speed * factor)",
  T_49_META_TYP_79_I26_D: "Current Ammo Count",
  T_49_META_TYP_79_I27_D: "Gunskin ID",
  T_49_META_TYP_79_I28_D: "When player configuration is prioritized, the gun skin configuration on the player overrides the gun skin property of the weapon itself",
  T_49_META_TYP_79_I29_D: "When writing in the gun skin's properties for a weapon, the weapon's base value is affected by the gun skin",
  T_49_META_TYP_79_I3_D: "Ammo Mag Size",
  T_49_META_TYP_79_I30_D: "Diffusion Increase Speed (0.1 = 10% expansion for each additional burst of collision)",
  T_49_META_TYP_79_I31_D: "Diffusion recovery speed",
  T_49_META_TYP_79_I32_D: "Player speed effect when firing",
  T_49_META_TYP_79_I33_D: "Diffusion size in case of movement (1.5 = 1.5 * basic collimator size)",
  T_49_META_TYP_79_I34_D: "Weapon Type",
  T_49_META_TYP_79_I36_D: "Fire Type",
  T_49_META_TYP_79_I37_D: "Is Single Shot",
  T_49_META_TYP_79_I38_D: "Is Silenced",
  T_49_META_TYP_79_I39_D: "ADS Sensitivity Multiplier",
  T_49_META_TYP_79_I4_D: "Initial Mag Count",
  T_49_META_TYP_79_I5_D: "Armor Penetration",
  T_49_META_TYP_79_I6_D: "Full Damage Distance",
  T_49_META_TYP_79_I7_D: "Min. Damage Distance",
  T_49_META_TYP_79_I8_D: "Min. Damage",
  T_49_META_TYP_79_I9_D: "The number of bullets that can be fired before the scattering begins",
  T_49_META_TYP_80_I1_D: "When true, manual disable is disabled.",
  T_49_META_TYP_80_I2_D: "Bound shop entities",
  T_49_META_TYP_80_I4_D: "Bound Money List",
  T_49_META_TYP_80_I5_D: "Bound Wallet ID",
  T_49_META_TYP_80_I6_D: "The type of the current UI player request target",
  T_49_META_TYP_80_I7_D: "Requested Item List",
  T_49_META_TYP_81_I0_D: "Random Buff",
  T_49_META_TYP_81_I1_D: "HP Buff",
  T_49_META_TYP_81_I2_D: "Bullet Buff",
  T_49_META_TYP_81_I3_D: "Armor Buff",
  T_49_META_TYP_82_I1_D: "Button icon",
  T_49_META_TYP_82_I3_D: "Position relative to the anchor point",
  T_49_META_TYP_83_I1_D: "TriggerPlayerID",
  T_49_META_TYP_83_I2_D: "Passed parameters",
  T_49_META_TYP_86_I0_D: "Min",
  T_49_META_TYP_86_I1_D: "Max",
  T_49_META_TYP_86_I2_D: "Base coefficient, multiplied by the original value before all calculations are performed.",
  T_49_META_TYP_86_I3_D: "Pre-accumulator, accumulates before multiplication, participates in multiplication calculations",
  T_49_META_TYP_86_I4_D: "Consecutive multipliers, for example (reduced to 90%, strengthened to 110%) have the effect of Value*90%*110%.",
  T_49_META_TYP_86_I5_D: "The effect of a multiplication accumulator, e.g. (add 10%, add 5%) is Value*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Post accumulator, not involved in multiplication calculations, stacked at the end",
  T_49_META_TYP_88_I0_D: "Base type, the most basic in-game currency, the type of pricing for general shop items in the current version",
  T_49_META_TYP_89_I0_D: "Only base currency is available in the current version",
  T_49_META_TYP_89_I1_D: "Amount of currency",
  T_49_META_TYP_89_I2_D: "Currency icon",
  T_49_META_TYP_89_I3_D: "Currency icon color",
  T_49_META_TYP_90_I0_D: "The contents of the wallet are a bunch of currencies",
  T_49_META_TYP_92_I0_D: "Square Wooden Crate",
  T_49_META_TYP_92_I1_D: "Long Wooden Crate",
  T_49_META_TYP_92_I10_D: "Turret",
  T_49_META_TYP_92_I100_D: "Stairs",
  T_49_META_TYP_92_I101_D: "Stair Landing B",
  T_49_META_TYP_92_I102_D: "Stair Landing A",
  T_49_META_TYP_92_I103_D: "Phone Booth",
  T_49_META_TYP_92_I104_D: "BIS Themed Wall",
  T_49_META_TYP_92_I105_D: "BIS Themed Flower Bed",
  T_49_META_TYP_92_I106_D: "Vending Machine",
  T_49_META_TYP_92_I107_D: "Monster Entities",
  T_49_META_TYP_92_I108_D: "Unit Generator",
  T_49_META_TYP_92_I109_D: "Sports Car",
  T_49_META_TYP_92_I11_D: "Guardhouse",
  T_49_META_TYP_92_I110_D: "Tuk Tuk",
  T_49_META_TYP_92_I111_D: "Destructible Wooden Crate",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Motorbike",
  T_49_META_TYP_92_I114_D: "Monster Truck",
  T_49_META_TYP_92_I115_D: "Coin Generator",
  T_49_META_TYP_92_I116_D: "Stair Landing C",
  T_49_META_TYP_92_I117_D: "Sign",
  T_49_META_TYP_92_I118_D: "Fence",
  T_49_META_TYP_92_I119_D: "Jersey Machine",
  T_49_META_TYP_92_I12_D: "Two-Story House",
  T_49_META_TYP_92_I121_D: "Concrete Pillar",
  T_49_META_TYP_92_I122_D: "Loot Soccer Item Box",
  T_49_META_TYP_92_I123_D: "Oil Drum",
  T_49_META_TYP_92_I124_D: "Low-Gravity Area",
  T_49_META_TYP_92_I125_D: "Weapon",
  T_49_META_TYP_92_I126_D: "Fence B",
  T_49_META_TYP_92_I127_D: "Small House A",
  T_49_META_TYP_92_I128_D: "Damaged Truck",
  T_49_META_TYP_92_I129_D: "Basic Sphere",
  T_49_META_TYP_92_I13_D: "Sand Sculpture",
  T_49_META_TYP_92_I130_D: "Basic Cone",
  T_49_META_TYP_92_I131_D: "Basic Cylinder",
  T_49_META_TYP_92_I132_D: "Consumable Generator",
  T_49_META_TYP_92_I133_D: "Custom Water Body",
  T_49_META_TYP_92_I134_D: "Arrow",
  T_49_META_TYP_92_I135_D: "Dyed Block",
  T_49_META_TYP_92_I136_D: "Dyed Oil Drum",
  T_49_META_TYP_92_I137_D: "Text",
  T_49_META_TYP_92_I138_D: "Icon",
  T_49_META_TYP_92_I139_D: "Ice Doll",
  T_49_META_TYP_92_I14_D: "Fountain",
  T_49_META_TYP_92_I140_D: "Capsule Trigger",
  T_49_META_TYP_92_I141_D: "Sphere Collision Trigger",
  T_49_META_TYP_92_I142_D: "Reflective Solid Color Basic Block 1",
  T_49_META_TYP_92_I143_D: "Bumper Car Manufacturer",
  T_49_META_TYP_92_I144_D: "Checkered Amusement Park Block",
  T_49_META_TYP_92_I145_D: "Large Screen",
  T_49_META_TYP_92_I146_D: "Podium",
  T_49_META_TYP_92_I147_D: "Giant Lollipop",
  T_49_META_TYP_92_I148_D: "Food Truck B",
  T_49_META_TYP_92_I15_D: "Cherry Blossom",
  T_49_META_TYP_92_I16_D: "One-Story House",
  T_49_META_TYP_92_I17_D: "Three-Story House",
  T_49_META_TYP_92_I18_D: "Banana Tree",
  T_49_META_TYP_92_I19_D: "Toilet",
  T_49_META_TYP_92_I2_D: "Bush-Covered Long Wooden Crate",
  T_49_META_TYP_92_I20_D: "Fence",
  T_49_META_TYP_92_I21_D: "Destructible Container",
  T_49_META_TYP_92_I22_D: "Destructible Fence",
  T_49_META_TYP_92_I23_D: "Tire",
  T_49_META_TYP_92_I24_D: "Bumper Car",
  T_49_META_TYP_92_I25_D: "Amphibious Vehicle",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Trash Can",
  T_49_META_TYP_92_I28_D: "Medical Tent",
  T_49_META_TYP_92_I29_D: "Garage",
  T_49_META_TYP_92_I3_D: "Haystack",
  T_49_META_TYP_92_I30_D: "Painted Wall",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Iron Platform",
  T_49_META_TYP_92_I33_D: "Container House",
  T_49_META_TYP_92_I34_D: "Trailer",
  T_49_META_TYP_92_I35_D: "Wall A",
  T_49_META_TYP_92_I36_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I37_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I38_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I39_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I4_D: "Wrecked Car",
  T_49_META_TYP_92_I40_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I41_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I42_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I43_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I44_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I45_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I46_D: "Buff Generator",
  T_49_META_TYP_92_I47_D: "Propeller Mechanisms",
  T_49_META_TYP_92_I48_D: "Pan Loot",
  T_49_META_TYP_92_I49_D: "Cube Loot",
  T_49_META_TYP_92_I5_D: "Wrecked Bus",
  T_49_META_TYP_92_I50_D: "Circle Loot",
  T_49_META_TYP_92_I51_D: "Mallet Machine",
  T_49_META_TYP_92_I52_D: "Moving Board",
  T_49_META_TYP_92_I53_D: "Moving Target",
  T_49_META_TYP_92_I54_D: "Retractable Wall",
  T_49_META_TYP_92_I55_D: "Loot Point Weapon Component",
  T_49_META_TYP_92_I56_D: "Loot Point Bullet Component",
  T_49_META_TYP_92_I57_D: "Loot Point Expendable Item Component",
  T_49_META_TYP_92_I58_D: "Loot Point Thrown Item Component",
  T_49_META_TYP_92_I59_D: "Loot Point Multiplier Component",
  T_49_META_TYP_92_I6_D: "Container A",
  T_49_META_TYP_92_I60_D: "Loot Point Armor Component",
  T_49_META_TYP_92_I61_D: "I Pipe",
  T_49_META_TYP_92_I62_D: "T Pipe",
  T_49_META_TYP_92_I63_D: "Cross Pipe",
  T_49_META_TYP_92_I64_D: "Elbow Pipe",
  T_49_META_TYP_92_I65_D: "Giant Mushroom Cluster",
  T_49_META_TYP_92_I66_D: "Drying Rack",
  T_49_META_TYP_92_I67_D: "Plank Bridge",
  T_49_META_TYP_92_I68_D: "Lattice Screen",
  T_49_META_TYP_92_I69_D: "Concrete Column",
  T_49_META_TYP_92_I7_D: "Shipping Container B",
  T_49_META_TYP_92_I70_D: "Cactus",
  T_49_META_TYP_92_I71_D: "Dead Wood",
  T_49_META_TYP_92_I72_D: "Stone Lantern",
  T_49_META_TYP_92_I73_D: "Streetlight",
  T_49_META_TYP_92_I74_D: "Solar Panel",
  T_49_META_TYP_92_I75_D: "Air Conditioner",
  T_49_META_TYP_92_I76_D: "Square",
  T_49_META_TYP_92_I77_D: "Slope",
  T_49_META_TYP_92_I78_D: "Food Truck",
  T_49_META_TYP_92_I79_D: "Death or Invincibility Trigger",
  T_49_META_TYP_92_I8_D: "Shipping Container C",
  T_49_META_TYP_92_I80_D: "Checkpoint",
  T_49_META_TYP_92_I81_D: "End Position",
  T_49_META_TYP_92_I82_D: "Dice",
  T_49_META_TYP_92_I83_D: "Bench",
  T_49_META_TYP_92_I84_D: "Bus Stop",
  T_49_META_TYP_92_I85_D: "Dog House",
  T_49_META_TYP_92_I86_D: "Ad Board",
  T_49_META_TYP_92_I87_D: "Refinery Tank",
  T_49_META_TYP_92_I88_D: "Graffiti Wall",
  T_49_META_TYP_92_I89_D: "Stable",
  T_49_META_TYP_92_I9_D: "Cabin",
  T_49_META_TYP_92_I90_D: "Stone Arch Bridge",
  T_49_META_TYP_92_I91_D: "Patio Set With Umbrella",
  T_49_META_TYP_92_I92_D: "Finish Banner",
  T_49_META_TYP_92_I93_D: "Fortress",
  T_49_META_TYP_92_I94_D: "Monster Spawn Point",
  T_49_META_TYP_92_I95_D: "Mark",
  T_49_META_TYP_92_I97_D: "Custom Trigger",
  T_49_META_TYP_92_I98_D: "Double Door",
  T_49_META_TYP_92_I99_D: "Barricade",
  T_49_META_TYP_94_I0_D: "Add",
  T_49_META_TYP_94_I1_D: "Multiply",
  T_49_META_TYP_95_I0_D: "Money Type",
  T_49_META_TYP_95_I1_D: "Amount of currency",
  T_49_META_TYP_96_I0_D: "Get Wallet",
  T_49_META_TYP_96_I1_D: "Display position (anchor is top right corner)",
  T_49_META_TYP_97_I0_D: "Position in the world coordinate system",
  T_49_META_TYP_97_I1_D: "Rotation angle in the world coordinate system, XYZ components are pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I10_D: "Local coordinate axis x-axis orientation",
  T_49_META_TYP_97_I11_D: "Local axis z-axis orientation",
  T_49_META_TYP_97_I2_D: "Zoom size in the world coordinate system",
  T_49_META_TYP_97_I3_D: "Parent node of this node",
  T_49_META_TYP_97_I4_D: "Rotation in the world coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I5_D: "Position in local coordinate system",
  T_49_META_TYP_97_I6_D: "Rotation in the local coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I7_D: "Rotation angle in the local coordinate system, with XYZ components for pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I8_D: "Scaling dimension in the local coordinate system",
  T_49_META_TYP_97_I9_D: "Local coordinate axis y-axis orientation",
  T_49_META_TYP_99_I0_D: "Radius of the soccer ball",
  T_49_META_TYP_99_I1_D: "Friction coefficient at normal condition",
  T_49_META_TYP_99_I2_D: "Impact Friction",
  T_49_META_TYP_99_I3_D: "Min. Shooting Angle",
  T_49_META_TYP_99_I4_D: "Min. Elevation Angle",
  T_49_META_TYP_99_I5_D: "Reset Time",
  T_49_META_TYP_99_I6_D: "Max. Shooting Angle",
  T_49_META_TYP_99_I7_D: "Reset Position",
  T_49_META_TYPE_0_D: "Object, the root of the type hierarchy",
  T_49_META_TYPE_1_D: "A container for a set of data in a list",
  T_49_META_TYPE_10_D: "Entity base component, all components will combine this component",
  T_49_META_TYPE_100_D: "JerseyMachine",
  T_49_META_TYPE_101_D: "Morph Object",
  T_49_META_TYPE_1010_D: "Timer Info",
  T_49_META_TYPE_1011_D: "Opening Banner",
  T_49_META_TYPE_1012_D: "Banner entities start in two-team rounds, and modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1013_D: "General round start banner entity, modifying entity properties affects display content on corresponding UIs",
  T_49_META_TYPE_1014_D: "Team round score banner entity, modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1015_D: "Checkpoint Manager entity, modifying the entity properties will affect the display on the corresponding UI.",
  T_49_META_TYPE_1016_D: "End of round display entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1017_D: "If there are two teams at the start of the round, display the two teams' rivalry banner",
  T_49_META_TYPE_1018_D: "Score of the round between the two teams",
  T_49_META_TYPE_1019_D: "The final result is a tie",
  T_49_META_TYPE_102_D: "Resurrection source type: death, fall down",
  T_49_META_TYPE_1020_D: "Round count entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1021_D: "Phase countdown entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1022_D: "Match information subheading entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1023_D: "Two teams match information entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1024_D: "Team match information UI entity, modify the entity property to affect the display content on the corresponding UI",
  T_49_META_TYPE_1027_D: "Describes the type of the type and returns that type when Typeof is used",
  T_49_META_TYPE_1028_D: "Camp information entity, modify the entity properties to affect the display content of the corresponding UI.",
  T_49_META_TYPE_1029_D: "The icon hint information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_103_D: "Enumeration of item slots",
  T_49_META_TYPE_1030_D: "Short version of the two teams' match information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1031_D: "Timing prompt UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1032_D: "Floating word prompt entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1033_D: "Round switching entity, including current round settlement and next round start information, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1035_D: "Open scoreboard button UI entity, modifying entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1036_D: "Infected mode, display the UI of current zombie level.",
  T_49_META_TYPE_1037_D: "Add points animation UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1038_D: "Infected mode zombie UI effects",
  T_49_META_TYPE_1039_D: "Countdown prompt entity, modifying the entity properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_104_D: "Jersey Style",
  T_49_META_TYPE_1040_D: "UI Card Selection Panel",
  T_49_META_TYPE_1041_D: "UI Identity Notification",
  T_49_META_TYPE_1042_D: "UI Countdown 5s",
  T_49_META_TYPE_1043_D: "UI Title Banner",
  T_49_META_TYPE_1044_D: "UI Built-In Switch",
  T_49_META_TYPE_1045_D: "UI Skill Button",
  T_49_META_TYPE_105_D: "Football Goal",
  T_49_META_TYPE_106_D: "Aiming aid type",
  T_49_META_TYPE_107_D: "Entities that can be targeted and hit, but not necessarily harmed",
  T_49_META_TYPE_108_D: "Integer types, 64-bit signed integers",
  T_49_META_TYPE_109_D: "The chat channel entity is a container that contains its channel ID and players.",
  T_49_META_TYPE_11_D: "Global entity, unique for the entire game",
  T_49_META_TYPE_110_D: "Idle chat channel",
  T_49_META_TYPE_111_D: "Behavior types",
  T_49_META_TYPE_112_D: "Player Behavior Status Type",
  T_49_META_TYPE_113_D: "Drum Music",
  T_49_META_TYPE_114_D: "Lead1 Music",
  T_49_META_TYPE_115_D: "Lead2 Music",
  T_49_META_TYPE_116_D: "Lead3 Music",
  T_49_META_TYPE_117_D: "Drumbeat music component type",
  T_49_META_TYPE_118_D: "Faction",
  T_49_META_TYPE_119_D: "Attackable options",
  T_49_META_TYPE_12_D: "Combat entities, can attack, take hits, kill, etc.",
  T_49_META_TYPE_120_D: "UI Progress Bar",
  T_49_META_TYPE_121_D: "Interval between waves",
  T_49_META_TYPE_122_D: "Skybox",
  T_49_META_TYPE_123_D: "Enumeration of skybox base types",
  T_49_META_TYPE_124_D: "Claim Range",
  T_49_META_TYPE_125_D: "Can modify the base appearance of objects, such as mapping and transparency",
  T_49_META_TYPE_126_D: "Health Bar",
  T_49_META_TYPE_127_D: "How to move objects",
  T_49_META_TYPE_128_D: "Morphable Object",
  T_49_META_TYPE_129_D: "Loot Ammo Type",
  T_49_META_TYPE_13_D: "UI Widget Entity",
  T_49_META_TYPE_130_D: "Loot Consumable Type",
  T_49_META_TYPE_131_D: "Loot Armor Type",
  T_49_META_TYPE_132_D: "Loot Throwable Type",
  T_49_META_TYPE_133_D: "Loot Scope Type",
  T_49_META_TYPE_134_D: "Loot Weapon Type",
  T_49_META_TYPE_135_D: "Generates ammo drops of the selected type",
  T_49_META_TYPE_136_D: "Generates a consumable drop of the selected type.",
  T_49_META_TYPE_137_D: "Generates a selected type of projectile drop",
  T_49_META_TYPE_138_D: "Spawns a scope drop of the selected type",
  T_49_META_TYPE_139_D: "Generates the selected type of armor drop.",
  T_49_META_TYPE_14_D: "In-game player entities, one per user",
  T_49_META_TYPE_140_D: "Wave",
  T_49_META_TYPE_141_D: "Loot Soccer Type",
  T_49_META_TYPE_142_D: "Loot Soccer Item Box",
  T_49_META_TYPE_143_D: "Lead1 music component type",
  T_49_META_TYPE_144_D: "Lead2 Music Component Type",
  T_49_META_TYPE_145_D: "Lead3 Music Component Type",
  T_49_META_TYPE_146_D: "Key Music Component Type",
  T_49_META_TYPE_147_D: "Multiple preset camera types available, as well as custom camera types",
  T_49_META_TYPE_148_D: "Camera components",
  T_49_META_TYPE_149_D: "Localization Key",
  T_49_META_TYPE_15_D: "In-game team entities, one per team",
  T_49_META_TYPE_150_D: "Oil Drum",
  T_49_META_TYPE_151_D: "Quaternion is a special four-dimensional vector used only to represent rotations",
  T_49_META_TYPE_152_D: "Low-Gravity Area",
  T_49_META_TYPE_153_D: "Entity containers that generate entities of the corresponding type at the location.",
  T_49_META_TYPE_154_D: "Dual-Wield Weapon Type",
  T_49_META_TYPE_155_D: "Helmet entity",
  T_49_META_TYPE_156_D: "Body armor",
  T_49_META_TYPE_157_D: "Camera Transition Type",
  T_49_META_TYPE_158_D: "Text prompt UI",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Level object entities",
  T_49_META_TYPE_160_D: "Texture Types",
  T_49_META_TYPE_161_D: "Un Replaceable Texture VFX",
  T_49_META_TYPE_162_D: "Type List",
  T_49_META_TYPE_163_D: "Type or Type List",
  T_49_META_TYPE_164_D: "Component is the base class of all entity components or specific component classes.",
  T_49_META_TYPE_165_D: "Collision box component",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "Special effect entity represents a displayed special effect (deleted, reusable).",
  T_49_META_TYPE_17_D: "Level Object List",
  T_49_META_TYPE_170_D: "Indicates whether visibility can be set",
  T_49_META_TYPE_171_D: "Mushroom",
  T_49_META_TYPE_172_D: "Ammo",
  T_49_META_TYPE_173_D: "Backpack",
  T_49_META_TYPE_174_D: "Grenade component",
  T_49_META_TYPE_175_D: "Freezing Grenade",
  T_49_META_TYPE_176_D: "Weapon Generator",
  T_49_META_TYPE_177_D: "Motion mode of the camera when there is an obstruction between the camera and the object it is following",
  T_49_META_TYPE_178_D: "Camera's imaging style when rendering a screen",
  T_49_META_TYPE_179_D: "Basic Sphere",
  T_49_META_TYPE_18_D: "(Deprecated, please do not use)",
  T_49_META_TYPE_180_D: "refers to a property of a component",
  T_49_META_TYPE_181_D: "Types used to describe mesh assets",
  T_49_META_TYPE_182_D: "A type used to describe a material asset",
  T_49_META_TYPE_183_D: "A type to describe a texture asset",
  T_49_META_TYPE_184_D: "Bridge rendering component for rendering with built-in model resources",
  T_49_META_TYPE_185_D: "Custom rendering component for rendering with custom model resources",
  T_49_META_TYPE_186_D: "A blank object component that can be used in conjunction with a renderer component, collider component, etc.",
  T_49_META_TYPE_187_D: "Container",
  T_49_META_TYPE_188_D: "Basic Cylinder",
  T_49_META_TYPE_189_D: "List of localized strings",
  T_49_META_TYPE_19_D: "A list template, where the type of content can be specified via T.",
  T_49_META_TYPE_190_D: "Two Team Score Panel",
  T_49_META_TYPE_191_D: "Tactical thrown weapon that blinds enemies within a certain range for a short period of time.",
  T_49_META_TYPE_192_D: "When used, it creates smoke that obscures events, which is a useful tool for interrupting enemy attacks.",
  T_49_META_TYPE_193_D: "Multi-Team Result Panel",
  T_49_META_TYPE_194_D: "Sensor mines that can be placed on the ground and will explode when an enemy approaches, be careful not to step on them yourself",
  T_49_META_TYPE_195_D: "Tween Campaign Playing Style",
  T_49_META_TYPE_197_D: "Playable Components",
  T_49_META_TYPE_198_D: "Item Base",
  T_49_META_TYPE_199_D: "Auxiliary equipment for aerial combat, but you need to keep an eye on the energy consumption at all times",
  T_49_META_TYPE_2_D: "Boolean types, to indicate true, false, or yes/no",
  T_49_META_TYPE_20_D: "A built-in enumeration of UI types, which is automatically generated by the type system.",
  T_49_META_TYPE_200_D: "Jailbreak area",
  T_49_META_TYPE_201_D: "Areas where you can swim after entering",
  T_49_META_TYPE_202_D: "ColliderID",
  T_49_META_TYPE_203_D: "Tween Movement",
  T_49_META_TYPE_204_D: "Shoes fitted with technological power-ups that allow you to jump in the air in two stages",
  T_49_META_TYPE_205_D: "A glider that can fly in the sky, use it to land from a high place to move farther away",
  T_49_META_TYPE_206_D: "Skateboard",
  T_49_META_TYPE_207_D: "Zipline",
  T_49_META_TYPE_208_D: "List of Playables",
  T_49_META_TYPE_209_D: "Playable or List of Playables",
  T_49_META_TYPE_21_D: "Built-in UI entities, which encapsulate specific functionality.",
  T_49_META_TYPE_210_D: "Trajectory Animation is an animation that simulates Trajectory movement.",
  T_49_META_TYPE_211_D: "Coordinate System",
  T_49_META_TYPE_212_D: "One object follows another object",
  T_49_META_TYPE_213_D: "An object's front face is always facing the other object.",
  T_49_META_TYPE_214_D: "An ID that describes a gallery sprite asset",
  T_49_META_TYPE_215_D: "results of a competition",
  T_49_META_TYPE_216_D: "Dictionary data container, the data elements are a pair of Key, Value.",
  T_49_META_TYPE_217_D: "Dictionary data template, can be specified by T1, T2 type of content",
  T_49_META_TYPE_218_D: "A type of light source that emits light of equal intensity in all directions from the position of the light source.",
  T_49_META_TYPE_219_D: "Motorcycle Carrier",
  T_49_META_TYPE_22_D: "Custom UIs, created by the player through the UI editor.",
  T_49_META_TYPE_220_D: "Assault vehicle (tricycle) carrier",
  T_49_META_TYPE_221_D: "Amphibious/Machine Gun Motorcycle Vehicle",
  T_49_META_TYPE_222_D: "Four-wheeled vehicle",
  T_49_META_TYPE_224_D: "Skill Type List",
  T_49_META_TYPE_225_D: "Artificial Intelligence Turret made of high-tech materials that actively searches for and attacks enemies within a certain range.",
  T_49_META_TYPE_226_D: "Turret generated by using turret consumable.",
  T_49_META_TYPE_227_D: "Custom UI widgets type enumeration",
  T_49_META_TYPE_23_D: "An enumeration of the level's object types, which is automatically generated by the system based on the type.",
  T_49_META_TYPE_231_D: "Repair Kit",
  T_49_META_TYPE_233_D: "Progress Circle",
  T_49_META_TYPE_234_D: "Landmine Created",
  T_49_META_TYPE_235_D: "Gloo Wall",
  T_49_META_TYPE_236_D: "Ice Wall Created",
  T_49_META_TYPE_237_D: "Hook Gun",
  T_49_META_TYPE_238_D: "Rainbow Paint Gun",
  T_49_META_TYPE_239_D: "Spray Rifle",
  T_49_META_TYPE_24_D: "Current system-defined damage types",
  T_49_META_TYPE_240_D: "Entities are the carriers of all components, components must be attached to entities to produce instances",
  T_49_META_TYPE_241_D: "Power Hook Gun",
  T_49_META_TYPE_242_D: "Score Bar",
  T_49_META_TYPE_243_D: "Clothing slots",
  T_49_META_TYPE_244_D: "Text entity represents a displayed text",
  T_49_META_TYPE_245_D: "Icon entity represents a displayed icon",
  T_49_META_TYPE_246_D: "Spray Color",
  T_49_META_TYPE_247_D: "Player UI type",
  T_49_META_TYPE_248_D: "General UI switch entity",
  T_49_META_TYPE_249_D: "Switch Equip Slot",
  T_49_META_TYPE_25_D: "Phases of the game, such as game start, game preparation, game end, etc.",
  T_49_META_TYPE_250_D: "Effects entity represents a displayed effect",
  T_49_META_TYPE_2500_D: "The player's birth point",
  T_49_META_TYPE_2501_D: "Triggers for triggering the player's (or other object's) entry and exit events",
  T_49_META_TYPE_2502_D: "Death or invulnerability triggers that control whether the player is dead or invulnerable effects when entering based on properties",
  T_49_META_TYPE_2503_D: "Race mode checkpoints",
  T_49_META_TYPE_2504_D: "Typically used in Race Mode to recognize when a player has entered a specified finish line. This is a specific trigger, custom triggers will be opened later, this endpoint is just a wrapper for custom triggers.",
  T_49_META_TYPE_2505_D: "Fence around the birth point, close it to leave the birth point",
  T_49_META_TYPE_2507_D: "Turret",
  T_49_META_TYPE_2508_D: "Monster Spawn",
  T_49_META_TYPE_2509_D: "Instances of the type can be generated on demand",
  T_49_META_TYPE_251_D: "Effect Container",
  T_49_META_TYPE_2510_D: "Player birth area (rectangle)",
  T_49_META_TYPE_252_D: "Spray Result UI",
  T_49_META_TYPE_253_D: "Hint Button",
  T_49_META_TYPE_254_D: "Heartbeat Effect",
  T_49_META_TYPE_255_D: "Timestamp Localization String",
  T_49_META_TYPE_256_D: "Rigidbody Type",
  T_49_META_TYPE_257_D: "Rigid body components",
  T_49_META_TYPE_258_D: "Timestamp Format Style Type",
  T_49_META_TYPE_259_D: "Tips",
  T_49_META_TYPE_26_D: "Rounds in a game, often a small game with several phases.",
  T_49_META_TYPE_260_D: "Progress Skill Button",
  T_49_META_TYPE_261_D: "Unique ID",
  T_49_META_TYPE_262_D: "Weapon Skin ID",
  T_49_META_TYPE_263_D: "Clothing ID",
  T_49_META_TYPE_264_D: "Consumable ID, when the version only has the weapon ID",
  T_49_META_TYPE_265_D: "UI panel entity",
  T_49_META_TYPE_267_D: "UI scroll view entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_268_D: "A switch with three states, with the option to keep the original logic except for on and off.",
  T_49_META_TYPE_269_D: "The player's equipment.",
  T_49_META_TYPE_270_D: "Entity or Prefab ID",
  T_49_META_TYPE_271_D: "UI panel entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_272_D: "Gender enumeration",
  T_49_META_TYPE_273_D: "Minimap",
  T_49_META_TYPE_274_D: "Icon displayed on the mini-map to follow the target",
  T_49_META_TYPE_275_D: "Individual part nodes in the skeleton",
  T_49_META_TYPE_276_D: "Nodes used to access skinned rigs",
  T_49_META_TYPE_277_D: "Client-side camera ray detection",
  T_49_META_TYPE_278_D: "Pixel blocks displayed on the mini-map, representing the collision size of the object at that location.",
  T_49_META_TYPE_279_D: "Color Drum",
  T_49_META_TYPE_28_D: "Reset at the beginning of each round.",
  T_49_META_TYPE_280_D: "Sphere Trigger",
  T_49_META_TYPE_281_D: "Capsule Trigger",
  T_49_META_TYPE_282_D: "Type describing the asset configuration ID, used to indicate that the parent package comes with the asset configuration ID, which needs to be parsed through the configuration table before loading",
  T_49_META_TYPE_283_D: "Describe the type of asset, used to indicate the identifier of the asset, can be loaded directly.",
  T_49_META_TYPE_284_D: "Indicates a humanoid model resource, which can be replaced with a player character.",
  T_49_META_TYPE_285_D: "A list or dictionary that can be traversed in a loop.",
  T_49_META_TYPE_286_D: "ID to describe the script asset",
  T_49_META_TYPE_287_D: "to describe the ID of a static script asset",
  T_49_META_TYPE_288_D: "to describe the ID of a custom UI asset",
  T_49_META_TYPE_289_D: "ID for describing the body of a preconfigured asset",
  T_49_META_TYPE_29_D: "Special effects",
  T_49_META_TYPE_290_D: "Behavior Tree",
  T_49_META_TYPE_291_D: "Behavior Tree Node Type",
  T_49_META_TYPE_292_D: "Behavior Tree Custom Node",
  T_49_META_TYPE_293_D: "Behavior Tree Attachable",
  T_49_META_TYPE_294_D: "UI layout entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_295_D: "State",
  T_49_META_TYPE_296_D: "Animation Clip",
  T_49_META_TYPE_297_D: "Animation Controller",
  T_49_META_TYPE_298_D: "Loop Type",
  T_49_META_TYPE_3_D: "Integer types, 32-bit signed integers",
  T_49_META_TYPE_30_D: "Icon",
  T_49_META_TYPE_300_D: "UI3DContainer entity, UI edited by the player via the UI Editor",
  T_49_META_TYPE_301_D: "AI Skill Type",
  T_49_META_TYPE_302_D: "Enumeration of equipment slots.",
  T_49_META_TYPE_303_D: "Corresponds to the Id column in BuffData.csv, please check with GPP before adding new items.",
  T_49_META_TYPE_304_D: "Buff Type List",
  T_49_META_TYPE_305_D: "Behavior Tree Node Status",
  T_49_META_TYPE_306_D: "Add buffs, remove buffs, and get a list of buffs already added.",
  T_49_META_TYPE_307_D: "Gloo Maker",
  T_49_META_TYPE_308_D: "Special Item ID Type",
  T_49_META_TYPE_309_D: "Thrown Object Props",
  T_49_META_TYPE_31_D: "Sound Effects",
  T_49_META_TYPE_310_D: "Crossbow",
  T_49_META_TYPE_311_D: "Grenade Base",
  T_49_META_TYPE_312_D: "Throwable props",
  T_49_META_TYPE_313_D: "Grenade DeIce Wall",
  T_49_META_TYPE_314_D: "Managing Animation Controllers and Resources",
  T_49_META_TYPE_315_D: "Player Backpack",
  T_49_META_TYPE_316_D: "UITexture entity, the UI edited by the player through the UI editor",
  T_49_META_TYPE_317_D: "Rigid body motion constraints, each of which can be used in combination",
  T_49_META_TYPE_318_D: "Attachment",
  T_49_META_TYPE_319_D: "Fill type enumeration",
  T_49_META_TYPE_32_D: "Player state type",
  T_49_META_TYPE_320_D: "Fill direction",
  T_49_META_TYPE_321_D: "Entities that can be target-assisted",
  T_49_META_TYPE_322_D: "Damaged Body Part Type",
  T_49_META_TYPE_323_D: "UIProfileInfo entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_324_D: "Several different effects of rigid body forces. Note that this only works for Dynamic types.",
  T_49_META_TYPE_325_D: "to describe the ID of a widget in a custom UI asset",
  T_49_META_TYPE_326_D: "Player profile information",
  T_49_META_TYPE_327_D: "Configure dressing according to each component",
  T_49_META_TYPE_328_D: "Behavior Tree ID",
  T_49_META_TYPE_329_D: "Seat Type",
  T_49_META_TYPE_33_D: "Sort by: ascending ignore zero value, descending, ascending",
  T_49_META_TYPE_330_D: "Self-relative movement",
  T_49_META_TYPE_331_D: "Bezier Curve",
  T_49_META_TYPE_332_D: "Loopable component",
  T_49_META_TYPE_333_D: "Font Type",
  T_49_META_TYPE_334_D: "Vehicle Skin ID",
  T_49_META_TYPE_335_D: "The sound entity represents a playing sound effect.",
  T_49_META_TYPE_336_D: "Sound Effect List",
  T_49_META_TYPE_337_D: "Sound Effect or Sound Effect List",
  T_49_META_TYPE_338_D: "Player behavior property synchronization entity",
  T_49_META_TYPE_339_D: "Equipment Accessory",
  T_49_META_TYPE_34_D: "Item ID",
  T_49_META_TYPE_340_D: "Bot Difficulty Type",
  T_49_META_TYPE_341_D: "Dictionary of integers",
  T_49_META_TYPE_342_D: "Timer objects",
  T_49_META_TYPE_343_D: "Flying Daggers (pickable)",
  T_49_META_TYPE_344_D: "Throwing Knife",
  T_49_META_TYPE_345_D: "Weapon Type",
  T_49_META_TYPE_346_D: "Ammo Type",
  T_49_META_TYPE_347_D: "Frame Self Relative",
  T_49_META_TYPE_348_D: "Function pointer to a function instance, used to implement dummy functions or delegate mechanism.",
  T_49_META_TYPE_349_D: "A handle to a concurrent program, which can be used to perform some handle operations.",
  T_49_META_TYPE_350_D: "Vehicle enumeration",
  T_49_META_TYPE_351_D: "Describes the type of the object",
  T_49_META_TYPE_352_D: "UIToggle entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_353_D: "MedKit",
  T_49_META_TYPE_354_D: "Inhaler",
  T_49_META_TYPE_355_D: "Horizaline",
  T_49_META_TYPE_356_D: "Airdrops, will start dropping from a high place after the preparation time is over",
  T_49_META_TYPE_357_D: "Descriptive colors for objects, such as borders, surfaces, etc. (deleted, reusable)",
  T_49_META_TYPE_358_D: "Refers to an event",
  T_49_META_TYPE_359_D: "Player controller with physics effects to apply forces.",
  T_49_META_TYPE_360_D: "Launch Pad",
  T_49_META_TYPE_361_D: "Folded cannon, when unfolded it can be used to launch people out, be careful not to launch yourself out of the safe zone!",
  T_49_META_TYPE_362_D: "Snowball fight! Punch it!",
  T_49_META_TYPE_363_D: "Shop request purchase",
  T_49_META_TYPE_364_D: "AnimationTrigger",
  T_49_META_TYPE_365_D: "Animation Trigger UI Component",
  T_49_META_TYPE_366_D: "Batch Combine Render",
  T_49_META_TYPE_367_D: "Top Compass",
  T_49_META_TYPE_368_D: "Custom character resource ID",
  T_49_META_TYPE_369_D: "Custom animation resource ID",
  T_49_META_TYPE_370_D: "Information displayed at the start of a round",
  T_49_META_TYPE_371_D: "At the end of each round, the results are displayed.",
  T_49_META_TYPE_372_D: "Player Stance Types",
  T_49_META_TYPE_373_D: "Collection ID, used for resource information collection",
  T_49_META_TYPE_374_D: "Follow Health Bar",
  T_49_META_TYPE_375_D: "Monster target type",
  T_49_META_TYPE_376_D: "Defense tower attack target type",
  T_49_META_TYPE_377_D: "Alias to refer to player entity, vehicle entity type",
  T_49_META_TYPE_378_D: "to describe the ID of an audio asset",
  T_49_META_TYPE_379_D: "ID to describe the configuration table asset",
  T_49_META_TYPE_38_D: "UI Empty Widget entity, UI edited by the player through the UI editor.",
  T_49_META_TYPE_380_D: "ID to describe the effects asset",
  T_49_META_TYPE_381_D: "ID to describe the Animation Controller asset",
  T_49_META_TYPE_382_D: "How knockdown status is handled",
  T_49_META_TYPE_383_D: "Surface or decorations on the map itself",
  T_49_META_TYPE_384_D: "Items",
  T_49_META_TYPE_385_D: "Character Skill ID",
  T_49_META_TYPE_386_D: "Skill ID List",
  T_49_META_TYPE_387_D: "UITouchPad entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_388_D: "Backpack Skin ID",
  T_49_META_TYPE_389_D: "Joystick entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_39_D: "UI image entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_390_D: "Hierarchical",
  T_49_META_TYPE_391_D: "Custom UI or Widget",
  T_49_META_TYPE_392_D: "Placeable out-of-zone objects",
  T_49_META_TYPE_393_D: "Entities with PhysicalCCT or Rigidbody component",
  T_49_META_TYPE_394_D: "Mathematical constants",
  T_49_META_TYPE_395_D: "Entities with PhysicalCCT or PlayerCCT components can move along with them.",
  T_49_META_TYPE_396_D: "Mid-Game Exit Configuration",
  T_49_META_TYPE_397_D: "Components used to describe collision shapes",
  T_49_META_TYPE_398_D: "String or Localization String",
  T_49_META_TYPE_399_D: "Character Controller with Physical Effects, for FF characters only.",
  T_49_META_TYPE_4_D: "Floating-point type, 32-bit single-precision floating-point number",
  T_49_META_TYPE_40_D: "UI Text entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_400_D: "How to perform the attack behavior",
  T_49_META_TYPE_401_D: "Fire Type",
  T_49_META_TYPE_402_D: "Social Button Widget",
  T_49_META_TYPE_403_D: "Social Button Types",
  T_49_META_TYPE_404_D: "Social Button Styles",
  T_49_META_TYPE_405_D: "Layout Sort Type",
  T_49_META_TYPE_406_D: "Can be triggered to go over obstacles",
  T_49_META_TYPE_407_D: "Platform Type",
  T_49_META_TYPE_408_D: "Base Data Alias",
  T_49_META_TYPE_409_D: "Error code enumeration",
  T_49_META_TYPE_41_D: "UI button entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_410_D: "Alias that refers to a player entity or Transform entity type",
  T_49_META_TYPE_411_D: "Helicopter Carrier",
  T_49_META_TYPE_412_D: "Vehicle component, which is an extension of the Carrier component.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Limits the range of camera rotation angles",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Persona Chat Window UI",
  T_49_META_TYPE_417_D: "Particle entity component",
  T_49_META_TYPE_418_D: "Member status enumeration",
  T_49_META_TYPE_419_D: "Gun Skin Type",
  T_49_META_TYPE_42_D: "UI input entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_420_D: "Vehicle Skin Types",
  T_49_META_TYPE_421_D: "Skin",
  T_49_META_TYPE_422_D: "Backpack Skin Types",
  T_49_META_TYPE_423_D: "Persona ID",
  T_49_META_TYPE_424_D: "Fog effect base type",
  T_49_META_TYPE_425_D: "Particle asset ID",
  T_49_META_TYPE_426_D: "A type of light source that emits a cone of light in the negative Y-axis direction from the light source, defaulting to the ground.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Clothing information to be retained when the player transforms into another character.",
  T_49_META_TYPE_429_D: "Player or NPC entities",
  T_49_META_TYPE_43_D: "List of element types that must be player entities",
  T_49_META_TYPE_430_D: "Random Number Generator",
  T_49_META_TYPE_431_D: "Motion objects moving along a customized path",
  T_49_META_TYPE_432_D: "Custom Curve Path Waypoints",
  T_49_META_TYPE_433_D: "Custom curve path waypoint types",
  T_49_META_TYPE_434_D: "Custom Curve Paths",
  T_49_META_TYPE_435_D: "List of unique player identifiers",
  T_49_META_TYPE_436_D: "Error code list",
  T_49_META_TYPE_437_D: "Two teams match details UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_438_D: "Multi-team match details UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_439_D: "Combine",
  T_49_META_TYPE_44_D: "A list of entities whose element types must be team entities",
  T_49_META_TYPE_440_D: "Timeline",
  T_49_META_TYPE_441_D: "Timeline Resource ID",
  T_49_META_TYPE_442_D: "New two-team match information short version entity component, supports fully customizable headcount display",
  T_49_META_TYPE_443_D: "Dialog stream asset ID",
  T_49_META_TYPE_444_D: "Language Type",
  T_49_META_TYPE_45_D: "Bool List",
  T_49_META_TYPE_46_D: "Int List",
  T_49_META_TYPE_47_D: "Float List",
  T_49_META_TYPE_48_D: "String List",
  T_49_META_TYPE_49_D: "Vector3 List",
  T_49_META_TYPE_5_D: "String type, value is text content",
  T_49_META_TYPE_50_D: "A list of entities whose element types must be entities",
  T_49_META_TYPE_51_D: "Zombie Types",
  T_49_META_TYPE_53_D: "Common Level Object",
  T_49_META_TYPE_54_D: "Destructible Object",
  T_49_META_TYPE_55_D: "General Spawn Point",
  T_49_META_TYPE_56_D: "Vehicle",
  T_49_META_TYPE_57_D: "Players can be teleported to a specific location upon entry",
  T_49_META_TYPE_58_D: "Buffs can be generated on demand",
  T_49_META_TYPE_59_D: "Moving Platform",
  T_49_META_TYPE_6_D: "Three-dimensional vectors, which can represent spatial coordinates or spatial directions",
  T_49_META_TYPE_60_D: "Generates a weapon drop of the selected type.",
  T_49_META_TYPE_61_D: "Entering the trigger range opens the Bound Shop.",
  T_49_META_TYPE_62_D: "Bouncy Dice",
  T_49_META_TYPE_63_D: "Players step on them and they will be bounced to a specific location.",
  T_49_META_TYPE_64_D: "Players will make a sound when stepping on them",
  T_49_META_TYPE_65_D: "Basic Scalable",
  T_49_META_TYPE_66_D: "Custom Path",
  T_49_META_TYPE_67_D: "Path Point",
  T_49_META_TYPE_68_D: "AI monster entities, such as zombies",
  T_49_META_TYPE_69_D: "Large numbers are high precision floating point numbers",
  T_49_META_TYPE_7_D: "Numbers are type aliases that refer to integer, 64-bit integer, or floating-point types",
  T_49_META_TYPE_70_D: "Property formulas are used to calculate entity property values, only some player properties and weapon properties are supported for now.",
  T_49_META_TYPE_71_D: "Only used for entities sold in the shop, the concept of shop items is different from that of items purchased.",
  T_49_META_TYPE_72_D: "Contains several shop items.",
  T_49_META_TYPE_73_D: "Contains several shelves.",
  T_49_META_TYPE_74_D: "Item ID",
  T_49_META_TYPE_75_D: "Come Back",
  T_49_META_TYPE_76_D: "Patrol style",
  T_49_META_TYPE_77_D: "A generator entity that can generate and refresh objects.",
  T_49_META_TYPE_78_D: "A unit entity that can be used by the unit generator to absorb and generate units in batches.",
  T_49_META_TYPE_79_D: "Weapon",
  T_49_META_TYPE_8_D: "Conditionals are special Bool types",
  T_49_META_TYPE_80_D: "UI of the shop",
  T_49_META_TYPE_81_D: "Buff Type",
  T_49_META_TYPE_82_D: "UI Heartbeat",
  T_49_META_TYPE_83_D: "Interaction Button",
  T_49_META_TYPE_84_D: "Rankable entity, capable of being ranked",
  T_49_META_TYPE_85_D: "Scoreable entity, has its own score",
  T_49_META_TYPE_86_D: "Property formula factor type",
  T_49_META_TYPE_87_D: "Describes the type of RGBA color, the range of value is 0~255 for each channel.",
  T_49_META_TYPE_88_D: "Currency type, currently only the base currency type",
  T_49_META_TYPE_89_D: "Currency entity, which describes the type and amount of currency.",
  T_49_META_TYPE_9_D: "A set of conditions",
  T_49_META_TYPE_90_D: "Wallet entities are containers for a bunch of currency entities",
  T_49_META_TYPE_91_D: "Indicates an integer or integer array type.",
  T_49_META_TYPE_92_D: "Dynamic Create Level Object Type",
  T_49_META_TYPE_93_D: "Entities with formulable properties",
  T_49_META_TYPE_94_D: "Property modification",
  T_49_META_TYPE_95_D: "Coin Generator",
  T_49_META_TYPE_96_D: "Wallet",
  T_49_META_TYPE_97_D: "Position rotation and scaling, supports parent-child structure",
  T_49_META_TYPE_98_D: "List all available types",
  T_49_META_TYPE_99_D: "Football"
};
export {
  _ as default
};
